/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** A date, represented as a 'yyyy-mm-dd' string */
  Date: { input: any; output: any };
  /** A date and time, represented as an ISO-8601 string */
  DateTime: { input: any; output: any };
};

export type Absence = {
  __typename?: 'Absence';
  comment?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  days: Array<Day>;
  daysAggregate?: Maybe<AbsenceDayDaysAggregationSelection>;
  daysConnection: AbsenceDaysConnection;
  endTime: Scalars['DateTime']['output'];
  excused?: Maybe<Scalars['Boolean']['output']>;
  foreignRefId?: Maybe<Array<Scalars['String']['output']>>;
  owner: Profile;
  ownerAggregate?: Maybe<AbsenceProfileOwnerAggregationSelection>;
  ownerConnection: AbsenceOwnerConnection;
  reason?: Maybe<AbsenceReason>;
  reasonAggregate?: Maybe<AbsenceAbsenceReasonReasonAggregationSelection>;
  reasonConnection: AbsenceReasonConnection;
  startTime: Scalars['DateTime']['output'];
  updated: Scalars['DateTime']['output'];
  uuid: Scalars['ID']['output'];
  wholeDay?: Maybe<Scalars['Boolean']['output']>;
};

export type AbsenceDaysArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DayOptions>;
  where?: InputMaybe<DayWhere>;
};

export type AbsenceDaysAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DayWhere>;
};

export type AbsenceDaysConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AbsenceDaysConnectionSort>>;
  where?: InputMaybe<AbsenceDaysConnectionWhere>;
};

export type AbsenceOwnerArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ProfileOptions>;
  where?: InputMaybe<ProfileWhere>;
};

export type AbsenceOwnerAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProfileWhere>;
};

export type AbsenceOwnerConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AbsenceOwnerConnectionSort>>;
  where?: InputMaybe<AbsenceOwnerConnectionWhere>;
};

export type AbsenceReasonArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AbsenceReasonOptions>;
  where?: InputMaybe<AbsenceReasonWhere>;
};

export type AbsenceReasonAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AbsenceReasonWhere>;
};

export type AbsenceReasonConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AbsenceReasonConnectionSort>>;
  where?: InputMaybe<AbsenceReasonConnectionWhere>;
};

export type AbsenceAbsenceReasonReasonAggregationSelection = {
  __typename?: 'AbsenceAbsenceReasonReasonAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AbsenceAbsenceReasonReasonNodeAggregateSelection>;
};

export type AbsenceAbsenceReasonReasonNodeAggregateSelection = {
  __typename?: 'AbsenceAbsenceReasonReasonNodeAggregateSelection';
  reason: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type AbsenceAggregateSelection = {
  __typename?: 'AbsenceAggregateSelection';
  comment: StringAggregateSelection;
  count: Scalars['Int']['output'];
  created: DateTimeAggregateSelection;
  endTime: DateTimeAggregateSelection;
  startTime: DateTimeAggregateSelection;
  updated: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type AbsenceCreateInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  days?: InputMaybe<AbsenceDaysFieldInput>;
  endTime: Scalars['DateTime']['input'];
  excused?: InputMaybe<Scalars['Boolean']['input']>;
  foreignRefId?: InputMaybe<Array<Scalars['String']['input']>>;
  owner?: InputMaybe<AbsenceOwnerFieldInput>;
  reason?: InputMaybe<AbsenceReasonFieldInput>;
  startTime: Scalars['DateTime']['input'];
  wholeDay?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AbsenceDayDaysAggregationSelection = {
  __typename?: 'AbsenceDayDaysAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AbsenceDayDaysNodeAggregateSelection>;
};

export type AbsenceDayDaysNodeAggregateSelection = {
  __typename?: 'AbsenceDayDaysNodeAggregateSelection';
  date: StringAggregateSelection;
  day: IntAggregateSelection;
  dayOfWeek: IntAggregateSelection;
  month: IntAggregateSelection;
  uuid: IdAggregateSelection;
  week: IntAggregateSelection;
  year: IntAggregateSelection;
};

export type AbsenceDaysAggregateInput = {
  AND?: InputMaybe<Array<AbsenceDaysAggregateInput>>;
  NOT?: InputMaybe<AbsenceDaysAggregateInput>;
  OR?: InputMaybe<Array<AbsenceDaysAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AbsenceDaysNodeAggregationWhereInput>;
};

export type AbsenceDaysConnectFieldInput = {
  connect?: InputMaybe<Array<DayConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<DayConnectWhere>;
};

export type AbsenceDaysConnectOrCreateFieldInput = {
  onCreate: AbsenceDaysConnectOrCreateFieldInputOnCreate;
  where: DayConnectOrCreateWhere;
};

export type AbsenceDaysConnectOrCreateFieldInputOnCreate = {
  node: DayOnCreateInput;
};

export type AbsenceDaysConnection = {
  __typename?: 'AbsenceDaysConnection';
  edges: Array<AbsenceDaysRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AbsenceDaysConnectionSort = {
  node?: InputMaybe<DaySort>;
};

export type AbsenceDaysConnectionWhere = {
  AND?: InputMaybe<Array<AbsenceDaysConnectionWhere>>;
  NOT?: InputMaybe<AbsenceDaysConnectionWhere>;
  OR?: InputMaybe<Array<AbsenceDaysConnectionWhere>>;
  node?: InputMaybe<DayWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<DayWhere>;
};

export type AbsenceDaysCreateFieldInput = {
  node: DayCreateInput;
};

export type AbsenceDaysDeleteFieldInput = {
  delete?: InputMaybe<DayDeleteInput>;
  where?: InputMaybe<AbsenceDaysConnectionWhere>;
};

export type AbsenceDaysDisconnectFieldInput = {
  disconnect?: InputMaybe<DayDisconnectInput>;
  where?: InputMaybe<AbsenceDaysConnectionWhere>;
};

export type AbsenceDaysFieldInput = {
  connect?: InputMaybe<Array<AbsenceDaysConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AbsenceDaysConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AbsenceDaysCreateFieldInput>>;
};

export type AbsenceDaysNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AbsenceDaysNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AbsenceDaysNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AbsenceDaysNodeAggregationWhereInput>>;
  date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  day_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  day_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  day_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  day_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  day_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  day_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  day_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  day_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  day_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  day_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  month_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  month_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  month_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  month_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  month_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  month_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  month_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  month_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  month_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  month_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  week_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  week_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  week_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  week_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  week_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  week_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  week_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  week_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  week_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  week_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  year_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  year_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AbsenceDaysRelationship = {
  __typename?: 'AbsenceDaysRelationship';
  cursor: Scalars['String']['output'];
  node: Day;
};

export type AbsenceDaysUpdateConnectionInput = {
  node?: InputMaybe<DayUpdateInput>;
};

export type AbsenceDaysUpdateFieldInput = {
  connect?: InputMaybe<Array<AbsenceDaysConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AbsenceDaysConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AbsenceDaysCreateFieldInput>>;
  delete?: InputMaybe<Array<AbsenceDaysDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AbsenceDaysDisconnectFieldInput>>;
  update?: InputMaybe<AbsenceDaysUpdateConnectionInput>;
  where?: InputMaybe<AbsenceDaysConnectionWhere>;
};

export type AbsenceDeleteInput = {
  days?: InputMaybe<Array<AbsenceDaysDeleteFieldInput>>;
  owner?: InputMaybe<AbsenceOwnerDeleteFieldInput>;
  reason?: InputMaybe<AbsenceReasonDeleteFieldInput>;
};

export type AbsenceEdge = {
  __typename?: 'AbsenceEdge';
  cursor: Scalars['String']['output'];
  node: Absence;
};

export type AbsenceOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AbsenceSort objects to sort Absences by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AbsenceSort>>;
};

export type AbsenceOwnerAggregateInput = {
  AND?: InputMaybe<Array<AbsenceOwnerAggregateInput>>;
  NOT?: InputMaybe<AbsenceOwnerAggregateInput>;
  OR?: InputMaybe<Array<AbsenceOwnerAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AbsenceOwnerNodeAggregationWhereInput>;
};

export type AbsenceOwnerConnectFieldInput = {
  connect?: InputMaybe<ProfileConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ProfileConnectWhere>;
};

export type AbsenceOwnerConnectOrCreateFieldInput = {
  onCreate: AbsenceOwnerConnectOrCreateFieldInputOnCreate;
  where: ProfileConnectOrCreateWhere;
};

export type AbsenceOwnerConnectOrCreateFieldInputOnCreate = {
  node: ProfileOnCreateInput;
};

export type AbsenceOwnerConnection = {
  __typename?: 'AbsenceOwnerConnection';
  edges: Array<AbsenceOwnerRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AbsenceOwnerConnectionSort = {
  node?: InputMaybe<ProfileSort>;
};

export type AbsenceOwnerConnectionWhere = {
  AND?: InputMaybe<Array<AbsenceOwnerConnectionWhere>>;
  NOT?: InputMaybe<AbsenceOwnerConnectionWhere>;
  OR?: InputMaybe<Array<AbsenceOwnerConnectionWhere>>;
  node?: InputMaybe<ProfileWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ProfileWhere>;
};

export type AbsenceOwnerCreateFieldInput = {
  node: ProfileCreateInput;
};

export type AbsenceOwnerDeleteFieldInput = {
  delete?: InputMaybe<ProfileDeleteInput>;
  where?: InputMaybe<AbsenceOwnerConnectionWhere>;
};

export type AbsenceOwnerDisconnectFieldInput = {
  disconnect?: InputMaybe<ProfileDisconnectInput>;
  where?: InputMaybe<AbsenceOwnerConnectionWhere>;
};

export type AbsenceOwnerFieldInput = {
  connect?: InputMaybe<AbsenceOwnerConnectFieldInput>;
  connectOrCreate?: InputMaybe<AbsenceOwnerConnectOrCreateFieldInput>;
  create?: InputMaybe<AbsenceOwnerCreateFieldInput>;
};

export type AbsenceOwnerNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AbsenceOwnerNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AbsenceOwnerNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AbsenceOwnerNodeAggregationWhereInput>>;
  address1_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address1_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address2_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address2_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address3_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address3_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  birthday_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  userUuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  userUuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AbsenceOwnerRelationship = {
  __typename?: 'AbsenceOwnerRelationship';
  cursor: Scalars['String']['output'];
  node: Profile;
};

export type AbsenceOwnerUpdateConnectionInput = {
  node?: InputMaybe<ProfileUpdateInput>;
};

export type AbsenceOwnerUpdateFieldInput = {
  connect?: InputMaybe<AbsenceOwnerConnectFieldInput>;
  connectOrCreate?: InputMaybe<AbsenceOwnerConnectOrCreateFieldInput>;
  create?: InputMaybe<AbsenceOwnerCreateFieldInput>;
  delete?: InputMaybe<AbsenceOwnerDeleteFieldInput>;
  disconnect?: InputMaybe<AbsenceOwnerDisconnectFieldInput>;
  update?: InputMaybe<AbsenceOwnerUpdateConnectionInput>;
  where?: InputMaybe<AbsenceOwnerConnectionWhere>;
};

export type AbsenceProfileOwnerAggregationSelection = {
  __typename?: 'AbsenceProfileOwnerAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AbsenceProfileOwnerNodeAggregateSelection>;
};

export type AbsenceProfileOwnerNodeAggregateSelection = {
  __typename?: 'AbsenceProfileOwnerNodeAggregateSelection';
  address1: StringAggregateSelection;
  address2: StringAggregateSelection;
  address3: StringAggregateSelection;
  birthday: StringAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  email: StringAggregateSelection;
  firstName: StringAggregateSelection;
  firstNames: StringAggregateSelection;
  lastName: StringAggregateSelection;
  managedBy: StringAggregateSelection;
  matrixToken: StringAggregateSelection;
  nextcloudUserId: StringAggregateSelection;
  prefixName: StringAggregateSelection;
  salutation: StringAggregateSelection;
  shortName: StringAggregateSelection;
  threemaId: StringAggregateSelection;
  title: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  userUuid: StringAggregateSelection;
  uuid: IdAggregateSelection;
  zoomUserId: StringAggregateSelection;
};

export type AbsenceReason = {
  __typename?: 'AbsenceReason';
  absences: Array<AbsenceReason>;
  absencesAggregate?: Maybe<AbsenceReasonAbsenceReasonAbsencesAggregationSelection>;
  absencesConnection: AbsenceReasonAbsencesConnection;
  internal?: Maybe<Scalars['Boolean']['output']>;
  organization?: Maybe<Organization>;
  organizationAggregate?: Maybe<AbsenceReasonOrganizationOrganizationAggregationSelection>;
  organizationConnection: AbsenceReasonOrganizationConnection;
  reason: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type AbsenceReasonAbsencesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AbsenceReasonOptions>;
  where?: InputMaybe<AbsenceReasonWhere>;
};

export type AbsenceReasonAbsencesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AbsenceReasonWhere>;
};

export type AbsenceReasonAbsencesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AbsenceReasonAbsencesConnectionSort>>;
  where?: InputMaybe<AbsenceReasonAbsencesConnectionWhere>;
};

export type AbsenceReasonOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type AbsenceReasonOrganizationAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OrganizationWhere>;
};

export type AbsenceReasonOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AbsenceReasonOrganizationConnectionSort>>;
  where?: InputMaybe<AbsenceReasonOrganizationConnectionWhere>;
};

export type AbsenceReasonAbsenceReasonAbsencesAggregationSelection = {
  __typename?: 'AbsenceReasonAbsenceReasonAbsencesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AbsenceReasonAbsenceReasonAbsencesNodeAggregateSelection>;
};

export type AbsenceReasonAbsenceReasonAbsencesNodeAggregateSelection = {
  __typename?: 'AbsenceReasonAbsenceReasonAbsencesNodeAggregateSelection';
  reason: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type AbsenceReasonAbsencesAggregateInput = {
  AND?: InputMaybe<Array<AbsenceReasonAbsencesAggregateInput>>;
  NOT?: InputMaybe<AbsenceReasonAbsencesAggregateInput>;
  OR?: InputMaybe<Array<AbsenceReasonAbsencesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AbsenceReasonAbsencesNodeAggregationWhereInput>;
};

export type AbsenceReasonAbsencesConnectFieldInput = {
  connect?: InputMaybe<Array<AbsenceReasonConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AbsenceReasonConnectWhere>;
};

export type AbsenceReasonAbsencesConnection = {
  __typename?: 'AbsenceReasonAbsencesConnection';
  edges: Array<AbsenceReasonAbsencesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AbsenceReasonAbsencesConnectionSort = {
  node?: InputMaybe<AbsenceReasonSort>;
};

export type AbsenceReasonAbsencesConnectionWhere = {
  AND?: InputMaybe<Array<AbsenceReasonAbsencesConnectionWhere>>;
  NOT?: InputMaybe<AbsenceReasonAbsencesConnectionWhere>;
  OR?: InputMaybe<Array<AbsenceReasonAbsencesConnectionWhere>>;
  node?: InputMaybe<AbsenceReasonWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<AbsenceReasonWhere>;
};

export type AbsenceReasonAbsencesCreateFieldInput = {
  node: AbsenceReasonCreateInput;
};

export type AbsenceReasonAbsencesDeleteFieldInput = {
  delete?: InputMaybe<AbsenceReasonDeleteInput>;
  where?: InputMaybe<AbsenceReasonAbsencesConnectionWhere>;
};

export type AbsenceReasonAbsencesDisconnectFieldInput = {
  disconnect?: InputMaybe<AbsenceReasonDisconnectInput>;
  where?: InputMaybe<AbsenceReasonAbsencesConnectionWhere>;
};

export type AbsenceReasonAbsencesFieldInput = {
  connect?: InputMaybe<Array<AbsenceReasonAbsencesConnectFieldInput>>;
  create?: InputMaybe<Array<AbsenceReasonAbsencesCreateFieldInput>>;
};

export type AbsenceReasonAbsencesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AbsenceReasonAbsencesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AbsenceReasonAbsencesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AbsenceReasonAbsencesNodeAggregationWhereInput>>;
  reason_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  reason_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  reason_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  reason_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  reason_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  reason_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reason_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reason_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reason_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reason_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reason_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reason_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reason_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reason_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reason_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AbsenceReasonAbsencesRelationship = {
  __typename?: 'AbsenceReasonAbsencesRelationship';
  cursor: Scalars['String']['output'];
  node: AbsenceReason;
};

export type AbsenceReasonAbsencesUpdateConnectionInput = {
  node?: InputMaybe<AbsenceReasonUpdateInput>;
};

export type AbsenceReasonAbsencesUpdateFieldInput = {
  connect?: InputMaybe<Array<AbsenceReasonAbsencesConnectFieldInput>>;
  create?: InputMaybe<Array<AbsenceReasonAbsencesCreateFieldInput>>;
  delete?: InputMaybe<Array<AbsenceReasonAbsencesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AbsenceReasonAbsencesDisconnectFieldInput>>;
  update?: InputMaybe<AbsenceReasonAbsencesUpdateConnectionInput>;
  where?: InputMaybe<AbsenceReasonAbsencesConnectionWhere>;
};

export type AbsenceReasonAggregateInput = {
  AND?: InputMaybe<Array<AbsenceReasonAggregateInput>>;
  NOT?: InputMaybe<AbsenceReasonAggregateInput>;
  OR?: InputMaybe<Array<AbsenceReasonAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AbsenceReasonNodeAggregationWhereInput>;
};

export type AbsenceReasonAggregateSelection = {
  __typename?: 'AbsenceReasonAggregateSelection';
  count: Scalars['Int']['output'];
  reason: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type AbsenceReasonConnectFieldInput = {
  connect?: InputMaybe<AbsenceReasonConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AbsenceReasonConnectWhere>;
};

export type AbsenceReasonConnectInput = {
  absences?: InputMaybe<Array<AbsenceReasonAbsencesConnectFieldInput>>;
  organization?: InputMaybe<AbsenceReasonOrganizationConnectFieldInput>;
};

export type AbsenceReasonConnectWhere = {
  node: AbsenceReasonWhere;
};

export type AbsenceReasonConnection = {
  __typename?: 'AbsenceReasonConnection';
  edges: Array<AbsenceReasonRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AbsenceReasonConnectionSort = {
  node?: InputMaybe<AbsenceReasonSort>;
};

export type AbsenceReasonConnectionWhere = {
  AND?: InputMaybe<Array<AbsenceReasonConnectionWhere>>;
  NOT?: InputMaybe<AbsenceReasonConnectionWhere>;
  OR?: InputMaybe<Array<AbsenceReasonConnectionWhere>>;
  node?: InputMaybe<AbsenceReasonWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<AbsenceReasonWhere>;
};

export type AbsenceReasonCreateFieldInput = {
  node: AbsenceReasonCreateInput;
};

export type AbsenceReasonCreateInput = {
  absences?: InputMaybe<AbsenceReasonAbsencesFieldInput>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<AbsenceReasonOrganizationFieldInput>;
  reason: Scalars['String']['input'];
};

export type AbsenceReasonDeleteFieldInput = {
  delete?: InputMaybe<AbsenceReasonDeleteInput>;
  where?: InputMaybe<AbsenceReasonConnectionWhere>;
};

export type AbsenceReasonDeleteInput = {
  absences?: InputMaybe<Array<AbsenceReasonAbsencesDeleteFieldInput>>;
  organization?: InputMaybe<AbsenceReasonOrganizationDeleteFieldInput>;
};

export type AbsenceReasonDisconnectFieldInput = {
  disconnect?: InputMaybe<AbsenceReasonDisconnectInput>;
  where?: InputMaybe<AbsenceReasonConnectionWhere>;
};

export type AbsenceReasonDisconnectInput = {
  absences?: InputMaybe<Array<AbsenceReasonAbsencesDisconnectFieldInput>>;
  organization?: InputMaybe<AbsenceReasonOrganizationDisconnectFieldInput>;
};

export type AbsenceReasonEdge = {
  __typename?: 'AbsenceReasonEdge';
  cursor: Scalars['String']['output'];
  node: AbsenceReason;
};

export type AbsenceReasonFieldInput = {
  connect?: InputMaybe<AbsenceReasonConnectFieldInput>;
  create?: InputMaybe<AbsenceReasonCreateFieldInput>;
};

export type AbsenceReasonNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AbsenceReasonNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AbsenceReasonNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AbsenceReasonNodeAggregationWhereInput>>;
  reason_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  reason_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  reason_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  reason_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  reason_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  reason_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reason_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reason_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reason_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reason_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reason_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reason_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reason_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reason_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reason_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AbsenceReasonOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AbsenceReasonSort objects to sort AbsenceReasons by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AbsenceReasonSort>>;
};

export type AbsenceReasonOrganizationAggregateInput = {
  AND?: InputMaybe<Array<AbsenceReasonOrganizationAggregateInput>>;
  NOT?: InputMaybe<AbsenceReasonOrganizationAggregateInput>;
  OR?: InputMaybe<Array<AbsenceReasonOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AbsenceReasonOrganizationNodeAggregationWhereInput>;
};

export type AbsenceReasonOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type AbsenceReasonOrganizationConnectOrCreateFieldInput = {
  onCreate: AbsenceReasonOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type AbsenceReasonOrganizationConnectOrCreateFieldInputOnCreate = {
  node: OrganizationOnCreateInput;
};

export type AbsenceReasonOrganizationConnection = {
  __typename?: 'AbsenceReasonOrganizationConnection';
  edges: Array<AbsenceReasonOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AbsenceReasonOrganizationConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type AbsenceReasonOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<AbsenceReasonOrganizationConnectionWhere>>;
  NOT?: InputMaybe<AbsenceReasonOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<AbsenceReasonOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type AbsenceReasonOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type AbsenceReasonOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<AbsenceReasonOrganizationConnectionWhere>;
};

export type AbsenceReasonOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<AbsenceReasonOrganizationConnectionWhere>;
};

export type AbsenceReasonOrganizationFieldInput = {
  connect?: InputMaybe<AbsenceReasonOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<AbsenceReasonOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<AbsenceReasonOrganizationCreateFieldInput>;
};

export type AbsenceReasonOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AbsenceReasonOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AbsenceReasonOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AbsenceReasonOrganizationNodeAggregationWhereInput>>;
  aboutInfoLastUpdated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AbsenceReasonOrganizationOrganizationAggregationSelection = {
  __typename?: 'AbsenceReasonOrganizationOrganizationAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AbsenceReasonOrganizationOrganizationNodeAggregateSelection>;
};

export type AbsenceReasonOrganizationOrganizationNodeAggregateSelection = {
  __typename?: 'AbsenceReasonOrganizationOrganizationNodeAggregateSelection';
  aboutInfo: StringAggregateSelection;
  aboutInfoLastUpdated: DateTimeAggregateSelection;
  displayName: StringAggregateSelection;
  matrixRoomId: StringAggregateSelection;
  planungSyncProps: StringAggregateSelection;
  procuratSyncProps: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type AbsenceReasonOrganizationRelationship = {
  __typename?: 'AbsenceReasonOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type AbsenceReasonOrganizationUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type AbsenceReasonOrganizationUpdateFieldInput = {
  connect?: InputMaybe<AbsenceReasonOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<AbsenceReasonOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<AbsenceReasonOrganizationCreateFieldInput>;
  delete?: InputMaybe<AbsenceReasonOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<AbsenceReasonOrganizationDisconnectFieldInput>;
  update?: InputMaybe<AbsenceReasonOrganizationUpdateConnectionInput>;
  where?: InputMaybe<AbsenceReasonOrganizationConnectionWhere>;
};

export type AbsenceReasonRelationship = {
  __typename?: 'AbsenceReasonRelationship';
  cursor: Scalars['String']['output'];
  node: AbsenceReason;
};

/** Fields to sort AbsenceReasons by. The order in which sorts are applied is not guaranteed when specifying many fields in one AbsenceReasonSort object. */
export type AbsenceReasonSort = {
  internal?: InputMaybe<SortDirection>;
  reason?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type AbsenceReasonUpdateConnectionInput = {
  node?: InputMaybe<AbsenceReasonUpdateInput>;
};

export type AbsenceReasonUpdateFieldInput = {
  connect?: InputMaybe<AbsenceReasonConnectFieldInput>;
  create?: InputMaybe<AbsenceReasonCreateFieldInput>;
  delete?: InputMaybe<AbsenceReasonDeleteFieldInput>;
  disconnect?: InputMaybe<AbsenceReasonDisconnectFieldInput>;
  update?: InputMaybe<AbsenceReasonUpdateConnectionInput>;
  where?: InputMaybe<AbsenceReasonConnectionWhere>;
};

export type AbsenceReasonUpdateInput = {
  absences?: InputMaybe<Array<AbsenceReasonAbsencesUpdateFieldInput>>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<AbsenceReasonOrganizationUpdateFieldInput>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type AbsenceReasonWhere = {
  AND?: InputMaybe<Array<AbsenceReasonWhere>>;
  NOT?: InputMaybe<AbsenceReasonWhere>;
  OR?: InputMaybe<Array<AbsenceReasonWhere>>;
  /** @deprecated Use `absences_SOME` instead. */
  absences?: InputMaybe<AbsenceReasonWhere>;
  absencesAggregate?: InputMaybe<AbsenceReasonAbsencesAggregateInput>;
  /** @deprecated Use `absencesConnection_SOME` instead. */
  absencesConnection?: InputMaybe<AbsenceReasonAbsencesConnectionWhere>;
  /** Return AbsenceReasons where all of the related AbsenceReasonAbsencesConnections match this filter */
  absencesConnection_ALL?: InputMaybe<AbsenceReasonAbsencesConnectionWhere>;
  /** Return AbsenceReasons where none of the related AbsenceReasonAbsencesConnections match this filter */
  absencesConnection_NONE?: InputMaybe<AbsenceReasonAbsencesConnectionWhere>;
  /** @deprecated Use `absencesConnection_NONE` instead. */
  absencesConnection_NOT?: InputMaybe<AbsenceReasonAbsencesConnectionWhere>;
  /** Return AbsenceReasons where one of the related AbsenceReasonAbsencesConnections match this filter */
  absencesConnection_SINGLE?: InputMaybe<AbsenceReasonAbsencesConnectionWhere>;
  /** Return AbsenceReasons where some of the related AbsenceReasonAbsencesConnections match this filter */
  absencesConnection_SOME?: InputMaybe<AbsenceReasonAbsencesConnectionWhere>;
  /** Return AbsenceReasons where all of the related AbsenceReasons match this filter */
  absences_ALL?: InputMaybe<AbsenceReasonWhere>;
  /** Return AbsenceReasons where none of the related AbsenceReasons match this filter */
  absences_NONE?: InputMaybe<AbsenceReasonWhere>;
  /** @deprecated Use `absences_NONE` instead. */
  absences_NOT?: InputMaybe<AbsenceReasonWhere>;
  /** Return AbsenceReasons where one of the related AbsenceReasons match this filter */
  absences_SINGLE?: InputMaybe<AbsenceReasonWhere>;
  /** Return AbsenceReasons where some of the related AbsenceReasons match this filter */
  absences_SOME?: InputMaybe<AbsenceReasonWhere>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  internal_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<AbsenceReasonOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<AbsenceReasonOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<AbsenceReasonOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  reason?: InputMaybe<Scalars['String']['input']>;
  reason_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  reason_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  reason_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  reason_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  reason_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  reason_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  reason_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  reason_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  reason_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type AbsenceReasonsConnection = {
  __typename?: 'AbsenceReasonsConnection';
  edges: Array<AbsenceReasonEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Fields to sort Absences by. The order in which sorts are applied is not guaranteed when specifying many fields in one AbsenceSort object. */
export type AbsenceSort = {
  comment?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  endTime?: InputMaybe<SortDirection>;
  excused?: InputMaybe<SortDirection>;
  startTime?: InputMaybe<SortDirection>;
  updated?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
  wholeDay?: InputMaybe<SortDirection>;
};

export type AbsenceUpdateInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  days?: InputMaybe<Array<AbsenceDaysUpdateFieldInput>>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  excused?: InputMaybe<Scalars['Boolean']['input']>;
  foreignRefId?: InputMaybe<Array<Scalars['String']['input']>>;
  foreignRefId_POP?: InputMaybe<Scalars['Int']['input']>;
  foreignRefId_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
  owner?: InputMaybe<AbsenceOwnerUpdateFieldInput>;
  reason?: InputMaybe<AbsenceReasonUpdateFieldInput>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  wholeDay?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AbsenceWhere = {
  AND?: InputMaybe<Array<AbsenceWhere>>;
  NOT?: InputMaybe<AbsenceWhere>;
  OR?: InputMaybe<Array<AbsenceWhere>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  comment_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  comment_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  comment_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  comment_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  created_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  created_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  /** @deprecated Use `days_SOME` instead. */
  days?: InputMaybe<DayWhere>;
  daysAggregate?: InputMaybe<AbsenceDaysAggregateInput>;
  /** @deprecated Use `daysConnection_SOME` instead. */
  daysConnection?: InputMaybe<AbsenceDaysConnectionWhere>;
  /** Return Absences where all of the related AbsenceDaysConnections match this filter */
  daysConnection_ALL?: InputMaybe<AbsenceDaysConnectionWhere>;
  /** Return Absences where none of the related AbsenceDaysConnections match this filter */
  daysConnection_NONE?: InputMaybe<AbsenceDaysConnectionWhere>;
  /** @deprecated Use `daysConnection_NONE` instead. */
  daysConnection_NOT?: InputMaybe<AbsenceDaysConnectionWhere>;
  /** Return Absences where one of the related AbsenceDaysConnections match this filter */
  daysConnection_SINGLE?: InputMaybe<AbsenceDaysConnectionWhere>;
  /** Return Absences where some of the related AbsenceDaysConnections match this filter */
  daysConnection_SOME?: InputMaybe<AbsenceDaysConnectionWhere>;
  /** Return Absences where all of the related Days match this filter */
  days_ALL?: InputMaybe<DayWhere>;
  /** Return Absences where none of the related Days match this filter */
  days_NONE?: InputMaybe<DayWhere>;
  /** @deprecated Use `days_NONE` instead. */
  days_NOT?: InputMaybe<DayWhere>;
  /** Return Absences where one of the related Days match this filter */
  days_SINGLE?: InputMaybe<DayWhere>;
  /** Return Absences where some of the related Days match this filter */
  days_SOME?: InputMaybe<DayWhere>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  endTime_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endTime_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endTime_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  endTime_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endTime_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  endTime_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  endTime_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  excused?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  excused_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  foreignRefId?: InputMaybe<Array<Scalars['String']['input']>>;
  foreignRefId_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignRefId_NOT?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignRefId_NOT_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<ProfileWhere>;
  ownerAggregate?: InputMaybe<AbsenceOwnerAggregateInput>;
  ownerConnection?: InputMaybe<AbsenceOwnerConnectionWhere>;
  ownerConnection_NOT?: InputMaybe<AbsenceOwnerConnectionWhere>;
  owner_NOT?: InputMaybe<ProfileWhere>;
  reason?: InputMaybe<AbsenceReasonWhere>;
  reasonAggregate?: InputMaybe<AbsenceReasonAggregateInput>;
  reasonConnection?: InputMaybe<AbsenceReasonConnectionWhere>;
  reasonConnection_NOT?: InputMaybe<AbsenceReasonConnectionWhere>;
  reason_NOT?: InputMaybe<AbsenceReasonWhere>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  startTime_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startTime_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startTime_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  startTime_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startTime_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  startTime_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  startTime_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  updated_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updated_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updated_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updated_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  wholeDay?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  wholeDay_NOT?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AbsencesConnection = {
  __typename?: 'AbsencesConnection';
  edges: Array<AbsenceEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Assignment = {
  __typename?: 'Assignment';
  allowSubmissionAfterDueDate?: Maybe<Scalars['Boolean']['output']>;
  course: Group;
  courseConnection: AssignmentCourseConnection;
  created: Scalars['DateTime']['output'];
  dueDate?: Maybe<Day>;
  dueDateConnection: AssignmentDueDateConnection;
  holder: AssignmentHolder;
  holderConnection: AssignmentHolderConnection;
  material: Material;
  materialConnection: AssignmentMaterialConnection;
  submissions: Array<Submission>;
  submissionsAggregate?: Maybe<AssignmentSubmissionSubmissionsAggregationSelection>;
  submissionsConnection: AssignmentSubmissionsConnection;
  title: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  uuid: Scalars['ID']['output'];
  visibleFrom?: Maybe<Day>;
  visibleFromConnection: AssignmentVisibleFromConnection;
};

export type AssignmentCourseArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<GroupOptions>;
  where?: InputMaybe<GroupWhere>;
};

export type AssignmentCourseConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AssignmentCourseConnectionSort>>;
  where?: InputMaybe<AssignmentCourseConnectionWhere>;
};

export type AssignmentDueDateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DayOptions>;
  where?: InputMaybe<DayWhere>;
};

export type AssignmentDueDateConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AssignmentDueDateConnectionSort>>;
  where?: InputMaybe<AssignmentDueDateConnectionWhere>;
};

export type AssignmentHolderArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<AssignmentHolderWhere>;
};

export type AssignmentHolderConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssignmentHolderConnectionWhere>;
};

export type AssignmentMaterialArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<MaterialOptions>;
  where?: InputMaybe<MaterialWhere>;
};

export type AssignmentMaterialConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AssignmentMaterialConnectionSort>>;
  where?: InputMaybe<AssignmentMaterialConnectionWhere>;
};

export type AssignmentSubmissionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SubmissionOptions>;
  where?: InputMaybe<SubmissionWhere>;
};

export type AssignmentSubmissionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SubmissionWhere>;
};

export type AssignmentSubmissionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AssignmentSubmissionsConnectionSort>>;
  where?: InputMaybe<AssignmentSubmissionsConnectionWhere>;
};

export type AssignmentVisibleFromArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DayOptions>;
  where?: InputMaybe<DayWhere>;
};

export type AssignmentVisibleFromConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AssignmentVisibleFromConnectionSort>>;
  where?: InputMaybe<AssignmentVisibleFromConnectionWhere>;
};

export type AssignmentAggregateSelection = {
  __typename?: 'AssignmentAggregateSelection';
  count: Scalars['Int']['output'];
  created: DateTimeAggregateSelection;
  title: StringAggregateSelection;
  updated: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type AssignmentConnectInput = {
  course?: InputMaybe<AssignmentCourseConnectFieldInput>;
  dueDate?: InputMaybe<AssignmentDueDateConnectFieldInput>;
  holder?: InputMaybe<AssignmentHolderConnectInput>;
  material?: InputMaybe<AssignmentMaterialConnectFieldInput>;
  submissions?: InputMaybe<Array<AssignmentSubmissionsConnectFieldInput>>;
  visibleFrom?: InputMaybe<AssignmentVisibleFromConnectFieldInput>;
};

export type AssignmentConnectWhere = {
  node: AssignmentWhere;
};

export type AssignmentCourseAggregateInput = {
  AND?: InputMaybe<Array<AssignmentCourseAggregateInput>>;
  NOT?: InputMaybe<AssignmentCourseAggregateInput>;
  OR?: InputMaybe<Array<AssignmentCourseAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AssignmentCourseNodeAggregationWhereInput>;
};

export type AssignmentCourseConnectFieldInput = {
  connect?: InputMaybe<GroupConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<GroupConnectWhere>;
};

export type AssignmentCourseConnectOrCreateFieldInput = {
  onCreate: AssignmentCourseConnectOrCreateFieldInputOnCreate;
  where: GroupConnectOrCreateWhere;
};

export type AssignmentCourseConnectOrCreateFieldInputOnCreate = {
  node: GroupOnCreateInput;
};

export type AssignmentCourseConnection = {
  __typename?: 'AssignmentCourseConnection';
  edges: Array<AssignmentCourseRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssignmentCourseConnectionSort = {
  node?: InputMaybe<GroupSort>;
};

export type AssignmentCourseConnectionWhere = {
  AND?: InputMaybe<Array<AssignmentCourseConnectionWhere>>;
  NOT?: InputMaybe<AssignmentCourseConnectionWhere>;
  OR?: InputMaybe<Array<AssignmentCourseConnectionWhere>>;
  node?: InputMaybe<GroupWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<GroupWhere>;
};

export type AssignmentCourseCreateFieldInput = {
  node: GroupCreateInput;
};

export type AssignmentCourseDeleteFieldInput = {
  delete?: InputMaybe<GroupDeleteInput>;
  where?: InputMaybe<AssignmentCourseConnectionWhere>;
};

export type AssignmentCourseDisconnectFieldInput = {
  disconnect?: InputMaybe<GroupDisconnectInput>;
  where?: InputMaybe<AssignmentCourseConnectionWhere>;
};

export type AssignmentCourseFieldInput = {
  connect?: InputMaybe<AssignmentCourseConnectFieldInput>;
  connectOrCreate?: InputMaybe<AssignmentCourseConnectOrCreateFieldInput>;
  create?: InputMaybe<AssignmentCourseCreateFieldInput>;
};

export type AssignmentCourseNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AssignmentCourseNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AssignmentCourseNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AssignmentCourseNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AssignmentCourseRelationship = {
  __typename?: 'AssignmentCourseRelationship';
  cursor: Scalars['String']['output'];
  node: Group;
};

export type AssignmentCourseUpdateConnectionInput = {
  node?: InputMaybe<GroupUpdateInput>;
};

export type AssignmentCourseUpdateFieldInput = {
  connect?: InputMaybe<AssignmentCourseConnectFieldInput>;
  connectOrCreate?: InputMaybe<AssignmentCourseConnectOrCreateFieldInput>;
  create?: InputMaybe<AssignmentCourseCreateFieldInput>;
  delete?: InputMaybe<AssignmentCourseDeleteFieldInput>;
  disconnect?: InputMaybe<AssignmentCourseDisconnectFieldInput>;
  update?: InputMaybe<AssignmentCourseUpdateConnectionInput>;
  where?: InputMaybe<AssignmentCourseConnectionWhere>;
};

export type AssignmentCreateInput = {
  allowSubmissionAfterDueDate?: InputMaybe<Scalars['Boolean']['input']>;
  course?: InputMaybe<AssignmentCourseFieldInput>;
  dueDate?: InputMaybe<AssignmentDueDateFieldInput>;
  holder?: InputMaybe<AssignmentHolderCreateInput>;
  material?: InputMaybe<AssignmentMaterialFieldInput>;
  submissions?: InputMaybe<AssignmentSubmissionsFieldInput>;
  title: Scalars['String']['input'];
  visibleFrom?: InputMaybe<AssignmentVisibleFromFieldInput>;
};

export type AssignmentDeleteInput = {
  course?: InputMaybe<AssignmentCourseDeleteFieldInput>;
  dueDate?: InputMaybe<AssignmentDueDateDeleteFieldInput>;
  holder?: InputMaybe<AssignmentHolderDeleteInput>;
  material?: InputMaybe<AssignmentMaterialDeleteFieldInput>;
  submissions?: InputMaybe<Array<AssignmentSubmissionsDeleteFieldInput>>;
  visibleFrom?: InputMaybe<AssignmentVisibleFromDeleteFieldInput>;
};

export type AssignmentDisconnectInput = {
  course?: InputMaybe<AssignmentCourseDisconnectFieldInput>;
  dueDate?: InputMaybe<AssignmentDueDateDisconnectFieldInput>;
  holder?: InputMaybe<AssignmentHolderDisconnectInput>;
  material?: InputMaybe<AssignmentMaterialDisconnectFieldInput>;
  submissions?: InputMaybe<Array<AssignmentSubmissionsDisconnectFieldInput>>;
  visibleFrom?: InputMaybe<AssignmentVisibleFromDisconnectFieldInput>;
};

export type AssignmentDueDateAggregateInput = {
  AND?: InputMaybe<Array<AssignmentDueDateAggregateInput>>;
  NOT?: InputMaybe<AssignmentDueDateAggregateInput>;
  OR?: InputMaybe<Array<AssignmentDueDateAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AssignmentDueDateNodeAggregationWhereInput>;
};

export type AssignmentDueDateConnectFieldInput = {
  connect?: InputMaybe<DayConnectInput>;
  edge?: InputMaybe<DayRelationPropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<DayConnectWhere>;
};

export type AssignmentDueDateConnectOrCreateFieldInput = {
  onCreate: AssignmentDueDateConnectOrCreateFieldInputOnCreate;
  where: DayConnectOrCreateWhere;
};

export type AssignmentDueDateConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<DayRelationPropertiesCreateInput>;
  node: DayOnCreateInput;
};

export type AssignmentDueDateConnection = {
  __typename?: 'AssignmentDueDateConnection';
  edges: Array<AssignmentDueDateRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssignmentDueDateConnectionSort = {
  edge?: InputMaybe<DayRelationPropertiesSort>;
  node?: InputMaybe<DaySort>;
};

export type AssignmentDueDateConnectionWhere = {
  AND?: InputMaybe<Array<AssignmentDueDateConnectionWhere>>;
  NOT?: InputMaybe<AssignmentDueDateConnectionWhere>;
  OR?: InputMaybe<Array<AssignmentDueDateConnectionWhere>>;
  edge?: InputMaybe<DayRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<DayRelationPropertiesWhere>;
  node?: InputMaybe<DayWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<DayWhere>;
};

export type AssignmentDueDateCreateFieldInput = {
  edge?: InputMaybe<DayRelationPropertiesCreateInput>;
  node: DayCreateInput;
};

export type AssignmentDueDateDeleteFieldInput = {
  delete?: InputMaybe<DayDeleteInput>;
  where?: InputMaybe<AssignmentDueDateConnectionWhere>;
};

export type AssignmentDueDateDisconnectFieldInput = {
  disconnect?: InputMaybe<DayDisconnectInput>;
  where?: InputMaybe<AssignmentDueDateConnectionWhere>;
};

export type AssignmentDueDateFieldInput = {
  connect?: InputMaybe<AssignmentDueDateConnectFieldInput>;
  connectOrCreate?: InputMaybe<AssignmentDueDateConnectOrCreateFieldInput>;
  create?: InputMaybe<AssignmentDueDateCreateFieldInput>;
};

export type AssignmentDueDateNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AssignmentDueDateNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AssignmentDueDateNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AssignmentDueDateNodeAggregationWhereInput>>;
  date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  day_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  day_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  day_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  day_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  day_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  day_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  day_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  day_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  day_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  day_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  month_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  month_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  month_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  month_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  month_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  month_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  month_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  month_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  month_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  month_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  week_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  week_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  week_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  week_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  week_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  week_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  week_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  week_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  week_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  week_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  year_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  year_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AssignmentDueDateRelationship = {
  __typename?: 'AssignmentDueDateRelationship';
  cursor: Scalars['String']['output'];
  node: Day;
  properties: DayRelationProperties;
};

export type AssignmentDueDateUpdateConnectionInput = {
  edge?: InputMaybe<DayRelationPropertiesUpdateInput>;
  node?: InputMaybe<DayUpdateInput>;
};

export type AssignmentDueDateUpdateFieldInput = {
  connect?: InputMaybe<AssignmentDueDateConnectFieldInput>;
  connectOrCreate?: InputMaybe<AssignmentDueDateConnectOrCreateFieldInput>;
  create?: InputMaybe<AssignmentDueDateCreateFieldInput>;
  delete?: InputMaybe<AssignmentDueDateDeleteFieldInput>;
  disconnect?: InputMaybe<AssignmentDueDateDisconnectFieldInput>;
  update?: InputMaybe<AssignmentDueDateUpdateConnectionInput>;
  where?: InputMaybe<AssignmentDueDateConnectionWhere>;
};

export type AssignmentEdge = {
  __typename?: 'AssignmentEdge';
  cursor: Scalars['String']['output'];
  node: Assignment;
};

export type AssignmentHolder = TeachingUnit;

export type AssignmentHolderConnectInput = {
  TeachingUnit?: InputMaybe<AssignmentHolderTeachingUnitConnectFieldInput>;
};

export type AssignmentHolderConnection = {
  __typename?: 'AssignmentHolderConnection';
  edges: Array<AssignmentHolderRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssignmentHolderConnectionWhere = {
  TeachingUnit?: InputMaybe<AssignmentHolderTeachingUnitConnectionWhere>;
};

export type AssignmentHolderCreateInput = {
  TeachingUnit?: InputMaybe<AssignmentHolderTeachingUnitFieldInput>;
};

export type AssignmentHolderDeleteInput = {
  TeachingUnit?: InputMaybe<AssignmentHolderTeachingUnitDeleteFieldInput>;
};

export type AssignmentHolderDisconnectInput = {
  TeachingUnit?: InputMaybe<AssignmentHolderTeachingUnitDisconnectFieldInput>;
};

export type AssignmentHolderRelationship = {
  __typename?: 'AssignmentHolderRelationship';
  cursor: Scalars['String']['output'];
  node: AssignmentHolder;
};

export type AssignmentHolderTeachingUnitConnectFieldInput = {
  connect?: InputMaybe<TeachingUnitConnectInput>;
  where?: InputMaybe<TeachingUnitConnectWhere>;
};

export type AssignmentHolderTeachingUnitConnectionWhere = {
  AND?: InputMaybe<Array<AssignmentHolderTeachingUnitConnectionWhere>>;
  NOT?: InputMaybe<AssignmentHolderTeachingUnitConnectionWhere>;
  OR?: InputMaybe<Array<AssignmentHolderTeachingUnitConnectionWhere>>;
  node?: InputMaybe<TeachingUnitWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TeachingUnitWhere>;
};

export type AssignmentHolderTeachingUnitCreateFieldInput = {
  node: TeachingUnitCreateInput;
};

export type AssignmentHolderTeachingUnitDeleteFieldInput = {
  delete?: InputMaybe<TeachingUnitDeleteInput>;
  where?: InputMaybe<AssignmentHolderTeachingUnitConnectionWhere>;
};

export type AssignmentHolderTeachingUnitDisconnectFieldInput = {
  disconnect?: InputMaybe<TeachingUnitDisconnectInput>;
  where?: InputMaybe<AssignmentHolderTeachingUnitConnectionWhere>;
};

export type AssignmentHolderTeachingUnitFieldInput = {
  connect?: InputMaybe<AssignmentHolderTeachingUnitConnectFieldInput>;
  create?: InputMaybe<AssignmentHolderTeachingUnitCreateFieldInput>;
};

export type AssignmentHolderTeachingUnitUpdateConnectionInput = {
  node?: InputMaybe<TeachingUnitUpdateInput>;
};

export type AssignmentHolderTeachingUnitUpdateFieldInput = {
  connect?: InputMaybe<AssignmentHolderTeachingUnitConnectFieldInput>;
  create?: InputMaybe<AssignmentHolderTeachingUnitCreateFieldInput>;
  delete?: InputMaybe<AssignmentHolderTeachingUnitDeleteFieldInput>;
  disconnect?: InputMaybe<AssignmentHolderTeachingUnitDisconnectFieldInput>;
  update?: InputMaybe<AssignmentHolderTeachingUnitUpdateConnectionInput>;
  where?: InputMaybe<AssignmentHolderTeachingUnitConnectionWhere>;
};

export type AssignmentHolderUpdateInput = {
  TeachingUnit?: InputMaybe<AssignmentHolderTeachingUnitUpdateFieldInput>;
};

export type AssignmentHolderWhere = {
  TeachingUnit?: InputMaybe<TeachingUnitWhere>;
};

export type AssignmentMaterialAggregateInput = {
  AND?: InputMaybe<Array<AssignmentMaterialAggregateInput>>;
  NOT?: InputMaybe<AssignmentMaterialAggregateInput>;
  OR?: InputMaybe<Array<AssignmentMaterialAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AssignmentMaterialNodeAggregationWhereInput>;
};

export type AssignmentMaterialConnectFieldInput = {
  connect?: InputMaybe<MaterialConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<MaterialConnectWhere>;
};

export type AssignmentMaterialConnection = {
  __typename?: 'AssignmentMaterialConnection';
  edges: Array<AssignmentMaterialRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssignmentMaterialConnectionSort = {
  node?: InputMaybe<MaterialSort>;
};

export type AssignmentMaterialConnectionWhere = {
  AND?: InputMaybe<Array<AssignmentMaterialConnectionWhere>>;
  NOT?: InputMaybe<AssignmentMaterialConnectionWhere>;
  OR?: InputMaybe<Array<AssignmentMaterialConnectionWhere>>;
  node?: InputMaybe<MaterialWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<MaterialWhere>;
};

export type AssignmentMaterialCreateFieldInput = {
  node: MaterialCreateInput;
};

export type AssignmentMaterialDeleteFieldInput = {
  delete?: InputMaybe<MaterialDeleteInput>;
  where?: InputMaybe<AssignmentMaterialConnectionWhere>;
};

export type AssignmentMaterialDisconnectFieldInput = {
  disconnect?: InputMaybe<MaterialDisconnectInput>;
  where?: InputMaybe<AssignmentMaterialConnectionWhere>;
};

export type AssignmentMaterialFieldInput = {
  connect?: InputMaybe<AssignmentMaterialConnectFieldInput>;
  create?: InputMaybe<AssignmentMaterialCreateFieldInput>;
};

export type AssignmentMaterialNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AssignmentMaterialNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AssignmentMaterialNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AssignmentMaterialNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  textMediaType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  textMediaType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  textMediaType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  textMediaType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  textMediaType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  textMediaType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  textMediaType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  textMediaType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  textMediaType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  textMediaType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  textMediaType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  textMediaType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  textMediaType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  textMediaType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  textMediaType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  text_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  text_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AssignmentMaterialRelationship = {
  __typename?: 'AssignmentMaterialRelationship';
  cursor: Scalars['String']['output'];
  node: Material;
};

export type AssignmentMaterialUpdateConnectionInput = {
  node?: InputMaybe<MaterialUpdateInput>;
};

export type AssignmentMaterialUpdateFieldInput = {
  connect?: InputMaybe<AssignmentMaterialConnectFieldInput>;
  create?: InputMaybe<AssignmentMaterialCreateFieldInput>;
  delete?: InputMaybe<AssignmentMaterialDeleteFieldInput>;
  disconnect?: InputMaybe<AssignmentMaterialDisconnectFieldInput>;
  update?: InputMaybe<AssignmentMaterialUpdateConnectionInput>;
  where?: InputMaybe<AssignmentMaterialConnectionWhere>;
};

export type AssignmentOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AssignmentSort objects to sort Assignments by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AssignmentSort>>;
};

/** Fields to sort Assignments by. The order in which sorts are applied is not guaranteed when specifying many fields in one AssignmentSort object. */
export type AssignmentSort = {
  allowSubmissionAfterDueDate?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
  updated?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type AssignmentSubmissionSubmissionsAggregationSelection = {
  __typename?: 'AssignmentSubmissionSubmissionsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AssignmentSubmissionSubmissionsNodeAggregateSelection>;
};

export type AssignmentSubmissionSubmissionsNodeAggregateSelection = {
  __typename?: 'AssignmentSubmissionSubmissionsNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  matrixRoomId: StringAggregateSelection;
  updated: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type AssignmentSubmissionsAggregateInput = {
  AND?: InputMaybe<Array<AssignmentSubmissionsAggregateInput>>;
  NOT?: InputMaybe<AssignmentSubmissionsAggregateInput>;
  OR?: InputMaybe<Array<AssignmentSubmissionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AssignmentSubmissionsNodeAggregationWhereInput>;
};

export type AssignmentSubmissionsConnectFieldInput = {
  connect?: InputMaybe<Array<SubmissionConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SubmissionConnectWhere>;
};

export type AssignmentSubmissionsConnection = {
  __typename?: 'AssignmentSubmissionsConnection';
  edges: Array<AssignmentSubmissionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssignmentSubmissionsConnectionSort = {
  node?: InputMaybe<SubmissionSort>;
};

export type AssignmentSubmissionsConnectionWhere = {
  AND?: InputMaybe<Array<AssignmentSubmissionsConnectionWhere>>;
  NOT?: InputMaybe<AssignmentSubmissionsConnectionWhere>;
  OR?: InputMaybe<Array<AssignmentSubmissionsConnectionWhere>>;
  node?: InputMaybe<SubmissionWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SubmissionWhere>;
};

export type AssignmentSubmissionsCreateFieldInput = {
  node: SubmissionCreateInput;
};

export type AssignmentSubmissionsDeleteFieldInput = {
  delete?: InputMaybe<SubmissionDeleteInput>;
  where?: InputMaybe<AssignmentSubmissionsConnectionWhere>;
};

export type AssignmentSubmissionsDisconnectFieldInput = {
  disconnect?: InputMaybe<SubmissionDisconnectInput>;
  where?: InputMaybe<AssignmentSubmissionsConnectionWhere>;
};

export type AssignmentSubmissionsFieldInput = {
  connect?: InputMaybe<Array<AssignmentSubmissionsConnectFieldInput>>;
  create?: InputMaybe<Array<AssignmentSubmissionsCreateFieldInput>>;
};

export type AssignmentSubmissionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AssignmentSubmissionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AssignmentSubmissionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AssignmentSubmissionsNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  matrixRoomId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AssignmentSubmissionsRelationship = {
  __typename?: 'AssignmentSubmissionsRelationship';
  cursor: Scalars['String']['output'];
  node: Submission;
};

export type AssignmentSubmissionsUpdateConnectionInput = {
  node?: InputMaybe<SubmissionUpdateInput>;
};

export type AssignmentSubmissionsUpdateFieldInput = {
  connect?: InputMaybe<Array<AssignmentSubmissionsConnectFieldInput>>;
  create?: InputMaybe<Array<AssignmentSubmissionsCreateFieldInput>>;
  delete?: InputMaybe<Array<AssignmentSubmissionsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AssignmentSubmissionsDisconnectFieldInput>>;
  update?: InputMaybe<AssignmentSubmissionsUpdateConnectionInput>;
  where?: InputMaybe<AssignmentSubmissionsConnectionWhere>;
};

export type AssignmentUpdateInput = {
  allowSubmissionAfterDueDate?: InputMaybe<Scalars['Boolean']['input']>;
  course?: InputMaybe<AssignmentCourseUpdateFieldInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate?: InputMaybe<AssignmentDueDateUpdateFieldInput>;
  holder?: InputMaybe<AssignmentHolderUpdateInput>;
  material?: InputMaybe<AssignmentMaterialUpdateFieldInput>;
  submissions?: InputMaybe<Array<AssignmentSubmissionsUpdateFieldInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
  visibleFrom?: InputMaybe<AssignmentVisibleFromUpdateFieldInput>;
};

export type AssignmentVisibleFromAggregateInput = {
  AND?: InputMaybe<Array<AssignmentVisibleFromAggregateInput>>;
  NOT?: InputMaybe<AssignmentVisibleFromAggregateInput>;
  OR?: InputMaybe<Array<AssignmentVisibleFromAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AssignmentVisibleFromNodeAggregationWhereInput>;
};

export type AssignmentVisibleFromConnectFieldInput = {
  connect?: InputMaybe<DayConnectInput>;
  edge?: InputMaybe<DayRelationPropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<DayConnectWhere>;
};

export type AssignmentVisibleFromConnectOrCreateFieldInput = {
  onCreate: AssignmentVisibleFromConnectOrCreateFieldInputOnCreate;
  where: DayConnectOrCreateWhere;
};

export type AssignmentVisibleFromConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<DayRelationPropertiesCreateInput>;
  node: DayOnCreateInput;
};

export type AssignmentVisibleFromConnection = {
  __typename?: 'AssignmentVisibleFromConnection';
  edges: Array<AssignmentVisibleFromRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssignmentVisibleFromConnectionSort = {
  edge?: InputMaybe<DayRelationPropertiesSort>;
  node?: InputMaybe<DaySort>;
};

export type AssignmentVisibleFromConnectionWhere = {
  AND?: InputMaybe<Array<AssignmentVisibleFromConnectionWhere>>;
  NOT?: InputMaybe<AssignmentVisibleFromConnectionWhere>;
  OR?: InputMaybe<Array<AssignmentVisibleFromConnectionWhere>>;
  edge?: InputMaybe<DayRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<DayRelationPropertiesWhere>;
  node?: InputMaybe<DayWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<DayWhere>;
};

export type AssignmentVisibleFromCreateFieldInput = {
  edge?: InputMaybe<DayRelationPropertiesCreateInput>;
  node: DayCreateInput;
};

export type AssignmentVisibleFromDeleteFieldInput = {
  delete?: InputMaybe<DayDeleteInput>;
  where?: InputMaybe<AssignmentVisibleFromConnectionWhere>;
};

export type AssignmentVisibleFromDisconnectFieldInput = {
  disconnect?: InputMaybe<DayDisconnectInput>;
  where?: InputMaybe<AssignmentVisibleFromConnectionWhere>;
};

export type AssignmentVisibleFromFieldInput = {
  connect?: InputMaybe<AssignmentVisibleFromConnectFieldInput>;
  connectOrCreate?: InputMaybe<AssignmentVisibleFromConnectOrCreateFieldInput>;
  create?: InputMaybe<AssignmentVisibleFromCreateFieldInput>;
};

export type AssignmentVisibleFromNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AssignmentVisibleFromNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AssignmentVisibleFromNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AssignmentVisibleFromNodeAggregationWhereInput>>;
  date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  day_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  day_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  day_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  day_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  day_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  day_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  day_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  day_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  day_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  day_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  month_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  month_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  month_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  month_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  month_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  month_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  month_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  month_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  month_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  month_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  week_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  week_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  week_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  week_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  week_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  week_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  week_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  week_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  week_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  week_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  year_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  year_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AssignmentVisibleFromRelationship = {
  __typename?: 'AssignmentVisibleFromRelationship';
  cursor: Scalars['String']['output'];
  node: Day;
  properties: DayRelationProperties;
};

export type AssignmentVisibleFromUpdateConnectionInput = {
  edge?: InputMaybe<DayRelationPropertiesUpdateInput>;
  node?: InputMaybe<DayUpdateInput>;
};

export type AssignmentVisibleFromUpdateFieldInput = {
  connect?: InputMaybe<AssignmentVisibleFromConnectFieldInput>;
  connectOrCreate?: InputMaybe<AssignmentVisibleFromConnectOrCreateFieldInput>;
  create?: InputMaybe<AssignmentVisibleFromCreateFieldInput>;
  delete?: InputMaybe<AssignmentVisibleFromDeleteFieldInput>;
  disconnect?: InputMaybe<AssignmentVisibleFromDisconnectFieldInput>;
  update?: InputMaybe<AssignmentVisibleFromUpdateConnectionInput>;
  where?: InputMaybe<AssignmentVisibleFromConnectionWhere>;
};

export type AssignmentWhere = {
  AND?: InputMaybe<Array<AssignmentWhere>>;
  NOT?: InputMaybe<AssignmentWhere>;
  OR?: InputMaybe<Array<AssignmentWhere>>;
  allowSubmissionAfterDueDate?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  allowSubmissionAfterDueDate_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  course?: InputMaybe<GroupWhere>;
  courseAggregate?: InputMaybe<AssignmentCourseAggregateInput>;
  courseConnection?: InputMaybe<AssignmentCourseConnectionWhere>;
  courseConnection_NOT?: InputMaybe<AssignmentCourseConnectionWhere>;
  course_NOT?: InputMaybe<GroupWhere>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  created_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  created_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  dueDate?: InputMaybe<DayWhere>;
  dueDateAggregate?: InputMaybe<AssignmentDueDateAggregateInput>;
  dueDateConnection?: InputMaybe<AssignmentDueDateConnectionWhere>;
  dueDateConnection_NOT?: InputMaybe<AssignmentDueDateConnectionWhere>;
  dueDate_NOT?: InputMaybe<DayWhere>;
  holder?: InputMaybe<AssignmentHolderWhere>;
  holderConnection?: InputMaybe<AssignmentHolderConnectionWhere>;
  holderConnection_NOT?: InputMaybe<AssignmentHolderConnectionWhere>;
  holder_NOT?: InputMaybe<AssignmentHolderWhere>;
  material?: InputMaybe<MaterialWhere>;
  materialAggregate?: InputMaybe<AssignmentMaterialAggregateInput>;
  materialConnection?: InputMaybe<AssignmentMaterialConnectionWhere>;
  materialConnection_NOT?: InputMaybe<AssignmentMaterialConnectionWhere>;
  material_NOT?: InputMaybe<MaterialWhere>;
  /** @deprecated Use `submissions_SOME` instead. */
  submissions?: InputMaybe<SubmissionWhere>;
  submissionsAggregate?: InputMaybe<AssignmentSubmissionsAggregateInput>;
  /** @deprecated Use `submissionsConnection_SOME` instead. */
  submissionsConnection?: InputMaybe<AssignmentSubmissionsConnectionWhere>;
  /** Return Assignments where all of the related AssignmentSubmissionsConnections match this filter */
  submissionsConnection_ALL?: InputMaybe<AssignmentSubmissionsConnectionWhere>;
  /** Return Assignments where none of the related AssignmentSubmissionsConnections match this filter */
  submissionsConnection_NONE?: InputMaybe<AssignmentSubmissionsConnectionWhere>;
  /** @deprecated Use `submissionsConnection_NONE` instead. */
  submissionsConnection_NOT?: InputMaybe<AssignmentSubmissionsConnectionWhere>;
  /** Return Assignments where one of the related AssignmentSubmissionsConnections match this filter */
  submissionsConnection_SINGLE?: InputMaybe<AssignmentSubmissionsConnectionWhere>;
  /** Return Assignments where some of the related AssignmentSubmissionsConnections match this filter */
  submissionsConnection_SOME?: InputMaybe<AssignmentSubmissionsConnectionWhere>;
  /** Return Assignments where all of the related Submissions match this filter */
  submissions_ALL?: InputMaybe<SubmissionWhere>;
  /** Return Assignments where none of the related Submissions match this filter */
  submissions_NONE?: InputMaybe<SubmissionWhere>;
  /** @deprecated Use `submissions_NONE` instead. */
  submissions_NOT?: InputMaybe<SubmissionWhere>;
  /** Return Assignments where one of the related Submissions match this filter */
  submissions_SINGLE?: InputMaybe<SubmissionWhere>;
  /** Return Assignments where some of the related Submissions match this filter */
  submissions_SOME?: InputMaybe<SubmissionWhere>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  updated_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updated_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updated_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updated_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  visibleFrom?: InputMaybe<DayWhere>;
  visibleFromAggregate?: InputMaybe<AssignmentVisibleFromAggregateInput>;
  visibleFromConnection?: InputMaybe<AssignmentVisibleFromConnectionWhere>;
  visibleFromConnection_NOT?: InputMaybe<AssignmentVisibleFromConnectionWhere>;
  visibleFrom_NOT?: InputMaybe<DayWhere>;
};

export type AssignmentsConnection = {
  __typename?: 'AssignmentsConnection';
  edges: Array<AssignmentEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BigBlueButton = {
  __typename?: 'BigBlueButton';
  allowRecording?: Maybe<Scalars['Boolean']['output']>;
  apiUrl?: Maybe<Scalars['String']['output']>;
  /**
   * how many participants are at nax allowed in one meeting, if 0 no limit
   * has nothing to do with how many concurrent connections are allowed
   * => concurrent connections are from "version" field auf LicenseProperties (number = connection, 0 = unlimited)
   */
  maxParticipantsPerMeeting?: Maybe<Scalars['Int']['output']>;
  organization: Organization;
  organizationAggregate?: Maybe<BigBlueButtonOrganizationOrganizationAggregationSelection>;
  organizationConnection: BigBlueButtonOrganizationConnection;
  uuid: Scalars['ID']['output'];
};

export type BigBlueButtonOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type BigBlueButtonOrganizationAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OrganizationWhere>;
};

export type BigBlueButtonOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BigBlueButtonOrganizationConnectionSort>>;
  where?: InputMaybe<BigBlueButtonOrganizationConnectionWhere>;
};

export type BigBlueButtonAggregateSelection = {
  __typename?: 'BigBlueButtonAggregateSelection';
  apiUrl: StringAggregateSelection;
  count: Scalars['Int']['output'];
  maxParticipantsPerMeeting: IntAggregateSelection;
  uuid: IdAggregateSelection;
};

export type BigBlueButtonConnectInput = {
  organization?: InputMaybe<BigBlueButtonOrganizationConnectFieldInput>;
};

export type BigBlueButtonConnectWhere = {
  node: BigBlueButtonWhere;
};

export type BigBlueButtonCreateInput = {
  allowRecording?: InputMaybe<Scalars['Boolean']['input']>;
  apiUrl?: InputMaybe<Scalars['String']['input']>;
  maxParticipantsPerMeeting?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<BigBlueButtonOrganizationFieldInput>;
};

export type BigBlueButtonDeleteInput = {
  organization?: InputMaybe<BigBlueButtonOrganizationDeleteFieldInput>;
};

export type BigBlueButtonDisconnectInput = {
  organization?: InputMaybe<BigBlueButtonOrganizationDisconnectFieldInput>;
};

export type BigBlueButtonEdge = {
  __typename?: 'BigBlueButtonEdge';
  cursor: Scalars['String']['output'];
  node: BigBlueButton;
};

export type BigBlueButtonOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more BigBlueButtonSort objects to sort BigBlueButtons by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<BigBlueButtonSort>>;
};

export type BigBlueButtonOrganizationAggregateInput = {
  AND?: InputMaybe<Array<BigBlueButtonOrganizationAggregateInput>>;
  NOT?: InputMaybe<BigBlueButtonOrganizationAggregateInput>;
  OR?: InputMaybe<Array<BigBlueButtonOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<LicensePropertiesAggregationWhereInput>;
  node?: InputMaybe<BigBlueButtonOrganizationNodeAggregationWhereInput>;
};

export type BigBlueButtonOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  edge?: InputMaybe<LicensePropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type BigBlueButtonOrganizationConnectOrCreateFieldInput = {
  onCreate: BigBlueButtonOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type BigBlueButtonOrganizationConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<LicensePropertiesCreateInput>;
  node: OrganizationOnCreateInput;
};

export type BigBlueButtonOrganizationConnection = {
  __typename?: 'BigBlueButtonOrganizationConnection';
  edges: Array<BigBlueButtonOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BigBlueButtonOrganizationConnectionSort = {
  edge?: InputMaybe<LicensePropertiesSort>;
  node?: InputMaybe<OrganizationSort>;
};

export type BigBlueButtonOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<BigBlueButtonOrganizationConnectionWhere>>;
  NOT?: InputMaybe<BigBlueButtonOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<BigBlueButtonOrganizationConnectionWhere>>;
  edge?: InputMaybe<LicensePropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<LicensePropertiesWhere>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type BigBlueButtonOrganizationCreateFieldInput = {
  edge?: InputMaybe<LicensePropertiesCreateInput>;
  node: OrganizationCreateInput;
};

export type BigBlueButtonOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<BigBlueButtonOrganizationConnectionWhere>;
};

export type BigBlueButtonOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<BigBlueButtonOrganizationConnectionWhere>;
};

export type BigBlueButtonOrganizationFieldInput = {
  connect?: InputMaybe<BigBlueButtonOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<BigBlueButtonOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<BigBlueButtonOrganizationCreateFieldInput>;
};

export type BigBlueButtonOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BigBlueButtonOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BigBlueButtonOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BigBlueButtonOrganizationNodeAggregationWhereInput>>;
  aboutInfoLastUpdated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BigBlueButtonOrganizationOrganizationAggregationSelection = {
  __typename?: 'BigBlueButtonOrganizationOrganizationAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<BigBlueButtonOrganizationOrganizationEdgeAggregateSelection>;
  node?: Maybe<BigBlueButtonOrganizationOrganizationNodeAggregateSelection>;
};

export type BigBlueButtonOrganizationOrganizationEdgeAggregateSelection = {
  __typename?: 'BigBlueButtonOrganizationOrganizationEdgeAggregateSelection';
  contractRef: StringAggregateSelection;
  notAfter: DateTimeAggregateSelection;
  notBefore: DateTimeAggregateSelection;
  version: StringAggregateSelection;
};

export type BigBlueButtonOrganizationOrganizationNodeAggregateSelection = {
  __typename?: 'BigBlueButtonOrganizationOrganizationNodeAggregateSelection';
  aboutInfo: StringAggregateSelection;
  aboutInfoLastUpdated: DateTimeAggregateSelection;
  displayName: StringAggregateSelection;
  matrixRoomId: StringAggregateSelection;
  planungSyncProps: StringAggregateSelection;
  procuratSyncProps: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type BigBlueButtonOrganizationRelationship = {
  __typename?: 'BigBlueButtonOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
  properties: LicenseProperties;
};

export type BigBlueButtonOrganizationUpdateConnectionInput = {
  edge?: InputMaybe<LicensePropertiesUpdateInput>;
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type BigBlueButtonOrganizationUpdateFieldInput = {
  connect?: InputMaybe<BigBlueButtonOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<BigBlueButtonOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<BigBlueButtonOrganizationCreateFieldInput>;
  delete?: InputMaybe<BigBlueButtonOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<BigBlueButtonOrganizationDisconnectFieldInput>;
  update?: InputMaybe<BigBlueButtonOrganizationUpdateConnectionInput>;
  where?: InputMaybe<BigBlueButtonOrganizationConnectionWhere>;
};

/** Fields to sort BigBlueButtons by. The order in which sorts are applied is not guaranteed when specifying many fields in one BigBlueButtonSort object. */
export type BigBlueButtonSort = {
  allowRecording?: InputMaybe<SortDirection>;
  apiUrl?: InputMaybe<SortDirection>;
  maxParticipantsPerMeeting?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type BigBlueButtonUpdateInput = {
  allowRecording?: InputMaybe<Scalars['Boolean']['input']>;
  apiUrl?: InputMaybe<Scalars['String']['input']>;
  maxParticipantsPerMeeting?: InputMaybe<Scalars['Int']['input']>;
  maxParticipantsPerMeeting_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  maxParticipantsPerMeeting_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<BigBlueButtonOrganizationUpdateFieldInput>;
};

export type BigBlueButtonWhere = {
  AND?: InputMaybe<Array<BigBlueButtonWhere>>;
  NOT?: InputMaybe<BigBlueButtonWhere>;
  OR?: InputMaybe<Array<BigBlueButtonWhere>>;
  allowRecording?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  allowRecording_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  apiUrl?: InputMaybe<Scalars['String']['input']>;
  apiUrl_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  apiUrl_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  apiUrl_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  apiUrl_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  apiUrl_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  apiUrl_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  apiUrl_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  apiUrl_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  apiUrl_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  maxParticipantsPerMeeting?: InputMaybe<Scalars['Int']['input']>;
  maxParticipantsPerMeeting_GT?: InputMaybe<Scalars['Int']['input']>;
  maxParticipantsPerMeeting_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxParticipantsPerMeeting_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  maxParticipantsPerMeeting_LT?: InputMaybe<Scalars['Int']['input']>;
  maxParticipantsPerMeeting_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  maxParticipantsPerMeeting_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  maxParticipantsPerMeeting_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<BigBlueButtonOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<BigBlueButtonOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<BigBlueButtonOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type BigBlueButtonsConnection = {
  __typename?: 'BigBlueButtonsConnection';
  edges: Array<BigBlueButtonEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Bildungsplattform = {
  __typename?: 'Bildungsplattform';
  allowParentExcuses?: Maybe<Scalars['Boolean']['output']>;
  allowStudentDirectMessages?: Maybe<Scalars['Boolean']['output']>;
  currentSchoolyear?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  organizationAggregate?: Maybe<BildungsplattformOrganizationOrganizationAggregationSelection>;
  organizationConnection: BildungsplattformOrganizationConnection;
  uuid: Scalars['ID']['output'];
};

export type BildungsplattformOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type BildungsplattformOrganizationAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OrganizationWhere>;
};

export type BildungsplattformOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BildungsplattformOrganizationConnectionSort>>;
  where?: InputMaybe<BildungsplattformOrganizationConnectionWhere>;
};

export type BildungsplattformAggregateSelection = {
  __typename?: 'BildungsplattformAggregateSelection';
  count: Scalars['Int']['output'];
  currentSchoolyear: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type BildungsplattformConnectInput = {
  organization?: InputMaybe<BildungsplattformOrganizationConnectFieldInput>;
};

export type BildungsplattformConnectWhere = {
  node: BildungsplattformWhere;
};

export type BildungsplattformCreateInput = {
  allowParentExcuses?: InputMaybe<Scalars['Boolean']['input']>;
  allowStudentDirectMessages?: InputMaybe<Scalars['Boolean']['input']>;
  currentSchoolyear?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<BildungsplattformOrganizationFieldInput>;
};

export type BildungsplattformDeleteInput = {
  organization?: InputMaybe<BildungsplattformOrganizationDeleteFieldInput>;
};

export type BildungsplattformDisconnectInput = {
  organization?: InputMaybe<BildungsplattformOrganizationDisconnectFieldInput>;
};

export type BildungsplattformEdge = {
  __typename?: 'BildungsplattformEdge';
  cursor: Scalars['String']['output'];
  node: Bildungsplattform;
};

export type BildungsplattformOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more BildungsplattformSort objects to sort Bildungsplattforms by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<BildungsplattformSort>>;
};

export type BildungsplattformOrganizationAggregateInput = {
  AND?: InputMaybe<Array<BildungsplattformOrganizationAggregateInput>>;
  NOT?: InputMaybe<BildungsplattformOrganizationAggregateInput>;
  OR?: InputMaybe<Array<BildungsplattformOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<LicensePropertiesAggregationWhereInput>;
  node?: InputMaybe<BildungsplattformOrganizationNodeAggregationWhereInput>;
};

export type BildungsplattformOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  edge?: InputMaybe<LicensePropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type BildungsplattformOrganizationConnectOrCreateFieldInput = {
  onCreate: BildungsplattformOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type BildungsplattformOrganizationConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<LicensePropertiesCreateInput>;
  node: OrganizationOnCreateInput;
};

export type BildungsplattformOrganizationConnection = {
  __typename?: 'BildungsplattformOrganizationConnection';
  edges: Array<BildungsplattformOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BildungsplattformOrganizationConnectionSort = {
  edge?: InputMaybe<LicensePropertiesSort>;
  node?: InputMaybe<OrganizationSort>;
};

export type BildungsplattformOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<BildungsplattformOrganizationConnectionWhere>>;
  NOT?: InputMaybe<BildungsplattformOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<BildungsplattformOrganizationConnectionWhere>>;
  edge?: InputMaybe<LicensePropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<LicensePropertiesWhere>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type BildungsplattformOrganizationCreateFieldInput = {
  edge?: InputMaybe<LicensePropertiesCreateInput>;
  node: OrganizationCreateInput;
};

export type BildungsplattformOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<BildungsplattformOrganizationConnectionWhere>;
};

export type BildungsplattformOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<BildungsplattformOrganizationConnectionWhere>;
};

export type BildungsplattformOrganizationFieldInput = {
  connect?: InputMaybe<BildungsplattformOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<BildungsplattformOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<BildungsplattformOrganizationCreateFieldInput>;
};

export type BildungsplattformOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BildungsplattformOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BildungsplattformOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BildungsplattformOrganizationNodeAggregationWhereInput>>;
  aboutInfoLastUpdated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BildungsplattformOrganizationOrganizationAggregationSelection = {
  __typename?: 'BildungsplattformOrganizationOrganizationAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<BildungsplattformOrganizationOrganizationEdgeAggregateSelection>;
  node?: Maybe<BildungsplattformOrganizationOrganizationNodeAggregateSelection>;
};

export type BildungsplattformOrganizationOrganizationEdgeAggregateSelection = {
  __typename?: 'BildungsplattformOrganizationOrganizationEdgeAggregateSelection';
  contractRef: StringAggregateSelection;
  notAfter: DateTimeAggregateSelection;
  notBefore: DateTimeAggregateSelection;
  version: StringAggregateSelection;
};

export type BildungsplattformOrganizationOrganizationNodeAggregateSelection = {
  __typename?: 'BildungsplattformOrganizationOrganizationNodeAggregateSelection';
  aboutInfo: StringAggregateSelection;
  aboutInfoLastUpdated: DateTimeAggregateSelection;
  displayName: StringAggregateSelection;
  matrixRoomId: StringAggregateSelection;
  planungSyncProps: StringAggregateSelection;
  procuratSyncProps: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type BildungsplattformOrganizationRelationship = {
  __typename?: 'BildungsplattformOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
  properties: LicenseProperties;
};

export type BildungsplattformOrganizationUpdateConnectionInput = {
  edge?: InputMaybe<LicensePropertiesUpdateInput>;
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type BildungsplattformOrganizationUpdateFieldInput = {
  connect?: InputMaybe<BildungsplattformOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<BildungsplattformOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<BildungsplattformOrganizationCreateFieldInput>;
  delete?: InputMaybe<BildungsplattformOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<BildungsplattformOrganizationDisconnectFieldInput>;
  update?: InputMaybe<BildungsplattformOrganizationUpdateConnectionInput>;
  where?: InputMaybe<BildungsplattformOrganizationConnectionWhere>;
};

/** Fields to sort Bildungsplattforms by. The order in which sorts are applied is not guaranteed when specifying many fields in one BildungsplattformSort object. */
export type BildungsplattformSort = {
  allowParentExcuses?: InputMaybe<SortDirection>;
  allowStudentDirectMessages?: InputMaybe<SortDirection>;
  currentSchoolyear?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type BildungsplattformUpdateInput = {
  allowParentExcuses?: InputMaybe<Scalars['Boolean']['input']>;
  allowStudentDirectMessages?: InputMaybe<Scalars['Boolean']['input']>;
  currentSchoolyear?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<BildungsplattformOrganizationUpdateFieldInput>;
};

export type BildungsplattformWhere = {
  AND?: InputMaybe<Array<BildungsplattformWhere>>;
  NOT?: InputMaybe<BildungsplattformWhere>;
  OR?: InputMaybe<Array<BildungsplattformWhere>>;
  allowParentExcuses?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  allowParentExcuses_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  allowStudentDirectMessages?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  allowStudentDirectMessages_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  currentSchoolyear?: InputMaybe<Scalars['String']['input']>;
  currentSchoolyear_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  currentSchoolyear_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  currentSchoolyear_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  currentSchoolyear_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  currentSchoolyear_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  currentSchoolyear_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  currentSchoolyear_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  currentSchoolyear_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  currentSchoolyear_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<BildungsplattformOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<BildungsplattformOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<BildungsplattformOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type BildungsplattformsConnection = {
  __typename?: 'BildungsplattformsConnection';
  edges: Array<BildungsplattformEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BpGroupCreateInput = {
  admins: Array<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  editors: Array<Scalars['ID']['input']>;
  foreignRefId: Array<Scalars['String']['input']>;
  grades?: InputMaybe<Array<Scalars['String']['input']>>;
  groupType: GroupType;
  groups?: InputMaybe<Array<Scalars['ID']['input']>>;
  hasMembersFrom?: InputMaybe<Array<Scalars['String']['input']>>;
  isCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  organization: Scalars['ID']['input'];
  schoolYear: Scalars['ID']['input'];
  subject?: InputMaybe<Scalars['ID']['input']>;
  viewers: Array<Scalars['ID']['input']>;
};

export type BpGroupUpdateInput = {
  admins?: InputMaybe<Array<Scalars['ID']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  editors?: InputMaybe<Array<Scalars['ID']['input']>>;
  foreignRefId?: InputMaybe<Array<Scalars['String']['input']>>;
  grades?: InputMaybe<Array<Scalars['String']['input']>>;
  groups?: InputMaybe<Array<Scalars['ID']['input']>>;
  hasMembersFrom?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  schoolYear?: InputMaybe<Scalars['ID']['input']>;
  subject?: InputMaybe<Scalars['ID']['input']>;
  viewers?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type BpProfileCreateInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  address3?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['String']['input']>;
  createAndInviteUser?: InputMaybe<Scalars['Boolean']['input']>;
  createUser?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayNameShort?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  firstNames?: InputMaybe<Scalars['String']['input']>;
  foreignRefId: Array<Scalars['String']['input']>;
  frontendUri?: InputMaybe<Scalars['String']['input']>;
  importMeta?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName: Scalars['String']['input'];
  organization: Scalars['ID']['input'];
  organizationRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  prefixName?: InputMaybe<Scalars['String']['input']>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type BpProfileUpdateInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  address3?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayNameShort?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstNames?: InputMaybe<Scalars['String']['input']>;
  foreignRefId?: InputMaybe<Array<Scalars['String']['input']>>;
  frontendUri?: InputMaybe<Scalars['String']['input']>;
  importMeta?: InputMaybe<Array<Scalars['String']['input']>>;
  invite?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  prefixName?: InputMaybe<Scalars['String']['input']>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type BpSchoolyearCreateInput = {
  end: Scalars['String']['input'];
  foreignRefId: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organization: Scalars['ID']['input'];
  start: Scalars['String']['input'];
};

export type BpSchoolyearUpdateInput = {
  end?: InputMaybe<Scalars['String']['input']>;
  foreignRefId?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};

export type BpSubjectCreateInput = {
  foreignRefId: Array<Scalars['String']['input']>;
  globalSubject?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organization: Scalars['ID']['input'];
};

export type BpSubjectUpdateInput = {
  foreignRefId?: InputMaybe<Array<Scalars['String']['input']>>;
  globalSubject?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CalendarEvent = {
  __typename?: 'CalendarEvent';
  /** Who is allowed to start the virtual event? (only EDITORs and ADMINs ro VIEWERs too), */
  allCanStartVirtualEvent?: Maybe<Scalars['Boolean']['output']>;
  /** If a Person is attending this event, one needs to have this Relation */
  attendees: Array<Profile>;
  attendeesAggregate?: Maybe<CalendarEventProfileAttendeesAggregationSelection>;
  attendeesConnection: CalendarEventAttendeesConnection;
  categories?: Maybe<Array<Scalars['String']['output']>>;
  classShortNames?: Maybe<Array<Scalars['String']['output']>>;
  classbookHomework?: Maybe<Scalars['String']['output']>;
  classbookHomeworkContentType?: Maybe<Scalars['String']['output']>;
  /** Classbook specific */
  classbookNote?: Maybe<Scalars['String']['output']>;
  classbookNoteContentType?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  days: Array<Day>;
  daysAggregate?: Maybe<CalendarEventDayDaysAggregationSelection>;
  daysConnection: CalendarEventDaysConnection;
  description?: Maybe<Scalars['String']['output']>;
  descriptionContentType?: Maybe<Scalars['String']['output']>;
  duration: Scalars['String']['output'];
  foreignRefId?: Maybe<Array<Scalars['String']['output']>>;
  /** Is this a public/guest joinable Conference? */
  guestsAllowed?: Maybe<Scalars['Boolean']['output']>;
  /** Is this Events an organization-wide or only group-wide event (profiles in orga/group are only possible attendees!) */
  holder: CalendarEventHolder;
  holderConnection: CalendarEventHolderConnection;
  keywords?: Maybe<Array<Scalars['String']['output']>>;
  locale?: Maybe<Scalars['String']['output']>;
  locations: Array<Location>;
  locationsAggregate?: Maybe<CalendarEventLocationLocationsAggregationSelection>;
  locationsConnection: CalendarEventLocationsConnection;
  /** How many attendees are max. allowed in this event? */
  maxAttendees?: Maybe<Scalars['Int']['output']>;
  /** only for tenant-filtering purposes */
  organization: Organization;
  organizationAggregate?: Maybe<CalendarEventOrganizationOrganizationAggregationSelection>;
  organizationConnection: CalendarEventOrganizationConnection;
  /** Profile which created this event */
  owner: Profile;
  ownerAggregate?: Maybe<CalendarEventProfileOwnerAggregationSelection>;
  ownerConnection: CalendarEventOwnerConnection;
  privacy?: Maybe<Scalars['String']['output']>;
  prodId?: Maybe<Scalars['String']['output']>;
  /** Should the virtual event be recorded? */
  recordVirtualEvent?: Maybe<Scalars['Boolean']['output']>;
  recurrenceRule?: Maybe<RecurrenceRule>;
  recurrenceRuleAggregate?: Maybe<CalendarEventRecurrenceRuleRecurrenceRuleAggregationSelection>;
  recurrenceRuleConnection: CalendarEventRecurrenceRuleConnection;
  sequence?: Maybe<Scalars['Int']['output']>;
  showWithoutTime?: Maybe<Scalars['Boolean']['output']>;
  start: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  teachingUnit?: Maybe<TeachingUnit>;
  teachingUnitAggregate?: Maybe<CalendarEventTeachingUnitTeachingUnitAggregationSelection>;
  teachingUnitConnection: CalendarEventTeachingUnitConnection;
  timeZone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated: Scalars['DateTime']['output'];
  uuid: Scalars['ID']['output'];
  virtualLocations: Array<VirtualLocation>;
  virtualLocationsAggregate?: Maybe<CalendarEventVirtualLocationVirtualLocationsAggregationSelection>;
  virtualLocationsConnection: CalendarEventVirtualLocationsConnection;
};

export type CalendarEventAttendeesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ProfileOptions>;
  where?: InputMaybe<ProfileWhere>;
};

export type CalendarEventAttendeesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProfileWhere>;
};

export type CalendarEventAttendeesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CalendarEventAttendeesConnectionSort>>;
  where?: InputMaybe<CalendarEventAttendeesConnectionWhere>;
};

export type CalendarEventDaysArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DayOptions>;
  where?: InputMaybe<DayWhere>;
};

export type CalendarEventDaysAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DayWhere>;
};

export type CalendarEventDaysConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CalendarEventDaysConnectionSort>>;
  where?: InputMaybe<CalendarEventDaysConnectionWhere>;
};

export type CalendarEventHolderArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<CalendarEventHolderWhere>;
};

export type CalendarEventHolderConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CalendarEventHolderConnectionSort>>;
  where?: InputMaybe<CalendarEventHolderConnectionWhere>;
};

export type CalendarEventLocationsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LocationOptions>;
  where?: InputMaybe<LocationWhere>;
};

export type CalendarEventLocationsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LocationWhere>;
};

export type CalendarEventLocationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CalendarEventLocationsConnectionSort>>;
  where?: InputMaybe<CalendarEventLocationsConnectionWhere>;
};

export type CalendarEventOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type CalendarEventOrganizationAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OrganizationWhere>;
};

export type CalendarEventOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CalendarEventOrganizationConnectionSort>>;
  where?: InputMaybe<CalendarEventOrganizationConnectionWhere>;
};

export type CalendarEventOwnerArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ProfileOptions>;
  where?: InputMaybe<ProfileWhere>;
};

export type CalendarEventOwnerAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProfileWhere>;
};

export type CalendarEventOwnerConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CalendarEventOwnerConnectionSort>>;
  where?: InputMaybe<CalendarEventOwnerConnectionWhere>;
};

export type CalendarEventRecurrenceRuleArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RecurrenceRuleOptions>;
  where?: InputMaybe<RecurrenceRuleWhere>;
};

export type CalendarEventRecurrenceRuleAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<RecurrenceRuleWhere>;
};

export type CalendarEventRecurrenceRuleConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CalendarEventRecurrenceRuleConnectionSort>>;
  where?: InputMaybe<CalendarEventRecurrenceRuleConnectionWhere>;
};

export type CalendarEventTeachingUnitArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TeachingUnitOptions>;
  where?: InputMaybe<TeachingUnitWhere>;
};

export type CalendarEventTeachingUnitAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TeachingUnitWhere>;
};

export type CalendarEventTeachingUnitConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CalendarEventTeachingUnitConnectionSort>>;
  where?: InputMaybe<CalendarEventTeachingUnitConnectionWhere>;
};

export type CalendarEventVirtualLocationsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<VirtualLocationOptions>;
  where?: InputMaybe<VirtualLocationWhere>;
};

export type CalendarEventVirtualLocationsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<VirtualLocationWhere>;
};

export type CalendarEventVirtualLocationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CalendarEventVirtualLocationsConnectionSort>>;
  where?: InputMaybe<CalendarEventVirtualLocationsConnectionWhere>;
};

export type CalendarEventAggregateSelection = {
  __typename?: 'CalendarEventAggregateSelection';
  classbookHomework: StringAggregateSelection;
  classbookHomeworkContentType: StringAggregateSelection;
  classbookNote: StringAggregateSelection;
  classbookNoteContentType: StringAggregateSelection;
  color: StringAggregateSelection;
  count: Scalars['Int']['output'];
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  descriptionContentType: StringAggregateSelection;
  duration: StringAggregateSelection;
  locale: StringAggregateSelection;
  maxAttendees: IntAggregateSelection;
  privacy: StringAggregateSelection;
  prodId: StringAggregateSelection;
  sequence: IntAggregateSelection;
  start: StringAggregateSelection;
  status: StringAggregateSelection;
  timeZone: StringAggregateSelection;
  title: StringAggregateSelection;
  updated: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type CalendarEventAttendeesAggregateInput = {
  AND?: InputMaybe<Array<CalendarEventAttendeesAggregateInput>>;
  NOT?: InputMaybe<CalendarEventAttendeesAggregateInput>;
  OR?: InputMaybe<Array<CalendarEventAttendeesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<EventAttendeesPropertiesAggregationWhereInput>;
  node?: InputMaybe<CalendarEventAttendeesNodeAggregationWhereInput>;
};

export type CalendarEventAttendeesConnectFieldInput = {
  connect?: InputMaybe<Array<ProfileConnectInput>>;
  edge?: InputMaybe<EventAttendeesPropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ProfileConnectWhere>;
};

export type CalendarEventAttendeesConnectOrCreateFieldInput = {
  onCreate: CalendarEventAttendeesConnectOrCreateFieldInputOnCreate;
  where: ProfileConnectOrCreateWhere;
};

export type CalendarEventAttendeesConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<EventAttendeesPropertiesCreateInput>;
  node: ProfileOnCreateInput;
};

export type CalendarEventAttendeesConnection = {
  __typename?: 'CalendarEventAttendeesConnection';
  edges: Array<CalendarEventAttendeesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CalendarEventAttendeesConnectionSort = {
  edge?: InputMaybe<EventAttendeesPropertiesSort>;
  node?: InputMaybe<ProfileSort>;
};

export type CalendarEventAttendeesConnectionWhere = {
  AND?: InputMaybe<Array<CalendarEventAttendeesConnectionWhere>>;
  NOT?: InputMaybe<CalendarEventAttendeesConnectionWhere>;
  OR?: InputMaybe<Array<CalendarEventAttendeesConnectionWhere>>;
  edge?: InputMaybe<EventAttendeesPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<EventAttendeesPropertiesWhere>;
  node?: InputMaybe<ProfileWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ProfileWhere>;
};

export type CalendarEventAttendeesCreateFieldInput = {
  edge?: InputMaybe<EventAttendeesPropertiesCreateInput>;
  node: ProfileCreateInput;
};

export type CalendarEventAttendeesDeleteFieldInput = {
  delete?: InputMaybe<ProfileDeleteInput>;
  where?: InputMaybe<CalendarEventAttendeesConnectionWhere>;
};

export type CalendarEventAttendeesDisconnectFieldInput = {
  disconnect?: InputMaybe<ProfileDisconnectInput>;
  where?: InputMaybe<CalendarEventAttendeesConnectionWhere>;
};

export type CalendarEventAttendeesFieldInput = {
  connect?: InputMaybe<Array<CalendarEventAttendeesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CalendarEventAttendeesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CalendarEventAttendeesCreateFieldInput>>;
};

export type CalendarEventAttendeesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CalendarEventAttendeesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CalendarEventAttendeesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CalendarEventAttendeesNodeAggregationWhereInput>>;
  address1_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address1_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address2_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address2_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address3_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address3_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  birthday_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  userUuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  userUuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CalendarEventAttendeesRelationship = {
  __typename?: 'CalendarEventAttendeesRelationship';
  cursor: Scalars['String']['output'];
  node: Profile;
  properties: EventAttendeesProperties;
};

export type CalendarEventAttendeesUpdateConnectionInput = {
  edge?: InputMaybe<EventAttendeesPropertiesUpdateInput>;
  node?: InputMaybe<ProfileUpdateInput>;
};

export type CalendarEventAttendeesUpdateFieldInput = {
  connect?: InputMaybe<Array<CalendarEventAttendeesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CalendarEventAttendeesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CalendarEventAttendeesCreateFieldInput>>;
  delete?: InputMaybe<Array<CalendarEventAttendeesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CalendarEventAttendeesDisconnectFieldInput>>;
  update?: InputMaybe<CalendarEventAttendeesUpdateConnectionInput>;
  where?: InputMaybe<CalendarEventAttendeesConnectionWhere>;
};

export type CalendarEventCreateInput = {
  allCanStartVirtualEvent?: InputMaybe<Scalars['Boolean']['input']>;
  attendees?: InputMaybe<CalendarEventAttendeesFieldInput>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  classbookHomework?: InputMaybe<Scalars['String']['input']>;
  classbookHomeworkContentType?: InputMaybe<Scalars['String']['input']>;
  classbookNote?: InputMaybe<Scalars['String']['input']>;
  classbookNoteContentType?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  days?: InputMaybe<CalendarEventDaysFieldInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContentType?: InputMaybe<Scalars['String']['input']>;
  duration: Scalars['String']['input'];
  foreignRefId?: InputMaybe<Array<Scalars['String']['input']>>;
  guestsAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  holder?: InputMaybe<CalendarEventHolderCreateInput>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<CalendarEventLocationsFieldInput>;
  maxAttendees?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<CalendarEventOrganizationFieldInput>;
  owner?: InputMaybe<CalendarEventOwnerFieldInput>;
  privacy?: InputMaybe<Scalars['String']['input']>;
  prodId?: InputMaybe<Scalars['String']['input']>;
  recordVirtualEvent?: InputMaybe<Scalars['Boolean']['input']>;
  recurrenceRule?: InputMaybe<CalendarEventRecurrenceRuleFieldInput>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
  showWithoutTime?: InputMaybe<Scalars['Boolean']['input']>;
  start: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  teachingUnit?: InputMaybe<CalendarEventTeachingUnitFieldInput>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  virtualLocations?: InputMaybe<CalendarEventVirtualLocationsFieldInput>;
};

export type CalendarEventDayDaysAggregationSelection = {
  __typename?: 'CalendarEventDayDaysAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CalendarEventDayDaysNodeAggregateSelection>;
};

export type CalendarEventDayDaysNodeAggregateSelection = {
  __typename?: 'CalendarEventDayDaysNodeAggregateSelection';
  date: StringAggregateSelection;
  day: IntAggregateSelection;
  dayOfWeek: IntAggregateSelection;
  month: IntAggregateSelection;
  uuid: IdAggregateSelection;
  week: IntAggregateSelection;
  year: IntAggregateSelection;
};

export type CalendarEventDaysAggregateInput = {
  AND?: InputMaybe<Array<CalendarEventDaysAggregateInput>>;
  NOT?: InputMaybe<CalendarEventDaysAggregateInput>;
  OR?: InputMaybe<Array<CalendarEventDaysAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CalendarEventDaysNodeAggregationWhereInput>;
};

export type CalendarEventDaysConnectFieldInput = {
  connect?: InputMaybe<Array<DayConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<DayConnectWhere>;
};

export type CalendarEventDaysConnectOrCreateFieldInput = {
  onCreate: CalendarEventDaysConnectOrCreateFieldInputOnCreate;
  where: DayConnectOrCreateWhere;
};

export type CalendarEventDaysConnectOrCreateFieldInputOnCreate = {
  node: DayOnCreateInput;
};

export type CalendarEventDaysConnection = {
  __typename?: 'CalendarEventDaysConnection';
  edges: Array<CalendarEventDaysRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CalendarEventDaysConnectionSort = {
  node?: InputMaybe<DaySort>;
};

export type CalendarEventDaysConnectionWhere = {
  AND?: InputMaybe<Array<CalendarEventDaysConnectionWhere>>;
  NOT?: InputMaybe<CalendarEventDaysConnectionWhere>;
  OR?: InputMaybe<Array<CalendarEventDaysConnectionWhere>>;
  node?: InputMaybe<DayWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<DayWhere>;
};

export type CalendarEventDaysCreateFieldInput = {
  node: DayCreateInput;
};

export type CalendarEventDaysDeleteFieldInput = {
  delete?: InputMaybe<DayDeleteInput>;
  where?: InputMaybe<CalendarEventDaysConnectionWhere>;
};

export type CalendarEventDaysDisconnectFieldInput = {
  disconnect?: InputMaybe<DayDisconnectInput>;
  where?: InputMaybe<CalendarEventDaysConnectionWhere>;
};

export type CalendarEventDaysFieldInput = {
  connect?: InputMaybe<Array<CalendarEventDaysConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CalendarEventDaysConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CalendarEventDaysCreateFieldInput>>;
};

export type CalendarEventDaysNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CalendarEventDaysNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CalendarEventDaysNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CalendarEventDaysNodeAggregationWhereInput>>;
  date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  day_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  day_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  day_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  day_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  day_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  day_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  day_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  day_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  day_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  day_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  month_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  month_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  month_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  month_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  month_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  month_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  month_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  month_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  month_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  month_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  week_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  week_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  week_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  week_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  week_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  week_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  week_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  week_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  week_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  week_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  year_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  year_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CalendarEventDaysRelationship = {
  __typename?: 'CalendarEventDaysRelationship';
  cursor: Scalars['String']['output'];
  node: Day;
};

export type CalendarEventDaysUpdateConnectionInput = {
  node?: InputMaybe<DayUpdateInput>;
};

export type CalendarEventDaysUpdateFieldInput = {
  connect?: InputMaybe<Array<CalendarEventDaysConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CalendarEventDaysConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CalendarEventDaysCreateFieldInput>>;
  delete?: InputMaybe<Array<CalendarEventDaysDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CalendarEventDaysDisconnectFieldInput>>;
  update?: InputMaybe<CalendarEventDaysUpdateConnectionInput>;
  where?: InputMaybe<CalendarEventDaysConnectionWhere>;
};

export type CalendarEventDeleteInput = {
  attendees?: InputMaybe<Array<CalendarEventAttendeesDeleteFieldInput>>;
  days?: InputMaybe<Array<CalendarEventDaysDeleteFieldInput>>;
  holder?: InputMaybe<CalendarEventHolderDeleteInput>;
  locations?: InputMaybe<Array<CalendarEventLocationsDeleteFieldInput>>;
  organization?: InputMaybe<CalendarEventOrganizationDeleteFieldInput>;
  owner?: InputMaybe<CalendarEventOwnerDeleteFieldInput>;
  recurrenceRule?: InputMaybe<CalendarEventRecurrenceRuleDeleteFieldInput>;
  teachingUnit?: InputMaybe<CalendarEventTeachingUnitDeleteFieldInput>;
  virtualLocations?: InputMaybe<Array<CalendarEventVirtualLocationsDeleteFieldInput>>;
};

export type CalendarEventEdge = {
  __typename?: 'CalendarEventEdge';
  cursor: Scalars['String']['output'];
  node: CalendarEvent;
};

export type CalendarEventHolder = Group | Organization | Profile;

export type CalendarEventHolderConnection = {
  __typename?: 'CalendarEventHolderConnection';
  edges: Array<CalendarEventHolderRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CalendarEventHolderConnectionSort = {
  edge?: InputMaybe<EventHolderPropertiesSort>;
};

export type CalendarEventHolderConnectionWhere = {
  Group?: InputMaybe<CalendarEventHolderGroupConnectionWhere>;
  Organization?: InputMaybe<CalendarEventHolderOrganizationConnectionWhere>;
  Profile?: InputMaybe<CalendarEventHolderProfileConnectionWhere>;
};

export type CalendarEventHolderCreateInput = {
  Group?: InputMaybe<CalendarEventHolderGroupFieldInput>;
  Organization?: InputMaybe<CalendarEventHolderOrganizationFieldInput>;
  Profile?: InputMaybe<CalendarEventHolderProfileFieldInput>;
};

export type CalendarEventHolderDeleteInput = {
  Group?: InputMaybe<CalendarEventHolderGroupDeleteFieldInput>;
  Organization?: InputMaybe<CalendarEventHolderOrganizationDeleteFieldInput>;
  Profile?: InputMaybe<CalendarEventHolderProfileDeleteFieldInput>;
};

export type CalendarEventHolderGroupConnectFieldInput = {
  connect?: InputMaybe<GroupConnectInput>;
  edge?: InputMaybe<EventHolderPropertiesCreateInput>;
  where?: InputMaybe<GroupConnectWhere>;
};

export type CalendarEventHolderGroupConnectOrCreateFieldInput = {
  onCreate: CalendarEventHolderGroupConnectOrCreateFieldInputOnCreate;
  where: GroupConnectOrCreateWhere;
};

export type CalendarEventHolderGroupConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<EventHolderPropertiesCreateInput>;
  node: GroupOnCreateInput;
};

export type CalendarEventHolderGroupConnectionWhere = {
  AND?: InputMaybe<Array<CalendarEventHolderGroupConnectionWhere>>;
  NOT?: InputMaybe<CalendarEventHolderGroupConnectionWhere>;
  OR?: InputMaybe<Array<CalendarEventHolderGroupConnectionWhere>>;
  edge?: InputMaybe<EventHolderPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<EventHolderPropertiesWhere>;
  node?: InputMaybe<GroupWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<GroupWhere>;
};

export type CalendarEventHolderGroupCreateFieldInput = {
  edge?: InputMaybe<EventHolderPropertiesCreateInput>;
  node: GroupCreateInput;
};

export type CalendarEventHolderGroupDeleteFieldInput = {
  delete?: InputMaybe<GroupDeleteInput>;
  where?: InputMaybe<CalendarEventHolderGroupConnectionWhere>;
};

export type CalendarEventHolderGroupDisconnectFieldInput = {
  disconnect?: InputMaybe<GroupDisconnectInput>;
  where?: InputMaybe<CalendarEventHolderGroupConnectionWhere>;
};

export type CalendarEventHolderGroupFieldInput = {
  connect?: InputMaybe<CalendarEventHolderGroupConnectFieldInput>;
  connectOrCreate?: InputMaybe<CalendarEventHolderGroupConnectOrCreateFieldInput>;
  create?: InputMaybe<CalendarEventHolderGroupCreateFieldInput>;
};

export type CalendarEventHolderGroupUpdateConnectionInput = {
  edge?: InputMaybe<EventHolderPropertiesUpdateInput>;
  node?: InputMaybe<GroupUpdateInput>;
};

export type CalendarEventHolderGroupUpdateFieldInput = {
  connect?: InputMaybe<CalendarEventHolderGroupConnectFieldInput>;
  connectOrCreate?: InputMaybe<CalendarEventHolderGroupConnectOrCreateFieldInput>;
  create?: InputMaybe<CalendarEventHolderGroupCreateFieldInput>;
  delete?: InputMaybe<CalendarEventHolderGroupDeleteFieldInput>;
  disconnect?: InputMaybe<CalendarEventHolderGroupDisconnectFieldInput>;
  update?: InputMaybe<CalendarEventHolderGroupUpdateConnectionInput>;
  where?: InputMaybe<CalendarEventHolderGroupConnectionWhere>;
};

export type CalendarEventHolderOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  edge?: InputMaybe<EventHolderPropertiesCreateInput>;
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type CalendarEventHolderOrganizationConnectOrCreateFieldInput = {
  onCreate: CalendarEventHolderOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type CalendarEventHolderOrganizationConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<EventHolderPropertiesCreateInput>;
  node: OrganizationOnCreateInput;
};

export type CalendarEventHolderOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<CalendarEventHolderOrganizationConnectionWhere>>;
  NOT?: InputMaybe<CalendarEventHolderOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<CalendarEventHolderOrganizationConnectionWhere>>;
  edge?: InputMaybe<EventHolderPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<EventHolderPropertiesWhere>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type CalendarEventHolderOrganizationCreateFieldInput = {
  edge?: InputMaybe<EventHolderPropertiesCreateInput>;
  node: OrganizationCreateInput;
};

export type CalendarEventHolderOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<CalendarEventHolderOrganizationConnectionWhere>;
};

export type CalendarEventHolderOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<CalendarEventHolderOrganizationConnectionWhere>;
};

export type CalendarEventHolderOrganizationFieldInput = {
  connect?: InputMaybe<CalendarEventHolderOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<CalendarEventHolderOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<CalendarEventHolderOrganizationCreateFieldInput>;
};

export type CalendarEventHolderOrganizationUpdateConnectionInput = {
  edge?: InputMaybe<EventHolderPropertiesUpdateInput>;
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type CalendarEventHolderOrganizationUpdateFieldInput = {
  connect?: InputMaybe<CalendarEventHolderOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<CalendarEventHolderOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<CalendarEventHolderOrganizationCreateFieldInput>;
  delete?: InputMaybe<CalendarEventHolderOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<CalendarEventHolderOrganizationDisconnectFieldInput>;
  update?: InputMaybe<CalendarEventHolderOrganizationUpdateConnectionInput>;
  where?: InputMaybe<CalendarEventHolderOrganizationConnectionWhere>;
};

export type CalendarEventHolderProfileConnectFieldInput = {
  connect?: InputMaybe<ProfileConnectInput>;
  edge?: InputMaybe<EventHolderPropertiesCreateInput>;
  where?: InputMaybe<ProfileConnectWhere>;
};

export type CalendarEventHolderProfileConnectOrCreateFieldInput = {
  onCreate: CalendarEventHolderProfileConnectOrCreateFieldInputOnCreate;
  where: ProfileConnectOrCreateWhere;
};

export type CalendarEventHolderProfileConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<EventHolderPropertiesCreateInput>;
  node: ProfileOnCreateInput;
};

export type CalendarEventHolderProfileConnectionWhere = {
  AND?: InputMaybe<Array<CalendarEventHolderProfileConnectionWhere>>;
  NOT?: InputMaybe<CalendarEventHolderProfileConnectionWhere>;
  OR?: InputMaybe<Array<CalendarEventHolderProfileConnectionWhere>>;
  edge?: InputMaybe<EventHolderPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<EventHolderPropertiesWhere>;
  node?: InputMaybe<ProfileWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ProfileWhere>;
};

export type CalendarEventHolderProfileCreateFieldInput = {
  edge?: InputMaybe<EventHolderPropertiesCreateInput>;
  node: ProfileCreateInput;
};

export type CalendarEventHolderProfileDeleteFieldInput = {
  delete?: InputMaybe<ProfileDeleteInput>;
  where?: InputMaybe<CalendarEventHolderProfileConnectionWhere>;
};

export type CalendarEventHolderProfileDisconnectFieldInput = {
  disconnect?: InputMaybe<ProfileDisconnectInput>;
  where?: InputMaybe<CalendarEventHolderProfileConnectionWhere>;
};

export type CalendarEventHolderProfileFieldInput = {
  connect?: InputMaybe<CalendarEventHolderProfileConnectFieldInput>;
  connectOrCreate?: InputMaybe<CalendarEventHolderProfileConnectOrCreateFieldInput>;
  create?: InputMaybe<CalendarEventHolderProfileCreateFieldInput>;
};

export type CalendarEventHolderProfileUpdateConnectionInput = {
  edge?: InputMaybe<EventHolderPropertiesUpdateInput>;
  node?: InputMaybe<ProfileUpdateInput>;
};

export type CalendarEventHolderProfileUpdateFieldInput = {
  connect?: InputMaybe<CalendarEventHolderProfileConnectFieldInput>;
  connectOrCreate?: InputMaybe<CalendarEventHolderProfileConnectOrCreateFieldInput>;
  create?: InputMaybe<CalendarEventHolderProfileCreateFieldInput>;
  delete?: InputMaybe<CalendarEventHolderProfileDeleteFieldInput>;
  disconnect?: InputMaybe<CalendarEventHolderProfileDisconnectFieldInput>;
  update?: InputMaybe<CalendarEventHolderProfileUpdateConnectionInput>;
  where?: InputMaybe<CalendarEventHolderProfileConnectionWhere>;
};

export type CalendarEventHolderRelationship = {
  __typename?: 'CalendarEventHolderRelationship';
  cursor: Scalars['String']['output'];
  node: CalendarEventHolder;
  properties: EventHolderProperties;
};

export type CalendarEventHolderUpdateInput = {
  Group?: InputMaybe<CalendarEventHolderGroupUpdateFieldInput>;
  Organization?: InputMaybe<CalendarEventHolderOrganizationUpdateFieldInput>;
  Profile?: InputMaybe<CalendarEventHolderProfileUpdateFieldInput>;
};

export type CalendarEventHolderWhere = {
  Group?: InputMaybe<GroupWhere>;
  Organization?: InputMaybe<OrganizationWhere>;
  Profile?: InputMaybe<ProfileWhere>;
};

export type CalendarEventLocationLocationsAggregationSelection = {
  __typename?: 'CalendarEventLocationLocationsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CalendarEventLocationLocationsNodeAggregateSelection>;
};

export type CalendarEventLocationLocationsNodeAggregateSelection = {
  __typename?: 'CalendarEventLocationLocationsNodeAggregateSelection';
  coordinates: StringAggregateSelection;
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  relativeTo: StringAggregateSelection;
  timeZone: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type CalendarEventLocationsAggregateInput = {
  AND?: InputMaybe<Array<CalendarEventLocationsAggregateInput>>;
  NOT?: InputMaybe<CalendarEventLocationsAggregateInput>;
  OR?: InputMaybe<Array<CalendarEventLocationsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CalendarEventLocationsNodeAggregationWhereInput>;
};

export type CalendarEventLocationsConnectFieldInput = {
  connect?: InputMaybe<Array<LocationConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<LocationConnectWhere>;
};

export type CalendarEventLocationsConnection = {
  __typename?: 'CalendarEventLocationsConnection';
  edges: Array<CalendarEventLocationsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CalendarEventLocationsConnectionSort = {
  node?: InputMaybe<LocationSort>;
};

export type CalendarEventLocationsConnectionWhere = {
  AND?: InputMaybe<Array<CalendarEventLocationsConnectionWhere>>;
  NOT?: InputMaybe<CalendarEventLocationsConnectionWhere>;
  OR?: InputMaybe<Array<CalendarEventLocationsConnectionWhere>>;
  node?: InputMaybe<LocationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<LocationWhere>;
};

export type CalendarEventLocationsCreateFieldInput = {
  node: LocationCreateInput;
};

export type CalendarEventLocationsDeleteFieldInput = {
  delete?: InputMaybe<LocationDeleteInput>;
  where?: InputMaybe<CalendarEventLocationsConnectionWhere>;
};

export type CalendarEventLocationsDisconnectFieldInput = {
  disconnect?: InputMaybe<LocationDisconnectInput>;
  where?: InputMaybe<CalendarEventLocationsConnectionWhere>;
};

export type CalendarEventLocationsFieldInput = {
  connect?: InputMaybe<Array<CalendarEventLocationsConnectFieldInput>>;
  create?: InputMaybe<Array<CalendarEventLocationsCreateFieldInput>>;
};

export type CalendarEventLocationsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CalendarEventLocationsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CalendarEventLocationsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CalendarEventLocationsNodeAggregationWhereInput>>;
  coordinates_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coordinates_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  coordinates_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  coordinates_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  coordinates_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  coordinates_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coordinates_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  coordinates_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  coordinates_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  coordinates_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  coordinates_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coordinates_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  coordinates_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  coordinates_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  coordinates_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  relativeTo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  relativeTo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  relativeTo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  relativeTo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  relativeTo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  relativeTo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  relativeTo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  relativeTo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  relativeTo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  relativeTo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  relativeTo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  relativeTo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  relativeTo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  relativeTo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  relativeTo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeZone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeZone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timeZone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeZone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timeZone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeZone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeZone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timeZone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeZone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timeZone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeZone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeZone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timeZone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeZone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timeZone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CalendarEventLocationsRelationship = {
  __typename?: 'CalendarEventLocationsRelationship';
  cursor: Scalars['String']['output'];
  node: Location;
};

export type CalendarEventLocationsUpdateConnectionInput = {
  node?: InputMaybe<LocationUpdateInput>;
};

export type CalendarEventLocationsUpdateFieldInput = {
  connect?: InputMaybe<Array<CalendarEventLocationsConnectFieldInput>>;
  create?: InputMaybe<Array<CalendarEventLocationsCreateFieldInput>>;
  delete?: InputMaybe<Array<CalendarEventLocationsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CalendarEventLocationsDisconnectFieldInput>>;
  update?: InputMaybe<CalendarEventLocationsUpdateConnectionInput>;
  where?: InputMaybe<CalendarEventLocationsConnectionWhere>;
};

export type CalendarEventOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CalendarEventSort objects to sort CalendarEvents by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CalendarEventSort>>;
};

export type CalendarEventOrganizationAggregateInput = {
  AND?: InputMaybe<Array<CalendarEventOrganizationAggregateInput>>;
  NOT?: InputMaybe<CalendarEventOrganizationAggregateInput>;
  OR?: InputMaybe<Array<CalendarEventOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CalendarEventOrganizationNodeAggregationWhereInput>;
};

export type CalendarEventOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type CalendarEventOrganizationConnectOrCreateFieldInput = {
  onCreate: CalendarEventOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type CalendarEventOrganizationConnectOrCreateFieldInputOnCreate = {
  node: OrganizationOnCreateInput;
};

export type CalendarEventOrganizationConnection = {
  __typename?: 'CalendarEventOrganizationConnection';
  edges: Array<CalendarEventOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CalendarEventOrganizationConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type CalendarEventOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<CalendarEventOrganizationConnectionWhere>>;
  NOT?: InputMaybe<CalendarEventOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<CalendarEventOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type CalendarEventOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type CalendarEventOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<CalendarEventOrganizationConnectionWhere>;
};

export type CalendarEventOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<CalendarEventOrganizationConnectionWhere>;
};

export type CalendarEventOrganizationFieldInput = {
  connect?: InputMaybe<CalendarEventOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<CalendarEventOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<CalendarEventOrganizationCreateFieldInput>;
};

export type CalendarEventOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CalendarEventOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CalendarEventOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CalendarEventOrganizationNodeAggregationWhereInput>>;
  aboutInfoLastUpdated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CalendarEventOrganizationOrganizationAggregationSelection = {
  __typename?: 'CalendarEventOrganizationOrganizationAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CalendarEventOrganizationOrganizationNodeAggregateSelection>;
};

export type CalendarEventOrganizationOrganizationNodeAggregateSelection = {
  __typename?: 'CalendarEventOrganizationOrganizationNodeAggregateSelection';
  aboutInfo: StringAggregateSelection;
  aboutInfoLastUpdated: DateTimeAggregateSelection;
  displayName: StringAggregateSelection;
  matrixRoomId: StringAggregateSelection;
  planungSyncProps: StringAggregateSelection;
  procuratSyncProps: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type CalendarEventOrganizationRelationship = {
  __typename?: 'CalendarEventOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type CalendarEventOrganizationUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type CalendarEventOrganizationUpdateFieldInput = {
  connect?: InputMaybe<CalendarEventOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<CalendarEventOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<CalendarEventOrganizationCreateFieldInput>;
  delete?: InputMaybe<CalendarEventOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<CalendarEventOrganizationDisconnectFieldInput>;
  update?: InputMaybe<CalendarEventOrganizationUpdateConnectionInput>;
  where?: InputMaybe<CalendarEventOrganizationConnectionWhere>;
};

export type CalendarEventOwnerAggregateInput = {
  AND?: InputMaybe<Array<CalendarEventOwnerAggregateInput>>;
  NOT?: InputMaybe<CalendarEventOwnerAggregateInput>;
  OR?: InputMaybe<Array<CalendarEventOwnerAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CalendarEventOwnerNodeAggregationWhereInput>;
};

export type CalendarEventOwnerConnectFieldInput = {
  connect?: InputMaybe<ProfileConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ProfileConnectWhere>;
};

export type CalendarEventOwnerConnectOrCreateFieldInput = {
  onCreate: CalendarEventOwnerConnectOrCreateFieldInputOnCreate;
  where: ProfileConnectOrCreateWhere;
};

export type CalendarEventOwnerConnectOrCreateFieldInputOnCreate = {
  node: ProfileOnCreateInput;
};

export type CalendarEventOwnerConnection = {
  __typename?: 'CalendarEventOwnerConnection';
  edges: Array<CalendarEventOwnerRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CalendarEventOwnerConnectionSort = {
  node?: InputMaybe<ProfileSort>;
};

export type CalendarEventOwnerConnectionWhere = {
  AND?: InputMaybe<Array<CalendarEventOwnerConnectionWhere>>;
  NOT?: InputMaybe<CalendarEventOwnerConnectionWhere>;
  OR?: InputMaybe<Array<CalendarEventOwnerConnectionWhere>>;
  node?: InputMaybe<ProfileWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ProfileWhere>;
};

export type CalendarEventOwnerCreateFieldInput = {
  node: ProfileCreateInput;
};

export type CalendarEventOwnerDeleteFieldInput = {
  delete?: InputMaybe<ProfileDeleteInput>;
  where?: InputMaybe<CalendarEventOwnerConnectionWhere>;
};

export type CalendarEventOwnerDisconnectFieldInput = {
  disconnect?: InputMaybe<ProfileDisconnectInput>;
  where?: InputMaybe<CalendarEventOwnerConnectionWhere>;
};

export type CalendarEventOwnerFieldInput = {
  connect?: InputMaybe<CalendarEventOwnerConnectFieldInput>;
  connectOrCreate?: InputMaybe<CalendarEventOwnerConnectOrCreateFieldInput>;
  create?: InputMaybe<CalendarEventOwnerCreateFieldInput>;
};

export type CalendarEventOwnerNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CalendarEventOwnerNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CalendarEventOwnerNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CalendarEventOwnerNodeAggregationWhereInput>>;
  address1_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address1_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address2_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address2_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address3_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address3_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  birthday_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  userUuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  userUuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CalendarEventOwnerRelationship = {
  __typename?: 'CalendarEventOwnerRelationship';
  cursor: Scalars['String']['output'];
  node: Profile;
};

export type CalendarEventOwnerUpdateConnectionInput = {
  node?: InputMaybe<ProfileUpdateInput>;
};

export type CalendarEventOwnerUpdateFieldInput = {
  connect?: InputMaybe<CalendarEventOwnerConnectFieldInput>;
  connectOrCreate?: InputMaybe<CalendarEventOwnerConnectOrCreateFieldInput>;
  create?: InputMaybe<CalendarEventOwnerCreateFieldInput>;
  delete?: InputMaybe<CalendarEventOwnerDeleteFieldInput>;
  disconnect?: InputMaybe<CalendarEventOwnerDisconnectFieldInput>;
  update?: InputMaybe<CalendarEventOwnerUpdateConnectionInput>;
  where?: InputMaybe<CalendarEventOwnerConnectionWhere>;
};

export type CalendarEventProfileAttendeesAggregationSelection = {
  __typename?: 'CalendarEventProfileAttendeesAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<CalendarEventProfileAttendeesEdgeAggregateSelection>;
  node?: Maybe<CalendarEventProfileAttendeesNodeAggregateSelection>;
};

export type CalendarEventProfileAttendeesEdgeAggregateSelection = {
  __typename?: 'CalendarEventProfileAttendeesEdgeAggregateSelection';
  classbookComment: StringAggregateSelection;
};

export type CalendarEventProfileAttendeesNodeAggregateSelection = {
  __typename?: 'CalendarEventProfileAttendeesNodeAggregateSelection';
  address1: StringAggregateSelection;
  address2: StringAggregateSelection;
  address3: StringAggregateSelection;
  birthday: StringAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  email: StringAggregateSelection;
  firstName: StringAggregateSelection;
  firstNames: StringAggregateSelection;
  lastName: StringAggregateSelection;
  managedBy: StringAggregateSelection;
  matrixToken: StringAggregateSelection;
  nextcloudUserId: StringAggregateSelection;
  prefixName: StringAggregateSelection;
  salutation: StringAggregateSelection;
  shortName: StringAggregateSelection;
  threemaId: StringAggregateSelection;
  title: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  userUuid: StringAggregateSelection;
  uuid: IdAggregateSelection;
  zoomUserId: StringAggregateSelection;
};

export type CalendarEventProfileOwnerAggregationSelection = {
  __typename?: 'CalendarEventProfileOwnerAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CalendarEventProfileOwnerNodeAggregateSelection>;
};

export type CalendarEventProfileOwnerNodeAggregateSelection = {
  __typename?: 'CalendarEventProfileOwnerNodeAggregateSelection';
  address1: StringAggregateSelection;
  address2: StringAggregateSelection;
  address3: StringAggregateSelection;
  birthday: StringAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  email: StringAggregateSelection;
  firstName: StringAggregateSelection;
  firstNames: StringAggregateSelection;
  lastName: StringAggregateSelection;
  managedBy: StringAggregateSelection;
  matrixToken: StringAggregateSelection;
  nextcloudUserId: StringAggregateSelection;
  prefixName: StringAggregateSelection;
  salutation: StringAggregateSelection;
  shortName: StringAggregateSelection;
  threemaId: StringAggregateSelection;
  title: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  userUuid: StringAggregateSelection;
  uuid: IdAggregateSelection;
  zoomUserId: StringAggregateSelection;
};

export type CalendarEventRecurrenceRuleAggregateInput = {
  AND?: InputMaybe<Array<CalendarEventRecurrenceRuleAggregateInput>>;
  NOT?: InputMaybe<CalendarEventRecurrenceRuleAggregateInput>;
  OR?: InputMaybe<Array<CalendarEventRecurrenceRuleAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CalendarEventRecurrenceRuleNodeAggregationWhereInput>;
};

export type CalendarEventRecurrenceRuleConnectFieldInput = {
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<RecurrenceRuleConnectWhere>;
};

export type CalendarEventRecurrenceRuleConnection = {
  __typename?: 'CalendarEventRecurrenceRuleConnection';
  edges: Array<CalendarEventRecurrenceRuleRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CalendarEventRecurrenceRuleConnectionSort = {
  node?: InputMaybe<RecurrenceRuleSort>;
};

export type CalendarEventRecurrenceRuleConnectionWhere = {
  AND?: InputMaybe<Array<CalendarEventRecurrenceRuleConnectionWhere>>;
  NOT?: InputMaybe<CalendarEventRecurrenceRuleConnectionWhere>;
  OR?: InputMaybe<Array<CalendarEventRecurrenceRuleConnectionWhere>>;
  node?: InputMaybe<RecurrenceRuleWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<RecurrenceRuleWhere>;
};

export type CalendarEventRecurrenceRuleCreateFieldInput = {
  node: RecurrenceRuleCreateInput;
};

export type CalendarEventRecurrenceRuleDeleteFieldInput = {
  where?: InputMaybe<CalendarEventRecurrenceRuleConnectionWhere>;
};

export type CalendarEventRecurrenceRuleDisconnectFieldInput = {
  where?: InputMaybe<CalendarEventRecurrenceRuleConnectionWhere>;
};

export type CalendarEventRecurrenceRuleFieldInput = {
  connect?: InputMaybe<CalendarEventRecurrenceRuleConnectFieldInput>;
  create?: InputMaybe<CalendarEventRecurrenceRuleCreateFieldInput>;
};

export type CalendarEventRecurrenceRuleNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CalendarEventRecurrenceRuleNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CalendarEventRecurrenceRuleNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CalendarEventRecurrenceRuleNodeAggregationWhereInput>>;
  until_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  until_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  until_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  until_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  until_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  until_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  until_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  until_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  until_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  until_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  until_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  until_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  until_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  until_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  until_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CalendarEventRecurrenceRuleRecurrenceRuleAggregationSelection = {
  __typename?: 'CalendarEventRecurrenceRuleRecurrenceRuleAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CalendarEventRecurrenceRuleRecurrenceRuleNodeAggregateSelection>;
};

export type CalendarEventRecurrenceRuleRecurrenceRuleNodeAggregateSelection = {
  __typename?: 'CalendarEventRecurrenceRuleRecurrenceRuleNodeAggregateSelection';
  until: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type CalendarEventRecurrenceRuleRelationship = {
  __typename?: 'CalendarEventRecurrenceRuleRelationship';
  cursor: Scalars['String']['output'];
  node: RecurrenceRule;
};

export type CalendarEventRecurrenceRuleUpdateConnectionInput = {
  node?: InputMaybe<RecurrenceRuleUpdateInput>;
};

export type CalendarEventRecurrenceRuleUpdateFieldInput = {
  connect?: InputMaybe<CalendarEventRecurrenceRuleConnectFieldInput>;
  create?: InputMaybe<CalendarEventRecurrenceRuleCreateFieldInput>;
  delete?: InputMaybe<CalendarEventRecurrenceRuleDeleteFieldInput>;
  disconnect?: InputMaybe<CalendarEventRecurrenceRuleDisconnectFieldInput>;
  update?: InputMaybe<CalendarEventRecurrenceRuleUpdateConnectionInput>;
  where?: InputMaybe<CalendarEventRecurrenceRuleConnectionWhere>;
};

/** Fields to sort CalendarEvents by. The order in which sorts are applied is not guaranteed when specifying many fields in one CalendarEventSort object. */
export type CalendarEventSort = {
  allCanStartVirtualEvent?: InputMaybe<SortDirection>;
  classbookHomework?: InputMaybe<SortDirection>;
  classbookHomeworkContentType?: InputMaybe<SortDirection>;
  classbookNote?: InputMaybe<SortDirection>;
  classbookNoteContentType?: InputMaybe<SortDirection>;
  color?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  descriptionContentType?: InputMaybe<SortDirection>;
  duration?: InputMaybe<SortDirection>;
  guestsAllowed?: InputMaybe<SortDirection>;
  locale?: InputMaybe<SortDirection>;
  maxAttendees?: InputMaybe<SortDirection>;
  privacy?: InputMaybe<SortDirection>;
  prodId?: InputMaybe<SortDirection>;
  recordVirtualEvent?: InputMaybe<SortDirection>;
  sequence?: InputMaybe<SortDirection>;
  showWithoutTime?: InputMaybe<SortDirection>;
  start?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  timeZone?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
  updated?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type CalendarEventTeachingUnitAggregateInput = {
  AND?: InputMaybe<Array<CalendarEventTeachingUnitAggregateInput>>;
  NOT?: InputMaybe<CalendarEventTeachingUnitAggregateInput>;
  OR?: InputMaybe<Array<CalendarEventTeachingUnitAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CalendarEventTeachingUnitNodeAggregationWhereInput>;
};

export type CalendarEventTeachingUnitConnectFieldInput = {
  connect?: InputMaybe<TeachingUnitConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TeachingUnitConnectWhere>;
};

export type CalendarEventTeachingUnitConnection = {
  __typename?: 'CalendarEventTeachingUnitConnection';
  edges: Array<CalendarEventTeachingUnitRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CalendarEventTeachingUnitConnectionSort = {
  node?: InputMaybe<TeachingUnitSort>;
};

export type CalendarEventTeachingUnitConnectionWhere = {
  AND?: InputMaybe<Array<CalendarEventTeachingUnitConnectionWhere>>;
  NOT?: InputMaybe<CalendarEventTeachingUnitConnectionWhere>;
  OR?: InputMaybe<Array<CalendarEventTeachingUnitConnectionWhere>>;
  node?: InputMaybe<TeachingUnitWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TeachingUnitWhere>;
};

export type CalendarEventTeachingUnitCreateFieldInput = {
  node: TeachingUnitCreateInput;
};

export type CalendarEventTeachingUnitDeleteFieldInput = {
  delete?: InputMaybe<TeachingUnitDeleteInput>;
  where?: InputMaybe<CalendarEventTeachingUnitConnectionWhere>;
};

export type CalendarEventTeachingUnitDisconnectFieldInput = {
  disconnect?: InputMaybe<TeachingUnitDisconnectInput>;
  where?: InputMaybe<CalendarEventTeachingUnitConnectionWhere>;
};

export type CalendarEventTeachingUnitFieldInput = {
  connect?: InputMaybe<CalendarEventTeachingUnitConnectFieldInput>;
  create?: InputMaybe<CalendarEventTeachingUnitCreateFieldInput>;
};

export type CalendarEventTeachingUnitNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CalendarEventTeachingUnitNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CalendarEventTeachingUnitNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CalendarEventTeachingUnitNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  descriptionMediaType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionMediaType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionMediaType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionMediaType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionMediaType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionMediaType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionMediaType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionMediaType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionMediaType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionMediaType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionMediaType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionMediaType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionMediaType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionMediaType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionMediaType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sortIndex_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sortIndex_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sortIndex_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sortIndex_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  sortIndex_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CalendarEventTeachingUnitRelationship = {
  __typename?: 'CalendarEventTeachingUnitRelationship';
  cursor: Scalars['String']['output'];
  node: TeachingUnit;
};

export type CalendarEventTeachingUnitTeachingUnitAggregationSelection = {
  __typename?: 'CalendarEventTeachingUnitTeachingUnitAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CalendarEventTeachingUnitTeachingUnitNodeAggregateSelection>;
};

export type CalendarEventTeachingUnitTeachingUnitNodeAggregateSelection = {
  __typename?: 'CalendarEventTeachingUnitTeachingUnitNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  descriptionMediaType: StringAggregateSelection;
  sortIndex: IntAggregateSelection;
  title: StringAggregateSelection;
  updated: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type CalendarEventTeachingUnitUpdateConnectionInput = {
  node?: InputMaybe<TeachingUnitUpdateInput>;
};

export type CalendarEventTeachingUnitUpdateFieldInput = {
  connect?: InputMaybe<CalendarEventTeachingUnitConnectFieldInput>;
  create?: InputMaybe<CalendarEventTeachingUnitCreateFieldInput>;
  delete?: InputMaybe<CalendarEventTeachingUnitDeleteFieldInput>;
  disconnect?: InputMaybe<CalendarEventTeachingUnitDisconnectFieldInput>;
  update?: InputMaybe<CalendarEventTeachingUnitUpdateConnectionInput>;
  where?: InputMaybe<CalendarEventTeachingUnitConnectionWhere>;
};

export type CalendarEventUpdateInput = {
  allCanStartVirtualEvent?: InputMaybe<Scalars['Boolean']['input']>;
  attendees?: InputMaybe<Array<CalendarEventAttendeesUpdateFieldInput>>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  categories_POP?: InputMaybe<Scalars['Int']['input']>;
  categories_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
  classbookHomework?: InputMaybe<Scalars['String']['input']>;
  classbookHomeworkContentType?: InputMaybe<Scalars['String']['input']>;
  classbookNote?: InputMaybe<Scalars['String']['input']>;
  classbookNoteContentType?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  days?: InputMaybe<Array<CalendarEventDaysUpdateFieldInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContentType?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  foreignRefId?: InputMaybe<Array<Scalars['String']['input']>>;
  foreignRefId_POP?: InputMaybe<Scalars['Int']['input']>;
  foreignRefId_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
  guestsAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  holder?: InputMaybe<CalendarEventHolderUpdateInput>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  keywords_POP?: InputMaybe<Scalars['Int']['input']>;
  keywords_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<Array<CalendarEventLocationsUpdateFieldInput>>;
  maxAttendees?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<CalendarEventOrganizationUpdateFieldInput>;
  owner?: InputMaybe<CalendarEventOwnerUpdateFieldInput>;
  privacy?: InputMaybe<Scalars['String']['input']>;
  prodId?: InputMaybe<Scalars['String']['input']>;
  recordVirtualEvent?: InputMaybe<Scalars['Boolean']['input']>;
  recurrenceRule?: InputMaybe<CalendarEventRecurrenceRuleUpdateFieldInput>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
  sequence_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  sequence_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  showWithoutTime?: InputMaybe<Scalars['Boolean']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  teachingUnit?: InputMaybe<CalendarEventTeachingUnitUpdateFieldInput>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  virtualLocations?: InputMaybe<Array<CalendarEventVirtualLocationsUpdateFieldInput>>;
};

export type CalendarEventVirtualLocationVirtualLocationsAggregationSelection = {
  __typename?: 'CalendarEventVirtualLocationVirtualLocationsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CalendarEventVirtualLocationVirtualLocationsNodeAggregateSelection>;
};

export type CalendarEventVirtualLocationVirtualLocationsNodeAggregateSelection = {
  __typename?: 'CalendarEventVirtualLocationVirtualLocationsNodeAggregateSelection';
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  token: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type CalendarEventVirtualLocationsAggregateInput = {
  AND?: InputMaybe<Array<CalendarEventVirtualLocationsAggregateInput>>;
  NOT?: InputMaybe<CalendarEventVirtualLocationsAggregateInput>;
  OR?: InputMaybe<Array<CalendarEventVirtualLocationsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CalendarEventVirtualLocationsNodeAggregationWhereInput>;
};

export type CalendarEventVirtualLocationsConnectFieldInput = {
  connect?: InputMaybe<Array<VirtualLocationConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<VirtualLocationConnectWhere>;
};

export type CalendarEventVirtualLocationsConnection = {
  __typename?: 'CalendarEventVirtualLocationsConnection';
  edges: Array<CalendarEventVirtualLocationsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CalendarEventVirtualLocationsConnectionSort = {
  node?: InputMaybe<VirtualLocationSort>;
};

export type CalendarEventVirtualLocationsConnectionWhere = {
  AND?: InputMaybe<Array<CalendarEventVirtualLocationsConnectionWhere>>;
  NOT?: InputMaybe<CalendarEventVirtualLocationsConnectionWhere>;
  OR?: InputMaybe<Array<CalendarEventVirtualLocationsConnectionWhere>>;
  node?: InputMaybe<VirtualLocationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<VirtualLocationWhere>;
};

export type CalendarEventVirtualLocationsCreateFieldInput = {
  node: VirtualLocationCreateInput;
};

export type CalendarEventVirtualLocationsDeleteFieldInput = {
  delete?: InputMaybe<VirtualLocationDeleteInput>;
  where?: InputMaybe<CalendarEventVirtualLocationsConnectionWhere>;
};

export type CalendarEventVirtualLocationsDisconnectFieldInput = {
  disconnect?: InputMaybe<VirtualLocationDisconnectInput>;
  where?: InputMaybe<CalendarEventVirtualLocationsConnectionWhere>;
};

export type CalendarEventVirtualLocationsFieldInput = {
  connect?: InputMaybe<Array<CalendarEventVirtualLocationsConnectFieldInput>>;
  create?: InputMaybe<Array<CalendarEventVirtualLocationsCreateFieldInput>>;
};

export type CalendarEventVirtualLocationsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CalendarEventVirtualLocationsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CalendarEventVirtualLocationsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CalendarEventVirtualLocationsNodeAggregationWhereInput>>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  token_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  token_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  token_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  token_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  token_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  token_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  token_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  token_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  token_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  token_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  token_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  token_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  token_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  token_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  token_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CalendarEventVirtualLocationsRelationship = {
  __typename?: 'CalendarEventVirtualLocationsRelationship';
  cursor: Scalars['String']['output'];
  node: VirtualLocation;
};

export type CalendarEventVirtualLocationsUpdateConnectionInput = {
  node?: InputMaybe<VirtualLocationUpdateInput>;
};

export type CalendarEventVirtualLocationsUpdateFieldInput = {
  connect?: InputMaybe<Array<CalendarEventVirtualLocationsConnectFieldInput>>;
  create?: InputMaybe<Array<CalendarEventVirtualLocationsCreateFieldInput>>;
  delete?: InputMaybe<Array<CalendarEventVirtualLocationsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CalendarEventVirtualLocationsDisconnectFieldInput>>;
  update?: InputMaybe<CalendarEventVirtualLocationsUpdateConnectionInput>;
  where?: InputMaybe<CalendarEventVirtualLocationsConnectionWhere>;
};

export type CalendarEventWhere = {
  AND?: InputMaybe<Array<CalendarEventWhere>>;
  NOT?: InputMaybe<CalendarEventWhere>;
  OR?: InputMaybe<Array<CalendarEventWhere>>;
  allCanStartVirtualEvent?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  allCanStartVirtualEvent_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use `attendees_SOME` instead. */
  attendees?: InputMaybe<ProfileWhere>;
  attendeesAggregate?: InputMaybe<CalendarEventAttendeesAggregateInput>;
  /** @deprecated Use `attendeesConnection_SOME` instead. */
  attendeesConnection?: InputMaybe<CalendarEventAttendeesConnectionWhere>;
  /** Return CalendarEvents where all of the related CalendarEventAttendeesConnections match this filter */
  attendeesConnection_ALL?: InputMaybe<CalendarEventAttendeesConnectionWhere>;
  /** Return CalendarEvents where none of the related CalendarEventAttendeesConnections match this filter */
  attendeesConnection_NONE?: InputMaybe<CalendarEventAttendeesConnectionWhere>;
  /** @deprecated Use `attendeesConnection_NONE` instead. */
  attendeesConnection_NOT?: InputMaybe<CalendarEventAttendeesConnectionWhere>;
  /** Return CalendarEvents where one of the related CalendarEventAttendeesConnections match this filter */
  attendeesConnection_SINGLE?: InputMaybe<CalendarEventAttendeesConnectionWhere>;
  /** Return CalendarEvents where some of the related CalendarEventAttendeesConnections match this filter */
  attendeesConnection_SOME?: InputMaybe<CalendarEventAttendeesConnectionWhere>;
  /** Return CalendarEvents where all of the related Profiles match this filter */
  attendees_ALL?: InputMaybe<ProfileWhere>;
  /** Return CalendarEvents where none of the related Profiles match this filter */
  attendees_NONE?: InputMaybe<ProfileWhere>;
  /** @deprecated Use `attendees_NONE` instead. */
  attendees_NOT?: InputMaybe<ProfileWhere>;
  /** Return CalendarEvents where one of the related Profiles match this filter */
  attendees_SINGLE?: InputMaybe<ProfileWhere>;
  /** Return CalendarEvents where some of the related Profiles match this filter */
  attendees_SOME?: InputMaybe<ProfileWhere>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  categories_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  categories_NOT?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  categories_NOT_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  classShortNames?: InputMaybe<Array<Scalars['String']['input']>>;
  classShortNames_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  classShortNames_NOT?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  classShortNames_NOT_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  classbookHomework?: InputMaybe<Scalars['String']['input']>;
  classbookHomeworkContentType?: InputMaybe<Scalars['String']['input']>;
  classbookHomeworkContentType_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  classbookHomeworkContentType_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  classbookHomeworkContentType_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  classbookHomeworkContentType_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  classbookHomeworkContentType_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  classbookHomeworkContentType_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  classbookHomeworkContentType_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  classbookHomeworkContentType_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  classbookHomeworkContentType_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  classbookHomework_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  classbookHomework_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  classbookHomework_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  classbookHomework_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  classbookHomework_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  classbookHomework_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  classbookHomework_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  classbookHomework_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  classbookHomework_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  classbookNote?: InputMaybe<Scalars['String']['input']>;
  classbookNoteContentType?: InputMaybe<Scalars['String']['input']>;
  classbookNoteContentType_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  classbookNoteContentType_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  classbookNoteContentType_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  classbookNoteContentType_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  classbookNoteContentType_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  classbookNoteContentType_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  classbookNoteContentType_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  classbookNoteContentType_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  classbookNoteContentType_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  classbookNote_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  classbookNote_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  classbookNote_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  classbookNote_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  classbookNote_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  classbookNote_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  classbookNote_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  classbookNote_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  classbookNote_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  color_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  color_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  color_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  color_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  color_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  color_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  color_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  color_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  color_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  created_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  created_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  /** @deprecated Use `days_SOME` instead. */
  days?: InputMaybe<DayWhere>;
  daysAggregate?: InputMaybe<CalendarEventDaysAggregateInput>;
  /** @deprecated Use `daysConnection_SOME` instead. */
  daysConnection?: InputMaybe<CalendarEventDaysConnectionWhere>;
  /** Return CalendarEvents where all of the related CalendarEventDaysConnections match this filter */
  daysConnection_ALL?: InputMaybe<CalendarEventDaysConnectionWhere>;
  /** Return CalendarEvents where none of the related CalendarEventDaysConnections match this filter */
  daysConnection_NONE?: InputMaybe<CalendarEventDaysConnectionWhere>;
  /** @deprecated Use `daysConnection_NONE` instead. */
  daysConnection_NOT?: InputMaybe<CalendarEventDaysConnectionWhere>;
  /** Return CalendarEvents where one of the related CalendarEventDaysConnections match this filter */
  daysConnection_SINGLE?: InputMaybe<CalendarEventDaysConnectionWhere>;
  /** Return CalendarEvents where some of the related CalendarEventDaysConnections match this filter */
  daysConnection_SOME?: InputMaybe<CalendarEventDaysConnectionWhere>;
  /** Return CalendarEvents where all of the related Days match this filter */
  days_ALL?: InputMaybe<DayWhere>;
  /** Return CalendarEvents where none of the related Days match this filter */
  days_NONE?: InputMaybe<DayWhere>;
  /** @deprecated Use `days_NONE` instead. */
  days_NOT?: InputMaybe<DayWhere>;
  /** Return CalendarEvents where one of the related Days match this filter */
  days_SINGLE?: InputMaybe<DayWhere>;
  /** Return CalendarEvents where some of the related Days match this filter */
  days_SOME?: InputMaybe<DayWhere>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContentType?: InputMaybe<Scalars['String']['input']>;
  descriptionContentType_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  descriptionContentType_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  descriptionContentType_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  descriptionContentType_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  descriptionContentType_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  descriptionContentType_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  descriptionContentType_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  descriptionContentType_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  descriptionContentType_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  duration_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  duration_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  duration_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  duration_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  duration_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  duration_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  duration_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  duration_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  duration_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignRefId?: InputMaybe<Array<Scalars['String']['input']>>;
  foreignRefId_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignRefId_NOT?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignRefId_NOT_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  guestsAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  guestsAllowed_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  holder?: InputMaybe<CalendarEventHolderWhere>;
  holderConnection?: InputMaybe<CalendarEventHolderConnectionWhere>;
  holderConnection_NOT?: InputMaybe<CalendarEventHolderConnectionWhere>;
  holder_NOT?: InputMaybe<CalendarEventHolderWhere>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  keywords_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  keywords_NOT?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  keywords_NOT_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locale_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  locale_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  locale_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  locale_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  locale_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  locale_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  locale_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  locale_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  locale_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `locations_SOME` instead. */
  locations?: InputMaybe<LocationWhere>;
  locationsAggregate?: InputMaybe<CalendarEventLocationsAggregateInput>;
  /** @deprecated Use `locationsConnection_SOME` instead. */
  locationsConnection?: InputMaybe<CalendarEventLocationsConnectionWhere>;
  /** Return CalendarEvents where all of the related CalendarEventLocationsConnections match this filter */
  locationsConnection_ALL?: InputMaybe<CalendarEventLocationsConnectionWhere>;
  /** Return CalendarEvents where none of the related CalendarEventLocationsConnections match this filter */
  locationsConnection_NONE?: InputMaybe<CalendarEventLocationsConnectionWhere>;
  /** @deprecated Use `locationsConnection_NONE` instead. */
  locationsConnection_NOT?: InputMaybe<CalendarEventLocationsConnectionWhere>;
  /** Return CalendarEvents where one of the related CalendarEventLocationsConnections match this filter */
  locationsConnection_SINGLE?: InputMaybe<CalendarEventLocationsConnectionWhere>;
  /** Return CalendarEvents where some of the related CalendarEventLocationsConnections match this filter */
  locationsConnection_SOME?: InputMaybe<CalendarEventLocationsConnectionWhere>;
  /** Return CalendarEvents where all of the related Locations match this filter */
  locations_ALL?: InputMaybe<LocationWhere>;
  /** Return CalendarEvents where none of the related Locations match this filter */
  locations_NONE?: InputMaybe<LocationWhere>;
  /** @deprecated Use `locations_NONE` instead. */
  locations_NOT?: InputMaybe<LocationWhere>;
  /** Return CalendarEvents where one of the related Locations match this filter */
  locations_SINGLE?: InputMaybe<LocationWhere>;
  /** Return CalendarEvents where some of the related Locations match this filter */
  locations_SOME?: InputMaybe<LocationWhere>;
  maxAttendees?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_GT?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  maxAttendees_LT?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  maxAttendees_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  maxAttendees_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<CalendarEventOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<CalendarEventOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<CalendarEventOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  owner?: InputMaybe<ProfileWhere>;
  ownerAggregate?: InputMaybe<CalendarEventOwnerAggregateInput>;
  ownerConnection?: InputMaybe<CalendarEventOwnerConnectionWhere>;
  ownerConnection_NOT?: InputMaybe<CalendarEventOwnerConnectionWhere>;
  owner_NOT?: InputMaybe<ProfileWhere>;
  privacy?: InputMaybe<Scalars['String']['input']>;
  privacy_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  privacy_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  privacy_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  privacy_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  privacy_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  privacy_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  privacy_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  privacy_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  privacy_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  prodId?: InputMaybe<Scalars['String']['input']>;
  prodId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  prodId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  prodId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  prodId_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  prodId_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  prodId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  prodId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  prodId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  prodId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  recordVirtualEvent?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  recordVirtualEvent_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  recurrenceRule?: InputMaybe<RecurrenceRuleWhere>;
  recurrenceRuleAggregate?: InputMaybe<CalendarEventRecurrenceRuleAggregateInput>;
  recurrenceRuleConnection?: InputMaybe<CalendarEventRecurrenceRuleConnectionWhere>;
  recurrenceRuleConnection_NOT?: InputMaybe<CalendarEventRecurrenceRuleConnectionWhere>;
  recurrenceRule_NOT?: InputMaybe<RecurrenceRuleWhere>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
  sequence_GT?: InputMaybe<Scalars['Int']['input']>;
  sequence_GTE?: InputMaybe<Scalars['Int']['input']>;
  sequence_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sequence_LT?: InputMaybe<Scalars['Int']['input']>;
  sequence_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sequence_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sequence_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  showWithoutTime?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  showWithoutTime_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
  start_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  start_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  start_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  start_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  start_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  start_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  start_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  start_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  start_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  status_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  status_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  status_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  status_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  status_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  status_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  status_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  status_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  teachingUnit?: InputMaybe<TeachingUnitWhere>;
  teachingUnitAggregate?: InputMaybe<CalendarEventTeachingUnitAggregateInput>;
  teachingUnitConnection?: InputMaybe<CalendarEventTeachingUnitConnectionWhere>;
  teachingUnitConnection_NOT?: InputMaybe<CalendarEventTeachingUnitConnectionWhere>;
  teachingUnit_NOT?: InputMaybe<TeachingUnitWhere>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  timeZone_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  timeZone_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  timeZone_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  timeZone_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  timeZone_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  timeZone_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  timeZone_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  timeZone_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  timeZone_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  updated_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updated_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updated_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updated_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Use `virtualLocations_SOME` instead. */
  virtualLocations?: InputMaybe<VirtualLocationWhere>;
  virtualLocationsAggregate?: InputMaybe<CalendarEventVirtualLocationsAggregateInput>;
  /** @deprecated Use `virtualLocationsConnection_SOME` instead. */
  virtualLocationsConnection?: InputMaybe<CalendarEventVirtualLocationsConnectionWhere>;
  /** Return CalendarEvents where all of the related CalendarEventVirtualLocationsConnections match this filter */
  virtualLocationsConnection_ALL?: InputMaybe<CalendarEventVirtualLocationsConnectionWhere>;
  /** Return CalendarEvents where none of the related CalendarEventVirtualLocationsConnections match this filter */
  virtualLocationsConnection_NONE?: InputMaybe<CalendarEventVirtualLocationsConnectionWhere>;
  /** @deprecated Use `virtualLocationsConnection_NONE` instead. */
  virtualLocationsConnection_NOT?: InputMaybe<CalendarEventVirtualLocationsConnectionWhere>;
  /** Return CalendarEvents where one of the related CalendarEventVirtualLocationsConnections match this filter */
  virtualLocationsConnection_SINGLE?: InputMaybe<CalendarEventVirtualLocationsConnectionWhere>;
  /** Return CalendarEvents where some of the related CalendarEventVirtualLocationsConnections match this filter */
  virtualLocationsConnection_SOME?: InputMaybe<CalendarEventVirtualLocationsConnectionWhere>;
  /** Return CalendarEvents where all of the related VirtualLocations match this filter */
  virtualLocations_ALL?: InputMaybe<VirtualLocationWhere>;
  /** Return CalendarEvents where none of the related VirtualLocations match this filter */
  virtualLocations_NONE?: InputMaybe<VirtualLocationWhere>;
  /** @deprecated Use `virtualLocations_NONE` instead. */
  virtualLocations_NOT?: InputMaybe<VirtualLocationWhere>;
  /** Return CalendarEvents where one of the related VirtualLocations match this filter */
  virtualLocations_SINGLE?: InputMaybe<VirtualLocationWhere>;
  /** Return CalendarEvents where some of the related VirtualLocations match this filter */
  virtualLocations_SOME?: InputMaybe<VirtualLocationWhere>;
};

export type CalendarEventsConnection = {
  __typename?: 'CalendarEventsConnection';
  edges: Array<CalendarEventEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CalendarSubscription = {
  __typename?: 'CalendarSubscription';
  collections: Array<CalendarEventHolder>;
  collectionsConnection: CalendarSubscriptionCollectionsConnection;
  owner: Profile;
  ownerAggregate?: Maybe<CalendarSubscriptionProfileOwnerAggregationSelection>;
  ownerConnection: CalendarSubscriptionOwnerConnection;
  token: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type CalendarSubscriptionCollectionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<CalendarEventHolderWhere>;
};

export type CalendarSubscriptionCollectionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CalendarSubscriptionCollectionsConnectionWhere>;
};

export type CalendarSubscriptionOwnerArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ProfileOptions>;
  where?: InputMaybe<ProfileWhere>;
};

export type CalendarSubscriptionOwnerAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProfileWhere>;
};

export type CalendarSubscriptionOwnerConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CalendarSubscriptionOwnerConnectionSort>>;
  where?: InputMaybe<CalendarSubscriptionOwnerConnectionWhere>;
};

export type CalendarSubscriptionAggregateSelection = {
  __typename?: 'CalendarSubscriptionAggregateSelection';
  count: Scalars['Int']['output'];
  token: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type CalendarSubscriptionCollectionsConnectInput = {
  Group?: InputMaybe<Array<CalendarSubscriptionCollectionsGroupConnectFieldInput>>;
  Organization?: InputMaybe<Array<CalendarSubscriptionCollectionsOrganizationConnectFieldInput>>;
  Profile?: InputMaybe<Array<CalendarSubscriptionCollectionsProfileConnectFieldInput>>;
};

export type CalendarSubscriptionCollectionsConnection = {
  __typename?: 'CalendarSubscriptionCollectionsConnection';
  edges: Array<CalendarSubscriptionCollectionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CalendarSubscriptionCollectionsConnectionWhere = {
  Group?: InputMaybe<CalendarSubscriptionCollectionsGroupConnectionWhere>;
  Organization?: InputMaybe<CalendarSubscriptionCollectionsOrganizationConnectionWhere>;
  Profile?: InputMaybe<CalendarSubscriptionCollectionsProfileConnectionWhere>;
};

export type CalendarSubscriptionCollectionsCreateInput = {
  Group?: InputMaybe<CalendarSubscriptionCollectionsGroupFieldInput>;
  Organization?: InputMaybe<CalendarSubscriptionCollectionsOrganizationFieldInput>;
  Profile?: InputMaybe<CalendarSubscriptionCollectionsProfileFieldInput>;
};

export type CalendarSubscriptionCollectionsDeleteInput = {
  Group?: InputMaybe<Array<CalendarSubscriptionCollectionsGroupDeleteFieldInput>>;
  Organization?: InputMaybe<Array<CalendarSubscriptionCollectionsOrganizationDeleteFieldInput>>;
  Profile?: InputMaybe<Array<CalendarSubscriptionCollectionsProfileDeleteFieldInput>>;
};

export type CalendarSubscriptionCollectionsDisconnectInput = {
  Group?: InputMaybe<Array<CalendarSubscriptionCollectionsGroupDisconnectFieldInput>>;
  Organization?: InputMaybe<Array<CalendarSubscriptionCollectionsOrganizationDisconnectFieldInput>>;
  Profile?: InputMaybe<Array<CalendarSubscriptionCollectionsProfileDisconnectFieldInput>>;
};

export type CalendarSubscriptionCollectionsGroupConnectFieldInput = {
  connect?: InputMaybe<Array<GroupConnectInput>>;
  where?: InputMaybe<GroupConnectWhere>;
};

export type CalendarSubscriptionCollectionsGroupConnectOrCreateFieldInput = {
  onCreate: CalendarSubscriptionCollectionsGroupConnectOrCreateFieldInputOnCreate;
  where: GroupConnectOrCreateWhere;
};

export type CalendarSubscriptionCollectionsGroupConnectOrCreateFieldInputOnCreate = {
  node: GroupOnCreateInput;
};

export type CalendarSubscriptionCollectionsGroupConnectionWhere = {
  AND?: InputMaybe<Array<CalendarSubscriptionCollectionsGroupConnectionWhere>>;
  NOT?: InputMaybe<CalendarSubscriptionCollectionsGroupConnectionWhere>;
  OR?: InputMaybe<Array<CalendarSubscriptionCollectionsGroupConnectionWhere>>;
  node?: InputMaybe<GroupWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<GroupWhere>;
};

export type CalendarSubscriptionCollectionsGroupCreateFieldInput = {
  node: GroupCreateInput;
};

export type CalendarSubscriptionCollectionsGroupDeleteFieldInput = {
  delete?: InputMaybe<GroupDeleteInput>;
  where?: InputMaybe<CalendarSubscriptionCollectionsGroupConnectionWhere>;
};

export type CalendarSubscriptionCollectionsGroupDisconnectFieldInput = {
  disconnect?: InputMaybe<GroupDisconnectInput>;
  where?: InputMaybe<CalendarSubscriptionCollectionsGroupConnectionWhere>;
};

export type CalendarSubscriptionCollectionsGroupFieldInput = {
  connect?: InputMaybe<Array<CalendarSubscriptionCollectionsGroupConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CalendarSubscriptionCollectionsGroupConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CalendarSubscriptionCollectionsGroupCreateFieldInput>>;
};

export type CalendarSubscriptionCollectionsGroupUpdateConnectionInput = {
  node?: InputMaybe<GroupUpdateInput>;
};

export type CalendarSubscriptionCollectionsGroupUpdateFieldInput = {
  connect?: InputMaybe<Array<CalendarSubscriptionCollectionsGroupConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CalendarSubscriptionCollectionsGroupConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CalendarSubscriptionCollectionsGroupCreateFieldInput>>;
  delete?: InputMaybe<Array<CalendarSubscriptionCollectionsGroupDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CalendarSubscriptionCollectionsGroupDisconnectFieldInput>>;
  update?: InputMaybe<CalendarSubscriptionCollectionsGroupUpdateConnectionInput>;
  where?: InputMaybe<CalendarSubscriptionCollectionsGroupConnectionWhere>;
};

export type CalendarSubscriptionCollectionsOrganizationConnectFieldInput = {
  connect?: InputMaybe<Array<OrganizationConnectInput>>;
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type CalendarSubscriptionCollectionsOrganizationConnectOrCreateFieldInput = {
  onCreate: CalendarSubscriptionCollectionsOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type CalendarSubscriptionCollectionsOrganizationConnectOrCreateFieldInputOnCreate = {
  node: OrganizationOnCreateInput;
};

export type CalendarSubscriptionCollectionsOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<CalendarSubscriptionCollectionsOrganizationConnectionWhere>>;
  NOT?: InputMaybe<CalendarSubscriptionCollectionsOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<CalendarSubscriptionCollectionsOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type CalendarSubscriptionCollectionsOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type CalendarSubscriptionCollectionsOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<CalendarSubscriptionCollectionsOrganizationConnectionWhere>;
};

export type CalendarSubscriptionCollectionsOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<CalendarSubscriptionCollectionsOrganizationConnectionWhere>;
};

export type CalendarSubscriptionCollectionsOrganizationFieldInput = {
  connect?: InputMaybe<Array<CalendarSubscriptionCollectionsOrganizationConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CalendarSubscriptionCollectionsOrganizationConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CalendarSubscriptionCollectionsOrganizationCreateFieldInput>>;
};

export type CalendarSubscriptionCollectionsOrganizationUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type CalendarSubscriptionCollectionsOrganizationUpdateFieldInput = {
  connect?: InputMaybe<Array<CalendarSubscriptionCollectionsOrganizationConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CalendarSubscriptionCollectionsOrganizationConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CalendarSubscriptionCollectionsOrganizationCreateFieldInput>>;
  delete?: InputMaybe<Array<CalendarSubscriptionCollectionsOrganizationDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CalendarSubscriptionCollectionsOrganizationDisconnectFieldInput>>;
  update?: InputMaybe<CalendarSubscriptionCollectionsOrganizationUpdateConnectionInput>;
  where?: InputMaybe<CalendarSubscriptionCollectionsOrganizationConnectionWhere>;
};

export type CalendarSubscriptionCollectionsProfileConnectFieldInput = {
  connect?: InputMaybe<Array<ProfileConnectInput>>;
  where?: InputMaybe<ProfileConnectWhere>;
};

export type CalendarSubscriptionCollectionsProfileConnectOrCreateFieldInput = {
  onCreate: CalendarSubscriptionCollectionsProfileConnectOrCreateFieldInputOnCreate;
  where: ProfileConnectOrCreateWhere;
};

export type CalendarSubscriptionCollectionsProfileConnectOrCreateFieldInputOnCreate = {
  node: ProfileOnCreateInput;
};

export type CalendarSubscriptionCollectionsProfileConnectionWhere = {
  AND?: InputMaybe<Array<CalendarSubscriptionCollectionsProfileConnectionWhere>>;
  NOT?: InputMaybe<CalendarSubscriptionCollectionsProfileConnectionWhere>;
  OR?: InputMaybe<Array<CalendarSubscriptionCollectionsProfileConnectionWhere>>;
  node?: InputMaybe<ProfileWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ProfileWhere>;
};

export type CalendarSubscriptionCollectionsProfileCreateFieldInput = {
  node: ProfileCreateInput;
};

export type CalendarSubscriptionCollectionsProfileDeleteFieldInput = {
  delete?: InputMaybe<ProfileDeleteInput>;
  where?: InputMaybe<CalendarSubscriptionCollectionsProfileConnectionWhere>;
};

export type CalendarSubscriptionCollectionsProfileDisconnectFieldInput = {
  disconnect?: InputMaybe<ProfileDisconnectInput>;
  where?: InputMaybe<CalendarSubscriptionCollectionsProfileConnectionWhere>;
};

export type CalendarSubscriptionCollectionsProfileFieldInput = {
  connect?: InputMaybe<Array<CalendarSubscriptionCollectionsProfileConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CalendarSubscriptionCollectionsProfileConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CalendarSubscriptionCollectionsProfileCreateFieldInput>>;
};

export type CalendarSubscriptionCollectionsProfileUpdateConnectionInput = {
  node?: InputMaybe<ProfileUpdateInput>;
};

export type CalendarSubscriptionCollectionsProfileUpdateFieldInput = {
  connect?: InputMaybe<Array<CalendarSubscriptionCollectionsProfileConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CalendarSubscriptionCollectionsProfileConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CalendarSubscriptionCollectionsProfileCreateFieldInput>>;
  delete?: InputMaybe<Array<CalendarSubscriptionCollectionsProfileDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CalendarSubscriptionCollectionsProfileDisconnectFieldInput>>;
  update?: InputMaybe<CalendarSubscriptionCollectionsProfileUpdateConnectionInput>;
  where?: InputMaybe<CalendarSubscriptionCollectionsProfileConnectionWhere>;
};

export type CalendarSubscriptionCollectionsRelationship = {
  __typename?: 'CalendarSubscriptionCollectionsRelationship';
  cursor: Scalars['String']['output'];
  node: CalendarEventHolder;
};

export type CalendarSubscriptionCollectionsUpdateInput = {
  Group?: InputMaybe<Array<CalendarSubscriptionCollectionsGroupUpdateFieldInput>>;
  Organization?: InputMaybe<Array<CalendarSubscriptionCollectionsOrganizationUpdateFieldInput>>;
  Profile?: InputMaybe<Array<CalendarSubscriptionCollectionsProfileUpdateFieldInput>>;
};

export type CalendarSubscriptionConnectInput = {
  collections?: InputMaybe<CalendarSubscriptionCollectionsConnectInput>;
  owner?: InputMaybe<CalendarSubscriptionOwnerConnectFieldInput>;
};

export type CalendarSubscriptionConnectWhere = {
  node: CalendarSubscriptionWhere;
};

export type CalendarSubscriptionCreateInput = {
  collections?: InputMaybe<CalendarSubscriptionCollectionsCreateInput>;
  owner?: InputMaybe<CalendarSubscriptionOwnerFieldInput>;
  token: Scalars['String']['input'];
};

export type CalendarSubscriptionDeleteInput = {
  collections?: InputMaybe<CalendarSubscriptionCollectionsDeleteInput>;
  owner?: InputMaybe<CalendarSubscriptionOwnerDeleteFieldInput>;
};

export type CalendarSubscriptionDisconnectInput = {
  collections?: InputMaybe<CalendarSubscriptionCollectionsDisconnectInput>;
  owner?: InputMaybe<CalendarSubscriptionOwnerDisconnectFieldInput>;
};

export type CalendarSubscriptionEdge = {
  __typename?: 'CalendarSubscriptionEdge';
  cursor: Scalars['String']['output'];
  node: CalendarSubscription;
};

export type CalendarSubscriptionOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CalendarSubscriptionSort objects to sort CalendarSubscriptions by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CalendarSubscriptionSort>>;
};

export type CalendarSubscriptionOwnerAggregateInput = {
  AND?: InputMaybe<Array<CalendarSubscriptionOwnerAggregateInput>>;
  NOT?: InputMaybe<CalendarSubscriptionOwnerAggregateInput>;
  OR?: InputMaybe<Array<CalendarSubscriptionOwnerAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CalendarSubscriptionOwnerNodeAggregationWhereInput>;
};

export type CalendarSubscriptionOwnerConnectFieldInput = {
  connect?: InputMaybe<ProfileConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ProfileConnectWhere>;
};

export type CalendarSubscriptionOwnerConnectOrCreateFieldInput = {
  onCreate: CalendarSubscriptionOwnerConnectOrCreateFieldInputOnCreate;
  where: ProfileConnectOrCreateWhere;
};

export type CalendarSubscriptionOwnerConnectOrCreateFieldInputOnCreate = {
  node: ProfileOnCreateInput;
};

export type CalendarSubscriptionOwnerConnection = {
  __typename?: 'CalendarSubscriptionOwnerConnection';
  edges: Array<CalendarSubscriptionOwnerRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CalendarSubscriptionOwnerConnectionSort = {
  node?: InputMaybe<ProfileSort>;
};

export type CalendarSubscriptionOwnerConnectionWhere = {
  AND?: InputMaybe<Array<CalendarSubscriptionOwnerConnectionWhere>>;
  NOT?: InputMaybe<CalendarSubscriptionOwnerConnectionWhere>;
  OR?: InputMaybe<Array<CalendarSubscriptionOwnerConnectionWhere>>;
  node?: InputMaybe<ProfileWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ProfileWhere>;
};

export type CalendarSubscriptionOwnerCreateFieldInput = {
  node: ProfileCreateInput;
};

export type CalendarSubscriptionOwnerDeleteFieldInput = {
  delete?: InputMaybe<ProfileDeleteInput>;
  where?: InputMaybe<CalendarSubscriptionOwnerConnectionWhere>;
};

export type CalendarSubscriptionOwnerDisconnectFieldInput = {
  disconnect?: InputMaybe<ProfileDisconnectInput>;
  where?: InputMaybe<CalendarSubscriptionOwnerConnectionWhere>;
};

export type CalendarSubscriptionOwnerFieldInput = {
  connect?: InputMaybe<CalendarSubscriptionOwnerConnectFieldInput>;
  connectOrCreate?: InputMaybe<CalendarSubscriptionOwnerConnectOrCreateFieldInput>;
  create?: InputMaybe<CalendarSubscriptionOwnerCreateFieldInput>;
};

export type CalendarSubscriptionOwnerNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CalendarSubscriptionOwnerNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CalendarSubscriptionOwnerNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CalendarSubscriptionOwnerNodeAggregationWhereInput>>;
  address1_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address1_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address2_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address2_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address3_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address3_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  birthday_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  userUuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  userUuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CalendarSubscriptionOwnerRelationship = {
  __typename?: 'CalendarSubscriptionOwnerRelationship';
  cursor: Scalars['String']['output'];
  node: Profile;
};

export type CalendarSubscriptionOwnerUpdateConnectionInput = {
  node?: InputMaybe<ProfileUpdateInput>;
};

export type CalendarSubscriptionOwnerUpdateFieldInput = {
  connect?: InputMaybe<CalendarSubscriptionOwnerConnectFieldInput>;
  connectOrCreate?: InputMaybe<CalendarSubscriptionOwnerConnectOrCreateFieldInput>;
  create?: InputMaybe<CalendarSubscriptionOwnerCreateFieldInput>;
  delete?: InputMaybe<CalendarSubscriptionOwnerDeleteFieldInput>;
  disconnect?: InputMaybe<CalendarSubscriptionOwnerDisconnectFieldInput>;
  update?: InputMaybe<CalendarSubscriptionOwnerUpdateConnectionInput>;
  where?: InputMaybe<CalendarSubscriptionOwnerConnectionWhere>;
};

export type CalendarSubscriptionProfileOwnerAggregationSelection = {
  __typename?: 'CalendarSubscriptionProfileOwnerAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CalendarSubscriptionProfileOwnerNodeAggregateSelection>;
};

export type CalendarSubscriptionProfileOwnerNodeAggregateSelection = {
  __typename?: 'CalendarSubscriptionProfileOwnerNodeAggregateSelection';
  address1: StringAggregateSelection;
  address2: StringAggregateSelection;
  address3: StringAggregateSelection;
  birthday: StringAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  email: StringAggregateSelection;
  firstName: StringAggregateSelection;
  firstNames: StringAggregateSelection;
  lastName: StringAggregateSelection;
  managedBy: StringAggregateSelection;
  matrixToken: StringAggregateSelection;
  nextcloudUserId: StringAggregateSelection;
  prefixName: StringAggregateSelection;
  salutation: StringAggregateSelection;
  shortName: StringAggregateSelection;
  threemaId: StringAggregateSelection;
  title: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  userUuid: StringAggregateSelection;
  uuid: IdAggregateSelection;
  zoomUserId: StringAggregateSelection;
};

/** Fields to sort CalendarSubscriptions by. The order in which sorts are applied is not guaranteed when specifying many fields in one CalendarSubscriptionSort object. */
export type CalendarSubscriptionSort = {
  token?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type CalendarSubscriptionUpdateInput = {
  collections?: InputMaybe<CalendarSubscriptionCollectionsUpdateInput>;
  owner?: InputMaybe<CalendarSubscriptionOwnerUpdateFieldInput>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type CalendarSubscriptionWhere = {
  AND?: InputMaybe<Array<CalendarSubscriptionWhere>>;
  NOT?: InputMaybe<CalendarSubscriptionWhere>;
  OR?: InputMaybe<Array<CalendarSubscriptionWhere>>;
  /** @deprecated Use `collections_SOME` instead. */
  collections?: InputMaybe<CalendarEventHolderWhere>;
  /** @deprecated Use `collectionsConnection_SOME` instead. */
  collectionsConnection?: InputMaybe<CalendarSubscriptionCollectionsConnectionWhere>;
  /** Return CalendarSubscriptions where all of the related CalendarSubscriptionCollectionsConnections match this filter */
  collectionsConnection_ALL?: InputMaybe<CalendarSubscriptionCollectionsConnectionWhere>;
  /** Return CalendarSubscriptions where none of the related CalendarSubscriptionCollectionsConnections match this filter */
  collectionsConnection_NONE?: InputMaybe<CalendarSubscriptionCollectionsConnectionWhere>;
  /** @deprecated Use `collectionsConnection_NONE` instead. */
  collectionsConnection_NOT?: InputMaybe<CalendarSubscriptionCollectionsConnectionWhere>;
  /** Return CalendarSubscriptions where one of the related CalendarSubscriptionCollectionsConnections match this filter */
  collectionsConnection_SINGLE?: InputMaybe<CalendarSubscriptionCollectionsConnectionWhere>;
  /** Return CalendarSubscriptions where some of the related CalendarSubscriptionCollectionsConnections match this filter */
  collectionsConnection_SOME?: InputMaybe<CalendarSubscriptionCollectionsConnectionWhere>;
  /** Return CalendarSubscriptions where all of the related CalendarEventHolders match this filter */
  collections_ALL?: InputMaybe<CalendarEventHolderWhere>;
  /** Return CalendarSubscriptions where none of the related CalendarEventHolders match this filter */
  collections_NONE?: InputMaybe<CalendarEventHolderWhere>;
  /** @deprecated Use `collections_NONE` instead. */
  collections_NOT?: InputMaybe<CalendarEventHolderWhere>;
  /** Return CalendarSubscriptions where one of the related CalendarEventHolders match this filter */
  collections_SINGLE?: InputMaybe<CalendarEventHolderWhere>;
  /** Return CalendarSubscriptions where some of the related CalendarEventHolders match this filter */
  collections_SOME?: InputMaybe<CalendarEventHolderWhere>;
  owner?: InputMaybe<ProfileWhere>;
  ownerAggregate?: InputMaybe<CalendarSubscriptionOwnerAggregateInput>;
  ownerConnection?: InputMaybe<CalendarSubscriptionOwnerConnectionWhere>;
  ownerConnection_NOT?: InputMaybe<CalendarSubscriptionOwnerConnectionWhere>;
  owner_NOT?: InputMaybe<ProfileWhere>;
  token?: InputMaybe<Scalars['String']['input']>;
  token_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  token_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  token_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  token_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  token_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  token_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  token_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  token_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  token_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type CalendarSubscriptionsConnection = {
  __typename?: 'CalendarSubscriptionsConnection';
  edges: Array<CalendarSubscriptionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Class = {
  __typename?: 'Class';
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  divisions: Array<Division>;
  divisionsAggregate?: Maybe<ClassDivisionDivisionsAggregationSelection>;
  divisionsConnection: ClassDivisionsConnection;
  foreignRefId?: Maybe<Array<Scalars['String']['output']>>;
  grade: Scalars['String']['output'];
  gradeGroup: Scalars['String']['output'];
  group?: Maybe<Group>;
  groupConnection: ClassGroupConnection;
  managedBy: Scalars['String']['output'];
  members: Array<Profile>;
  membersAggregate?: Maybe<ClassProfileMembersAggregationSelection>;
  membersConnection: ClassMembersConnection;
  name: Scalars['String']['output'];
  organization: Organization;
  organizationConnection: ClassOrganizationConnection;
  schoolYear: SchoolYear;
  schoolYearConnection: ClassSchoolYearConnection;
  shortName: Scalars['String']['output'];
  tutors: Array<Profile>;
  tutorsAggregate?: Maybe<ClassProfileTutorsAggregationSelection>;
  tutorsConnection: ClassTutorsConnection;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['ID']['output'];
};

export type ClassDivisionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DivisionOptions>;
  where?: InputMaybe<DivisionWhere>;
};

export type ClassDivisionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DivisionWhere>;
};

export type ClassDivisionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ClassDivisionsConnectionSort>>;
  where?: InputMaybe<ClassDivisionsConnectionWhere>;
};

export type ClassGroupArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<GroupOptions>;
  where?: InputMaybe<GroupWhere>;
};

export type ClassGroupConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ClassGroupConnectionSort>>;
  where?: InputMaybe<ClassGroupConnectionWhere>;
};

export type ClassMembersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ProfileOptions>;
  where?: InputMaybe<ProfileWhere>;
};

export type ClassMembersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProfileWhere>;
};

export type ClassMembersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ClassMembersConnectionSort>>;
  where?: InputMaybe<ClassMembersConnectionWhere>;
};

export type ClassOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type ClassOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ClassOrganizationConnectionSort>>;
  where?: InputMaybe<ClassOrganizationConnectionWhere>;
};

export type ClassSchoolYearArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SchoolYearOptions>;
  where?: InputMaybe<SchoolYearWhere>;
};

export type ClassSchoolYearConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ClassSchoolYearConnectionSort>>;
  where?: InputMaybe<ClassSchoolYearConnectionWhere>;
};

export type ClassTutorsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ProfileOptions>;
  where?: InputMaybe<ProfileWhere>;
};

export type ClassTutorsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProfileWhere>;
};

export type ClassTutorsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ClassTutorsConnectionSort>>;
  where?: InputMaybe<ClassTutorsConnectionWhere>;
};

export type ClassAggregateSelection = {
  __typename?: 'ClassAggregateSelection';
  color: StringAggregateSelection;
  count: Scalars['Int']['output'];
  createdAt: DateTimeAggregateSelection;
  grade: StringAggregateSelection;
  gradeGroup: StringAggregateSelection;
  managedBy: StringAggregateSelection;
  name: StringAggregateSelection;
  shortName: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type ClassConnectInput = {
  divisions?: InputMaybe<Array<ClassDivisionsConnectFieldInput>>;
  group?: InputMaybe<ClassGroupConnectFieldInput>;
  members?: InputMaybe<Array<ClassMembersConnectFieldInput>>;
  organization?: InputMaybe<ClassOrganizationConnectFieldInput>;
  schoolYear?: InputMaybe<ClassSchoolYearConnectFieldInput>;
  tutors?: InputMaybe<Array<ClassTutorsConnectFieldInput>>;
};

export type ClassConnectWhere = {
  node: ClassWhere;
};

export type ClassCreateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  createdAt: Scalars['DateTime']['input'];
  divisions?: InputMaybe<ClassDivisionsFieldInput>;
  foreignRefId?: InputMaybe<Array<Scalars['String']['input']>>;
  grade: Scalars['String']['input'];
  gradeGroup: Scalars['String']['input'];
  group?: InputMaybe<ClassGroupFieldInput>;
  managedBy: Scalars['String']['input'];
  members?: InputMaybe<ClassMembersFieldInput>;
  name: Scalars['String']['input'];
  organization?: InputMaybe<ClassOrganizationFieldInput>;
  schoolYear?: InputMaybe<ClassSchoolYearFieldInput>;
  shortName: Scalars['String']['input'];
  tutors?: InputMaybe<ClassTutorsFieldInput>;
  updatedAt: Scalars['DateTime']['input'];
};

export type ClassDeleteInput = {
  divisions?: InputMaybe<Array<ClassDivisionsDeleteFieldInput>>;
  group?: InputMaybe<ClassGroupDeleteFieldInput>;
  members?: InputMaybe<Array<ClassMembersDeleteFieldInput>>;
  organization?: InputMaybe<ClassOrganizationDeleteFieldInput>;
  schoolYear?: InputMaybe<ClassSchoolYearDeleteFieldInput>;
  tutors?: InputMaybe<Array<ClassTutorsDeleteFieldInput>>;
};

export type ClassDisconnectInput = {
  divisions?: InputMaybe<Array<ClassDivisionsDisconnectFieldInput>>;
  group?: InputMaybe<ClassGroupDisconnectFieldInput>;
  members?: InputMaybe<Array<ClassMembersDisconnectFieldInput>>;
  organization?: InputMaybe<ClassOrganizationDisconnectFieldInput>;
  schoolYear?: InputMaybe<ClassSchoolYearDisconnectFieldInput>;
  tutors?: InputMaybe<Array<ClassTutorsDisconnectFieldInput>>;
};

export type ClassDivisionDivisionsAggregationSelection = {
  __typename?: 'ClassDivisionDivisionsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ClassDivisionDivisionsNodeAggregateSelection>;
};

export type ClassDivisionDivisionsNodeAggregateSelection = {
  __typename?: 'ClassDivisionDivisionsNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  managedBy: StringAggregateSelection;
  name: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type ClassDivisionsAggregateInput = {
  AND?: InputMaybe<Array<ClassDivisionsAggregateInput>>;
  NOT?: InputMaybe<ClassDivisionsAggregateInput>;
  OR?: InputMaybe<Array<ClassDivisionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ClassDivisionsNodeAggregationWhereInput>;
};

export type ClassDivisionsConnectFieldInput = {
  connect?: InputMaybe<Array<DivisionConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<DivisionConnectWhere>;
};

export type ClassDivisionsConnection = {
  __typename?: 'ClassDivisionsConnection';
  edges: Array<ClassDivisionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ClassDivisionsConnectionSort = {
  node?: InputMaybe<DivisionSort>;
};

export type ClassDivisionsConnectionWhere = {
  AND?: InputMaybe<Array<ClassDivisionsConnectionWhere>>;
  NOT?: InputMaybe<ClassDivisionsConnectionWhere>;
  OR?: InputMaybe<Array<ClassDivisionsConnectionWhere>>;
  node?: InputMaybe<DivisionWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<DivisionWhere>;
};

export type ClassDivisionsCreateFieldInput = {
  node: DivisionCreateInput;
};

export type ClassDivisionsDeleteFieldInput = {
  delete?: InputMaybe<DivisionDeleteInput>;
  where?: InputMaybe<ClassDivisionsConnectionWhere>;
};

export type ClassDivisionsDisconnectFieldInput = {
  disconnect?: InputMaybe<DivisionDisconnectInput>;
  where?: InputMaybe<ClassDivisionsConnectionWhere>;
};

export type ClassDivisionsFieldInput = {
  connect?: InputMaybe<Array<ClassDivisionsConnectFieldInput>>;
  create?: InputMaybe<Array<ClassDivisionsCreateFieldInput>>;
};

export type ClassDivisionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ClassDivisionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ClassDivisionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ClassDivisionsNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  managedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ClassDivisionsRelationship = {
  __typename?: 'ClassDivisionsRelationship';
  cursor: Scalars['String']['output'];
  node: Division;
};

export type ClassDivisionsUpdateConnectionInput = {
  node?: InputMaybe<DivisionUpdateInput>;
};

export type ClassDivisionsUpdateFieldInput = {
  connect?: InputMaybe<Array<ClassDivisionsConnectFieldInput>>;
  create?: InputMaybe<Array<ClassDivisionsCreateFieldInput>>;
  delete?: InputMaybe<Array<ClassDivisionsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ClassDivisionsDisconnectFieldInput>>;
  update?: InputMaybe<ClassDivisionsUpdateConnectionInput>;
  where?: InputMaybe<ClassDivisionsConnectionWhere>;
};

export type ClassEdge = {
  __typename?: 'ClassEdge';
  cursor: Scalars['String']['output'];
  node: Class;
};

export type ClassGroup = {
  __typename?: 'ClassGroup';
  division: Division;
  divisionAggregate?: Maybe<ClassGroupDivisionDivisionAggregationSelection>;
  divisionConnection: ClassGroupDivisionConnection;
  foreignRefId?: Maybe<Array<Scalars['String']['output']>>;
  managedBy: Scalars['String']['output'];
  members: Array<Profile>;
  membersAggregate?: Maybe<ClassGroupProfileMembersAggregationSelection>;
  membersConnection: ClassGroupMembersConnection;
  name: Scalars['String']['output'];
  organization: Organization;
  organizationConnection: ClassGroupOrganizationConnection;
  shortName: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type ClassGroupDivisionArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DivisionOptions>;
  where?: InputMaybe<DivisionWhere>;
};

export type ClassGroupDivisionAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DivisionWhere>;
};

export type ClassGroupDivisionConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ClassGroupDivisionConnectionSort>>;
  where?: InputMaybe<ClassGroupDivisionConnectionWhere>;
};

export type ClassGroupMembersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ProfileOptions>;
  where?: InputMaybe<ProfileWhere>;
};

export type ClassGroupMembersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProfileWhere>;
};

export type ClassGroupMembersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ClassGroupMembersConnectionSort>>;
  where?: InputMaybe<ClassGroupMembersConnectionWhere>;
};

export type ClassGroupOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type ClassGroupOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ClassGroupOrganizationConnectionSort>>;
  where?: InputMaybe<ClassGroupOrganizationConnectionWhere>;
};

export type ClassGroupAggregateInput = {
  AND?: InputMaybe<Array<ClassGroupAggregateInput>>;
  NOT?: InputMaybe<ClassGroupAggregateInput>;
  OR?: InputMaybe<Array<ClassGroupAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ClassGroupNodeAggregationWhereInput>;
};

export type ClassGroupAggregateSelection = {
  __typename?: 'ClassGroupAggregateSelection';
  count: Scalars['Int']['output'];
  managedBy: StringAggregateSelection;
  name: StringAggregateSelection;
  shortName: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type ClassGroupConnectFieldInput = {
  connect?: InputMaybe<GroupConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<GroupConnectWhere>;
};

export type ClassGroupConnectInput = {
  division?: InputMaybe<ClassGroupDivisionConnectFieldInput>;
  members?: InputMaybe<Array<ClassGroupMembersConnectFieldInput>>;
  organization?: InputMaybe<ClassGroupOrganizationConnectFieldInput>;
};

export type ClassGroupConnectOrCreateFieldInput = {
  onCreate: ClassGroupConnectOrCreateFieldInputOnCreate;
  where: GroupConnectOrCreateWhere;
};

export type ClassGroupConnectOrCreateFieldInputOnCreate = {
  node: GroupOnCreateInput;
};

export type ClassGroupConnectWhere = {
  node: ClassGroupWhere;
};

export type ClassGroupConnection = {
  __typename?: 'ClassGroupConnection';
  edges: Array<ClassGroupRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ClassGroupConnectionSort = {
  node?: InputMaybe<GroupSort>;
};

export type ClassGroupConnectionWhere = {
  AND?: InputMaybe<Array<ClassGroupConnectionWhere>>;
  NOT?: InputMaybe<ClassGroupConnectionWhere>;
  OR?: InputMaybe<Array<ClassGroupConnectionWhere>>;
  node?: InputMaybe<GroupWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<GroupWhere>;
};

export type ClassGroupCreateFieldInput = {
  node: GroupCreateInput;
};

export type ClassGroupCreateInput = {
  division?: InputMaybe<ClassGroupDivisionFieldInput>;
  foreignRefId?: InputMaybe<Array<Scalars['String']['input']>>;
  managedBy: Scalars['String']['input'];
  members?: InputMaybe<ClassGroupMembersFieldInput>;
  name: Scalars['String']['input'];
  organization?: InputMaybe<ClassGroupOrganizationFieldInput>;
  shortName: Scalars['String']['input'];
};

export type ClassGroupDeleteFieldInput = {
  delete?: InputMaybe<GroupDeleteInput>;
  where?: InputMaybe<ClassGroupConnectionWhere>;
};

export type ClassGroupDeleteInput = {
  division?: InputMaybe<ClassGroupDivisionDeleteFieldInput>;
  members?: InputMaybe<Array<ClassGroupMembersDeleteFieldInput>>;
  organization?: InputMaybe<ClassGroupOrganizationDeleteFieldInput>;
};

export type ClassGroupDisconnectFieldInput = {
  disconnect?: InputMaybe<GroupDisconnectInput>;
  where?: InputMaybe<ClassGroupConnectionWhere>;
};

export type ClassGroupDisconnectInput = {
  division?: InputMaybe<ClassGroupDivisionDisconnectFieldInput>;
  members?: InputMaybe<Array<ClassGroupMembersDisconnectFieldInput>>;
  organization?: InputMaybe<ClassGroupOrganizationDisconnectFieldInput>;
};

export type ClassGroupDivisionAggregateInput = {
  AND?: InputMaybe<Array<ClassGroupDivisionAggregateInput>>;
  NOT?: InputMaybe<ClassGroupDivisionAggregateInput>;
  OR?: InputMaybe<Array<ClassGroupDivisionAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<OrderedRelationPropertiesAggregationWhereInput>;
  node?: InputMaybe<ClassGroupDivisionNodeAggregationWhereInput>;
};

export type ClassGroupDivisionConnectFieldInput = {
  connect?: InputMaybe<DivisionConnectInput>;
  edge: OrderedRelationPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<DivisionConnectWhere>;
};

export type ClassGroupDivisionConnection = {
  __typename?: 'ClassGroupDivisionConnection';
  edges: Array<ClassGroupDivisionRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ClassGroupDivisionConnectionSort = {
  edge?: InputMaybe<OrderedRelationPropertiesSort>;
  node?: InputMaybe<DivisionSort>;
};

export type ClassGroupDivisionConnectionWhere = {
  AND?: InputMaybe<Array<ClassGroupDivisionConnectionWhere>>;
  NOT?: InputMaybe<ClassGroupDivisionConnectionWhere>;
  OR?: InputMaybe<Array<ClassGroupDivisionConnectionWhere>>;
  edge?: InputMaybe<OrderedRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<OrderedRelationPropertiesWhere>;
  node?: InputMaybe<DivisionWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<DivisionWhere>;
};

export type ClassGroupDivisionCreateFieldInput = {
  edge: OrderedRelationPropertiesCreateInput;
  node: DivisionCreateInput;
};

export type ClassGroupDivisionDeleteFieldInput = {
  delete?: InputMaybe<DivisionDeleteInput>;
  where?: InputMaybe<ClassGroupDivisionConnectionWhere>;
};

export type ClassGroupDivisionDisconnectFieldInput = {
  disconnect?: InputMaybe<DivisionDisconnectInput>;
  where?: InputMaybe<ClassGroupDivisionConnectionWhere>;
};

export type ClassGroupDivisionDivisionAggregationSelection = {
  __typename?: 'ClassGroupDivisionDivisionAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<ClassGroupDivisionDivisionEdgeAggregateSelection>;
  node?: Maybe<ClassGroupDivisionDivisionNodeAggregateSelection>;
};

export type ClassGroupDivisionDivisionEdgeAggregateSelection = {
  __typename?: 'ClassGroupDivisionDivisionEdgeAggregateSelection';
  order: IntAggregateSelection;
};

export type ClassGroupDivisionDivisionNodeAggregateSelection = {
  __typename?: 'ClassGroupDivisionDivisionNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  managedBy: StringAggregateSelection;
  name: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type ClassGroupDivisionFieldInput = {
  connect?: InputMaybe<ClassGroupDivisionConnectFieldInput>;
  create?: InputMaybe<ClassGroupDivisionCreateFieldInput>;
};

export type ClassGroupDivisionNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ClassGroupDivisionNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ClassGroupDivisionNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ClassGroupDivisionNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  managedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ClassGroupDivisionRelationship = {
  __typename?: 'ClassGroupDivisionRelationship';
  cursor: Scalars['String']['output'];
  node: Division;
  properties: OrderedRelationProperties;
};

export type ClassGroupDivisionUpdateConnectionInput = {
  edge?: InputMaybe<OrderedRelationPropertiesUpdateInput>;
  node?: InputMaybe<DivisionUpdateInput>;
};

export type ClassGroupDivisionUpdateFieldInput = {
  connect?: InputMaybe<ClassGroupDivisionConnectFieldInput>;
  create?: InputMaybe<ClassGroupDivisionCreateFieldInput>;
  delete?: InputMaybe<ClassGroupDivisionDeleteFieldInput>;
  disconnect?: InputMaybe<ClassGroupDivisionDisconnectFieldInput>;
  update?: InputMaybe<ClassGroupDivisionUpdateConnectionInput>;
  where?: InputMaybe<ClassGroupDivisionConnectionWhere>;
};

export type ClassGroupEdge = {
  __typename?: 'ClassGroupEdge';
  cursor: Scalars['String']['output'];
  node: ClassGroup;
};

export type ClassGroupFieldInput = {
  connect?: InputMaybe<ClassGroupConnectFieldInput>;
  connectOrCreate?: InputMaybe<ClassGroupConnectOrCreateFieldInput>;
  create?: InputMaybe<ClassGroupCreateFieldInput>;
};

export type ClassGroupMembersAggregateInput = {
  AND?: InputMaybe<Array<ClassGroupMembersAggregateInput>>;
  NOT?: InputMaybe<ClassGroupMembersAggregateInput>;
  OR?: InputMaybe<Array<ClassGroupMembersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ClassGroupMembersNodeAggregationWhereInput>;
};

export type ClassGroupMembersConnectFieldInput = {
  connect?: InputMaybe<Array<ProfileConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ProfileConnectWhere>;
};

export type ClassGroupMembersConnectOrCreateFieldInput = {
  onCreate: ClassGroupMembersConnectOrCreateFieldInputOnCreate;
  where: ProfileConnectOrCreateWhere;
};

export type ClassGroupMembersConnectOrCreateFieldInputOnCreate = {
  node: ProfileOnCreateInput;
};

export type ClassGroupMembersConnection = {
  __typename?: 'ClassGroupMembersConnection';
  edges: Array<ClassGroupMembersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ClassGroupMembersConnectionSort = {
  node?: InputMaybe<ProfileSort>;
};

export type ClassGroupMembersConnectionWhere = {
  AND?: InputMaybe<Array<ClassGroupMembersConnectionWhere>>;
  NOT?: InputMaybe<ClassGroupMembersConnectionWhere>;
  OR?: InputMaybe<Array<ClassGroupMembersConnectionWhere>>;
  node?: InputMaybe<ProfileWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ProfileWhere>;
};

export type ClassGroupMembersCreateFieldInput = {
  node: ProfileCreateInput;
};

export type ClassGroupMembersDeleteFieldInput = {
  delete?: InputMaybe<ProfileDeleteInput>;
  where?: InputMaybe<ClassGroupMembersConnectionWhere>;
};

export type ClassGroupMembersDisconnectFieldInput = {
  disconnect?: InputMaybe<ProfileDisconnectInput>;
  where?: InputMaybe<ClassGroupMembersConnectionWhere>;
};

export type ClassGroupMembersFieldInput = {
  connect?: InputMaybe<Array<ClassGroupMembersConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ClassGroupMembersConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ClassGroupMembersCreateFieldInput>>;
};

export type ClassGroupMembersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ClassGroupMembersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ClassGroupMembersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ClassGroupMembersNodeAggregationWhereInput>>;
  address1_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address1_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address2_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address2_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address3_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address3_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  birthday_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  userUuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  userUuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ClassGroupMembersRelationship = {
  __typename?: 'ClassGroupMembersRelationship';
  cursor: Scalars['String']['output'];
  node: Profile;
};

export type ClassGroupMembersUpdateConnectionInput = {
  node?: InputMaybe<ProfileUpdateInput>;
};

export type ClassGroupMembersUpdateFieldInput = {
  connect?: InputMaybe<Array<ClassGroupMembersConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ClassGroupMembersConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ClassGroupMembersCreateFieldInput>>;
  delete?: InputMaybe<Array<ClassGroupMembersDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ClassGroupMembersDisconnectFieldInput>>;
  update?: InputMaybe<ClassGroupMembersUpdateConnectionInput>;
  where?: InputMaybe<ClassGroupMembersConnectionWhere>;
};

export type ClassGroupNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ClassGroupNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ClassGroupNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ClassGroupNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ClassGroupOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ClassGroupSort objects to sort ClassGroups by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ClassGroupSort>>;
};

export type ClassGroupOrganizationAggregateInput = {
  AND?: InputMaybe<Array<ClassGroupOrganizationAggregateInput>>;
  NOT?: InputMaybe<ClassGroupOrganizationAggregateInput>;
  OR?: InputMaybe<Array<ClassGroupOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ClassGroupOrganizationNodeAggregationWhereInput>;
};

export type ClassGroupOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type ClassGroupOrganizationConnectOrCreateFieldInput = {
  onCreate: ClassGroupOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type ClassGroupOrganizationConnectOrCreateFieldInputOnCreate = {
  node: OrganizationOnCreateInput;
};

export type ClassGroupOrganizationConnection = {
  __typename?: 'ClassGroupOrganizationConnection';
  edges: Array<ClassGroupOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ClassGroupOrganizationConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type ClassGroupOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<ClassGroupOrganizationConnectionWhere>>;
  NOT?: InputMaybe<ClassGroupOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<ClassGroupOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type ClassGroupOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type ClassGroupOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<ClassGroupOrganizationConnectionWhere>;
};

export type ClassGroupOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<ClassGroupOrganizationConnectionWhere>;
};

export type ClassGroupOrganizationFieldInput = {
  connect?: InputMaybe<ClassGroupOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<ClassGroupOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<ClassGroupOrganizationCreateFieldInput>;
};

export type ClassGroupOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ClassGroupOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ClassGroupOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ClassGroupOrganizationNodeAggregationWhereInput>>;
  aboutInfoLastUpdated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ClassGroupOrganizationRelationship = {
  __typename?: 'ClassGroupOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type ClassGroupOrganizationUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type ClassGroupOrganizationUpdateFieldInput = {
  connect?: InputMaybe<ClassGroupOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<ClassGroupOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<ClassGroupOrganizationCreateFieldInput>;
  delete?: InputMaybe<ClassGroupOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<ClassGroupOrganizationDisconnectFieldInput>;
  update?: InputMaybe<ClassGroupOrganizationUpdateConnectionInput>;
  where?: InputMaybe<ClassGroupOrganizationConnectionWhere>;
};

export type ClassGroupProfileMembersAggregationSelection = {
  __typename?: 'ClassGroupProfileMembersAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ClassGroupProfileMembersNodeAggregateSelection>;
};

export type ClassGroupProfileMembersNodeAggregateSelection = {
  __typename?: 'ClassGroupProfileMembersNodeAggregateSelection';
  address1: StringAggregateSelection;
  address2: StringAggregateSelection;
  address3: StringAggregateSelection;
  birthday: StringAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  email: StringAggregateSelection;
  firstName: StringAggregateSelection;
  firstNames: StringAggregateSelection;
  lastName: StringAggregateSelection;
  managedBy: StringAggregateSelection;
  matrixToken: StringAggregateSelection;
  nextcloudUserId: StringAggregateSelection;
  prefixName: StringAggregateSelection;
  salutation: StringAggregateSelection;
  shortName: StringAggregateSelection;
  threemaId: StringAggregateSelection;
  title: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  userUuid: StringAggregateSelection;
  uuid: IdAggregateSelection;
  zoomUserId: StringAggregateSelection;
};

export type ClassGroupRelationship = {
  __typename?: 'ClassGroupRelationship';
  cursor: Scalars['String']['output'];
  node: Group;
};

/** Fields to sort ClassGroups by. The order in which sorts are applied is not guaranteed when specifying many fields in one ClassGroupSort object. */
export type ClassGroupSort = {
  managedBy?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  shortName?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type ClassGroupUpdateConnectionInput = {
  node?: InputMaybe<GroupUpdateInput>;
};

export type ClassGroupUpdateFieldInput = {
  connect?: InputMaybe<ClassGroupConnectFieldInput>;
  connectOrCreate?: InputMaybe<ClassGroupConnectOrCreateFieldInput>;
  create?: InputMaybe<ClassGroupCreateFieldInput>;
  delete?: InputMaybe<ClassGroupDeleteFieldInput>;
  disconnect?: InputMaybe<ClassGroupDisconnectFieldInput>;
  update?: InputMaybe<ClassGroupUpdateConnectionInput>;
  where?: InputMaybe<ClassGroupConnectionWhere>;
};

export type ClassGroupUpdateInput = {
  division?: InputMaybe<ClassGroupDivisionUpdateFieldInput>;
  foreignRefId?: InputMaybe<Array<Scalars['String']['input']>>;
  foreignRefId_POP?: InputMaybe<Scalars['Int']['input']>;
  foreignRefId_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
  managedBy?: InputMaybe<Scalars['String']['input']>;
  members?: InputMaybe<Array<ClassGroupMembersUpdateFieldInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<ClassGroupOrganizationUpdateFieldInput>;
  shortName?: InputMaybe<Scalars['String']['input']>;
};

export type ClassGroupWhere = {
  AND?: InputMaybe<Array<ClassGroupWhere>>;
  NOT?: InputMaybe<ClassGroupWhere>;
  OR?: InputMaybe<Array<ClassGroupWhere>>;
  division?: InputMaybe<DivisionWhere>;
  divisionAggregate?: InputMaybe<ClassGroupDivisionAggregateInput>;
  divisionConnection?: InputMaybe<ClassGroupDivisionConnectionWhere>;
  divisionConnection_NOT?: InputMaybe<ClassGroupDivisionConnectionWhere>;
  division_NOT?: InputMaybe<DivisionWhere>;
  foreignRefId?: InputMaybe<Array<Scalars['String']['input']>>;
  foreignRefId_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignRefId_NOT?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignRefId_NOT_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  managedBy?: InputMaybe<Scalars['String']['input']>;
  managedBy_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  managedBy_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  managedBy_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  managedBy_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  managedBy_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  managedBy_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  managedBy_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  managedBy_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  managedBy_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `members_SOME` instead. */
  members?: InputMaybe<ProfileWhere>;
  membersAggregate?: InputMaybe<ClassGroupMembersAggregateInput>;
  /** @deprecated Use `membersConnection_SOME` instead. */
  membersConnection?: InputMaybe<ClassGroupMembersConnectionWhere>;
  /** Return ClassGroups where all of the related ClassGroupMembersConnections match this filter */
  membersConnection_ALL?: InputMaybe<ClassGroupMembersConnectionWhere>;
  /** Return ClassGroups where none of the related ClassGroupMembersConnections match this filter */
  membersConnection_NONE?: InputMaybe<ClassGroupMembersConnectionWhere>;
  /** @deprecated Use `membersConnection_NONE` instead. */
  membersConnection_NOT?: InputMaybe<ClassGroupMembersConnectionWhere>;
  /** Return ClassGroups where one of the related ClassGroupMembersConnections match this filter */
  membersConnection_SINGLE?: InputMaybe<ClassGroupMembersConnectionWhere>;
  /** Return ClassGroups where some of the related ClassGroupMembersConnections match this filter */
  membersConnection_SOME?: InputMaybe<ClassGroupMembersConnectionWhere>;
  /** Return ClassGroups where all of the related Profiles match this filter */
  members_ALL?: InputMaybe<ProfileWhere>;
  /** Return ClassGroups where none of the related Profiles match this filter */
  members_NONE?: InputMaybe<ProfileWhere>;
  /** @deprecated Use `members_NONE` instead. */
  members_NOT?: InputMaybe<ProfileWhere>;
  /** Return ClassGroups where one of the related Profiles match this filter */
  members_SINGLE?: InputMaybe<ProfileWhere>;
  /** Return ClassGroups where some of the related Profiles match this filter */
  members_SOME?: InputMaybe<ProfileWhere>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<ClassGroupOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<ClassGroupOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<ClassGroupOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  shortName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  shortName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  shortName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  shortName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type ClassGroupsConnection = {
  __typename?: 'ClassGroupsConnection';
  edges: Array<ClassGroupEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ClassMembersAggregateInput = {
  AND?: InputMaybe<Array<ClassMembersAggregateInput>>;
  NOT?: InputMaybe<ClassMembersAggregateInput>;
  OR?: InputMaybe<Array<ClassMembersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ClassMembersNodeAggregationWhereInput>;
};

export type ClassMembersConnectFieldInput = {
  connect?: InputMaybe<Array<ProfileConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ProfileConnectWhere>;
};

export type ClassMembersConnectOrCreateFieldInput = {
  onCreate: ClassMembersConnectOrCreateFieldInputOnCreate;
  where: ProfileConnectOrCreateWhere;
};

export type ClassMembersConnectOrCreateFieldInputOnCreate = {
  node: ProfileOnCreateInput;
};

export type ClassMembersConnection = {
  __typename?: 'ClassMembersConnection';
  edges: Array<ClassMembersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ClassMembersConnectionSort = {
  node?: InputMaybe<ProfileSort>;
};

export type ClassMembersConnectionWhere = {
  AND?: InputMaybe<Array<ClassMembersConnectionWhere>>;
  NOT?: InputMaybe<ClassMembersConnectionWhere>;
  OR?: InputMaybe<Array<ClassMembersConnectionWhere>>;
  node?: InputMaybe<ProfileWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ProfileWhere>;
};

export type ClassMembersCreateFieldInput = {
  node: ProfileCreateInput;
};

export type ClassMembersDeleteFieldInput = {
  delete?: InputMaybe<ProfileDeleteInput>;
  where?: InputMaybe<ClassMembersConnectionWhere>;
};

export type ClassMembersDisconnectFieldInput = {
  disconnect?: InputMaybe<ProfileDisconnectInput>;
  where?: InputMaybe<ClassMembersConnectionWhere>;
};

export type ClassMembersFieldInput = {
  connect?: InputMaybe<Array<ClassMembersConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ClassMembersConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ClassMembersCreateFieldInput>>;
};

export type ClassMembersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ClassMembersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ClassMembersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ClassMembersNodeAggregationWhereInput>>;
  address1_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address1_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address2_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address2_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address3_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address3_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  birthday_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  userUuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  userUuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ClassMembersRelationship = {
  __typename?: 'ClassMembersRelationship';
  cursor: Scalars['String']['output'];
  node: Profile;
};

export type ClassMembersUpdateConnectionInput = {
  node?: InputMaybe<ProfileUpdateInput>;
};

export type ClassMembersUpdateFieldInput = {
  connect?: InputMaybe<Array<ClassMembersConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ClassMembersConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ClassMembersCreateFieldInput>>;
  delete?: InputMaybe<Array<ClassMembersDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ClassMembersDisconnectFieldInput>>;
  update?: InputMaybe<ClassMembersUpdateConnectionInput>;
  where?: InputMaybe<ClassMembersConnectionWhere>;
};

export type ClassOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ClassSort objects to sort Classes by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ClassSort>>;
};

export type ClassOrClassGroup = Class | ClassGroup;

export type ClassOrClassGroupWhere = {
  Class?: InputMaybe<ClassWhere>;
  ClassGroup?: InputMaybe<ClassGroupWhere>;
};

export type ClassOrganizationAggregateInput = {
  AND?: InputMaybe<Array<ClassOrganizationAggregateInput>>;
  NOT?: InputMaybe<ClassOrganizationAggregateInput>;
  OR?: InputMaybe<Array<ClassOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ClassOrganizationNodeAggregationWhereInput>;
};

export type ClassOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type ClassOrganizationConnectOrCreateFieldInput = {
  onCreate: ClassOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type ClassOrganizationConnectOrCreateFieldInputOnCreate = {
  node: OrganizationOnCreateInput;
};

export type ClassOrganizationConnection = {
  __typename?: 'ClassOrganizationConnection';
  edges: Array<ClassOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ClassOrganizationConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type ClassOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<ClassOrganizationConnectionWhere>>;
  NOT?: InputMaybe<ClassOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<ClassOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type ClassOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type ClassOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<ClassOrganizationConnectionWhere>;
};

export type ClassOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<ClassOrganizationConnectionWhere>;
};

export type ClassOrganizationFieldInput = {
  connect?: InputMaybe<ClassOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<ClassOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<ClassOrganizationCreateFieldInput>;
};

export type ClassOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ClassOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ClassOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ClassOrganizationNodeAggregationWhereInput>>;
  aboutInfoLastUpdated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ClassOrganizationRelationship = {
  __typename?: 'ClassOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type ClassOrganizationUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type ClassOrganizationUpdateFieldInput = {
  connect?: InputMaybe<ClassOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<ClassOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<ClassOrganizationCreateFieldInput>;
  delete?: InputMaybe<ClassOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<ClassOrganizationDisconnectFieldInput>;
  update?: InputMaybe<ClassOrganizationUpdateConnectionInput>;
  where?: InputMaybe<ClassOrganizationConnectionWhere>;
};

export type ClassProfileMembersAggregationSelection = {
  __typename?: 'ClassProfileMembersAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ClassProfileMembersNodeAggregateSelection>;
};

export type ClassProfileMembersNodeAggregateSelection = {
  __typename?: 'ClassProfileMembersNodeAggregateSelection';
  address1: StringAggregateSelection;
  address2: StringAggregateSelection;
  address3: StringAggregateSelection;
  birthday: StringAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  email: StringAggregateSelection;
  firstName: StringAggregateSelection;
  firstNames: StringAggregateSelection;
  lastName: StringAggregateSelection;
  managedBy: StringAggregateSelection;
  matrixToken: StringAggregateSelection;
  nextcloudUserId: StringAggregateSelection;
  prefixName: StringAggregateSelection;
  salutation: StringAggregateSelection;
  shortName: StringAggregateSelection;
  threemaId: StringAggregateSelection;
  title: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  userUuid: StringAggregateSelection;
  uuid: IdAggregateSelection;
  zoomUserId: StringAggregateSelection;
};

export type ClassProfileTutorsAggregationSelection = {
  __typename?: 'ClassProfileTutorsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<ClassProfileTutorsEdgeAggregateSelection>;
  node?: Maybe<ClassProfileTutorsNodeAggregateSelection>;
};

export type ClassProfileTutorsEdgeAggregateSelection = {
  __typename?: 'ClassProfileTutorsEdgeAggregateSelection';
  order: IntAggregateSelection;
};

export type ClassProfileTutorsNodeAggregateSelection = {
  __typename?: 'ClassProfileTutorsNodeAggregateSelection';
  address1: StringAggregateSelection;
  address2: StringAggregateSelection;
  address3: StringAggregateSelection;
  birthday: StringAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  email: StringAggregateSelection;
  firstName: StringAggregateSelection;
  firstNames: StringAggregateSelection;
  lastName: StringAggregateSelection;
  managedBy: StringAggregateSelection;
  matrixToken: StringAggregateSelection;
  nextcloudUserId: StringAggregateSelection;
  prefixName: StringAggregateSelection;
  salutation: StringAggregateSelection;
  shortName: StringAggregateSelection;
  threemaId: StringAggregateSelection;
  title: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  userUuid: StringAggregateSelection;
  uuid: IdAggregateSelection;
  zoomUserId: StringAggregateSelection;
};

export type ClassSchoolYearAggregateInput = {
  AND?: InputMaybe<Array<ClassSchoolYearAggregateInput>>;
  NOT?: InputMaybe<ClassSchoolYearAggregateInput>;
  OR?: InputMaybe<Array<ClassSchoolYearAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ClassSchoolYearNodeAggregationWhereInput>;
};

export type ClassSchoolYearConnectFieldInput = {
  connect?: InputMaybe<SchoolYearConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SchoolYearConnectWhere>;
};

export type ClassSchoolYearConnection = {
  __typename?: 'ClassSchoolYearConnection';
  edges: Array<ClassSchoolYearRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ClassSchoolYearConnectionSort = {
  node?: InputMaybe<SchoolYearSort>;
};

export type ClassSchoolYearConnectionWhere = {
  AND?: InputMaybe<Array<ClassSchoolYearConnectionWhere>>;
  NOT?: InputMaybe<ClassSchoolYearConnectionWhere>;
  OR?: InputMaybe<Array<ClassSchoolYearConnectionWhere>>;
  node?: InputMaybe<SchoolYearWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SchoolYearWhere>;
};

export type ClassSchoolYearCreateFieldInput = {
  node: SchoolYearCreateInput;
};

export type ClassSchoolYearDeleteFieldInput = {
  delete?: InputMaybe<SchoolYearDeleteInput>;
  where?: InputMaybe<ClassSchoolYearConnectionWhere>;
};

export type ClassSchoolYearDisconnectFieldInput = {
  disconnect?: InputMaybe<SchoolYearDisconnectInput>;
  where?: InputMaybe<ClassSchoolYearConnectionWhere>;
};

export type ClassSchoolYearFieldInput = {
  connect?: InputMaybe<ClassSchoolYearConnectFieldInput>;
  create?: InputMaybe<ClassSchoolYearCreateFieldInput>;
};

export type ClassSchoolYearNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ClassSchoolYearNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ClassSchoolYearNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ClassSchoolYearNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  managedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ClassSchoolYearRelationship = {
  __typename?: 'ClassSchoolYearRelationship';
  cursor: Scalars['String']['output'];
  node: SchoolYear;
};

export type ClassSchoolYearUpdateConnectionInput = {
  node?: InputMaybe<SchoolYearUpdateInput>;
};

export type ClassSchoolYearUpdateFieldInput = {
  connect?: InputMaybe<ClassSchoolYearConnectFieldInput>;
  create?: InputMaybe<ClassSchoolYearCreateFieldInput>;
  delete?: InputMaybe<ClassSchoolYearDeleteFieldInput>;
  disconnect?: InputMaybe<ClassSchoolYearDisconnectFieldInput>;
  update?: InputMaybe<ClassSchoolYearUpdateConnectionInput>;
  where?: InputMaybe<ClassSchoolYearConnectionWhere>;
};

/** Fields to sort Classes by. The order in which sorts are applied is not guaranteed when specifying many fields in one ClassSort object. */
export type ClassSort = {
  color?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  grade?: InputMaybe<SortDirection>;
  gradeGroup?: InputMaybe<SortDirection>;
  managedBy?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  shortName?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type ClassTutorsAggregateInput = {
  AND?: InputMaybe<Array<ClassTutorsAggregateInput>>;
  NOT?: InputMaybe<ClassTutorsAggregateInput>;
  OR?: InputMaybe<Array<ClassTutorsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<OrderedRelationPropertiesAggregationWhereInput>;
  node?: InputMaybe<ClassTutorsNodeAggregationWhereInput>;
};

export type ClassTutorsConnectFieldInput = {
  connect?: InputMaybe<Array<ProfileConnectInput>>;
  edge: OrderedRelationPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ProfileConnectWhere>;
};

export type ClassTutorsConnectOrCreateFieldInput = {
  onCreate: ClassTutorsConnectOrCreateFieldInputOnCreate;
  where: ProfileConnectOrCreateWhere;
};

export type ClassTutorsConnectOrCreateFieldInputOnCreate = {
  edge: OrderedRelationPropertiesCreateInput;
  node: ProfileOnCreateInput;
};

export type ClassTutorsConnection = {
  __typename?: 'ClassTutorsConnection';
  edges: Array<ClassTutorsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ClassTutorsConnectionSort = {
  edge?: InputMaybe<OrderedRelationPropertiesSort>;
  node?: InputMaybe<ProfileSort>;
};

export type ClassTutorsConnectionWhere = {
  AND?: InputMaybe<Array<ClassTutorsConnectionWhere>>;
  NOT?: InputMaybe<ClassTutorsConnectionWhere>;
  OR?: InputMaybe<Array<ClassTutorsConnectionWhere>>;
  edge?: InputMaybe<OrderedRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<OrderedRelationPropertiesWhere>;
  node?: InputMaybe<ProfileWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ProfileWhere>;
};

export type ClassTutorsCreateFieldInput = {
  edge: OrderedRelationPropertiesCreateInput;
  node: ProfileCreateInput;
};

export type ClassTutorsDeleteFieldInput = {
  delete?: InputMaybe<ProfileDeleteInput>;
  where?: InputMaybe<ClassTutorsConnectionWhere>;
};

export type ClassTutorsDisconnectFieldInput = {
  disconnect?: InputMaybe<ProfileDisconnectInput>;
  where?: InputMaybe<ClassTutorsConnectionWhere>;
};

export type ClassTutorsFieldInput = {
  connect?: InputMaybe<Array<ClassTutorsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ClassTutorsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ClassTutorsCreateFieldInput>>;
};

export type ClassTutorsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ClassTutorsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ClassTutorsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ClassTutorsNodeAggregationWhereInput>>;
  address1_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address1_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address2_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address2_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address3_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address3_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  birthday_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  userUuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  userUuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ClassTutorsRelationship = {
  __typename?: 'ClassTutorsRelationship';
  cursor: Scalars['String']['output'];
  node: Profile;
  properties: OrderedRelationProperties;
};

export type ClassTutorsUpdateConnectionInput = {
  edge?: InputMaybe<OrderedRelationPropertiesUpdateInput>;
  node?: InputMaybe<ProfileUpdateInput>;
};

export type ClassTutorsUpdateFieldInput = {
  connect?: InputMaybe<Array<ClassTutorsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ClassTutorsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ClassTutorsCreateFieldInput>>;
  delete?: InputMaybe<Array<ClassTutorsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ClassTutorsDisconnectFieldInput>>;
  update?: InputMaybe<ClassTutorsUpdateConnectionInput>;
  where?: InputMaybe<ClassTutorsConnectionWhere>;
};

export type ClassUpdateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  divisions?: InputMaybe<Array<ClassDivisionsUpdateFieldInput>>;
  foreignRefId?: InputMaybe<Array<Scalars['String']['input']>>;
  foreignRefId_POP?: InputMaybe<Scalars['Int']['input']>;
  foreignRefId_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
  grade?: InputMaybe<Scalars['String']['input']>;
  gradeGroup?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<ClassGroupUpdateFieldInput>;
  managedBy?: InputMaybe<Scalars['String']['input']>;
  members?: InputMaybe<Array<ClassMembersUpdateFieldInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<ClassOrganizationUpdateFieldInput>;
  schoolYear?: InputMaybe<ClassSchoolYearUpdateFieldInput>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  tutors?: InputMaybe<Array<ClassTutorsUpdateFieldInput>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ClassWhere = {
  AND?: InputMaybe<Array<ClassWhere>>;
  NOT?: InputMaybe<ClassWhere>;
  OR?: InputMaybe<Array<ClassWhere>>;
  color?: InputMaybe<Scalars['String']['input']>;
  color_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  color_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  color_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  color_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  color_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  color_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  color_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  color_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  color_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  /** @deprecated Use `divisions_SOME` instead. */
  divisions?: InputMaybe<DivisionWhere>;
  divisionsAggregate?: InputMaybe<ClassDivisionsAggregateInput>;
  /** @deprecated Use `divisionsConnection_SOME` instead. */
  divisionsConnection?: InputMaybe<ClassDivisionsConnectionWhere>;
  /** Return Classes where all of the related ClassDivisionsConnections match this filter */
  divisionsConnection_ALL?: InputMaybe<ClassDivisionsConnectionWhere>;
  /** Return Classes where none of the related ClassDivisionsConnections match this filter */
  divisionsConnection_NONE?: InputMaybe<ClassDivisionsConnectionWhere>;
  /** @deprecated Use `divisionsConnection_NONE` instead. */
  divisionsConnection_NOT?: InputMaybe<ClassDivisionsConnectionWhere>;
  /** Return Classes where one of the related ClassDivisionsConnections match this filter */
  divisionsConnection_SINGLE?: InputMaybe<ClassDivisionsConnectionWhere>;
  /** Return Classes where some of the related ClassDivisionsConnections match this filter */
  divisionsConnection_SOME?: InputMaybe<ClassDivisionsConnectionWhere>;
  /** Return Classes where all of the related Divisions match this filter */
  divisions_ALL?: InputMaybe<DivisionWhere>;
  /** Return Classes where none of the related Divisions match this filter */
  divisions_NONE?: InputMaybe<DivisionWhere>;
  /** @deprecated Use `divisions_NONE` instead. */
  divisions_NOT?: InputMaybe<DivisionWhere>;
  /** Return Classes where one of the related Divisions match this filter */
  divisions_SINGLE?: InputMaybe<DivisionWhere>;
  /** Return Classes where some of the related Divisions match this filter */
  divisions_SOME?: InputMaybe<DivisionWhere>;
  foreignRefId?: InputMaybe<Array<Scalars['String']['input']>>;
  foreignRefId_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignRefId_NOT?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignRefId_NOT_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<Scalars['String']['input']>;
  gradeGroup?: InputMaybe<Scalars['String']['input']>;
  gradeGroup_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  gradeGroup_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  gradeGroup_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  gradeGroup_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  gradeGroup_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  gradeGroup_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  gradeGroup_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  gradeGroup_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  gradeGroup_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  grade_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  grade_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  grade_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  grade_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  grade_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  grade_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  grade_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  grade_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  grade_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<GroupWhere>;
  groupAggregate?: InputMaybe<ClassGroupAggregateInput>;
  groupConnection?: InputMaybe<ClassGroupConnectionWhere>;
  groupConnection_NOT?: InputMaybe<ClassGroupConnectionWhere>;
  group_NOT?: InputMaybe<GroupWhere>;
  managedBy?: InputMaybe<Scalars['String']['input']>;
  managedBy_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  managedBy_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  managedBy_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  managedBy_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  managedBy_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  managedBy_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  managedBy_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  managedBy_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  managedBy_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `members_SOME` instead. */
  members?: InputMaybe<ProfileWhere>;
  membersAggregate?: InputMaybe<ClassMembersAggregateInput>;
  /** @deprecated Use `membersConnection_SOME` instead. */
  membersConnection?: InputMaybe<ClassMembersConnectionWhere>;
  /** Return Classes where all of the related ClassMembersConnections match this filter */
  membersConnection_ALL?: InputMaybe<ClassMembersConnectionWhere>;
  /** Return Classes where none of the related ClassMembersConnections match this filter */
  membersConnection_NONE?: InputMaybe<ClassMembersConnectionWhere>;
  /** @deprecated Use `membersConnection_NONE` instead. */
  membersConnection_NOT?: InputMaybe<ClassMembersConnectionWhere>;
  /** Return Classes where one of the related ClassMembersConnections match this filter */
  membersConnection_SINGLE?: InputMaybe<ClassMembersConnectionWhere>;
  /** Return Classes where some of the related ClassMembersConnections match this filter */
  membersConnection_SOME?: InputMaybe<ClassMembersConnectionWhere>;
  /** Return Classes where all of the related Profiles match this filter */
  members_ALL?: InputMaybe<ProfileWhere>;
  /** Return Classes where none of the related Profiles match this filter */
  members_NONE?: InputMaybe<ProfileWhere>;
  /** @deprecated Use `members_NONE` instead. */
  members_NOT?: InputMaybe<ProfileWhere>;
  /** Return Classes where one of the related Profiles match this filter */
  members_SINGLE?: InputMaybe<ProfileWhere>;
  /** Return Classes where some of the related Profiles match this filter */
  members_SOME?: InputMaybe<ProfileWhere>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<ClassOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<ClassOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<ClassOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  schoolYear?: InputMaybe<SchoolYearWhere>;
  schoolYearAggregate?: InputMaybe<ClassSchoolYearAggregateInput>;
  schoolYearConnection?: InputMaybe<ClassSchoolYearConnectionWhere>;
  schoolYearConnection_NOT?: InputMaybe<ClassSchoolYearConnectionWhere>;
  schoolYear_NOT?: InputMaybe<SchoolYearWhere>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  shortName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  shortName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  shortName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  shortName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `tutors_SOME` instead. */
  tutors?: InputMaybe<ProfileWhere>;
  tutorsAggregate?: InputMaybe<ClassTutorsAggregateInput>;
  /** @deprecated Use `tutorsConnection_SOME` instead. */
  tutorsConnection?: InputMaybe<ClassTutorsConnectionWhere>;
  /** Return Classes where all of the related ClassTutorsConnections match this filter */
  tutorsConnection_ALL?: InputMaybe<ClassTutorsConnectionWhere>;
  /** Return Classes where none of the related ClassTutorsConnections match this filter */
  tutorsConnection_NONE?: InputMaybe<ClassTutorsConnectionWhere>;
  /** @deprecated Use `tutorsConnection_NONE` instead. */
  tutorsConnection_NOT?: InputMaybe<ClassTutorsConnectionWhere>;
  /** Return Classes where one of the related ClassTutorsConnections match this filter */
  tutorsConnection_SINGLE?: InputMaybe<ClassTutorsConnectionWhere>;
  /** Return Classes where some of the related ClassTutorsConnections match this filter */
  tutorsConnection_SOME?: InputMaybe<ClassTutorsConnectionWhere>;
  /** Return Classes where all of the related Profiles match this filter */
  tutors_ALL?: InputMaybe<ProfileWhere>;
  /** Return Classes where none of the related Profiles match this filter */
  tutors_NONE?: InputMaybe<ProfileWhere>;
  /** @deprecated Use `tutors_NONE` instead. */
  tutors_NOT?: InputMaybe<ProfileWhere>;
  /** Return Classes where one of the related Profiles match this filter */
  tutors_SINGLE?: InputMaybe<ProfileWhere>;
  /** Return Classes where some of the related Profiles match this filter */
  tutors_SOME?: InputMaybe<ProfileWhere>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type ClassesConnection = {
  __typename?: 'ClassesConnection';
  edges: Array<ClassEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CollaboratingOrganizations = {
  __typename?: 'CollaboratingOrganizations';
  collaborationAdmins: Array<PimProfile>;
  collaborationStatus?: Maybe<CollaborationStatus>;
  groupAdmins: Array<PimProfile>;
  name: Scalars['String']['output'];
  sourceOrganization?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};

export enum CollaborationStatus {
  Collaboration = 'COLLABORATION',
  CollaborationCancelled = 'COLLABORATION_CANCELLED',
  NoCollaboration = 'NO_COLLABORATION',
  NoCollaborationPossible = 'NO_COLLABORATION_POSSIBLE',
  Pending = 'PENDING',
}

export type CreateAbsenceReasonsMutationResponse = {
  __typename?: 'CreateAbsenceReasonsMutationResponse';
  absenceReasons: Array<AbsenceReason>;
  info: CreateInfo;
};

export type CreateAbsencesMutationResponse = {
  __typename?: 'CreateAbsencesMutationResponse';
  absences: Array<Absence>;
  info: CreateInfo;
};

export type CreateAssignmentsMutationResponse = {
  __typename?: 'CreateAssignmentsMutationResponse';
  assignments: Array<Assignment>;
  info: CreateInfo;
};

export type CreateBigBlueButtonsMutationResponse = {
  __typename?: 'CreateBigBlueButtonsMutationResponse';
  bigBlueButtons: Array<BigBlueButton>;
  info: CreateInfo;
};

export type CreateBildungsplattformsMutationResponse = {
  __typename?: 'CreateBildungsplattformsMutationResponse';
  bildungsplattforms: Array<Bildungsplattform>;
  info: CreateInfo;
};

export type CreateCalendarEventsMutationResponse = {
  __typename?: 'CreateCalendarEventsMutationResponse';
  calendarEvents: Array<CalendarEvent>;
  info: CreateInfo;
};

export type CreateCalendarSubscriptionsMutationResponse = {
  __typename?: 'CreateCalendarSubscriptionsMutationResponse';
  calendarSubscriptions: Array<CalendarSubscription>;
  info: CreateInfo;
};

export type CreateClassGroupsMutationResponse = {
  __typename?: 'CreateClassGroupsMutationResponse';
  classGroups: Array<ClassGroup>;
  info: CreateInfo;
};

export type CreateClassesMutationResponse = {
  __typename?: 'CreateClassesMutationResponse';
  classes: Array<Class>;
  info: CreateInfo;
};

export type CreateDivisionsMutationResponse = {
  __typename?: 'CreateDivisionsMutationResponse';
  divisions: Array<Division>;
  info: CreateInfo;
};

export type CreateFileEntriesMutationResponse = {
  __typename?: 'CreateFileEntriesMutationResponse';
  fileEntries: Array<FileEntry>;
  info: CreateInfo;
};

/** Information about the number of nodes and relationships created during a create mutation */
export type CreateInfo = {
  __typename?: 'CreateInfo';
  nodesCreated: Scalars['Int']['output'];
  relationshipsCreated: Scalars['Int']['output'];
};

export type CreateLocationsMutationResponse = {
  __typename?: 'CreateLocationsMutationResponse';
  info: CreateInfo;
  locations: Array<Location>;
};

export type CreateMaterialsMutationResponse = {
  __typename?: 'CreateMaterialsMutationResponse';
  info: CreateInfo;
  materials: Array<Material>;
};

export type CreateNextcloudsMutationResponse = {
  __typename?: 'CreateNextcloudsMutationResponse';
  info: CreateInfo;
  nextclouds: Array<Nextcloud>;
};

export type CreateNotificationSettingsMutationResponse = {
  __typename?: 'CreateNotificationSettingsMutationResponse';
  info: CreateInfo;
  notificationSettings: Array<NotificationSettings>;
};

export type CreateOrganizationsMutationResponse = {
  __typename?: 'CreateOrganizationsMutationResponse';
  info: CreateInfo;
  organizations: Array<Organization>;
};

export type CreatePreferencesMutationResponse = {
  __typename?: 'CreatePreferencesMutationResponse';
  info: CreateInfo;
  preferences: Array<Preference>;
};

export type CreateProfilesMutationResponse = {
  __typename?: 'CreateProfilesMutationResponse';
  info: CreateInfo;
  profiles: Array<Profile>;
};

export type CreateRecurrenceRulesMutationResponse = {
  __typename?: 'CreateRecurrenceRulesMutationResponse';
  info: CreateInfo;
  recurrenceRules: Array<RecurrenceRule>;
};

export type CreateSubmissionsMutationResponse = {
  __typename?: 'CreateSubmissionsMutationResponse';
  info: CreateInfo;
  submissions: Array<Submission>;
};

export type CreateTeachingTopicsMutationResponse = {
  __typename?: 'CreateTeachingTopicsMutationResponse';
  info: CreateInfo;
  teachingTopics: Array<TeachingTopic>;
};

export type CreateTeachingUnitsMutationResponse = {
  __typename?: 'CreateTeachingUnitsMutationResponse';
  info: CreateInfo;
  teachingUnits: Array<TeachingUnit>;
};

export type CreateThreemaBroadcastsMutationResponse = {
  __typename?: 'CreateThreemaBroadcastsMutationResponse';
  info: CreateInfo;
  threemaBroadcasts: Array<ThreemaBroadcast>;
};

export type CreateThreemasMutationResponse = {
  __typename?: 'CreateThreemasMutationResponse';
  info: CreateInfo;
  threemas: Array<Threema>;
};

export type CreateVirtualLocationsMutationResponse = {
  __typename?: 'CreateVirtualLocationsMutationResponse';
  info: CreateInfo;
  virtualLocations: Array<VirtualLocation>;
};

export type CreateWorkMaterialsMutationResponse = {
  __typename?: 'CreateWorkMaterialsMutationResponse';
  info: CreateInfo;
  workMaterials: Array<WorkMaterial>;
};

export type CreateZoomsMutationResponse = {
  __typename?: 'CreateZoomsMutationResponse';
  info: CreateInfo;
  zooms: Array<Zoom>;
};

export type DateTimeAggregateSelection = {
  __typename?: 'DateTimeAggregateSelection';
  max?: Maybe<Scalars['DateTime']['output']>;
  min?: Maybe<Scalars['DateTime']['output']>;
};

export type Day = {
  __typename?: 'Day';
  date: Scalars['String']['output'];
  day: Scalars['Int']['output'];
  dayOfWeek: Scalars['Int']['output'];
  month: Scalars['Int']['output'];
  nextDay?: Maybe<Day>;
  nextDayConnection: DayNextDayConnection;
  previousDay?: Maybe<Day>;
  previousDayConnection: DayPreviousDayConnection;
  schoolDay: Scalars['Boolean']['output'];
  uuid: Scalars['ID']['output'];
  week: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type DayNextDayArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DayOptions>;
  where?: InputMaybe<DayWhere>;
};

export type DayNextDayConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DayNextDayConnectionSort>>;
  where?: InputMaybe<DayNextDayConnectionWhere>;
};

export type DayPreviousDayArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DayOptions>;
  where?: InputMaybe<DayWhere>;
};

export type DayPreviousDayConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DayPreviousDayConnectionSort>>;
  where?: InputMaybe<DayPreviousDayConnectionWhere>;
};

export type DayAggregateSelection = {
  __typename?: 'DayAggregateSelection';
  count: Scalars['Int']['output'];
  date: StringAggregateSelection;
  day: IntAggregateSelection;
  dayOfWeek: IntAggregateSelection;
  month: IntAggregateSelection;
  uuid: IdAggregateSelection;
  week: IntAggregateSelection;
  year: IntAggregateSelection;
};

export type DayConnectInput = {
  nextDay?: InputMaybe<DayNextDayConnectFieldInput>;
  previousDay?: InputMaybe<DayPreviousDayConnectFieldInput>;
};

export type DayConnectOrCreateWhere = {
  node: DayUniqueWhere;
};

export type DayConnectWhere = {
  node: DayWhere;
};

export type DayCreateInput = {
  date: Scalars['String']['input'];
  day: Scalars['Int']['input'];
  dayOfWeek: Scalars['Int']['input'];
  month: Scalars['Int']['input'];
  nextDay?: InputMaybe<DayNextDayFieldInput>;
  previousDay?: InputMaybe<DayPreviousDayFieldInput>;
  schoolDay: Scalars['Boolean']['input'];
  week: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type DayDeleteInput = {
  nextDay?: InputMaybe<DayNextDayDeleteFieldInput>;
  previousDay?: InputMaybe<DayPreviousDayDeleteFieldInput>;
};

export type DayDisconnectInput = {
  nextDay?: InputMaybe<DayNextDayDisconnectFieldInput>;
  previousDay?: InputMaybe<DayPreviousDayDisconnectFieldInput>;
};

export type DayEdge = {
  __typename?: 'DayEdge';
  cursor: Scalars['String']['output'];
  node: Day;
};

export type DayNextDayAggregateInput = {
  AND?: InputMaybe<Array<DayNextDayAggregateInput>>;
  NOT?: InputMaybe<DayNextDayAggregateInput>;
  OR?: InputMaybe<Array<DayNextDayAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DayNextDayNodeAggregationWhereInput>;
};

export type DayNextDayConnectFieldInput = {
  connect?: InputMaybe<DayConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<DayConnectWhere>;
};

export type DayNextDayConnectOrCreateFieldInput = {
  onCreate: DayNextDayConnectOrCreateFieldInputOnCreate;
  where: DayConnectOrCreateWhere;
};

export type DayNextDayConnectOrCreateFieldInputOnCreate = {
  node: DayOnCreateInput;
};

export type DayNextDayConnection = {
  __typename?: 'DayNextDayConnection';
  edges: Array<DayNextDayRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DayNextDayConnectionSort = {
  node?: InputMaybe<DaySort>;
};

export type DayNextDayConnectionWhere = {
  AND?: InputMaybe<Array<DayNextDayConnectionWhere>>;
  NOT?: InputMaybe<DayNextDayConnectionWhere>;
  OR?: InputMaybe<Array<DayNextDayConnectionWhere>>;
  node?: InputMaybe<DayWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<DayWhere>;
};

export type DayNextDayCreateFieldInput = {
  node: DayCreateInput;
};

export type DayNextDayDeleteFieldInput = {
  delete?: InputMaybe<DayDeleteInput>;
  where?: InputMaybe<DayNextDayConnectionWhere>;
};

export type DayNextDayDisconnectFieldInput = {
  disconnect?: InputMaybe<DayDisconnectInput>;
  where?: InputMaybe<DayNextDayConnectionWhere>;
};

export type DayNextDayFieldInput = {
  connect?: InputMaybe<DayNextDayConnectFieldInput>;
  connectOrCreate?: InputMaybe<DayNextDayConnectOrCreateFieldInput>;
  create?: InputMaybe<DayNextDayCreateFieldInput>;
};

export type DayNextDayNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DayNextDayNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DayNextDayNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DayNextDayNodeAggregationWhereInput>>;
  date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  day_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  day_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  day_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  day_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  day_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  day_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  day_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  day_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  day_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  day_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  month_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  month_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  month_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  month_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  month_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  month_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  month_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  month_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  month_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  month_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  week_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  week_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  week_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  week_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  week_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  week_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  week_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  week_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  week_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  week_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  year_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  year_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DayNextDayRelationship = {
  __typename?: 'DayNextDayRelationship';
  cursor: Scalars['String']['output'];
  node: Day;
};

export type DayNextDayUpdateConnectionInput = {
  node?: InputMaybe<DayUpdateInput>;
};

export type DayNextDayUpdateFieldInput = {
  connect?: InputMaybe<DayNextDayConnectFieldInput>;
  connectOrCreate?: InputMaybe<DayNextDayConnectOrCreateFieldInput>;
  create?: InputMaybe<DayNextDayCreateFieldInput>;
  delete?: InputMaybe<DayNextDayDeleteFieldInput>;
  disconnect?: InputMaybe<DayNextDayDisconnectFieldInput>;
  update?: InputMaybe<DayNextDayUpdateConnectionInput>;
  where?: InputMaybe<DayNextDayConnectionWhere>;
};

export type DayOnCreateInput = {
  date: Scalars['String']['input'];
  day: Scalars['Int']['input'];
  dayOfWeek: Scalars['Int']['input'];
  month: Scalars['Int']['input'];
  schoolDay: Scalars['Boolean']['input'];
  week: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type DayOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DaySort objects to sort Days by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DaySort>>;
};

export type DayPreviousDayAggregateInput = {
  AND?: InputMaybe<Array<DayPreviousDayAggregateInput>>;
  NOT?: InputMaybe<DayPreviousDayAggregateInput>;
  OR?: InputMaybe<Array<DayPreviousDayAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DayPreviousDayNodeAggregationWhereInput>;
};

export type DayPreviousDayConnectFieldInput = {
  connect?: InputMaybe<DayConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<DayConnectWhere>;
};

export type DayPreviousDayConnectOrCreateFieldInput = {
  onCreate: DayPreviousDayConnectOrCreateFieldInputOnCreate;
  where: DayConnectOrCreateWhere;
};

export type DayPreviousDayConnectOrCreateFieldInputOnCreate = {
  node: DayOnCreateInput;
};

export type DayPreviousDayConnection = {
  __typename?: 'DayPreviousDayConnection';
  edges: Array<DayPreviousDayRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DayPreviousDayConnectionSort = {
  node?: InputMaybe<DaySort>;
};

export type DayPreviousDayConnectionWhere = {
  AND?: InputMaybe<Array<DayPreviousDayConnectionWhere>>;
  NOT?: InputMaybe<DayPreviousDayConnectionWhere>;
  OR?: InputMaybe<Array<DayPreviousDayConnectionWhere>>;
  node?: InputMaybe<DayWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<DayWhere>;
};

export type DayPreviousDayCreateFieldInput = {
  node: DayCreateInput;
};

export type DayPreviousDayDeleteFieldInput = {
  delete?: InputMaybe<DayDeleteInput>;
  where?: InputMaybe<DayPreviousDayConnectionWhere>;
};

export type DayPreviousDayDisconnectFieldInput = {
  disconnect?: InputMaybe<DayDisconnectInput>;
  where?: InputMaybe<DayPreviousDayConnectionWhere>;
};

export type DayPreviousDayFieldInput = {
  connect?: InputMaybe<DayPreviousDayConnectFieldInput>;
  connectOrCreate?: InputMaybe<DayPreviousDayConnectOrCreateFieldInput>;
  create?: InputMaybe<DayPreviousDayCreateFieldInput>;
};

export type DayPreviousDayNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DayPreviousDayNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DayPreviousDayNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DayPreviousDayNodeAggregationWhereInput>>;
  date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  day_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  day_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  day_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  day_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  day_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  day_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  day_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  day_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  day_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  day_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  month_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  month_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  month_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  month_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  month_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  month_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  month_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  month_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  month_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  month_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  week_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  week_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  week_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  week_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  week_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  week_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  week_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  week_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  week_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  week_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  year_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  year_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DayPreviousDayRelationship = {
  __typename?: 'DayPreviousDayRelationship';
  cursor: Scalars['String']['output'];
  node: Day;
};

export type DayPreviousDayUpdateConnectionInput = {
  node?: InputMaybe<DayUpdateInput>;
};

export type DayPreviousDayUpdateFieldInput = {
  connect?: InputMaybe<DayPreviousDayConnectFieldInput>;
  connectOrCreate?: InputMaybe<DayPreviousDayConnectOrCreateFieldInput>;
  create?: InputMaybe<DayPreviousDayCreateFieldInput>;
  delete?: InputMaybe<DayPreviousDayDeleteFieldInput>;
  disconnect?: InputMaybe<DayPreviousDayDisconnectFieldInput>;
  update?: InputMaybe<DayPreviousDayUpdateConnectionInput>;
  where?: InputMaybe<DayPreviousDayConnectionWhere>;
};

/**
 * The edge properties for the following fields:
 * * WorkMaterial.visibleFrom
 * * WorkMaterial.visibleTo
 * * Assignment.visibleFrom
 * * Assignment.dueDate
 */
export type DayRelationProperties = {
  __typename?: 'DayRelationProperties';
  notified?: Maybe<Scalars['Boolean']['output']>;
};

export type DayRelationPropertiesCreateInput = {
  notified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DayRelationPropertiesSort = {
  notified?: InputMaybe<SortDirection>;
};

export type DayRelationPropertiesUpdateInput = {
  notified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DayRelationPropertiesWhere = {
  AND?: InputMaybe<Array<DayRelationPropertiesWhere>>;
  NOT?: InputMaybe<DayRelationPropertiesWhere>;
  OR?: InputMaybe<Array<DayRelationPropertiesWhere>>;
  notified?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  notified_NOT?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Fields to sort Days by. The order in which sorts are applied is not guaranteed when specifying many fields in one DaySort object. */
export type DaySort = {
  date?: InputMaybe<SortDirection>;
  day?: InputMaybe<SortDirection>;
  dayOfWeek?: InputMaybe<SortDirection>;
  month?: InputMaybe<SortDirection>;
  schoolDay?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
  week?: InputMaybe<SortDirection>;
  year?: InputMaybe<SortDirection>;
};

export type DayUniqueWhere = {
  date?: InputMaybe<Scalars['String']['input']>;
};

export type DayUpdateInput = {
  date?: InputMaybe<Scalars['String']['input']>;
  day?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  day_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  day_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  month?: InputMaybe<Scalars['Int']['input']>;
  month_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  month_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  nextDay?: InputMaybe<DayNextDayUpdateFieldInput>;
  previousDay?: InputMaybe<DayPreviousDayUpdateFieldInput>;
  schoolDay?: InputMaybe<Scalars['Boolean']['input']>;
  week?: InputMaybe<Scalars['Int']['input']>;
  week_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  week_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
  year_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  year_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
};

export type DayWhere = {
  AND?: InputMaybe<Array<DayWhere>>;
  NOT?: InputMaybe<DayWhere>;
  OR?: InputMaybe<Array<DayWhere>>;
  date?: InputMaybe<Scalars['String']['input']>;
  date_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  date_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  date_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  date_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  date_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  date_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  date_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  date_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  date_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  day?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_GT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_GTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  dayOfWeek_LT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  dayOfWeek_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  dayOfWeek_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  day_GT?: InputMaybe<Scalars['Int']['input']>;
  day_GTE?: InputMaybe<Scalars['Int']['input']>;
  day_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  day_LT?: InputMaybe<Scalars['Int']['input']>;
  day_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  day_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  day_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  month?: InputMaybe<Scalars['Int']['input']>;
  month_GT?: InputMaybe<Scalars['Int']['input']>;
  month_GTE?: InputMaybe<Scalars['Int']['input']>;
  month_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  month_LT?: InputMaybe<Scalars['Int']['input']>;
  month_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  month_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  month_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  nextDay?: InputMaybe<DayWhere>;
  nextDayAggregate?: InputMaybe<DayNextDayAggregateInput>;
  nextDayConnection?: InputMaybe<DayNextDayConnectionWhere>;
  nextDayConnection_NOT?: InputMaybe<DayNextDayConnectionWhere>;
  nextDay_NOT?: InputMaybe<DayWhere>;
  previousDay?: InputMaybe<DayWhere>;
  previousDayAggregate?: InputMaybe<DayPreviousDayAggregateInput>;
  previousDayConnection?: InputMaybe<DayPreviousDayConnectionWhere>;
  previousDayConnection_NOT?: InputMaybe<DayPreviousDayConnectionWhere>;
  previousDay_NOT?: InputMaybe<DayWhere>;
  schoolDay?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  schoolDay_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  week?: InputMaybe<Scalars['Int']['input']>;
  week_GT?: InputMaybe<Scalars['Int']['input']>;
  week_GTE?: InputMaybe<Scalars['Int']['input']>;
  week_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  week_LT?: InputMaybe<Scalars['Int']['input']>;
  week_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  week_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  week_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  year?: InputMaybe<Scalars['Int']['input']>;
  year_GT?: InputMaybe<Scalars['Int']['input']>;
  year_GTE?: InputMaybe<Scalars['Int']['input']>;
  year_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  year_LT?: InputMaybe<Scalars['Int']['input']>;
  year_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  year_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  year_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type DaysConnection = {
  __typename?: 'DaysConnection';
  edges: Array<DayEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Information about the number of nodes and relationships deleted during a delete mutation */
export type DeleteInfo = {
  __typename?: 'DeleteInfo';
  nodesDeleted: Scalars['Int']['output'];
  relationshipsDeleted: Scalars['Int']['output'];
};

/**
 * The edge properties for the following fields:
 * * Profile.directMessages
 */
export type DirectMessageProperties = {
  __typename?: 'DirectMessageProperties';
  /** Persist the matrixRoomId to reduce load on Matrix */
  matrixRoomId?: Maybe<Scalars['String']['output']>;
};

export type DirectMessagePropertiesAggregationWhereInput = {
  AND?: InputMaybe<Array<DirectMessagePropertiesAggregationWhereInput>>;
  NOT?: InputMaybe<DirectMessagePropertiesAggregationWhereInput>;
  OR?: InputMaybe<Array<DirectMessagePropertiesAggregationWhereInput>>;
  matrixRoomId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DirectMessagePropertiesCreateInput = {
  matrixRoomId?: InputMaybe<Scalars['String']['input']>;
};

export type DirectMessagePropertiesSort = {
  matrixRoomId?: InputMaybe<SortDirection>;
};

export type DirectMessagePropertiesUpdateInput = {
  matrixRoomId?: InputMaybe<Scalars['String']['input']>;
};

export type DirectMessagePropertiesWhere = {
  AND?: InputMaybe<Array<DirectMessagePropertiesWhere>>;
  NOT?: InputMaybe<DirectMessagePropertiesWhere>;
  OR?: InputMaybe<Array<DirectMessagePropertiesWhere>>;
  matrixRoomId?: InputMaybe<Scalars['String']['input']>;
  matrixRoomId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  matrixRoomId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  matrixRoomId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  matrixRoomId_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  matrixRoomId_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  matrixRoomId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  matrixRoomId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  matrixRoomId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  matrixRoomId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type Division = {
  __typename?: 'Division';
  class: Class;
  classAggregate?: Maybe<DivisionClassClassAggregationSelection>;
  classConnection: DivisionClassConnection;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  foreignRefId?: Maybe<Array<Scalars['String']['output']>>;
  groups: Array<ClassGroup>;
  groupsAggregate?: Maybe<DivisionClassGroupGroupsAggregationSelection>;
  groupsConnection: DivisionGroupsConnection;
  managedBy: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organization: Organization;
  organizationConnection: DivisionOrganizationConnection;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['ID']['output'];
};

export type DivisionClassArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ClassOptions>;
  where?: InputMaybe<ClassWhere>;
};

export type DivisionClassAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ClassWhere>;
};

export type DivisionClassConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DivisionClassConnectionSort>>;
  where?: InputMaybe<DivisionClassConnectionWhere>;
};

export type DivisionGroupsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ClassGroupOptions>;
  where?: InputMaybe<ClassGroupWhere>;
};

export type DivisionGroupsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ClassGroupWhere>;
};

export type DivisionGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DivisionGroupsConnectionSort>>;
  where?: InputMaybe<DivisionGroupsConnectionWhere>;
};

export type DivisionOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type DivisionOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DivisionOrganizationConnectionSort>>;
  where?: InputMaybe<DivisionOrganizationConnectionWhere>;
};

export type DivisionAggregateSelection = {
  __typename?: 'DivisionAggregateSelection';
  count: Scalars['Int']['output'];
  createdAt: DateTimeAggregateSelection;
  managedBy: StringAggregateSelection;
  name: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type DivisionClassAggregateInput = {
  AND?: InputMaybe<Array<DivisionClassAggregateInput>>;
  NOT?: InputMaybe<DivisionClassAggregateInput>;
  OR?: InputMaybe<Array<DivisionClassAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DivisionClassNodeAggregationWhereInput>;
};

export type DivisionClassClassAggregationSelection = {
  __typename?: 'DivisionClassClassAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<DivisionClassClassNodeAggregateSelection>;
};

export type DivisionClassClassNodeAggregateSelection = {
  __typename?: 'DivisionClassClassNodeAggregateSelection';
  color: StringAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  grade: StringAggregateSelection;
  gradeGroup: StringAggregateSelection;
  managedBy: StringAggregateSelection;
  name: StringAggregateSelection;
  shortName: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type DivisionClassConnectFieldInput = {
  connect?: InputMaybe<ClassConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ClassConnectWhere>;
};

export type DivisionClassConnection = {
  __typename?: 'DivisionClassConnection';
  edges: Array<DivisionClassRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DivisionClassConnectionSort = {
  node?: InputMaybe<ClassSort>;
};

export type DivisionClassConnectionWhere = {
  AND?: InputMaybe<Array<DivisionClassConnectionWhere>>;
  NOT?: InputMaybe<DivisionClassConnectionWhere>;
  OR?: InputMaybe<Array<DivisionClassConnectionWhere>>;
  node?: InputMaybe<ClassWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ClassWhere>;
};

export type DivisionClassCreateFieldInput = {
  node: ClassCreateInput;
};

export type DivisionClassDeleteFieldInput = {
  delete?: InputMaybe<ClassDeleteInput>;
  where?: InputMaybe<DivisionClassConnectionWhere>;
};

export type DivisionClassDisconnectFieldInput = {
  disconnect?: InputMaybe<ClassDisconnectInput>;
  where?: InputMaybe<DivisionClassConnectionWhere>;
};

export type DivisionClassFieldInput = {
  connect?: InputMaybe<DivisionClassConnectFieldInput>;
  create?: InputMaybe<DivisionClassCreateFieldInput>;
};

export type DivisionClassGroupGroupsAggregationSelection = {
  __typename?: 'DivisionClassGroupGroupsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<DivisionClassGroupGroupsEdgeAggregateSelection>;
  node?: Maybe<DivisionClassGroupGroupsNodeAggregateSelection>;
};

export type DivisionClassGroupGroupsEdgeAggregateSelection = {
  __typename?: 'DivisionClassGroupGroupsEdgeAggregateSelection';
  order: IntAggregateSelection;
};

export type DivisionClassGroupGroupsNodeAggregateSelection = {
  __typename?: 'DivisionClassGroupGroupsNodeAggregateSelection';
  managedBy: StringAggregateSelection;
  name: StringAggregateSelection;
  shortName: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type DivisionClassNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DivisionClassNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DivisionClassNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DivisionClassNodeAggregationWhereInput>>;
  color_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  color_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  gradeGroup_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gradeGroup_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gradeGroup_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gradeGroup_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gradeGroup_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gradeGroup_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gradeGroup_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gradeGroup_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gradeGroup_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gradeGroup_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gradeGroup_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gradeGroup_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gradeGroup_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gradeGroup_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gradeGroup_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grade_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  grade_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  grade_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  grade_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grade_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  grade_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  grade_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  grade_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DivisionClassRelationship = {
  __typename?: 'DivisionClassRelationship';
  cursor: Scalars['String']['output'];
  node: Class;
};

export type DivisionClassUpdateConnectionInput = {
  node?: InputMaybe<ClassUpdateInput>;
};

export type DivisionClassUpdateFieldInput = {
  connect?: InputMaybe<DivisionClassConnectFieldInput>;
  create?: InputMaybe<DivisionClassCreateFieldInput>;
  delete?: InputMaybe<DivisionClassDeleteFieldInput>;
  disconnect?: InputMaybe<DivisionClassDisconnectFieldInput>;
  update?: InputMaybe<DivisionClassUpdateConnectionInput>;
  where?: InputMaybe<DivisionClassConnectionWhere>;
};

export type DivisionConnectInput = {
  class?: InputMaybe<DivisionClassConnectFieldInput>;
  groups?: InputMaybe<Array<DivisionGroupsConnectFieldInput>>;
  organization?: InputMaybe<DivisionOrganizationConnectFieldInput>;
};

export type DivisionConnectWhere = {
  node: DivisionWhere;
};

export type DivisionCreateInput = {
  class?: InputMaybe<DivisionClassFieldInput>;
  foreignRefId?: InputMaybe<Array<Scalars['String']['input']>>;
  groups?: InputMaybe<DivisionGroupsFieldInput>;
  managedBy: Scalars['String']['input'];
  name: Scalars['String']['input'];
  organization?: InputMaybe<DivisionOrganizationFieldInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DivisionDeleteInput = {
  class?: InputMaybe<DivisionClassDeleteFieldInput>;
  groups?: InputMaybe<Array<DivisionGroupsDeleteFieldInput>>;
  organization?: InputMaybe<DivisionOrganizationDeleteFieldInput>;
};

export type DivisionDisconnectInput = {
  class?: InputMaybe<DivisionClassDisconnectFieldInput>;
  groups?: InputMaybe<Array<DivisionGroupsDisconnectFieldInput>>;
  organization?: InputMaybe<DivisionOrganizationDisconnectFieldInput>;
};

export type DivisionEdge = {
  __typename?: 'DivisionEdge';
  cursor: Scalars['String']['output'];
  node: Division;
};

export type DivisionGroupsAggregateInput = {
  AND?: InputMaybe<Array<DivisionGroupsAggregateInput>>;
  NOT?: InputMaybe<DivisionGroupsAggregateInput>;
  OR?: InputMaybe<Array<DivisionGroupsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<OrderedRelationPropertiesAggregationWhereInput>;
  node?: InputMaybe<DivisionGroupsNodeAggregationWhereInput>;
};

export type DivisionGroupsConnectFieldInput = {
  connect?: InputMaybe<Array<ClassGroupConnectInput>>;
  edge: OrderedRelationPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ClassGroupConnectWhere>;
};

export type DivisionGroupsConnection = {
  __typename?: 'DivisionGroupsConnection';
  edges: Array<DivisionGroupsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DivisionGroupsConnectionSort = {
  edge?: InputMaybe<OrderedRelationPropertiesSort>;
  node?: InputMaybe<ClassGroupSort>;
};

export type DivisionGroupsConnectionWhere = {
  AND?: InputMaybe<Array<DivisionGroupsConnectionWhere>>;
  NOT?: InputMaybe<DivisionGroupsConnectionWhere>;
  OR?: InputMaybe<Array<DivisionGroupsConnectionWhere>>;
  edge?: InputMaybe<OrderedRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<OrderedRelationPropertiesWhere>;
  node?: InputMaybe<ClassGroupWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ClassGroupWhere>;
};

export type DivisionGroupsCreateFieldInput = {
  edge: OrderedRelationPropertiesCreateInput;
  node: ClassGroupCreateInput;
};

export type DivisionGroupsDeleteFieldInput = {
  delete?: InputMaybe<ClassGroupDeleteInput>;
  where?: InputMaybe<DivisionGroupsConnectionWhere>;
};

export type DivisionGroupsDisconnectFieldInput = {
  disconnect?: InputMaybe<ClassGroupDisconnectInput>;
  where?: InputMaybe<DivisionGroupsConnectionWhere>;
};

export type DivisionGroupsFieldInput = {
  connect?: InputMaybe<Array<DivisionGroupsConnectFieldInput>>;
  create?: InputMaybe<Array<DivisionGroupsCreateFieldInput>>;
};

export type DivisionGroupsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DivisionGroupsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DivisionGroupsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DivisionGroupsNodeAggregationWhereInput>>;
  managedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DivisionGroupsRelationship = {
  __typename?: 'DivisionGroupsRelationship';
  cursor: Scalars['String']['output'];
  node: ClassGroup;
  properties: OrderedRelationProperties;
};

export type DivisionGroupsUpdateConnectionInput = {
  edge?: InputMaybe<OrderedRelationPropertiesUpdateInput>;
  node?: InputMaybe<ClassGroupUpdateInput>;
};

export type DivisionGroupsUpdateFieldInput = {
  connect?: InputMaybe<Array<DivisionGroupsConnectFieldInput>>;
  create?: InputMaybe<Array<DivisionGroupsCreateFieldInput>>;
  delete?: InputMaybe<Array<DivisionGroupsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<DivisionGroupsDisconnectFieldInput>>;
  update?: InputMaybe<DivisionGroupsUpdateConnectionInput>;
  where?: InputMaybe<DivisionGroupsConnectionWhere>;
};

export type DivisionOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DivisionSort objects to sort Divisions by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DivisionSort>>;
};

export type DivisionOrganizationAggregateInput = {
  AND?: InputMaybe<Array<DivisionOrganizationAggregateInput>>;
  NOT?: InputMaybe<DivisionOrganizationAggregateInput>;
  OR?: InputMaybe<Array<DivisionOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DivisionOrganizationNodeAggregationWhereInput>;
};

export type DivisionOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type DivisionOrganizationConnectOrCreateFieldInput = {
  onCreate: DivisionOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type DivisionOrganizationConnectOrCreateFieldInputOnCreate = {
  node: OrganizationOnCreateInput;
};

export type DivisionOrganizationConnection = {
  __typename?: 'DivisionOrganizationConnection';
  edges: Array<DivisionOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DivisionOrganizationConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type DivisionOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<DivisionOrganizationConnectionWhere>>;
  NOT?: InputMaybe<DivisionOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<DivisionOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type DivisionOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type DivisionOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<DivisionOrganizationConnectionWhere>;
};

export type DivisionOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<DivisionOrganizationConnectionWhere>;
};

export type DivisionOrganizationFieldInput = {
  connect?: InputMaybe<DivisionOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<DivisionOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<DivisionOrganizationCreateFieldInput>;
};

export type DivisionOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DivisionOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DivisionOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DivisionOrganizationNodeAggregationWhereInput>>;
  aboutInfoLastUpdated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DivisionOrganizationRelationship = {
  __typename?: 'DivisionOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type DivisionOrganizationUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type DivisionOrganizationUpdateFieldInput = {
  connect?: InputMaybe<DivisionOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<DivisionOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<DivisionOrganizationCreateFieldInput>;
  delete?: InputMaybe<DivisionOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<DivisionOrganizationDisconnectFieldInput>;
  update?: InputMaybe<DivisionOrganizationUpdateConnectionInput>;
  where?: InputMaybe<DivisionOrganizationConnectionWhere>;
};

/** Fields to sort Divisions by. The order in which sorts are applied is not guaranteed when specifying many fields in one DivisionSort object. */
export type DivisionSort = {
  createdAt?: InputMaybe<SortDirection>;
  managedBy?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type DivisionUpdateInput = {
  class?: InputMaybe<DivisionClassUpdateFieldInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  foreignRefId?: InputMaybe<Array<Scalars['String']['input']>>;
  foreignRefId_POP?: InputMaybe<Scalars['Int']['input']>;
  foreignRefId_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
  groups?: InputMaybe<Array<DivisionGroupsUpdateFieldInput>>;
  managedBy?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<DivisionOrganizationUpdateFieldInput>;
};

export type DivisionWhere = {
  AND?: InputMaybe<Array<DivisionWhere>>;
  NOT?: InputMaybe<DivisionWhere>;
  OR?: InputMaybe<Array<DivisionWhere>>;
  class?: InputMaybe<ClassWhere>;
  classAggregate?: InputMaybe<DivisionClassAggregateInput>;
  classConnection?: InputMaybe<DivisionClassConnectionWhere>;
  classConnection_NOT?: InputMaybe<DivisionClassConnectionWhere>;
  class_NOT?: InputMaybe<ClassWhere>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  foreignRefId?: InputMaybe<Array<Scalars['String']['input']>>;
  foreignRefId_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignRefId_NOT?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignRefId_NOT_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `groups_SOME` instead. */
  groups?: InputMaybe<ClassGroupWhere>;
  groupsAggregate?: InputMaybe<DivisionGroupsAggregateInput>;
  /** @deprecated Use `groupsConnection_SOME` instead. */
  groupsConnection?: InputMaybe<DivisionGroupsConnectionWhere>;
  /** Return Divisions where all of the related DivisionGroupsConnections match this filter */
  groupsConnection_ALL?: InputMaybe<DivisionGroupsConnectionWhere>;
  /** Return Divisions where none of the related DivisionGroupsConnections match this filter */
  groupsConnection_NONE?: InputMaybe<DivisionGroupsConnectionWhere>;
  /** @deprecated Use `groupsConnection_NONE` instead. */
  groupsConnection_NOT?: InputMaybe<DivisionGroupsConnectionWhere>;
  /** Return Divisions where one of the related DivisionGroupsConnections match this filter */
  groupsConnection_SINGLE?: InputMaybe<DivisionGroupsConnectionWhere>;
  /** Return Divisions where some of the related DivisionGroupsConnections match this filter */
  groupsConnection_SOME?: InputMaybe<DivisionGroupsConnectionWhere>;
  /** Return Divisions where all of the related ClassGroups match this filter */
  groups_ALL?: InputMaybe<ClassGroupWhere>;
  /** Return Divisions where none of the related ClassGroups match this filter */
  groups_NONE?: InputMaybe<ClassGroupWhere>;
  /** @deprecated Use `groups_NONE` instead. */
  groups_NOT?: InputMaybe<ClassGroupWhere>;
  /** Return Divisions where one of the related ClassGroups match this filter */
  groups_SINGLE?: InputMaybe<ClassGroupWhere>;
  /** Return Divisions where some of the related ClassGroups match this filter */
  groups_SOME?: InputMaybe<ClassGroupWhere>;
  managedBy?: InputMaybe<Scalars['String']['input']>;
  managedBy_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  managedBy_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  managedBy_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  managedBy_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  managedBy_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  managedBy_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  managedBy_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  managedBy_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  managedBy_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<DivisionOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<DivisionOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<DivisionOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type DivisionsConnection = {
  __typename?: 'DivisionsConnection';
  edges: Array<DivisionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EntitiesDeleteInfo = {
  __typename?: 'EntitiesDeleteInfo';
  entitiesDeleted: Scalars['Int']['output'];
};

export type EntitiesUpdateInfo = {
  __typename?: 'EntitiesUpdateInfo';
  entitiesUpdated: Scalars['Int']['output'];
};

/**
 * The edge properties for the following fields:
 * * Profile.attendsEvents
 * * CalendarEvent.attendees
 */
export type EventAttendeesProperties = {
  __typename?: 'EventAttendeesProperties';
  canStartVirtualEvent?: Maybe<Scalars['Boolean']['output']>;
  classbookComment?: Maybe<Scalars['String']['output']>;
};

export type EventAttendeesPropertiesAggregationWhereInput = {
  AND?: InputMaybe<Array<EventAttendeesPropertiesAggregationWhereInput>>;
  NOT?: InputMaybe<EventAttendeesPropertiesAggregationWhereInput>;
  OR?: InputMaybe<Array<EventAttendeesPropertiesAggregationWhereInput>>;
  classbookComment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classbookComment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classbookComment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classbookComment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classbookComment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classbookComment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classbookComment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classbookComment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classbookComment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classbookComment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classbookComment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classbookComment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classbookComment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classbookComment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classbookComment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type EventAttendeesPropertiesCreateInput = {
  canStartVirtualEvent?: InputMaybe<Scalars['Boolean']['input']>;
  classbookComment?: InputMaybe<Scalars['String']['input']>;
};

export type EventAttendeesPropertiesSort = {
  canStartVirtualEvent?: InputMaybe<SortDirection>;
  classbookComment?: InputMaybe<SortDirection>;
};

export type EventAttendeesPropertiesUpdateInput = {
  canStartVirtualEvent?: InputMaybe<Scalars['Boolean']['input']>;
  classbookComment?: InputMaybe<Scalars['String']['input']>;
};

export type EventAttendeesPropertiesWhere = {
  AND?: InputMaybe<Array<EventAttendeesPropertiesWhere>>;
  NOT?: InputMaybe<EventAttendeesPropertiesWhere>;
  OR?: InputMaybe<Array<EventAttendeesPropertiesWhere>>;
  canStartVirtualEvent?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  canStartVirtualEvent_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  classbookComment?: InputMaybe<Scalars['String']['input']>;
  classbookComment_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  classbookComment_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  classbookComment_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  classbookComment_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  classbookComment_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  classbookComment_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  classbookComment_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  classbookComment_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  classbookComment_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

/**
 * The edge properties for the following fields:
 * * CalendarEvent.holder
 */
export type EventHolderProperties = {
  __typename?: 'EventHolderProperties';
  hasTakenPlace?: Maybe<Scalars['Boolean']['output']>;
  homeworks?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
};

export type EventHolderPropertiesCreateInput = {
  hasTakenPlace?: InputMaybe<Scalars['Boolean']['input']>;
  homeworks?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type EventHolderPropertiesSort = {
  hasTakenPlace?: InputMaybe<SortDirection>;
  homeworks?: InputMaybe<SortDirection>;
  notes?: InputMaybe<SortDirection>;
};

export type EventHolderPropertiesUpdateInput = {
  hasTakenPlace?: InputMaybe<Scalars['Boolean']['input']>;
  homeworks?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type EventHolderPropertiesWhere = {
  AND?: InputMaybe<Array<EventHolderPropertiesWhere>>;
  NOT?: InputMaybe<EventHolderPropertiesWhere>;
  OR?: InputMaybe<Array<EventHolderPropertiesWhere>>;
  hasTakenPlace?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  hasTakenPlace_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  homeworks?: InputMaybe<Scalars['String']['input']>;
  homeworks_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  homeworks_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  homeworks_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  homeworks_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  homeworks_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  homeworks_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  homeworks_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  homeworks_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  homeworks_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notes_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  notes_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  notes_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  notes_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  notes_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  notes_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  notes_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  notes_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  notes_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export enum EventRecurrence {
  Daily = 'daily',
  Monthly = 'monthly',
  Weekly = 'weekly',
  Workdays = 'workdays',
  Yearly = 'yearly',
}

export type ExternalServices = {
  __typename?: 'ExternalServices';
  bbb?: Maybe<Scalars['Boolean']['output']>;
  mailbox?: Maybe<ExternalServicesStatus>;
  matrix?: Maybe<Scalars['Boolean']['output']>;
  nextcloud?: Maybe<ExternalServicesStatus>;
  threema?: Maybe<ExternalServicesStatus>;
  zoom?: Maybe<ExternalServicesStatus>;
};

export type ExternalServicesStatus = {
  __typename?: 'ExternalServicesStatus';
  enabled: Scalars['Boolean']['output'];
  lastSync?: Maybe<Scalars['DateTime']['output']>;
};

export type FileEntry = {
  __typename?: 'FileEntry';
  created: Scalars['DateTime']['output'];
  downloadToken: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  /**
   * The entity that holds this file entry. May be null initially, to
   * allow uploading files before the holder entity is created
   */
  holder?: Maybe<FileEntryHolder>;
  holderConnection: FileEntryHolderConnection;
  mediaType: Scalars['String']['output'];
  /**
   * FileEntry requires an explicit organization as it can exist
   * without a holder.
   */
  organization: Organization;
  organizationAggregate?: Maybe<FileEntryOrganizationOrganizationAggregationSelection>;
  organizationConnection: FileEntryOrganizationConnection;
  /**
   * FileEntry requires an explicit owner profile as it can exist
   * without a holder.
   */
  owner: Profile;
  ownerAggregate?: Maybe<FileEntryProfileOwnerAggregationSelection>;
  ownerConnection: FileEntryOwnerConnection;
  publicDownloadToken?: Maybe<Scalars['String']['output']>;
  size: Scalars['Int']['output'];
  updated: Scalars['DateTime']['output'];
  uuid: Scalars['ID']['output'];
};

export type FileEntryHolderArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<FileEntryHolderWhere>;
};

export type FileEntryHolderConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FileEntryHolderConnectionWhere>;
};

export type FileEntryOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type FileEntryOrganizationAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OrganizationWhere>;
};

export type FileEntryOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FileEntryOrganizationConnectionSort>>;
  where?: InputMaybe<FileEntryOrganizationConnectionWhere>;
};

export type FileEntryOwnerArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ProfileOptions>;
  where?: InputMaybe<ProfileWhere>;
};

export type FileEntryOwnerAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProfileWhere>;
};

export type FileEntryOwnerConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FileEntryOwnerConnectionSort>>;
  where?: InputMaybe<FileEntryOwnerConnectionWhere>;
};

export type FileEntryConnectInput = {
  holder?: InputMaybe<FileEntryHolderConnectInput>;
  organization?: InputMaybe<FileEntryOrganizationConnectFieldInput>;
  owner?: InputMaybe<FileEntryOwnerConnectFieldInput>;
};

export type FileEntryConnectWhere = {
  node: FileEntryWhere;
};

export type FileEntryCreateInput = {
  filename: Scalars['String']['input'];
  holder?: InputMaybe<FileEntryHolderCreateInput>;
  mediaType: Scalars['String']['input'];
  organization?: InputMaybe<FileEntryOrganizationFieldInput>;
  owner?: InputMaybe<FileEntryOwnerFieldInput>;
  size: Scalars['Int']['input'];
};

export type FileEntryDeleteInput = {
  holder?: InputMaybe<FileEntryHolderDeleteInput>;
  organization?: InputMaybe<FileEntryOrganizationDeleteFieldInput>;
  owner?: InputMaybe<FileEntryOwnerDeleteFieldInput>;
};

export type FileEntryDisconnectInput = {
  holder?: InputMaybe<FileEntryHolderDisconnectInput>;
  organization?: InputMaybe<FileEntryOrganizationDisconnectFieldInput>;
  owner?: InputMaybe<FileEntryOwnerDisconnectFieldInput>;
};

export type FileEntryHolder = Material;

export type FileEntryHolderConnectInput = {
  Material?: InputMaybe<FileEntryHolderMaterialConnectFieldInput>;
};

export type FileEntryHolderConnection = {
  __typename?: 'FileEntryHolderConnection';
  edges: Array<FileEntryHolderRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FileEntryHolderConnectionWhere = {
  Material?: InputMaybe<FileEntryHolderMaterialConnectionWhere>;
};

export type FileEntryHolderCreateInput = {
  Material?: InputMaybe<FileEntryHolderMaterialFieldInput>;
};

export type FileEntryHolderDeleteInput = {
  Material?: InputMaybe<FileEntryHolderMaterialDeleteFieldInput>;
};

export type FileEntryHolderDisconnectInput = {
  Material?: InputMaybe<FileEntryHolderMaterialDisconnectFieldInput>;
};

export type FileEntryHolderMaterialConnectFieldInput = {
  connect?: InputMaybe<MaterialConnectInput>;
  where?: InputMaybe<MaterialConnectWhere>;
};

export type FileEntryHolderMaterialConnectionWhere = {
  AND?: InputMaybe<Array<FileEntryHolderMaterialConnectionWhere>>;
  NOT?: InputMaybe<FileEntryHolderMaterialConnectionWhere>;
  OR?: InputMaybe<Array<FileEntryHolderMaterialConnectionWhere>>;
  node?: InputMaybe<MaterialWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<MaterialWhere>;
};

export type FileEntryHolderMaterialCreateFieldInput = {
  node: MaterialCreateInput;
};

export type FileEntryHolderMaterialDeleteFieldInput = {
  delete?: InputMaybe<MaterialDeleteInput>;
  where?: InputMaybe<FileEntryHolderMaterialConnectionWhere>;
};

export type FileEntryHolderMaterialDisconnectFieldInput = {
  disconnect?: InputMaybe<MaterialDisconnectInput>;
  where?: InputMaybe<FileEntryHolderMaterialConnectionWhere>;
};

export type FileEntryHolderMaterialFieldInput = {
  connect?: InputMaybe<FileEntryHolderMaterialConnectFieldInput>;
  create?: InputMaybe<FileEntryHolderMaterialCreateFieldInput>;
};

export type FileEntryHolderMaterialUpdateConnectionInput = {
  node?: InputMaybe<MaterialUpdateInput>;
};

export type FileEntryHolderMaterialUpdateFieldInput = {
  connect?: InputMaybe<FileEntryHolderMaterialConnectFieldInput>;
  create?: InputMaybe<FileEntryHolderMaterialCreateFieldInput>;
  delete?: InputMaybe<FileEntryHolderMaterialDeleteFieldInput>;
  disconnect?: InputMaybe<FileEntryHolderMaterialDisconnectFieldInput>;
  update?: InputMaybe<FileEntryHolderMaterialUpdateConnectionInput>;
  where?: InputMaybe<FileEntryHolderMaterialConnectionWhere>;
};

export type FileEntryHolderRelationship = {
  __typename?: 'FileEntryHolderRelationship';
  cursor: Scalars['String']['output'];
  node: FileEntryHolder;
};

export type FileEntryHolderUpdateInput = {
  Material?: InputMaybe<FileEntryHolderMaterialUpdateFieldInput>;
};

export type FileEntryHolderWhere = {
  Material?: InputMaybe<MaterialWhere>;
};

export type FileEntryOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more FileEntrySort objects to sort FileEntries by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<FileEntrySort>>;
};

export type FileEntryOrganizationAggregateInput = {
  AND?: InputMaybe<Array<FileEntryOrganizationAggregateInput>>;
  NOT?: InputMaybe<FileEntryOrganizationAggregateInput>;
  OR?: InputMaybe<Array<FileEntryOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FileEntryOrganizationNodeAggregationWhereInput>;
};

export type FileEntryOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type FileEntryOrganizationConnectOrCreateFieldInput = {
  onCreate: FileEntryOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type FileEntryOrganizationConnectOrCreateFieldInputOnCreate = {
  node: OrganizationOnCreateInput;
};

export type FileEntryOrganizationConnection = {
  __typename?: 'FileEntryOrganizationConnection';
  edges: Array<FileEntryOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FileEntryOrganizationConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type FileEntryOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<FileEntryOrganizationConnectionWhere>>;
  NOT?: InputMaybe<FileEntryOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<FileEntryOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type FileEntryOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type FileEntryOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<FileEntryOrganizationConnectionWhere>;
};

export type FileEntryOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<FileEntryOrganizationConnectionWhere>;
};

export type FileEntryOrganizationFieldInput = {
  connect?: InputMaybe<FileEntryOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<FileEntryOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<FileEntryOrganizationCreateFieldInput>;
};

export type FileEntryOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FileEntryOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FileEntryOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FileEntryOrganizationNodeAggregationWhereInput>>;
  aboutInfoLastUpdated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FileEntryOrganizationOrganizationAggregationSelection = {
  __typename?: 'FileEntryOrganizationOrganizationAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<FileEntryOrganizationOrganizationNodeAggregateSelection>;
};

export type FileEntryOrganizationOrganizationNodeAggregateSelection = {
  __typename?: 'FileEntryOrganizationOrganizationNodeAggregateSelection';
  aboutInfo: StringAggregateSelection;
  aboutInfoLastUpdated: DateTimeAggregateSelection;
  displayName: StringAggregateSelection;
  matrixRoomId: StringAggregateSelection;
  planungSyncProps: StringAggregateSelection;
  procuratSyncProps: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type FileEntryOrganizationRelationship = {
  __typename?: 'FileEntryOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type FileEntryOrganizationUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type FileEntryOrganizationUpdateFieldInput = {
  connect?: InputMaybe<FileEntryOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<FileEntryOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<FileEntryOrganizationCreateFieldInput>;
  delete?: InputMaybe<FileEntryOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<FileEntryOrganizationDisconnectFieldInput>;
  update?: InputMaybe<FileEntryOrganizationUpdateConnectionInput>;
  where?: InputMaybe<FileEntryOrganizationConnectionWhere>;
};

export type FileEntryOwnerAggregateInput = {
  AND?: InputMaybe<Array<FileEntryOwnerAggregateInput>>;
  NOT?: InputMaybe<FileEntryOwnerAggregateInput>;
  OR?: InputMaybe<Array<FileEntryOwnerAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FileEntryOwnerNodeAggregationWhereInput>;
};

export type FileEntryOwnerConnectFieldInput = {
  connect?: InputMaybe<ProfileConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ProfileConnectWhere>;
};

export type FileEntryOwnerConnectOrCreateFieldInput = {
  onCreate: FileEntryOwnerConnectOrCreateFieldInputOnCreate;
  where: ProfileConnectOrCreateWhere;
};

export type FileEntryOwnerConnectOrCreateFieldInputOnCreate = {
  node: ProfileOnCreateInput;
};

export type FileEntryOwnerConnection = {
  __typename?: 'FileEntryOwnerConnection';
  edges: Array<FileEntryOwnerRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FileEntryOwnerConnectionSort = {
  node?: InputMaybe<ProfileSort>;
};

export type FileEntryOwnerConnectionWhere = {
  AND?: InputMaybe<Array<FileEntryOwnerConnectionWhere>>;
  NOT?: InputMaybe<FileEntryOwnerConnectionWhere>;
  OR?: InputMaybe<Array<FileEntryOwnerConnectionWhere>>;
  node?: InputMaybe<ProfileWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ProfileWhere>;
};

export type FileEntryOwnerCreateFieldInput = {
  node: ProfileCreateInput;
};

export type FileEntryOwnerDeleteFieldInput = {
  delete?: InputMaybe<ProfileDeleteInput>;
  where?: InputMaybe<FileEntryOwnerConnectionWhere>;
};

export type FileEntryOwnerDisconnectFieldInput = {
  disconnect?: InputMaybe<ProfileDisconnectInput>;
  where?: InputMaybe<FileEntryOwnerConnectionWhere>;
};

export type FileEntryOwnerFieldInput = {
  connect?: InputMaybe<FileEntryOwnerConnectFieldInput>;
  connectOrCreate?: InputMaybe<FileEntryOwnerConnectOrCreateFieldInput>;
  create?: InputMaybe<FileEntryOwnerCreateFieldInput>;
};

export type FileEntryOwnerNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FileEntryOwnerNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FileEntryOwnerNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FileEntryOwnerNodeAggregationWhereInput>>;
  address1_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address1_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address2_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address2_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address3_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address3_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  birthday_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  userUuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  userUuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FileEntryOwnerRelationship = {
  __typename?: 'FileEntryOwnerRelationship';
  cursor: Scalars['String']['output'];
  node: Profile;
};

export type FileEntryOwnerUpdateConnectionInput = {
  node?: InputMaybe<ProfileUpdateInput>;
};

export type FileEntryOwnerUpdateFieldInput = {
  connect?: InputMaybe<FileEntryOwnerConnectFieldInput>;
  connectOrCreate?: InputMaybe<FileEntryOwnerConnectOrCreateFieldInput>;
  create?: InputMaybe<FileEntryOwnerCreateFieldInput>;
  delete?: InputMaybe<FileEntryOwnerDeleteFieldInput>;
  disconnect?: InputMaybe<FileEntryOwnerDisconnectFieldInput>;
  update?: InputMaybe<FileEntryOwnerUpdateConnectionInput>;
  where?: InputMaybe<FileEntryOwnerConnectionWhere>;
};

export type FileEntryProfileOwnerAggregationSelection = {
  __typename?: 'FileEntryProfileOwnerAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<FileEntryProfileOwnerNodeAggregateSelection>;
};

export type FileEntryProfileOwnerNodeAggregateSelection = {
  __typename?: 'FileEntryProfileOwnerNodeAggregateSelection';
  address1: StringAggregateSelection;
  address2: StringAggregateSelection;
  address3: StringAggregateSelection;
  birthday: StringAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  email: StringAggregateSelection;
  firstName: StringAggregateSelection;
  firstNames: StringAggregateSelection;
  lastName: StringAggregateSelection;
  managedBy: StringAggregateSelection;
  matrixToken: StringAggregateSelection;
  nextcloudUserId: StringAggregateSelection;
  prefixName: StringAggregateSelection;
  salutation: StringAggregateSelection;
  shortName: StringAggregateSelection;
  threemaId: StringAggregateSelection;
  title: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  userUuid: StringAggregateSelection;
  uuid: IdAggregateSelection;
  zoomUserId: StringAggregateSelection;
};

/** Fields to sort FileEntries by. The order in which sorts are applied is not guaranteed when specifying many fields in one FileEntrySort object. */
export type FileEntrySort = {
  created?: InputMaybe<SortDirection>;
  filename?: InputMaybe<SortDirection>;
  mediaType?: InputMaybe<SortDirection>;
  size?: InputMaybe<SortDirection>;
  updated?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type FileEntryUpdateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  holder?: InputMaybe<FileEntryHolderUpdateInput>;
  mediaType?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<FileEntryOrganizationUpdateFieldInput>;
  owner?: InputMaybe<FileEntryOwnerUpdateFieldInput>;
  size?: InputMaybe<Scalars['Int']['input']>;
  size_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  size_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
};

export type FileEntryWhere = {
  AND?: InputMaybe<Array<FileEntryWhere>>;
  NOT?: InputMaybe<FileEntryWhere>;
  OR?: InputMaybe<Array<FileEntryWhere>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  created_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  created_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  filename?: InputMaybe<Scalars['String']['input']>;
  filename_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  filename_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  filename_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  filename_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  filename_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  filename_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  filename_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  filename_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  filename_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  holder?: InputMaybe<FileEntryHolderWhere>;
  holderConnection?: InputMaybe<FileEntryHolderConnectionWhere>;
  holderConnection_NOT?: InputMaybe<FileEntryHolderConnectionWhere>;
  holder_NOT?: InputMaybe<FileEntryHolderWhere>;
  mediaType?: InputMaybe<Scalars['String']['input']>;
  mediaType_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  mediaType_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  mediaType_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mediaType_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mediaType_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mediaType_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mediaType_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mediaType_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  mediaType_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<FileEntryOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<FileEntryOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<FileEntryOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  owner?: InputMaybe<ProfileWhere>;
  ownerAggregate?: InputMaybe<FileEntryOwnerAggregateInput>;
  ownerConnection?: InputMaybe<FileEntryOwnerConnectionWhere>;
  ownerConnection_NOT?: InputMaybe<FileEntryOwnerConnectionWhere>;
  owner_NOT?: InputMaybe<ProfileWhere>;
  size?: InputMaybe<Scalars['Int']['input']>;
  size_GT?: InputMaybe<Scalars['Int']['input']>;
  size_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  size_LT?: InputMaybe<Scalars['Int']['input']>;
  size_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  size_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  size_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  updated_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updated_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updated_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updated_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type GlobalSubject = {
  __typename?: 'GlobalSubject';
  country: Scalars['String']['output'];
  states: Array<Scalars['String']['output']>;
  subject: Scalars['String']['output'];
};

export type GlobalSubjectsWhere = {
  country?: InputMaybe<Scalars['String']['input']>;
  foreignRefId?: InputMaybe<Array<Scalars['String']['input']>>;
  states_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type Group = {
  __typename?: 'Group';
  admins: Array<Profile>;
  adminsAggregate?: Maybe<GroupProfileAdminsAggregationSelection>;
  adminsConnection: GroupAdminsConnection;
  allowedProfileUuids: Array<Scalars['String']['output']>;
  classOrClassGroup: Array<ClassOrClassGroup>;
  classOrClassGroupConnection: GroupClassOrClassGroupConnection;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  editors: Array<Profile>;
  editorsAggregate?: Maybe<GroupProfileEditorsAggregationSelection>;
  editorsConnection: GroupEditorsConnection;
  /** All Events belonging to this group */
  events: Array<CalendarEvent>;
  eventsAggregate?: Maybe<GroupCalendarEventEventsAggregationSelection>;
  eventsConnection: GroupEventsConnection;
  externalServices?: Maybe<ExternalServices>;
  foreignRefId?: Maybe<Array<Scalars['String']['output']>>;
  /** Courses have grades */
  grades?: Maybe<Array<Scalars['String']['output']>>;
  /** if it is of type course it can have other groups */
  groups: Array<Group>;
  groupsAggregate?: Maybe<GroupGroupGroupsAggregationSelection>;
  groupsConnection: GroupGroupsConnection;
  inCurrentSchoolyear: Scalars['Boolean']['output'];
  isCommunity: Scalars['Boolean']['output'];
  managedBy: Scalars['String']['output'];
  /** Persist the matrixRoomId to reduce load on Matrix */
  matrixRoomId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nextcloud: Array<Nextcloud>;
  nextcloudAggregate?: Maybe<GroupNextcloudNextcloudAggregationSelection>;
  nextcloudConnection: GroupNextcloudConnection;
  organization: Organization;
  organizationConnection: GroupOrganizationConnection;
  schoolYear?: Maybe<SchoolYear>;
  schoolYearConnection: GroupSchoolYearConnection;
  subject?: Maybe<Subject>;
  subjectConnection: GroupSubjectConnection;
  teachingTopics: Array<TeachingTopic>;
  teachingTopicsAggregate?: Maybe<GroupTeachingTopicTeachingTopicsAggregationSelection>;
  teachingTopicsConnection: GroupTeachingTopicsConnection;
  teachingUnits: Array<TeachingUnit>;
  teachingUnitsAggregate?: Maybe<GroupTeachingUnitTeachingUnitsAggregationSelection>;
  teachingUnitsConnection: GroupTeachingUnitsConnection;
  threemaBroadcast: Array<ThreemaBroadcast>;
  threemaBroadcastAggregate?: Maybe<GroupThreemaBroadcastThreemaBroadcastAggregationSelection>;
  threemaBroadcastConnection: GroupThreemaBroadcastConnection;
  type: GroupType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['ID']['output'];
  viewers: Array<Profile>;
  viewersAggregate?: Maybe<GroupProfileViewersAggregationSelection>;
  viewersConnection: GroupViewersConnection;
};

export type GroupAdminsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ProfileOptions>;
  where?: InputMaybe<ProfileWhere>;
};

export type GroupAdminsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProfileWhere>;
};

export type GroupAdminsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<GroupAdminsConnectionSort>>;
  where?: InputMaybe<GroupAdminsConnectionWhere>;
};

export type GroupClassOrClassGroupArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<ClassOrClassGroupWhere>;
};

export type GroupClassOrClassGroupConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<GroupClassOrClassGroupConnectionSort>>;
  where?: InputMaybe<GroupClassOrClassGroupConnectionWhere>;
};

export type GroupEditorsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ProfileOptions>;
  where?: InputMaybe<ProfileWhere>;
};

export type GroupEditorsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProfileWhere>;
};

export type GroupEditorsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<GroupEditorsConnectionSort>>;
  where?: InputMaybe<GroupEditorsConnectionWhere>;
};

export type GroupEventsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CalendarEventOptions>;
  where?: InputMaybe<CalendarEventWhere>;
};

export type GroupEventsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CalendarEventWhere>;
};

export type GroupEventsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<GroupEventsConnectionSort>>;
  where?: InputMaybe<GroupEventsConnectionWhere>;
};

export type GroupGroupsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<GroupOptions>;
  where?: InputMaybe<GroupWhere>;
};

export type GroupGroupsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GroupWhere>;
};

export type GroupGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<GroupGroupsConnectionSort>>;
  where?: InputMaybe<GroupGroupsConnectionWhere>;
};

export type GroupNextcloudArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<NextcloudOptions>;
  where?: InputMaybe<NextcloudWhere>;
};

export type GroupNextcloudAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NextcloudWhere>;
};

export type GroupNextcloudConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<GroupNextcloudConnectionSort>>;
  where?: InputMaybe<GroupNextcloudConnectionWhere>;
};

export type GroupOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type GroupOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<GroupOrganizationConnectionSort>>;
  where?: InputMaybe<GroupOrganizationConnectionWhere>;
};

export type GroupSchoolYearArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SchoolYearOptions>;
  where?: InputMaybe<SchoolYearWhere>;
};

export type GroupSchoolYearConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<GroupSchoolYearConnectionSort>>;
  where?: InputMaybe<GroupSchoolYearConnectionWhere>;
};

export type GroupSubjectArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SubjectOptions>;
  where?: InputMaybe<SubjectWhere>;
};

export type GroupSubjectConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<GroupSubjectConnectionSort>>;
  where?: InputMaybe<GroupSubjectConnectionWhere>;
};

export type GroupTeachingTopicsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TeachingTopicOptions>;
  where?: InputMaybe<TeachingTopicWhere>;
};

export type GroupTeachingTopicsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TeachingTopicWhere>;
};

export type GroupTeachingTopicsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<GroupTeachingTopicsConnectionSort>>;
  where?: InputMaybe<GroupTeachingTopicsConnectionWhere>;
};

export type GroupTeachingUnitsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TeachingUnitOptions>;
  where?: InputMaybe<TeachingUnitWhere>;
};

export type GroupTeachingUnitsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TeachingUnitWhere>;
};

export type GroupTeachingUnitsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<GroupTeachingUnitsConnectionSort>>;
  where?: InputMaybe<GroupTeachingUnitsConnectionWhere>;
};

export type GroupThreemaBroadcastArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ThreemaBroadcastOptions>;
  where?: InputMaybe<ThreemaBroadcastWhere>;
};

export type GroupThreemaBroadcastAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ThreemaBroadcastWhere>;
};

export type GroupThreemaBroadcastConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<GroupThreemaBroadcastConnectionSort>>;
  where?: InputMaybe<GroupThreemaBroadcastConnectionWhere>;
};

export type GroupViewersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ProfileOptions>;
  where?: InputMaybe<ProfileWhere>;
};

export type GroupViewersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProfileWhere>;
};

export type GroupViewersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<GroupViewersConnectionSort>>;
  where?: InputMaybe<GroupViewersConnectionWhere>;
};

export type GroupAdminsAggregateInput = {
  AND?: InputMaybe<Array<GroupAdminsAggregateInput>>;
  NOT?: InputMaybe<GroupAdminsAggregateInput>;
  OR?: InputMaybe<Array<GroupAdminsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<GroupAdminsNodeAggregationWhereInput>;
};

export type GroupAdminsConnectFieldInput = {
  connect?: InputMaybe<Array<ProfileConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ProfileConnectWhere>;
};

export type GroupAdminsConnectOrCreateFieldInput = {
  onCreate: GroupAdminsConnectOrCreateFieldInputOnCreate;
  where: ProfileConnectOrCreateWhere;
};

export type GroupAdminsConnectOrCreateFieldInputOnCreate = {
  node: ProfileOnCreateInput;
};

export type GroupAdminsConnection = {
  __typename?: 'GroupAdminsConnection';
  edges: Array<GroupAdminsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GroupAdminsConnectionSort = {
  node?: InputMaybe<ProfileSort>;
};

export type GroupAdminsConnectionWhere = {
  AND?: InputMaybe<Array<GroupAdminsConnectionWhere>>;
  NOT?: InputMaybe<GroupAdminsConnectionWhere>;
  OR?: InputMaybe<Array<GroupAdminsConnectionWhere>>;
  node?: InputMaybe<ProfileWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ProfileWhere>;
};

export type GroupAdminsCreateFieldInput = {
  node: ProfileCreateInput;
};

export type GroupAdminsDeleteFieldInput = {
  delete?: InputMaybe<ProfileDeleteInput>;
  where?: InputMaybe<GroupAdminsConnectionWhere>;
};

export type GroupAdminsDisconnectFieldInput = {
  disconnect?: InputMaybe<ProfileDisconnectInput>;
  where?: InputMaybe<GroupAdminsConnectionWhere>;
};

export type GroupAdminsFieldInput = {
  connect?: InputMaybe<Array<GroupAdminsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<GroupAdminsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<GroupAdminsCreateFieldInput>>;
};

export type GroupAdminsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<GroupAdminsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<GroupAdminsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<GroupAdminsNodeAggregationWhereInput>>;
  address1_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address1_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address2_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address2_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address3_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address3_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  birthday_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  userUuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  userUuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type GroupAdminsRelationship = {
  __typename?: 'GroupAdminsRelationship';
  cursor: Scalars['String']['output'];
  node: Profile;
};

export type GroupAdminsUpdateConnectionInput = {
  node?: InputMaybe<ProfileUpdateInput>;
};

export type GroupAdminsUpdateFieldInput = {
  connect?: InputMaybe<Array<GroupAdminsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<GroupAdminsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<GroupAdminsCreateFieldInput>>;
  delete?: InputMaybe<Array<GroupAdminsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<GroupAdminsDisconnectFieldInput>>;
  update?: InputMaybe<GroupAdminsUpdateConnectionInput>;
  where?: InputMaybe<GroupAdminsConnectionWhere>;
};

export type GroupAggregateSelection = {
  __typename?: 'GroupAggregateSelection';
  count: Scalars['Int']['output'];
  createdAt: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  managedBy: StringAggregateSelection;
  matrixRoomId: StringAggregateSelection;
  name: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type GroupCalendarEventEventsAggregationSelection = {
  __typename?: 'GroupCalendarEventEventsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<GroupCalendarEventEventsNodeAggregateSelection>;
};

export type GroupCalendarEventEventsNodeAggregateSelection = {
  __typename?: 'GroupCalendarEventEventsNodeAggregateSelection';
  classbookHomework: StringAggregateSelection;
  classbookHomeworkContentType: StringAggregateSelection;
  classbookNote: StringAggregateSelection;
  classbookNoteContentType: StringAggregateSelection;
  color: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  descriptionContentType: StringAggregateSelection;
  duration: StringAggregateSelection;
  locale: StringAggregateSelection;
  maxAttendees: IntAggregateSelection;
  privacy: StringAggregateSelection;
  prodId: StringAggregateSelection;
  sequence: IntAggregateSelection;
  start: StringAggregateSelection;
  status: StringAggregateSelection;
  timeZone: StringAggregateSelection;
  title: StringAggregateSelection;
  updated: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type GroupClassOrClassGroupClassConnectFieldInput = {
  connect?: InputMaybe<Array<ClassConnectInput>>;
  edge: OrderedRelationPropertiesCreateInput;
  where?: InputMaybe<ClassConnectWhere>;
};

export type GroupClassOrClassGroupClassConnectionWhere = {
  AND?: InputMaybe<Array<GroupClassOrClassGroupClassConnectionWhere>>;
  NOT?: InputMaybe<GroupClassOrClassGroupClassConnectionWhere>;
  OR?: InputMaybe<Array<GroupClassOrClassGroupClassConnectionWhere>>;
  edge?: InputMaybe<OrderedRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<OrderedRelationPropertiesWhere>;
  node?: InputMaybe<ClassWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ClassWhere>;
};

export type GroupClassOrClassGroupClassCreateFieldInput = {
  edge: OrderedRelationPropertiesCreateInput;
  node: ClassCreateInput;
};

export type GroupClassOrClassGroupClassDeleteFieldInput = {
  delete?: InputMaybe<ClassDeleteInput>;
  where?: InputMaybe<GroupClassOrClassGroupClassConnectionWhere>;
};

export type GroupClassOrClassGroupClassDisconnectFieldInput = {
  disconnect?: InputMaybe<ClassDisconnectInput>;
  where?: InputMaybe<GroupClassOrClassGroupClassConnectionWhere>;
};

export type GroupClassOrClassGroupClassFieldInput = {
  connect?: InputMaybe<Array<GroupClassOrClassGroupClassConnectFieldInput>>;
  create?: InputMaybe<Array<GroupClassOrClassGroupClassCreateFieldInput>>;
};

export type GroupClassOrClassGroupClassGroupConnectFieldInput = {
  connect?: InputMaybe<Array<ClassGroupConnectInput>>;
  edge: OrderedRelationPropertiesCreateInput;
  where?: InputMaybe<ClassGroupConnectWhere>;
};

export type GroupClassOrClassGroupClassGroupConnectionWhere = {
  AND?: InputMaybe<Array<GroupClassOrClassGroupClassGroupConnectionWhere>>;
  NOT?: InputMaybe<GroupClassOrClassGroupClassGroupConnectionWhere>;
  OR?: InputMaybe<Array<GroupClassOrClassGroupClassGroupConnectionWhere>>;
  edge?: InputMaybe<OrderedRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<OrderedRelationPropertiesWhere>;
  node?: InputMaybe<ClassGroupWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ClassGroupWhere>;
};

export type GroupClassOrClassGroupClassGroupCreateFieldInput = {
  edge: OrderedRelationPropertiesCreateInput;
  node: ClassGroupCreateInput;
};

export type GroupClassOrClassGroupClassGroupDeleteFieldInput = {
  delete?: InputMaybe<ClassGroupDeleteInput>;
  where?: InputMaybe<GroupClassOrClassGroupClassGroupConnectionWhere>;
};

export type GroupClassOrClassGroupClassGroupDisconnectFieldInput = {
  disconnect?: InputMaybe<ClassGroupDisconnectInput>;
  where?: InputMaybe<GroupClassOrClassGroupClassGroupConnectionWhere>;
};

export type GroupClassOrClassGroupClassGroupFieldInput = {
  connect?: InputMaybe<Array<GroupClassOrClassGroupClassGroupConnectFieldInput>>;
  create?: InputMaybe<Array<GroupClassOrClassGroupClassGroupCreateFieldInput>>;
};

export type GroupClassOrClassGroupClassGroupUpdateConnectionInput = {
  edge?: InputMaybe<OrderedRelationPropertiesUpdateInput>;
  node?: InputMaybe<ClassGroupUpdateInput>;
};

export type GroupClassOrClassGroupClassGroupUpdateFieldInput = {
  connect?: InputMaybe<Array<GroupClassOrClassGroupClassGroupConnectFieldInput>>;
  create?: InputMaybe<Array<GroupClassOrClassGroupClassGroupCreateFieldInput>>;
  delete?: InputMaybe<Array<GroupClassOrClassGroupClassGroupDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<GroupClassOrClassGroupClassGroupDisconnectFieldInput>>;
  update?: InputMaybe<GroupClassOrClassGroupClassGroupUpdateConnectionInput>;
  where?: InputMaybe<GroupClassOrClassGroupClassGroupConnectionWhere>;
};

export type GroupClassOrClassGroupClassUpdateConnectionInput = {
  edge?: InputMaybe<OrderedRelationPropertiesUpdateInput>;
  node?: InputMaybe<ClassUpdateInput>;
};

export type GroupClassOrClassGroupClassUpdateFieldInput = {
  connect?: InputMaybe<Array<GroupClassOrClassGroupClassConnectFieldInput>>;
  create?: InputMaybe<Array<GroupClassOrClassGroupClassCreateFieldInput>>;
  delete?: InputMaybe<Array<GroupClassOrClassGroupClassDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<GroupClassOrClassGroupClassDisconnectFieldInput>>;
  update?: InputMaybe<GroupClassOrClassGroupClassUpdateConnectionInput>;
  where?: InputMaybe<GroupClassOrClassGroupClassConnectionWhere>;
};

export type GroupClassOrClassGroupConnectInput = {
  Class?: InputMaybe<Array<GroupClassOrClassGroupClassConnectFieldInput>>;
  ClassGroup?: InputMaybe<Array<GroupClassOrClassGroupClassGroupConnectFieldInput>>;
};

export type GroupClassOrClassGroupConnection = {
  __typename?: 'GroupClassOrClassGroupConnection';
  edges: Array<GroupClassOrClassGroupRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GroupClassOrClassGroupConnectionSort = {
  edge?: InputMaybe<OrderedRelationPropertiesSort>;
};

export type GroupClassOrClassGroupConnectionWhere = {
  Class?: InputMaybe<GroupClassOrClassGroupClassConnectionWhere>;
  ClassGroup?: InputMaybe<GroupClassOrClassGroupClassGroupConnectionWhere>;
};

export type GroupClassOrClassGroupCreateInput = {
  Class?: InputMaybe<GroupClassOrClassGroupClassFieldInput>;
  ClassGroup?: InputMaybe<GroupClassOrClassGroupClassGroupFieldInput>;
};

export type GroupClassOrClassGroupDeleteInput = {
  Class?: InputMaybe<Array<GroupClassOrClassGroupClassDeleteFieldInput>>;
  ClassGroup?: InputMaybe<Array<GroupClassOrClassGroupClassGroupDeleteFieldInput>>;
};

export type GroupClassOrClassGroupDisconnectInput = {
  Class?: InputMaybe<Array<GroupClassOrClassGroupClassDisconnectFieldInput>>;
  ClassGroup?: InputMaybe<Array<GroupClassOrClassGroupClassGroupDisconnectFieldInput>>;
};

export type GroupClassOrClassGroupRelationship = {
  __typename?: 'GroupClassOrClassGroupRelationship';
  cursor: Scalars['String']['output'];
  node: ClassOrClassGroup;
  properties: OrderedRelationProperties;
};

export type GroupClassOrClassGroupUpdateInput = {
  Class?: InputMaybe<Array<GroupClassOrClassGroupClassUpdateFieldInput>>;
  ClassGroup?: InputMaybe<Array<GroupClassOrClassGroupClassGroupUpdateFieldInput>>;
};

export type GroupConnectInput = {
  admins?: InputMaybe<Array<GroupAdminsConnectFieldInput>>;
  classOrClassGroup?: InputMaybe<GroupClassOrClassGroupConnectInput>;
  editors?: InputMaybe<Array<GroupEditorsConnectFieldInput>>;
  groups?: InputMaybe<Array<GroupGroupsConnectFieldInput>>;
  nextcloud?: InputMaybe<Array<GroupNextcloudConnectFieldInput>>;
  organization?: InputMaybe<GroupOrganizationConnectFieldInput>;
  schoolYear?: InputMaybe<GroupSchoolYearConnectFieldInput>;
  subject?: InputMaybe<GroupSubjectConnectFieldInput>;
  teachingTopics?: InputMaybe<Array<GroupTeachingTopicsConnectFieldInput>>;
  teachingUnits?: InputMaybe<Array<GroupTeachingUnitsConnectFieldInput>>;
  threemaBroadcast?: InputMaybe<Array<GroupThreemaBroadcastConnectFieldInput>>;
  viewers?: InputMaybe<Array<GroupViewersConnectFieldInput>>;
};

export type GroupConnectOrCreateWhere = {
  node: GroupUniqueWhere;
};

export type GroupConnectWhere = {
  node: GroupWhere;
};

export type GroupCreateInput = {
  admins?: InputMaybe<GroupAdminsFieldInput>;
  classOrClassGroup?: InputMaybe<GroupClassOrClassGroupCreateInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  editors?: InputMaybe<GroupEditorsFieldInput>;
  foreignRefId?: InputMaybe<Array<Scalars['String']['input']>>;
  grades?: InputMaybe<Array<Scalars['String']['input']>>;
  groups?: InputMaybe<GroupGroupsFieldInput>;
  managedBy: Scalars['String']['input'];
  matrixRoomId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  nextcloud?: InputMaybe<GroupNextcloudFieldInput>;
  organization?: InputMaybe<GroupOrganizationFieldInput>;
  schoolYear?: InputMaybe<GroupSchoolYearFieldInput>;
  subject?: InputMaybe<GroupSubjectFieldInput>;
  teachingTopics?: InputMaybe<GroupTeachingTopicsFieldInput>;
  teachingUnits?: InputMaybe<GroupTeachingUnitsFieldInput>;
  threemaBroadcast?: InputMaybe<GroupThreemaBroadcastFieldInput>;
  type: GroupType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['ID']['input'];
  viewers?: InputMaybe<GroupViewersFieldInput>;
};

export type GroupDeleteInput = {
  admins?: InputMaybe<Array<GroupAdminsDeleteFieldInput>>;
  classOrClassGroup?: InputMaybe<GroupClassOrClassGroupDeleteInput>;
  editors?: InputMaybe<Array<GroupEditorsDeleteFieldInput>>;
  groups?: InputMaybe<Array<GroupGroupsDeleteFieldInput>>;
  nextcloud?: InputMaybe<Array<GroupNextcloudDeleteFieldInput>>;
  organization?: InputMaybe<GroupOrganizationDeleteFieldInput>;
  schoolYear?: InputMaybe<GroupSchoolYearDeleteFieldInput>;
  subject?: InputMaybe<GroupSubjectDeleteFieldInput>;
  teachingTopics?: InputMaybe<Array<GroupTeachingTopicsDeleteFieldInput>>;
  teachingUnits?: InputMaybe<Array<GroupTeachingUnitsDeleteFieldInput>>;
  threemaBroadcast?: InputMaybe<Array<GroupThreemaBroadcastDeleteFieldInput>>;
  viewers?: InputMaybe<Array<GroupViewersDeleteFieldInput>>;
};

export type GroupDisconnectInput = {
  admins?: InputMaybe<Array<GroupAdminsDisconnectFieldInput>>;
  classOrClassGroup?: InputMaybe<GroupClassOrClassGroupDisconnectInput>;
  editors?: InputMaybe<Array<GroupEditorsDisconnectFieldInput>>;
  groups?: InputMaybe<Array<GroupGroupsDisconnectFieldInput>>;
  nextcloud?: InputMaybe<Array<GroupNextcloudDisconnectFieldInput>>;
  organization?: InputMaybe<GroupOrganizationDisconnectFieldInput>;
  schoolYear?: InputMaybe<GroupSchoolYearDisconnectFieldInput>;
  subject?: InputMaybe<GroupSubjectDisconnectFieldInput>;
  teachingTopics?: InputMaybe<Array<GroupTeachingTopicsDisconnectFieldInput>>;
  teachingUnits?: InputMaybe<Array<GroupTeachingUnitsDisconnectFieldInput>>;
  threemaBroadcast?: InputMaybe<Array<GroupThreemaBroadcastDisconnectFieldInput>>;
  viewers?: InputMaybe<Array<GroupViewersDisconnectFieldInput>>;
};

export type GroupEdge = {
  __typename?: 'GroupEdge';
  cursor: Scalars['String']['output'];
  node: Group;
};

export type GroupEditorsAggregateInput = {
  AND?: InputMaybe<Array<GroupEditorsAggregateInput>>;
  NOT?: InputMaybe<GroupEditorsAggregateInput>;
  OR?: InputMaybe<Array<GroupEditorsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<GroupEditorsNodeAggregationWhereInput>;
};

export type GroupEditorsConnectFieldInput = {
  connect?: InputMaybe<Array<ProfileConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ProfileConnectWhere>;
};

export type GroupEditorsConnectOrCreateFieldInput = {
  onCreate: GroupEditorsConnectOrCreateFieldInputOnCreate;
  where: ProfileConnectOrCreateWhere;
};

export type GroupEditorsConnectOrCreateFieldInputOnCreate = {
  node: ProfileOnCreateInput;
};

export type GroupEditorsConnection = {
  __typename?: 'GroupEditorsConnection';
  edges: Array<GroupEditorsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GroupEditorsConnectionSort = {
  node?: InputMaybe<ProfileSort>;
};

export type GroupEditorsConnectionWhere = {
  AND?: InputMaybe<Array<GroupEditorsConnectionWhere>>;
  NOT?: InputMaybe<GroupEditorsConnectionWhere>;
  OR?: InputMaybe<Array<GroupEditorsConnectionWhere>>;
  node?: InputMaybe<ProfileWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ProfileWhere>;
};

export type GroupEditorsCreateFieldInput = {
  node: ProfileCreateInput;
};

export type GroupEditorsDeleteFieldInput = {
  delete?: InputMaybe<ProfileDeleteInput>;
  where?: InputMaybe<GroupEditorsConnectionWhere>;
};

export type GroupEditorsDisconnectFieldInput = {
  disconnect?: InputMaybe<ProfileDisconnectInput>;
  where?: InputMaybe<GroupEditorsConnectionWhere>;
};

export type GroupEditorsFieldInput = {
  connect?: InputMaybe<Array<GroupEditorsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<GroupEditorsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<GroupEditorsCreateFieldInput>>;
};

export type GroupEditorsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<GroupEditorsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<GroupEditorsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<GroupEditorsNodeAggregationWhereInput>>;
  address1_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address1_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address2_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address2_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address3_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address3_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  birthday_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  userUuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  userUuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type GroupEditorsRelationship = {
  __typename?: 'GroupEditorsRelationship';
  cursor: Scalars['String']['output'];
  node: Profile;
};

export type GroupEditorsUpdateConnectionInput = {
  node?: InputMaybe<ProfileUpdateInput>;
};

export type GroupEditorsUpdateFieldInput = {
  connect?: InputMaybe<Array<GroupEditorsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<GroupEditorsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<GroupEditorsCreateFieldInput>>;
  delete?: InputMaybe<Array<GroupEditorsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<GroupEditorsDisconnectFieldInput>>;
  update?: InputMaybe<GroupEditorsUpdateConnectionInput>;
  where?: InputMaybe<GroupEditorsConnectionWhere>;
};

export type GroupEventsAggregateInput = {
  AND?: InputMaybe<Array<GroupEventsAggregateInput>>;
  NOT?: InputMaybe<GroupEventsAggregateInput>;
  OR?: InputMaybe<Array<GroupEventsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<GroupEventsNodeAggregationWhereInput>;
};

export type GroupEventsConnection = {
  __typename?: 'GroupEventsConnection';
  edges: Array<GroupEventsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GroupEventsConnectionSort = {
  node?: InputMaybe<CalendarEventSort>;
};

export type GroupEventsConnectionWhere = {
  AND?: InputMaybe<Array<GroupEventsConnectionWhere>>;
  NOT?: InputMaybe<GroupEventsConnectionWhere>;
  OR?: InputMaybe<Array<GroupEventsConnectionWhere>>;
  node?: InputMaybe<CalendarEventWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<CalendarEventWhere>;
};

export type GroupEventsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<GroupEventsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<GroupEventsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<GroupEventsNodeAggregationWhereInput>>;
  classbookHomeworkContentType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classbookHomeworkContentType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classbookHomeworkContentType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classbookHomeworkContentType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classbookHomeworkContentType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classbookHomeworkContentType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classbookHomeworkContentType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classbookHomeworkContentType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classbookHomeworkContentType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classbookHomeworkContentType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classbookHomeworkContentType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classbookHomeworkContentType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classbookHomeworkContentType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classbookHomeworkContentType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classbookHomeworkContentType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classbookHomework_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classbookHomework_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classbookHomework_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classbookHomework_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classbookHomework_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classbookHomework_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classbookHomework_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classbookHomework_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classbookHomework_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classbookHomework_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classbookHomework_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classbookHomework_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classbookHomework_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classbookHomework_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classbookHomework_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classbookNoteContentType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classbookNoteContentType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classbookNoteContentType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classbookNoteContentType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classbookNoteContentType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classbookNoteContentType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classbookNoteContentType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classbookNoteContentType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classbookNoteContentType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classbookNoteContentType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classbookNoteContentType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classbookNoteContentType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classbookNoteContentType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classbookNoteContentType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classbookNoteContentType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classbookNote_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classbookNote_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classbookNote_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classbookNote_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classbookNote_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classbookNote_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classbookNote_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classbookNote_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classbookNote_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classbookNote_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classbookNote_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classbookNote_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classbookNote_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classbookNote_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classbookNote_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  color_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  color_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  descriptionContentType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionContentType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionContentType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionContentType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionContentType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionContentType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionContentType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionContentType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionContentType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionContentType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionContentType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionContentType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionContentType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionContentType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionContentType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  duration_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  duration_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  duration_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  locale_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maxAttendees_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  maxAttendees_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  maxAttendees_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  maxAttendees_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  maxAttendees_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  privacy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  privacy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  privacy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  privacy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  privacy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  privacy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  privacy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  privacy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  privacy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  privacy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  privacy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  privacy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  privacy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  privacy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  privacy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prodId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  prodId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  prodId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  prodId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  prodId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  prodId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prodId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prodId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prodId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prodId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prodId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prodId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prodId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prodId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prodId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sequence_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sequence_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sequence_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sequence_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sequence_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  sequence_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sequence_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sequence_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sequence_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sequence_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sequence_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sequence_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sequence_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sequence_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sequence_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sequence_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sequence_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sequence_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sequence_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sequence_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  start_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  start_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  start_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  start_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  start_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  status_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  status_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeZone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeZone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timeZone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeZone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timeZone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeZone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeZone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timeZone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeZone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timeZone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeZone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeZone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timeZone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeZone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timeZone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GroupEventsRelationship = {
  __typename?: 'GroupEventsRelationship';
  cursor: Scalars['String']['output'];
  node: CalendarEvent;
};

export type GroupGroupGroupsAggregationSelection = {
  __typename?: 'GroupGroupGroupsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<GroupGroupGroupsEdgeAggregateSelection>;
  node?: Maybe<GroupGroupGroupsNodeAggregateSelection>;
};

export type GroupGroupGroupsEdgeAggregateSelection = {
  __typename?: 'GroupGroupGroupsEdgeAggregateSelection';
  order: IntAggregateSelection;
};

export type GroupGroupGroupsNodeAggregateSelection = {
  __typename?: 'GroupGroupGroupsNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  managedBy: StringAggregateSelection;
  matrixRoomId: StringAggregateSelection;
  name: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type GroupGroupsAggregateInput = {
  AND?: InputMaybe<Array<GroupGroupsAggregateInput>>;
  NOT?: InputMaybe<GroupGroupsAggregateInput>;
  OR?: InputMaybe<Array<GroupGroupsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<OrderedRelationPropertiesAggregationWhereInput>;
  node?: InputMaybe<GroupGroupsNodeAggregationWhereInput>;
};

export type GroupGroupsConnectFieldInput = {
  connect?: InputMaybe<Array<GroupConnectInput>>;
  edge: OrderedRelationPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<GroupConnectWhere>;
};

export type GroupGroupsConnectOrCreateFieldInput = {
  onCreate: GroupGroupsConnectOrCreateFieldInputOnCreate;
  where: GroupConnectOrCreateWhere;
};

export type GroupGroupsConnectOrCreateFieldInputOnCreate = {
  edge: OrderedRelationPropertiesCreateInput;
  node: GroupOnCreateInput;
};

export type GroupGroupsConnection = {
  __typename?: 'GroupGroupsConnection';
  edges: Array<GroupGroupsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GroupGroupsConnectionSort = {
  edge?: InputMaybe<OrderedRelationPropertiesSort>;
  node?: InputMaybe<GroupSort>;
};

export type GroupGroupsConnectionWhere = {
  AND?: InputMaybe<Array<GroupGroupsConnectionWhere>>;
  NOT?: InputMaybe<GroupGroupsConnectionWhere>;
  OR?: InputMaybe<Array<GroupGroupsConnectionWhere>>;
  edge?: InputMaybe<OrderedRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<OrderedRelationPropertiesWhere>;
  node?: InputMaybe<GroupWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<GroupWhere>;
};

export type GroupGroupsCreateFieldInput = {
  edge: OrderedRelationPropertiesCreateInput;
  node: GroupCreateInput;
};

export type GroupGroupsDeleteFieldInput = {
  delete?: InputMaybe<GroupDeleteInput>;
  where?: InputMaybe<GroupGroupsConnectionWhere>;
};

export type GroupGroupsDisconnectFieldInput = {
  disconnect?: InputMaybe<GroupDisconnectInput>;
  where?: InputMaybe<GroupGroupsConnectionWhere>;
};

export type GroupGroupsFieldInput = {
  connect?: InputMaybe<Array<GroupGroupsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<GroupGroupsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<GroupGroupsCreateFieldInput>>;
};

export type GroupGroupsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<GroupGroupsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<GroupGroupsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<GroupGroupsNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GroupGroupsRelationship = {
  __typename?: 'GroupGroupsRelationship';
  cursor: Scalars['String']['output'];
  node: Group;
  properties: OrderedRelationProperties;
};

export type GroupGroupsUpdateConnectionInput = {
  edge?: InputMaybe<OrderedRelationPropertiesUpdateInput>;
  node?: InputMaybe<GroupUpdateInput>;
};

export type GroupGroupsUpdateFieldInput = {
  connect?: InputMaybe<Array<GroupGroupsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<GroupGroupsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<GroupGroupsCreateFieldInput>>;
  delete?: InputMaybe<Array<GroupGroupsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<GroupGroupsDisconnectFieldInput>>;
  update?: InputMaybe<GroupGroupsUpdateConnectionInput>;
  where?: InputMaybe<GroupGroupsConnectionWhere>;
};

export type GroupNextcloudAggregateInput = {
  AND?: InputMaybe<Array<GroupNextcloudAggregateInput>>;
  NOT?: InputMaybe<GroupNextcloudAggregateInput>;
  OR?: InputMaybe<Array<GroupNextcloudAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<NextcloudGroupPropsAggregationWhereInput>;
  node?: InputMaybe<GroupNextcloudNodeAggregationWhereInput>;
};

export type GroupNextcloudConnectFieldInput = {
  connect?: InputMaybe<Array<NextcloudConnectInput>>;
  edge?: InputMaybe<NextcloudGroupPropsCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<NextcloudConnectWhere>;
};

export type GroupNextcloudConnection = {
  __typename?: 'GroupNextcloudConnection';
  edges: Array<GroupNextcloudRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GroupNextcloudConnectionSort = {
  edge?: InputMaybe<NextcloudGroupPropsSort>;
  node?: InputMaybe<NextcloudSort>;
};

export type GroupNextcloudConnectionWhere = {
  AND?: InputMaybe<Array<GroupNextcloudConnectionWhere>>;
  NOT?: InputMaybe<GroupNextcloudConnectionWhere>;
  OR?: InputMaybe<Array<GroupNextcloudConnectionWhere>>;
  edge?: InputMaybe<NextcloudGroupPropsWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<NextcloudGroupPropsWhere>;
  node?: InputMaybe<NextcloudWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<NextcloudWhere>;
};

export type GroupNextcloudCreateFieldInput = {
  edge?: InputMaybe<NextcloudGroupPropsCreateInput>;
  node: NextcloudCreateInput;
};

export type GroupNextcloudDeleteFieldInput = {
  delete?: InputMaybe<NextcloudDeleteInput>;
  where?: InputMaybe<GroupNextcloudConnectionWhere>;
};

export type GroupNextcloudDisconnectFieldInput = {
  disconnect?: InputMaybe<NextcloudDisconnectInput>;
  where?: InputMaybe<GroupNextcloudConnectionWhere>;
};

export type GroupNextcloudFieldInput = {
  connect?: InputMaybe<Array<GroupNextcloudConnectFieldInput>>;
  create?: InputMaybe<Array<GroupNextcloudCreateFieldInput>>;
};

export type GroupNextcloudNextcloudAggregationSelection = {
  __typename?: 'GroupNextcloudNextcloudAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<GroupNextcloudNextcloudEdgeAggregateSelection>;
  node?: Maybe<GroupNextcloudNextcloudNodeAggregateSelection>;
};

export type GroupNextcloudNextcloudEdgeAggregateSelection = {
  __typename?: 'GroupNextcloudNextcloudEdgeAggregateSelection';
  folderName: StringAggregateSelection;
  lastSync: DateTimeAggregateSelection;
};

export type GroupNextcloudNextcloudNodeAggregateSelection = {
  __typename?: 'GroupNextcloudNextcloudNodeAggregateSelection';
  serverUri: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type GroupNextcloudNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<GroupNextcloudNodeAggregationWhereInput>>;
  NOT?: InputMaybe<GroupNextcloudNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<GroupNextcloudNodeAggregationWhereInput>>;
  adminPass_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adminPass_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  adminPass_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  adminPass_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  adminPass_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  adminPass_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  adminPass_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  adminPass_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  adminPass_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  adminPass_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  adminPass_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  adminPass_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  adminPass_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  adminPass_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  adminPass_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  adminUser_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adminUser_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  adminUser_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  adminUser_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  adminUser_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  adminUser_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  adminUser_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  adminUser_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  adminUser_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  adminUser_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  adminUser_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  adminUser_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  adminUser_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  adminUser_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  adminUser_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  serverUri_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  serverUri_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  serverUri_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  serverUri_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  serverUri_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  serverUri_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  serverUri_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  serverUri_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  serverUri_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  serverUri_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  serverUri_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  serverUri_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  serverUri_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  serverUri_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  serverUri_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type GroupNextcloudRelationship = {
  __typename?: 'GroupNextcloudRelationship';
  cursor: Scalars['String']['output'];
  node: Nextcloud;
  properties: NextcloudGroupProps;
};

export type GroupNextcloudUpdateConnectionInput = {
  edge?: InputMaybe<NextcloudGroupPropsUpdateInput>;
  node?: InputMaybe<NextcloudUpdateInput>;
};

export type GroupNextcloudUpdateFieldInput = {
  connect?: InputMaybe<Array<GroupNextcloudConnectFieldInput>>;
  create?: InputMaybe<Array<GroupNextcloudCreateFieldInput>>;
  delete?: InputMaybe<Array<GroupNextcloudDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<GroupNextcloudDisconnectFieldInput>>;
  update?: InputMaybe<GroupNextcloudUpdateConnectionInput>;
  where?: InputMaybe<GroupNextcloudConnectionWhere>;
};

export type GroupOnCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  foreignRefId?: InputMaybe<Array<Scalars['String']['input']>>;
  grades?: InputMaybe<Array<Scalars['String']['input']>>;
  managedBy: Scalars['String']['input'];
  matrixRoomId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  type: GroupType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['ID']['input'];
};

export type GroupOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more GroupSort objects to sort Groups by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<GroupSort>>;
};

export type GroupOrganizationAggregateInput = {
  AND?: InputMaybe<Array<GroupOrganizationAggregateInput>>;
  NOT?: InputMaybe<GroupOrganizationAggregateInput>;
  OR?: InputMaybe<Array<GroupOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<GroupOrganizationNodeAggregationWhereInput>;
};

export type GroupOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type GroupOrganizationConnectOrCreateFieldInput = {
  onCreate: GroupOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type GroupOrganizationConnectOrCreateFieldInputOnCreate = {
  node: OrganizationOnCreateInput;
};

export type GroupOrganizationConnection = {
  __typename?: 'GroupOrganizationConnection';
  edges: Array<GroupOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GroupOrganizationConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type GroupOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<GroupOrganizationConnectionWhere>>;
  NOT?: InputMaybe<GroupOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<GroupOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type GroupOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type GroupOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<GroupOrganizationConnectionWhere>;
};

export type GroupOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<GroupOrganizationConnectionWhere>;
};

export type GroupOrganizationFieldInput = {
  connect?: InputMaybe<GroupOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<GroupOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<GroupOrganizationCreateFieldInput>;
};

export type GroupOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<GroupOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<GroupOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<GroupOrganizationNodeAggregationWhereInput>>;
  aboutInfoLastUpdated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type GroupOrganizationRelationship = {
  __typename?: 'GroupOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type GroupOrganizationUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type GroupOrganizationUpdateFieldInput = {
  connect?: InputMaybe<GroupOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<GroupOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<GroupOrganizationCreateFieldInput>;
  delete?: InputMaybe<GroupOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<GroupOrganizationDisconnectFieldInput>;
  update?: InputMaybe<GroupOrganizationUpdateConnectionInput>;
  where?: InputMaybe<GroupOrganizationConnectionWhere>;
};

export type GroupProfileAdminsAggregationSelection = {
  __typename?: 'GroupProfileAdminsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<GroupProfileAdminsNodeAggregateSelection>;
};

export type GroupProfileAdminsNodeAggregateSelection = {
  __typename?: 'GroupProfileAdminsNodeAggregateSelection';
  address1: StringAggregateSelection;
  address2: StringAggregateSelection;
  address3: StringAggregateSelection;
  birthday: StringAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  email: StringAggregateSelection;
  firstName: StringAggregateSelection;
  firstNames: StringAggregateSelection;
  lastName: StringAggregateSelection;
  managedBy: StringAggregateSelection;
  matrixToken: StringAggregateSelection;
  nextcloudUserId: StringAggregateSelection;
  prefixName: StringAggregateSelection;
  salutation: StringAggregateSelection;
  shortName: StringAggregateSelection;
  threemaId: StringAggregateSelection;
  title: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  userUuid: StringAggregateSelection;
  uuid: IdAggregateSelection;
  zoomUserId: StringAggregateSelection;
};

export type GroupProfileEditorsAggregationSelection = {
  __typename?: 'GroupProfileEditorsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<GroupProfileEditorsNodeAggregateSelection>;
};

export type GroupProfileEditorsNodeAggregateSelection = {
  __typename?: 'GroupProfileEditorsNodeAggregateSelection';
  address1: StringAggregateSelection;
  address2: StringAggregateSelection;
  address3: StringAggregateSelection;
  birthday: StringAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  email: StringAggregateSelection;
  firstName: StringAggregateSelection;
  firstNames: StringAggregateSelection;
  lastName: StringAggregateSelection;
  managedBy: StringAggregateSelection;
  matrixToken: StringAggregateSelection;
  nextcloudUserId: StringAggregateSelection;
  prefixName: StringAggregateSelection;
  salutation: StringAggregateSelection;
  shortName: StringAggregateSelection;
  threemaId: StringAggregateSelection;
  title: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  userUuid: StringAggregateSelection;
  uuid: IdAggregateSelection;
  zoomUserId: StringAggregateSelection;
};

export type GroupProfileViewersAggregationSelection = {
  __typename?: 'GroupProfileViewersAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<GroupProfileViewersNodeAggregateSelection>;
};

export type GroupProfileViewersNodeAggregateSelection = {
  __typename?: 'GroupProfileViewersNodeAggregateSelection';
  address1: StringAggregateSelection;
  address2: StringAggregateSelection;
  address3: StringAggregateSelection;
  birthday: StringAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  email: StringAggregateSelection;
  firstName: StringAggregateSelection;
  firstNames: StringAggregateSelection;
  lastName: StringAggregateSelection;
  managedBy: StringAggregateSelection;
  matrixToken: StringAggregateSelection;
  nextcloudUserId: StringAggregateSelection;
  prefixName: StringAggregateSelection;
  salutation: StringAggregateSelection;
  shortName: StringAggregateSelection;
  threemaId: StringAggregateSelection;
  title: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  userUuid: StringAggregateSelection;
  uuid: IdAggregateSelection;
  zoomUserId: StringAggregateSelection;
};

export type GroupSchoolYearAggregateInput = {
  AND?: InputMaybe<Array<GroupSchoolYearAggregateInput>>;
  NOT?: InputMaybe<GroupSchoolYearAggregateInput>;
  OR?: InputMaybe<Array<GroupSchoolYearAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<GroupSchoolYearNodeAggregationWhereInput>;
};

export type GroupSchoolYearConnectFieldInput = {
  connect?: InputMaybe<SchoolYearConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SchoolYearConnectWhere>;
};

export type GroupSchoolYearConnection = {
  __typename?: 'GroupSchoolYearConnection';
  edges: Array<GroupSchoolYearRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GroupSchoolYearConnectionSort = {
  node?: InputMaybe<SchoolYearSort>;
};

export type GroupSchoolYearConnectionWhere = {
  AND?: InputMaybe<Array<GroupSchoolYearConnectionWhere>>;
  NOT?: InputMaybe<GroupSchoolYearConnectionWhere>;
  OR?: InputMaybe<Array<GroupSchoolYearConnectionWhere>>;
  node?: InputMaybe<SchoolYearWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SchoolYearWhere>;
};

export type GroupSchoolYearCreateFieldInput = {
  node: SchoolYearCreateInput;
};

export type GroupSchoolYearDeleteFieldInput = {
  delete?: InputMaybe<SchoolYearDeleteInput>;
  where?: InputMaybe<GroupSchoolYearConnectionWhere>;
};

export type GroupSchoolYearDisconnectFieldInput = {
  disconnect?: InputMaybe<SchoolYearDisconnectInput>;
  where?: InputMaybe<GroupSchoolYearConnectionWhere>;
};

export type GroupSchoolYearFieldInput = {
  connect?: InputMaybe<GroupSchoolYearConnectFieldInput>;
  create?: InputMaybe<GroupSchoolYearCreateFieldInput>;
};

export type GroupSchoolYearNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<GroupSchoolYearNodeAggregationWhereInput>>;
  NOT?: InputMaybe<GroupSchoolYearNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<GroupSchoolYearNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  managedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GroupSchoolYearRelationship = {
  __typename?: 'GroupSchoolYearRelationship';
  cursor: Scalars['String']['output'];
  node: SchoolYear;
};

export type GroupSchoolYearUpdateConnectionInput = {
  node?: InputMaybe<SchoolYearUpdateInput>;
};

export type GroupSchoolYearUpdateFieldInput = {
  connect?: InputMaybe<GroupSchoolYearConnectFieldInput>;
  create?: InputMaybe<GroupSchoolYearCreateFieldInput>;
  delete?: InputMaybe<GroupSchoolYearDeleteFieldInput>;
  disconnect?: InputMaybe<GroupSchoolYearDisconnectFieldInput>;
  update?: InputMaybe<GroupSchoolYearUpdateConnectionInput>;
  where?: InputMaybe<GroupSchoolYearConnectionWhere>;
};

/** Fields to sort Groups by. The order in which sorts are applied is not guaranteed when specifying many fields in one GroupSort object. */
export type GroupSort = {
  createdAt?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  displayName?: InputMaybe<SortDirection>;
  inCurrentSchoolyear?: InputMaybe<SortDirection>;
  isCommunity?: InputMaybe<SortDirection>;
  managedBy?: InputMaybe<SortDirection>;
  matrixRoomId?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type GroupSubjectAggregateInput = {
  AND?: InputMaybe<Array<GroupSubjectAggregateInput>>;
  NOT?: InputMaybe<GroupSubjectAggregateInput>;
  OR?: InputMaybe<Array<GroupSubjectAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<GroupSubjectNodeAggregationWhereInput>;
};

export type GroupSubjectConnectFieldInput = {
  connect?: InputMaybe<SubjectConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SubjectConnectWhere>;
};

export type GroupSubjectConnection = {
  __typename?: 'GroupSubjectConnection';
  edges: Array<GroupSubjectRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GroupSubjectConnectionSort = {
  node?: InputMaybe<SubjectSort>;
};

export type GroupSubjectConnectionWhere = {
  AND?: InputMaybe<Array<GroupSubjectConnectionWhere>>;
  NOT?: InputMaybe<GroupSubjectConnectionWhere>;
  OR?: InputMaybe<Array<GroupSubjectConnectionWhere>>;
  node?: InputMaybe<SubjectWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SubjectWhere>;
};

export type GroupSubjectCreateFieldInput = {
  node: SubjectCreateInput;
};

export type GroupSubjectDeleteFieldInput = {
  delete?: InputMaybe<SubjectDeleteInput>;
  where?: InputMaybe<GroupSubjectConnectionWhere>;
};

export type GroupSubjectDisconnectFieldInput = {
  disconnect?: InputMaybe<SubjectDisconnectInput>;
  where?: InputMaybe<GroupSubjectConnectionWhere>;
};

export type GroupSubjectFieldInput = {
  connect?: InputMaybe<GroupSubjectConnectFieldInput>;
  create?: InputMaybe<GroupSubjectCreateFieldInput>;
};

export type GroupSubjectNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<GroupSubjectNodeAggregationWhereInput>>;
  NOT?: InputMaybe<GroupSubjectNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<GroupSubjectNodeAggregationWhereInput>>;
  globalSubject_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  globalSubject_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  globalSubject_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  globalSubject_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  globalSubject_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  globalSubject_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  globalSubject_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  globalSubject_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  globalSubject_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  globalSubject_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  globalSubject_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  globalSubject_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  globalSubject_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  globalSubject_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  globalSubject_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type GroupSubjectRelationship = {
  __typename?: 'GroupSubjectRelationship';
  cursor: Scalars['String']['output'];
  node: Subject;
};

export type GroupSubjectUpdateConnectionInput = {
  node?: InputMaybe<SubjectUpdateInput>;
};

export type GroupSubjectUpdateFieldInput = {
  connect?: InputMaybe<GroupSubjectConnectFieldInput>;
  create?: InputMaybe<GroupSubjectCreateFieldInput>;
  delete?: InputMaybe<GroupSubjectDeleteFieldInput>;
  disconnect?: InputMaybe<GroupSubjectDisconnectFieldInput>;
  update?: InputMaybe<GroupSubjectUpdateConnectionInput>;
  where?: InputMaybe<GroupSubjectConnectionWhere>;
};

export type GroupTeachingTopicTeachingTopicsAggregationSelection = {
  __typename?: 'GroupTeachingTopicTeachingTopicsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<GroupTeachingTopicTeachingTopicsEdgeAggregateSelection>;
  node?: Maybe<GroupTeachingTopicTeachingTopicsNodeAggregateSelection>;
};

export type GroupTeachingTopicTeachingTopicsEdgeAggregateSelection = {
  __typename?: 'GroupTeachingTopicTeachingTopicsEdgeAggregateSelection';
  order: IntAggregateSelection;
};

export type GroupTeachingTopicTeachingTopicsNodeAggregateSelection = {
  __typename?: 'GroupTeachingTopicTeachingTopicsNodeAggregateSelection';
  title: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type GroupTeachingTopicsAggregateInput = {
  AND?: InputMaybe<Array<GroupTeachingTopicsAggregateInput>>;
  NOT?: InputMaybe<GroupTeachingTopicsAggregateInput>;
  OR?: InputMaybe<Array<GroupTeachingTopicsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<OrderedRelationPropertiesAggregationWhereInput>;
  node?: InputMaybe<GroupTeachingTopicsNodeAggregationWhereInput>;
};

export type GroupTeachingTopicsConnectFieldInput = {
  connect?: InputMaybe<Array<TeachingTopicConnectInput>>;
  edge: OrderedRelationPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TeachingTopicConnectWhere>;
};

export type GroupTeachingTopicsConnection = {
  __typename?: 'GroupTeachingTopicsConnection';
  edges: Array<GroupTeachingTopicsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GroupTeachingTopicsConnectionSort = {
  edge?: InputMaybe<OrderedRelationPropertiesSort>;
  node?: InputMaybe<TeachingTopicSort>;
};

export type GroupTeachingTopicsConnectionWhere = {
  AND?: InputMaybe<Array<GroupTeachingTopicsConnectionWhere>>;
  NOT?: InputMaybe<GroupTeachingTopicsConnectionWhere>;
  OR?: InputMaybe<Array<GroupTeachingTopicsConnectionWhere>>;
  edge?: InputMaybe<OrderedRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<OrderedRelationPropertiesWhere>;
  node?: InputMaybe<TeachingTopicWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TeachingTopicWhere>;
};

export type GroupTeachingTopicsCreateFieldInput = {
  edge: OrderedRelationPropertiesCreateInput;
  node: TeachingTopicCreateInput;
};

export type GroupTeachingTopicsDeleteFieldInput = {
  delete?: InputMaybe<TeachingTopicDeleteInput>;
  where?: InputMaybe<GroupTeachingTopicsConnectionWhere>;
};

export type GroupTeachingTopicsDisconnectFieldInput = {
  disconnect?: InputMaybe<TeachingTopicDisconnectInput>;
  where?: InputMaybe<GroupTeachingTopicsConnectionWhere>;
};

export type GroupTeachingTopicsFieldInput = {
  connect?: InputMaybe<Array<GroupTeachingTopicsConnectFieldInput>>;
  create?: InputMaybe<Array<GroupTeachingTopicsCreateFieldInput>>;
};

export type GroupTeachingTopicsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<GroupTeachingTopicsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<GroupTeachingTopicsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<GroupTeachingTopicsNodeAggregationWhereInput>>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type GroupTeachingTopicsRelationship = {
  __typename?: 'GroupTeachingTopicsRelationship';
  cursor: Scalars['String']['output'];
  node: TeachingTopic;
  properties: OrderedRelationProperties;
};

export type GroupTeachingTopicsUpdateConnectionInput = {
  edge?: InputMaybe<OrderedRelationPropertiesUpdateInput>;
  node?: InputMaybe<TeachingTopicUpdateInput>;
};

export type GroupTeachingTopicsUpdateFieldInput = {
  connect?: InputMaybe<Array<GroupTeachingTopicsConnectFieldInput>>;
  create?: InputMaybe<Array<GroupTeachingTopicsCreateFieldInput>>;
  delete?: InputMaybe<Array<GroupTeachingTopicsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<GroupTeachingTopicsDisconnectFieldInput>>;
  update?: InputMaybe<GroupTeachingTopicsUpdateConnectionInput>;
  where?: InputMaybe<GroupTeachingTopicsConnectionWhere>;
};

export type GroupTeachingUnitTeachingUnitsAggregationSelection = {
  __typename?: 'GroupTeachingUnitTeachingUnitsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<GroupTeachingUnitTeachingUnitsEdgeAggregateSelection>;
  node?: Maybe<GroupTeachingUnitTeachingUnitsNodeAggregateSelection>;
};

export type GroupTeachingUnitTeachingUnitsEdgeAggregateSelection = {
  __typename?: 'GroupTeachingUnitTeachingUnitsEdgeAggregateSelection';
  order: IntAggregateSelection;
};

export type GroupTeachingUnitTeachingUnitsNodeAggregateSelection = {
  __typename?: 'GroupTeachingUnitTeachingUnitsNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  descriptionMediaType: StringAggregateSelection;
  sortIndex: IntAggregateSelection;
  title: StringAggregateSelection;
  updated: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type GroupTeachingUnitsAggregateInput = {
  AND?: InputMaybe<Array<GroupTeachingUnitsAggregateInput>>;
  NOT?: InputMaybe<GroupTeachingUnitsAggregateInput>;
  OR?: InputMaybe<Array<GroupTeachingUnitsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<OrderedRelationPropertiesAggregationWhereInput>;
  node?: InputMaybe<GroupTeachingUnitsNodeAggregationWhereInput>;
};

export type GroupTeachingUnitsConnectFieldInput = {
  connect?: InputMaybe<Array<TeachingUnitConnectInput>>;
  edge: OrderedRelationPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TeachingUnitConnectWhere>;
};

export type GroupTeachingUnitsConnection = {
  __typename?: 'GroupTeachingUnitsConnection';
  edges: Array<GroupTeachingUnitsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GroupTeachingUnitsConnectionSort = {
  edge?: InputMaybe<OrderedRelationPropertiesSort>;
  node?: InputMaybe<TeachingUnitSort>;
};

export type GroupTeachingUnitsConnectionWhere = {
  AND?: InputMaybe<Array<GroupTeachingUnitsConnectionWhere>>;
  NOT?: InputMaybe<GroupTeachingUnitsConnectionWhere>;
  OR?: InputMaybe<Array<GroupTeachingUnitsConnectionWhere>>;
  edge?: InputMaybe<OrderedRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<OrderedRelationPropertiesWhere>;
  node?: InputMaybe<TeachingUnitWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TeachingUnitWhere>;
};

export type GroupTeachingUnitsCreateFieldInput = {
  edge: OrderedRelationPropertiesCreateInput;
  node: TeachingUnitCreateInput;
};

export type GroupTeachingUnitsDeleteFieldInput = {
  delete?: InputMaybe<TeachingUnitDeleteInput>;
  where?: InputMaybe<GroupTeachingUnitsConnectionWhere>;
};

export type GroupTeachingUnitsDisconnectFieldInput = {
  disconnect?: InputMaybe<TeachingUnitDisconnectInput>;
  where?: InputMaybe<GroupTeachingUnitsConnectionWhere>;
};

export type GroupTeachingUnitsFieldInput = {
  connect?: InputMaybe<Array<GroupTeachingUnitsConnectFieldInput>>;
  create?: InputMaybe<Array<GroupTeachingUnitsCreateFieldInput>>;
};

export type GroupTeachingUnitsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<GroupTeachingUnitsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<GroupTeachingUnitsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<GroupTeachingUnitsNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  descriptionMediaType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionMediaType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionMediaType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionMediaType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionMediaType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionMediaType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionMediaType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionMediaType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionMediaType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionMediaType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionMediaType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionMediaType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionMediaType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionMediaType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionMediaType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sortIndex_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sortIndex_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sortIndex_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sortIndex_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  sortIndex_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GroupTeachingUnitsRelationship = {
  __typename?: 'GroupTeachingUnitsRelationship';
  cursor: Scalars['String']['output'];
  node: TeachingUnit;
  properties: OrderedRelationProperties;
};

export type GroupTeachingUnitsUpdateConnectionInput = {
  edge?: InputMaybe<OrderedRelationPropertiesUpdateInput>;
  node?: InputMaybe<TeachingUnitUpdateInput>;
};

export type GroupTeachingUnitsUpdateFieldInput = {
  connect?: InputMaybe<Array<GroupTeachingUnitsConnectFieldInput>>;
  create?: InputMaybe<Array<GroupTeachingUnitsCreateFieldInput>>;
  delete?: InputMaybe<Array<GroupTeachingUnitsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<GroupTeachingUnitsDisconnectFieldInput>>;
  update?: InputMaybe<GroupTeachingUnitsUpdateConnectionInput>;
  where?: InputMaybe<GroupTeachingUnitsConnectionWhere>;
};

export type GroupThreemaBroadcastAggregateInput = {
  AND?: InputMaybe<Array<GroupThreemaBroadcastAggregateInput>>;
  NOT?: InputMaybe<GroupThreemaBroadcastAggregateInput>;
  OR?: InputMaybe<Array<GroupThreemaBroadcastAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<ThreemaBroadcastPropsAggregationWhereInput>;
  node?: InputMaybe<GroupThreemaBroadcastNodeAggregationWhereInput>;
};

export type GroupThreemaBroadcastConnectFieldInput = {
  connect?: InputMaybe<Array<ThreemaBroadcastConnectInput>>;
  edge?: InputMaybe<ThreemaBroadcastPropsCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ThreemaBroadcastConnectWhere>;
};

export type GroupThreemaBroadcastConnection = {
  __typename?: 'GroupThreemaBroadcastConnection';
  edges: Array<GroupThreemaBroadcastRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GroupThreemaBroadcastConnectionSort = {
  edge?: InputMaybe<ThreemaBroadcastPropsSort>;
  node?: InputMaybe<ThreemaBroadcastSort>;
};

export type GroupThreemaBroadcastConnectionWhere = {
  AND?: InputMaybe<Array<GroupThreemaBroadcastConnectionWhere>>;
  NOT?: InputMaybe<GroupThreemaBroadcastConnectionWhere>;
  OR?: InputMaybe<Array<GroupThreemaBroadcastConnectionWhere>>;
  edge?: InputMaybe<ThreemaBroadcastPropsWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<ThreemaBroadcastPropsWhere>;
  node?: InputMaybe<ThreemaBroadcastWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ThreemaBroadcastWhere>;
};

export type GroupThreemaBroadcastCreateFieldInput = {
  edge?: InputMaybe<ThreemaBroadcastPropsCreateInput>;
  node: ThreemaBroadcastCreateInput;
};

export type GroupThreemaBroadcastDeleteFieldInput = {
  delete?: InputMaybe<ThreemaBroadcastDeleteInput>;
  where?: InputMaybe<GroupThreemaBroadcastConnectionWhere>;
};

export type GroupThreemaBroadcastDisconnectFieldInput = {
  disconnect?: InputMaybe<ThreemaBroadcastDisconnectInput>;
  where?: InputMaybe<GroupThreemaBroadcastConnectionWhere>;
};

export type GroupThreemaBroadcastFieldInput = {
  connect?: InputMaybe<Array<GroupThreemaBroadcastConnectFieldInput>>;
  create?: InputMaybe<Array<GroupThreemaBroadcastCreateFieldInput>>;
};

export type GroupThreemaBroadcastNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<GroupThreemaBroadcastNodeAggregationWhereInput>>;
  NOT?: InputMaybe<GroupThreemaBroadcastNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<GroupThreemaBroadcastNodeAggregationWhereInput>>;
  apiToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  apiToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  apiToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  apiToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  apiToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  apiToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  apiToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  apiToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  apiToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  apiToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  apiToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  apiToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  apiToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  apiToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  apiToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thremaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  thremaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  thremaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  thremaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  thremaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  thremaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thremaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thremaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thremaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thremaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thremaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thremaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thremaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thremaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thremaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type GroupThreemaBroadcastRelationship = {
  __typename?: 'GroupThreemaBroadcastRelationship';
  cursor: Scalars['String']['output'];
  node: ThreemaBroadcast;
  properties: ThreemaBroadcastProps;
};

export type GroupThreemaBroadcastThreemaBroadcastAggregationSelection = {
  __typename?: 'GroupThreemaBroadcastThreemaBroadcastAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<GroupThreemaBroadcastThreemaBroadcastEdgeAggregateSelection>;
  node?: Maybe<GroupThreemaBroadcastThreemaBroadcastNodeAggregateSelection>;
};

export type GroupThreemaBroadcastThreemaBroadcastEdgeAggregateSelection = {
  __typename?: 'GroupThreemaBroadcastThreemaBroadcastEdgeAggregateSelection';
  lastSync: DateTimeAggregateSelection;
  name: StringAggregateSelection;
  threemaId: StringAggregateSelection;
};

export type GroupThreemaBroadcastThreemaBroadcastNodeAggregateSelection = {
  __typename?: 'GroupThreemaBroadcastThreemaBroadcastNodeAggregateSelection';
  apiToken: StringAggregateSelection;
  thremaId: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type GroupThreemaBroadcastUpdateConnectionInput = {
  edge?: InputMaybe<ThreemaBroadcastPropsUpdateInput>;
  node?: InputMaybe<ThreemaBroadcastUpdateInput>;
};

export type GroupThreemaBroadcastUpdateFieldInput = {
  connect?: InputMaybe<Array<GroupThreemaBroadcastConnectFieldInput>>;
  create?: InputMaybe<Array<GroupThreemaBroadcastCreateFieldInput>>;
  delete?: InputMaybe<Array<GroupThreemaBroadcastDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<GroupThreemaBroadcastDisconnectFieldInput>>;
  update?: InputMaybe<GroupThreemaBroadcastUpdateConnectionInput>;
  where?: InputMaybe<GroupThreemaBroadcastConnectionWhere>;
};

export enum GroupType {
  Course = 'course',
  Group = 'group',
}

export type GroupUniqueWhere = {
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type GroupUpdateInput = {
  admins?: InputMaybe<Array<GroupAdminsUpdateFieldInput>>;
  classOrClassGroup?: InputMaybe<GroupClassOrClassGroupUpdateInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  editors?: InputMaybe<Array<GroupEditorsUpdateFieldInput>>;
  foreignRefId?: InputMaybe<Array<Scalars['String']['input']>>;
  foreignRefId_POP?: InputMaybe<Scalars['Int']['input']>;
  foreignRefId_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
  grades?: InputMaybe<Array<Scalars['String']['input']>>;
  grades_POP?: InputMaybe<Scalars['Int']['input']>;
  grades_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
  groups?: InputMaybe<Array<GroupGroupsUpdateFieldInput>>;
  managedBy?: InputMaybe<Scalars['String']['input']>;
  matrixRoomId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nextcloud?: InputMaybe<Array<GroupNextcloudUpdateFieldInput>>;
  organization?: InputMaybe<GroupOrganizationUpdateFieldInput>;
  schoolYear?: InputMaybe<GroupSchoolYearUpdateFieldInput>;
  subject?: InputMaybe<GroupSubjectUpdateFieldInput>;
  teachingTopics?: InputMaybe<Array<GroupTeachingTopicsUpdateFieldInput>>;
  teachingUnits?: InputMaybe<Array<GroupTeachingUnitsUpdateFieldInput>>;
  threemaBroadcast?: InputMaybe<Array<GroupThreemaBroadcastUpdateFieldInput>>;
  type?: InputMaybe<GroupType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  viewers?: InputMaybe<Array<GroupViewersUpdateFieldInput>>;
};

export type GroupViewersAggregateInput = {
  AND?: InputMaybe<Array<GroupViewersAggregateInput>>;
  NOT?: InputMaybe<GroupViewersAggregateInput>;
  OR?: InputMaybe<Array<GroupViewersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<GroupViewersNodeAggregationWhereInput>;
};

export type GroupViewersConnectFieldInput = {
  connect?: InputMaybe<Array<ProfileConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ProfileConnectWhere>;
};

export type GroupViewersConnectOrCreateFieldInput = {
  onCreate: GroupViewersConnectOrCreateFieldInputOnCreate;
  where: ProfileConnectOrCreateWhere;
};

export type GroupViewersConnectOrCreateFieldInputOnCreate = {
  node: ProfileOnCreateInput;
};

export type GroupViewersConnection = {
  __typename?: 'GroupViewersConnection';
  edges: Array<GroupViewersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GroupViewersConnectionSort = {
  node?: InputMaybe<ProfileSort>;
};

export type GroupViewersConnectionWhere = {
  AND?: InputMaybe<Array<GroupViewersConnectionWhere>>;
  NOT?: InputMaybe<GroupViewersConnectionWhere>;
  OR?: InputMaybe<Array<GroupViewersConnectionWhere>>;
  node?: InputMaybe<ProfileWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ProfileWhere>;
};

export type GroupViewersCreateFieldInput = {
  node: ProfileCreateInput;
};

export type GroupViewersDeleteFieldInput = {
  delete?: InputMaybe<ProfileDeleteInput>;
  where?: InputMaybe<GroupViewersConnectionWhere>;
};

export type GroupViewersDisconnectFieldInput = {
  disconnect?: InputMaybe<ProfileDisconnectInput>;
  where?: InputMaybe<GroupViewersConnectionWhere>;
};

export type GroupViewersFieldInput = {
  connect?: InputMaybe<Array<GroupViewersConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<GroupViewersConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<GroupViewersCreateFieldInput>>;
};

export type GroupViewersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<GroupViewersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<GroupViewersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<GroupViewersNodeAggregationWhereInput>>;
  address1_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address1_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address2_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address2_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address3_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address3_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  birthday_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  userUuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  userUuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type GroupViewersRelationship = {
  __typename?: 'GroupViewersRelationship';
  cursor: Scalars['String']['output'];
  node: Profile;
};

export type GroupViewersUpdateConnectionInput = {
  node?: InputMaybe<ProfileUpdateInput>;
};

export type GroupViewersUpdateFieldInput = {
  connect?: InputMaybe<Array<GroupViewersConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<GroupViewersConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<GroupViewersCreateFieldInput>>;
  delete?: InputMaybe<Array<GroupViewersDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<GroupViewersDisconnectFieldInput>>;
  update?: InputMaybe<GroupViewersUpdateConnectionInput>;
  where?: InputMaybe<GroupViewersConnectionWhere>;
};

export type GroupWhere = {
  AND?: InputMaybe<Array<GroupWhere>>;
  NOT?: InputMaybe<GroupWhere>;
  OR?: InputMaybe<Array<GroupWhere>>;
  /** @deprecated Use `admins_SOME` instead. */
  admins?: InputMaybe<ProfileWhere>;
  adminsAggregate?: InputMaybe<GroupAdminsAggregateInput>;
  /** @deprecated Use `adminsConnection_SOME` instead. */
  adminsConnection?: InputMaybe<GroupAdminsConnectionWhere>;
  /** Return Groups where all of the related GroupAdminsConnections match this filter */
  adminsConnection_ALL?: InputMaybe<GroupAdminsConnectionWhere>;
  /** Return Groups where none of the related GroupAdminsConnections match this filter */
  adminsConnection_NONE?: InputMaybe<GroupAdminsConnectionWhere>;
  /** @deprecated Use `adminsConnection_NONE` instead. */
  adminsConnection_NOT?: InputMaybe<GroupAdminsConnectionWhere>;
  /** Return Groups where one of the related GroupAdminsConnections match this filter */
  adminsConnection_SINGLE?: InputMaybe<GroupAdminsConnectionWhere>;
  /** Return Groups where some of the related GroupAdminsConnections match this filter */
  adminsConnection_SOME?: InputMaybe<GroupAdminsConnectionWhere>;
  /** Return Groups where all of the related Profiles match this filter */
  admins_ALL?: InputMaybe<ProfileWhere>;
  /** Return Groups where none of the related Profiles match this filter */
  admins_NONE?: InputMaybe<ProfileWhere>;
  /** @deprecated Use `admins_NONE` instead. */
  admins_NOT?: InputMaybe<ProfileWhere>;
  /** Return Groups where one of the related Profiles match this filter */
  admins_SINGLE?: InputMaybe<ProfileWhere>;
  /** Return Groups where some of the related Profiles match this filter */
  admins_SOME?: InputMaybe<ProfileWhere>;
  allowedProfileUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedProfileUuids_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  allowedProfileUuids_NOT?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  allowedProfileUuids_NOT_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `classOrClassGroup_SOME` instead. */
  classOrClassGroup?: InputMaybe<ClassOrClassGroupWhere>;
  /** @deprecated Use `classOrClassGroupConnection_SOME` instead. */
  classOrClassGroupConnection?: InputMaybe<GroupClassOrClassGroupConnectionWhere>;
  /** Return Groups where all of the related GroupClassOrClassGroupConnections match this filter */
  classOrClassGroupConnection_ALL?: InputMaybe<GroupClassOrClassGroupConnectionWhere>;
  /** Return Groups where none of the related GroupClassOrClassGroupConnections match this filter */
  classOrClassGroupConnection_NONE?: InputMaybe<GroupClassOrClassGroupConnectionWhere>;
  /** @deprecated Use `classOrClassGroupConnection_NONE` instead. */
  classOrClassGroupConnection_NOT?: InputMaybe<GroupClassOrClassGroupConnectionWhere>;
  /** Return Groups where one of the related GroupClassOrClassGroupConnections match this filter */
  classOrClassGroupConnection_SINGLE?: InputMaybe<GroupClassOrClassGroupConnectionWhere>;
  /** Return Groups where some of the related GroupClassOrClassGroupConnections match this filter */
  classOrClassGroupConnection_SOME?: InputMaybe<GroupClassOrClassGroupConnectionWhere>;
  /** Return Groups where all of the related ClassOrClassGroups match this filter */
  classOrClassGroup_ALL?: InputMaybe<ClassOrClassGroupWhere>;
  /** Return Groups where none of the related ClassOrClassGroups match this filter */
  classOrClassGroup_NONE?: InputMaybe<ClassOrClassGroupWhere>;
  /** @deprecated Use `classOrClassGroup_NONE` instead. */
  classOrClassGroup_NOT?: InputMaybe<ClassOrClassGroupWhere>;
  /** Return Groups where one of the related ClassOrClassGroups match this filter */
  classOrClassGroup_SINGLE?: InputMaybe<ClassOrClassGroupWhere>;
  /** Return Groups where some of the related ClassOrClassGroups match this filter */
  classOrClassGroup_SOME?: InputMaybe<ClassOrClassGroupWhere>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  displayName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  displayName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  displayName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `editors_SOME` instead. */
  editors?: InputMaybe<ProfileWhere>;
  editorsAggregate?: InputMaybe<GroupEditorsAggregateInput>;
  /** @deprecated Use `editorsConnection_SOME` instead. */
  editorsConnection?: InputMaybe<GroupEditorsConnectionWhere>;
  /** Return Groups where all of the related GroupEditorsConnections match this filter */
  editorsConnection_ALL?: InputMaybe<GroupEditorsConnectionWhere>;
  /** Return Groups where none of the related GroupEditorsConnections match this filter */
  editorsConnection_NONE?: InputMaybe<GroupEditorsConnectionWhere>;
  /** @deprecated Use `editorsConnection_NONE` instead. */
  editorsConnection_NOT?: InputMaybe<GroupEditorsConnectionWhere>;
  /** Return Groups where one of the related GroupEditorsConnections match this filter */
  editorsConnection_SINGLE?: InputMaybe<GroupEditorsConnectionWhere>;
  /** Return Groups where some of the related GroupEditorsConnections match this filter */
  editorsConnection_SOME?: InputMaybe<GroupEditorsConnectionWhere>;
  /** Return Groups where all of the related Profiles match this filter */
  editors_ALL?: InputMaybe<ProfileWhere>;
  /** Return Groups where none of the related Profiles match this filter */
  editors_NONE?: InputMaybe<ProfileWhere>;
  /** @deprecated Use `editors_NONE` instead. */
  editors_NOT?: InputMaybe<ProfileWhere>;
  /** Return Groups where one of the related Profiles match this filter */
  editors_SINGLE?: InputMaybe<ProfileWhere>;
  /** Return Groups where some of the related Profiles match this filter */
  editors_SOME?: InputMaybe<ProfileWhere>;
  /** @deprecated Use `events_SOME` instead. */
  events?: InputMaybe<CalendarEventWhere>;
  eventsAggregate?: InputMaybe<GroupEventsAggregateInput>;
  /** @deprecated Use `eventsConnection_SOME` instead. */
  eventsConnection?: InputMaybe<GroupEventsConnectionWhere>;
  /** Return Groups where all of the related GroupEventsConnections match this filter */
  eventsConnection_ALL?: InputMaybe<GroupEventsConnectionWhere>;
  /** Return Groups where none of the related GroupEventsConnections match this filter */
  eventsConnection_NONE?: InputMaybe<GroupEventsConnectionWhere>;
  /** @deprecated Use `eventsConnection_NONE` instead. */
  eventsConnection_NOT?: InputMaybe<GroupEventsConnectionWhere>;
  /** Return Groups where one of the related GroupEventsConnections match this filter */
  eventsConnection_SINGLE?: InputMaybe<GroupEventsConnectionWhere>;
  /** Return Groups where some of the related GroupEventsConnections match this filter */
  eventsConnection_SOME?: InputMaybe<GroupEventsConnectionWhere>;
  /** Return Groups where all of the related CalendarEvents match this filter */
  events_ALL?: InputMaybe<CalendarEventWhere>;
  /** Return Groups where none of the related CalendarEvents match this filter */
  events_NONE?: InputMaybe<CalendarEventWhere>;
  /** @deprecated Use `events_NONE` instead. */
  events_NOT?: InputMaybe<CalendarEventWhere>;
  /** Return Groups where one of the related CalendarEvents match this filter */
  events_SINGLE?: InputMaybe<CalendarEventWhere>;
  /** Return Groups where some of the related CalendarEvents match this filter */
  events_SOME?: InputMaybe<CalendarEventWhere>;
  foreignRefId?: InputMaybe<Array<Scalars['String']['input']>>;
  foreignRefId_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignRefId_NOT?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignRefId_NOT_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  grades?: InputMaybe<Array<Scalars['String']['input']>>;
  grades_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  grades_NOT?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  grades_NOT_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `groups_SOME` instead. */
  groups?: InputMaybe<GroupWhere>;
  groupsAggregate?: InputMaybe<GroupGroupsAggregateInput>;
  /** @deprecated Use `groupsConnection_SOME` instead. */
  groupsConnection?: InputMaybe<GroupGroupsConnectionWhere>;
  /** Return Groups where all of the related GroupGroupsConnections match this filter */
  groupsConnection_ALL?: InputMaybe<GroupGroupsConnectionWhere>;
  /** Return Groups where none of the related GroupGroupsConnections match this filter */
  groupsConnection_NONE?: InputMaybe<GroupGroupsConnectionWhere>;
  /** @deprecated Use `groupsConnection_NONE` instead. */
  groupsConnection_NOT?: InputMaybe<GroupGroupsConnectionWhere>;
  /** Return Groups where one of the related GroupGroupsConnections match this filter */
  groupsConnection_SINGLE?: InputMaybe<GroupGroupsConnectionWhere>;
  /** Return Groups where some of the related GroupGroupsConnections match this filter */
  groupsConnection_SOME?: InputMaybe<GroupGroupsConnectionWhere>;
  /** Return Groups where all of the related Groups match this filter */
  groups_ALL?: InputMaybe<GroupWhere>;
  /** Return Groups where none of the related Groups match this filter */
  groups_NONE?: InputMaybe<GroupWhere>;
  /** @deprecated Use `groups_NONE` instead. */
  groups_NOT?: InputMaybe<GroupWhere>;
  /** Return Groups where one of the related Groups match this filter */
  groups_SINGLE?: InputMaybe<GroupWhere>;
  /** Return Groups where some of the related Groups match this filter */
  groups_SOME?: InputMaybe<GroupWhere>;
  inCurrentSchoolyear?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  inCurrentSchoolyear_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  isCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  isCommunity_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  managedBy?: InputMaybe<Scalars['String']['input']>;
  managedBy_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  managedBy_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  managedBy_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  managedBy_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  managedBy_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  managedBy_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  managedBy_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  managedBy_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  managedBy_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  matrixRoomId?: InputMaybe<Scalars['String']['input']>;
  matrixRoomId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  matrixRoomId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  matrixRoomId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  matrixRoomId_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  matrixRoomId_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  matrixRoomId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  matrixRoomId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  matrixRoomId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  matrixRoomId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `nextcloud_SOME` instead. */
  nextcloud?: InputMaybe<NextcloudWhere>;
  nextcloudAggregate?: InputMaybe<GroupNextcloudAggregateInput>;
  /** @deprecated Use `nextcloudConnection_SOME` instead. */
  nextcloudConnection?: InputMaybe<GroupNextcloudConnectionWhere>;
  /** Return Groups where all of the related GroupNextcloudConnections match this filter */
  nextcloudConnection_ALL?: InputMaybe<GroupNextcloudConnectionWhere>;
  /** Return Groups where none of the related GroupNextcloudConnections match this filter */
  nextcloudConnection_NONE?: InputMaybe<GroupNextcloudConnectionWhere>;
  /** @deprecated Use `nextcloudConnection_NONE` instead. */
  nextcloudConnection_NOT?: InputMaybe<GroupNextcloudConnectionWhere>;
  /** Return Groups where one of the related GroupNextcloudConnections match this filter */
  nextcloudConnection_SINGLE?: InputMaybe<GroupNextcloudConnectionWhere>;
  /** Return Groups where some of the related GroupNextcloudConnections match this filter */
  nextcloudConnection_SOME?: InputMaybe<GroupNextcloudConnectionWhere>;
  /** Return Groups where all of the related Nextclouds match this filter */
  nextcloud_ALL?: InputMaybe<NextcloudWhere>;
  /** Return Groups where none of the related Nextclouds match this filter */
  nextcloud_NONE?: InputMaybe<NextcloudWhere>;
  /** @deprecated Use `nextcloud_NONE` instead. */
  nextcloud_NOT?: InputMaybe<NextcloudWhere>;
  /** Return Groups where one of the related Nextclouds match this filter */
  nextcloud_SINGLE?: InputMaybe<NextcloudWhere>;
  /** Return Groups where some of the related Nextclouds match this filter */
  nextcloud_SOME?: InputMaybe<NextcloudWhere>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<GroupOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<GroupOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<GroupOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  schoolYear?: InputMaybe<SchoolYearWhere>;
  schoolYearAggregate?: InputMaybe<GroupSchoolYearAggregateInput>;
  schoolYearConnection?: InputMaybe<GroupSchoolYearConnectionWhere>;
  schoolYearConnection_NOT?: InputMaybe<GroupSchoolYearConnectionWhere>;
  schoolYear_NOT?: InputMaybe<SchoolYearWhere>;
  subject?: InputMaybe<SubjectWhere>;
  subjectAggregate?: InputMaybe<GroupSubjectAggregateInput>;
  subjectConnection?: InputMaybe<GroupSubjectConnectionWhere>;
  subjectConnection_NOT?: InputMaybe<GroupSubjectConnectionWhere>;
  subject_NOT?: InputMaybe<SubjectWhere>;
  /** @deprecated Use `teachingTopics_SOME` instead. */
  teachingTopics?: InputMaybe<TeachingTopicWhere>;
  teachingTopicsAggregate?: InputMaybe<GroupTeachingTopicsAggregateInput>;
  /** @deprecated Use `teachingTopicsConnection_SOME` instead. */
  teachingTopicsConnection?: InputMaybe<GroupTeachingTopicsConnectionWhere>;
  /** Return Groups where all of the related GroupTeachingTopicsConnections match this filter */
  teachingTopicsConnection_ALL?: InputMaybe<GroupTeachingTopicsConnectionWhere>;
  /** Return Groups where none of the related GroupTeachingTopicsConnections match this filter */
  teachingTopicsConnection_NONE?: InputMaybe<GroupTeachingTopicsConnectionWhere>;
  /** @deprecated Use `teachingTopicsConnection_NONE` instead. */
  teachingTopicsConnection_NOT?: InputMaybe<GroupTeachingTopicsConnectionWhere>;
  /** Return Groups where one of the related GroupTeachingTopicsConnections match this filter */
  teachingTopicsConnection_SINGLE?: InputMaybe<GroupTeachingTopicsConnectionWhere>;
  /** Return Groups where some of the related GroupTeachingTopicsConnections match this filter */
  teachingTopicsConnection_SOME?: InputMaybe<GroupTeachingTopicsConnectionWhere>;
  /** Return Groups where all of the related TeachingTopics match this filter */
  teachingTopics_ALL?: InputMaybe<TeachingTopicWhere>;
  /** Return Groups where none of the related TeachingTopics match this filter */
  teachingTopics_NONE?: InputMaybe<TeachingTopicWhere>;
  /** @deprecated Use `teachingTopics_NONE` instead. */
  teachingTopics_NOT?: InputMaybe<TeachingTopicWhere>;
  /** Return Groups where one of the related TeachingTopics match this filter */
  teachingTopics_SINGLE?: InputMaybe<TeachingTopicWhere>;
  /** Return Groups where some of the related TeachingTopics match this filter */
  teachingTopics_SOME?: InputMaybe<TeachingTopicWhere>;
  /** @deprecated Use `teachingUnits_SOME` instead. */
  teachingUnits?: InputMaybe<TeachingUnitWhere>;
  teachingUnitsAggregate?: InputMaybe<GroupTeachingUnitsAggregateInput>;
  /** @deprecated Use `teachingUnitsConnection_SOME` instead. */
  teachingUnitsConnection?: InputMaybe<GroupTeachingUnitsConnectionWhere>;
  /** Return Groups where all of the related GroupTeachingUnitsConnections match this filter */
  teachingUnitsConnection_ALL?: InputMaybe<GroupTeachingUnitsConnectionWhere>;
  /** Return Groups where none of the related GroupTeachingUnitsConnections match this filter */
  teachingUnitsConnection_NONE?: InputMaybe<GroupTeachingUnitsConnectionWhere>;
  /** @deprecated Use `teachingUnitsConnection_NONE` instead. */
  teachingUnitsConnection_NOT?: InputMaybe<GroupTeachingUnitsConnectionWhere>;
  /** Return Groups where one of the related GroupTeachingUnitsConnections match this filter */
  teachingUnitsConnection_SINGLE?: InputMaybe<GroupTeachingUnitsConnectionWhere>;
  /** Return Groups where some of the related GroupTeachingUnitsConnections match this filter */
  teachingUnitsConnection_SOME?: InputMaybe<GroupTeachingUnitsConnectionWhere>;
  /** Return Groups where all of the related TeachingUnits match this filter */
  teachingUnits_ALL?: InputMaybe<TeachingUnitWhere>;
  /** Return Groups where none of the related TeachingUnits match this filter */
  teachingUnits_NONE?: InputMaybe<TeachingUnitWhere>;
  /** @deprecated Use `teachingUnits_NONE` instead. */
  teachingUnits_NOT?: InputMaybe<TeachingUnitWhere>;
  /** Return Groups where one of the related TeachingUnits match this filter */
  teachingUnits_SINGLE?: InputMaybe<TeachingUnitWhere>;
  /** Return Groups where some of the related TeachingUnits match this filter */
  teachingUnits_SOME?: InputMaybe<TeachingUnitWhere>;
  /** @deprecated Use `threemaBroadcast_SOME` instead. */
  threemaBroadcast?: InputMaybe<ThreemaBroadcastWhere>;
  threemaBroadcastAggregate?: InputMaybe<GroupThreemaBroadcastAggregateInput>;
  /** @deprecated Use `threemaBroadcastConnection_SOME` instead. */
  threemaBroadcastConnection?: InputMaybe<GroupThreemaBroadcastConnectionWhere>;
  /** Return Groups where all of the related GroupThreemaBroadcastConnections match this filter */
  threemaBroadcastConnection_ALL?: InputMaybe<GroupThreemaBroadcastConnectionWhere>;
  /** Return Groups where none of the related GroupThreemaBroadcastConnections match this filter */
  threemaBroadcastConnection_NONE?: InputMaybe<GroupThreemaBroadcastConnectionWhere>;
  /** @deprecated Use `threemaBroadcastConnection_NONE` instead. */
  threemaBroadcastConnection_NOT?: InputMaybe<GroupThreemaBroadcastConnectionWhere>;
  /** Return Groups where one of the related GroupThreemaBroadcastConnections match this filter */
  threemaBroadcastConnection_SINGLE?: InputMaybe<GroupThreemaBroadcastConnectionWhere>;
  /** Return Groups where some of the related GroupThreemaBroadcastConnections match this filter */
  threemaBroadcastConnection_SOME?: InputMaybe<GroupThreemaBroadcastConnectionWhere>;
  /** Return Groups where all of the related ThreemaBroadcasts match this filter */
  threemaBroadcast_ALL?: InputMaybe<ThreemaBroadcastWhere>;
  /** Return Groups where none of the related ThreemaBroadcasts match this filter */
  threemaBroadcast_NONE?: InputMaybe<ThreemaBroadcastWhere>;
  /** @deprecated Use `threemaBroadcast_NONE` instead. */
  threemaBroadcast_NOT?: InputMaybe<ThreemaBroadcastWhere>;
  /** Return Groups where one of the related ThreemaBroadcasts match this filter */
  threemaBroadcast_SINGLE?: InputMaybe<ThreemaBroadcastWhere>;
  /** Return Groups where some of the related ThreemaBroadcasts match this filter */
  threemaBroadcast_SOME?: InputMaybe<ThreemaBroadcastWhere>;
  type?: InputMaybe<GroupType>;
  type_IN?: InputMaybe<Array<GroupType>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  type_NOT?: InputMaybe<GroupType>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  type_NOT_IN?: InputMaybe<Array<GroupType>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Use `viewers_SOME` instead. */
  viewers?: InputMaybe<ProfileWhere>;
  viewersAggregate?: InputMaybe<GroupViewersAggregateInput>;
  /** @deprecated Use `viewersConnection_SOME` instead. */
  viewersConnection?: InputMaybe<GroupViewersConnectionWhere>;
  /** Return Groups where all of the related GroupViewersConnections match this filter */
  viewersConnection_ALL?: InputMaybe<GroupViewersConnectionWhere>;
  /** Return Groups where none of the related GroupViewersConnections match this filter */
  viewersConnection_NONE?: InputMaybe<GroupViewersConnectionWhere>;
  /** @deprecated Use `viewersConnection_NONE` instead. */
  viewersConnection_NOT?: InputMaybe<GroupViewersConnectionWhere>;
  /** Return Groups where one of the related GroupViewersConnections match this filter */
  viewersConnection_SINGLE?: InputMaybe<GroupViewersConnectionWhere>;
  /** Return Groups where some of the related GroupViewersConnections match this filter */
  viewersConnection_SOME?: InputMaybe<GroupViewersConnectionWhere>;
  /** Return Groups where all of the related Profiles match this filter */
  viewers_ALL?: InputMaybe<ProfileWhere>;
  /** Return Groups where none of the related Profiles match this filter */
  viewers_NONE?: InputMaybe<ProfileWhere>;
  /** @deprecated Use `viewers_NONE` instead. */
  viewers_NOT?: InputMaybe<ProfileWhere>;
  /** Return Groups where one of the related Profiles match this filter */
  viewers_SINGLE?: InputMaybe<ProfileWhere>;
  /** Return Groups where some of the related Profiles match this filter */
  viewers_SOME?: InputMaybe<ProfileWhere>;
};

export type GroupsConnection = {
  __typename?: 'GroupsConnection';
  edges: Array<GroupEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type IdAggregateSelection = {
  __typename?: 'IDAggregateSelection';
  longest?: Maybe<Scalars['ID']['output']>;
  shortest?: Maybe<Scalars['ID']['output']>;
};

export type IntAggregateSelection = {
  __typename?: 'IntAggregateSelection';
  average?: Maybe<Scalars['Float']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  sum?: Maybe<Scalars['Int']['output']>;
};

/**
 * The edge properties for the following fields:
 * * Organization.licensedProducts
 * * Bildungsplattform.organization
 * * BigBlueButton.organization
 * * Zoom.organization
 * * Nextcloud.organization
 * * Threema.organization
 * * ThreemaBroadcast.organization
 */
export type LicenseProperties = {
  __typename?: 'LicenseProperties';
  /** Optional. Possible reference(id) of a contract-object in tecart */
  contractRef?: Maybe<Scalars['String']['output']>;
  /** Optional. If not set, the license is always valid in the future. */
  notAfter?: Maybe<Scalars['DateTime']['output']>;
  /** Optional. If not set, the license is always valid in the past. */
  notBefore?: Maybe<Scalars['DateTime']['output']>;
  /** Optional. If there are different versions of this product */
  version?: Maybe<Scalars['String']['output']>;
};

export type LicensePropertiesAggregationWhereInput = {
  AND?: InputMaybe<Array<LicensePropertiesAggregationWhereInput>>;
  NOT?: InputMaybe<LicensePropertiesAggregationWhereInput>;
  OR?: InputMaybe<Array<LicensePropertiesAggregationWhereInput>>;
  contractRef_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contractRef_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contractRef_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contractRef_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contractRef_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contractRef_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contractRef_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contractRef_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contractRef_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contractRef_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contractRef_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contractRef_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contractRef_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contractRef_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contractRef_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  notAfter_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  notAfter_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  notAfter_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  notAfter_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  notAfter_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  notAfter_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  notAfter_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  notAfter_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  notAfter_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  notAfter_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  notBefore_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  notBefore_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  notBefore_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  notBefore_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  notBefore_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  notBefore_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  notBefore_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  notBefore_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  notBefore_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  notBefore_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  version_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  version_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  version_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type LicensePropertiesCreateInput = {
  contractRef?: InputMaybe<Scalars['String']['input']>;
  notAfter?: InputMaybe<Scalars['DateTime']['input']>;
  notBefore?: InputMaybe<Scalars['DateTime']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type LicensePropertiesSort = {
  contractRef?: InputMaybe<SortDirection>;
  notAfter?: InputMaybe<SortDirection>;
  notBefore?: InputMaybe<SortDirection>;
  version?: InputMaybe<SortDirection>;
};

export type LicensePropertiesUpdateInput = {
  contractRef?: InputMaybe<Scalars['String']['input']>;
  notAfter?: InputMaybe<Scalars['DateTime']['input']>;
  notBefore?: InputMaybe<Scalars['DateTime']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type LicensePropertiesWhere = {
  AND?: InputMaybe<Array<LicensePropertiesWhere>>;
  NOT?: InputMaybe<LicensePropertiesWhere>;
  OR?: InputMaybe<Array<LicensePropertiesWhere>>;
  contractRef?: InputMaybe<Scalars['String']['input']>;
  contractRef_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  contractRef_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  contractRef_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  contractRef_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  contractRef_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  contractRef_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  contractRef_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  contractRef_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  contractRef_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  notAfter?: InputMaybe<Scalars['DateTime']['input']>;
  notAfter_GT?: InputMaybe<Scalars['DateTime']['input']>;
  notAfter_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  notAfter_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  notAfter_LT?: InputMaybe<Scalars['DateTime']['input']>;
  notAfter_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  notAfter_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  notAfter_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  notBefore?: InputMaybe<Scalars['DateTime']['input']>;
  notBefore_GT?: InputMaybe<Scalars['DateTime']['input']>;
  notBefore_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  notBefore_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  notBefore_LT?: InputMaybe<Scalars['DateTime']['input']>;
  notBefore_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  notBefore_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  notBefore_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  version?: InputMaybe<Scalars['String']['input']>;
  version_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  version_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  version_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  version_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  version_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  version_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  version_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  version_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  version_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type LicensedProduct = BigBlueButton | Bildungsplattform | Nextcloud | Threema | ThreemaBroadcast | Zoom;

export type LicensedProductWhere = {
  BigBlueButton?: InputMaybe<BigBlueButtonWhere>;
  Bildungsplattform?: InputMaybe<BildungsplattformWhere>;
  Nextcloud?: InputMaybe<NextcloudWhere>;
  Threema?: InputMaybe<ThreemaWhere>;
  ThreemaBroadcast?: InputMaybe<ThreemaBroadcastWhere>;
  Zoom?: InputMaybe<ZoomWhere>;
};

export type Location = {
  __typename?: 'Location';
  coordinates?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  locationTypes?: Maybe<Array<Scalars['String']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  organizationAggregate?: Maybe<LocationOrganizationOrganizationAggregationSelection>;
  organizationConnection: LocationOrganizationConnection;
  relativeTo?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};

export type LocationOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type LocationOrganizationAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OrganizationWhere>;
};

export type LocationOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<LocationOrganizationConnectionSort>>;
  where?: InputMaybe<LocationOrganizationConnectionWhere>;
};

export type LocationAggregateSelection = {
  __typename?: 'LocationAggregateSelection';
  coordinates: StringAggregateSelection;
  count: Scalars['Int']['output'];
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  relativeTo: StringAggregateSelection;
  timeZone: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type LocationConnectInput = {
  organization?: InputMaybe<LocationOrganizationConnectFieldInput>;
};

export type LocationConnectWhere = {
  node: LocationWhere;
};

export type LocationCreateInput = {
  coordinates?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  locationTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<LocationOrganizationFieldInput>;
  relativeTo?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type LocationDeleteInput = {
  organization?: InputMaybe<LocationOrganizationDeleteFieldInput>;
};

export type LocationDisconnectInput = {
  organization?: InputMaybe<LocationOrganizationDisconnectFieldInput>;
};

export type LocationEdge = {
  __typename?: 'LocationEdge';
  cursor: Scalars['String']['output'];
  node: Location;
};

export type LocationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more LocationSort objects to sort Locations by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<LocationSort>>;
};

export type LocationOrganizationAggregateInput = {
  AND?: InputMaybe<Array<LocationOrganizationAggregateInput>>;
  NOT?: InputMaybe<LocationOrganizationAggregateInput>;
  OR?: InputMaybe<Array<LocationOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<LocationOrganizationNodeAggregationWhereInput>;
};

export type LocationOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type LocationOrganizationConnectOrCreateFieldInput = {
  onCreate: LocationOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type LocationOrganizationConnectOrCreateFieldInputOnCreate = {
  node: OrganizationOnCreateInput;
};

export type LocationOrganizationConnection = {
  __typename?: 'LocationOrganizationConnection';
  edges: Array<LocationOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LocationOrganizationConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type LocationOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<LocationOrganizationConnectionWhere>>;
  NOT?: InputMaybe<LocationOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<LocationOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type LocationOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type LocationOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<LocationOrganizationConnectionWhere>;
};

export type LocationOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<LocationOrganizationConnectionWhere>;
};

export type LocationOrganizationFieldInput = {
  connect?: InputMaybe<LocationOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<LocationOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<LocationOrganizationCreateFieldInput>;
};

export type LocationOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<LocationOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<LocationOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<LocationOrganizationNodeAggregationWhereInput>>;
  aboutInfoLastUpdated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type LocationOrganizationOrganizationAggregationSelection = {
  __typename?: 'LocationOrganizationOrganizationAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<LocationOrganizationOrganizationNodeAggregateSelection>;
};

export type LocationOrganizationOrganizationNodeAggregateSelection = {
  __typename?: 'LocationOrganizationOrganizationNodeAggregateSelection';
  aboutInfo: StringAggregateSelection;
  aboutInfoLastUpdated: DateTimeAggregateSelection;
  displayName: StringAggregateSelection;
  matrixRoomId: StringAggregateSelection;
  planungSyncProps: StringAggregateSelection;
  procuratSyncProps: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type LocationOrganizationRelationship = {
  __typename?: 'LocationOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type LocationOrganizationUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type LocationOrganizationUpdateFieldInput = {
  connect?: InputMaybe<LocationOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<LocationOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<LocationOrganizationCreateFieldInput>;
  delete?: InputMaybe<LocationOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<LocationOrganizationDisconnectFieldInput>;
  update?: InputMaybe<LocationOrganizationUpdateConnectionInput>;
  where?: InputMaybe<LocationOrganizationConnectionWhere>;
};

/** Fields to sort Locations by. The order in which sorts are applied is not guaranteed when specifying many fields in one LocationSort object. */
export type LocationSort = {
  coordinates?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  relativeTo?: InputMaybe<SortDirection>;
  timeZone?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type LocationUpdateInput = {
  coordinates?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  locationTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  locationTypes_POP?: InputMaybe<Scalars['Int']['input']>;
  locationTypes_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<LocationOrganizationUpdateFieldInput>;
  relativeTo?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type LocationWhere = {
  AND?: InputMaybe<Array<LocationWhere>>;
  NOT?: InputMaybe<LocationWhere>;
  OR?: InputMaybe<Array<LocationWhere>>;
  coordinates?: InputMaybe<Scalars['String']['input']>;
  coordinates_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  coordinates_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  coordinates_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  coordinates_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  coordinates_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  coordinates_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  coordinates_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  coordinates_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  coordinates_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  locationTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  locationTypes_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  locationTypes_NOT?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  locationTypes_NOT_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<LocationOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<LocationOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<LocationOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  relativeTo?: InputMaybe<Scalars['String']['input']>;
  relativeTo_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  relativeTo_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  relativeTo_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  relativeTo_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  relativeTo_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  relativeTo_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  relativeTo_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  relativeTo_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  relativeTo_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  timeZone_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  timeZone_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  timeZone_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  timeZone_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  timeZone_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  timeZone_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  timeZone_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  timeZone_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  timeZone_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type LocationsConnection = {
  __typename?: 'LocationsConnection';
  edges: Array<LocationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Material = {
  __typename?: 'Material';
  created: Scalars['DateTime']['output'];
  fileEntries: Array<FileEntry>;
  fileEntriesAggregate?: Maybe<MaterialFileEntryFileEntriesAggregationSelection>;
  fileEntriesConnection: MaterialFileEntriesConnection;
  holder: MaterialHolder;
  holderConnection: MaterialHolderConnection;
  text?: Maybe<Scalars['String']['output']>;
  textMediaType: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  uuid: Scalars['ID']['output'];
  viewers: Array<Scalars['String']['output']>;
};

export type MaterialFileEntriesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FileEntryOptions>;
  where?: InputMaybe<FileEntryWhere>;
};

export type MaterialFileEntriesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FileEntryWhere>;
};

export type MaterialFileEntriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<MaterialFileEntriesConnectionSort>>;
  where?: InputMaybe<MaterialFileEntriesConnectionWhere>;
};

export type MaterialHolderArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<MaterialHolderWhere>;
};

export type MaterialHolderConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MaterialHolderConnectionWhere>;
};

export type MaterialAggregateSelection = {
  __typename?: 'MaterialAggregateSelection';
  count: Scalars['Int']['output'];
  created: DateTimeAggregateSelection;
  text: StringAggregateSelection;
  textMediaType: StringAggregateSelection;
  updated: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type MaterialConnectInput = {
  fileEntries?: InputMaybe<Array<MaterialFileEntriesConnectFieldInput>>;
  holder?: InputMaybe<MaterialHolderConnectInput>;
};

export type MaterialConnectWhere = {
  node: MaterialWhere;
};

export type MaterialCreateInput = {
  fileEntries?: InputMaybe<MaterialFileEntriesFieldInput>;
  holder?: InputMaybe<MaterialHolderCreateInput>;
  text?: InputMaybe<Scalars['String']['input']>;
  textMediaType?: Scalars['String']['input'];
};

export type MaterialDeleteInput = {
  fileEntries?: InputMaybe<Array<MaterialFileEntriesDeleteFieldInput>>;
  holder?: InputMaybe<MaterialHolderDeleteInput>;
};

export type MaterialDisconnectInput = {
  fileEntries?: InputMaybe<Array<MaterialFileEntriesDisconnectFieldInput>>;
  holder?: InputMaybe<MaterialHolderDisconnectInput>;
};

export type MaterialEdge = {
  __typename?: 'MaterialEdge';
  cursor: Scalars['String']['output'];
  node: Material;
};

export type MaterialFileEntriesAggregateInput = {
  AND?: InputMaybe<Array<MaterialFileEntriesAggregateInput>>;
  NOT?: InputMaybe<MaterialFileEntriesAggregateInput>;
  OR?: InputMaybe<Array<MaterialFileEntriesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<OrderedRelationPropertiesAggregationWhereInput>;
  node?: InputMaybe<MaterialFileEntriesNodeAggregationWhereInput>;
};

export type MaterialFileEntriesConnectFieldInput = {
  connect?: InputMaybe<Array<FileEntryConnectInput>>;
  edge: OrderedRelationPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<FileEntryConnectWhere>;
};

export type MaterialFileEntriesConnection = {
  __typename?: 'MaterialFileEntriesConnection';
  edges: Array<MaterialFileEntriesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MaterialFileEntriesConnectionSort = {
  edge?: InputMaybe<OrderedRelationPropertiesSort>;
  node?: InputMaybe<FileEntrySort>;
};

export type MaterialFileEntriesConnectionWhere = {
  AND?: InputMaybe<Array<MaterialFileEntriesConnectionWhere>>;
  NOT?: InputMaybe<MaterialFileEntriesConnectionWhere>;
  OR?: InputMaybe<Array<MaterialFileEntriesConnectionWhere>>;
  edge?: InputMaybe<OrderedRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<OrderedRelationPropertiesWhere>;
  node?: InputMaybe<FileEntryWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<FileEntryWhere>;
};

export type MaterialFileEntriesCreateFieldInput = {
  edge: OrderedRelationPropertiesCreateInput;
  node: FileEntryCreateInput;
};

export type MaterialFileEntriesDeleteFieldInput = {
  delete?: InputMaybe<FileEntryDeleteInput>;
  where?: InputMaybe<MaterialFileEntriesConnectionWhere>;
};

export type MaterialFileEntriesDisconnectFieldInput = {
  disconnect?: InputMaybe<FileEntryDisconnectInput>;
  where?: InputMaybe<MaterialFileEntriesConnectionWhere>;
};

export type MaterialFileEntriesFieldInput = {
  connect?: InputMaybe<Array<MaterialFileEntriesConnectFieldInput>>;
  create?: InputMaybe<Array<MaterialFileEntriesCreateFieldInput>>;
};

export type MaterialFileEntriesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<MaterialFileEntriesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<MaterialFileEntriesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<MaterialFileEntriesNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  filename_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filename_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filename_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filename_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filename_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filename_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filename_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filename_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filename_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filename_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filename_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filename_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filename_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filename_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filename_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mediaType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  mediaType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  mediaType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  mediaType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  mediaType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  mediaType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mediaType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mediaType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mediaType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mediaType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mediaType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mediaType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mediaType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mediaType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mediaType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  size_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MaterialFileEntriesRelationship = {
  __typename?: 'MaterialFileEntriesRelationship';
  cursor: Scalars['String']['output'];
  node: FileEntry;
  properties: OrderedRelationProperties;
};

export type MaterialFileEntriesUpdateConnectionInput = {
  edge?: InputMaybe<OrderedRelationPropertiesUpdateInput>;
  node?: InputMaybe<FileEntryUpdateInput>;
};

export type MaterialFileEntriesUpdateFieldInput = {
  connect?: InputMaybe<Array<MaterialFileEntriesConnectFieldInput>>;
  create?: InputMaybe<Array<MaterialFileEntriesCreateFieldInput>>;
  delete?: InputMaybe<Array<MaterialFileEntriesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<MaterialFileEntriesDisconnectFieldInput>>;
  update?: InputMaybe<MaterialFileEntriesUpdateConnectionInput>;
  where?: InputMaybe<MaterialFileEntriesConnectionWhere>;
};

export type MaterialFileEntryFileEntriesAggregationSelection = {
  __typename?: 'MaterialFileEntryFileEntriesAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<MaterialFileEntryFileEntriesEdgeAggregateSelection>;
  node?: Maybe<MaterialFileEntryFileEntriesNodeAggregateSelection>;
};

export type MaterialFileEntryFileEntriesEdgeAggregateSelection = {
  __typename?: 'MaterialFileEntryFileEntriesEdgeAggregateSelection';
  order: IntAggregateSelection;
};

export type MaterialFileEntryFileEntriesNodeAggregateSelection = {
  __typename?: 'MaterialFileEntryFileEntriesNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  filename: StringAggregateSelection;
  mediaType: StringAggregateSelection;
  size: IntAggregateSelection;
  updated: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type MaterialHolder = Assignment | Submission | TeachingUnit | WorkMaterial;

export type MaterialHolderAssignmentConnectFieldInput = {
  connect?: InputMaybe<AssignmentConnectInput>;
  where?: InputMaybe<AssignmentConnectWhere>;
};

export type MaterialHolderAssignmentConnectionWhere = {
  AND?: InputMaybe<Array<MaterialHolderAssignmentConnectionWhere>>;
  NOT?: InputMaybe<MaterialHolderAssignmentConnectionWhere>;
  OR?: InputMaybe<Array<MaterialHolderAssignmentConnectionWhere>>;
  node?: InputMaybe<AssignmentWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<AssignmentWhere>;
};

export type MaterialHolderAssignmentCreateFieldInput = {
  node: AssignmentCreateInput;
};

export type MaterialHolderAssignmentDeleteFieldInput = {
  delete?: InputMaybe<AssignmentDeleteInput>;
  where?: InputMaybe<MaterialHolderAssignmentConnectionWhere>;
};

export type MaterialHolderAssignmentDisconnectFieldInput = {
  disconnect?: InputMaybe<AssignmentDisconnectInput>;
  where?: InputMaybe<MaterialHolderAssignmentConnectionWhere>;
};

export type MaterialHolderAssignmentFieldInput = {
  connect?: InputMaybe<MaterialHolderAssignmentConnectFieldInput>;
  create?: InputMaybe<MaterialHolderAssignmentCreateFieldInput>;
};

export type MaterialHolderAssignmentUpdateConnectionInput = {
  node?: InputMaybe<AssignmentUpdateInput>;
};

export type MaterialHolderAssignmentUpdateFieldInput = {
  connect?: InputMaybe<MaterialHolderAssignmentConnectFieldInput>;
  create?: InputMaybe<MaterialHolderAssignmentCreateFieldInput>;
  delete?: InputMaybe<MaterialHolderAssignmentDeleteFieldInput>;
  disconnect?: InputMaybe<MaterialHolderAssignmentDisconnectFieldInput>;
  update?: InputMaybe<MaterialHolderAssignmentUpdateConnectionInput>;
  where?: InputMaybe<MaterialHolderAssignmentConnectionWhere>;
};

export type MaterialHolderConnectInput = {
  Assignment?: InputMaybe<MaterialHolderAssignmentConnectFieldInput>;
  Submission?: InputMaybe<MaterialHolderSubmissionConnectFieldInput>;
  TeachingUnit?: InputMaybe<MaterialHolderTeachingUnitConnectFieldInput>;
  WorkMaterial?: InputMaybe<MaterialHolderWorkMaterialConnectFieldInput>;
};

export type MaterialHolderConnection = {
  __typename?: 'MaterialHolderConnection';
  edges: Array<MaterialHolderRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MaterialHolderConnectionWhere = {
  Assignment?: InputMaybe<MaterialHolderAssignmentConnectionWhere>;
  Submission?: InputMaybe<MaterialHolderSubmissionConnectionWhere>;
  TeachingUnit?: InputMaybe<MaterialHolderTeachingUnitConnectionWhere>;
  WorkMaterial?: InputMaybe<MaterialHolderWorkMaterialConnectionWhere>;
};

export type MaterialHolderCreateInput = {
  Assignment?: InputMaybe<MaterialHolderAssignmentFieldInput>;
  Submission?: InputMaybe<MaterialHolderSubmissionFieldInput>;
  TeachingUnit?: InputMaybe<MaterialHolderTeachingUnitFieldInput>;
  WorkMaterial?: InputMaybe<MaterialHolderWorkMaterialFieldInput>;
};

export type MaterialHolderDeleteInput = {
  Assignment?: InputMaybe<MaterialHolderAssignmentDeleteFieldInput>;
  Submission?: InputMaybe<MaterialHolderSubmissionDeleteFieldInput>;
  TeachingUnit?: InputMaybe<MaterialHolderTeachingUnitDeleteFieldInput>;
  WorkMaterial?: InputMaybe<MaterialHolderWorkMaterialDeleteFieldInput>;
};

export type MaterialHolderDisconnectInput = {
  Assignment?: InputMaybe<MaterialHolderAssignmentDisconnectFieldInput>;
  Submission?: InputMaybe<MaterialHolderSubmissionDisconnectFieldInput>;
  TeachingUnit?: InputMaybe<MaterialHolderTeachingUnitDisconnectFieldInput>;
  WorkMaterial?: InputMaybe<MaterialHolderWorkMaterialDisconnectFieldInput>;
};

export type MaterialHolderRelationship = {
  __typename?: 'MaterialHolderRelationship';
  cursor: Scalars['String']['output'];
  node: MaterialHolder;
};

export type MaterialHolderSubmissionConnectFieldInput = {
  connect?: InputMaybe<SubmissionConnectInput>;
  where?: InputMaybe<SubmissionConnectWhere>;
};

export type MaterialHolderSubmissionConnectionWhere = {
  AND?: InputMaybe<Array<MaterialHolderSubmissionConnectionWhere>>;
  NOT?: InputMaybe<MaterialHolderSubmissionConnectionWhere>;
  OR?: InputMaybe<Array<MaterialHolderSubmissionConnectionWhere>>;
  node?: InputMaybe<SubmissionWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SubmissionWhere>;
};

export type MaterialHolderSubmissionCreateFieldInput = {
  node: SubmissionCreateInput;
};

export type MaterialHolderSubmissionDeleteFieldInput = {
  delete?: InputMaybe<SubmissionDeleteInput>;
  where?: InputMaybe<MaterialHolderSubmissionConnectionWhere>;
};

export type MaterialHolderSubmissionDisconnectFieldInput = {
  disconnect?: InputMaybe<SubmissionDisconnectInput>;
  where?: InputMaybe<MaterialHolderSubmissionConnectionWhere>;
};

export type MaterialHolderSubmissionFieldInput = {
  connect?: InputMaybe<MaterialHolderSubmissionConnectFieldInput>;
  create?: InputMaybe<MaterialHolderSubmissionCreateFieldInput>;
};

export type MaterialHolderSubmissionUpdateConnectionInput = {
  node?: InputMaybe<SubmissionUpdateInput>;
};

export type MaterialHolderSubmissionUpdateFieldInput = {
  connect?: InputMaybe<MaterialHolderSubmissionConnectFieldInput>;
  create?: InputMaybe<MaterialHolderSubmissionCreateFieldInput>;
  delete?: InputMaybe<MaterialHolderSubmissionDeleteFieldInput>;
  disconnect?: InputMaybe<MaterialHolderSubmissionDisconnectFieldInput>;
  update?: InputMaybe<MaterialHolderSubmissionUpdateConnectionInput>;
  where?: InputMaybe<MaterialHolderSubmissionConnectionWhere>;
};

export type MaterialHolderTeachingUnitConnectFieldInput = {
  connect?: InputMaybe<TeachingUnitConnectInput>;
  where?: InputMaybe<TeachingUnitConnectWhere>;
};

export type MaterialHolderTeachingUnitConnectionWhere = {
  AND?: InputMaybe<Array<MaterialHolderTeachingUnitConnectionWhere>>;
  NOT?: InputMaybe<MaterialHolderTeachingUnitConnectionWhere>;
  OR?: InputMaybe<Array<MaterialHolderTeachingUnitConnectionWhere>>;
  node?: InputMaybe<TeachingUnitWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TeachingUnitWhere>;
};

export type MaterialHolderTeachingUnitCreateFieldInput = {
  node: TeachingUnitCreateInput;
};

export type MaterialHolderTeachingUnitDeleteFieldInput = {
  delete?: InputMaybe<TeachingUnitDeleteInput>;
  where?: InputMaybe<MaterialHolderTeachingUnitConnectionWhere>;
};

export type MaterialHolderTeachingUnitDisconnectFieldInput = {
  disconnect?: InputMaybe<TeachingUnitDisconnectInput>;
  where?: InputMaybe<MaterialHolderTeachingUnitConnectionWhere>;
};

export type MaterialHolderTeachingUnitFieldInput = {
  connect?: InputMaybe<MaterialHolderTeachingUnitConnectFieldInput>;
  create?: InputMaybe<MaterialHolderTeachingUnitCreateFieldInput>;
};

export type MaterialHolderTeachingUnitUpdateConnectionInput = {
  node?: InputMaybe<TeachingUnitUpdateInput>;
};

export type MaterialHolderTeachingUnitUpdateFieldInput = {
  connect?: InputMaybe<MaterialHolderTeachingUnitConnectFieldInput>;
  create?: InputMaybe<MaterialHolderTeachingUnitCreateFieldInput>;
  delete?: InputMaybe<MaterialHolderTeachingUnitDeleteFieldInput>;
  disconnect?: InputMaybe<MaterialHolderTeachingUnitDisconnectFieldInput>;
  update?: InputMaybe<MaterialHolderTeachingUnitUpdateConnectionInput>;
  where?: InputMaybe<MaterialHolderTeachingUnitConnectionWhere>;
};

export type MaterialHolderUpdateInput = {
  Assignment?: InputMaybe<MaterialHolderAssignmentUpdateFieldInput>;
  Submission?: InputMaybe<MaterialHolderSubmissionUpdateFieldInput>;
  TeachingUnit?: InputMaybe<MaterialHolderTeachingUnitUpdateFieldInput>;
  WorkMaterial?: InputMaybe<MaterialHolderWorkMaterialUpdateFieldInput>;
};

export type MaterialHolderWhere = {
  Assignment?: InputMaybe<AssignmentWhere>;
  Submission?: InputMaybe<SubmissionWhere>;
  TeachingUnit?: InputMaybe<TeachingUnitWhere>;
  WorkMaterial?: InputMaybe<WorkMaterialWhere>;
};

export type MaterialHolderWorkMaterialConnectFieldInput = {
  connect?: InputMaybe<WorkMaterialConnectInput>;
  where?: InputMaybe<WorkMaterialConnectWhere>;
};

export type MaterialHolderWorkMaterialConnectionWhere = {
  AND?: InputMaybe<Array<MaterialHolderWorkMaterialConnectionWhere>>;
  NOT?: InputMaybe<MaterialHolderWorkMaterialConnectionWhere>;
  OR?: InputMaybe<Array<MaterialHolderWorkMaterialConnectionWhere>>;
  node?: InputMaybe<WorkMaterialWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<WorkMaterialWhere>;
};

export type MaterialHolderWorkMaterialCreateFieldInput = {
  node: WorkMaterialCreateInput;
};

export type MaterialHolderWorkMaterialDeleteFieldInput = {
  delete?: InputMaybe<WorkMaterialDeleteInput>;
  where?: InputMaybe<MaterialHolderWorkMaterialConnectionWhere>;
};

export type MaterialHolderWorkMaterialDisconnectFieldInput = {
  disconnect?: InputMaybe<WorkMaterialDisconnectInput>;
  where?: InputMaybe<MaterialHolderWorkMaterialConnectionWhere>;
};

export type MaterialHolderWorkMaterialFieldInput = {
  connect?: InputMaybe<MaterialHolderWorkMaterialConnectFieldInput>;
  create?: InputMaybe<MaterialHolderWorkMaterialCreateFieldInput>;
};

export type MaterialHolderWorkMaterialUpdateConnectionInput = {
  node?: InputMaybe<WorkMaterialUpdateInput>;
};

export type MaterialHolderWorkMaterialUpdateFieldInput = {
  connect?: InputMaybe<MaterialHolderWorkMaterialConnectFieldInput>;
  create?: InputMaybe<MaterialHolderWorkMaterialCreateFieldInput>;
  delete?: InputMaybe<MaterialHolderWorkMaterialDeleteFieldInput>;
  disconnect?: InputMaybe<MaterialHolderWorkMaterialDisconnectFieldInput>;
  update?: InputMaybe<MaterialHolderWorkMaterialUpdateConnectionInput>;
  where?: InputMaybe<MaterialHolderWorkMaterialConnectionWhere>;
};

export type MaterialOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more MaterialSort objects to sort Materials by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<MaterialSort>>;
};

/** Fields to sort Materials by. The order in which sorts are applied is not guaranteed when specifying many fields in one MaterialSort object. */
export type MaterialSort = {
  created?: InputMaybe<SortDirection>;
  text?: InputMaybe<SortDirection>;
  textMediaType?: InputMaybe<SortDirection>;
  updated?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type MaterialUpdateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  fileEntries?: InputMaybe<Array<MaterialFileEntriesUpdateFieldInput>>;
  holder?: InputMaybe<MaterialHolderUpdateInput>;
  text?: InputMaybe<Scalars['String']['input']>;
  textMediaType?: InputMaybe<Scalars['String']['input']>;
};

export type MaterialWhere = {
  AND?: InputMaybe<Array<MaterialWhere>>;
  NOT?: InputMaybe<MaterialWhere>;
  OR?: InputMaybe<Array<MaterialWhere>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  created_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  created_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  /** @deprecated Use `fileEntries_SOME` instead. */
  fileEntries?: InputMaybe<FileEntryWhere>;
  fileEntriesAggregate?: InputMaybe<MaterialFileEntriesAggregateInput>;
  /** @deprecated Use `fileEntriesConnection_SOME` instead. */
  fileEntriesConnection?: InputMaybe<MaterialFileEntriesConnectionWhere>;
  /** Return Materials where all of the related MaterialFileEntriesConnections match this filter */
  fileEntriesConnection_ALL?: InputMaybe<MaterialFileEntriesConnectionWhere>;
  /** Return Materials where none of the related MaterialFileEntriesConnections match this filter */
  fileEntriesConnection_NONE?: InputMaybe<MaterialFileEntriesConnectionWhere>;
  /** @deprecated Use `fileEntriesConnection_NONE` instead. */
  fileEntriesConnection_NOT?: InputMaybe<MaterialFileEntriesConnectionWhere>;
  /** Return Materials where one of the related MaterialFileEntriesConnections match this filter */
  fileEntriesConnection_SINGLE?: InputMaybe<MaterialFileEntriesConnectionWhere>;
  /** Return Materials where some of the related MaterialFileEntriesConnections match this filter */
  fileEntriesConnection_SOME?: InputMaybe<MaterialFileEntriesConnectionWhere>;
  /** Return Materials where all of the related FileEntries match this filter */
  fileEntries_ALL?: InputMaybe<FileEntryWhere>;
  /** Return Materials where none of the related FileEntries match this filter */
  fileEntries_NONE?: InputMaybe<FileEntryWhere>;
  /** @deprecated Use `fileEntries_NONE` instead. */
  fileEntries_NOT?: InputMaybe<FileEntryWhere>;
  /** Return Materials where one of the related FileEntries match this filter */
  fileEntries_SINGLE?: InputMaybe<FileEntryWhere>;
  /** Return Materials where some of the related FileEntries match this filter */
  fileEntries_SOME?: InputMaybe<FileEntryWhere>;
  holder?: InputMaybe<MaterialHolderWhere>;
  holderConnection?: InputMaybe<MaterialHolderConnectionWhere>;
  holderConnection_NOT?: InputMaybe<MaterialHolderConnectionWhere>;
  holder_NOT?: InputMaybe<MaterialHolderWhere>;
  text?: InputMaybe<Scalars['String']['input']>;
  textMediaType?: InputMaybe<Scalars['String']['input']>;
  textMediaType_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  textMediaType_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  textMediaType_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  textMediaType_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  textMediaType_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  textMediaType_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  textMediaType_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  textMediaType_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  textMediaType_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  text_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  text_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  text_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  text_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  text_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  text_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  text_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  text_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  text_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  updated_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updated_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updated_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updated_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  viewers?: InputMaybe<Array<Scalars['String']['input']>>;
  viewers_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  viewers_NOT?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  viewers_NOT_INCLUDES?: InputMaybe<Scalars['String']['input']>;
};

export type MaterialsConnection = {
  __typename?: 'MaterialsConnection';
  edges: Array<MaterialEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  createAbsenceReasons: CreateAbsenceReasonsMutationResponse;
  createAbsences: CreateAbsencesMutationResponse;
  createAssignments: CreateAssignmentsMutationResponse;
  createBigBlueButtons: CreateBigBlueButtonsMutationResponse;
  createBildungsplattforms: CreateBildungsplattformsMutationResponse;
  createBpGroup: Group;
  createBpProfile: Profile;
  createBpSchoolyear: SchoolYear;
  createBpSubject: Subject;
  createCalendarEvents: CreateCalendarEventsMutationResponse;
  createCalendarSubscriptions: CreateCalendarSubscriptionsMutationResponse;
  createClassGroups: CreateClassGroupsMutationResponse;
  createClasses: CreateClassesMutationResponse;
  createCollaboration: CollaboratingOrganizations;
  createDivisions: CreateDivisionsMutationResponse;
  createFileEntries: CreateFileEntriesMutationResponse;
  createLocations: CreateLocationsMutationResponse;
  createMaterials: CreateMaterialsMutationResponse;
  createNextclouds: CreateNextcloudsMutationResponse;
  createNotificationSettings: CreateNotificationSettingsMutationResponse;
  createOrganizations: CreateOrganizationsMutationResponse;
  createPreferences: CreatePreferencesMutationResponse;
  createProfiles: CreateProfilesMutationResponse;
  createRecurrenceRules: CreateRecurrenceRulesMutationResponse;
  createSubmissions: CreateSubmissionsMutationResponse;
  createTeachingTopics: CreateTeachingTopicsMutationResponse;
  createTeachingUnits: CreateTeachingUnitsMutationResponse;
  createThreemaBroadcasts: CreateThreemaBroadcastsMutationResponse;
  createThreemas: CreateThreemasMutationResponse;
  createVirtualLocations: CreateVirtualLocationsMutationResponse;
  createWorkMaterials: CreateWorkMaterialsMutationResponse;
  createZooms: CreateZoomsMutationResponse;
  deleteAbsenceReasons: DeleteInfo;
  deleteAbsences: DeleteInfo;
  deleteAssignments: DeleteInfo;
  deleteBigBlueButtons: DeleteInfo;
  deleteBildungsplattforms: DeleteInfo;
  deleteBpGroup: EntitiesDeleteInfo;
  deleteBpProfile: EntitiesDeleteInfo;
  deleteBpSchoolyear: EntitiesDeleteInfo;
  deleteBpSubject: EntitiesDeleteInfo;
  deleteCalendarEvents: DeleteInfo;
  deleteCalendarSubscriptions: DeleteInfo;
  deleteClassGroups: DeleteInfo;
  deleteClasses: DeleteInfo;
  deleteCollaboration: EntitiesDeleteInfo;
  deleteDivisions: DeleteInfo;
  deleteFileEntries: DeleteInfo;
  deleteLocations: DeleteInfo;
  deleteMaterials: DeleteInfo;
  deleteNextclouds: DeleteInfo;
  deleteNotificationSettings: DeleteInfo;
  deleteOrganizations: DeleteInfo;
  deletePreferences: DeleteInfo;
  deleteProfiles: DeleteInfo;
  deleteRecurrenceRules: DeleteInfo;
  deleteSubmissions: DeleteInfo;
  deleteTeachingTopics: DeleteInfo;
  deleteTeachingUnits: DeleteInfo;
  deleteThreemaBroadcasts: DeleteInfo;
  deleteThreemas: DeleteInfo;
  deleteVirtualLocations: DeleteInfo;
  deleteWorkMaterials: DeleteInfo;
  deleteZooms: DeleteInfo;
  updateAbsenceReasons: UpdateAbsenceReasonsMutationResponse;
  updateAbsences: UpdateAbsencesMutationResponse;
  updateAclRoles: EntitiesUpdateInfo;
  updateAssignments: UpdateAssignmentsMutationResponse;
  updateBigBlueButtons: UpdateBigBlueButtonsMutationResponse;
  updateBildungsplattforms: UpdateBildungsplattformsMutationResponse;
  updateBpGroup: Group;
  updateBpProfile: Profile;
  updateBpSchoolyear: SchoolYear;
  updateBpSubject: Subject;
  updateCalendarEvents: UpdateCalendarEventsMutationResponse;
  updateCalendarSubscriptions: UpdateCalendarSubscriptionsMutationResponse;
  updateClassGroups: UpdateClassGroupsMutationResponse;
  updateClasses: UpdateClassesMutationResponse;
  updateDivisions: UpdateDivisionsMutationResponse;
  updateFileEntries: UpdateFileEntriesMutationResponse;
  updateGroupSettings: EntitiesUpdateInfo;
  updateLocations: UpdateLocationsMutationResponse;
  updateMaterials: UpdateMaterialsMutationResponse;
  updateNextclouds: UpdateNextcloudsMutationResponse;
  updateNotificationSettings: UpdateNotificationSettingsMutationResponse;
  updateOrganizations: UpdateOrganizationsMutationResponse;
  updateParents: EntitiesUpdateInfo;
  updatePasswords: UpdatePasswordsMutationResponse;
  updatePreferences: UpdatePreferencesMutationResponse;
  updateProfileRole: EntitiesUpdateInfo;
  updateProfileSettings: EntitiesUpdateInfo;
  updateProfiles: UpdateProfilesMutationResponse;
  updateRecurrenceRules: UpdateRecurrenceRulesMutationResponse;
  updateSubmissions: UpdateSubmissionsMutationResponse;
  updateTeachingTopics: UpdateTeachingTopicsMutationResponse;
  updateTeachingUnits: UpdateTeachingUnitsMutationResponse;
  updateThreemaBroadcasts: UpdateThreemaBroadcastsMutationResponse;
  updateThreemas: UpdateThreemasMutationResponse;
  updateVirtualLocations: UpdateVirtualLocationsMutationResponse;
  updateWorkMaterials: UpdateWorkMaterialsMutationResponse;
  updateZooms: UpdateZoomsMutationResponse;
};

export type MutationCreateAbsenceReasonsArgs = {
  input: Array<AbsenceReasonCreateInput>;
};

export type MutationCreateAbsencesArgs = {
  input: Array<AbsenceCreateInput>;
};

export type MutationCreateAssignmentsArgs = {
  input: Array<AssignmentCreateInput>;
};

export type MutationCreateBigBlueButtonsArgs = {
  input: Array<BigBlueButtonCreateInput>;
};

export type MutationCreateBildungsplattformsArgs = {
  input: Array<BildungsplattformCreateInput>;
};

export type MutationCreateBpGroupArgs = {
  input: BpGroupCreateInput;
};

export type MutationCreateBpProfileArgs = {
  input: BpProfileCreateInput;
};

export type MutationCreateBpSchoolyearArgs = {
  input: BpSchoolyearCreateInput;
};

export type MutationCreateBpSubjectArgs = {
  input: BpSubjectCreateInput;
};

export type MutationCreateCalendarEventsArgs = {
  input: Array<CalendarEventCreateInput>;
};

export type MutationCreateCalendarSubscriptionsArgs = {
  input: Array<CalendarSubscriptionCreateInput>;
};

export type MutationCreateClassGroupsArgs = {
  input: Array<ClassGroupCreateInput>;
};

export type MutationCreateClassesArgs = {
  input: Array<ClassCreateInput>;
};

export type MutationCreateCollaborationArgs = {
  uuid: Scalars['ID']['input'];
};

export type MutationCreateDivisionsArgs = {
  input: Array<DivisionCreateInput>;
};

export type MutationCreateFileEntriesArgs = {
  input: Array<FileEntryCreateInput>;
};

export type MutationCreateLocationsArgs = {
  input: Array<LocationCreateInput>;
};

export type MutationCreateMaterialsArgs = {
  input: Array<MaterialCreateInput>;
};

export type MutationCreateNextcloudsArgs = {
  input: Array<NextcloudCreateInput>;
};

export type MutationCreateNotificationSettingsArgs = {
  input: Array<NotificationSettingsCreateInput>;
};

export type MutationCreateOrganizationsArgs = {
  input: Array<OrganizationCreateInput>;
};

export type MutationCreatePreferencesArgs = {
  input: Array<PreferenceCreateInput>;
};

export type MutationCreateProfilesArgs = {
  input: Array<ProfileCreateInput>;
};

export type MutationCreateRecurrenceRulesArgs = {
  input: Array<RecurrenceRuleCreateInput>;
};

export type MutationCreateSubmissionsArgs = {
  input: Array<SubmissionCreateInput>;
};

export type MutationCreateTeachingTopicsArgs = {
  input: Array<TeachingTopicCreateInput>;
};

export type MutationCreateTeachingUnitsArgs = {
  input: Array<TeachingUnitCreateInput>;
};

export type MutationCreateThreemaBroadcastsArgs = {
  input: Array<ThreemaBroadcastCreateInput>;
};

export type MutationCreateThreemasArgs = {
  input: Array<ThreemaCreateInput>;
};

export type MutationCreateVirtualLocationsArgs = {
  input: Array<VirtualLocationCreateInput>;
};

export type MutationCreateWorkMaterialsArgs = {
  input: Array<WorkMaterialCreateInput>;
};

export type MutationCreateZoomsArgs = {
  input: Array<ZoomCreateInput>;
};

export type MutationDeleteAbsenceReasonsArgs = {
  delete?: InputMaybe<AbsenceReasonDeleteInput>;
  where?: InputMaybe<AbsenceReasonWhere>;
};

export type MutationDeleteAbsencesArgs = {
  delete?: InputMaybe<AbsenceDeleteInput>;
  where?: InputMaybe<AbsenceWhere>;
};

export type MutationDeleteAssignmentsArgs = {
  delete?: InputMaybe<AssignmentDeleteInput>;
  where?: InputMaybe<AssignmentWhere>;
};

export type MutationDeleteBigBlueButtonsArgs = {
  delete?: InputMaybe<BigBlueButtonDeleteInput>;
  where?: InputMaybe<BigBlueButtonWhere>;
};

export type MutationDeleteBildungsplattformsArgs = {
  delete?: InputMaybe<BildungsplattformDeleteInput>;
  where?: InputMaybe<BildungsplattformWhere>;
};

export type MutationDeleteBpGroupArgs = {
  uuid: Scalars['ID']['input'];
};

export type MutationDeleteBpProfileArgs = {
  uuid: Scalars['String']['input'];
};

export type MutationDeleteBpSchoolyearArgs = {
  uuid: Scalars['ID']['input'];
};

export type MutationDeleteBpSubjectArgs = {
  uuid: Scalars['ID']['input'];
};

export type MutationDeleteCalendarEventsArgs = {
  delete?: InputMaybe<CalendarEventDeleteInput>;
  where?: InputMaybe<CalendarEventWhere>;
};

export type MutationDeleteCalendarSubscriptionsArgs = {
  delete?: InputMaybe<CalendarSubscriptionDeleteInput>;
  where?: InputMaybe<CalendarSubscriptionWhere>;
};

export type MutationDeleteClassGroupsArgs = {
  delete?: InputMaybe<ClassGroupDeleteInput>;
  where?: InputMaybe<ClassGroupWhere>;
};

export type MutationDeleteClassesArgs = {
  delete?: InputMaybe<ClassDeleteInput>;
  where?: InputMaybe<ClassWhere>;
};

export type MutationDeleteCollaborationArgs = {
  uuid: Scalars['ID']['input'];
};

export type MutationDeleteDivisionsArgs = {
  delete?: InputMaybe<DivisionDeleteInput>;
  where?: InputMaybe<DivisionWhere>;
};

export type MutationDeleteFileEntriesArgs = {
  delete?: InputMaybe<FileEntryDeleteInput>;
  where?: InputMaybe<FileEntryWhere>;
};

export type MutationDeleteLocationsArgs = {
  delete?: InputMaybe<LocationDeleteInput>;
  where?: InputMaybe<LocationWhere>;
};

export type MutationDeleteMaterialsArgs = {
  delete?: InputMaybe<MaterialDeleteInput>;
  where?: InputMaybe<MaterialWhere>;
};

export type MutationDeleteNextcloudsArgs = {
  delete?: InputMaybe<NextcloudDeleteInput>;
  where?: InputMaybe<NextcloudWhere>;
};

export type MutationDeleteNotificationSettingsArgs = {
  delete?: InputMaybe<NotificationSettingsDeleteInput>;
  where?: InputMaybe<NotificationSettingsWhere>;
};

export type MutationDeleteOrganizationsArgs = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<OrganizationWhere>;
};

export type MutationDeletePreferencesArgs = {
  where?: InputMaybe<PreferenceWhere>;
};

export type MutationDeleteProfilesArgs = {
  delete?: InputMaybe<ProfileDeleteInput>;
  where?: InputMaybe<ProfileWhere>;
};

export type MutationDeleteRecurrenceRulesArgs = {
  where?: InputMaybe<RecurrenceRuleWhere>;
};

export type MutationDeleteSubmissionsArgs = {
  delete?: InputMaybe<SubmissionDeleteInput>;
  where?: InputMaybe<SubmissionWhere>;
};

export type MutationDeleteTeachingTopicsArgs = {
  delete?: InputMaybe<TeachingTopicDeleteInput>;
  where?: InputMaybe<TeachingTopicWhere>;
};

export type MutationDeleteTeachingUnitsArgs = {
  delete?: InputMaybe<TeachingUnitDeleteInput>;
  where?: InputMaybe<TeachingUnitWhere>;
};

export type MutationDeleteThreemaBroadcastsArgs = {
  delete?: InputMaybe<ThreemaBroadcastDeleteInput>;
  where?: InputMaybe<ThreemaBroadcastWhere>;
};

export type MutationDeleteThreemasArgs = {
  delete?: InputMaybe<ThreemaDeleteInput>;
  where?: InputMaybe<ThreemaWhere>;
};

export type MutationDeleteVirtualLocationsArgs = {
  delete?: InputMaybe<VirtualLocationDeleteInput>;
  where?: InputMaybe<VirtualLocationWhere>;
};

export type MutationDeleteWorkMaterialsArgs = {
  delete?: InputMaybe<WorkMaterialDeleteInput>;
  where?: InputMaybe<WorkMaterialWhere>;
};

export type MutationDeleteZoomsArgs = {
  delete?: InputMaybe<ZoomDeleteInput>;
  where?: InputMaybe<ZoomWhere>;
};

export type MutationUpdateAbsenceReasonsArgs = {
  update?: InputMaybe<AbsenceReasonUpdateInput>;
  where?: InputMaybe<AbsenceReasonWhere>;
};

export type MutationUpdateAbsencesArgs = {
  update?: InputMaybe<AbsenceUpdateInput>;
  where?: InputMaybe<AbsenceWhere>;
};

export type MutationUpdateAclRolesArgs = {
  roles: Array<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type MutationUpdateAssignmentsArgs = {
  update?: InputMaybe<AssignmentUpdateInput>;
  where?: InputMaybe<AssignmentWhere>;
};

export type MutationUpdateBigBlueButtonsArgs = {
  update?: InputMaybe<BigBlueButtonUpdateInput>;
  where?: InputMaybe<BigBlueButtonWhere>;
};

export type MutationUpdateBildungsplattformsArgs = {
  update?: InputMaybe<BildungsplattformUpdateInput>;
  where?: InputMaybe<BildungsplattformWhere>;
};

export type MutationUpdateBpGroupArgs = {
  update: BpGroupUpdateInput;
  uuid: Scalars['ID']['input'];
};

export type MutationUpdateBpProfileArgs = {
  update: BpProfileUpdateInput;
  uuid: Scalars['String']['input'];
};

export type MutationUpdateBpSchoolyearArgs = {
  update: BpSchoolyearUpdateInput;
  uuid: Scalars['ID']['input'];
};

export type MutationUpdateBpSubjectArgs = {
  update: BpSubjectUpdateInput;
  uuid: Scalars['ID']['input'];
};

export type MutationUpdateCalendarEventsArgs = {
  update?: InputMaybe<CalendarEventUpdateInput>;
  where?: InputMaybe<CalendarEventWhere>;
};

export type MutationUpdateCalendarSubscriptionsArgs = {
  update?: InputMaybe<CalendarSubscriptionUpdateInput>;
  where?: InputMaybe<CalendarSubscriptionWhere>;
};

export type MutationUpdateClassGroupsArgs = {
  update?: InputMaybe<ClassGroupUpdateInput>;
  where?: InputMaybe<ClassGroupWhere>;
};

export type MutationUpdateClassesArgs = {
  update?: InputMaybe<ClassUpdateInput>;
  where?: InputMaybe<ClassWhere>;
};

export type MutationUpdateDivisionsArgs = {
  update?: InputMaybe<DivisionUpdateInput>;
  where?: InputMaybe<DivisionWhere>;
};

export type MutationUpdateFileEntriesArgs = {
  update?: InputMaybe<FileEntryUpdateInput>;
  where?: InputMaybe<FileEntryWhere>;
};

export type MutationUpdateGroupSettingsArgs = {
  update: UpdateGroupSettings;
  where: GroupWhere;
};

export type MutationUpdateLocationsArgs = {
  update?: InputMaybe<LocationUpdateInput>;
  where?: InputMaybe<LocationWhere>;
};

export type MutationUpdateMaterialsArgs = {
  update?: InputMaybe<MaterialUpdateInput>;
  where?: InputMaybe<MaterialWhere>;
};

export type MutationUpdateNextcloudsArgs = {
  update?: InputMaybe<NextcloudUpdateInput>;
  where?: InputMaybe<NextcloudWhere>;
};

export type MutationUpdateNotificationSettingsArgs = {
  update?: InputMaybe<NotificationSettingsUpdateInput>;
  where?: InputMaybe<NotificationSettingsWhere>;
};

export type MutationUpdateOrganizationsArgs = {
  update?: InputMaybe<OrganizationUpdateInput>;
  where?: InputMaybe<OrganizationWhere>;
};

export type MutationUpdateParentsArgs = {
  child: Scalars['ID']['input'];
  parents: Array<Scalars['ID']['input']>;
};

export type MutationUpdatePasswordsArgs = {
  update: PasswordUpdateInput;
  where: PasswordWhere;
};

export type MutationUpdatePreferencesArgs = {
  update?: InputMaybe<PreferenceUpdateInput>;
  where?: InputMaybe<PreferenceWhere>;
};

export type MutationUpdateProfileRoleArgs = {
  role: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

export type MutationUpdateProfileSettingsArgs = {
  update: UpdateProfileSettings;
  where: ProfileWhere;
};

export type MutationUpdateProfilesArgs = {
  update?: InputMaybe<ProfileUpdateInput>;
  where?: InputMaybe<ProfileWhere>;
};

export type MutationUpdateRecurrenceRulesArgs = {
  update?: InputMaybe<RecurrenceRuleUpdateInput>;
  where?: InputMaybe<RecurrenceRuleWhere>;
};

export type MutationUpdateSubmissionsArgs = {
  update?: InputMaybe<SubmissionUpdateInput>;
  where?: InputMaybe<SubmissionWhere>;
};

export type MutationUpdateTeachingTopicsArgs = {
  update?: InputMaybe<TeachingTopicUpdateInput>;
  where?: InputMaybe<TeachingTopicWhere>;
};

export type MutationUpdateTeachingUnitsArgs = {
  update?: InputMaybe<TeachingUnitUpdateInput>;
  where?: InputMaybe<TeachingUnitWhere>;
};

export type MutationUpdateThreemaBroadcastsArgs = {
  update?: InputMaybe<ThreemaBroadcastUpdateInput>;
  where?: InputMaybe<ThreemaBroadcastWhere>;
};

export type MutationUpdateThreemasArgs = {
  update?: InputMaybe<ThreemaUpdateInput>;
  where?: InputMaybe<ThreemaWhere>;
};

export type MutationUpdateVirtualLocationsArgs = {
  update?: InputMaybe<VirtualLocationUpdateInput>;
  where?: InputMaybe<VirtualLocationWhere>;
};

export type MutationUpdateWorkMaterialsArgs = {
  update?: InputMaybe<WorkMaterialUpdateInput>;
  where?: InputMaybe<WorkMaterialWhere>;
};

export type MutationUpdateZoomsArgs = {
  update?: InputMaybe<ZoomUpdateInput>;
  where?: InputMaybe<ZoomWhere>;
};

export type Nextcloud = {
  __typename?: 'Nextcloud';
  organization: Organization;
  organizationAggregate?: Maybe<NextcloudOrganizationOrganizationAggregationSelection>;
  organizationConnection: NextcloudOrganizationConnection;
  profiles: Array<Profile>;
  profilesAggregate?: Maybe<NextcloudProfileProfilesAggregationSelection>;
  profilesConnection: NextcloudProfilesConnection;
  serverAliase?: Maybe<Array<Scalars['String']['output']>>;
  serverUri: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type NextcloudOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type NextcloudOrganizationAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OrganizationWhere>;
};

export type NextcloudOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<NextcloudOrganizationConnectionSort>>;
  where?: InputMaybe<NextcloudOrganizationConnectionWhere>;
};

export type NextcloudProfilesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ProfileOptions>;
  where?: InputMaybe<ProfileWhere>;
};

export type NextcloudProfilesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProfileWhere>;
};

export type NextcloudProfilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<NextcloudProfilesConnectionSort>>;
  where?: InputMaybe<NextcloudProfilesConnectionWhere>;
};

export type NextcloudAggregateSelection = {
  __typename?: 'NextcloudAggregateSelection';
  count: Scalars['Int']['output'];
  serverUri: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type NextcloudConnectInput = {
  organization?: InputMaybe<NextcloudOrganizationConnectFieldInput>;
  profiles?: InputMaybe<Array<NextcloudProfilesConnectFieldInput>>;
};

export type NextcloudConnectWhere = {
  node: NextcloudWhere;
};

export type NextcloudCreateInput = {
  adminPass: Scalars['String']['input'];
  adminUser: Scalars['String']['input'];
  organization?: InputMaybe<NextcloudOrganizationFieldInput>;
  profiles?: InputMaybe<NextcloudProfilesFieldInput>;
  serverAliase?: InputMaybe<Array<Scalars['String']['input']>>;
  serverUri: Scalars['String']['input'];
};

export type NextcloudDeleteInput = {
  organization?: InputMaybe<NextcloudOrganizationDeleteFieldInput>;
  profiles?: InputMaybe<Array<NextcloudProfilesDeleteFieldInput>>;
};

export type NextcloudDisconnectInput = {
  organization?: InputMaybe<NextcloudOrganizationDisconnectFieldInput>;
  profiles?: InputMaybe<Array<NextcloudProfilesDisconnectFieldInput>>;
};

export type NextcloudEdge = {
  __typename?: 'NextcloudEdge';
  cursor: Scalars['String']['output'];
  node: Nextcloud;
};

/**
 * The edge properties for the following fields:
 * * Group.nextcloud
 */
export type NextcloudGroupProps = {
  __typename?: 'NextcloudGroupProps';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  folderName?: Maybe<Scalars['String']['output']>;
  lastSync?: Maybe<Scalars['DateTime']['output']>;
};

export type NextcloudGroupPropsAggregationWhereInput = {
  AND?: InputMaybe<Array<NextcloudGroupPropsAggregationWhereInput>>;
  NOT?: InputMaybe<NextcloudGroupPropsAggregationWhereInput>;
  OR?: InputMaybe<Array<NextcloudGroupPropsAggregationWhereInput>>;
  folderName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  folderName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  folderName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  folderName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  folderName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  folderName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  folderName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  folderName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  folderName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  folderName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  folderName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  folderName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  folderName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  folderName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  folderName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastSync_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NextcloudGroupPropsCreateInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  folderName?: InputMaybe<Scalars['String']['input']>;
  lastSync?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NextcloudGroupPropsSort = {
  enabled?: InputMaybe<SortDirection>;
  folderName?: InputMaybe<SortDirection>;
  lastSync?: InputMaybe<SortDirection>;
};

export type NextcloudGroupPropsUpdateInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  folderName?: InputMaybe<Scalars['String']['input']>;
  lastSync?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NextcloudGroupPropsWhere = {
  AND?: InputMaybe<Array<NextcloudGroupPropsWhere>>;
  NOT?: InputMaybe<NextcloudGroupPropsWhere>;
  OR?: InputMaybe<Array<NextcloudGroupPropsWhere>>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  enabled_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  folderName?: InputMaybe<Scalars['String']['input']>;
  folderName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  folderName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  folderName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  folderName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  folderName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  folderName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  folderName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  folderName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  folderName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastSync?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastSync_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lastSync_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lastSync_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export type NextcloudOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more NextcloudSort objects to sort Nextclouds by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<NextcloudSort>>;
};

export type NextcloudOrganizationAggregateInput = {
  AND?: InputMaybe<Array<NextcloudOrganizationAggregateInput>>;
  NOT?: InputMaybe<NextcloudOrganizationAggregateInput>;
  OR?: InputMaybe<Array<NextcloudOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<LicensePropertiesAggregationWhereInput>;
  node?: InputMaybe<NextcloudOrganizationNodeAggregationWhereInput>;
};

export type NextcloudOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  edge?: InputMaybe<LicensePropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type NextcloudOrganizationConnectOrCreateFieldInput = {
  onCreate: NextcloudOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type NextcloudOrganizationConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<LicensePropertiesCreateInput>;
  node: OrganizationOnCreateInput;
};

export type NextcloudOrganizationConnection = {
  __typename?: 'NextcloudOrganizationConnection';
  edges: Array<NextcloudOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NextcloudOrganizationConnectionSort = {
  edge?: InputMaybe<LicensePropertiesSort>;
  node?: InputMaybe<OrganizationSort>;
};

export type NextcloudOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<NextcloudOrganizationConnectionWhere>>;
  NOT?: InputMaybe<NextcloudOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<NextcloudOrganizationConnectionWhere>>;
  edge?: InputMaybe<LicensePropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<LicensePropertiesWhere>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type NextcloudOrganizationCreateFieldInput = {
  edge?: InputMaybe<LicensePropertiesCreateInput>;
  node: OrganizationCreateInput;
};

export type NextcloudOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<NextcloudOrganizationConnectionWhere>;
};

export type NextcloudOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<NextcloudOrganizationConnectionWhere>;
};

export type NextcloudOrganizationFieldInput = {
  connect?: InputMaybe<NextcloudOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<NextcloudOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<NextcloudOrganizationCreateFieldInput>;
};

export type NextcloudOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<NextcloudOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<NextcloudOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<NextcloudOrganizationNodeAggregationWhereInput>>;
  aboutInfoLastUpdated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type NextcloudOrganizationOrganizationAggregationSelection = {
  __typename?: 'NextcloudOrganizationOrganizationAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<NextcloudOrganizationOrganizationEdgeAggregateSelection>;
  node?: Maybe<NextcloudOrganizationOrganizationNodeAggregateSelection>;
};

export type NextcloudOrganizationOrganizationEdgeAggregateSelection = {
  __typename?: 'NextcloudOrganizationOrganizationEdgeAggregateSelection';
  contractRef: StringAggregateSelection;
  notAfter: DateTimeAggregateSelection;
  notBefore: DateTimeAggregateSelection;
  version: StringAggregateSelection;
};

export type NextcloudOrganizationOrganizationNodeAggregateSelection = {
  __typename?: 'NextcloudOrganizationOrganizationNodeAggregateSelection';
  aboutInfo: StringAggregateSelection;
  aboutInfoLastUpdated: DateTimeAggregateSelection;
  displayName: StringAggregateSelection;
  matrixRoomId: StringAggregateSelection;
  planungSyncProps: StringAggregateSelection;
  procuratSyncProps: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type NextcloudOrganizationRelationship = {
  __typename?: 'NextcloudOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
  properties: LicenseProperties;
};

export type NextcloudOrganizationUpdateConnectionInput = {
  edge?: InputMaybe<LicensePropertiesUpdateInput>;
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type NextcloudOrganizationUpdateFieldInput = {
  connect?: InputMaybe<NextcloudOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<NextcloudOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<NextcloudOrganizationCreateFieldInput>;
  delete?: InputMaybe<NextcloudOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<NextcloudOrganizationDisconnectFieldInput>;
  update?: InputMaybe<NextcloudOrganizationUpdateConnectionInput>;
  where?: InputMaybe<NextcloudOrganizationConnectionWhere>;
};

export type NextcloudProfileProfilesAggregationSelection = {
  __typename?: 'NextcloudProfileProfilesAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<NextcloudProfileProfilesEdgeAggregateSelection>;
  node?: Maybe<NextcloudProfileProfilesNodeAggregateSelection>;
};

export type NextcloudProfileProfilesEdgeAggregateSelection = {
  __typename?: 'NextcloudProfileProfilesEdgeAggregateSelection';
  lastSync: DateTimeAggregateSelection;
};

export type NextcloudProfileProfilesNodeAggregateSelection = {
  __typename?: 'NextcloudProfileProfilesNodeAggregateSelection';
  address1: StringAggregateSelection;
  address2: StringAggregateSelection;
  address3: StringAggregateSelection;
  birthday: StringAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  email: StringAggregateSelection;
  firstName: StringAggregateSelection;
  firstNames: StringAggregateSelection;
  lastName: StringAggregateSelection;
  managedBy: StringAggregateSelection;
  matrixToken: StringAggregateSelection;
  nextcloudUserId: StringAggregateSelection;
  prefixName: StringAggregateSelection;
  salutation: StringAggregateSelection;
  shortName: StringAggregateSelection;
  threemaId: StringAggregateSelection;
  title: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  userUuid: StringAggregateSelection;
  uuid: IdAggregateSelection;
  zoomUserId: StringAggregateSelection;
};

export type NextcloudProfilesAggregateInput = {
  AND?: InputMaybe<Array<NextcloudProfilesAggregateInput>>;
  NOT?: InputMaybe<NextcloudProfilesAggregateInput>;
  OR?: InputMaybe<Array<NextcloudProfilesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<NextcloudUserPropsAggregationWhereInput>;
  node?: InputMaybe<NextcloudProfilesNodeAggregationWhereInput>;
};

export type NextcloudProfilesConnectFieldInput = {
  connect?: InputMaybe<Array<ProfileConnectInput>>;
  edge?: InputMaybe<NextcloudUserPropsCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ProfileConnectWhere>;
};

export type NextcloudProfilesConnectOrCreateFieldInput = {
  onCreate: NextcloudProfilesConnectOrCreateFieldInputOnCreate;
  where: ProfileConnectOrCreateWhere;
};

export type NextcloudProfilesConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<NextcloudUserPropsCreateInput>;
  node: ProfileOnCreateInput;
};

export type NextcloudProfilesConnection = {
  __typename?: 'NextcloudProfilesConnection';
  edges: Array<NextcloudProfilesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NextcloudProfilesConnectionSort = {
  edge?: InputMaybe<NextcloudUserPropsSort>;
  node?: InputMaybe<ProfileSort>;
};

export type NextcloudProfilesConnectionWhere = {
  AND?: InputMaybe<Array<NextcloudProfilesConnectionWhere>>;
  NOT?: InputMaybe<NextcloudProfilesConnectionWhere>;
  OR?: InputMaybe<Array<NextcloudProfilesConnectionWhere>>;
  edge?: InputMaybe<NextcloudUserPropsWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<NextcloudUserPropsWhere>;
  node?: InputMaybe<ProfileWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ProfileWhere>;
};

export type NextcloudProfilesCreateFieldInput = {
  edge?: InputMaybe<NextcloudUserPropsCreateInput>;
  node: ProfileCreateInput;
};

export type NextcloudProfilesDeleteFieldInput = {
  delete?: InputMaybe<ProfileDeleteInput>;
  where?: InputMaybe<NextcloudProfilesConnectionWhere>;
};

export type NextcloudProfilesDisconnectFieldInput = {
  disconnect?: InputMaybe<ProfileDisconnectInput>;
  where?: InputMaybe<NextcloudProfilesConnectionWhere>;
};

export type NextcloudProfilesFieldInput = {
  connect?: InputMaybe<Array<NextcloudProfilesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<NextcloudProfilesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<NextcloudProfilesCreateFieldInput>>;
};

export type NextcloudProfilesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<NextcloudProfilesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<NextcloudProfilesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<NextcloudProfilesNodeAggregationWhereInput>>;
  address1_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address1_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address2_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address2_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address3_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address3_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  birthday_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  userUuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  userUuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type NextcloudProfilesRelationship = {
  __typename?: 'NextcloudProfilesRelationship';
  cursor: Scalars['String']['output'];
  node: Profile;
  properties: NextcloudUserProps;
};

export type NextcloudProfilesUpdateConnectionInput = {
  edge?: InputMaybe<NextcloudUserPropsUpdateInput>;
  node?: InputMaybe<ProfileUpdateInput>;
};

export type NextcloudProfilesUpdateFieldInput = {
  connect?: InputMaybe<Array<NextcloudProfilesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<NextcloudProfilesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<NextcloudProfilesCreateFieldInput>>;
  delete?: InputMaybe<Array<NextcloudProfilesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<NextcloudProfilesDisconnectFieldInput>>;
  update?: InputMaybe<NextcloudProfilesUpdateConnectionInput>;
  where?: InputMaybe<NextcloudProfilesConnectionWhere>;
};

/** Fields to sort Nextclouds by. The order in which sorts are applied is not guaranteed when specifying many fields in one NextcloudSort object. */
export type NextcloudSort = {
  adminPass?: InputMaybe<SortDirection>;
  adminUser?: InputMaybe<SortDirection>;
  serverUri?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type NextcloudUpdateInput = {
  adminPass?: InputMaybe<Scalars['String']['input']>;
  adminUser?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<NextcloudOrganizationUpdateFieldInput>;
  profiles?: InputMaybe<Array<NextcloudProfilesUpdateFieldInput>>;
  serverAliase?: InputMaybe<Array<Scalars['String']['input']>>;
  serverAliase_POP?: InputMaybe<Scalars['Int']['input']>;
  serverAliase_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
  serverUri?: InputMaybe<Scalars['String']['input']>;
};

/**
 * The edge properties for the following fields:
 * * Profile.nextcloud
 * * Nextcloud.profiles
 */
export type NextcloudUserProps = {
  __typename?: 'NextcloudUserProps';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  lastSync?: Maybe<Scalars['DateTime']['output']>;
};

export type NextcloudUserPropsAggregationWhereInput = {
  AND?: InputMaybe<Array<NextcloudUserPropsAggregationWhereInput>>;
  NOT?: InputMaybe<NextcloudUserPropsAggregationWhereInput>;
  OR?: InputMaybe<Array<NextcloudUserPropsAggregationWhereInput>>;
  lastSync_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NextcloudUserPropsCreateInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastSync?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NextcloudUserPropsSort = {
  enabled?: InputMaybe<SortDirection>;
  lastSync?: InputMaybe<SortDirection>;
};

export type NextcloudUserPropsUpdateInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastSync?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NextcloudUserPropsWhere = {
  AND?: InputMaybe<Array<NextcloudUserPropsWhere>>;
  NOT?: InputMaybe<NextcloudUserPropsWhere>;
  OR?: InputMaybe<Array<NextcloudUserPropsWhere>>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  enabled_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  lastSync?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastSync_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lastSync_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lastSync_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export type NextcloudWhere = {
  AND?: InputMaybe<Array<NextcloudWhere>>;
  NOT?: InputMaybe<NextcloudWhere>;
  OR?: InputMaybe<Array<NextcloudWhere>>;
  adminPass?: InputMaybe<Scalars['String']['input']>;
  adminPass_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  adminPass_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  adminPass_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  adminPass_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  adminPass_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  adminPass_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  adminPass_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  adminPass_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  adminPass_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  adminUser?: InputMaybe<Scalars['String']['input']>;
  adminUser_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  adminUser_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  adminUser_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  adminUser_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  adminUser_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  adminUser_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  adminUser_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  adminUser_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  adminUser_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<NextcloudOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<NextcloudOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<NextcloudOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  /** @deprecated Use `profiles_SOME` instead. */
  profiles?: InputMaybe<ProfileWhere>;
  profilesAggregate?: InputMaybe<NextcloudProfilesAggregateInput>;
  /** @deprecated Use `profilesConnection_SOME` instead. */
  profilesConnection?: InputMaybe<NextcloudProfilesConnectionWhere>;
  /** Return Nextclouds where all of the related NextcloudProfilesConnections match this filter */
  profilesConnection_ALL?: InputMaybe<NextcloudProfilesConnectionWhere>;
  /** Return Nextclouds where none of the related NextcloudProfilesConnections match this filter */
  profilesConnection_NONE?: InputMaybe<NextcloudProfilesConnectionWhere>;
  /** @deprecated Use `profilesConnection_NONE` instead. */
  profilesConnection_NOT?: InputMaybe<NextcloudProfilesConnectionWhere>;
  /** Return Nextclouds where one of the related NextcloudProfilesConnections match this filter */
  profilesConnection_SINGLE?: InputMaybe<NextcloudProfilesConnectionWhere>;
  /** Return Nextclouds where some of the related NextcloudProfilesConnections match this filter */
  profilesConnection_SOME?: InputMaybe<NextcloudProfilesConnectionWhere>;
  /** Return Nextclouds where all of the related Profiles match this filter */
  profiles_ALL?: InputMaybe<ProfileWhere>;
  /** Return Nextclouds where none of the related Profiles match this filter */
  profiles_NONE?: InputMaybe<ProfileWhere>;
  /** @deprecated Use `profiles_NONE` instead. */
  profiles_NOT?: InputMaybe<ProfileWhere>;
  /** Return Nextclouds where one of the related Profiles match this filter */
  profiles_SINGLE?: InputMaybe<ProfileWhere>;
  /** Return Nextclouds where some of the related Profiles match this filter */
  profiles_SOME?: InputMaybe<ProfileWhere>;
  serverAliase?: InputMaybe<Array<Scalars['String']['input']>>;
  serverAliase_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  serverAliase_NOT?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  serverAliase_NOT_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  serverUri?: InputMaybe<Scalars['String']['input']>;
  serverUri_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  serverUri_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  serverUri_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  serverUri_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  serverUri_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  serverUri_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  serverUri_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  serverUri_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  serverUri_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type NextcloudsConnection = {
  __typename?: 'NextcloudsConnection';
  edges: Array<NextcloudEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/**
 * The edge properties for the following fields:
 * * Profile.notificationPreferences
 */
export type NotificationPreferenceProperty = {
  __typename?: 'NotificationPreferenceProperty';
  transports: Array<Scalars['String']['output']>;
};

export type NotificationPreferencePropertyCreateInput = {
  transports: Array<Scalars['String']['input']>;
};

export type NotificationPreferencePropertySort = {
  transports?: InputMaybe<SortDirection>;
};

export type NotificationPreferencePropertyUpdateInput = {
  transports?: InputMaybe<Array<Scalars['String']['input']>>;
  transports_POP?: InputMaybe<Scalars['Int']['input']>;
  transports_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type NotificationPreferencePropertyWhere = {
  AND?: InputMaybe<Array<NotificationPreferencePropertyWhere>>;
  NOT?: InputMaybe<NotificationPreferencePropertyWhere>;
  OR?: InputMaybe<Array<NotificationPreferencePropertyWhere>>;
  transports?: InputMaybe<Array<Scalars['String']['input']>>;
  transports_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  transports_NOT?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  transports_NOT_INCLUDES?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationSettings = {
  __typename?: 'NotificationSettings';
  email?: Maybe<Scalars['String']['output']>;
  profile: Array<Profile>;
  profileConnection: NotificationSettingsProfileConnection;
  pushIds: Array<Scalars['String']['output']>;
  userUuid: Scalars['ID']['output'];
};

export type NotificationSettingsProfileArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ProfileOptions>;
  where?: InputMaybe<ProfileWhere>;
};

export type NotificationSettingsProfileConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<NotificationSettingsProfileConnectionSort>>;
  where?: InputMaybe<NotificationSettingsProfileConnectionWhere>;
};

export type NotificationSettingsAggregateSelection = {
  __typename?: 'NotificationSettingsAggregateSelection';
  count: Scalars['Int']['output'];
  email: StringAggregateSelection;
  userUuid: IdAggregateSelection;
};

export type NotificationSettingsConnectInput = {
  profile?: InputMaybe<Array<NotificationSettingsProfileConnectFieldInput>>;
};

export type NotificationSettingsConnectOrCreateWhere = {
  node: NotificationSettingsUniqueWhere;
};

export type NotificationSettingsConnectWhere = {
  node: NotificationSettingsWhere;
};

export type NotificationSettingsConnection = {
  __typename?: 'NotificationSettingsConnection';
  edges: Array<NotificationSettingsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NotificationSettingsCreateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  profile?: InputMaybe<NotificationSettingsProfileFieldInput>;
  pushIds: Array<Scalars['String']['input']>;
  userUuid: Scalars['ID']['input'];
};

export type NotificationSettingsDeleteInput = {
  profile?: InputMaybe<Array<NotificationSettingsProfileDeleteFieldInput>>;
};

export type NotificationSettingsDisconnectInput = {
  profile?: InputMaybe<Array<NotificationSettingsProfileDisconnectFieldInput>>;
};

export type NotificationSettingsEdge = {
  __typename?: 'NotificationSettingsEdge';
  cursor: Scalars['String']['output'];
  node: NotificationSettings;
};

export type NotificationSettingsOnCreateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  pushIds: Array<Scalars['String']['input']>;
  userUuid: Scalars['ID']['input'];
};

export type NotificationSettingsOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more NotificationSettingsSort objects to sort NotificationSettings by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<NotificationSettingsSort>>;
};

export type NotificationSettingsProfileAggregateInput = {
  AND?: InputMaybe<Array<NotificationSettingsProfileAggregateInput>>;
  NOT?: InputMaybe<NotificationSettingsProfileAggregateInput>;
  OR?: InputMaybe<Array<NotificationSettingsProfileAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<NotificationSettingsProfileNodeAggregationWhereInput>;
};

export type NotificationSettingsProfileConnectFieldInput = {
  connect?: InputMaybe<Array<ProfileConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ProfileConnectWhere>;
};

export type NotificationSettingsProfileConnectOrCreateFieldInput = {
  onCreate: NotificationSettingsProfileConnectOrCreateFieldInputOnCreate;
  where: ProfileConnectOrCreateWhere;
};

export type NotificationSettingsProfileConnectOrCreateFieldInputOnCreate = {
  node: ProfileOnCreateInput;
};

export type NotificationSettingsProfileConnection = {
  __typename?: 'NotificationSettingsProfileConnection';
  edges: Array<NotificationSettingsProfileRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NotificationSettingsProfileConnectionSort = {
  node?: InputMaybe<ProfileSort>;
};

export type NotificationSettingsProfileConnectionWhere = {
  AND?: InputMaybe<Array<NotificationSettingsProfileConnectionWhere>>;
  NOT?: InputMaybe<NotificationSettingsProfileConnectionWhere>;
  OR?: InputMaybe<Array<NotificationSettingsProfileConnectionWhere>>;
  node?: InputMaybe<ProfileWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ProfileWhere>;
};

export type NotificationSettingsProfileCreateFieldInput = {
  node: ProfileCreateInput;
};

export type NotificationSettingsProfileDeleteFieldInput = {
  delete?: InputMaybe<ProfileDeleteInput>;
  where?: InputMaybe<NotificationSettingsProfileConnectionWhere>;
};

export type NotificationSettingsProfileDisconnectFieldInput = {
  disconnect?: InputMaybe<ProfileDisconnectInput>;
  where?: InputMaybe<NotificationSettingsProfileConnectionWhere>;
};

export type NotificationSettingsProfileFieldInput = {
  connect?: InputMaybe<Array<NotificationSettingsProfileConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationSettingsProfileConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<NotificationSettingsProfileCreateFieldInput>>;
};

export type NotificationSettingsProfileNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<NotificationSettingsProfileNodeAggregationWhereInput>>;
  NOT?: InputMaybe<NotificationSettingsProfileNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<NotificationSettingsProfileNodeAggregationWhereInput>>;
  address1_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address1_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address2_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address2_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address3_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address3_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  birthday_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  userUuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  userUuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type NotificationSettingsProfileRelationship = {
  __typename?: 'NotificationSettingsProfileRelationship';
  cursor: Scalars['String']['output'];
  node: Profile;
};

export type NotificationSettingsProfileUpdateConnectionInput = {
  node?: InputMaybe<ProfileUpdateInput>;
};

export type NotificationSettingsProfileUpdateFieldInput = {
  connect?: InputMaybe<Array<NotificationSettingsProfileConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationSettingsProfileConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<NotificationSettingsProfileCreateFieldInput>>;
  delete?: InputMaybe<Array<NotificationSettingsProfileDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<NotificationSettingsProfileDisconnectFieldInput>>;
  update?: InputMaybe<NotificationSettingsProfileUpdateConnectionInput>;
  where?: InputMaybe<NotificationSettingsProfileConnectionWhere>;
};

/** Fields to sort NotificationSettings by. The order in which sorts are applied is not guaranteed when specifying many fields in one NotificationSettingsSort object. */
export type NotificationSettingsSort = {
  email?: InputMaybe<SortDirection>;
  userUuid?: InputMaybe<SortDirection>;
};

export type NotificationSettingsUniqueWhere = {
  userUuid?: InputMaybe<Scalars['ID']['input']>;
};

export type NotificationSettingsUpdateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  profile?: InputMaybe<Array<NotificationSettingsProfileUpdateFieldInput>>;
  pushIds?: InputMaybe<Array<Scalars['String']['input']>>;
  pushIds_POP?: InputMaybe<Scalars['Int']['input']>;
  pushIds_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
  userUuid?: InputMaybe<Scalars['ID']['input']>;
};

export type NotificationSettingsWhere = {
  AND?: InputMaybe<Array<NotificationSettingsWhere>>;
  NOT?: InputMaybe<NotificationSettingsWhere>;
  OR?: InputMaybe<Array<NotificationSettingsWhere>>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  email_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  email_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  email_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `profile_SOME` instead. */
  profile?: InputMaybe<ProfileWhere>;
  profileAggregate?: InputMaybe<NotificationSettingsProfileAggregateInput>;
  /** @deprecated Use `profileConnection_SOME` instead. */
  profileConnection?: InputMaybe<NotificationSettingsProfileConnectionWhere>;
  /** Return NotificationSettings where all of the related NotificationSettingsProfileConnections match this filter */
  profileConnection_ALL?: InputMaybe<NotificationSettingsProfileConnectionWhere>;
  /** Return NotificationSettings where none of the related NotificationSettingsProfileConnections match this filter */
  profileConnection_NONE?: InputMaybe<NotificationSettingsProfileConnectionWhere>;
  /** @deprecated Use `profileConnection_NONE` instead. */
  profileConnection_NOT?: InputMaybe<NotificationSettingsProfileConnectionWhere>;
  /** Return NotificationSettings where one of the related NotificationSettingsProfileConnections match this filter */
  profileConnection_SINGLE?: InputMaybe<NotificationSettingsProfileConnectionWhere>;
  /** Return NotificationSettings where some of the related NotificationSettingsProfileConnections match this filter */
  profileConnection_SOME?: InputMaybe<NotificationSettingsProfileConnectionWhere>;
  /** Return NotificationSettings where all of the related Profiles match this filter */
  profile_ALL?: InputMaybe<ProfileWhere>;
  /** Return NotificationSettings where none of the related Profiles match this filter */
  profile_NONE?: InputMaybe<ProfileWhere>;
  /** @deprecated Use `profile_NONE` instead. */
  profile_NOT?: InputMaybe<ProfileWhere>;
  /** Return NotificationSettings where one of the related Profiles match this filter */
  profile_SINGLE?: InputMaybe<ProfileWhere>;
  /** Return NotificationSettings where some of the related Profiles match this filter */
  profile_SOME?: InputMaybe<ProfileWhere>;
  pushIds?: InputMaybe<Array<Scalars['String']['input']>>;
  pushIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  pushIds_NOT?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  pushIds_NOT_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  userUuid?: InputMaybe<Scalars['ID']['input']>;
  userUuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  userUuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  userUuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  userUuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  userUuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  userUuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  userUuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  userUuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  userUuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * The edge properties for the following fields:
 * * Group.groups
 * * Group.classOrClassGroup
 * * Group.teachingTopics
 * * Group.teachingUnits
 * * Class.tutors
 * * ClassGroup.division
 * * Division.groups
 * * TeachingTopic.teachingUnits
 * * TeachingTopic.topicChilds
 * * Material.fileEntries
 */
export type OrderedRelationProperties = {
  __typename?: 'OrderedRelationProperties';
  order: Scalars['Int']['output'];
};

export type OrderedRelationPropertiesAggregationWhereInput = {
  AND?: InputMaybe<Array<OrderedRelationPropertiesAggregationWhereInput>>;
  NOT?: InputMaybe<OrderedRelationPropertiesAggregationWhereInput>;
  OR?: InputMaybe<Array<OrderedRelationPropertiesAggregationWhereInput>>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderedRelationPropertiesCreateInput = {
  order: Scalars['Int']['input'];
};

export type OrderedRelationPropertiesSort = {
  order?: InputMaybe<SortDirection>;
};

export type OrderedRelationPropertiesUpdateInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
  order_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  order_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderedRelationPropertiesWhere = {
  AND?: InputMaybe<Array<OrderedRelationPropertiesWhere>>;
  NOT?: InputMaybe<OrderedRelationPropertiesWhere>;
  OR?: InputMaybe<Array<OrderedRelationPropertiesWhere>>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_GT?: InputMaybe<Scalars['Int']['input']>;
  order_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_LT?: InputMaybe<Scalars['Int']['input']>;
  order_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  order_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  order_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type Organization = {
  __typename?: 'Organization';
  aboutInfo?: Maybe<Scalars['String']['output']>;
  aboutInfoLastUpdated?: Maybe<Scalars['DateTime']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  /** All Events meant for the whole Organization */
  events: Array<CalendarEvent>;
  eventsAggregate?: Maybe<OrganizationCalendarEventEventsAggregationSelection>;
  eventsConnection: OrganizationEventsConnection;
  foreignRefId?: Maybe<Array<Scalars['String']['output']>>;
  licensedProducts: Array<LicensedProduct>;
  licensedProductsConnection: OrganizationLicensedProductsConnection;
  /** Persist the matrixRoomId to reduce load on Matrix */
  matrixRoomId?: Maybe<Scalars['String']['output']>;
  /** JSON-Field to store additional infos for P5! sync */
  planungSyncProps?: Maybe<Scalars['String']['output']>;
  /** JSON-Field to store additional infos for P5! sync */
  procuratSyncProps?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};

export type OrganizationEventsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CalendarEventOptions>;
  where?: InputMaybe<CalendarEventWhere>;
};

export type OrganizationEventsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CalendarEventWhere>;
};

export type OrganizationEventsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<OrganizationEventsConnectionSort>>;
  where?: InputMaybe<OrganizationEventsConnectionWhere>;
};

export type OrganizationLicensedProductsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<LicensedProductWhere>;
};

export type OrganizationLicensedProductsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<OrganizationLicensedProductsConnectionSort>>;
  where?: InputMaybe<OrganizationLicensedProductsConnectionWhere>;
};

export type OrganizationAggregateSelection = {
  __typename?: 'OrganizationAggregateSelection';
  aboutInfo: StringAggregateSelection;
  aboutInfoLastUpdated: DateTimeAggregateSelection;
  count: Scalars['Int']['output'];
  displayName: StringAggregateSelection;
  matrixRoomId: StringAggregateSelection;
  planungSyncProps: StringAggregateSelection;
  procuratSyncProps: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type OrganizationCalendarEventEventsAggregationSelection = {
  __typename?: 'OrganizationCalendarEventEventsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<OrganizationCalendarEventEventsNodeAggregateSelection>;
};

export type OrganizationCalendarEventEventsNodeAggregateSelection = {
  __typename?: 'OrganizationCalendarEventEventsNodeAggregateSelection';
  classbookHomework: StringAggregateSelection;
  classbookHomeworkContentType: StringAggregateSelection;
  classbookNote: StringAggregateSelection;
  classbookNoteContentType: StringAggregateSelection;
  color: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  descriptionContentType: StringAggregateSelection;
  duration: StringAggregateSelection;
  locale: StringAggregateSelection;
  maxAttendees: IntAggregateSelection;
  privacy: StringAggregateSelection;
  prodId: StringAggregateSelection;
  sequence: IntAggregateSelection;
  start: StringAggregateSelection;
  status: StringAggregateSelection;
  timeZone: StringAggregateSelection;
  title: StringAggregateSelection;
  updated: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type OrganizationConnectInput = {
  licensedProducts?: InputMaybe<OrganizationLicensedProductsConnectInput>;
};

export type OrganizationConnectOrCreateWhere = {
  node: OrganizationUniqueWhere;
};

export type OrganizationConnectWhere = {
  node: OrganizationWhere;
};

export type OrganizationCreateInput = {
  aboutInfo?: InputMaybe<Scalars['String']['input']>;
  aboutInfoLastUpdated?: InputMaybe<Scalars['DateTime']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  foreignRefId?: InputMaybe<Array<Scalars['String']['input']>>;
  licensedProducts?: InputMaybe<OrganizationLicensedProductsCreateInput>;
  matrixRoomId?: InputMaybe<Scalars['String']['input']>;
  planungSyncProps?: InputMaybe<Scalars['String']['input']>;
  procuratSyncProps?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};

export type OrganizationDeleteInput = {
  licensedProducts?: InputMaybe<OrganizationLicensedProductsDeleteInput>;
};

export type OrganizationDisconnectInput = {
  licensedProducts?: InputMaybe<OrganizationLicensedProductsDisconnectInput>;
};

export type OrganizationEdge = {
  __typename?: 'OrganizationEdge';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type OrganizationEventsAggregateInput = {
  AND?: InputMaybe<Array<OrganizationEventsAggregateInput>>;
  NOT?: InputMaybe<OrganizationEventsAggregateInput>;
  OR?: InputMaybe<Array<OrganizationEventsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<OrganizationEventsNodeAggregationWhereInput>;
};

export type OrganizationEventsConnection = {
  __typename?: 'OrganizationEventsConnection';
  edges: Array<OrganizationEventsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OrganizationEventsConnectionSort = {
  node?: InputMaybe<CalendarEventSort>;
};

export type OrganizationEventsConnectionWhere = {
  AND?: InputMaybe<Array<OrganizationEventsConnectionWhere>>;
  NOT?: InputMaybe<OrganizationEventsConnectionWhere>;
  OR?: InputMaybe<Array<OrganizationEventsConnectionWhere>>;
  node?: InputMaybe<CalendarEventWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<CalendarEventWhere>;
};

export type OrganizationEventsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<OrganizationEventsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<OrganizationEventsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<OrganizationEventsNodeAggregationWhereInput>>;
  classbookHomeworkContentType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classbookHomeworkContentType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classbookHomeworkContentType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classbookHomeworkContentType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classbookHomeworkContentType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classbookHomeworkContentType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classbookHomeworkContentType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classbookHomeworkContentType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classbookHomeworkContentType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classbookHomeworkContentType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classbookHomeworkContentType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classbookHomeworkContentType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classbookHomeworkContentType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classbookHomeworkContentType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classbookHomeworkContentType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classbookHomework_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classbookHomework_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classbookHomework_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classbookHomework_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classbookHomework_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classbookHomework_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classbookHomework_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classbookHomework_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classbookHomework_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classbookHomework_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classbookHomework_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classbookHomework_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classbookHomework_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classbookHomework_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classbookHomework_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classbookNoteContentType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classbookNoteContentType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classbookNoteContentType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classbookNoteContentType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classbookNoteContentType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classbookNoteContentType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classbookNoteContentType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classbookNoteContentType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classbookNoteContentType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classbookNoteContentType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classbookNoteContentType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classbookNoteContentType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classbookNoteContentType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classbookNoteContentType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classbookNoteContentType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classbookNote_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classbookNote_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classbookNote_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classbookNote_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classbookNote_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classbookNote_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classbookNote_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classbookNote_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classbookNote_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classbookNote_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classbookNote_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classbookNote_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classbookNote_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classbookNote_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classbookNote_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  color_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  color_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  descriptionContentType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionContentType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionContentType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionContentType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionContentType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionContentType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionContentType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionContentType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionContentType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionContentType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionContentType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionContentType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionContentType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionContentType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionContentType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  duration_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  duration_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  duration_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  locale_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maxAttendees_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  maxAttendees_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  maxAttendees_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  maxAttendees_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  maxAttendees_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  privacy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  privacy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  privacy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  privacy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  privacy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  privacy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  privacy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  privacy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  privacy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  privacy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  privacy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  privacy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  privacy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  privacy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  privacy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prodId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  prodId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  prodId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  prodId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  prodId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  prodId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prodId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prodId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prodId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prodId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prodId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prodId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prodId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prodId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prodId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sequence_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sequence_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sequence_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sequence_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sequence_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  sequence_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sequence_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sequence_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sequence_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sequence_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sequence_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sequence_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sequence_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sequence_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sequence_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sequence_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sequence_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sequence_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sequence_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sequence_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  start_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  start_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  start_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  start_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  start_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  status_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  status_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeZone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeZone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timeZone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeZone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timeZone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeZone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeZone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timeZone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeZone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timeZone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeZone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeZone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timeZone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeZone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timeZone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrganizationEventsRelationship = {
  __typename?: 'OrganizationEventsRelationship';
  cursor: Scalars['String']['output'];
  node: CalendarEvent;
};

export type OrganizationLicensedProductsBigBlueButtonConnectFieldInput = {
  connect?: InputMaybe<Array<BigBlueButtonConnectInput>>;
  edge?: InputMaybe<LicensePropertiesCreateInput>;
  where?: InputMaybe<BigBlueButtonConnectWhere>;
};

export type OrganizationLicensedProductsBigBlueButtonConnectionWhere = {
  AND?: InputMaybe<Array<OrganizationLicensedProductsBigBlueButtonConnectionWhere>>;
  NOT?: InputMaybe<OrganizationLicensedProductsBigBlueButtonConnectionWhere>;
  OR?: InputMaybe<Array<OrganizationLicensedProductsBigBlueButtonConnectionWhere>>;
  edge?: InputMaybe<LicensePropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<LicensePropertiesWhere>;
  node?: InputMaybe<BigBlueButtonWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<BigBlueButtonWhere>;
};

export type OrganizationLicensedProductsBigBlueButtonCreateFieldInput = {
  edge?: InputMaybe<LicensePropertiesCreateInput>;
  node: BigBlueButtonCreateInput;
};

export type OrganizationLicensedProductsBigBlueButtonDeleteFieldInput = {
  delete?: InputMaybe<BigBlueButtonDeleteInput>;
  where?: InputMaybe<OrganizationLicensedProductsBigBlueButtonConnectionWhere>;
};

export type OrganizationLicensedProductsBigBlueButtonDisconnectFieldInput = {
  disconnect?: InputMaybe<BigBlueButtonDisconnectInput>;
  where?: InputMaybe<OrganizationLicensedProductsBigBlueButtonConnectionWhere>;
};

export type OrganizationLicensedProductsBigBlueButtonFieldInput = {
  connect?: InputMaybe<Array<OrganizationLicensedProductsBigBlueButtonConnectFieldInput>>;
  create?: InputMaybe<Array<OrganizationLicensedProductsBigBlueButtonCreateFieldInput>>;
};

export type OrganizationLicensedProductsBigBlueButtonUpdateConnectionInput = {
  edge?: InputMaybe<LicensePropertiesUpdateInput>;
  node?: InputMaybe<BigBlueButtonUpdateInput>;
};

export type OrganizationLicensedProductsBigBlueButtonUpdateFieldInput = {
  connect?: InputMaybe<Array<OrganizationLicensedProductsBigBlueButtonConnectFieldInput>>;
  create?: InputMaybe<Array<OrganizationLicensedProductsBigBlueButtonCreateFieldInput>>;
  delete?: InputMaybe<Array<OrganizationLicensedProductsBigBlueButtonDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<OrganizationLicensedProductsBigBlueButtonDisconnectFieldInput>>;
  update?: InputMaybe<OrganizationLicensedProductsBigBlueButtonUpdateConnectionInput>;
  where?: InputMaybe<OrganizationLicensedProductsBigBlueButtonConnectionWhere>;
};

export type OrganizationLicensedProductsBildungsplattformConnectFieldInput = {
  connect?: InputMaybe<Array<BildungsplattformConnectInput>>;
  edge?: InputMaybe<LicensePropertiesCreateInput>;
  where?: InputMaybe<BildungsplattformConnectWhere>;
};

export type OrganizationLicensedProductsBildungsplattformConnectionWhere = {
  AND?: InputMaybe<Array<OrganizationLicensedProductsBildungsplattformConnectionWhere>>;
  NOT?: InputMaybe<OrganizationLicensedProductsBildungsplattformConnectionWhere>;
  OR?: InputMaybe<Array<OrganizationLicensedProductsBildungsplattformConnectionWhere>>;
  edge?: InputMaybe<LicensePropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<LicensePropertiesWhere>;
  node?: InputMaybe<BildungsplattformWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<BildungsplattformWhere>;
};

export type OrganizationLicensedProductsBildungsplattformCreateFieldInput = {
  edge?: InputMaybe<LicensePropertiesCreateInput>;
  node: BildungsplattformCreateInput;
};

export type OrganizationLicensedProductsBildungsplattformDeleteFieldInput = {
  delete?: InputMaybe<BildungsplattformDeleteInput>;
  where?: InputMaybe<OrganizationLicensedProductsBildungsplattformConnectionWhere>;
};

export type OrganizationLicensedProductsBildungsplattformDisconnectFieldInput = {
  disconnect?: InputMaybe<BildungsplattformDisconnectInput>;
  where?: InputMaybe<OrganizationLicensedProductsBildungsplattformConnectionWhere>;
};

export type OrganizationLicensedProductsBildungsplattformFieldInput = {
  connect?: InputMaybe<Array<OrganizationLicensedProductsBildungsplattformConnectFieldInput>>;
  create?: InputMaybe<Array<OrganizationLicensedProductsBildungsplattformCreateFieldInput>>;
};

export type OrganizationLicensedProductsBildungsplattformUpdateConnectionInput = {
  edge?: InputMaybe<LicensePropertiesUpdateInput>;
  node?: InputMaybe<BildungsplattformUpdateInput>;
};

export type OrganizationLicensedProductsBildungsplattformUpdateFieldInput = {
  connect?: InputMaybe<Array<OrganizationLicensedProductsBildungsplattformConnectFieldInput>>;
  create?: InputMaybe<Array<OrganizationLicensedProductsBildungsplattformCreateFieldInput>>;
  delete?: InputMaybe<Array<OrganizationLicensedProductsBildungsplattformDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<OrganizationLicensedProductsBildungsplattformDisconnectFieldInput>>;
  update?: InputMaybe<OrganizationLicensedProductsBildungsplattformUpdateConnectionInput>;
  where?: InputMaybe<OrganizationLicensedProductsBildungsplattformConnectionWhere>;
};

export type OrganizationLicensedProductsConnectInput = {
  BigBlueButton?: InputMaybe<Array<OrganizationLicensedProductsBigBlueButtonConnectFieldInput>>;
  Bildungsplattform?: InputMaybe<Array<OrganizationLicensedProductsBildungsplattformConnectFieldInput>>;
  Nextcloud?: InputMaybe<Array<OrganizationLicensedProductsNextcloudConnectFieldInput>>;
  Threema?: InputMaybe<Array<OrganizationLicensedProductsThreemaConnectFieldInput>>;
  ThreemaBroadcast?: InputMaybe<Array<OrganizationLicensedProductsThreemaBroadcastConnectFieldInput>>;
  Zoom?: InputMaybe<Array<OrganizationLicensedProductsZoomConnectFieldInput>>;
};

export type OrganizationLicensedProductsConnection = {
  __typename?: 'OrganizationLicensedProductsConnection';
  edges: Array<OrganizationLicensedProductsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OrganizationLicensedProductsConnectionSort = {
  edge?: InputMaybe<LicensePropertiesSort>;
};

export type OrganizationLicensedProductsConnectionWhere = {
  BigBlueButton?: InputMaybe<OrganizationLicensedProductsBigBlueButtonConnectionWhere>;
  Bildungsplattform?: InputMaybe<OrganizationLicensedProductsBildungsplattformConnectionWhere>;
  Nextcloud?: InputMaybe<OrganizationLicensedProductsNextcloudConnectionWhere>;
  Threema?: InputMaybe<OrganizationLicensedProductsThreemaConnectionWhere>;
  ThreemaBroadcast?: InputMaybe<OrganizationLicensedProductsThreemaBroadcastConnectionWhere>;
  Zoom?: InputMaybe<OrganizationLicensedProductsZoomConnectionWhere>;
};

export type OrganizationLicensedProductsCreateInput = {
  BigBlueButton?: InputMaybe<OrganizationLicensedProductsBigBlueButtonFieldInput>;
  Bildungsplattform?: InputMaybe<OrganizationLicensedProductsBildungsplattformFieldInput>;
  Nextcloud?: InputMaybe<OrganizationLicensedProductsNextcloudFieldInput>;
  Threema?: InputMaybe<OrganizationLicensedProductsThreemaFieldInput>;
  ThreemaBroadcast?: InputMaybe<OrganizationLicensedProductsThreemaBroadcastFieldInput>;
  Zoom?: InputMaybe<OrganizationLicensedProductsZoomFieldInput>;
};

export type OrganizationLicensedProductsDeleteInput = {
  BigBlueButton?: InputMaybe<Array<OrganizationLicensedProductsBigBlueButtonDeleteFieldInput>>;
  Bildungsplattform?: InputMaybe<Array<OrganizationLicensedProductsBildungsplattformDeleteFieldInput>>;
  Nextcloud?: InputMaybe<Array<OrganizationLicensedProductsNextcloudDeleteFieldInput>>;
  Threema?: InputMaybe<Array<OrganizationLicensedProductsThreemaDeleteFieldInput>>;
  ThreemaBroadcast?: InputMaybe<Array<OrganizationLicensedProductsThreemaBroadcastDeleteFieldInput>>;
  Zoom?: InputMaybe<Array<OrganizationLicensedProductsZoomDeleteFieldInput>>;
};

export type OrganizationLicensedProductsDisconnectInput = {
  BigBlueButton?: InputMaybe<Array<OrganizationLicensedProductsBigBlueButtonDisconnectFieldInput>>;
  Bildungsplattform?: InputMaybe<Array<OrganizationLicensedProductsBildungsplattformDisconnectFieldInput>>;
  Nextcloud?: InputMaybe<Array<OrganizationLicensedProductsNextcloudDisconnectFieldInput>>;
  Threema?: InputMaybe<Array<OrganizationLicensedProductsThreemaDisconnectFieldInput>>;
  ThreemaBroadcast?: InputMaybe<Array<OrganizationLicensedProductsThreemaBroadcastDisconnectFieldInput>>;
  Zoom?: InputMaybe<Array<OrganizationLicensedProductsZoomDisconnectFieldInput>>;
};

export type OrganizationLicensedProductsNextcloudConnectFieldInput = {
  connect?: InputMaybe<Array<NextcloudConnectInput>>;
  edge?: InputMaybe<LicensePropertiesCreateInput>;
  where?: InputMaybe<NextcloudConnectWhere>;
};

export type OrganizationLicensedProductsNextcloudConnectionWhere = {
  AND?: InputMaybe<Array<OrganizationLicensedProductsNextcloudConnectionWhere>>;
  NOT?: InputMaybe<OrganizationLicensedProductsNextcloudConnectionWhere>;
  OR?: InputMaybe<Array<OrganizationLicensedProductsNextcloudConnectionWhere>>;
  edge?: InputMaybe<LicensePropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<LicensePropertiesWhere>;
  node?: InputMaybe<NextcloudWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<NextcloudWhere>;
};

export type OrganizationLicensedProductsNextcloudCreateFieldInput = {
  edge?: InputMaybe<LicensePropertiesCreateInput>;
  node: NextcloudCreateInput;
};

export type OrganizationLicensedProductsNextcloudDeleteFieldInput = {
  delete?: InputMaybe<NextcloudDeleteInput>;
  where?: InputMaybe<OrganizationLicensedProductsNextcloudConnectionWhere>;
};

export type OrganizationLicensedProductsNextcloudDisconnectFieldInput = {
  disconnect?: InputMaybe<NextcloudDisconnectInput>;
  where?: InputMaybe<OrganizationLicensedProductsNextcloudConnectionWhere>;
};

export type OrganizationLicensedProductsNextcloudFieldInput = {
  connect?: InputMaybe<Array<OrganizationLicensedProductsNextcloudConnectFieldInput>>;
  create?: InputMaybe<Array<OrganizationLicensedProductsNextcloudCreateFieldInput>>;
};

export type OrganizationLicensedProductsNextcloudUpdateConnectionInput = {
  edge?: InputMaybe<LicensePropertiesUpdateInput>;
  node?: InputMaybe<NextcloudUpdateInput>;
};

export type OrganizationLicensedProductsNextcloudUpdateFieldInput = {
  connect?: InputMaybe<Array<OrganizationLicensedProductsNextcloudConnectFieldInput>>;
  create?: InputMaybe<Array<OrganizationLicensedProductsNextcloudCreateFieldInput>>;
  delete?: InputMaybe<Array<OrganizationLicensedProductsNextcloudDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<OrganizationLicensedProductsNextcloudDisconnectFieldInput>>;
  update?: InputMaybe<OrganizationLicensedProductsNextcloudUpdateConnectionInput>;
  where?: InputMaybe<OrganizationLicensedProductsNextcloudConnectionWhere>;
};

export type OrganizationLicensedProductsRelationship = {
  __typename?: 'OrganizationLicensedProductsRelationship';
  cursor: Scalars['String']['output'];
  node: LicensedProduct;
  properties: LicenseProperties;
};

export type OrganizationLicensedProductsThreemaBroadcastConnectFieldInput = {
  connect?: InputMaybe<Array<ThreemaBroadcastConnectInput>>;
  edge?: InputMaybe<LicensePropertiesCreateInput>;
  where?: InputMaybe<ThreemaBroadcastConnectWhere>;
};

export type OrganizationLicensedProductsThreemaBroadcastConnectionWhere = {
  AND?: InputMaybe<Array<OrganizationLicensedProductsThreemaBroadcastConnectionWhere>>;
  NOT?: InputMaybe<OrganizationLicensedProductsThreemaBroadcastConnectionWhere>;
  OR?: InputMaybe<Array<OrganizationLicensedProductsThreemaBroadcastConnectionWhere>>;
  edge?: InputMaybe<LicensePropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<LicensePropertiesWhere>;
  node?: InputMaybe<ThreemaBroadcastWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ThreemaBroadcastWhere>;
};

export type OrganizationLicensedProductsThreemaBroadcastCreateFieldInput = {
  edge?: InputMaybe<LicensePropertiesCreateInput>;
  node: ThreemaBroadcastCreateInput;
};

export type OrganizationLicensedProductsThreemaBroadcastDeleteFieldInput = {
  delete?: InputMaybe<ThreemaBroadcastDeleteInput>;
  where?: InputMaybe<OrganizationLicensedProductsThreemaBroadcastConnectionWhere>;
};

export type OrganizationLicensedProductsThreemaBroadcastDisconnectFieldInput = {
  disconnect?: InputMaybe<ThreemaBroadcastDisconnectInput>;
  where?: InputMaybe<OrganizationLicensedProductsThreemaBroadcastConnectionWhere>;
};

export type OrganizationLicensedProductsThreemaBroadcastFieldInput = {
  connect?: InputMaybe<Array<OrganizationLicensedProductsThreemaBroadcastConnectFieldInput>>;
  create?: InputMaybe<Array<OrganizationLicensedProductsThreemaBroadcastCreateFieldInput>>;
};

export type OrganizationLicensedProductsThreemaBroadcastUpdateConnectionInput = {
  edge?: InputMaybe<LicensePropertiesUpdateInput>;
  node?: InputMaybe<ThreemaBroadcastUpdateInput>;
};

export type OrganizationLicensedProductsThreemaBroadcastUpdateFieldInput = {
  connect?: InputMaybe<Array<OrganizationLicensedProductsThreemaBroadcastConnectFieldInput>>;
  create?: InputMaybe<Array<OrganizationLicensedProductsThreemaBroadcastCreateFieldInput>>;
  delete?: InputMaybe<Array<OrganizationLicensedProductsThreemaBroadcastDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<OrganizationLicensedProductsThreemaBroadcastDisconnectFieldInput>>;
  update?: InputMaybe<OrganizationLicensedProductsThreemaBroadcastUpdateConnectionInput>;
  where?: InputMaybe<OrganizationLicensedProductsThreemaBroadcastConnectionWhere>;
};

export type OrganizationLicensedProductsThreemaConnectFieldInput = {
  connect?: InputMaybe<Array<ThreemaConnectInput>>;
  edge?: InputMaybe<LicensePropertiesCreateInput>;
  where?: InputMaybe<ThreemaConnectWhere>;
};

export type OrganizationLicensedProductsThreemaConnectionWhere = {
  AND?: InputMaybe<Array<OrganizationLicensedProductsThreemaConnectionWhere>>;
  NOT?: InputMaybe<OrganizationLicensedProductsThreemaConnectionWhere>;
  OR?: InputMaybe<Array<OrganizationLicensedProductsThreemaConnectionWhere>>;
  edge?: InputMaybe<LicensePropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<LicensePropertiesWhere>;
  node?: InputMaybe<ThreemaWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ThreemaWhere>;
};

export type OrganizationLicensedProductsThreemaCreateFieldInput = {
  edge?: InputMaybe<LicensePropertiesCreateInput>;
  node: ThreemaCreateInput;
};

export type OrganizationLicensedProductsThreemaDeleteFieldInput = {
  delete?: InputMaybe<ThreemaDeleteInput>;
  where?: InputMaybe<OrganizationLicensedProductsThreemaConnectionWhere>;
};

export type OrganizationLicensedProductsThreemaDisconnectFieldInput = {
  disconnect?: InputMaybe<ThreemaDisconnectInput>;
  where?: InputMaybe<OrganizationLicensedProductsThreemaConnectionWhere>;
};

export type OrganizationLicensedProductsThreemaFieldInput = {
  connect?: InputMaybe<Array<OrganizationLicensedProductsThreemaConnectFieldInput>>;
  create?: InputMaybe<Array<OrganizationLicensedProductsThreemaCreateFieldInput>>;
};

export type OrganizationLicensedProductsThreemaUpdateConnectionInput = {
  edge?: InputMaybe<LicensePropertiesUpdateInput>;
  node?: InputMaybe<ThreemaUpdateInput>;
};

export type OrganizationLicensedProductsThreemaUpdateFieldInput = {
  connect?: InputMaybe<Array<OrganizationLicensedProductsThreemaConnectFieldInput>>;
  create?: InputMaybe<Array<OrganizationLicensedProductsThreemaCreateFieldInput>>;
  delete?: InputMaybe<Array<OrganizationLicensedProductsThreemaDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<OrganizationLicensedProductsThreemaDisconnectFieldInput>>;
  update?: InputMaybe<OrganizationLicensedProductsThreemaUpdateConnectionInput>;
  where?: InputMaybe<OrganizationLicensedProductsThreemaConnectionWhere>;
};

export type OrganizationLicensedProductsUpdateInput = {
  BigBlueButton?: InputMaybe<Array<OrganizationLicensedProductsBigBlueButtonUpdateFieldInput>>;
  Bildungsplattform?: InputMaybe<Array<OrganizationLicensedProductsBildungsplattformUpdateFieldInput>>;
  Nextcloud?: InputMaybe<Array<OrganizationLicensedProductsNextcloudUpdateFieldInput>>;
  Threema?: InputMaybe<Array<OrganizationLicensedProductsThreemaUpdateFieldInput>>;
  ThreemaBroadcast?: InputMaybe<Array<OrganizationLicensedProductsThreemaBroadcastUpdateFieldInput>>;
  Zoom?: InputMaybe<Array<OrganizationLicensedProductsZoomUpdateFieldInput>>;
};

export type OrganizationLicensedProductsZoomConnectFieldInput = {
  connect?: InputMaybe<Array<ZoomConnectInput>>;
  edge?: InputMaybe<LicensePropertiesCreateInput>;
  where?: InputMaybe<ZoomConnectWhere>;
};

export type OrganizationLicensedProductsZoomConnectionWhere = {
  AND?: InputMaybe<Array<OrganizationLicensedProductsZoomConnectionWhere>>;
  NOT?: InputMaybe<OrganizationLicensedProductsZoomConnectionWhere>;
  OR?: InputMaybe<Array<OrganizationLicensedProductsZoomConnectionWhere>>;
  edge?: InputMaybe<LicensePropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<LicensePropertiesWhere>;
  node?: InputMaybe<ZoomWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ZoomWhere>;
};

export type OrganizationLicensedProductsZoomCreateFieldInput = {
  edge?: InputMaybe<LicensePropertiesCreateInput>;
  node: ZoomCreateInput;
};

export type OrganizationLicensedProductsZoomDeleteFieldInput = {
  delete?: InputMaybe<ZoomDeleteInput>;
  where?: InputMaybe<OrganizationLicensedProductsZoomConnectionWhere>;
};

export type OrganizationLicensedProductsZoomDisconnectFieldInput = {
  disconnect?: InputMaybe<ZoomDisconnectInput>;
  where?: InputMaybe<OrganizationLicensedProductsZoomConnectionWhere>;
};

export type OrganizationLicensedProductsZoomFieldInput = {
  connect?: InputMaybe<Array<OrganizationLicensedProductsZoomConnectFieldInput>>;
  create?: InputMaybe<Array<OrganizationLicensedProductsZoomCreateFieldInput>>;
};

export type OrganizationLicensedProductsZoomUpdateConnectionInput = {
  edge?: InputMaybe<LicensePropertiesUpdateInput>;
  node?: InputMaybe<ZoomUpdateInput>;
};

export type OrganizationLicensedProductsZoomUpdateFieldInput = {
  connect?: InputMaybe<Array<OrganizationLicensedProductsZoomConnectFieldInput>>;
  create?: InputMaybe<Array<OrganizationLicensedProductsZoomCreateFieldInput>>;
  delete?: InputMaybe<Array<OrganizationLicensedProductsZoomDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<OrganizationLicensedProductsZoomDisconnectFieldInput>>;
  update?: InputMaybe<OrganizationLicensedProductsZoomUpdateConnectionInput>;
  where?: InputMaybe<OrganizationLicensedProductsZoomConnectionWhere>;
};

export type OrganizationOnCreateInput = {
  aboutInfo?: InputMaybe<Scalars['String']['input']>;
  aboutInfoLastUpdated?: InputMaybe<Scalars['DateTime']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  foreignRefId?: InputMaybe<Array<Scalars['String']['input']>>;
  matrixRoomId?: InputMaybe<Scalars['String']['input']>;
  planungSyncProps?: InputMaybe<Scalars['String']['input']>;
  procuratSyncProps?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};

export type OrganizationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more OrganizationSort objects to sort Organizations by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<OrganizationSort>>;
};

/** Fields to sort Organizations by. The order in which sorts are applied is not guaranteed when specifying many fields in one OrganizationSort object. */
export type OrganizationSort = {
  aboutInfo?: InputMaybe<SortDirection>;
  aboutInfoLastUpdated?: InputMaybe<SortDirection>;
  displayName?: InputMaybe<SortDirection>;
  matrixRoomId?: InputMaybe<SortDirection>;
  planungSyncProps?: InputMaybe<SortDirection>;
  procuratSyncProps?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type OrganizationUniqueWhere = {
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type OrganizationUpdateInput = {
  aboutInfo?: InputMaybe<Scalars['String']['input']>;
  aboutInfoLastUpdated?: InputMaybe<Scalars['DateTime']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  foreignRefId?: InputMaybe<Array<Scalars['String']['input']>>;
  foreignRefId_POP?: InputMaybe<Scalars['Int']['input']>;
  foreignRefId_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
  licensedProducts?: InputMaybe<OrganizationLicensedProductsUpdateInput>;
  matrixRoomId?: InputMaybe<Scalars['String']['input']>;
  planungSyncProps?: InputMaybe<Scalars['String']['input']>;
  procuratSyncProps?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type OrganizationWhere = {
  AND?: InputMaybe<Array<OrganizationWhere>>;
  NOT?: InputMaybe<OrganizationWhere>;
  OR?: InputMaybe<Array<OrganizationWhere>>;
  aboutInfo?: InputMaybe<Scalars['String']['input']>;
  aboutInfoLastUpdated?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_GT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  aboutInfoLastUpdated_LT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  aboutInfoLastUpdated_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  aboutInfoLastUpdated_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  aboutInfo_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  aboutInfo_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  aboutInfo_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  aboutInfo_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  aboutInfo_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  aboutInfo_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  aboutInfo_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  aboutInfo_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  aboutInfo_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  displayName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  displayName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  displayName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `events_SOME` instead. */
  events?: InputMaybe<CalendarEventWhere>;
  eventsAggregate?: InputMaybe<OrganizationEventsAggregateInput>;
  /** @deprecated Use `eventsConnection_SOME` instead. */
  eventsConnection?: InputMaybe<OrganizationEventsConnectionWhere>;
  /** Return Organizations where all of the related OrganizationEventsConnections match this filter */
  eventsConnection_ALL?: InputMaybe<OrganizationEventsConnectionWhere>;
  /** Return Organizations where none of the related OrganizationEventsConnections match this filter */
  eventsConnection_NONE?: InputMaybe<OrganizationEventsConnectionWhere>;
  /** @deprecated Use `eventsConnection_NONE` instead. */
  eventsConnection_NOT?: InputMaybe<OrganizationEventsConnectionWhere>;
  /** Return Organizations where one of the related OrganizationEventsConnections match this filter */
  eventsConnection_SINGLE?: InputMaybe<OrganizationEventsConnectionWhere>;
  /** Return Organizations where some of the related OrganizationEventsConnections match this filter */
  eventsConnection_SOME?: InputMaybe<OrganizationEventsConnectionWhere>;
  /** Return Organizations where all of the related CalendarEvents match this filter */
  events_ALL?: InputMaybe<CalendarEventWhere>;
  /** Return Organizations where none of the related CalendarEvents match this filter */
  events_NONE?: InputMaybe<CalendarEventWhere>;
  /** @deprecated Use `events_NONE` instead. */
  events_NOT?: InputMaybe<CalendarEventWhere>;
  /** Return Organizations where one of the related CalendarEvents match this filter */
  events_SINGLE?: InputMaybe<CalendarEventWhere>;
  /** Return Organizations where some of the related CalendarEvents match this filter */
  events_SOME?: InputMaybe<CalendarEventWhere>;
  foreignRefId?: InputMaybe<Array<Scalars['String']['input']>>;
  foreignRefId_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignRefId_NOT?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignRefId_NOT_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `licensedProducts_SOME` instead. */
  licensedProducts?: InputMaybe<LicensedProductWhere>;
  /** @deprecated Use `licensedProductsConnection_SOME` instead. */
  licensedProductsConnection?: InputMaybe<OrganizationLicensedProductsConnectionWhere>;
  /** Return Organizations where all of the related OrganizationLicensedProductsConnections match this filter */
  licensedProductsConnection_ALL?: InputMaybe<OrganizationLicensedProductsConnectionWhere>;
  /** Return Organizations where none of the related OrganizationLicensedProductsConnections match this filter */
  licensedProductsConnection_NONE?: InputMaybe<OrganizationLicensedProductsConnectionWhere>;
  /** @deprecated Use `licensedProductsConnection_NONE` instead. */
  licensedProductsConnection_NOT?: InputMaybe<OrganizationLicensedProductsConnectionWhere>;
  /** Return Organizations where one of the related OrganizationLicensedProductsConnections match this filter */
  licensedProductsConnection_SINGLE?: InputMaybe<OrganizationLicensedProductsConnectionWhere>;
  /** Return Organizations where some of the related OrganizationLicensedProductsConnections match this filter */
  licensedProductsConnection_SOME?: InputMaybe<OrganizationLicensedProductsConnectionWhere>;
  /** Return Organizations where all of the related LicensedProducts match this filter */
  licensedProducts_ALL?: InputMaybe<LicensedProductWhere>;
  /** Return Organizations where none of the related LicensedProducts match this filter */
  licensedProducts_NONE?: InputMaybe<LicensedProductWhere>;
  /** @deprecated Use `licensedProducts_NONE` instead. */
  licensedProducts_NOT?: InputMaybe<LicensedProductWhere>;
  /** Return Organizations where one of the related LicensedProducts match this filter */
  licensedProducts_SINGLE?: InputMaybe<LicensedProductWhere>;
  /** Return Organizations where some of the related LicensedProducts match this filter */
  licensedProducts_SOME?: InputMaybe<LicensedProductWhere>;
  matrixRoomId?: InputMaybe<Scalars['String']['input']>;
  matrixRoomId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  matrixRoomId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  matrixRoomId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  matrixRoomId_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  matrixRoomId_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  matrixRoomId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  matrixRoomId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  matrixRoomId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  matrixRoomId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  planungSyncProps?: InputMaybe<Scalars['String']['input']>;
  planungSyncProps_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  planungSyncProps_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  planungSyncProps_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  planungSyncProps_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  planungSyncProps_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  planungSyncProps_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  planungSyncProps_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  planungSyncProps_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  planungSyncProps_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  procuratSyncProps?: InputMaybe<Scalars['String']['input']>;
  procuratSyncProps_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  procuratSyncProps_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  procuratSyncProps_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  procuratSyncProps_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  procuratSyncProps_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  procuratSyncProps_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  procuratSyncProps_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  procuratSyncProps_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  procuratSyncProps_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type OrganizationsConnection = {
  __typename?: 'OrganizationsConnection';
  edges: Array<OrganizationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Pagination information (Relay) */
export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PasswordUpdateInput = {
  newPassword: Scalars['String']['input'];
  oldPassword?: InputMaybe<Scalars['String']['input']>;
};

export type PasswordWhere = {
  uuid: Scalars['ID']['input'];
};

export type PimOrganization = {
  __typename?: 'PimOrganization';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  address3?: Maybe<Scalars['String']['output']>;
  bpEnabled?: Maybe<Scalars['Boolean']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  planungEnabled?: Maybe<Scalars['Boolean']['output']>;
  uuid: Scalars['ID']['output'];
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type PimOrganizationEdge = {
  __typename?: 'PimOrganizationEdge';
  cursor: Scalars['String']['output'];
  node: PimOrganization;
};

export type PimOrganizationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PimOrganizationSort objects to sort PimOrganizations by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PimOrganizationSort>>;
};

/** Fields to sort PimOrganizations by. The order in which sorts are applied is not guaranteed when specifying many fields in one PimOrganizationSort object. */
export type PimOrganizationSort = {
  address1?: InputMaybe<SortDirection>;
  address2?: InputMaybe<SortDirection>;
  address3?: InputMaybe<SortDirection>;
  bpEnabled?: InputMaybe<SortDirection>;
  city?: InputMaybe<SortDirection>;
  country?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  planungEnabled?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
  zipCode?: InputMaybe<SortDirection>;
};

export type PimOrganizationWhere = {
  AND?: InputMaybe<Array<PimOrganizationWhere>>;
  NOT?: InputMaybe<PimOrganizationWhere>;
  OR?: InputMaybe<Array<PimOrganizationWhere>>;
  address1?: InputMaybe<Scalars['String']['input']>;
  address1_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  address1_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  address1_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address1_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address1_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address1_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address1_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address1_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  address1_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  address2_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  address2_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  address2_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address2_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address2_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address2_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address2_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address2_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  address2_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  address3?: InputMaybe<Scalars['String']['input']>;
  address3_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  address3_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  address3_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address3_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address3_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address3_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address3_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address3_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  address3_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  bpEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  bpEnabled_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  city_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  city_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  city_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  city_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  city_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  city_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  city_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  city_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  city_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  country_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  country_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  country_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  country_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  country_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  country_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  country_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  country_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  country_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  planungEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  planungEnabled_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
  zipCode_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  zipCode_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  zipCode_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  zipCode_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  zipCode_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  zipCode_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  zipCode_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  zipCode_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  zipCode_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type PimOrganizationsConnection = {
  __typename?: 'PimOrganizationsConnection';
  edges: Array<PimOrganizationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PimProfile = {
  __typename?: 'PimProfile';
  displayName?: Maybe<Scalars['String']['output']>;
  displayNameShort?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  firstNames?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  organization: Organization;
  prefixName?: Maybe<Scalars['String']['output']>;
  salutation?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};

export type Preference = {
  __typename?: 'Preference';
  name: Scalars['String']['output'];
};

export type PreferenceAggregateSelection = {
  __typename?: 'PreferenceAggregateSelection';
  count: Scalars['Int']['output'];
  name: StringAggregateSelection;
};

export type PreferenceConnectOrCreateWhere = {
  node: PreferenceUniqueWhere;
};

export type PreferenceConnectWhere = {
  node: PreferenceWhere;
};

export type PreferenceCreateInput = {
  name: Scalars['String']['input'];
};

export type PreferenceEdge = {
  __typename?: 'PreferenceEdge';
  cursor: Scalars['String']['output'];
  node: Preference;
};

export type PreferenceOnCreateInput = {
  name: Scalars['String']['input'];
};

export type PreferenceOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PreferenceSort objects to sort Preferences by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PreferenceSort>>;
};

/**
 * The edge properties for the following fields:
 * * Profile.preferences
 */
export type PreferenceProperty = {
  __typename?: 'PreferenceProperty';
  value?: Maybe<Scalars['String']['output']>;
};

export type PreferencePropertyAggregationWhereInput = {
  AND?: InputMaybe<Array<PreferencePropertyAggregationWhereInput>>;
  NOT?: InputMaybe<PreferencePropertyAggregationWhereInput>;
  OR?: InputMaybe<Array<PreferencePropertyAggregationWhereInput>>;
  value_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  value_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  value_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  value_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  value_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  value_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PreferencePropertyCreateInput = {
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PreferencePropertySort = {
  value?: InputMaybe<SortDirection>;
};

export type PreferencePropertyUpdateInput = {
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PreferencePropertyWhere = {
  AND?: InputMaybe<Array<PreferencePropertyWhere>>;
  NOT?: InputMaybe<PreferencePropertyWhere>;
  OR?: InputMaybe<Array<PreferencePropertyWhere>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  value_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  value_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  value_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

/** Fields to sort Preferences by. The order in which sorts are applied is not guaranteed when specifying many fields in one PreferenceSort object. */
export type PreferenceSort = {
  name?: InputMaybe<SortDirection>;
};

export type PreferenceUniqueWhere = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type PreferenceUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type PreferenceWhere = {
  AND?: InputMaybe<Array<PreferenceWhere>>;
  NOT?: InputMaybe<PreferenceWhere>;
  OR?: InputMaybe<Array<PreferenceWhere>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type PreferencesConnection = {
  __typename?: 'PreferencesConnection';
  edges: Array<PreferenceEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Profile = {
  __typename?: 'Profile';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  address3?: Maybe<Scalars['String']['output']>;
  attendsEvents: Array<CalendarEvent>;
  attendsEventsAggregate?: Maybe<ProfileCalendarEventAttendsEventsAggregationSelection>;
  attendsEventsConnection: ProfileAttendsEventsConnection;
  birthday?: Maybe<Scalars['String']['output']>;
  calendarSubscriptions: Array<CalendarSubscription>;
  calendarSubscriptionsAggregate?: Maybe<ProfileCalendarSubscriptionCalendarSubscriptionsAggregationSelection>;
  calendarSubscriptionsConnection: ProfileCalendarSubscriptionsConnection;
  classes: Array<Class>;
  classesAggregate?: Maybe<ProfileClassClassesAggregationSelection>;
  classesConnection: ProfileClassesConnection;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  directMessages?: Maybe<Profile>;
  directMessagesAggregate?: Maybe<ProfileProfileDirectMessagesAggregationSelection>;
  directMessagesConnection: ProfileDirectMessagesConnection;
  displayName?: Maybe<Scalars['String']['output']>;
  displayNameShort?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  externalServices?: Maybe<ExternalServices>;
  firstName?: Maybe<Scalars['String']['output']>;
  firstNames?: Maybe<Scalars['String']['output']>;
  foreignRefId?: Maybe<Array<Scalars['String']['output']>>;
  groupAdmin: Array<Group>;
  groupAdminAggregate?: Maybe<ProfileGroupGroupAdminAggregationSelection>;
  groupAdminConnection: ProfileGroupAdminConnection;
  groupEditor: Array<Group>;
  groupEditorAggregate?: Maybe<ProfileGroupGroupEditorAggregationSelection>;
  groupEditorConnection: ProfileGroupEditorConnection;
  groupViewer: Array<Group>;
  groupViewerAggregate?: Maybe<ProfileGroupGroupViewerAggregationSelection>;
  groupViewerConnection: ProfileGroupViewerConnection;
  importMeta?: Maybe<Array<Scalars['String']['output']>>;
  incomingRoles: Array<Profile>;
  incomingRolesConnection: ProfileIncomingRolesConnection;
  lastName?: Maybe<Scalars['String']['output']>;
  listName?: Maybe<Scalars['String']['output']>;
  managedBy: Scalars['String']['output'];
  /** Persist the matrix-token, since only one at a time is valid... */
  matrixToken?: Maybe<Scalars['String']['output']>;
  nextcloud: Array<Nextcloud>;
  nextcloudAggregate?: Maybe<ProfileNextcloudNextcloudAggregationSelection>;
  nextcloudConnection: ProfileNextcloudConnection;
  nextcloudUserId?: Maybe<Scalars['String']['output']>;
  notificationPreferences: Array<Preference>;
  notificationPreferencesConnection: ProfileNotificationPreferencesConnection;
  notificationSettings?: Maybe<NotificationSettings>;
  notificationSettingsConnection: ProfileNotificationSettingsConnection;
  organization: Organization;
  organizationConnection: ProfileOrganizationConnection;
  organizationRoles: Array<Scalars['String']['output']>;
  ownsEvents: Array<CalendarEvent>;
  ownsEventsAggregate?: Maybe<ProfileCalendarEventOwnsEventsAggregationSelection>;
  ownsEventsConnection: ProfileOwnsEventsConnection;
  preferences: Array<Preference>;
  preferencesAggregate?: Maybe<ProfilePreferencePreferencesAggregationSelection>;
  preferencesConnection: ProfilePreferencesConnection;
  prefixName?: Maybe<Scalars['String']['output']>;
  roles: Array<RoleTarget>;
  rolesConnection: ProfileRolesConnection;
  salutation?: Maybe<Scalars['String']['output']>;
  selectName?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  threema: Array<Threema>;
  threemaAggregate?: Maybe<ProfileThreemaThreemaAggregationSelection>;
  threemaConnection: ProfileThreemaConnection;
  threemaId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** userUuid can be null before the userStatus has changed */
  userStatus: UserStatus;
  userUuid?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
  workMaterials: Array<WorkMaterial>;
  workMaterialsAggregate?: Maybe<ProfileWorkMaterialWorkMaterialsAggregationSelection>;
  workMaterialsConnection: ProfileWorkMaterialsConnection;
  zoomUserId?: Maybe<Scalars['String']['output']>;
};

export type ProfileAttendsEventsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CalendarEventOptions>;
  where?: InputMaybe<CalendarEventWhere>;
};

export type ProfileAttendsEventsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CalendarEventWhere>;
};

export type ProfileAttendsEventsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ProfileAttendsEventsConnectionSort>>;
  where?: InputMaybe<ProfileAttendsEventsConnectionWhere>;
};

export type ProfileCalendarSubscriptionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CalendarSubscriptionOptions>;
  where?: InputMaybe<CalendarSubscriptionWhere>;
};

export type ProfileCalendarSubscriptionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CalendarSubscriptionWhere>;
};

export type ProfileCalendarSubscriptionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ProfileCalendarSubscriptionsConnectionSort>>;
  where?: InputMaybe<ProfileCalendarSubscriptionsConnectionWhere>;
};

export type ProfileClassesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ClassOptions>;
  where?: InputMaybe<ClassWhere>;
};

export type ProfileClassesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ClassWhere>;
};

export type ProfileClassesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ProfileClassesConnectionSort>>;
  where?: InputMaybe<ProfileClassesConnectionWhere>;
};

export type ProfileDirectMessagesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ProfileOptions>;
  where?: InputMaybe<ProfileWhere>;
};

export type ProfileDirectMessagesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProfileWhere>;
};

export type ProfileDirectMessagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ProfileDirectMessagesConnectionSort>>;
  where?: InputMaybe<ProfileDirectMessagesConnectionWhere>;
};

export type ProfileGroupAdminArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<GroupOptions>;
  where?: InputMaybe<GroupWhere>;
};

export type ProfileGroupAdminAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GroupWhere>;
};

export type ProfileGroupAdminConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ProfileGroupAdminConnectionSort>>;
  where?: InputMaybe<ProfileGroupAdminConnectionWhere>;
};

export type ProfileGroupEditorArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<GroupOptions>;
  where?: InputMaybe<GroupWhere>;
};

export type ProfileGroupEditorAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GroupWhere>;
};

export type ProfileGroupEditorConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ProfileGroupEditorConnectionSort>>;
  where?: InputMaybe<ProfileGroupEditorConnectionWhere>;
};

export type ProfileGroupViewerArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<GroupOptions>;
  where?: InputMaybe<GroupWhere>;
};

export type ProfileGroupViewerAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GroupWhere>;
};

export type ProfileGroupViewerConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ProfileGroupViewerConnectionSort>>;
  where?: InputMaybe<ProfileGroupViewerConnectionWhere>;
};

export type ProfileIncomingRolesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ProfileOptions>;
  where?: InputMaybe<ProfileWhere>;
};

export type ProfileIncomingRolesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ProfileIncomingRolesConnectionSort>>;
  where?: InputMaybe<ProfileIncomingRolesConnectionWhere>;
};

export type ProfileNextcloudArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<NextcloudOptions>;
  where?: InputMaybe<NextcloudWhere>;
};

export type ProfileNextcloudAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NextcloudWhere>;
};

export type ProfileNextcloudConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ProfileNextcloudConnectionSort>>;
  where?: InputMaybe<ProfileNextcloudConnectionWhere>;
};

export type ProfileNotificationPreferencesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PreferenceOptions>;
  where?: InputMaybe<PreferenceWhere>;
};

export type ProfileNotificationPreferencesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ProfileNotificationPreferencesConnectionSort>>;
  where?: InputMaybe<ProfileNotificationPreferencesConnectionWhere>;
};

export type ProfileNotificationSettingsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<NotificationSettingsOptions>;
  where?: InputMaybe<NotificationSettingsWhere>;
};

export type ProfileNotificationSettingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ProfileNotificationSettingsConnectionSort>>;
  where?: InputMaybe<ProfileNotificationSettingsConnectionWhere>;
};

export type ProfileOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type ProfileOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ProfileOrganizationConnectionSort>>;
  where?: InputMaybe<ProfileOrganizationConnectionWhere>;
};

export type ProfileOwnsEventsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CalendarEventOptions>;
  where?: InputMaybe<CalendarEventWhere>;
};

export type ProfileOwnsEventsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CalendarEventWhere>;
};

export type ProfileOwnsEventsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ProfileOwnsEventsConnectionSort>>;
  where?: InputMaybe<ProfileOwnsEventsConnectionWhere>;
};

export type ProfilePreferencesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PreferenceOptions>;
  where?: InputMaybe<PreferenceWhere>;
};

export type ProfilePreferencesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PreferenceWhere>;
};

export type ProfilePreferencesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ProfilePreferencesConnectionSort>>;
  where?: InputMaybe<ProfilePreferencesConnectionWhere>;
};

export type ProfileRolesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<RoleTargetWhere>;
};

export type ProfileRolesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ProfileRolesConnectionSort>>;
  where?: InputMaybe<ProfileRolesConnectionWhere>;
};

export type ProfileThreemaArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ThreemaOptions>;
  where?: InputMaybe<ThreemaWhere>;
};

export type ProfileThreemaAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ThreemaWhere>;
};

export type ProfileThreemaConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ProfileThreemaConnectionSort>>;
  where?: InputMaybe<ProfileThreemaConnectionWhere>;
};

export type ProfileWorkMaterialsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<WorkMaterialOptions>;
  where?: InputMaybe<WorkMaterialWhere>;
};

export type ProfileWorkMaterialsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WorkMaterialWhere>;
};

export type ProfileWorkMaterialsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ProfileWorkMaterialsConnectionSort>>;
  where?: InputMaybe<ProfileWorkMaterialsConnectionWhere>;
};

export type ProfileAggregateSelection = {
  __typename?: 'ProfileAggregateSelection';
  address1: StringAggregateSelection;
  address2: StringAggregateSelection;
  address3: StringAggregateSelection;
  birthday: StringAggregateSelection;
  count: Scalars['Int']['output'];
  createdAt: DateTimeAggregateSelection;
  email: StringAggregateSelection;
  firstName: StringAggregateSelection;
  firstNames: StringAggregateSelection;
  lastName: StringAggregateSelection;
  managedBy: StringAggregateSelection;
  matrixToken: StringAggregateSelection;
  nextcloudUserId: StringAggregateSelection;
  prefixName: StringAggregateSelection;
  salutation: StringAggregateSelection;
  shortName: StringAggregateSelection;
  threemaId: StringAggregateSelection;
  title: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  userUuid: StringAggregateSelection;
  uuid: IdAggregateSelection;
  zoomUserId: StringAggregateSelection;
};

export type ProfileAttendsEventsAggregateInput = {
  AND?: InputMaybe<Array<ProfileAttendsEventsAggregateInput>>;
  NOT?: InputMaybe<ProfileAttendsEventsAggregateInput>;
  OR?: InputMaybe<Array<ProfileAttendsEventsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<EventAttendeesPropertiesAggregationWhereInput>;
  node?: InputMaybe<ProfileAttendsEventsNodeAggregationWhereInput>;
};

export type ProfileAttendsEventsConnection = {
  __typename?: 'ProfileAttendsEventsConnection';
  edges: Array<ProfileAttendsEventsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProfileAttendsEventsConnectionSort = {
  edge?: InputMaybe<EventAttendeesPropertiesSort>;
  node?: InputMaybe<CalendarEventSort>;
};

export type ProfileAttendsEventsConnectionWhere = {
  AND?: InputMaybe<Array<ProfileAttendsEventsConnectionWhere>>;
  NOT?: InputMaybe<ProfileAttendsEventsConnectionWhere>;
  OR?: InputMaybe<Array<ProfileAttendsEventsConnectionWhere>>;
  edge?: InputMaybe<EventAttendeesPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<EventAttendeesPropertiesWhere>;
  node?: InputMaybe<CalendarEventWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<CalendarEventWhere>;
};

export type ProfileAttendsEventsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProfileAttendsEventsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ProfileAttendsEventsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ProfileAttendsEventsNodeAggregationWhereInput>>;
  classbookHomeworkContentType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classbookHomeworkContentType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classbookHomeworkContentType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classbookHomeworkContentType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classbookHomeworkContentType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classbookHomeworkContentType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classbookHomeworkContentType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classbookHomeworkContentType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classbookHomeworkContentType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classbookHomeworkContentType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classbookHomeworkContentType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classbookHomeworkContentType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classbookHomeworkContentType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classbookHomeworkContentType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classbookHomeworkContentType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classbookHomework_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classbookHomework_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classbookHomework_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classbookHomework_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classbookHomework_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classbookHomework_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classbookHomework_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classbookHomework_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classbookHomework_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classbookHomework_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classbookHomework_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classbookHomework_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classbookHomework_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classbookHomework_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classbookHomework_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classbookNoteContentType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classbookNoteContentType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classbookNoteContentType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classbookNoteContentType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classbookNoteContentType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classbookNoteContentType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classbookNoteContentType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classbookNoteContentType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classbookNoteContentType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classbookNoteContentType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classbookNoteContentType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classbookNoteContentType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classbookNoteContentType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classbookNoteContentType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classbookNoteContentType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classbookNote_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classbookNote_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classbookNote_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classbookNote_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classbookNote_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classbookNote_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classbookNote_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classbookNote_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classbookNote_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classbookNote_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classbookNote_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classbookNote_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classbookNote_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classbookNote_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classbookNote_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  color_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  color_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  descriptionContentType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionContentType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionContentType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionContentType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionContentType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionContentType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionContentType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionContentType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionContentType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionContentType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionContentType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionContentType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionContentType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionContentType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionContentType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  duration_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  duration_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  duration_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  locale_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maxAttendees_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  maxAttendees_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  maxAttendees_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  maxAttendees_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  maxAttendees_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  privacy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  privacy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  privacy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  privacy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  privacy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  privacy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  privacy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  privacy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  privacy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  privacy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  privacy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  privacy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  privacy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  privacy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  privacy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prodId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  prodId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  prodId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  prodId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  prodId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  prodId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prodId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prodId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prodId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prodId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prodId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prodId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prodId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prodId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prodId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sequence_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sequence_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sequence_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sequence_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sequence_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  sequence_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sequence_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sequence_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sequence_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sequence_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sequence_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sequence_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sequence_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sequence_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sequence_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sequence_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sequence_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sequence_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sequence_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sequence_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  start_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  start_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  start_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  start_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  start_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  status_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  status_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeZone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeZone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timeZone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeZone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timeZone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeZone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeZone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timeZone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeZone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timeZone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeZone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeZone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timeZone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeZone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timeZone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProfileAttendsEventsRelationship = {
  __typename?: 'ProfileAttendsEventsRelationship';
  cursor: Scalars['String']['output'];
  node: CalendarEvent;
  properties: EventAttendeesProperties;
};

export type ProfileCalendarEventAttendsEventsAggregationSelection = {
  __typename?: 'ProfileCalendarEventAttendsEventsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<ProfileCalendarEventAttendsEventsEdgeAggregateSelection>;
  node?: Maybe<ProfileCalendarEventAttendsEventsNodeAggregateSelection>;
};

export type ProfileCalendarEventAttendsEventsEdgeAggregateSelection = {
  __typename?: 'ProfileCalendarEventAttendsEventsEdgeAggregateSelection';
  classbookComment: StringAggregateSelection;
};

export type ProfileCalendarEventAttendsEventsNodeAggregateSelection = {
  __typename?: 'ProfileCalendarEventAttendsEventsNodeAggregateSelection';
  classbookHomework: StringAggregateSelection;
  classbookHomeworkContentType: StringAggregateSelection;
  classbookNote: StringAggregateSelection;
  classbookNoteContentType: StringAggregateSelection;
  color: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  descriptionContentType: StringAggregateSelection;
  duration: StringAggregateSelection;
  locale: StringAggregateSelection;
  maxAttendees: IntAggregateSelection;
  privacy: StringAggregateSelection;
  prodId: StringAggregateSelection;
  sequence: IntAggregateSelection;
  start: StringAggregateSelection;
  status: StringAggregateSelection;
  timeZone: StringAggregateSelection;
  title: StringAggregateSelection;
  updated: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type ProfileCalendarEventOwnsEventsAggregationSelection = {
  __typename?: 'ProfileCalendarEventOwnsEventsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ProfileCalendarEventOwnsEventsNodeAggregateSelection>;
};

export type ProfileCalendarEventOwnsEventsNodeAggregateSelection = {
  __typename?: 'ProfileCalendarEventOwnsEventsNodeAggregateSelection';
  classbookHomework: StringAggregateSelection;
  classbookHomeworkContentType: StringAggregateSelection;
  classbookNote: StringAggregateSelection;
  classbookNoteContentType: StringAggregateSelection;
  color: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  descriptionContentType: StringAggregateSelection;
  duration: StringAggregateSelection;
  locale: StringAggregateSelection;
  maxAttendees: IntAggregateSelection;
  privacy: StringAggregateSelection;
  prodId: StringAggregateSelection;
  sequence: IntAggregateSelection;
  start: StringAggregateSelection;
  status: StringAggregateSelection;
  timeZone: StringAggregateSelection;
  title: StringAggregateSelection;
  updated: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type ProfileCalendarSubscriptionCalendarSubscriptionsAggregationSelection = {
  __typename?: 'ProfileCalendarSubscriptionCalendarSubscriptionsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ProfileCalendarSubscriptionCalendarSubscriptionsNodeAggregateSelection>;
};

export type ProfileCalendarSubscriptionCalendarSubscriptionsNodeAggregateSelection = {
  __typename?: 'ProfileCalendarSubscriptionCalendarSubscriptionsNodeAggregateSelection';
  token: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type ProfileCalendarSubscriptionsAggregateInput = {
  AND?: InputMaybe<Array<ProfileCalendarSubscriptionsAggregateInput>>;
  NOT?: InputMaybe<ProfileCalendarSubscriptionsAggregateInput>;
  OR?: InputMaybe<Array<ProfileCalendarSubscriptionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ProfileCalendarSubscriptionsNodeAggregationWhereInput>;
};

export type ProfileCalendarSubscriptionsConnectFieldInput = {
  connect?: InputMaybe<Array<CalendarSubscriptionConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CalendarSubscriptionConnectWhere>;
};

export type ProfileCalendarSubscriptionsConnection = {
  __typename?: 'ProfileCalendarSubscriptionsConnection';
  edges: Array<ProfileCalendarSubscriptionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProfileCalendarSubscriptionsConnectionSort = {
  node?: InputMaybe<CalendarSubscriptionSort>;
};

export type ProfileCalendarSubscriptionsConnectionWhere = {
  AND?: InputMaybe<Array<ProfileCalendarSubscriptionsConnectionWhere>>;
  NOT?: InputMaybe<ProfileCalendarSubscriptionsConnectionWhere>;
  OR?: InputMaybe<Array<ProfileCalendarSubscriptionsConnectionWhere>>;
  node?: InputMaybe<CalendarSubscriptionWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<CalendarSubscriptionWhere>;
};

export type ProfileCalendarSubscriptionsCreateFieldInput = {
  node: CalendarSubscriptionCreateInput;
};

export type ProfileCalendarSubscriptionsDeleteFieldInput = {
  delete?: InputMaybe<CalendarSubscriptionDeleteInput>;
  where?: InputMaybe<ProfileCalendarSubscriptionsConnectionWhere>;
};

export type ProfileCalendarSubscriptionsDisconnectFieldInput = {
  disconnect?: InputMaybe<CalendarSubscriptionDisconnectInput>;
  where?: InputMaybe<ProfileCalendarSubscriptionsConnectionWhere>;
};

export type ProfileCalendarSubscriptionsFieldInput = {
  connect?: InputMaybe<Array<ProfileCalendarSubscriptionsConnectFieldInput>>;
  create?: InputMaybe<Array<ProfileCalendarSubscriptionsCreateFieldInput>>;
};

export type ProfileCalendarSubscriptionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProfileCalendarSubscriptionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ProfileCalendarSubscriptionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ProfileCalendarSubscriptionsNodeAggregationWhereInput>>;
  token_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  token_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  token_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  token_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  token_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  token_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  token_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  token_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  token_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  token_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  token_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  token_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  token_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  token_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  token_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ProfileCalendarSubscriptionsRelationship = {
  __typename?: 'ProfileCalendarSubscriptionsRelationship';
  cursor: Scalars['String']['output'];
  node: CalendarSubscription;
};

export type ProfileCalendarSubscriptionsUpdateConnectionInput = {
  node?: InputMaybe<CalendarSubscriptionUpdateInput>;
};

export type ProfileCalendarSubscriptionsUpdateFieldInput = {
  connect?: InputMaybe<Array<ProfileCalendarSubscriptionsConnectFieldInput>>;
  create?: InputMaybe<Array<ProfileCalendarSubscriptionsCreateFieldInput>>;
  delete?: InputMaybe<Array<ProfileCalendarSubscriptionsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProfileCalendarSubscriptionsDisconnectFieldInput>>;
  update?: InputMaybe<ProfileCalendarSubscriptionsUpdateConnectionInput>;
  where?: InputMaybe<ProfileCalendarSubscriptionsConnectionWhere>;
};

export type ProfileClassClassesAggregationSelection = {
  __typename?: 'ProfileClassClassesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ProfileClassClassesNodeAggregateSelection>;
};

export type ProfileClassClassesNodeAggregateSelection = {
  __typename?: 'ProfileClassClassesNodeAggregateSelection';
  color: StringAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  grade: StringAggregateSelection;
  gradeGroup: StringAggregateSelection;
  managedBy: StringAggregateSelection;
  name: StringAggregateSelection;
  shortName: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type ProfileClassesAggregateInput = {
  AND?: InputMaybe<Array<ProfileClassesAggregateInput>>;
  NOT?: InputMaybe<ProfileClassesAggregateInput>;
  OR?: InputMaybe<Array<ProfileClassesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ProfileClassesNodeAggregationWhereInput>;
};

export type ProfileClassesConnectFieldInput = {
  connect?: InputMaybe<Array<ClassConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ClassConnectWhere>;
};

export type ProfileClassesConnection = {
  __typename?: 'ProfileClassesConnection';
  edges: Array<ProfileClassesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProfileClassesConnectionSort = {
  node?: InputMaybe<ClassSort>;
};

export type ProfileClassesConnectionWhere = {
  AND?: InputMaybe<Array<ProfileClassesConnectionWhere>>;
  NOT?: InputMaybe<ProfileClassesConnectionWhere>;
  OR?: InputMaybe<Array<ProfileClassesConnectionWhere>>;
  node?: InputMaybe<ClassWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ClassWhere>;
};

export type ProfileClassesCreateFieldInput = {
  node: ClassCreateInput;
};

export type ProfileClassesDeleteFieldInput = {
  delete?: InputMaybe<ClassDeleteInput>;
  where?: InputMaybe<ProfileClassesConnectionWhere>;
};

export type ProfileClassesDisconnectFieldInput = {
  disconnect?: InputMaybe<ClassDisconnectInput>;
  where?: InputMaybe<ProfileClassesConnectionWhere>;
};

export type ProfileClassesFieldInput = {
  connect?: InputMaybe<Array<ProfileClassesConnectFieldInput>>;
  create?: InputMaybe<Array<ProfileClassesCreateFieldInput>>;
};

export type ProfileClassesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProfileClassesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ProfileClassesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ProfileClassesNodeAggregationWhereInput>>;
  color_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  color_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  gradeGroup_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gradeGroup_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gradeGroup_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gradeGroup_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gradeGroup_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gradeGroup_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gradeGroup_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gradeGroup_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gradeGroup_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gradeGroup_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gradeGroup_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gradeGroup_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gradeGroup_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gradeGroup_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gradeGroup_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grade_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  grade_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  grade_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  grade_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grade_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  grade_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  grade_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  grade_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProfileClassesRelationship = {
  __typename?: 'ProfileClassesRelationship';
  cursor: Scalars['String']['output'];
  node: Class;
};

export type ProfileClassesUpdateConnectionInput = {
  node?: InputMaybe<ClassUpdateInput>;
};

export type ProfileClassesUpdateFieldInput = {
  connect?: InputMaybe<Array<ProfileClassesConnectFieldInput>>;
  create?: InputMaybe<Array<ProfileClassesCreateFieldInput>>;
  delete?: InputMaybe<Array<ProfileClassesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProfileClassesDisconnectFieldInput>>;
  update?: InputMaybe<ProfileClassesUpdateConnectionInput>;
  where?: InputMaybe<ProfileClassesConnectionWhere>;
};

export type ProfileConnectInput = {
  calendarSubscriptions?: InputMaybe<Array<ProfileCalendarSubscriptionsConnectFieldInput>>;
  classes?: InputMaybe<Array<ProfileClassesConnectFieldInput>>;
  directMessages?: InputMaybe<ProfileDirectMessagesConnectFieldInput>;
  incomingRoles?: InputMaybe<Array<ProfileIncomingRolesConnectFieldInput>>;
  nextcloud?: InputMaybe<Array<ProfileNextcloudConnectFieldInput>>;
  notificationPreferences?: InputMaybe<Array<ProfileNotificationPreferencesConnectFieldInput>>;
  notificationSettings?: InputMaybe<ProfileNotificationSettingsConnectFieldInput>;
  organization?: InputMaybe<ProfileOrganizationConnectFieldInput>;
  preferences?: InputMaybe<Array<ProfilePreferencesConnectFieldInput>>;
  roles?: InputMaybe<ProfileRolesConnectInput>;
  threema?: InputMaybe<Array<ProfileThreemaConnectFieldInput>>;
  workMaterials?: InputMaybe<Array<ProfileWorkMaterialsConnectFieldInput>>;
};

export type ProfileConnectOrCreateWhere = {
  node: ProfileUniqueWhere;
};

export type ProfileConnectWhere = {
  node: ProfileWhere;
};

export type ProfileCreateInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  address3?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['String']['input']>;
  calendarSubscriptions?: InputMaybe<ProfileCalendarSubscriptionsFieldInput>;
  classes?: InputMaybe<ProfileClassesFieldInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  directMessages?: InputMaybe<ProfileDirectMessagesFieldInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstNames?: InputMaybe<Scalars['String']['input']>;
  foreignRefId?: InputMaybe<Array<Scalars['String']['input']>>;
  importMeta?: InputMaybe<Array<Scalars['String']['input']>>;
  incomingRoles?: InputMaybe<ProfileIncomingRolesFieldInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  managedBy: Scalars['String']['input'];
  matrixToken?: InputMaybe<Scalars['String']['input']>;
  nextcloud?: InputMaybe<ProfileNextcloudFieldInput>;
  nextcloudUserId?: InputMaybe<Scalars['String']['input']>;
  notificationPreferences?: InputMaybe<ProfileNotificationPreferencesFieldInput>;
  notificationSettings?: InputMaybe<ProfileNotificationSettingsFieldInput>;
  organization?: InputMaybe<ProfileOrganizationFieldInput>;
  preferences?: InputMaybe<ProfilePreferencesFieldInput>;
  prefixName?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<ProfileRolesCreateInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  threema?: InputMaybe<ProfileThreemaFieldInput>;
  threemaId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userStatus: UserStatus;
  userUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
  workMaterials?: InputMaybe<ProfileWorkMaterialsFieldInput>;
  zoomUserId?: InputMaybe<Scalars['String']['input']>;
};

export type ProfileDeleteInput = {
  calendarSubscriptions?: InputMaybe<Array<ProfileCalendarSubscriptionsDeleteFieldInput>>;
  classes?: InputMaybe<Array<ProfileClassesDeleteFieldInput>>;
  directMessages?: InputMaybe<ProfileDirectMessagesDeleteFieldInput>;
  incomingRoles?: InputMaybe<Array<ProfileIncomingRolesDeleteFieldInput>>;
  nextcloud?: InputMaybe<Array<ProfileNextcloudDeleteFieldInput>>;
  notificationPreferences?: InputMaybe<Array<ProfileNotificationPreferencesDeleteFieldInput>>;
  notificationSettings?: InputMaybe<ProfileNotificationSettingsDeleteFieldInput>;
  organization?: InputMaybe<ProfileOrganizationDeleteFieldInput>;
  preferences?: InputMaybe<Array<ProfilePreferencesDeleteFieldInput>>;
  roles?: InputMaybe<ProfileRolesDeleteInput>;
  threema?: InputMaybe<Array<ProfileThreemaDeleteFieldInput>>;
  workMaterials?: InputMaybe<Array<ProfileWorkMaterialsDeleteFieldInput>>;
};

export type ProfileDirectMessagesAggregateInput = {
  AND?: InputMaybe<Array<ProfileDirectMessagesAggregateInput>>;
  NOT?: InputMaybe<ProfileDirectMessagesAggregateInput>;
  OR?: InputMaybe<Array<ProfileDirectMessagesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<DirectMessagePropertiesAggregationWhereInput>;
  node?: InputMaybe<ProfileDirectMessagesNodeAggregationWhereInput>;
};

export type ProfileDirectMessagesConnectFieldInput = {
  connect?: InputMaybe<ProfileConnectInput>;
  edge?: InputMaybe<DirectMessagePropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ProfileConnectWhere>;
};

export type ProfileDirectMessagesConnectOrCreateFieldInput = {
  onCreate: ProfileDirectMessagesConnectOrCreateFieldInputOnCreate;
  where: ProfileConnectOrCreateWhere;
};

export type ProfileDirectMessagesConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<DirectMessagePropertiesCreateInput>;
  node: ProfileOnCreateInput;
};

export type ProfileDirectMessagesConnection = {
  __typename?: 'ProfileDirectMessagesConnection';
  edges: Array<ProfileDirectMessagesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProfileDirectMessagesConnectionSort = {
  edge?: InputMaybe<DirectMessagePropertiesSort>;
  node?: InputMaybe<ProfileSort>;
};

export type ProfileDirectMessagesConnectionWhere = {
  AND?: InputMaybe<Array<ProfileDirectMessagesConnectionWhere>>;
  NOT?: InputMaybe<ProfileDirectMessagesConnectionWhere>;
  OR?: InputMaybe<Array<ProfileDirectMessagesConnectionWhere>>;
  edge?: InputMaybe<DirectMessagePropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<DirectMessagePropertiesWhere>;
  node?: InputMaybe<ProfileWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ProfileWhere>;
};

export type ProfileDirectMessagesCreateFieldInput = {
  edge?: InputMaybe<DirectMessagePropertiesCreateInput>;
  node: ProfileCreateInput;
};

export type ProfileDirectMessagesDeleteFieldInput = {
  delete?: InputMaybe<ProfileDeleteInput>;
  where?: InputMaybe<ProfileDirectMessagesConnectionWhere>;
};

export type ProfileDirectMessagesDisconnectFieldInput = {
  disconnect?: InputMaybe<ProfileDisconnectInput>;
  where?: InputMaybe<ProfileDirectMessagesConnectionWhere>;
};

export type ProfileDirectMessagesFieldInput = {
  connect?: InputMaybe<ProfileDirectMessagesConnectFieldInput>;
  connectOrCreate?: InputMaybe<ProfileDirectMessagesConnectOrCreateFieldInput>;
  create?: InputMaybe<ProfileDirectMessagesCreateFieldInput>;
};

export type ProfileDirectMessagesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProfileDirectMessagesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ProfileDirectMessagesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ProfileDirectMessagesNodeAggregationWhereInput>>;
  address1_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address1_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address2_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address2_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address3_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address3_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  birthday_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  userUuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  userUuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ProfileDirectMessagesRelationship = {
  __typename?: 'ProfileDirectMessagesRelationship';
  cursor: Scalars['String']['output'];
  node: Profile;
  properties: DirectMessageProperties;
};

export type ProfileDirectMessagesUpdateConnectionInput = {
  edge?: InputMaybe<DirectMessagePropertiesUpdateInput>;
  node?: InputMaybe<ProfileUpdateInput>;
};

export type ProfileDirectMessagesUpdateFieldInput = {
  connect?: InputMaybe<ProfileDirectMessagesConnectFieldInput>;
  connectOrCreate?: InputMaybe<ProfileDirectMessagesConnectOrCreateFieldInput>;
  create?: InputMaybe<ProfileDirectMessagesCreateFieldInput>;
  delete?: InputMaybe<ProfileDirectMessagesDeleteFieldInput>;
  disconnect?: InputMaybe<ProfileDirectMessagesDisconnectFieldInput>;
  update?: InputMaybe<ProfileDirectMessagesUpdateConnectionInput>;
  where?: InputMaybe<ProfileDirectMessagesConnectionWhere>;
};

export type ProfileDisconnectInput = {
  calendarSubscriptions?: InputMaybe<Array<ProfileCalendarSubscriptionsDisconnectFieldInput>>;
  classes?: InputMaybe<Array<ProfileClassesDisconnectFieldInput>>;
  directMessages?: InputMaybe<ProfileDirectMessagesDisconnectFieldInput>;
  incomingRoles?: InputMaybe<Array<ProfileIncomingRolesDisconnectFieldInput>>;
  nextcloud?: InputMaybe<Array<ProfileNextcloudDisconnectFieldInput>>;
  notificationPreferences?: InputMaybe<Array<ProfileNotificationPreferencesDisconnectFieldInput>>;
  notificationSettings?: InputMaybe<ProfileNotificationSettingsDisconnectFieldInput>;
  organization?: InputMaybe<ProfileOrganizationDisconnectFieldInput>;
  preferences?: InputMaybe<Array<ProfilePreferencesDisconnectFieldInput>>;
  roles?: InputMaybe<ProfileRolesDisconnectInput>;
  threema?: InputMaybe<Array<ProfileThreemaDisconnectFieldInput>>;
  workMaterials?: InputMaybe<Array<ProfileWorkMaterialsDisconnectFieldInput>>;
};

export type ProfileEdge = {
  __typename?: 'ProfileEdge';
  cursor: Scalars['String']['output'];
  node: Profile;
};

export type ProfileGroupAdminAggregateInput = {
  AND?: InputMaybe<Array<ProfileGroupAdminAggregateInput>>;
  NOT?: InputMaybe<ProfileGroupAdminAggregateInput>;
  OR?: InputMaybe<Array<ProfileGroupAdminAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ProfileGroupAdminNodeAggregationWhereInput>;
};

export type ProfileGroupAdminConnection = {
  __typename?: 'ProfileGroupAdminConnection';
  edges: Array<ProfileGroupAdminRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProfileGroupAdminConnectionSort = {
  node?: InputMaybe<GroupSort>;
};

export type ProfileGroupAdminConnectionWhere = {
  AND?: InputMaybe<Array<ProfileGroupAdminConnectionWhere>>;
  NOT?: InputMaybe<ProfileGroupAdminConnectionWhere>;
  OR?: InputMaybe<Array<ProfileGroupAdminConnectionWhere>>;
  node?: InputMaybe<GroupWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<GroupWhere>;
};

export type ProfileGroupAdminNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProfileGroupAdminNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ProfileGroupAdminNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ProfileGroupAdminNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProfileGroupAdminRelationship = {
  __typename?: 'ProfileGroupAdminRelationship';
  cursor: Scalars['String']['output'];
  node: Group;
};

export type ProfileGroupEditorAggregateInput = {
  AND?: InputMaybe<Array<ProfileGroupEditorAggregateInput>>;
  NOT?: InputMaybe<ProfileGroupEditorAggregateInput>;
  OR?: InputMaybe<Array<ProfileGroupEditorAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ProfileGroupEditorNodeAggregationWhereInput>;
};

export type ProfileGroupEditorConnection = {
  __typename?: 'ProfileGroupEditorConnection';
  edges: Array<ProfileGroupEditorRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProfileGroupEditorConnectionSort = {
  node?: InputMaybe<GroupSort>;
};

export type ProfileGroupEditorConnectionWhere = {
  AND?: InputMaybe<Array<ProfileGroupEditorConnectionWhere>>;
  NOT?: InputMaybe<ProfileGroupEditorConnectionWhere>;
  OR?: InputMaybe<Array<ProfileGroupEditorConnectionWhere>>;
  node?: InputMaybe<GroupWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<GroupWhere>;
};

export type ProfileGroupEditorNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProfileGroupEditorNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ProfileGroupEditorNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ProfileGroupEditorNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProfileGroupEditorRelationship = {
  __typename?: 'ProfileGroupEditorRelationship';
  cursor: Scalars['String']['output'];
  node: Group;
};

export type ProfileGroupGroupAdminAggregationSelection = {
  __typename?: 'ProfileGroupGroupAdminAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ProfileGroupGroupAdminNodeAggregateSelection>;
};

export type ProfileGroupGroupAdminNodeAggregateSelection = {
  __typename?: 'ProfileGroupGroupAdminNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  managedBy: StringAggregateSelection;
  matrixRoomId: StringAggregateSelection;
  name: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type ProfileGroupGroupEditorAggregationSelection = {
  __typename?: 'ProfileGroupGroupEditorAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ProfileGroupGroupEditorNodeAggregateSelection>;
};

export type ProfileGroupGroupEditorNodeAggregateSelection = {
  __typename?: 'ProfileGroupGroupEditorNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  managedBy: StringAggregateSelection;
  matrixRoomId: StringAggregateSelection;
  name: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type ProfileGroupGroupViewerAggregationSelection = {
  __typename?: 'ProfileGroupGroupViewerAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ProfileGroupGroupViewerNodeAggregateSelection>;
};

export type ProfileGroupGroupViewerNodeAggregateSelection = {
  __typename?: 'ProfileGroupGroupViewerNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  managedBy: StringAggregateSelection;
  matrixRoomId: StringAggregateSelection;
  name: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type ProfileGroupViewerAggregateInput = {
  AND?: InputMaybe<Array<ProfileGroupViewerAggregateInput>>;
  NOT?: InputMaybe<ProfileGroupViewerAggregateInput>;
  OR?: InputMaybe<Array<ProfileGroupViewerAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ProfileGroupViewerNodeAggregationWhereInput>;
};

export type ProfileGroupViewerConnection = {
  __typename?: 'ProfileGroupViewerConnection';
  edges: Array<ProfileGroupViewerRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProfileGroupViewerConnectionSort = {
  node?: InputMaybe<GroupSort>;
};

export type ProfileGroupViewerConnectionWhere = {
  AND?: InputMaybe<Array<ProfileGroupViewerConnectionWhere>>;
  NOT?: InputMaybe<ProfileGroupViewerConnectionWhere>;
  OR?: InputMaybe<Array<ProfileGroupViewerConnectionWhere>>;
  node?: InputMaybe<GroupWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<GroupWhere>;
};

export type ProfileGroupViewerNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProfileGroupViewerNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ProfileGroupViewerNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ProfileGroupViewerNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProfileGroupViewerRelationship = {
  __typename?: 'ProfileGroupViewerRelationship';
  cursor: Scalars['String']['output'];
  node: Group;
};

export type ProfileIncomingRolesAggregateInput = {
  AND?: InputMaybe<Array<ProfileIncomingRolesAggregateInput>>;
  NOT?: InputMaybe<ProfileIncomingRolesAggregateInput>;
  OR?: InputMaybe<Array<ProfileIncomingRolesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ProfileIncomingRolesNodeAggregationWhereInput>;
};

export type ProfileIncomingRolesConnectFieldInput = {
  connect?: InputMaybe<Array<ProfileConnectInput>>;
  edge: RoleNamesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ProfileConnectWhere>;
};

export type ProfileIncomingRolesConnectOrCreateFieldInput = {
  onCreate: ProfileIncomingRolesConnectOrCreateFieldInputOnCreate;
  where: ProfileConnectOrCreateWhere;
};

export type ProfileIncomingRolesConnectOrCreateFieldInputOnCreate = {
  edge: RoleNamesCreateInput;
  node: ProfileOnCreateInput;
};

export type ProfileIncomingRolesConnection = {
  __typename?: 'ProfileIncomingRolesConnection';
  edges: Array<ProfileIncomingRolesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProfileIncomingRolesConnectionSort = {
  edge?: InputMaybe<RoleNamesSort>;
  node?: InputMaybe<ProfileSort>;
};

export type ProfileIncomingRolesConnectionWhere = {
  AND?: InputMaybe<Array<ProfileIncomingRolesConnectionWhere>>;
  NOT?: InputMaybe<ProfileIncomingRolesConnectionWhere>;
  OR?: InputMaybe<Array<ProfileIncomingRolesConnectionWhere>>;
  edge?: InputMaybe<RoleNamesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<RoleNamesWhere>;
  node?: InputMaybe<ProfileWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ProfileWhere>;
};

export type ProfileIncomingRolesCreateFieldInput = {
  edge: RoleNamesCreateInput;
  node: ProfileCreateInput;
};

export type ProfileIncomingRolesDeleteFieldInput = {
  delete?: InputMaybe<ProfileDeleteInput>;
  where?: InputMaybe<ProfileIncomingRolesConnectionWhere>;
};

export type ProfileIncomingRolesDisconnectFieldInput = {
  disconnect?: InputMaybe<ProfileDisconnectInput>;
  where?: InputMaybe<ProfileIncomingRolesConnectionWhere>;
};

export type ProfileIncomingRolesFieldInput = {
  connect?: InputMaybe<Array<ProfileIncomingRolesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ProfileIncomingRolesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ProfileIncomingRolesCreateFieldInput>>;
};

export type ProfileIncomingRolesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProfileIncomingRolesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ProfileIncomingRolesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ProfileIncomingRolesNodeAggregationWhereInput>>;
  address1_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address1_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address2_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address2_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address3_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address3_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  birthday_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  userUuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  userUuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ProfileIncomingRolesRelationship = {
  __typename?: 'ProfileIncomingRolesRelationship';
  cursor: Scalars['String']['output'];
  node: Profile;
  properties: RoleNames;
};

export type ProfileIncomingRolesUpdateConnectionInput = {
  edge?: InputMaybe<RoleNamesUpdateInput>;
  node?: InputMaybe<ProfileUpdateInput>;
};

export type ProfileIncomingRolesUpdateFieldInput = {
  connect?: InputMaybe<Array<ProfileIncomingRolesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ProfileIncomingRolesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ProfileIncomingRolesCreateFieldInput>>;
  delete?: InputMaybe<Array<ProfileIncomingRolesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProfileIncomingRolesDisconnectFieldInput>>;
  update?: InputMaybe<ProfileIncomingRolesUpdateConnectionInput>;
  where?: InputMaybe<ProfileIncomingRolesConnectionWhere>;
};

export type ProfileNextcloudAggregateInput = {
  AND?: InputMaybe<Array<ProfileNextcloudAggregateInput>>;
  NOT?: InputMaybe<ProfileNextcloudAggregateInput>;
  OR?: InputMaybe<Array<ProfileNextcloudAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<NextcloudUserPropsAggregationWhereInput>;
  node?: InputMaybe<ProfileNextcloudNodeAggregationWhereInput>;
};

export type ProfileNextcloudConnectFieldInput = {
  connect?: InputMaybe<Array<NextcloudConnectInput>>;
  edge?: InputMaybe<NextcloudUserPropsCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<NextcloudConnectWhere>;
};

export type ProfileNextcloudConnection = {
  __typename?: 'ProfileNextcloudConnection';
  edges: Array<ProfileNextcloudRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProfileNextcloudConnectionSort = {
  edge?: InputMaybe<NextcloudUserPropsSort>;
  node?: InputMaybe<NextcloudSort>;
};

export type ProfileNextcloudConnectionWhere = {
  AND?: InputMaybe<Array<ProfileNextcloudConnectionWhere>>;
  NOT?: InputMaybe<ProfileNextcloudConnectionWhere>;
  OR?: InputMaybe<Array<ProfileNextcloudConnectionWhere>>;
  edge?: InputMaybe<NextcloudUserPropsWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<NextcloudUserPropsWhere>;
  node?: InputMaybe<NextcloudWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<NextcloudWhere>;
};

export type ProfileNextcloudCreateFieldInput = {
  edge?: InputMaybe<NextcloudUserPropsCreateInput>;
  node: NextcloudCreateInput;
};

export type ProfileNextcloudDeleteFieldInput = {
  delete?: InputMaybe<NextcloudDeleteInput>;
  where?: InputMaybe<ProfileNextcloudConnectionWhere>;
};

export type ProfileNextcloudDisconnectFieldInput = {
  disconnect?: InputMaybe<NextcloudDisconnectInput>;
  where?: InputMaybe<ProfileNextcloudConnectionWhere>;
};

export type ProfileNextcloudFieldInput = {
  connect?: InputMaybe<Array<ProfileNextcloudConnectFieldInput>>;
  create?: InputMaybe<Array<ProfileNextcloudCreateFieldInput>>;
};

export type ProfileNextcloudNextcloudAggregationSelection = {
  __typename?: 'ProfileNextcloudNextcloudAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<ProfileNextcloudNextcloudEdgeAggregateSelection>;
  node?: Maybe<ProfileNextcloudNextcloudNodeAggregateSelection>;
};

export type ProfileNextcloudNextcloudEdgeAggregateSelection = {
  __typename?: 'ProfileNextcloudNextcloudEdgeAggregateSelection';
  lastSync: DateTimeAggregateSelection;
};

export type ProfileNextcloudNextcloudNodeAggregateSelection = {
  __typename?: 'ProfileNextcloudNextcloudNodeAggregateSelection';
  serverUri: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type ProfileNextcloudNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProfileNextcloudNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ProfileNextcloudNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ProfileNextcloudNodeAggregationWhereInput>>;
  adminPass_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adminPass_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  adminPass_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  adminPass_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  adminPass_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  adminPass_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  adminPass_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  adminPass_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  adminPass_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  adminPass_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  adminPass_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  adminPass_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  adminPass_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  adminPass_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  adminPass_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  adminUser_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adminUser_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  adminUser_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  adminUser_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  adminUser_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  adminUser_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  adminUser_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  adminUser_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  adminUser_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  adminUser_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  adminUser_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  adminUser_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  adminUser_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  adminUser_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  adminUser_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  serverUri_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  serverUri_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  serverUri_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  serverUri_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  serverUri_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  serverUri_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  serverUri_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  serverUri_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  serverUri_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  serverUri_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  serverUri_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  serverUri_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  serverUri_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  serverUri_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  serverUri_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ProfileNextcloudRelationship = {
  __typename?: 'ProfileNextcloudRelationship';
  cursor: Scalars['String']['output'];
  node: Nextcloud;
  properties: NextcloudUserProps;
};

export type ProfileNextcloudUpdateConnectionInput = {
  edge?: InputMaybe<NextcloudUserPropsUpdateInput>;
  node?: InputMaybe<NextcloudUpdateInput>;
};

export type ProfileNextcloudUpdateFieldInput = {
  connect?: InputMaybe<Array<ProfileNextcloudConnectFieldInput>>;
  create?: InputMaybe<Array<ProfileNextcloudCreateFieldInput>>;
  delete?: InputMaybe<Array<ProfileNextcloudDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProfileNextcloudDisconnectFieldInput>>;
  update?: InputMaybe<ProfileNextcloudUpdateConnectionInput>;
  where?: InputMaybe<ProfileNextcloudConnectionWhere>;
};

export type ProfileNotificationPreferencesAggregateInput = {
  AND?: InputMaybe<Array<ProfileNotificationPreferencesAggregateInput>>;
  NOT?: InputMaybe<ProfileNotificationPreferencesAggregateInput>;
  OR?: InputMaybe<Array<ProfileNotificationPreferencesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ProfileNotificationPreferencesNodeAggregationWhereInput>;
};

export type ProfileNotificationPreferencesConnectFieldInput = {
  edge: NotificationPreferencePropertyCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<PreferenceConnectWhere>;
};

export type ProfileNotificationPreferencesConnectOrCreateFieldInput = {
  onCreate: ProfileNotificationPreferencesConnectOrCreateFieldInputOnCreate;
  where: PreferenceConnectOrCreateWhere;
};

export type ProfileNotificationPreferencesConnectOrCreateFieldInputOnCreate = {
  edge: NotificationPreferencePropertyCreateInput;
  node: PreferenceOnCreateInput;
};

export type ProfileNotificationPreferencesConnection = {
  __typename?: 'ProfileNotificationPreferencesConnection';
  edges: Array<ProfileNotificationPreferencesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProfileNotificationPreferencesConnectionSort = {
  edge?: InputMaybe<NotificationPreferencePropertySort>;
  node?: InputMaybe<PreferenceSort>;
};

export type ProfileNotificationPreferencesConnectionWhere = {
  AND?: InputMaybe<Array<ProfileNotificationPreferencesConnectionWhere>>;
  NOT?: InputMaybe<ProfileNotificationPreferencesConnectionWhere>;
  OR?: InputMaybe<Array<ProfileNotificationPreferencesConnectionWhere>>;
  edge?: InputMaybe<NotificationPreferencePropertyWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<NotificationPreferencePropertyWhere>;
  node?: InputMaybe<PreferenceWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<PreferenceWhere>;
};

export type ProfileNotificationPreferencesCreateFieldInput = {
  edge: NotificationPreferencePropertyCreateInput;
  node: PreferenceCreateInput;
};

export type ProfileNotificationPreferencesDeleteFieldInput = {
  where?: InputMaybe<ProfileNotificationPreferencesConnectionWhere>;
};

export type ProfileNotificationPreferencesDisconnectFieldInput = {
  where?: InputMaybe<ProfileNotificationPreferencesConnectionWhere>;
};

export type ProfileNotificationPreferencesFieldInput = {
  connect?: InputMaybe<Array<ProfileNotificationPreferencesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ProfileNotificationPreferencesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ProfileNotificationPreferencesCreateFieldInput>>;
};

export type ProfileNotificationPreferencesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProfileNotificationPreferencesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ProfileNotificationPreferencesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ProfileNotificationPreferencesNodeAggregationWhereInput>>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ProfileNotificationPreferencesRelationship = {
  __typename?: 'ProfileNotificationPreferencesRelationship';
  cursor: Scalars['String']['output'];
  node: Preference;
  properties: NotificationPreferenceProperty;
};

export type ProfileNotificationPreferencesUpdateConnectionInput = {
  edge?: InputMaybe<NotificationPreferencePropertyUpdateInput>;
  node?: InputMaybe<PreferenceUpdateInput>;
};

export type ProfileNotificationPreferencesUpdateFieldInput = {
  connect?: InputMaybe<Array<ProfileNotificationPreferencesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ProfileNotificationPreferencesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ProfileNotificationPreferencesCreateFieldInput>>;
  delete?: InputMaybe<Array<ProfileNotificationPreferencesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProfileNotificationPreferencesDisconnectFieldInput>>;
  update?: InputMaybe<ProfileNotificationPreferencesUpdateConnectionInput>;
  where?: InputMaybe<ProfileNotificationPreferencesConnectionWhere>;
};

export type ProfileNotificationSettingsAggregateInput = {
  AND?: InputMaybe<Array<ProfileNotificationSettingsAggregateInput>>;
  NOT?: InputMaybe<ProfileNotificationSettingsAggregateInput>;
  OR?: InputMaybe<Array<ProfileNotificationSettingsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ProfileNotificationSettingsNodeAggregationWhereInput>;
};

export type ProfileNotificationSettingsConnectFieldInput = {
  connect?: InputMaybe<NotificationSettingsConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<NotificationSettingsConnectWhere>;
};

export type ProfileNotificationSettingsConnectOrCreateFieldInput = {
  onCreate: ProfileNotificationSettingsConnectOrCreateFieldInputOnCreate;
  where: NotificationSettingsConnectOrCreateWhere;
};

export type ProfileNotificationSettingsConnectOrCreateFieldInputOnCreate = {
  node: NotificationSettingsOnCreateInput;
};

export type ProfileNotificationSettingsConnection = {
  __typename?: 'ProfileNotificationSettingsConnection';
  edges: Array<ProfileNotificationSettingsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProfileNotificationSettingsConnectionSort = {
  node?: InputMaybe<NotificationSettingsSort>;
};

export type ProfileNotificationSettingsConnectionWhere = {
  AND?: InputMaybe<Array<ProfileNotificationSettingsConnectionWhere>>;
  NOT?: InputMaybe<ProfileNotificationSettingsConnectionWhere>;
  OR?: InputMaybe<Array<ProfileNotificationSettingsConnectionWhere>>;
  node?: InputMaybe<NotificationSettingsWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<NotificationSettingsWhere>;
};

export type ProfileNotificationSettingsCreateFieldInput = {
  node: NotificationSettingsCreateInput;
};

export type ProfileNotificationSettingsDeleteFieldInput = {
  delete?: InputMaybe<NotificationSettingsDeleteInput>;
  where?: InputMaybe<ProfileNotificationSettingsConnectionWhere>;
};

export type ProfileNotificationSettingsDisconnectFieldInput = {
  disconnect?: InputMaybe<NotificationSettingsDisconnectInput>;
  where?: InputMaybe<ProfileNotificationSettingsConnectionWhere>;
};

export type ProfileNotificationSettingsFieldInput = {
  connect?: InputMaybe<ProfileNotificationSettingsConnectFieldInput>;
  connectOrCreate?: InputMaybe<ProfileNotificationSettingsConnectOrCreateFieldInput>;
  create?: InputMaybe<ProfileNotificationSettingsCreateFieldInput>;
};

export type ProfileNotificationSettingsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProfileNotificationSettingsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ProfileNotificationSettingsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ProfileNotificationSettingsNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ProfileNotificationSettingsRelationship = {
  __typename?: 'ProfileNotificationSettingsRelationship';
  cursor: Scalars['String']['output'];
  node: NotificationSettings;
};

export type ProfileNotificationSettingsUpdateConnectionInput = {
  node?: InputMaybe<NotificationSettingsUpdateInput>;
};

export type ProfileNotificationSettingsUpdateFieldInput = {
  connect?: InputMaybe<ProfileNotificationSettingsConnectFieldInput>;
  connectOrCreate?: InputMaybe<ProfileNotificationSettingsConnectOrCreateFieldInput>;
  create?: InputMaybe<ProfileNotificationSettingsCreateFieldInput>;
  delete?: InputMaybe<ProfileNotificationSettingsDeleteFieldInput>;
  disconnect?: InputMaybe<ProfileNotificationSettingsDisconnectFieldInput>;
  update?: InputMaybe<ProfileNotificationSettingsUpdateConnectionInput>;
  where?: InputMaybe<ProfileNotificationSettingsConnectionWhere>;
};

export type ProfileOnCreateInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  address3?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstNames?: InputMaybe<Scalars['String']['input']>;
  foreignRefId?: InputMaybe<Array<Scalars['String']['input']>>;
  importMeta?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  managedBy: Scalars['String']['input'];
  matrixToken?: InputMaybe<Scalars['String']['input']>;
  nextcloudUserId?: InputMaybe<Scalars['String']['input']>;
  prefixName?: InputMaybe<Scalars['String']['input']>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  threemaId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userStatus: UserStatus;
  userUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
  zoomUserId?: InputMaybe<Scalars['String']['input']>;
};

export type ProfileOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ProfileSort objects to sort Profiles by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ProfileSort>>;
};

export type ProfileOrganizationAggregateInput = {
  AND?: InputMaybe<Array<ProfileOrganizationAggregateInput>>;
  NOT?: InputMaybe<ProfileOrganizationAggregateInput>;
  OR?: InputMaybe<Array<ProfileOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ProfileOrganizationNodeAggregationWhereInput>;
};

export type ProfileOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type ProfileOrganizationConnectOrCreateFieldInput = {
  onCreate: ProfileOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type ProfileOrganizationConnectOrCreateFieldInputOnCreate = {
  node: OrganizationOnCreateInput;
};

export type ProfileOrganizationConnection = {
  __typename?: 'ProfileOrganizationConnection';
  edges: Array<ProfileOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProfileOrganizationConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type ProfileOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<ProfileOrganizationConnectionWhere>>;
  NOT?: InputMaybe<ProfileOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<ProfileOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type ProfileOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type ProfileOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<ProfileOrganizationConnectionWhere>;
};

export type ProfileOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<ProfileOrganizationConnectionWhere>;
};

export type ProfileOrganizationFieldInput = {
  connect?: InputMaybe<ProfileOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<ProfileOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<ProfileOrganizationCreateFieldInput>;
};

export type ProfileOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProfileOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ProfileOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ProfileOrganizationNodeAggregationWhereInput>>;
  aboutInfoLastUpdated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ProfileOrganizationRelationship = {
  __typename?: 'ProfileOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type ProfileOrganizationUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type ProfileOrganizationUpdateFieldInput = {
  connect?: InputMaybe<ProfileOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<ProfileOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<ProfileOrganizationCreateFieldInput>;
  delete?: InputMaybe<ProfileOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<ProfileOrganizationDisconnectFieldInput>;
  update?: InputMaybe<ProfileOrganizationUpdateConnectionInput>;
  where?: InputMaybe<ProfileOrganizationConnectionWhere>;
};

export type ProfileOwnsEventsAggregateInput = {
  AND?: InputMaybe<Array<ProfileOwnsEventsAggregateInput>>;
  NOT?: InputMaybe<ProfileOwnsEventsAggregateInput>;
  OR?: InputMaybe<Array<ProfileOwnsEventsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ProfileOwnsEventsNodeAggregationWhereInput>;
};

export type ProfileOwnsEventsConnection = {
  __typename?: 'ProfileOwnsEventsConnection';
  edges: Array<ProfileOwnsEventsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProfileOwnsEventsConnectionSort = {
  node?: InputMaybe<CalendarEventSort>;
};

export type ProfileOwnsEventsConnectionWhere = {
  AND?: InputMaybe<Array<ProfileOwnsEventsConnectionWhere>>;
  NOT?: InputMaybe<ProfileOwnsEventsConnectionWhere>;
  OR?: InputMaybe<Array<ProfileOwnsEventsConnectionWhere>>;
  node?: InputMaybe<CalendarEventWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<CalendarEventWhere>;
};

export type ProfileOwnsEventsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProfileOwnsEventsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ProfileOwnsEventsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ProfileOwnsEventsNodeAggregationWhereInput>>;
  classbookHomeworkContentType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classbookHomeworkContentType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classbookHomeworkContentType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classbookHomeworkContentType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classbookHomeworkContentType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classbookHomeworkContentType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classbookHomeworkContentType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classbookHomeworkContentType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classbookHomeworkContentType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classbookHomeworkContentType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classbookHomeworkContentType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classbookHomeworkContentType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classbookHomeworkContentType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classbookHomeworkContentType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classbookHomeworkContentType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classbookHomework_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classbookHomework_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classbookHomework_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classbookHomework_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classbookHomework_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classbookHomework_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classbookHomework_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classbookHomework_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classbookHomework_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classbookHomework_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classbookHomework_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classbookHomework_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classbookHomework_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classbookHomework_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classbookHomework_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classbookNoteContentType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classbookNoteContentType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classbookNoteContentType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classbookNoteContentType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classbookNoteContentType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classbookNoteContentType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classbookNoteContentType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classbookNoteContentType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classbookNoteContentType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classbookNoteContentType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classbookNoteContentType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classbookNoteContentType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classbookNoteContentType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classbookNoteContentType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classbookNoteContentType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classbookNote_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classbookNote_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classbookNote_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classbookNote_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classbookNote_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classbookNote_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classbookNote_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classbookNote_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classbookNote_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classbookNote_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classbookNote_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classbookNote_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classbookNote_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classbookNote_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classbookNote_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  color_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  color_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  descriptionContentType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionContentType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionContentType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionContentType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionContentType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionContentType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionContentType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionContentType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionContentType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionContentType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionContentType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionContentType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionContentType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionContentType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionContentType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  duration_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  duration_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  duration_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  locale_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maxAttendees_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  maxAttendees_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  maxAttendees_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  maxAttendees_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  maxAttendees_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  maxAttendees_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  privacy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  privacy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  privacy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  privacy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  privacy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  privacy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  privacy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  privacy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  privacy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  privacy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  privacy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  privacy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  privacy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  privacy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  privacy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prodId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  prodId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  prodId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  prodId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  prodId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  prodId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prodId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prodId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prodId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prodId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prodId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prodId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prodId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prodId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prodId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sequence_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sequence_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sequence_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sequence_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sequence_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  sequence_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sequence_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sequence_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sequence_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sequence_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sequence_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sequence_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sequence_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sequence_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sequence_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sequence_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sequence_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sequence_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sequence_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sequence_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  start_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  start_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  start_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  start_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  start_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  status_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  status_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeZone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeZone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timeZone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeZone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timeZone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeZone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeZone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timeZone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeZone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timeZone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeZone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeZone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timeZone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeZone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timeZone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProfileOwnsEventsRelationship = {
  __typename?: 'ProfileOwnsEventsRelationship';
  cursor: Scalars['String']['output'];
  node: CalendarEvent;
};

export type ProfilePreferencePreferencesAggregationSelection = {
  __typename?: 'ProfilePreferencePreferencesAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<ProfilePreferencePreferencesEdgeAggregateSelection>;
  node?: Maybe<ProfilePreferencePreferencesNodeAggregateSelection>;
};

export type ProfilePreferencePreferencesEdgeAggregateSelection = {
  __typename?: 'ProfilePreferencePreferencesEdgeAggregateSelection';
  value: StringAggregateSelection;
};

export type ProfilePreferencePreferencesNodeAggregateSelection = {
  __typename?: 'ProfilePreferencePreferencesNodeAggregateSelection';
  name: StringAggregateSelection;
};

export type ProfilePreferencesAggregateInput = {
  AND?: InputMaybe<Array<ProfilePreferencesAggregateInput>>;
  NOT?: InputMaybe<ProfilePreferencesAggregateInput>;
  OR?: InputMaybe<Array<ProfilePreferencesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<PreferencePropertyAggregationWhereInput>;
  node?: InputMaybe<ProfilePreferencesNodeAggregationWhereInput>;
};

export type ProfilePreferencesConnectFieldInput = {
  edge?: InputMaybe<PreferencePropertyCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<PreferenceConnectWhere>;
};

export type ProfilePreferencesConnectOrCreateFieldInput = {
  onCreate: ProfilePreferencesConnectOrCreateFieldInputOnCreate;
  where: PreferenceConnectOrCreateWhere;
};

export type ProfilePreferencesConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<PreferencePropertyCreateInput>;
  node: PreferenceOnCreateInput;
};

export type ProfilePreferencesConnection = {
  __typename?: 'ProfilePreferencesConnection';
  edges: Array<ProfilePreferencesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProfilePreferencesConnectionSort = {
  edge?: InputMaybe<PreferencePropertySort>;
  node?: InputMaybe<PreferenceSort>;
};

export type ProfilePreferencesConnectionWhere = {
  AND?: InputMaybe<Array<ProfilePreferencesConnectionWhere>>;
  NOT?: InputMaybe<ProfilePreferencesConnectionWhere>;
  OR?: InputMaybe<Array<ProfilePreferencesConnectionWhere>>;
  edge?: InputMaybe<PreferencePropertyWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<PreferencePropertyWhere>;
  node?: InputMaybe<PreferenceWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<PreferenceWhere>;
};

export type ProfilePreferencesCreateFieldInput = {
  edge?: InputMaybe<PreferencePropertyCreateInput>;
  node: PreferenceCreateInput;
};

export type ProfilePreferencesDeleteFieldInput = {
  where?: InputMaybe<ProfilePreferencesConnectionWhere>;
};

export type ProfilePreferencesDisconnectFieldInput = {
  where?: InputMaybe<ProfilePreferencesConnectionWhere>;
};

export type ProfilePreferencesFieldInput = {
  connect?: InputMaybe<Array<ProfilePreferencesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ProfilePreferencesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ProfilePreferencesCreateFieldInput>>;
};

export type ProfilePreferencesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProfilePreferencesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ProfilePreferencesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ProfilePreferencesNodeAggregationWhereInput>>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ProfilePreferencesRelationship = {
  __typename?: 'ProfilePreferencesRelationship';
  cursor: Scalars['String']['output'];
  node: Preference;
  properties: PreferenceProperty;
};

export type ProfilePreferencesUpdateConnectionInput = {
  edge?: InputMaybe<PreferencePropertyUpdateInput>;
  node?: InputMaybe<PreferenceUpdateInput>;
};

export type ProfilePreferencesUpdateFieldInput = {
  connect?: InputMaybe<Array<ProfilePreferencesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ProfilePreferencesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ProfilePreferencesCreateFieldInput>>;
  delete?: InputMaybe<Array<ProfilePreferencesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProfilePreferencesDisconnectFieldInput>>;
  update?: InputMaybe<ProfilePreferencesUpdateConnectionInput>;
  where?: InputMaybe<ProfilePreferencesConnectionWhere>;
};

export type ProfileProfileDirectMessagesAggregationSelection = {
  __typename?: 'ProfileProfileDirectMessagesAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<ProfileProfileDirectMessagesEdgeAggregateSelection>;
  node?: Maybe<ProfileProfileDirectMessagesNodeAggregateSelection>;
};

export type ProfileProfileDirectMessagesEdgeAggregateSelection = {
  __typename?: 'ProfileProfileDirectMessagesEdgeAggregateSelection';
  matrixRoomId: StringAggregateSelection;
};

export type ProfileProfileDirectMessagesNodeAggregateSelection = {
  __typename?: 'ProfileProfileDirectMessagesNodeAggregateSelection';
  address1: StringAggregateSelection;
  address2: StringAggregateSelection;
  address3: StringAggregateSelection;
  birthday: StringAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  email: StringAggregateSelection;
  firstName: StringAggregateSelection;
  firstNames: StringAggregateSelection;
  lastName: StringAggregateSelection;
  managedBy: StringAggregateSelection;
  matrixToken: StringAggregateSelection;
  nextcloudUserId: StringAggregateSelection;
  prefixName: StringAggregateSelection;
  salutation: StringAggregateSelection;
  shortName: StringAggregateSelection;
  threemaId: StringAggregateSelection;
  title: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  userUuid: StringAggregateSelection;
  uuid: IdAggregateSelection;
  zoomUserId: StringAggregateSelection;
};

export type ProfileRolesConnectInput = {
  Group?: InputMaybe<Array<ProfileRolesGroupConnectFieldInput>>;
  Organization?: InputMaybe<Array<ProfileRolesOrganizationConnectFieldInput>>;
  Profile?: InputMaybe<Array<ProfileRolesProfileConnectFieldInput>>;
};

export type ProfileRolesConnection = {
  __typename?: 'ProfileRolesConnection';
  edges: Array<ProfileRolesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProfileRolesConnectionSort = {
  edge?: InputMaybe<RoleNamesSort>;
};

export type ProfileRolesConnectionWhere = {
  Group?: InputMaybe<ProfileRolesGroupConnectionWhere>;
  Organization?: InputMaybe<ProfileRolesOrganizationConnectionWhere>;
  Profile?: InputMaybe<ProfileRolesProfileConnectionWhere>;
};

export type ProfileRolesCreateInput = {
  Group?: InputMaybe<ProfileRolesGroupFieldInput>;
  Organization?: InputMaybe<ProfileRolesOrganizationFieldInput>;
  Profile?: InputMaybe<ProfileRolesProfileFieldInput>;
};

export type ProfileRolesDeleteInput = {
  Group?: InputMaybe<Array<ProfileRolesGroupDeleteFieldInput>>;
  Organization?: InputMaybe<Array<ProfileRolesOrganizationDeleteFieldInput>>;
  Profile?: InputMaybe<Array<ProfileRolesProfileDeleteFieldInput>>;
};

export type ProfileRolesDisconnectInput = {
  Group?: InputMaybe<Array<ProfileRolesGroupDisconnectFieldInput>>;
  Organization?: InputMaybe<Array<ProfileRolesOrganizationDisconnectFieldInput>>;
  Profile?: InputMaybe<Array<ProfileRolesProfileDisconnectFieldInput>>;
};

export type ProfileRolesGroupConnectFieldInput = {
  connect?: InputMaybe<Array<GroupConnectInput>>;
  edge: RoleNamesCreateInput;
  where?: InputMaybe<GroupConnectWhere>;
};

export type ProfileRolesGroupConnectOrCreateFieldInput = {
  onCreate: ProfileRolesGroupConnectOrCreateFieldInputOnCreate;
  where: GroupConnectOrCreateWhere;
};

export type ProfileRolesGroupConnectOrCreateFieldInputOnCreate = {
  edge: RoleNamesCreateInput;
  node: GroupOnCreateInput;
};

export type ProfileRolesGroupConnectionWhere = {
  AND?: InputMaybe<Array<ProfileRolesGroupConnectionWhere>>;
  NOT?: InputMaybe<ProfileRolesGroupConnectionWhere>;
  OR?: InputMaybe<Array<ProfileRolesGroupConnectionWhere>>;
  edge?: InputMaybe<RoleNamesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<RoleNamesWhere>;
  node?: InputMaybe<GroupWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<GroupWhere>;
};

export type ProfileRolesGroupCreateFieldInput = {
  edge: RoleNamesCreateInput;
  node: GroupCreateInput;
};

export type ProfileRolesGroupDeleteFieldInput = {
  delete?: InputMaybe<GroupDeleteInput>;
  where?: InputMaybe<ProfileRolesGroupConnectionWhere>;
};

export type ProfileRolesGroupDisconnectFieldInput = {
  disconnect?: InputMaybe<GroupDisconnectInput>;
  where?: InputMaybe<ProfileRolesGroupConnectionWhere>;
};

export type ProfileRolesGroupFieldInput = {
  connect?: InputMaybe<Array<ProfileRolesGroupConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ProfileRolesGroupConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ProfileRolesGroupCreateFieldInput>>;
};

export type ProfileRolesGroupUpdateConnectionInput = {
  edge?: InputMaybe<RoleNamesUpdateInput>;
  node?: InputMaybe<GroupUpdateInput>;
};

export type ProfileRolesGroupUpdateFieldInput = {
  connect?: InputMaybe<Array<ProfileRolesGroupConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ProfileRolesGroupConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ProfileRolesGroupCreateFieldInput>>;
  delete?: InputMaybe<Array<ProfileRolesGroupDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProfileRolesGroupDisconnectFieldInput>>;
  update?: InputMaybe<ProfileRolesGroupUpdateConnectionInput>;
  where?: InputMaybe<ProfileRolesGroupConnectionWhere>;
};

export type ProfileRolesOrganizationConnectFieldInput = {
  connect?: InputMaybe<Array<OrganizationConnectInput>>;
  edge: RoleNamesCreateInput;
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type ProfileRolesOrganizationConnectOrCreateFieldInput = {
  onCreate: ProfileRolesOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type ProfileRolesOrganizationConnectOrCreateFieldInputOnCreate = {
  edge: RoleNamesCreateInput;
  node: OrganizationOnCreateInput;
};

export type ProfileRolesOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<ProfileRolesOrganizationConnectionWhere>>;
  NOT?: InputMaybe<ProfileRolesOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<ProfileRolesOrganizationConnectionWhere>>;
  edge?: InputMaybe<RoleNamesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<RoleNamesWhere>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type ProfileRolesOrganizationCreateFieldInput = {
  edge: RoleNamesCreateInput;
  node: OrganizationCreateInput;
};

export type ProfileRolesOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<ProfileRolesOrganizationConnectionWhere>;
};

export type ProfileRolesOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<ProfileRolesOrganizationConnectionWhere>;
};

export type ProfileRolesOrganizationFieldInput = {
  connect?: InputMaybe<Array<ProfileRolesOrganizationConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ProfileRolesOrganizationConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ProfileRolesOrganizationCreateFieldInput>>;
};

export type ProfileRolesOrganizationUpdateConnectionInput = {
  edge?: InputMaybe<RoleNamesUpdateInput>;
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type ProfileRolesOrganizationUpdateFieldInput = {
  connect?: InputMaybe<Array<ProfileRolesOrganizationConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ProfileRolesOrganizationConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ProfileRolesOrganizationCreateFieldInput>>;
  delete?: InputMaybe<Array<ProfileRolesOrganizationDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProfileRolesOrganizationDisconnectFieldInput>>;
  update?: InputMaybe<ProfileRolesOrganizationUpdateConnectionInput>;
  where?: InputMaybe<ProfileRolesOrganizationConnectionWhere>;
};

export type ProfileRolesProfileConnectFieldInput = {
  connect?: InputMaybe<Array<ProfileConnectInput>>;
  edge: RoleNamesCreateInput;
  where?: InputMaybe<ProfileConnectWhere>;
};

export type ProfileRolesProfileConnectOrCreateFieldInput = {
  onCreate: ProfileRolesProfileConnectOrCreateFieldInputOnCreate;
  where: ProfileConnectOrCreateWhere;
};

export type ProfileRolesProfileConnectOrCreateFieldInputOnCreate = {
  edge: RoleNamesCreateInput;
  node: ProfileOnCreateInput;
};

export type ProfileRolesProfileConnectionWhere = {
  AND?: InputMaybe<Array<ProfileRolesProfileConnectionWhere>>;
  NOT?: InputMaybe<ProfileRolesProfileConnectionWhere>;
  OR?: InputMaybe<Array<ProfileRolesProfileConnectionWhere>>;
  edge?: InputMaybe<RoleNamesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<RoleNamesWhere>;
  node?: InputMaybe<ProfileWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ProfileWhere>;
};

export type ProfileRolesProfileCreateFieldInput = {
  edge: RoleNamesCreateInput;
  node: ProfileCreateInput;
};

export type ProfileRolesProfileDeleteFieldInput = {
  delete?: InputMaybe<ProfileDeleteInput>;
  where?: InputMaybe<ProfileRolesProfileConnectionWhere>;
};

export type ProfileRolesProfileDisconnectFieldInput = {
  disconnect?: InputMaybe<ProfileDisconnectInput>;
  where?: InputMaybe<ProfileRolesProfileConnectionWhere>;
};

export type ProfileRolesProfileFieldInput = {
  connect?: InputMaybe<Array<ProfileRolesProfileConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ProfileRolesProfileConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ProfileRolesProfileCreateFieldInput>>;
};

export type ProfileRolesProfileUpdateConnectionInput = {
  edge?: InputMaybe<RoleNamesUpdateInput>;
  node?: InputMaybe<ProfileUpdateInput>;
};

export type ProfileRolesProfileUpdateFieldInput = {
  connect?: InputMaybe<Array<ProfileRolesProfileConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ProfileRolesProfileConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ProfileRolesProfileCreateFieldInput>>;
  delete?: InputMaybe<Array<ProfileRolesProfileDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProfileRolesProfileDisconnectFieldInput>>;
  update?: InputMaybe<ProfileRolesProfileUpdateConnectionInput>;
  where?: InputMaybe<ProfileRolesProfileConnectionWhere>;
};

export type ProfileRolesRelationship = {
  __typename?: 'ProfileRolesRelationship';
  cursor: Scalars['String']['output'];
  node: RoleTarget;
  properties: RoleNames;
};

export type ProfileRolesUpdateInput = {
  Group?: InputMaybe<Array<ProfileRolesGroupUpdateFieldInput>>;
  Organization?: InputMaybe<Array<ProfileRolesOrganizationUpdateFieldInput>>;
  Profile?: InputMaybe<Array<ProfileRolesProfileUpdateFieldInput>>;
};

/** Fields to sort Profiles by. The order in which sorts are applied is not guaranteed when specifying many fields in one ProfileSort object. */
export type ProfileSort = {
  address1?: InputMaybe<SortDirection>;
  address2?: InputMaybe<SortDirection>;
  address3?: InputMaybe<SortDirection>;
  birthday?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  displayName?: InputMaybe<SortDirection>;
  displayNameShort?: InputMaybe<SortDirection>;
  email?: InputMaybe<SortDirection>;
  firstName?: InputMaybe<SortDirection>;
  firstNames?: InputMaybe<SortDirection>;
  lastName?: InputMaybe<SortDirection>;
  listName?: InputMaybe<SortDirection>;
  managedBy?: InputMaybe<SortDirection>;
  matrixToken?: InputMaybe<SortDirection>;
  nextcloudUserId?: InputMaybe<SortDirection>;
  prefixName?: InputMaybe<SortDirection>;
  salutation?: InputMaybe<SortDirection>;
  selectName?: InputMaybe<SortDirection>;
  shortName?: InputMaybe<SortDirection>;
  threemaId?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
  userStatus?: InputMaybe<SortDirection>;
  userUuid?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
  zoomUserId?: InputMaybe<SortDirection>;
};

export type ProfileThreemaAggregateInput = {
  AND?: InputMaybe<Array<ProfileThreemaAggregateInput>>;
  NOT?: InputMaybe<ProfileThreemaAggregateInput>;
  OR?: InputMaybe<Array<ProfileThreemaAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<ThreemaPropsAggregationWhereInput>;
  node?: InputMaybe<ProfileThreemaNodeAggregationWhereInput>;
};

export type ProfileThreemaConnectFieldInput = {
  connect?: InputMaybe<Array<ThreemaConnectInput>>;
  edge?: InputMaybe<ThreemaPropsCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ThreemaConnectWhere>;
};

export type ProfileThreemaConnection = {
  __typename?: 'ProfileThreemaConnection';
  edges: Array<ProfileThreemaRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProfileThreemaConnectionSort = {
  edge?: InputMaybe<ThreemaPropsSort>;
  node?: InputMaybe<ThreemaSort>;
};

export type ProfileThreemaConnectionWhere = {
  AND?: InputMaybe<Array<ProfileThreemaConnectionWhere>>;
  NOT?: InputMaybe<ProfileThreemaConnectionWhere>;
  OR?: InputMaybe<Array<ProfileThreemaConnectionWhere>>;
  edge?: InputMaybe<ThreemaPropsWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<ThreemaPropsWhere>;
  node?: InputMaybe<ThreemaWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ThreemaWhere>;
};

export type ProfileThreemaCreateFieldInput = {
  edge?: InputMaybe<ThreemaPropsCreateInput>;
  node: ThreemaCreateInput;
};

export type ProfileThreemaDeleteFieldInput = {
  delete?: InputMaybe<ThreemaDeleteInput>;
  where?: InputMaybe<ProfileThreemaConnectionWhere>;
};

export type ProfileThreemaDisconnectFieldInput = {
  disconnect?: InputMaybe<ThreemaDisconnectInput>;
  where?: InputMaybe<ProfileThreemaConnectionWhere>;
};

export type ProfileThreemaFieldInput = {
  connect?: InputMaybe<Array<ProfileThreemaConnectFieldInput>>;
  create?: InputMaybe<Array<ProfileThreemaCreateFieldInput>>;
};

export type ProfileThreemaNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProfileThreemaNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ProfileThreemaNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ProfileThreemaNodeAggregationWhereInput>>;
  apiToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  apiToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  apiToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  apiToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  apiToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  apiToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  apiToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  apiToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  apiToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  apiToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  apiToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  apiToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  apiToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  apiToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  apiToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  licenseCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  licenseCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  licenseCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  licenseCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  licenseCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  licenseCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  licenseCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  licenseCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  licenseCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  licenseCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  licenseCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  licenseCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  licenseCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  licenseCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  licenseCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  licenseCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  licenseCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  licenseCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  licenseCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  licenseCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  licenseName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  licenseName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  licenseName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  licenseName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  licenseName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  licenseName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  licenseName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  licenseName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  licenseName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  licenseName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  licenseName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  licenseName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  licenseName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  licenseName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  licenseName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  licenseType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  licenseType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  licenseType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  licenseType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  licenseType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  licenseType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  licenseType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  licenseType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  licenseType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  licenseType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  licenseType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  licenseType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  licenseType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  licenseType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  licenseType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  licenseValidUntil_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  licenseValidUntil_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  licenseValidUntil_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  licenseValidUntil_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  licenseValidUntil_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  licenseValidUntil_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  licenseValidUntil_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  licenseValidUntil_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  licenseValidUntil_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  licenseValidUntil_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProfileThreemaRelationship = {
  __typename?: 'ProfileThreemaRelationship';
  cursor: Scalars['String']['output'];
  node: Threema;
  properties: ThreemaProps;
};

export type ProfileThreemaThreemaAggregationSelection = {
  __typename?: 'ProfileThreemaThreemaAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<ProfileThreemaThreemaEdgeAggregateSelection>;
  node?: Maybe<ProfileThreemaThreemaNodeAggregateSelection>;
};

export type ProfileThreemaThreemaEdgeAggregateSelection = {
  __typename?: 'ProfileThreemaThreemaEdgeAggregateSelection';
  lastSync: DateTimeAggregateSelection;
  threemaId: StringAggregateSelection;
  workCredentialId: StringAggregateSelection;
  workPass: StringAggregateSelection;
  workUser: StringAggregateSelection;
};

export type ProfileThreemaThreemaNodeAggregateSelection = {
  __typename?: 'ProfileThreemaThreemaNodeAggregateSelection';
  apiToken: StringAggregateSelection;
  licenseCount: IntAggregateSelection;
  licenseName: StringAggregateSelection;
  licenseType: StringAggregateSelection;
  licenseValidUntil: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type ProfileThreemaUpdateConnectionInput = {
  edge?: InputMaybe<ThreemaPropsUpdateInput>;
  node?: InputMaybe<ThreemaUpdateInput>;
};

export type ProfileThreemaUpdateFieldInput = {
  connect?: InputMaybe<Array<ProfileThreemaConnectFieldInput>>;
  create?: InputMaybe<Array<ProfileThreemaCreateFieldInput>>;
  delete?: InputMaybe<Array<ProfileThreemaDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProfileThreemaDisconnectFieldInput>>;
  update?: InputMaybe<ProfileThreemaUpdateConnectionInput>;
  where?: InputMaybe<ProfileThreemaConnectionWhere>;
};

export type ProfileUniqueWhere = {
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type ProfileUpdateInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  address3?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['String']['input']>;
  calendarSubscriptions?: InputMaybe<Array<ProfileCalendarSubscriptionsUpdateFieldInput>>;
  classes?: InputMaybe<Array<ProfileClassesUpdateFieldInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  directMessages?: InputMaybe<ProfileDirectMessagesUpdateFieldInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstNames?: InputMaybe<Scalars['String']['input']>;
  foreignRefId?: InputMaybe<Array<Scalars['String']['input']>>;
  foreignRefId_POP?: InputMaybe<Scalars['Int']['input']>;
  foreignRefId_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
  importMeta?: InputMaybe<Array<Scalars['String']['input']>>;
  importMeta_POP?: InputMaybe<Scalars['Int']['input']>;
  importMeta_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
  incomingRoles?: InputMaybe<Array<ProfileIncomingRolesUpdateFieldInput>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  managedBy?: InputMaybe<Scalars['String']['input']>;
  matrixToken?: InputMaybe<Scalars['String']['input']>;
  nextcloud?: InputMaybe<Array<ProfileNextcloudUpdateFieldInput>>;
  nextcloudUserId?: InputMaybe<Scalars['String']['input']>;
  notificationPreferences?: InputMaybe<Array<ProfileNotificationPreferencesUpdateFieldInput>>;
  notificationSettings?: InputMaybe<ProfileNotificationSettingsUpdateFieldInput>;
  organization?: InputMaybe<ProfileOrganizationUpdateFieldInput>;
  preferences?: InputMaybe<Array<ProfilePreferencesUpdateFieldInput>>;
  prefixName?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<ProfileRolesUpdateInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  threema?: InputMaybe<Array<ProfileThreemaUpdateFieldInput>>;
  threemaId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userStatus?: InputMaybe<UserStatus>;
  userUuid?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  workMaterials?: InputMaybe<Array<ProfileWorkMaterialsUpdateFieldInput>>;
  zoomUserId?: InputMaybe<Scalars['String']['input']>;
};

export type ProfileWhere = {
  AND?: InputMaybe<Array<ProfileWhere>>;
  NOT?: InputMaybe<ProfileWhere>;
  OR?: InputMaybe<Array<ProfileWhere>>;
  address1?: InputMaybe<Scalars['String']['input']>;
  address1_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  address1_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  address1_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address1_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address1_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address1_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address1_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address1_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  address1_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  address2_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  address2_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  address2_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address2_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address2_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address2_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address2_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address2_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  address2_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  address3?: InputMaybe<Scalars['String']['input']>;
  address3_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  address3_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  address3_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address3_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address3_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address3_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address3_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address3_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  address3_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `attendsEvents_SOME` instead. */
  attendsEvents?: InputMaybe<CalendarEventWhere>;
  attendsEventsAggregate?: InputMaybe<ProfileAttendsEventsAggregateInput>;
  /** @deprecated Use `attendsEventsConnection_SOME` instead. */
  attendsEventsConnection?: InputMaybe<ProfileAttendsEventsConnectionWhere>;
  /** Return Profiles where all of the related ProfileAttendsEventsConnections match this filter */
  attendsEventsConnection_ALL?: InputMaybe<ProfileAttendsEventsConnectionWhere>;
  /** Return Profiles where none of the related ProfileAttendsEventsConnections match this filter */
  attendsEventsConnection_NONE?: InputMaybe<ProfileAttendsEventsConnectionWhere>;
  /** @deprecated Use `attendsEventsConnection_NONE` instead. */
  attendsEventsConnection_NOT?: InputMaybe<ProfileAttendsEventsConnectionWhere>;
  /** Return Profiles where one of the related ProfileAttendsEventsConnections match this filter */
  attendsEventsConnection_SINGLE?: InputMaybe<ProfileAttendsEventsConnectionWhere>;
  /** Return Profiles where some of the related ProfileAttendsEventsConnections match this filter */
  attendsEventsConnection_SOME?: InputMaybe<ProfileAttendsEventsConnectionWhere>;
  /** Return Profiles where all of the related CalendarEvents match this filter */
  attendsEvents_ALL?: InputMaybe<CalendarEventWhere>;
  /** Return Profiles where none of the related CalendarEvents match this filter */
  attendsEvents_NONE?: InputMaybe<CalendarEventWhere>;
  /** @deprecated Use `attendsEvents_NONE` instead. */
  attendsEvents_NOT?: InputMaybe<CalendarEventWhere>;
  /** Return Profiles where one of the related CalendarEvents match this filter */
  attendsEvents_SINGLE?: InputMaybe<CalendarEventWhere>;
  /** Return Profiles where some of the related CalendarEvents match this filter */
  attendsEvents_SOME?: InputMaybe<CalendarEventWhere>;
  birthday?: InputMaybe<Scalars['String']['input']>;
  birthday_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  birthday_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  birthday_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  birthday_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  birthday_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  birthday_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  birthday_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  birthday_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  birthday_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `calendarSubscriptions_SOME` instead. */
  calendarSubscriptions?: InputMaybe<CalendarSubscriptionWhere>;
  calendarSubscriptionsAggregate?: InputMaybe<ProfileCalendarSubscriptionsAggregateInput>;
  /** @deprecated Use `calendarSubscriptionsConnection_SOME` instead. */
  calendarSubscriptionsConnection?: InputMaybe<ProfileCalendarSubscriptionsConnectionWhere>;
  /** Return Profiles where all of the related ProfileCalendarSubscriptionsConnections match this filter */
  calendarSubscriptionsConnection_ALL?: InputMaybe<ProfileCalendarSubscriptionsConnectionWhere>;
  /** Return Profiles where none of the related ProfileCalendarSubscriptionsConnections match this filter */
  calendarSubscriptionsConnection_NONE?: InputMaybe<ProfileCalendarSubscriptionsConnectionWhere>;
  /** @deprecated Use `calendarSubscriptionsConnection_NONE` instead. */
  calendarSubscriptionsConnection_NOT?: InputMaybe<ProfileCalendarSubscriptionsConnectionWhere>;
  /** Return Profiles where one of the related ProfileCalendarSubscriptionsConnections match this filter */
  calendarSubscriptionsConnection_SINGLE?: InputMaybe<ProfileCalendarSubscriptionsConnectionWhere>;
  /** Return Profiles where some of the related ProfileCalendarSubscriptionsConnections match this filter */
  calendarSubscriptionsConnection_SOME?: InputMaybe<ProfileCalendarSubscriptionsConnectionWhere>;
  /** Return Profiles where all of the related CalendarSubscriptions match this filter */
  calendarSubscriptions_ALL?: InputMaybe<CalendarSubscriptionWhere>;
  /** Return Profiles where none of the related CalendarSubscriptions match this filter */
  calendarSubscriptions_NONE?: InputMaybe<CalendarSubscriptionWhere>;
  /** @deprecated Use `calendarSubscriptions_NONE` instead. */
  calendarSubscriptions_NOT?: InputMaybe<CalendarSubscriptionWhere>;
  /** Return Profiles where one of the related CalendarSubscriptions match this filter */
  calendarSubscriptions_SINGLE?: InputMaybe<CalendarSubscriptionWhere>;
  /** Return Profiles where some of the related CalendarSubscriptions match this filter */
  calendarSubscriptions_SOME?: InputMaybe<CalendarSubscriptionWhere>;
  /** @deprecated Use `classes_SOME` instead. */
  classes?: InputMaybe<ClassWhere>;
  classesAggregate?: InputMaybe<ProfileClassesAggregateInput>;
  /** @deprecated Use `classesConnection_SOME` instead. */
  classesConnection?: InputMaybe<ProfileClassesConnectionWhere>;
  /** Return Profiles where all of the related ProfileClassesConnections match this filter */
  classesConnection_ALL?: InputMaybe<ProfileClassesConnectionWhere>;
  /** Return Profiles where none of the related ProfileClassesConnections match this filter */
  classesConnection_NONE?: InputMaybe<ProfileClassesConnectionWhere>;
  /** @deprecated Use `classesConnection_NONE` instead. */
  classesConnection_NOT?: InputMaybe<ProfileClassesConnectionWhere>;
  /** Return Profiles where one of the related ProfileClassesConnections match this filter */
  classesConnection_SINGLE?: InputMaybe<ProfileClassesConnectionWhere>;
  /** Return Profiles where some of the related ProfileClassesConnections match this filter */
  classesConnection_SOME?: InputMaybe<ProfileClassesConnectionWhere>;
  /** Return Profiles where all of the related Classes match this filter */
  classes_ALL?: InputMaybe<ClassWhere>;
  /** Return Profiles where none of the related Classes match this filter */
  classes_NONE?: InputMaybe<ClassWhere>;
  /** @deprecated Use `classes_NONE` instead. */
  classes_NOT?: InputMaybe<ClassWhere>;
  /** Return Profiles where one of the related Classes match this filter */
  classes_SINGLE?: InputMaybe<ClassWhere>;
  /** Return Profiles where some of the related Classes match this filter */
  classes_SOME?: InputMaybe<ClassWhere>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  directMessages?: InputMaybe<ProfileWhere>;
  directMessagesAggregate?: InputMaybe<ProfileDirectMessagesAggregateInput>;
  directMessagesConnection?: InputMaybe<ProfileDirectMessagesConnectionWhere>;
  directMessagesConnection_NOT?: InputMaybe<ProfileDirectMessagesConnectionWhere>;
  directMessages_NOT?: InputMaybe<ProfileWhere>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayNameShort?: InputMaybe<Scalars['String']['input']>;
  displayNameShort_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  displayNameShort_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  displayNameShort_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayNameShort_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayNameShort_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayNameShort_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayNameShort_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayNameShort_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  displayNameShort_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  displayName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  displayName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  displayName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  displayName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  email_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  email_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  email_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  firstName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  firstName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  firstName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  firstName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  firstName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  firstName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  firstName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  firstName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  firstNames?: InputMaybe<Scalars['String']['input']>;
  firstNames_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  firstNames_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  firstNames_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  firstNames_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  firstNames_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  firstNames_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  firstNames_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  firstNames_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  firstNames_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignRefId?: InputMaybe<Array<Scalars['String']['input']>>;
  foreignRefId_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignRefId_NOT?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignRefId_NOT_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `groupAdmin_SOME` instead. */
  groupAdmin?: InputMaybe<GroupWhere>;
  groupAdminAggregate?: InputMaybe<ProfileGroupAdminAggregateInput>;
  /** @deprecated Use `groupAdminConnection_SOME` instead. */
  groupAdminConnection?: InputMaybe<ProfileGroupAdminConnectionWhere>;
  /** Return Profiles where all of the related ProfileGroupAdminConnections match this filter */
  groupAdminConnection_ALL?: InputMaybe<ProfileGroupAdminConnectionWhere>;
  /** Return Profiles where none of the related ProfileGroupAdminConnections match this filter */
  groupAdminConnection_NONE?: InputMaybe<ProfileGroupAdminConnectionWhere>;
  /** @deprecated Use `groupAdminConnection_NONE` instead. */
  groupAdminConnection_NOT?: InputMaybe<ProfileGroupAdminConnectionWhere>;
  /** Return Profiles where one of the related ProfileGroupAdminConnections match this filter */
  groupAdminConnection_SINGLE?: InputMaybe<ProfileGroupAdminConnectionWhere>;
  /** Return Profiles where some of the related ProfileGroupAdminConnections match this filter */
  groupAdminConnection_SOME?: InputMaybe<ProfileGroupAdminConnectionWhere>;
  /** Return Profiles where all of the related Groups match this filter */
  groupAdmin_ALL?: InputMaybe<GroupWhere>;
  /** Return Profiles where none of the related Groups match this filter */
  groupAdmin_NONE?: InputMaybe<GroupWhere>;
  /** @deprecated Use `groupAdmin_NONE` instead. */
  groupAdmin_NOT?: InputMaybe<GroupWhere>;
  /** Return Profiles where one of the related Groups match this filter */
  groupAdmin_SINGLE?: InputMaybe<GroupWhere>;
  /** Return Profiles where some of the related Groups match this filter */
  groupAdmin_SOME?: InputMaybe<GroupWhere>;
  /** @deprecated Use `groupEditor_SOME` instead. */
  groupEditor?: InputMaybe<GroupWhere>;
  groupEditorAggregate?: InputMaybe<ProfileGroupEditorAggregateInput>;
  /** @deprecated Use `groupEditorConnection_SOME` instead. */
  groupEditorConnection?: InputMaybe<ProfileGroupEditorConnectionWhere>;
  /** Return Profiles where all of the related ProfileGroupEditorConnections match this filter */
  groupEditorConnection_ALL?: InputMaybe<ProfileGroupEditorConnectionWhere>;
  /** Return Profiles where none of the related ProfileGroupEditorConnections match this filter */
  groupEditorConnection_NONE?: InputMaybe<ProfileGroupEditorConnectionWhere>;
  /** @deprecated Use `groupEditorConnection_NONE` instead. */
  groupEditorConnection_NOT?: InputMaybe<ProfileGroupEditorConnectionWhere>;
  /** Return Profiles where one of the related ProfileGroupEditorConnections match this filter */
  groupEditorConnection_SINGLE?: InputMaybe<ProfileGroupEditorConnectionWhere>;
  /** Return Profiles where some of the related ProfileGroupEditorConnections match this filter */
  groupEditorConnection_SOME?: InputMaybe<ProfileGroupEditorConnectionWhere>;
  /** Return Profiles where all of the related Groups match this filter */
  groupEditor_ALL?: InputMaybe<GroupWhere>;
  /** Return Profiles where none of the related Groups match this filter */
  groupEditor_NONE?: InputMaybe<GroupWhere>;
  /** @deprecated Use `groupEditor_NONE` instead. */
  groupEditor_NOT?: InputMaybe<GroupWhere>;
  /** Return Profiles where one of the related Groups match this filter */
  groupEditor_SINGLE?: InputMaybe<GroupWhere>;
  /** Return Profiles where some of the related Groups match this filter */
  groupEditor_SOME?: InputMaybe<GroupWhere>;
  /** @deprecated Use `groupViewer_SOME` instead. */
  groupViewer?: InputMaybe<GroupWhere>;
  groupViewerAggregate?: InputMaybe<ProfileGroupViewerAggregateInput>;
  /** @deprecated Use `groupViewerConnection_SOME` instead. */
  groupViewerConnection?: InputMaybe<ProfileGroupViewerConnectionWhere>;
  /** Return Profiles where all of the related ProfileGroupViewerConnections match this filter */
  groupViewerConnection_ALL?: InputMaybe<ProfileGroupViewerConnectionWhere>;
  /** Return Profiles where none of the related ProfileGroupViewerConnections match this filter */
  groupViewerConnection_NONE?: InputMaybe<ProfileGroupViewerConnectionWhere>;
  /** @deprecated Use `groupViewerConnection_NONE` instead. */
  groupViewerConnection_NOT?: InputMaybe<ProfileGroupViewerConnectionWhere>;
  /** Return Profiles where one of the related ProfileGroupViewerConnections match this filter */
  groupViewerConnection_SINGLE?: InputMaybe<ProfileGroupViewerConnectionWhere>;
  /** Return Profiles where some of the related ProfileGroupViewerConnections match this filter */
  groupViewerConnection_SOME?: InputMaybe<ProfileGroupViewerConnectionWhere>;
  /** Return Profiles where all of the related Groups match this filter */
  groupViewer_ALL?: InputMaybe<GroupWhere>;
  /** Return Profiles where none of the related Groups match this filter */
  groupViewer_NONE?: InputMaybe<GroupWhere>;
  /** @deprecated Use `groupViewer_NONE` instead. */
  groupViewer_NOT?: InputMaybe<GroupWhere>;
  /** Return Profiles where one of the related Groups match this filter */
  groupViewer_SINGLE?: InputMaybe<GroupWhere>;
  /** Return Profiles where some of the related Groups match this filter */
  groupViewer_SOME?: InputMaybe<GroupWhere>;
  importMeta?: InputMaybe<Array<Scalars['String']['input']>>;
  importMeta_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  importMeta_NOT?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  importMeta_NOT_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `incomingRoles_SOME` instead. */
  incomingRoles?: InputMaybe<ProfileWhere>;
  incomingRolesAggregate?: InputMaybe<ProfileIncomingRolesAggregateInput>;
  /** @deprecated Use `incomingRolesConnection_SOME` instead. */
  incomingRolesConnection?: InputMaybe<ProfileIncomingRolesConnectionWhere>;
  /** Return Profiles where all of the related ProfileIncomingRolesConnections match this filter */
  incomingRolesConnection_ALL?: InputMaybe<ProfileIncomingRolesConnectionWhere>;
  /** Return Profiles where none of the related ProfileIncomingRolesConnections match this filter */
  incomingRolesConnection_NONE?: InputMaybe<ProfileIncomingRolesConnectionWhere>;
  /** @deprecated Use `incomingRolesConnection_NONE` instead. */
  incomingRolesConnection_NOT?: InputMaybe<ProfileIncomingRolesConnectionWhere>;
  /** Return Profiles where one of the related ProfileIncomingRolesConnections match this filter */
  incomingRolesConnection_SINGLE?: InputMaybe<ProfileIncomingRolesConnectionWhere>;
  /** Return Profiles where some of the related ProfileIncomingRolesConnections match this filter */
  incomingRolesConnection_SOME?: InputMaybe<ProfileIncomingRolesConnectionWhere>;
  /** Return Profiles where all of the related Profiles match this filter */
  incomingRoles_ALL?: InputMaybe<ProfileWhere>;
  /** Return Profiles where none of the related Profiles match this filter */
  incomingRoles_NONE?: InputMaybe<ProfileWhere>;
  /** @deprecated Use `incomingRoles_NONE` instead. */
  incomingRoles_NOT?: InputMaybe<ProfileWhere>;
  /** Return Profiles where one of the related Profiles match this filter */
  incomingRoles_SINGLE?: InputMaybe<ProfileWhere>;
  /** Return Profiles where some of the related Profiles match this filter */
  incomingRoles_SOME?: InputMaybe<ProfileWhere>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  lastName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lastName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lastName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lastName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lastName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lastName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  listName?: InputMaybe<Scalars['String']['input']>;
  listName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  listName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  listName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  listName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  listName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  listName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  listName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  listName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  listName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  managedBy?: InputMaybe<Scalars['String']['input']>;
  managedBy_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  managedBy_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  managedBy_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  managedBy_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  managedBy_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  managedBy_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  managedBy_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  managedBy_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  managedBy_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  matrixToken?: InputMaybe<Scalars['String']['input']>;
  matrixToken_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  matrixToken_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  matrixToken_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  matrixToken_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  matrixToken_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  matrixToken_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  matrixToken_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  matrixToken_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  matrixToken_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `nextcloud_SOME` instead. */
  nextcloud?: InputMaybe<NextcloudWhere>;
  nextcloudAggregate?: InputMaybe<ProfileNextcloudAggregateInput>;
  /** @deprecated Use `nextcloudConnection_SOME` instead. */
  nextcloudConnection?: InputMaybe<ProfileNextcloudConnectionWhere>;
  /** Return Profiles where all of the related ProfileNextcloudConnections match this filter */
  nextcloudConnection_ALL?: InputMaybe<ProfileNextcloudConnectionWhere>;
  /** Return Profiles where none of the related ProfileNextcloudConnections match this filter */
  nextcloudConnection_NONE?: InputMaybe<ProfileNextcloudConnectionWhere>;
  /** @deprecated Use `nextcloudConnection_NONE` instead. */
  nextcloudConnection_NOT?: InputMaybe<ProfileNextcloudConnectionWhere>;
  /** Return Profiles where one of the related ProfileNextcloudConnections match this filter */
  nextcloudConnection_SINGLE?: InputMaybe<ProfileNextcloudConnectionWhere>;
  /** Return Profiles where some of the related ProfileNextcloudConnections match this filter */
  nextcloudConnection_SOME?: InputMaybe<ProfileNextcloudConnectionWhere>;
  nextcloudUserId?: InputMaybe<Scalars['String']['input']>;
  nextcloudUserId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  nextcloudUserId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  nextcloudUserId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  nextcloudUserId_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  nextcloudUserId_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  nextcloudUserId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  nextcloudUserId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  nextcloudUserId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  nextcloudUserId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** Return Profiles where all of the related Nextclouds match this filter */
  nextcloud_ALL?: InputMaybe<NextcloudWhere>;
  /** Return Profiles where none of the related Nextclouds match this filter */
  nextcloud_NONE?: InputMaybe<NextcloudWhere>;
  /** @deprecated Use `nextcloud_NONE` instead. */
  nextcloud_NOT?: InputMaybe<NextcloudWhere>;
  /** Return Profiles where one of the related Nextclouds match this filter */
  nextcloud_SINGLE?: InputMaybe<NextcloudWhere>;
  /** Return Profiles where some of the related Nextclouds match this filter */
  nextcloud_SOME?: InputMaybe<NextcloudWhere>;
  /** @deprecated Use `notificationPreferences_SOME` instead. */
  notificationPreferences?: InputMaybe<PreferenceWhere>;
  notificationPreferencesAggregate?: InputMaybe<ProfileNotificationPreferencesAggregateInput>;
  /** @deprecated Use `notificationPreferencesConnection_SOME` instead. */
  notificationPreferencesConnection?: InputMaybe<ProfileNotificationPreferencesConnectionWhere>;
  /** Return Profiles where all of the related ProfileNotificationPreferencesConnections match this filter */
  notificationPreferencesConnection_ALL?: InputMaybe<ProfileNotificationPreferencesConnectionWhere>;
  /** Return Profiles where none of the related ProfileNotificationPreferencesConnections match this filter */
  notificationPreferencesConnection_NONE?: InputMaybe<ProfileNotificationPreferencesConnectionWhere>;
  /** @deprecated Use `notificationPreferencesConnection_NONE` instead. */
  notificationPreferencesConnection_NOT?: InputMaybe<ProfileNotificationPreferencesConnectionWhere>;
  /** Return Profiles where one of the related ProfileNotificationPreferencesConnections match this filter */
  notificationPreferencesConnection_SINGLE?: InputMaybe<ProfileNotificationPreferencesConnectionWhere>;
  /** Return Profiles where some of the related ProfileNotificationPreferencesConnections match this filter */
  notificationPreferencesConnection_SOME?: InputMaybe<ProfileNotificationPreferencesConnectionWhere>;
  /** Return Profiles where all of the related Preferences match this filter */
  notificationPreferences_ALL?: InputMaybe<PreferenceWhere>;
  /** Return Profiles where none of the related Preferences match this filter */
  notificationPreferences_NONE?: InputMaybe<PreferenceWhere>;
  /** @deprecated Use `notificationPreferences_NONE` instead. */
  notificationPreferences_NOT?: InputMaybe<PreferenceWhere>;
  /** Return Profiles where one of the related Preferences match this filter */
  notificationPreferences_SINGLE?: InputMaybe<PreferenceWhere>;
  /** Return Profiles where some of the related Preferences match this filter */
  notificationPreferences_SOME?: InputMaybe<PreferenceWhere>;
  notificationSettings?: InputMaybe<NotificationSettingsWhere>;
  notificationSettingsAggregate?: InputMaybe<ProfileNotificationSettingsAggregateInput>;
  notificationSettingsConnection?: InputMaybe<ProfileNotificationSettingsConnectionWhere>;
  notificationSettingsConnection_NOT?: InputMaybe<ProfileNotificationSettingsConnectionWhere>;
  notificationSettings_NOT?: InputMaybe<NotificationSettingsWhere>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<ProfileOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<ProfileOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<ProfileOrganizationConnectionWhere>;
  organizationRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationRoles_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  organizationRoles_NOT?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  organizationRoles_NOT_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  /** @deprecated Use `ownsEvents_SOME` instead. */
  ownsEvents?: InputMaybe<CalendarEventWhere>;
  ownsEventsAggregate?: InputMaybe<ProfileOwnsEventsAggregateInput>;
  /** @deprecated Use `ownsEventsConnection_SOME` instead. */
  ownsEventsConnection?: InputMaybe<ProfileOwnsEventsConnectionWhere>;
  /** Return Profiles where all of the related ProfileOwnsEventsConnections match this filter */
  ownsEventsConnection_ALL?: InputMaybe<ProfileOwnsEventsConnectionWhere>;
  /** Return Profiles where none of the related ProfileOwnsEventsConnections match this filter */
  ownsEventsConnection_NONE?: InputMaybe<ProfileOwnsEventsConnectionWhere>;
  /** @deprecated Use `ownsEventsConnection_NONE` instead. */
  ownsEventsConnection_NOT?: InputMaybe<ProfileOwnsEventsConnectionWhere>;
  /** Return Profiles where one of the related ProfileOwnsEventsConnections match this filter */
  ownsEventsConnection_SINGLE?: InputMaybe<ProfileOwnsEventsConnectionWhere>;
  /** Return Profiles where some of the related ProfileOwnsEventsConnections match this filter */
  ownsEventsConnection_SOME?: InputMaybe<ProfileOwnsEventsConnectionWhere>;
  /** Return Profiles where all of the related CalendarEvents match this filter */
  ownsEvents_ALL?: InputMaybe<CalendarEventWhere>;
  /** Return Profiles where none of the related CalendarEvents match this filter */
  ownsEvents_NONE?: InputMaybe<CalendarEventWhere>;
  /** @deprecated Use `ownsEvents_NONE` instead. */
  ownsEvents_NOT?: InputMaybe<CalendarEventWhere>;
  /** Return Profiles where one of the related CalendarEvents match this filter */
  ownsEvents_SINGLE?: InputMaybe<CalendarEventWhere>;
  /** Return Profiles where some of the related CalendarEvents match this filter */
  ownsEvents_SOME?: InputMaybe<CalendarEventWhere>;
  /** @deprecated Use `preferences_SOME` instead. */
  preferences?: InputMaybe<PreferenceWhere>;
  preferencesAggregate?: InputMaybe<ProfilePreferencesAggregateInput>;
  /** @deprecated Use `preferencesConnection_SOME` instead. */
  preferencesConnection?: InputMaybe<ProfilePreferencesConnectionWhere>;
  /** Return Profiles where all of the related ProfilePreferencesConnections match this filter */
  preferencesConnection_ALL?: InputMaybe<ProfilePreferencesConnectionWhere>;
  /** Return Profiles where none of the related ProfilePreferencesConnections match this filter */
  preferencesConnection_NONE?: InputMaybe<ProfilePreferencesConnectionWhere>;
  /** @deprecated Use `preferencesConnection_NONE` instead. */
  preferencesConnection_NOT?: InputMaybe<ProfilePreferencesConnectionWhere>;
  /** Return Profiles where one of the related ProfilePreferencesConnections match this filter */
  preferencesConnection_SINGLE?: InputMaybe<ProfilePreferencesConnectionWhere>;
  /** Return Profiles where some of the related ProfilePreferencesConnections match this filter */
  preferencesConnection_SOME?: InputMaybe<ProfilePreferencesConnectionWhere>;
  /** Return Profiles where all of the related Preferences match this filter */
  preferences_ALL?: InputMaybe<PreferenceWhere>;
  /** Return Profiles where none of the related Preferences match this filter */
  preferences_NONE?: InputMaybe<PreferenceWhere>;
  /** @deprecated Use `preferences_NONE` instead. */
  preferences_NOT?: InputMaybe<PreferenceWhere>;
  /** Return Profiles where one of the related Preferences match this filter */
  preferences_SINGLE?: InputMaybe<PreferenceWhere>;
  /** Return Profiles where some of the related Preferences match this filter */
  preferences_SOME?: InputMaybe<PreferenceWhere>;
  prefixName?: InputMaybe<Scalars['String']['input']>;
  prefixName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  prefixName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  prefixName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  prefixName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  prefixName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  prefixName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  prefixName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  prefixName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  prefixName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `roles_SOME` instead. */
  roles?: InputMaybe<RoleTargetWhere>;
  /** @deprecated Use `rolesConnection_SOME` instead. */
  rolesConnection?: InputMaybe<ProfileRolesConnectionWhere>;
  /** Return Profiles where all of the related ProfileRolesConnections match this filter */
  rolesConnection_ALL?: InputMaybe<ProfileRolesConnectionWhere>;
  /** Return Profiles where none of the related ProfileRolesConnections match this filter */
  rolesConnection_NONE?: InputMaybe<ProfileRolesConnectionWhere>;
  /** @deprecated Use `rolesConnection_NONE` instead. */
  rolesConnection_NOT?: InputMaybe<ProfileRolesConnectionWhere>;
  /** Return Profiles where one of the related ProfileRolesConnections match this filter */
  rolesConnection_SINGLE?: InputMaybe<ProfileRolesConnectionWhere>;
  /** Return Profiles where some of the related ProfileRolesConnections match this filter */
  rolesConnection_SOME?: InputMaybe<ProfileRolesConnectionWhere>;
  /** Return Profiles where all of the related RoleTargets match this filter */
  roles_ALL?: InputMaybe<RoleTargetWhere>;
  /** Return Profiles where none of the related RoleTargets match this filter */
  roles_NONE?: InputMaybe<RoleTargetWhere>;
  /** @deprecated Use `roles_NONE` instead. */
  roles_NOT?: InputMaybe<RoleTargetWhere>;
  /** Return Profiles where one of the related RoleTargets match this filter */
  roles_SINGLE?: InputMaybe<RoleTargetWhere>;
  /** Return Profiles where some of the related RoleTargets match this filter */
  roles_SOME?: InputMaybe<RoleTargetWhere>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  salutation_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  salutation_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  salutation_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  salutation_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  salutation_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  salutation_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  salutation_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  salutation_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  salutation_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  selectName?: InputMaybe<Scalars['String']['input']>;
  selectName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  selectName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  selectName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  selectName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  selectName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  selectName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  selectName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  selectName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  selectName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  shortName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  shortName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  shortName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  shortName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `threema_SOME` instead. */
  threema?: InputMaybe<ThreemaWhere>;
  threemaAggregate?: InputMaybe<ProfileThreemaAggregateInput>;
  /** @deprecated Use `threemaConnection_SOME` instead. */
  threemaConnection?: InputMaybe<ProfileThreemaConnectionWhere>;
  /** Return Profiles where all of the related ProfileThreemaConnections match this filter */
  threemaConnection_ALL?: InputMaybe<ProfileThreemaConnectionWhere>;
  /** Return Profiles where none of the related ProfileThreemaConnections match this filter */
  threemaConnection_NONE?: InputMaybe<ProfileThreemaConnectionWhere>;
  /** @deprecated Use `threemaConnection_NONE` instead. */
  threemaConnection_NOT?: InputMaybe<ProfileThreemaConnectionWhere>;
  /** Return Profiles where one of the related ProfileThreemaConnections match this filter */
  threemaConnection_SINGLE?: InputMaybe<ProfileThreemaConnectionWhere>;
  /** Return Profiles where some of the related ProfileThreemaConnections match this filter */
  threemaConnection_SOME?: InputMaybe<ProfileThreemaConnectionWhere>;
  threemaId?: InputMaybe<Scalars['String']['input']>;
  threemaId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  threemaId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  threemaId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  threemaId_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  threemaId_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  threemaId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  threemaId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  threemaId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  threemaId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** Return Profiles where all of the related Threemas match this filter */
  threema_ALL?: InputMaybe<ThreemaWhere>;
  /** Return Profiles where none of the related Threemas match this filter */
  threema_NONE?: InputMaybe<ThreemaWhere>;
  /** @deprecated Use `threema_NONE` instead. */
  threema_NOT?: InputMaybe<ThreemaWhere>;
  /** Return Profiles where one of the related Threemas match this filter */
  threema_SINGLE?: InputMaybe<ThreemaWhere>;
  /** Return Profiles where some of the related Threemas match this filter */
  threema_SOME?: InputMaybe<ThreemaWhere>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  userStatus?: InputMaybe<UserStatus>;
  userStatus_IN?: InputMaybe<Array<UserStatus>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  userStatus_NOT?: InputMaybe<UserStatus>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  userStatus_NOT_IN?: InputMaybe<Array<UserStatus>>;
  userUuid?: InputMaybe<Scalars['String']['input']>;
  userUuid_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  userUuid_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  userUuid_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  userUuid_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  userUuid_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  userUuid_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  userUuid_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  userUuid_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  userUuid_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Use `workMaterials_SOME` instead. */
  workMaterials?: InputMaybe<WorkMaterialWhere>;
  workMaterialsAggregate?: InputMaybe<ProfileWorkMaterialsAggregateInput>;
  /** @deprecated Use `workMaterialsConnection_SOME` instead. */
  workMaterialsConnection?: InputMaybe<ProfileWorkMaterialsConnectionWhere>;
  /** Return Profiles where all of the related ProfileWorkMaterialsConnections match this filter */
  workMaterialsConnection_ALL?: InputMaybe<ProfileWorkMaterialsConnectionWhere>;
  /** Return Profiles where none of the related ProfileWorkMaterialsConnections match this filter */
  workMaterialsConnection_NONE?: InputMaybe<ProfileWorkMaterialsConnectionWhere>;
  /** @deprecated Use `workMaterialsConnection_NONE` instead. */
  workMaterialsConnection_NOT?: InputMaybe<ProfileWorkMaterialsConnectionWhere>;
  /** Return Profiles where one of the related ProfileWorkMaterialsConnections match this filter */
  workMaterialsConnection_SINGLE?: InputMaybe<ProfileWorkMaterialsConnectionWhere>;
  /** Return Profiles where some of the related ProfileWorkMaterialsConnections match this filter */
  workMaterialsConnection_SOME?: InputMaybe<ProfileWorkMaterialsConnectionWhere>;
  /** Return Profiles where all of the related WorkMaterials match this filter */
  workMaterials_ALL?: InputMaybe<WorkMaterialWhere>;
  /** Return Profiles where none of the related WorkMaterials match this filter */
  workMaterials_NONE?: InputMaybe<WorkMaterialWhere>;
  /** @deprecated Use `workMaterials_NONE` instead. */
  workMaterials_NOT?: InputMaybe<WorkMaterialWhere>;
  /** Return Profiles where one of the related WorkMaterials match this filter */
  workMaterials_SINGLE?: InputMaybe<WorkMaterialWhere>;
  /** Return Profiles where some of the related WorkMaterials match this filter */
  workMaterials_SOME?: InputMaybe<WorkMaterialWhere>;
  zoomUserId?: InputMaybe<Scalars['String']['input']>;
  zoomUserId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  zoomUserId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  zoomUserId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  zoomUserId_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  zoomUserId_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  zoomUserId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  zoomUserId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  zoomUserId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  zoomUserId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type ProfileWorkMaterialWorkMaterialsAggregationSelection = {
  __typename?: 'ProfileWorkMaterialWorkMaterialsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ProfileWorkMaterialWorkMaterialsNodeAggregateSelection>;
};

export type ProfileWorkMaterialWorkMaterialsNodeAggregateSelection = {
  __typename?: 'ProfileWorkMaterialWorkMaterialsNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  title: StringAggregateSelection;
  updated: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type ProfileWorkMaterialsAggregateInput = {
  AND?: InputMaybe<Array<ProfileWorkMaterialsAggregateInput>>;
  NOT?: InputMaybe<ProfileWorkMaterialsAggregateInput>;
  OR?: InputMaybe<Array<ProfileWorkMaterialsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ProfileWorkMaterialsNodeAggregationWhereInput>;
};

export type ProfileWorkMaterialsConnectFieldInput = {
  connect?: InputMaybe<Array<WorkMaterialConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<WorkMaterialConnectWhere>;
};

export type ProfileWorkMaterialsConnection = {
  __typename?: 'ProfileWorkMaterialsConnection';
  edges: Array<ProfileWorkMaterialsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProfileWorkMaterialsConnectionSort = {
  node?: InputMaybe<WorkMaterialSort>;
};

export type ProfileWorkMaterialsConnectionWhere = {
  AND?: InputMaybe<Array<ProfileWorkMaterialsConnectionWhere>>;
  NOT?: InputMaybe<ProfileWorkMaterialsConnectionWhere>;
  OR?: InputMaybe<Array<ProfileWorkMaterialsConnectionWhere>>;
  node?: InputMaybe<WorkMaterialWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<WorkMaterialWhere>;
};

export type ProfileWorkMaterialsCreateFieldInput = {
  node: WorkMaterialCreateInput;
};

export type ProfileWorkMaterialsDeleteFieldInput = {
  delete?: InputMaybe<WorkMaterialDeleteInput>;
  where?: InputMaybe<ProfileWorkMaterialsConnectionWhere>;
};

export type ProfileWorkMaterialsDisconnectFieldInput = {
  disconnect?: InputMaybe<WorkMaterialDisconnectInput>;
  where?: InputMaybe<ProfileWorkMaterialsConnectionWhere>;
};

export type ProfileWorkMaterialsFieldInput = {
  connect?: InputMaybe<Array<ProfileWorkMaterialsConnectFieldInput>>;
  create?: InputMaybe<Array<ProfileWorkMaterialsCreateFieldInput>>;
};

export type ProfileWorkMaterialsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProfileWorkMaterialsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ProfileWorkMaterialsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ProfileWorkMaterialsNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProfileWorkMaterialsRelationship = {
  __typename?: 'ProfileWorkMaterialsRelationship';
  cursor: Scalars['String']['output'];
  node: WorkMaterial;
};

export type ProfileWorkMaterialsUpdateConnectionInput = {
  node?: InputMaybe<WorkMaterialUpdateInput>;
};

export type ProfileWorkMaterialsUpdateFieldInput = {
  connect?: InputMaybe<Array<ProfileWorkMaterialsConnectFieldInput>>;
  create?: InputMaybe<Array<ProfileWorkMaterialsCreateFieldInput>>;
  delete?: InputMaybe<Array<ProfileWorkMaterialsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProfileWorkMaterialsDisconnectFieldInput>>;
  update?: InputMaybe<ProfileWorkMaterialsUpdateConnectionInput>;
  where?: InputMaybe<ProfileWorkMaterialsConnectionWhere>;
};

export type ProfilesConnection = {
  __typename?: 'ProfilesConnection';
  edges: Array<ProfileEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  absenceReasons: Array<AbsenceReason>;
  absenceReasonsAggregate: AbsenceReasonAggregateSelection;
  absenceReasonsConnection: AbsenceReasonsConnection;
  absences: Array<Absence>;
  absencesAggregate: AbsenceAggregateSelection;
  absencesConnection: AbsencesConnection;
  adminProfiles: Array<Profile>;
  assignmentHolders: Array<AssignmentHolder>;
  assignments: Array<Assignment>;
  assignmentsAggregate: AssignmentAggregateSelection;
  assignmentsConnection: AssignmentsConnection;
  bigBlueButtons: Array<BigBlueButton>;
  bigBlueButtonsAggregate: BigBlueButtonAggregateSelection;
  bigBlueButtonsConnection: BigBlueButtonsConnection;
  bildungsplattforms: Array<Bildungsplattform>;
  bildungsplattformsAggregate: BildungsplattformAggregateSelection;
  bildungsplattformsConnection: BildungsplattformsConnection;
  birthdayEvents: Array<CalendarEvent>;
  calendarEventHolders: Array<CalendarEventHolder>;
  calendarEvents: Array<CalendarEvent>;
  calendarEventsAggregate: CalendarEventAggregateSelection;
  calendarEventsConnection: CalendarEventsConnection;
  calendarSubscriptions: Array<CalendarSubscription>;
  calendarSubscriptionsAggregate: CalendarSubscriptionAggregateSelection;
  calendarSubscriptionsConnection: CalendarSubscriptionsConnection;
  classGroups: Array<ClassGroup>;
  classGroupsAggregate: ClassGroupAggregateSelection;
  classGroupsConnection: ClassGroupsConnection;
  classOrClassGroups: Array<ClassOrClassGroup>;
  classes: Array<Class>;
  classesAggregate: ClassAggregateSelection;
  classesConnection: ClassesConnection;
  collaboratingOrganizations: Array<CollaboratingOrganizations>;
  days: Array<Day>;
  daysAggregate: DayAggregateSelection;
  daysConnection: DaysConnection;
  divisions: Array<Division>;
  divisionsAggregate: DivisionAggregateSelection;
  divisionsConnection: DivisionsConnection;
  fileEntryHolders: Array<FileEntryHolder>;
  globalSubjects: Array<GlobalSubject>;
  groups: Array<Group>;
  groupsAggregate: GroupAggregateSelection;
  groupsConnection: GroupsConnection;
  licensedProducts: Array<LicensedProduct>;
  listParents: Array<Profile>;
  locations: Array<Location>;
  locationsAggregate: LocationAggregateSelection;
  locationsConnection: LocationsConnection;
  materialHolders: Array<MaterialHolder>;
  materials: Array<Material>;
  materialsAggregate: MaterialAggregateSelection;
  materialsConnection: MaterialsConnection;
  nextclouds: Array<Nextcloud>;
  nextcloudsAggregate: NextcloudAggregateSelection;
  nextcloudsConnection: NextcloudsConnection;
  notificationSettings: Array<NotificationSettings>;
  notificationSettingsAggregate: NotificationSettingsAggregateSelection;
  notificationSettingsConnection: NotificationSettingsConnection;
  organizations: Array<Organization>;
  organizationsAggregate: OrganizationAggregateSelection;
  organizationsConnection: OrganizationsConnection;
  pimOrganizations: Array<PimOrganization>;
  pimOrganizationsConnection: PimOrganizationsConnection;
  preferences: Array<Preference>;
  preferencesAggregate: PreferenceAggregateSelection;
  preferencesConnection: PreferencesConnection;
  profiles: Array<Profile>;
  profilesAggregate: ProfileAggregateSelection;
  profilesConnection: ProfilesConnection;
  recurrenceRules: Array<RecurrenceRule>;
  recurrenceRulesAggregate: RecurrenceRuleAggregateSelection;
  recurrenceRulesConnection: RecurrenceRulesConnection;
  roleTargets: Array<RoleTarget>;
  schoolYears: Array<SchoolYear>;
  schoolYearsAggregate: SchoolYearAggregateSelection;
  schoolYearsConnection: SchoolYearsConnection;
  subjects: Array<Subject>;
  subjectsAggregate: SubjectAggregateSelection;
  subjectsConnection: SubjectsConnection;
  submissions: Array<Submission>;
  submissionsAggregate: SubmissionAggregateSelection;
  submissionsConnection: SubmissionsConnection;
  teachingTopics: Array<TeachingTopic>;
  teachingTopicsAggregate: TeachingTopicAggregateSelection;
  teachingTopicsConnection: TeachingTopicsConnection;
  teachingUnits: Array<TeachingUnit>;
  teachingUnitsAggregate: TeachingUnitAggregateSelection;
  teachingUnitsConnection: TeachingUnitsConnection;
  threemaBroadcasts: Array<ThreemaBroadcast>;
  threemaBroadcastsAggregate: ThreemaBroadcastAggregateSelection;
  threemaBroadcastsConnection: ThreemaBroadcastsConnection;
  threemas: Array<Threema>;
  threemasAggregate: ThreemaAggregateSelection;
  threemasConnection: ThreemasConnection;
  virtualLocationBackends: Array<VirtualLocationBackend>;
  virtualLocations: Array<VirtualLocation>;
  virtualLocationsAggregate: VirtualLocationAggregateSelection;
  virtualLocationsConnection: VirtualLocationsConnection;
  workMaterialHolders: Array<WorkMaterialHolder>;
  workMaterials: Array<WorkMaterial>;
  workMaterialsAggregate: WorkMaterialAggregateSelection;
  workMaterialsConnection: WorkMaterialsConnection;
  zooms: Array<Zoom>;
  zoomsAggregate: ZoomAggregateSelection;
  zoomsConnection: ZoomsConnection;
};

export type QueryAbsenceReasonsArgs = {
  options?: InputMaybe<AbsenceReasonOptions>;
  where?: InputMaybe<AbsenceReasonWhere>;
};

export type QueryAbsenceReasonsAggregateArgs = {
  where?: InputMaybe<AbsenceReasonWhere>;
};

export type QueryAbsenceReasonsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AbsenceReasonSort>>>;
  where?: InputMaybe<AbsenceReasonWhere>;
};

export type QueryAbsencesArgs = {
  options?: InputMaybe<AbsenceOptions>;
  where?: InputMaybe<AbsenceWhere>;
};

export type QueryAbsencesAggregateArgs = {
  where?: InputMaybe<AbsenceWhere>;
};

export type QueryAbsencesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AbsenceSort>>>;
  where?: InputMaybe<AbsenceWhere>;
};

export type QueryAdminProfilesArgs = {
  options?: InputMaybe<ProfileOptions>;
  where?: InputMaybe<ProfileWhere>;
};

export type QueryAssignmentHoldersArgs = {
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<AssignmentHolderWhere>;
};

export type QueryAssignmentsArgs = {
  options?: InputMaybe<AssignmentOptions>;
  where?: InputMaybe<AssignmentWhere>;
};

export type QueryAssignmentsAggregateArgs = {
  where?: InputMaybe<AssignmentWhere>;
};

export type QueryAssignmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AssignmentSort>>>;
  where?: InputMaybe<AssignmentWhere>;
};

export type QueryBigBlueButtonsArgs = {
  options?: InputMaybe<BigBlueButtonOptions>;
  where?: InputMaybe<BigBlueButtonWhere>;
};

export type QueryBigBlueButtonsAggregateArgs = {
  where?: InputMaybe<BigBlueButtonWhere>;
};

export type QueryBigBlueButtonsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<BigBlueButtonSort>>>;
  where?: InputMaybe<BigBlueButtonWhere>;
};

export type QueryBildungsplattformsArgs = {
  options?: InputMaybe<BildungsplattformOptions>;
  where?: InputMaybe<BildungsplattformWhere>;
};

export type QueryBildungsplattformsAggregateArgs = {
  where?: InputMaybe<BildungsplattformWhere>;
};

export type QueryBildungsplattformsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<BildungsplattformSort>>>;
  where?: InputMaybe<BildungsplattformWhere>;
};

export type QueryBirthdayEventsArgs = {
  courseUuid?: InputMaybe<Scalars['ID']['input']>;
  groupUuid?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryCalendarEventHoldersArgs = {
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<CalendarEventHolderWhere>;
};

export type QueryCalendarEventsArgs = {
  options?: InputMaybe<CalendarEventOptions>;
  where?: InputMaybe<CalendarEventWhere>;
};

export type QueryCalendarEventsAggregateArgs = {
  where?: InputMaybe<CalendarEventWhere>;
};

export type QueryCalendarEventsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CalendarEventSort>>>;
  where?: InputMaybe<CalendarEventWhere>;
};

export type QueryCalendarSubscriptionsArgs = {
  options?: InputMaybe<CalendarSubscriptionOptions>;
  where?: InputMaybe<CalendarSubscriptionWhere>;
};

export type QueryCalendarSubscriptionsAggregateArgs = {
  where?: InputMaybe<CalendarSubscriptionWhere>;
};

export type QueryCalendarSubscriptionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CalendarSubscriptionSort>>>;
  where?: InputMaybe<CalendarSubscriptionWhere>;
};

export type QueryClassGroupsArgs = {
  options?: InputMaybe<ClassGroupOptions>;
  where?: InputMaybe<ClassGroupWhere>;
};

export type QueryClassGroupsAggregateArgs = {
  where?: InputMaybe<ClassGroupWhere>;
};

export type QueryClassGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ClassGroupSort>>>;
  where?: InputMaybe<ClassGroupWhere>;
};

export type QueryClassOrClassGroupsArgs = {
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<ClassOrClassGroupWhere>;
};

export type QueryClassesArgs = {
  options?: InputMaybe<ClassOptions>;
  where?: InputMaybe<ClassWhere>;
};

export type QueryClassesAggregateArgs = {
  where?: InputMaybe<ClassWhere>;
};

export type QueryClassesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ClassSort>>>;
  where?: InputMaybe<ClassWhere>;
};

export type QueryCollaboratingOrganizationsArgs = {
  uuid: Scalars['ID']['input'];
};

export type QueryDaysArgs = {
  options?: InputMaybe<DayOptions>;
  where?: InputMaybe<DayWhere>;
};

export type QueryDaysAggregateArgs = {
  where?: InputMaybe<DayWhere>;
};

export type QueryDaysConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DaySort>>>;
  where?: InputMaybe<DayWhere>;
};

export type QueryDivisionsArgs = {
  options?: InputMaybe<DivisionOptions>;
  where?: InputMaybe<DivisionWhere>;
};

export type QueryDivisionsAggregateArgs = {
  where?: InputMaybe<DivisionWhere>;
};

export type QueryDivisionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DivisionSort>>>;
  where?: InputMaybe<DivisionWhere>;
};

export type QueryFileEntryHoldersArgs = {
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<FileEntryHolderWhere>;
};

export type QueryGlobalSubjectsArgs = {
  where?: InputMaybe<GlobalSubjectsWhere>;
};

export type QueryGroupsArgs = {
  options?: InputMaybe<GroupOptions>;
  where?: InputMaybe<GroupWhere>;
};

export type QueryGroupsAggregateArgs = {
  where?: InputMaybe<GroupWhere>;
};

export type QueryGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GroupSort>>>;
  where?: InputMaybe<GroupWhere>;
};

export type QueryLicensedProductsArgs = {
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<LicensedProductWhere>;
};

export type QueryListParentsArgs = {
  child: Scalars['ID']['input'];
};

export type QueryLocationsArgs = {
  options?: InputMaybe<LocationOptions>;
  where?: InputMaybe<LocationWhere>;
};

export type QueryLocationsAggregateArgs = {
  where?: InputMaybe<LocationWhere>;
};

export type QueryLocationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<LocationSort>>>;
  where?: InputMaybe<LocationWhere>;
};

export type QueryMaterialHoldersArgs = {
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<MaterialHolderWhere>;
};

export type QueryMaterialsArgs = {
  options?: InputMaybe<MaterialOptions>;
  where?: InputMaybe<MaterialWhere>;
};

export type QueryMaterialsAggregateArgs = {
  where?: InputMaybe<MaterialWhere>;
};

export type QueryMaterialsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<MaterialSort>>>;
  where?: InputMaybe<MaterialWhere>;
};

export type QueryNextcloudsArgs = {
  options?: InputMaybe<NextcloudOptions>;
  where?: InputMaybe<NextcloudWhere>;
};

export type QueryNextcloudsAggregateArgs = {
  where?: InputMaybe<NextcloudWhere>;
};

export type QueryNextcloudsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<NextcloudSort>>>;
  where?: InputMaybe<NextcloudWhere>;
};

export type QueryNotificationSettingsArgs = {
  options?: InputMaybe<NotificationSettingsOptions>;
  where?: InputMaybe<NotificationSettingsWhere>;
};

export type QueryNotificationSettingsAggregateArgs = {
  where?: InputMaybe<NotificationSettingsWhere>;
};

export type QueryNotificationSettingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<NotificationSettingsSort>>>;
  where?: InputMaybe<NotificationSettingsWhere>;
};

export type QueryOrganizationsArgs = {
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type QueryOrganizationsAggregateArgs = {
  where?: InputMaybe<OrganizationWhere>;
};

export type QueryOrganizationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<OrganizationSort>>>;
  where?: InputMaybe<OrganizationWhere>;
};

export type QueryPimOrganizationsArgs = {
  options?: InputMaybe<PimOrganizationOptions>;
  where?: InputMaybe<PimOrganizationWhere>;
};

export type QueryPimOrganizationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PimOrganizationSort>>>;
  where?: InputMaybe<PimOrganizationWhere>;
};

export type QueryPreferencesArgs = {
  options?: InputMaybe<PreferenceOptions>;
  where?: InputMaybe<PreferenceWhere>;
};

export type QueryPreferencesAggregateArgs = {
  where?: InputMaybe<PreferenceWhere>;
};

export type QueryPreferencesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PreferenceSort>>>;
  where?: InputMaybe<PreferenceWhere>;
};

export type QueryProfilesArgs = {
  options?: InputMaybe<ProfileOptions>;
  where?: InputMaybe<ProfileWhere>;
};

export type QueryProfilesAggregateArgs = {
  where?: InputMaybe<ProfileWhere>;
};

export type QueryProfilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ProfileSort>>>;
  where?: InputMaybe<ProfileWhere>;
};

export type QueryRecurrenceRulesArgs = {
  options?: InputMaybe<RecurrenceRuleOptions>;
  where?: InputMaybe<RecurrenceRuleWhere>;
};

export type QueryRecurrenceRulesAggregateArgs = {
  where?: InputMaybe<RecurrenceRuleWhere>;
};

export type QueryRecurrenceRulesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<RecurrenceRuleSort>>>;
  where?: InputMaybe<RecurrenceRuleWhere>;
};

export type QueryRoleTargetsArgs = {
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<RoleTargetWhere>;
};

export type QuerySchoolYearsArgs = {
  options?: InputMaybe<SchoolYearOptions>;
  where?: InputMaybe<SchoolYearWhere>;
};

export type QuerySchoolYearsAggregateArgs = {
  where?: InputMaybe<SchoolYearWhere>;
};

export type QuerySchoolYearsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SchoolYearSort>>>;
  where?: InputMaybe<SchoolYearWhere>;
};

export type QuerySubjectsArgs = {
  options?: InputMaybe<SubjectOptions>;
  where?: InputMaybe<SubjectWhere>;
};

export type QuerySubjectsAggregateArgs = {
  where?: InputMaybe<SubjectWhere>;
};

export type QuerySubjectsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SubjectSort>>>;
  where?: InputMaybe<SubjectWhere>;
};

export type QuerySubmissionsArgs = {
  options?: InputMaybe<SubmissionOptions>;
  where?: InputMaybe<SubmissionWhere>;
};

export type QuerySubmissionsAggregateArgs = {
  where?: InputMaybe<SubmissionWhere>;
};

export type QuerySubmissionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SubmissionSort>>>;
  where?: InputMaybe<SubmissionWhere>;
};

export type QueryTeachingTopicsArgs = {
  options?: InputMaybe<TeachingTopicOptions>;
  where?: InputMaybe<TeachingTopicWhere>;
};

export type QueryTeachingTopicsAggregateArgs = {
  where?: InputMaybe<TeachingTopicWhere>;
};

export type QueryTeachingTopicsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TeachingTopicSort>>>;
  where?: InputMaybe<TeachingTopicWhere>;
};

export type QueryTeachingUnitsArgs = {
  options?: InputMaybe<TeachingUnitOptions>;
  where?: InputMaybe<TeachingUnitWhere>;
};

export type QueryTeachingUnitsAggregateArgs = {
  where?: InputMaybe<TeachingUnitWhere>;
};

export type QueryTeachingUnitsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TeachingUnitSort>>>;
  where?: InputMaybe<TeachingUnitWhere>;
};

export type QueryThreemaBroadcastsArgs = {
  options?: InputMaybe<ThreemaBroadcastOptions>;
  where?: InputMaybe<ThreemaBroadcastWhere>;
};

export type QueryThreemaBroadcastsAggregateArgs = {
  where?: InputMaybe<ThreemaBroadcastWhere>;
};

export type QueryThreemaBroadcastsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ThreemaBroadcastSort>>>;
  where?: InputMaybe<ThreemaBroadcastWhere>;
};

export type QueryThreemasArgs = {
  options?: InputMaybe<ThreemaOptions>;
  where?: InputMaybe<ThreemaWhere>;
};

export type QueryThreemasAggregateArgs = {
  where?: InputMaybe<ThreemaWhere>;
};

export type QueryThreemasConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ThreemaSort>>>;
  where?: InputMaybe<ThreemaWhere>;
};

export type QueryVirtualLocationBackendsArgs = {
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<VirtualLocationBackendWhere>;
};

export type QueryVirtualLocationsArgs = {
  options?: InputMaybe<VirtualLocationOptions>;
  where?: InputMaybe<VirtualLocationWhere>;
};

export type QueryVirtualLocationsAggregateArgs = {
  where?: InputMaybe<VirtualLocationWhere>;
};

export type QueryVirtualLocationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<VirtualLocationSort>>>;
  where?: InputMaybe<VirtualLocationWhere>;
};

export type QueryWorkMaterialHoldersArgs = {
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<WorkMaterialHolderWhere>;
};

export type QueryWorkMaterialsArgs = {
  options?: InputMaybe<WorkMaterialOptions>;
  where?: InputMaybe<WorkMaterialWhere>;
};

export type QueryWorkMaterialsAggregateArgs = {
  where?: InputMaybe<WorkMaterialWhere>;
};

export type QueryWorkMaterialsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<WorkMaterialSort>>>;
  where?: InputMaybe<WorkMaterialWhere>;
};

export type QueryZoomsArgs = {
  options?: InputMaybe<ZoomOptions>;
  where?: InputMaybe<ZoomWhere>;
};

export type QueryZoomsAggregateArgs = {
  where?: InputMaybe<ZoomWhere>;
};

export type QueryZoomsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ZoomSort>>>;
  where?: InputMaybe<ZoomWhere>;
};

/** Input type for options that can be specified on a query operation. */
export type QueryOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type RecurrenceRule = {
  __typename?: 'RecurrenceRule';
  frequency?: Maybe<EventRecurrence>;
  until: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type RecurrenceRuleAggregateSelection = {
  __typename?: 'RecurrenceRuleAggregateSelection';
  count: Scalars['Int']['output'];
  until: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type RecurrenceRuleConnectWhere = {
  node: RecurrenceRuleWhere;
};

export type RecurrenceRuleCreateInput = {
  frequency?: InputMaybe<EventRecurrence>;
  until: Scalars['String']['input'];
};

export type RecurrenceRuleEdge = {
  __typename?: 'RecurrenceRuleEdge';
  cursor: Scalars['String']['output'];
  node: RecurrenceRule;
};

export type RecurrenceRuleOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more RecurrenceRuleSort objects to sort RecurrenceRules by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<RecurrenceRuleSort>>;
};

/** Fields to sort RecurrenceRules by. The order in which sorts are applied is not guaranteed when specifying many fields in one RecurrenceRuleSort object. */
export type RecurrenceRuleSort = {
  frequency?: InputMaybe<SortDirection>;
  until?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type RecurrenceRuleUpdateInput = {
  frequency?: InputMaybe<EventRecurrence>;
  until?: InputMaybe<Scalars['String']['input']>;
};

export type RecurrenceRuleWhere = {
  AND?: InputMaybe<Array<RecurrenceRuleWhere>>;
  NOT?: InputMaybe<RecurrenceRuleWhere>;
  OR?: InputMaybe<Array<RecurrenceRuleWhere>>;
  frequency?: InputMaybe<EventRecurrence>;
  frequency_IN?: InputMaybe<Array<InputMaybe<EventRecurrence>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  frequency_NOT?: InputMaybe<EventRecurrence>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  frequency_NOT_IN?: InputMaybe<Array<InputMaybe<EventRecurrence>>>;
  until?: InputMaybe<Scalars['String']['input']>;
  until_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  until_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  until_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  until_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  until_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  until_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  until_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  until_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  until_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type RecurrenceRulesConnection = {
  __typename?: 'RecurrenceRulesConnection';
  edges: Array<RecurrenceRuleEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/**
 * The edge properties for the following fields:
 * * Profile.roles
 * * Profile.incomingRoles
 */
export type RoleNames = {
  __typename?: 'RoleNames';
  roleNames: Array<Scalars['String']['output']>;
};

export type RoleNamesCreateInput = {
  roleNames: Array<Scalars['String']['input']>;
};

export type RoleNamesSort = {
  roleNames?: InputMaybe<SortDirection>;
};

export type RoleNamesUpdateInput = {
  roleNames?: InputMaybe<Array<Scalars['String']['input']>>;
  roleNames_POP?: InputMaybe<Scalars['Int']['input']>;
  roleNames_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RoleNamesWhere = {
  AND?: InputMaybe<Array<RoleNamesWhere>>;
  NOT?: InputMaybe<RoleNamesWhere>;
  OR?: InputMaybe<Array<RoleNamesWhere>>;
  roleNames?: InputMaybe<Array<Scalars['String']['input']>>;
  roleNames_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  roleNames_NOT?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  roleNames_NOT_INCLUDES?: InputMaybe<Scalars['String']['input']>;
};

export type RoleTarget = Group | Organization | Profile;

export type RoleTargetWhere = {
  Group?: InputMaybe<GroupWhere>;
  Organization?: InputMaybe<OrganizationWhere>;
  Profile?: InputMaybe<ProfileWhere>;
};

export type SchoolYear = {
  __typename?: 'SchoolYear';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  end: Scalars['Date']['output'];
  foreignRefId?: Maybe<Array<Scalars['String']['output']>>;
  managedBy: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organization: Organization;
  organizationConnection: SchoolYearOrganizationConnection;
  shortName: Scalars['String']['output'];
  start: Scalars['Date']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['ID']['output'];
};

export type SchoolYearOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type SchoolYearOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SchoolYearOrganizationConnectionSort>>;
  where?: InputMaybe<SchoolYearOrganizationConnectionWhere>;
};

export type SchoolYearAggregateSelection = {
  __typename?: 'SchoolYearAggregateSelection';
  count: Scalars['Int']['output'];
  createdAt: DateTimeAggregateSelection;
  managedBy: StringAggregateSelection;
  name: StringAggregateSelection;
  shortName: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type SchoolYearConnectInput = {
  organization?: InputMaybe<SchoolYearOrganizationConnectFieldInput>;
};

export type SchoolYearConnectWhere = {
  node: SchoolYearWhere;
};

export type SchoolYearCreateInput = {
  end: Scalars['Date']['input'];
  foreignRefId?: InputMaybe<Array<Scalars['String']['input']>>;
  managedBy: Scalars['String']['input'];
  name: Scalars['String']['input'];
  organization?: InputMaybe<SchoolYearOrganizationFieldInput>;
  shortName: Scalars['String']['input'];
  start: Scalars['Date']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SchoolYearDeleteInput = {
  organization?: InputMaybe<SchoolYearOrganizationDeleteFieldInput>;
};

export type SchoolYearDisconnectInput = {
  organization?: InputMaybe<SchoolYearOrganizationDisconnectFieldInput>;
};

export type SchoolYearEdge = {
  __typename?: 'SchoolYearEdge';
  cursor: Scalars['String']['output'];
  node: SchoolYear;
};

export type SchoolYearOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more SchoolYearSort objects to sort SchoolYears by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<SchoolYearSort>>;
};

export type SchoolYearOrganizationAggregateInput = {
  AND?: InputMaybe<Array<SchoolYearOrganizationAggregateInput>>;
  NOT?: InputMaybe<SchoolYearOrganizationAggregateInput>;
  OR?: InputMaybe<Array<SchoolYearOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SchoolYearOrganizationNodeAggregationWhereInput>;
};

export type SchoolYearOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type SchoolYearOrganizationConnectOrCreateFieldInput = {
  onCreate: SchoolYearOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type SchoolYearOrganizationConnectOrCreateFieldInputOnCreate = {
  node: OrganizationOnCreateInput;
};

export type SchoolYearOrganizationConnection = {
  __typename?: 'SchoolYearOrganizationConnection';
  edges: Array<SchoolYearOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SchoolYearOrganizationConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type SchoolYearOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<SchoolYearOrganizationConnectionWhere>>;
  NOT?: InputMaybe<SchoolYearOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<SchoolYearOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type SchoolYearOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type SchoolYearOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<SchoolYearOrganizationConnectionWhere>;
};

export type SchoolYearOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<SchoolYearOrganizationConnectionWhere>;
};

export type SchoolYearOrganizationFieldInput = {
  connect?: InputMaybe<SchoolYearOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<SchoolYearOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<SchoolYearOrganizationCreateFieldInput>;
};

export type SchoolYearOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SchoolYearOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SchoolYearOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SchoolYearOrganizationNodeAggregationWhereInput>>;
  aboutInfoLastUpdated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type SchoolYearOrganizationRelationship = {
  __typename?: 'SchoolYearOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type SchoolYearOrganizationUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type SchoolYearOrganizationUpdateFieldInput = {
  connect?: InputMaybe<SchoolYearOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<SchoolYearOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<SchoolYearOrganizationCreateFieldInput>;
  delete?: InputMaybe<SchoolYearOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<SchoolYearOrganizationDisconnectFieldInput>;
  update?: InputMaybe<SchoolYearOrganizationUpdateConnectionInput>;
  where?: InputMaybe<SchoolYearOrganizationConnectionWhere>;
};

/** Fields to sort SchoolYears by. The order in which sorts are applied is not guaranteed when specifying many fields in one SchoolYearSort object. */
export type SchoolYearSort = {
  createdAt?: InputMaybe<SortDirection>;
  end?: InputMaybe<SortDirection>;
  managedBy?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  shortName?: InputMaybe<SortDirection>;
  start?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type SchoolYearUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  end?: InputMaybe<Scalars['Date']['input']>;
  foreignRefId?: InputMaybe<Array<Scalars['String']['input']>>;
  foreignRefId_POP?: InputMaybe<Scalars['Int']['input']>;
  foreignRefId_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
  managedBy?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<SchoolYearOrganizationUpdateFieldInput>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
};

export type SchoolYearWhere = {
  AND?: InputMaybe<Array<SchoolYearWhere>>;
  NOT?: InputMaybe<SchoolYearWhere>;
  OR?: InputMaybe<Array<SchoolYearWhere>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  end?: InputMaybe<Scalars['Date']['input']>;
  end_GT?: InputMaybe<Scalars['Date']['input']>;
  end_GTE?: InputMaybe<Scalars['Date']['input']>;
  end_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  end_LT?: InputMaybe<Scalars['Date']['input']>;
  end_LTE?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  end_NOT?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  end_NOT_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  foreignRefId?: InputMaybe<Array<Scalars['String']['input']>>;
  foreignRefId_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignRefId_NOT?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignRefId_NOT_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  managedBy?: InputMaybe<Scalars['String']['input']>;
  managedBy_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  managedBy_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  managedBy_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  managedBy_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  managedBy_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  managedBy_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  managedBy_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  managedBy_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  managedBy_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<SchoolYearOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<SchoolYearOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<SchoolYearOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  shortName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  shortName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  shortName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  shortName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
  start_GT?: InputMaybe<Scalars['Date']['input']>;
  start_GTE?: InputMaybe<Scalars['Date']['input']>;
  start_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  start_LT?: InputMaybe<Scalars['Date']['input']>;
  start_LTE?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  start_NOT?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  start_NOT_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type SchoolYearsConnection = {
  __typename?: 'SchoolYearsConnection';
  edges: Array<SchoolYearEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An enum for sorting in either ascending or descending order. */
export enum SortDirection {
  /** Sort by field values in ascending order. */
  Asc = 'ASC',
  /** Sort by field values in descending order. */
  Desc = 'DESC',
}

export type StringAggregateSelection = {
  __typename?: 'StringAggregateSelection';
  longest?: Maybe<Scalars['String']['output']>;
  shortest?: Maybe<Scalars['String']['output']>;
};

export type Subject = {
  __typename?: 'Subject';
  foreignRefId?: Maybe<Array<Scalars['String']['output']>>;
  globalSubject?: Maybe<Scalars['String']['output']>;
  managedBy: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organization: Organization;
  organizationConnection: SubjectOrganizationConnection;
  uuid: Scalars['ID']['output'];
};

export type SubjectOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type SubjectOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SubjectOrganizationConnectionSort>>;
  where?: InputMaybe<SubjectOrganizationConnectionWhere>;
};

export type SubjectAggregateSelection = {
  __typename?: 'SubjectAggregateSelection';
  count: Scalars['Int']['output'];
  globalSubject: StringAggregateSelection;
  managedBy: StringAggregateSelection;
  name: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type SubjectConnectInput = {
  organization?: InputMaybe<SubjectOrganizationConnectFieldInput>;
};

export type SubjectConnectWhere = {
  node: SubjectWhere;
};

export type SubjectCreateInput = {
  foreignRefId?: InputMaybe<Array<Scalars['String']['input']>>;
  globalSubject?: InputMaybe<Scalars['String']['input']>;
  managedBy: Scalars['String']['input'];
  name: Scalars['String']['input'];
  organization?: InputMaybe<SubjectOrganizationFieldInput>;
};

export type SubjectDeleteInput = {
  organization?: InputMaybe<SubjectOrganizationDeleteFieldInput>;
};

export type SubjectDisconnectInput = {
  organization?: InputMaybe<SubjectOrganizationDisconnectFieldInput>;
};

export type SubjectEdge = {
  __typename?: 'SubjectEdge';
  cursor: Scalars['String']['output'];
  node: Subject;
};

export type SubjectOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more SubjectSort objects to sort Subjects by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<SubjectSort>>;
};

export type SubjectOrganizationAggregateInput = {
  AND?: InputMaybe<Array<SubjectOrganizationAggregateInput>>;
  NOT?: InputMaybe<SubjectOrganizationAggregateInput>;
  OR?: InputMaybe<Array<SubjectOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SubjectOrganizationNodeAggregationWhereInput>;
};

export type SubjectOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type SubjectOrganizationConnectOrCreateFieldInput = {
  onCreate: SubjectOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type SubjectOrganizationConnectOrCreateFieldInputOnCreate = {
  node: OrganizationOnCreateInput;
};

export type SubjectOrganizationConnection = {
  __typename?: 'SubjectOrganizationConnection';
  edges: Array<SubjectOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SubjectOrganizationConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type SubjectOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<SubjectOrganizationConnectionWhere>>;
  NOT?: InputMaybe<SubjectOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<SubjectOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type SubjectOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type SubjectOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<SubjectOrganizationConnectionWhere>;
};

export type SubjectOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<SubjectOrganizationConnectionWhere>;
};

export type SubjectOrganizationFieldInput = {
  connect?: InputMaybe<SubjectOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<SubjectOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<SubjectOrganizationCreateFieldInput>;
};

export type SubjectOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SubjectOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SubjectOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SubjectOrganizationNodeAggregationWhereInput>>;
  aboutInfoLastUpdated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type SubjectOrganizationRelationship = {
  __typename?: 'SubjectOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type SubjectOrganizationUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type SubjectOrganizationUpdateFieldInput = {
  connect?: InputMaybe<SubjectOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<SubjectOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<SubjectOrganizationCreateFieldInput>;
  delete?: InputMaybe<SubjectOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<SubjectOrganizationDisconnectFieldInput>;
  update?: InputMaybe<SubjectOrganizationUpdateConnectionInput>;
  where?: InputMaybe<SubjectOrganizationConnectionWhere>;
};

/** Fields to sort Subjects by. The order in which sorts are applied is not guaranteed when specifying many fields in one SubjectSort object. */
export type SubjectSort = {
  globalSubject?: InputMaybe<SortDirection>;
  managedBy?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type SubjectUpdateInput = {
  foreignRefId?: InputMaybe<Array<Scalars['String']['input']>>;
  foreignRefId_POP?: InputMaybe<Scalars['Int']['input']>;
  foreignRefId_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
  globalSubject?: InputMaybe<Scalars['String']['input']>;
  managedBy?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<SubjectOrganizationUpdateFieldInput>;
};

export type SubjectWhere = {
  AND?: InputMaybe<Array<SubjectWhere>>;
  NOT?: InputMaybe<SubjectWhere>;
  OR?: InputMaybe<Array<SubjectWhere>>;
  foreignRefId?: InputMaybe<Array<Scalars['String']['input']>>;
  foreignRefId_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignRefId_NOT?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignRefId_NOT_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  globalSubject?: InputMaybe<Scalars['String']['input']>;
  globalSubject_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  globalSubject_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  globalSubject_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  globalSubject_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  globalSubject_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  globalSubject_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  globalSubject_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  globalSubject_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  globalSubject_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  managedBy?: InputMaybe<Scalars['String']['input']>;
  managedBy_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  managedBy_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  managedBy_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  managedBy_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  managedBy_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  managedBy_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  managedBy_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  managedBy_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  managedBy_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<SubjectOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<SubjectOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<SubjectOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type SubjectsConnection = {
  __typename?: 'SubjectsConnection';
  edges: Array<SubjectEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Submission = {
  __typename?: 'Submission';
  assignment: Array<Assignment>;
  assignmentAggregate?: Maybe<SubmissionAssignmentAssignmentAggregationSelection>;
  assignmentConnection: SubmissionAssignmentConnection;
  created: Scalars['DateTime']['output'];
  editorUuids: Array<Scalars['ID']['output']>;
  material: Material;
  materialConnection: SubmissionMaterialConnection;
  /** Persist the matrixRoomId to reduce load on Matrix */
  matrixRoomId?: Maybe<Scalars['String']['output']>;
  owner: Profile;
  ownerConnection: SubmissionOwnerConnection;
  public?: Maybe<Scalars['Boolean']['output']>;
  status: SubmissionStatus;
  updated: Scalars['DateTime']['output'];
  uuid: Scalars['ID']['output'];
};

export type SubmissionAssignmentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AssignmentOptions>;
  where?: InputMaybe<AssignmentWhere>;
};

export type SubmissionAssignmentAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssignmentWhere>;
};

export type SubmissionAssignmentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SubmissionAssignmentConnectionSort>>;
  where?: InputMaybe<SubmissionAssignmentConnectionWhere>;
};

export type SubmissionMaterialArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<MaterialOptions>;
  where?: InputMaybe<MaterialWhere>;
};

export type SubmissionMaterialConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SubmissionMaterialConnectionSort>>;
  where?: InputMaybe<SubmissionMaterialConnectionWhere>;
};

export type SubmissionOwnerArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ProfileOptions>;
  where?: InputMaybe<ProfileWhere>;
};

export type SubmissionOwnerConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SubmissionOwnerConnectionSort>>;
  where?: InputMaybe<SubmissionOwnerConnectionWhere>;
};

export type SubmissionAggregateSelection = {
  __typename?: 'SubmissionAggregateSelection';
  count: Scalars['Int']['output'];
  created: DateTimeAggregateSelection;
  matrixRoomId: StringAggregateSelection;
  updated: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type SubmissionAssignmentAggregateInput = {
  AND?: InputMaybe<Array<SubmissionAssignmentAggregateInput>>;
  NOT?: InputMaybe<SubmissionAssignmentAggregateInput>;
  OR?: InputMaybe<Array<SubmissionAssignmentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SubmissionAssignmentNodeAggregationWhereInput>;
};

export type SubmissionAssignmentAssignmentAggregationSelection = {
  __typename?: 'SubmissionAssignmentAssignmentAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<SubmissionAssignmentAssignmentNodeAggregateSelection>;
};

export type SubmissionAssignmentAssignmentNodeAggregateSelection = {
  __typename?: 'SubmissionAssignmentAssignmentNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  title: StringAggregateSelection;
  updated: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type SubmissionAssignmentConnectFieldInput = {
  connect?: InputMaybe<Array<AssignmentConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AssignmentConnectWhere>;
};

export type SubmissionAssignmentConnection = {
  __typename?: 'SubmissionAssignmentConnection';
  edges: Array<SubmissionAssignmentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SubmissionAssignmentConnectionSort = {
  node?: InputMaybe<AssignmentSort>;
};

export type SubmissionAssignmentConnectionWhere = {
  AND?: InputMaybe<Array<SubmissionAssignmentConnectionWhere>>;
  NOT?: InputMaybe<SubmissionAssignmentConnectionWhere>;
  OR?: InputMaybe<Array<SubmissionAssignmentConnectionWhere>>;
  node?: InputMaybe<AssignmentWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<AssignmentWhere>;
};

export type SubmissionAssignmentCreateFieldInput = {
  node: AssignmentCreateInput;
};

export type SubmissionAssignmentDeleteFieldInput = {
  delete?: InputMaybe<AssignmentDeleteInput>;
  where?: InputMaybe<SubmissionAssignmentConnectionWhere>;
};

export type SubmissionAssignmentDisconnectFieldInput = {
  disconnect?: InputMaybe<AssignmentDisconnectInput>;
  where?: InputMaybe<SubmissionAssignmentConnectionWhere>;
};

export type SubmissionAssignmentFieldInput = {
  connect?: InputMaybe<Array<SubmissionAssignmentConnectFieldInput>>;
  create?: InputMaybe<Array<SubmissionAssignmentCreateFieldInput>>;
};

export type SubmissionAssignmentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SubmissionAssignmentNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SubmissionAssignmentNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SubmissionAssignmentNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SubmissionAssignmentRelationship = {
  __typename?: 'SubmissionAssignmentRelationship';
  cursor: Scalars['String']['output'];
  node: Assignment;
};

export type SubmissionAssignmentUpdateConnectionInput = {
  node?: InputMaybe<AssignmentUpdateInput>;
};

export type SubmissionAssignmentUpdateFieldInput = {
  connect?: InputMaybe<Array<SubmissionAssignmentConnectFieldInput>>;
  create?: InputMaybe<Array<SubmissionAssignmentCreateFieldInput>>;
  delete?: InputMaybe<Array<SubmissionAssignmentDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<SubmissionAssignmentDisconnectFieldInput>>;
  update?: InputMaybe<SubmissionAssignmentUpdateConnectionInput>;
  where?: InputMaybe<SubmissionAssignmentConnectionWhere>;
};

export type SubmissionConnectInput = {
  assignment?: InputMaybe<Array<SubmissionAssignmentConnectFieldInput>>;
  material?: InputMaybe<SubmissionMaterialConnectFieldInput>;
  owner?: InputMaybe<SubmissionOwnerConnectFieldInput>;
};

export type SubmissionConnectWhere = {
  node: SubmissionWhere;
};

export type SubmissionCreateInput = {
  assignment?: InputMaybe<SubmissionAssignmentFieldInput>;
  material?: InputMaybe<SubmissionMaterialFieldInput>;
  matrixRoomId?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<SubmissionOwnerFieldInput>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  status: SubmissionStatus;
};

export type SubmissionDeleteInput = {
  assignment?: InputMaybe<Array<SubmissionAssignmentDeleteFieldInput>>;
  material?: InputMaybe<SubmissionMaterialDeleteFieldInput>;
  owner?: InputMaybe<SubmissionOwnerDeleteFieldInput>;
};

export type SubmissionDisconnectInput = {
  assignment?: InputMaybe<Array<SubmissionAssignmentDisconnectFieldInput>>;
  material?: InputMaybe<SubmissionMaterialDisconnectFieldInput>;
  owner?: InputMaybe<SubmissionOwnerDisconnectFieldInput>;
};

export type SubmissionEdge = {
  __typename?: 'SubmissionEdge';
  cursor: Scalars['String']['output'];
  node: Submission;
};

export type SubmissionMaterialAggregateInput = {
  AND?: InputMaybe<Array<SubmissionMaterialAggregateInput>>;
  NOT?: InputMaybe<SubmissionMaterialAggregateInput>;
  OR?: InputMaybe<Array<SubmissionMaterialAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SubmissionMaterialNodeAggregationWhereInput>;
};

export type SubmissionMaterialConnectFieldInput = {
  connect?: InputMaybe<MaterialConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<MaterialConnectWhere>;
};

export type SubmissionMaterialConnection = {
  __typename?: 'SubmissionMaterialConnection';
  edges: Array<SubmissionMaterialRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SubmissionMaterialConnectionSort = {
  node?: InputMaybe<MaterialSort>;
};

export type SubmissionMaterialConnectionWhere = {
  AND?: InputMaybe<Array<SubmissionMaterialConnectionWhere>>;
  NOT?: InputMaybe<SubmissionMaterialConnectionWhere>;
  OR?: InputMaybe<Array<SubmissionMaterialConnectionWhere>>;
  node?: InputMaybe<MaterialWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<MaterialWhere>;
};

export type SubmissionMaterialCreateFieldInput = {
  node: MaterialCreateInput;
};

export type SubmissionMaterialDeleteFieldInput = {
  delete?: InputMaybe<MaterialDeleteInput>;
  where?: InputMaybe<SubmissionMaterialConnectionWhere>;
};

export type SubmissionMaterialDisconnectFieldInput = {
  disconnect?: InputMaybe<MaterialDisconnectInput>;
  where?: InputMaybe<SubmissionMaterialConnectionWhere>;
};

export type SubmissionMaterialFieldInput = {
  connect?: InputMaybe<SubmissionMaterialConnectFieldInput>;
  create?: InputMaybe<SubmissionMaterialCreateFieldInput>;
};

export type SubmissionMaterialNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SubmissionMaterialNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SubmissionMaterialNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SubmissionMaterialNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  textMediaType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  textMediaType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  textMediaType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  textMediaType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  textMediaType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  textMediaType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  textMediaType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  textMediaType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  textMediaType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  textMediaType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  textMediaType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  textMediaType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  textMediaType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  textMediaType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  textMediaType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  text_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  text_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SubmissionMaterialRelationship = {
  __typename?: 'SubmissionMaterialRelationship';
  cursor: Scalars['String']['output'];
  node: Material;
};

export type SubmissionMaterialUpdateConnectionInput = {
  node?: InputMaybe<MaterialUpdateInput>;
};

export type SubmissionMaterialUpdateFieldInput = {
  connect?: InputMaybe<SubmissionMaterialConnectFieldInput>;
  create?: InputMaybe<SubmissionMaterialCreateFieldInput>;
  delete?: InputMaybe<SubmissionMaterialDeleteFieldInput>;
  disconnect?: InputMaybe<SubmissionMaterialDisconnectFieldInput>;
  update?: InputMaybe<SubmissionMaterialUpdateConnectionInput>;
  where?: InputMaybe<SubmissionMaterialConnectionWhere>;
};

export type SubmissionOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more SubmissionSort objects to sort Submissions by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<SubmissionSort>>;
};

export type SubmissionOwnerAggregateInput = {
  AND?: InputMaybe<Array<SubmissionOwnerAggregateInput>>;
  NOT?: InputMaybe<SubmissionOwnerAggregateInput>;
  OR?: InputMaybe<Array<SubmissionOwnerAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SubmissionOwnerNodeAggregationWhereInput>;
};

export type SubmissionOwnerConnectFieldInput = {
  connect?: InputMaybe<ProfileConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ProfileConnectWhere>;
};

export type SubmissionOwnerConnectOrCreateFieldInput = {
  onCreate: SubmissionOwnerConnectOrCreateFieldInputOnCreate;
  where: ProfileConnectOrCreateWhere;
};

export type SubmissionOwnerConnectOrCreateFieldInputOnCreate = {
  node: ProfileOnCreateInput;
};

export type SubmissionOwnerConnection = {
  __typename?: 'SubmissionOwnerConnection';
  edges: Array<SubmissionOwnerRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SubmissionOwnerConnectionSort = {
  node?: InputMaybe<ProfileSort>;
};

export type SubmissionOwnerConnectionWhere = {
  AND?: InputMaybe<Array<SubmissionOwnerConnectionWhere>>;
  NOT?: InputMaybe<SubmissionOwnerConnectionWhere>;
  OR?: InputMaybe<Array<SubmissionOwnerConnectionWhere>>;
  node?: InputMaybe<ProfileWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ProfileWhere>;
};

export type SubmissionOwnerCreateFieldInput = {
  node: ProfileCreateInput;
};

export type SubmissionOwnerDeleteFieldInput = {
  delete?: InputMaybe<ProfileDeleteInput>;
  where?: InputMaybe<SubmissionOwnerConnectionWhere>;
};

export type SubmissionOwnerDisconnectFieldInput = {
  disconnect?: InputMaybe<ProfileDisconnectInput>;
  where?: InputMaybe<SubmissionOwnerConnectionWhere>;
};

export type SubmissionOwnerFieldInput = {
  connect?: InputMaybe<SubmissionOwnerConnectFieldInput>;
  connectOrCreate?: InputMaybe<SubmissionOwnerConnectOrCreateFieldInput>;
  create?: InputMaybe<SubmissionOwnerCreateFieldInput>;
};

export type SubmissionOwnerNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SubmissionOwnerNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SubmissionOwnerNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SubmissionOwnerNodeAggregationWhereInput>>;
  address1_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address1_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address2_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address2_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address3_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address3_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  birthday_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  userUuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  userUuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type SubmissionOwnerRelationship = {
  __typename?: 'SubmissionOwnerRelationship';
  cursor: Scalars['String']['output'];
  node: Profile;
};

export type SubmissionOwnerUpdateConnectionInput = {
  node?: InputMaybe<ProfileUpdateInput>;
};

export type SubmissionOwnerUpdateFieldInput = {
  connect?: InputMaybe<SubmissionOwnerConnectFieldInput>;
  connectOrCreate?: InputMaybe<SubmissionOwnerConnectOrCreateFieldInput>;
  create?: InputMaybe<SubmissionOwnerCreateFieldInput>;
  delete?: InputMaybe<SubmissionOwnerDeleteFieldInput>;
  disconnect?: InputMaybe<SubmissionOwnerDisconnectFieldInput>;
  update?: InputMaybe<SubmissionOwnerUpdateConnectionInput>;
  where?: InputMaybe<SubmissionOwnerConnectionWhere>;
};

/** Fields to sort Submissions by. The order in which sorts are applied is not guaranteed when specifying many fields in one SubmissionSort object. */
export type SubmissionSort = {
  created?: InputMaybe<SortDirection>;
  matrixRoomId?: InputMaybe<SortDirection>;
  public?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  updated?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export enum SubmissionStatus {
  Done = 'Done',
  Draft = 'Draft',
  Feedback = 'Feedback',
  New = 'New',
  Todo = 'Todo',
  Updated = 'Updated',
}

export type SubmissionUpdateInput = {
  assignment?: InputMaybe<Array<SubmissionAssignmentUpdateFieldInput>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  material?: InputMaybe<SubmissionMaterialUpdateFieldInput>;
  matrixRoomId?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<SubmissionOwnerUpdateFieldInput>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<SubmissionStatus>;
};

export type SubmissionWhere = {
  AND?: InputMaybe<Array<SubmissionWhere>>;
  NOT?: InputMaybe<SubmissionWhere>;
  OR?: InputMaybe<Array<SubmissionWhere>>;
  /** @deprecated Use `assignment_SOME` instead. */
  assignment?: InputMaybe<AssignmentWhere>;
  assignmentAggregate?: InputMaybe<SubmissionAssignmentAggregateInput>;
  /** @deprecated Use `assignmentConnection_SOME` instead. */
  assignmentConnection?: InputMaybe<SubmissionAssignmentConnectionWhere>;
  /** Return Submissions where all of the related SubmissionAssignmentConnections match this filter */
  assignmentConnection_ALL?: InputMaybe<SubmissionAssignmentConnectionWhere>;
  /** Return Submissions where none of the related SubmissionAssignmentConnections match this filter */
  assignmentConnection_NONE?: InputMaybe<SubmissionAssignmentConnectionWhere>;
  /** @deprecated Use `assignmentConnection_NONE` instead. */
  assignmentConnection_NOT?: InputMaybe<SubmissionAssignmentConnectionWhere>;
  /** Return Submissions where one of the related SubmissionAssignmentConnections match this filter */
  assignmentConnection_SINGLE?: InputMaybe<SubmissionAssignmentConnectionWhere>;
  /** Return Submissions where some of the related SubmissionAssignmentConnections match this filter */
  assignmentConnection_SOME?: InputMaybe<SubmissionAssignmentConnectionWhere>;
  /** Return Submissions where all of the related Assignments match this filter */
  assignment_ALL?: InputMaybe<AssignmentWhere>;
  /** Return Submissions where none of the related Assignments match this filter */
  assignment_NONE?: InputMaybe<AssignmentWhere>;
  /** @deprecated Use `assignment_NONE` instead. */
  assignment_NOT?: InputMaybe<AssignmentWhere>;
  /** Return Submissions where one of the related Assignments match this filter */
  assignment_SINGLE?: InputMaybe<AssignmentWhere>;
  /** Return Submissions where some of the related Assignments match this filter */
  assignment_SOME?: InputMaybe<AssignmentWhere>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  created_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  created_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  editorUuids?: InputMaybe<Array<Scalars['ID']['input']>>;
  editorUuids_INCLUDES?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  editorUuids_NOT?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  editorUuids_NOT_INCLUDES?: InputMaybe<Scalars['ID']['input']>;
  material?: InputMaybe<MaterialWhere>;
  materialAggregate?: InputMaybe<SubmissionMaterialAggregateInput>;
  materialConnection?: InputMaybe<SubmissionMaterialConnectionWhere>;
  materialConnection_NOT?: InputMaybe<SubmissionMaterialConnectionWhere>;
  material_NOT?: InputMaybe<MaterialWhere>;
  matrixRoomId?: InputMaybe<Scalars['String']['input']>;
  matrixRoomId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  matrixRoomId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  matrixRoomId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  matrixRoomId_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  matrixRoomId_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  matrixRoomId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  matrixRoomId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  matrixRoomId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  matrixRoomId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<ProfileWhere>;
  ownerAggregate?: InputMaybe<SubmissionOwnerAggregateInput>;
  ownerConnection?: InputMaybe<SubmissionOwnerConnectionWhere>;
  ownerConnection_NOT?: InputMaybe<SubmissionOwnerConnectionWhere>;
  owner_NOT?: InputMaybe<ProfileWhere>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  public_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<SubmissionStatus>;
  status_IN?: InputMaybe<Array<SubmissionStatus>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  status_NOT?: InputMaybe<SubmissionStatus>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  status_NOT_IN?: InputMaybe<Array<SubmissionStatus>>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  updated_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updated_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updated_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updated_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type SubmissionsConnection = {
  __typename?: 'SubmissionsConnection';
  edges: Array<SubmissionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingTopic = {
  __typename?: 'TeachingTopic';
  group: Group;
  groupAggregate?: Maybe<TeachingTopicGroupGroupAggregationSelection>;
  groupConnection: TeachingTopicGroupConnection;
  isRoot: Scalars['Boolean']['output'];
  organization: Organization;
  organizationAggregate?: Maybe<TeachingTopicOrganizationOrganizationAggregationSelection>;
  organizationConnection: TeachingTopicOrganizationConnection;
  owner: Profile;
  ownerAggregate?: Maybe<TeachingTopicProfileOwnerAggregationSelection>;
  ownerConnection: TeachingTopicOwnerConnection;
  teachingUnits: Array<TeachingUnit>;
  teachingUnitsAggregate?: Maybe<TeachingTopicTeachingUnitTeachingUnitsAggregationSelection>;
  teachingUnitsConnection: TeachingTopicTeachingUnitsConnection;
  title: Scalars['String']['output'];
  topicChilds: Array<TeachingTopic>;
  topicChildsAggregate?: Maybe<TeachingTopicTeachingTopicTopicChildsAggregationSelection>;
  topicChildsConnection: TeachingTopicTopicChildsConnection;
  topicParent?: Maybe<TeachingTopic>;
  topicParentAggregate?: Maybe<TeachingTopicTeachingTopicTopicParentAggregationSelection>;
  topicParentConnection: TeachingTopicTopicParentConnection;
  uuid: Scalars['ID']['output'];
};

export type TeachingTopicGroupArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<GroupOptions>;
  where?: InputMaybe<GroupWhere>;
};

export type TeachingTopicGroupAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GroupWhere>;
};

export type TeachingTopicGroupConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TeachingTopicGroupConnectionSort>>;
  where?: InputMaybe<TeachingTopicGroupConnectionWhere>;
};

export type TeachingTopicOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type TeachingTopicOrganizationAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OrganizationWhere>;
};

export type TeachingTopicOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TeachingTopicOrganizationConnectionSort>>;
  where?: InputMaybe<TeachingTopicOrganizationConnectionWhere>;
};

export type TeachingTopicOwnerArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ProfileOptions>;
  where?: InputMaybe<ProfileWhere>;
};

export type TeachingTopicOwnerAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProfileWhere>;
};

export type TeachingTopicOwnerConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TeachingTopicOwnerConnectionSort>>;
  where?: InputMaybe<TeachingTopicOwnerConnectionWhere>;
};

export type TeachingTopicTeachingUnitsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TeachingUnitOptions>;
  where?: InputMaybe<TeachingUnitWhere>;
};

export type TeachingTopicTeachingUnitsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TeachingUnitWhere>;
};

export type TeachingTopicTeachingUnitsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TeachingTopicTeachingUnitsConnectionSort>>;
  where?: InputMaybe<TeachingTopicTeachingUnitsConnectionWhere>;
};

export type TeachingTopicTopicChildsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TeachingTopicOptions>;
  where?: InputMaybe<TeachingTopicWhere>;
};

export type TeachingTopicTopicChildsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TeachingTopicWhere>;
};

export type TeachingTopicTopicChildsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TeachingTopicTopicChildsConnectionSort>>;
  where?: InputMaybe<TeachingTopicTopicChildsConnectionWhere>;
};

export type TeachingTopicTopicParentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TeachingTopicOptions>;
  where?: InputMaybe<TeachingTopicWhere>;
};

export type TeachingTopicTopicParentAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TeachingTopicWhere>;
};

export type TeachingTopicTopicParentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TeachingTopicTopicParentConnectionSort>>;
  where?: InputMaybe<TeachingTopicTopicParentConnectionWhere>;
};

export type TeachingTopicAggregateSelection = {
  __typename?: 'TeachingTopicAggregateSelection';
  count: Scalars['Int']['output'];
  title: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type TeachingTopicConnectInput = {
  group?: InputMaybe<TeachingTopicGroupConnectFieldInput>;
  organization?: InputMaybe<TeachingTopicOrganizationConnectFieldInput>;
  owner?: InputMaybe<TeachingTopicOwnerConnectFieldInput>;
  teachingUnits?: InputMaybe<Array<TeachingTopicTeachingUnitsConnectFieldInput>>;
  topicChilds?: InputMaybe<Array<TeachingTopicTopicChildsConnectFieldInput>>;
  topicParent?: InputMaybe<TeachingTopicTopicParentConnectFieldInput>;
};

export type TeachingTopicConnectWhere = {
  node: TeachingTopicWhere;
};

export type TeachingTopicCreateInput = {
  group?: InputMaybe<TeachingTopicGroupFieldInput>;
  organization?: InputMaybe<TeachingTopicOrganizationFieldInput>;
  owner?: InputMaybe<TeachingTopicOwnerFieldInput>;
  teachingUnits?: InputMaybe<TeachingTopicTeachingUnitsFieldInput>;
  title: Scalars['String']['input'];
  topicChilds?: InputMaybe<TeachingTopicTopicChildsFieldInput>;
  topicParent?: InputMaybe<TeachingTopicTopicParentFieldInput>;
};

export type TeachingTopicDeleteInput = {
  group?: InputMaybe<TeachingTopicGroupDeleteFieldInput>;
  organization?: InputMaybe<TeachingTopicOrganizationDeleteFieldInput>;
  owner?: InputMaybe<TeachingTopicOwnerDeleteFieldInput>;
  teachingUnits?: InputMaybe<Array<TeachingTopicTeachingUnitsDeleteFieldInput>>;
  topicChilds?: InputMaybe<Array<TeachingTopicTopicChildsDeleteFieldInput>>;
  topicParent?: InputMaybe<TeachingTopicTopicParentDeleteFieldInput>;
};

export type TeachingTopicDisconnectInput = {
  group?: InputMaybe<TeachingTopicGroupDisconnectFieldInput>;
  organization?: InputMaybe<TeachingTopicOrganizationDisconnectFieldInput>;
  owner?: InputMaybe<TeachingTopicOwnerDisconnectFieldInput>;
  teachingUnits?: InputMaybe<Array<TeachingTopicTeachingUnitsDisconnectFieldInput>>;
  topicChilds?: InputMaybe<Array<TeachingTopicTopicChildsDisconnectFieldInput>>;
  topicParent?: InputMaybe<TeachingTopicTopicParentDisconnectFieldInput>;
};

export type TeachingTopicEdge = {
  __typename?: 'TeachingTopicEdge';
  cursor: Scalars['String']['output'];
  node: TeachingTopic;
};

export type TeachingTopicGroupAggregateInput = {
  AND?: InputMaybe<Array<TeachingTopicGroupAggregateInput>>;
  NOT?: InputMaybe<TeachingTopicGroupAggregateInput>;
  OR?: InputMaybe<Array<TeachingTopicGroupAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TeachingTopicGroupNodeAggregationWhereInput>;
};

export type TeachingTopicGroupConnectFieldInput = {
  connect?: InputMaybe<GroupConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<GroupConnectWhere>;
};

export type TeachingTopicGroupConnectOrCreateFieldInput = {
  onCreate: TeachingTopicGroupConnectOrCreateFieldInputOnCreate;
  where: GroupConnectOrCreateWhere;
};

export type TeachingTopicGroupConnectOrCreateFieldInputOnCreate = {
  node: GroupOnCreateInput;
};

export type TeachingTopicGroupConnection = {
  __typename?: 'TeachingTopicGroupConnection';
  edges: Array<TeachingTopicGroupRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingTopicGroupConnectionSort = {
  node?: InputMaybe<GroupSort>;
};

export type TeachingTopicGroupConnectionWhere = {
  AND?: InputMaybe<Array<TeachingTopicGroupConnectionWhere>>;
  NOT?: InputMaybe<TeachingTopicGroupConnectionWhere>;
  OR?: InputMaybe<Array<TeachingTopicGroupConnectionWhere>>;
  node?: InputMaybe<GroupWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<GroupWhere>;
};

export type TeachingTopicGroupCreateFieldInput = {
  node: GroupCreateInput;
};

export type TeachingTopicGroupDeleteFieldInput = {
  delete?: InputMaybe<GroupDeleteInput>;
  where?: InputMaybe<TeachingTopicGroupConnectionWhere>;
};

export type TeachingTopicGroupDisconnectFieldInput = {
  disconnect?: InputMaybe<GroupDisconnectInput>;
  where?: InputMaybe<TeachingTopicGroupConnectionWhere>;
};

export type TeachingTopicGroupFieldInput = {
  connect?: InputMaybe<TeachingTopicGroupConnectFieldInput>;
  connectOrCreate?: InputMaybe<TeachingTopicGroupConnectOrCreateFieldInput>;
  create?: InputMaybe<TeachingTopicGroupCreateFieldInput>;
};

export type TeachingTopicGroupGroupAggregationSelection = {
  __typename?: 'TeachingTopicGroupGroupAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TeachingTopicGroupGroupNodeAggregateSelection>;
};

export type TeachingTopicGroupGroupNodeAggregateSelection = {
  __typename?: 'TeachingTopicGroupGroupNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  managedBy: StringAggregateSelection;
  matrixRoomId: StringAggregateSelection;
  name: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type TeachingTopicGroupNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TeachingTopicGroupNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TeachingTopicGroupNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TeachingTopicGroupNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeachingTopicGroupRelationship = {
  __typename?: 'TeachingTopicGroupRelationship';
  cursor: Scalars['String']['output'];
  node: Group;
};

export type TeachingTopicGroupUpdateConnectionInput = {
  node?: InputMaybe<GroupUpdateInput>;
};

export type TeachingTopicGroupUpdateFieldInput = {
  connect?: InputMaybe<TeachingTopicGroupConnectFieldInput>;
  connectOrCreate?: InputMaybe<TeachingTopicGroupConnectOrCreateFieldInput>;
  create?: InputMaybe<TeachingTopicGroupCreateFieldInput>;
  delete?: InputMaybe<TeachingTopicGroupDeleteFieldInput>;
  disconnect?: InputMaybe<TeachingTopicGroupDisconnectFieldInput>;
  update?: InputMaybe<TeachingTopicGroupUpdateConnectionInput>;
  where?: InputMaybe<TeachingTopicGroupConnectionWhere>;
};

export type TeachingTopicOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more TeachingTopicSort objects to sort TeachingTopics by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<TeachingTopicSort>>;
};

export type TeachingTopicOrganizationAggregateInput = {
  AND?: InputMaybe<Array<TeachingTopicOrganizationAggregateInput>>;
  NOT?: InputMaybe<TeachingTopicOrganizationAggregateInput>;
  OR?: InputMaybe<Array<TeachingTopicOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TeachingTopicOrganizationNodeAggregationWhereInput>;
};

export type TeachingTopicOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type TeachingTopicOrganizationConnectOrCreateFieldInput = {
  onCreate: TeachingTopicOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type TeachingTopicOrganizationConnectOrCreateFieldInputOnCreate = {
  node: OrganizationOnCreateInput;
};

export type TeachingTopicOrganizationConnection = {
  __typename?: 'TeachingTopicOrganizationConnection';
  edges: Array<TeachingTopicOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingTopicOrganizationConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type TeachingTopicOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<TeachingTopicOrganizationConnectionWhere>>;
  NOT?: InputMaybe<TeachingTopicOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<TeachingTopicOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type TeachingTopicOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type TeachingTopicOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<TeachingTopicOrganizationConnectionWhere>;
};

export type TeachingTopicOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<TeachingTopicOrganizationConnectionWhere>;
};

export type TeachingTopicOrganizationFieldInput = {
  connect?: InputMaybe<TeachingTopicOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<TeachingTopicOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<TeachingTopicOrganizationCreateFieldInput>;
};

export type TeachingTopicOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TeachingTopicOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TeachingTopicOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TeachingTopicOrganizationNodeAggregationWhereInput>>;
  aboutInfoLastUpdated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TeachingTopicOrganizationOrganizationAggregationSelection = {
  __typename?: 'TeachingTopicOrganizationOrganizationAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TeachingTopicOrganizationOrganizationNodeAggregateSelection>;
};

export type TeachingTopicOrganizationOrganizationNodeAggregateSelection = {
  __typename?: 'TeachingTopicOrganizationOrganizationNodeAggregateSelection';
  aboutInfo: StringAggregateSelection;
  aboutInfoLastUpdated: DateTimeAggregateSelection;
  displayName: StringAggregateSelection;
  matrixRoomId: StringAggregateSelection;
  planungSyncProps: StringAggregateSelection;
  procuratSyncProps: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type TeachingTopicOrganizationRelationship = {
  __typename?: 'TeachingTopicOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type TeachingTopicOrganizationUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type TeachingTopicOrganizationUpdateFieldInput = {
  connect?: InputMaybe<TeachingTopicOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<TeachingTopicOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<TeachingTopicOrganizationCreateFieldInput>;
  delete?: InputMaybe<TeachingTopicOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<TeachingTopicOrganizationDisconnectFieldInput>;
  update?: InputMaybe<TeachingTopicOrganizationUpdateConnectionInput>;
  where?: InputMaybe<TeachingTopicOrganizationConnectionWhere>;
};

export type TeachingTopicOwnerAggregateInput = {
  AND?: InputMaybe<Array<TeachingTopicOwnerAggregateInput>>;
  NOT?: InputMaybe<TeachingTopicOwnerAggregateInput>;
  OR?: InputMaybe<Array<TeachingTopicOwnerAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TeachingTopicOwnerNodeAggregationWhereInput>;
};

export type TeachingTopicOwnerConnectFieldInput = {
  connect?: InputMaybe<ProfileConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ProfileConnectWhere>;
};

export type TeachingTopicOwnerConnectOrCreateFieldInput = {
  onCreate: TeachingTopicOwnerConnectOrCreateFieldInputOnCreate;
  where: ProfileConnectOrCreateWhere;
};

export type TeachingTopicOwnerConnectOrCreateFieldInputOnCreate = {
  node: ProfileOnCreateInput;
};

export type TeachingTopicOwnerConnection = {
  __typename?: 'TeachingTopicOwnerConnection';
  edges: Array<TeachingTopicOwnerRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingTopicOwnerConnectionSort = {
  node?: InputMaybe<ProfileSort>;
};

export type TeachingTopicOwnerConnectionWhere = {
  AND?: InputMaybe<Array<TeachingTopicOwnerConnectionWhere>>;
  NOT?: InputMaybe<TeachingTopicOwnerConnectionWhere>;
  OR?: InputMaybe<Array<TeachingTopicOwnerConnectionWhere>>;
  node?: InputMaybe<ProfileWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ProfileWhere>;
};

export type TeachingTopicOwnerCreateFieldInput = {
  node: ProfileCreateInput;
};

export type TeachingTopicOwnerDeleteFieldInput = {
  delete?: InputMaybe<ProfileDeleteInput>;
  where?: InputMaybe<TeachingTopicOwnerConnectionWhere>;
};

export type TeachingTopicOwnerDisconnectFieldInput = {
  disconnect?: InputMaybe<ProfileDisconnectInput>;
  where?: InputMaybe<TeachingTopicOwnerConnectionWhere>;
};

export type TeachingTopicOwnerFieldInput = {
  connect?: InputMaybe<TeachingTopicOwnerConnectFieldInput>;
  connectOrCreate?: InputMaybe<TeachingTopicOwnerConnectOrCreateFieldInput>;
  create?: InputMaybe<TeachingTopicOwnerCreateFieldInput>;
};

export type TeachingTopicOwnerNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TeachingTopicOwnerNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TeachingTopicOwnerNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TeachingTopicOwnerNodeAggregationWhereInput>>;
  address1_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address1_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address2_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address2_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address3_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address3_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  birthday_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  userUuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  userUuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TeachingTopicOwnerRelationship = {
  __typename?: 'TeachingTopicOwnerRelationship';
  cursor: Scalars['String']['output'];
  node: Profile;
};

export type TeachingTopicOwnerUpdateConnectionInput = {
  node?: InputMaybe<ProfileUpdateInput>;
};

export type TeachingTopicOwnerUpdateFieldInput = {
  connect?: InputMaybe<TeachingTopicOwnerConnectFieldInput>;
  connectOrCreate?: InputMaybe<TeachingTopicOwnerConnectOrCreateFieldInput>;
  create?: InputMaybe<TeachingTopicOwnerCreateFieldInput>;
  delete?: InputMaybe<TeachingTopicOwnerDeleteFieldInput>;
  disconnect?: InputMaybe<TeachingTopicOwnerDisconnectFieldInput>;
  update?: InputMaybe<TeachingTopicOwnerUpdateConnectionInput>;
  where?: InputMaybe<TeachingTopicOwnerConnectionWhere>;
};

export type TeachingTopicProfileOwnerAggregationSelection = {
  __typename?: 'TeachingTopicProfileOwnerAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TeachingTopicProfileOwnerNodeAggregateSelection>;
};

export type TeachingTopicProfileOwnerNodeAggregateSelection = {
  __typename?: 'TeachingTopicProfileOwnerNodeAggregateSelection';
  address1: StringAggregateSelection;
  address2: StringAggregateSelection;
  address3: StringAggregateSelection;
  birthday: StringAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  email: StringAggregateSelection;
  firstName: StringAggregateSelection;
  firstNames: StringAggregateSelection;
  lastName: StringAggregateSelection;
  managedBy: StringAggregateSelection;
  matrixToken: StringAggregateSelection;
  nextcloudUserId: StringAggregateSelection;
  prefixName: StringAggregateSelection;
  salutation: StringAggregateSelection;
  shortName: StringAggregateSelection;
  threemaId: StringAggregateSelection;
  title: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  userUuid: StringAggregateSelection;
  uuid: IdAggregateSelection;
  zoomUserId: StringAggregateSelection;
};

/** Fields to sort TeachingTopics by. The order in which sorts are applied is not guaranteed when specifying many fields in one TeachingTopicSort object. */
export type TeachingTopicSort = {
  title?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type TeachingTopicTeachingTopicTopicChildsAggregationSelection = {
  __typename?: 'TeachingTopicTeachingTopicTopicChildsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<TeachingTopicTeachingTopicTopicChildsEdgeAggregateSelection>;
  node?: Maybe<TeachingTopicTeachingTopicTopicChildsNodeAggregateSelection>;
};

export type TeachingTopicTeachingTopicTopicChildsEdgeAggregateSelection = {
  __typename?: 'TeachingTopicTeachingTopicTopicChildsEdgeAggregateSelection';
  order: IntAggregateSelection;
};

export type TeachingTopicTeachingTopicTopicChildsNodeAggregateSelection = {
  __typename?: 'TeachingTopicTeachingTopicTopicChildsNodeAggregateSelection';
  title: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type TeachingTopicTeachingTopicTopicParentAggregationSelection = {
  __typename?: 'TeachingTopicTeachingTopicTopicParentAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TeachingTopicTeachingTopicTopicParentNodeAggregateSelection>;
};

export type TeachingTopicTeachingTopicTopicParentNodeAggregateSelection = {
  __typename?: 'TeachingTopicTeachingTopicTopicParentNodeAggregateSelection';
  title: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type TeachingTopicTeachingUnitTeachingUnitsAggregationSelection = {
  __typename?: 'TeachingTopicTeachingUnitTeachingUnitsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<TeachingTopicTeachingUnitTeachingUnitsEdgeAggregateSelection>;
  node?: Maybe<TeachingTopicTeachingUnitTeachingUnitsNodeAggregateSelection>;
};

export type TeachingTopicTeachingUnitTeachingUnitsEdgeAggregateSelection = {
  __typename?: 'TeachingTopicTeachingUnitTeachingUnitsEdgeAggregateSelection';
  order: IntAggregateSelection;
};

export type TeachingTopicTeachingUnitTeachingUnitsNodeAggregateSelection = {
  __typename?: 'TeachingTopicTeachingUnitTeachingUnitsNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  descriptionMediaType: StringAggregateSelection;
  sortIndex: IntAggregateSelection;
  title: StringAggregateSelection;
  updated: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type TeachingTopicTeachingUnitsAggregateInput = {
  AND?: InputMaybe<Array<TeachingTopicTeachingUnitsAggregateInput>>;
  NOT?: InputMaybe<TeachingTopicTeachingUnitsAggregateInput>;
  OR?: InputMaybe<Array<TeachingTopicTeachingUnitsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<OrderedRelationPropertiesAggregationWhereInput>;
  node?: InputMaybe<TeachingTopicTeachingUnitsNodeAggregationWhereInput>;
};

export type TeachingTopicTeachingUnitsConnectFieldInput = {
  connect?: InputMaybe<Array<TeachingUnitConnectInput>>;
  edge: OrderedRelationPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TeachingUnitConnectWhere>;
};

export type TeachingTopicTeachingUnitsConnection = {
  __typename?: 'TeachingTopicTeachingUnitsConnection';
  edges: Array<TeachingTopicTeachingUnitsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingTopicTeachingUnitsConnectionSort = {
  edge?: InputMaybe<OrderedRelationPropertiesSort>;
  node?: InputMaybe<TeachingUnitSort>;
};

export type TeachingTopicTeachingUnitsConnectionWhere = {
  AND?: InputMaybe<Array<TeachingTopicTeachingUnitsConnectionWhere>>;
  NOT?: InputMaybe<TeachingTopicTeachingUnitsConnectionWhere>;
  OR?: InputMaybe<Array<TeachingTopicTeachingUnitsConnectionWhere>>;
  edge?: InputMaybe<OrderedRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<OrderedRelationPropertiesWhere>;
  node?: InputMaybe<TeachingUnitWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TeachingUnitWhere>;
};

export type TeachingTopicTeachingUnitsCreateFieldInput = {
  edge: OrderedRelationPropertiesCreateInput;
  node: TeachingUnitCreateInput;
};

export type TeachingTopicTeachingUnitsDeleteFieldInput = {
  delete?: InputMaybe<TeachingUnitDeleteInput>;
  where?: InputMaybe<TeachingTopicTeachingUnitsConnectionWhere>;
};

export type TeachingTopicTeachingUnitsDisconnectFieldInput = {
  disconnect?: InputMaybe<TeachingUnitDisconnectInput>;
  where?: InputMaybe<TeachingTopicTeachingUnitsConnectionWhere>;
};

export type TeachingTopicTeachingUnitsFieldInput = {
  connect?: InputMaybe<Array<TeachingTopicTeachingUnitsConnectFieldInput>>;
  create?: InputMaybe<Array<TeachingTopicTeachingUnitsCreateFieldInput>>;
};

export type TeachingTopicTeachingUnitsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TeachingTopicTeachingUnitsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TeachingTopicTeachingUnitsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TeachingTopicTeachingUnitsNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  descriptionMediaType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionMediaType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionMediaType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionMediaType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionMediaType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionMediaType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionMediaType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionMediaType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionMediaType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionMediaType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionMediaType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionMediaType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionMediaType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionMediaType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionMediaType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sortIndex_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sortIndex_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sortIndex_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sortIndex_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  sortIndex_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeachingTopicTeachingUnitsRelationship = {
  __typename?: 'TeachingTopicTeachingUnitsRelationship';
  cursor: Scalars['String']['output'];
  node: TeachingUnit;
  properties: OrderedRelationProperties;
};

export type TeachingTopicTeachingUnitsUpdateConnectionInput = {
  edge?: InputMaybe<OrderedRelationPropertiesUpdateInput>;
  node?: InputMaybe<TeachingUnitUpdateInput>;
};

export type TeachingTopicTeachingUnitsUpdateFieldInput = {
  connect?: InputMaybe<Array<TeachingTopicTeachingUnitsConnectFieldInput>>;
  create?: InputMaybe<Array<TeachingTopicTeachingUnitsCreateFieldInput>>;
  delete?: InputMaybe<Array<TeachingTopicTeachingUnitsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TeachingTopicTeachingUnitsDisconnectFieldInput>>;
  update?: InputMaybe<TeachingTopicTeachingUnitsUpdateConnectionInput>;
  where?: InputMaybe<TeachingTopicTeachingUnitsConnectionWhere>;
};

export type TeachingTopicTopicChildsAggregateInput = {
  AND?: InputMaybe<Array<TeachingTopicTopicChildsAggregateInput>>;
  NOT?: InputMaybe<TeachingTopicTopicChildsAggregateInput>;
  OR?: InputMaybe<Array<TeachingTopicTopicChildsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<OrderedRelationPropertiesAggregationWhereInput>;
  node?: InputMaybe<TeachingTopicTopicChildsNodeAggregationWhereInput>;
};

export type TeachingTopicTopicChildsConnectFieldInput = {
  connect?: InputMaybe<Array<TeachingTopicConnectInput>>;
  edge: OrderedRelationPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TeachingTopicConnectWhere>;
};

export type TeachingTopicTopicChildsConnection = {
  __typename?: 'TeachingTopicTopicChildsConnection';
  edges: Array<TeachingTopicTopicChildsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingTopicTopicChildsConnectionSort = {
  edge?: InputMaybe<OrderedRelationPropertiesSort>;
  node?: InputMaybe<TeachingTopicSort>;
};

export type TeachingTopicTopicChildsConnectionWhere = {
  AND?: InputMaybe<Array<TeachingTopicTopicChildsConnectionWhere>>;
  NOT?: InputMaybe<TeachingTopicTopicChildsConnectionWhere>;
  OR?: InputMaybe<Array<TeachingTopicTopicChildsConnectionWhere>>;
  edge?: InputMaybe<OrderedRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<OrderedRelationPropertiesWhere>;
  node?: InputMaybe<TeachingTopicWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TeachingTopicWhere>;
};

export type TeachingTopicTopicChildsCreateFieldInput = {
  edge: OrderedRelationPropertiesCreateInput;
  node: TeachingTopicCreateInput;
};

export type TeachingTopicTopicChildsDeleteFieldInput = {
  delete?: InputMaybe<TeachingTopicDeleteInput>;
  where?: InputMaybe<TeachingTopicTopicChildsConnectionWhere>;
};

export type TeachingTopicTopicChildsDisconnectFieldInput = {
  disconnect?: InputMaybe<TeachingTopicDisconnectInput>;
  where?: InputMaybe<TeachingTopicTopicChildsConnectionWhere>;
};

export type TeachingTopicTopicChildsFieldInput = {
  connect?: InputMaybe<Array<TeachingTopicTopicChildsConnectFieldInput>>;
  create?: InputMaybe<Array<TeachingTopicTopicChildsCreateFieldInput>>;
};

export type TeachingTopicTopicChildsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TeachingTopicTopicChildsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TeachingTopicTopicChildsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TeachingTopicTopicChildsNodeAggregationWhereInput>>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TeachingTopicTopicChildsRelationship = {
  __typename?: 'TeachingTopicTopicChildsRelationship';
  cursor: Scalars['String']['output'];
  node: TeachingTopic;
  properties: OrderedRelationProperties;
};

export type TeachingTopicTopicChildsUpdateConnectionInput = {
  edge?: InputMaybe<OrderedRelationPropertiesUpdateInput>;
  node?: InputMaybe<TeachingTopicUpdateInput>;
};

export type TeachingTopicTopicChildsUpdateFieldInput = {
  connect?: InputMaybe<Array<TeachingTopicTopicChildsConnectFieldInput>>;
  create?: InputMaybe<Array<TeachingTopicTopicChildsCreateFieldInput>>;
  delete?: InputMaybe<Array<TeachingTopicTopicChildsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TeachingTopicTopicChildsDisconnectFieldInput>>;
  update?: InputMaybe<TeachingTopicTopicChildsUpdateConnectionInput>;
  where?: InputMaybe<TeachingTopicTopicChildsConnectionWhere>;
};

export type TeachingTopicTopicParentAggregateInput = {
  AND?: InputMaybe<Array<TeachingTopicTopicParentAggregateInput>>;
  NOT?: InputMaybe<TeachingTopicTopicParentAggregateInput>;
  OR?: InputMaybe<Array<TeachingTopicTopicParentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TeachingTopicTopicParentNodeAggregationWhereInput>;
};

export type TeachingTopicTopicParentConnectFieldInput = {
  connect?: InputMaybe<TeachingTopicConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TeachingTopicConnectWhere>;
};

export type TeachingTopicTopicParentConnection = {
  __typename?: 'TeachingTopicTopicParentConnection';
  edges: Array<TeachingTopicTopicParentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingTopicTopicParentConnectionSort = {
  node?: InputMaybe<TeachingTopicSort>;
};

export type TeachingTopicTopicParentConnectionWhere = {
  AND?: InputMaybe<Array<TeachingTopicTopicParentConnectionWhere>>;
  NOT?: InputMaybe<TeachingTopicTopicParentConnectionWhere>;
  OR?: InputMaybe<Array<TeachingTopicTopicParentConnectionWhere>>;
  node?: InputMaybe<TeachingTopicWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TeachingTopicWhere>;
};

export type TeachingTopicTopicParentCreateFieldInput = {
  node: TeachingTopicCreateInput;
};

export type TeachingTopicTopicParentDeleteFieldInput = {
  delete?: InputMaybe<TeachingTopicDeleteInput>;
  where?: InputMaybe<TeachingTopicTopicParentConnectionWhere>;
};

export type TeachingTopicTopicParentDisconnectFieldInput = {
  disconnect?: InputMaybe<TeachingTopicDisconnectInput>;
  where?: InputMaybe<TeachingTopicTopicParentConnectionWhere>;
};

export type TeachingTopicTopicParentFieldInput = {
  connect?: InputMaybe<TeachingTopicTopicParentConnectFieldInput>;
  create?: InputMaybe<TeachingTopicTopicParentCreateFieldInput>;
};

export type TeachingTopicTopicParentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TeachingTopicTopicParentNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TeachingTopicTopicParentNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TeachingTopicTopicParentNodeAggregationWhereInput>>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TeachingTopicTopicParentRelationship = {
  __typename?: 'TeachingTopicTopicParentRelationship';
  cursor: Scalars['String']['output'];
  node: TeachingTopic;
};

export type TeachingTopicTopicParentUpdateConnectionInput = {
  node?: InputMaybe<TeachingTopicUpdateInput>;
};

export type TeachingTopicTopicParentUpdateFieldInput = {
  connect?: InputMaybe<TeachingTopicTopicParentConnectFieldInput>;
  create?: InputMaybe<TeachingTopicTopicParentCreateFieldInput>;
  delete?: InputMaybe<TeachingTopicTopicParentDeleteFieldInput>;
  disconnect?: InputMaybe<TeachingTopicTopicParentDisconnectFieldInput>;
  update?: InputMaybe<TeachingTopicTopicParentUpdateConnectionInput>;
  where?: InputMaybe<TeachingTopicTopicParentConnectionWhere>;
};

export type TeachingTopicUpdateInput = {
  group?: InputMaybe<TeachingTopicGroupUpdateFieldInput>;
  organization?: InputMaybe<TeachingTopicOrganizationUpdateFieldInput>;
  owner?: InputMaybe<TeachingTopicOwnerUpdateFieldInput>;
  teachingUnits?: InputMaybe<Array<TeachingTopicTeachingUnitsUpdateFieldInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
  topicChilds?: InputMaybe<Array<TeachingTopicTopicChildsUpdateFieldInput>>;
  topicParent?: InputMaybe<TeachingTopicTopicParentUpdateFieldInput>;
};

export type TeachingTopicWhere = {
  AND?: InputMaybe<Array<TeachingTopicWhere>>;
  NOT?: InputMaybe<TeachingTopicWhere>;
  OR?: InputMaybe<Array<TeachingTopicWhere>>;
  group?: InputMaybe<GroupWhere>;
  groupAggregate?: InputMaybe<TeachingTopicGroupAggregateInput>;
  groupConnection?: InputMaybe<TeachingTopicGroupConnectionWhere>;
  groupConnection_NOT?: InputMaybe<TeachingTopicGroupConnectionWhere>;
  group_NOT?: InputMaybe<GroupWhere>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<TeachingTopicOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<TeachingTopicOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<TeachingTopicOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  owner?: InputMaybe<ProfileWhere>;
  ownerAggregate?: InputMaybe<TeachingTopicOwnerAggregateInput>;
  ownerConnection?: InputMaybe<TeachingTopicOwnerConnectionWhere>;
  ownerConnection_NOT?: InputMaybe<TeachingTopicOwnerConnectionWhere>;
  owner_NOT?: InputMaybe<ProfileWhere>;
  /** @deprecated Use `teachingUnits_SOME` instead. */
  teachingUnits?: InputMaybe<TeachingUnitWhere>;
  teachingUnitsAggregate?: InputMaybe<TeachingTopicTeachingUnitsAggregateInput>;
  /** @deprecated Use `teachingUnitsConnection_SOME` instead. */
  teachingUnitsConnection?: InputMaybe<TeachingTopicTeachingUnitsConnectionWhere>;
  /** Return TeachingTopics where all of the related TeachingTopicTeachingUnitsConnections match this filter */
  teachingUnitsConnection_ALL?: InputMaybe<TeachingTopicTeachingUnitsConnectionWhere>;
  /** Return TeachingTopics where none of the related TeachingTopicTeachingUnitsConnections match this filter */
  teachingUnitsConnection_NONE?: InputMaybe<TeachingTopicTeachingUnitsConnectionWhere>;
  /** @deprecated Use `teachingUnitsConnection_NONE` instead. */
  teachingUnitsConnection_NOT?: InputMaybe<TeachingTopicTeachingUnitsConnectionWhere>;
  /** Return TeachingTopics where one of the related TeachingTopicTeachingUnitsConnections match this filter */
  teachingUnitsConnection_SINGLE?: InputMaybe<TeachingTopicTeachingUnitsConnectionWhere>;
  /** Return TeachingTopics where some of the related TeachingTopicTeachingUnitsConnections match this filter */
  teachingUnitsConnection_SOME?: InputMaybe<TeachingTopicTeachingUnitsConnectionWhere>;
  /** Return TeachingTopics where all of the related TeachingUnits match this filter */
  teachingUnits_ALL?: InputMaybe<TeachingUnitWhere>;
  /** Return TeachingTopics where none of the related TeachingUnits match this filter */
  teachingUnits_NONE?: InputMaybe<TeachingUnitWhere>;
  /** @deprecated Use `teachingUnits_NONE` instead. */
  teachingUnits_NOT?: InputMaybe<TeachingUnitWhere>;
  /** Return TeachingTopics where one of the related TeachingUnits match this filter */
  teachingUnits_SINGLE?: InputMaybe<TeachingUnitWhere>;
  /** Return TeachingTopics where some of the related TeachingUnits match this filter */
  teachingUnits_SOME?: InputMaybe<TeachingUnitWhere>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `topicChilds_SOME` instead. */
  topicChilds?: InputMaybe<TeachingTopicWhere>;
  topicChildsAggregate?: InputMaybe<TeachingTopicTopicChildsAggregateInput>;
  /** @deprecated Use `topicChildsConnection_SOME` instead. */
  topicChildsConnection?: InputMaybe<TeachingTopicTopicChildsConnectionWhere>;
  /** Return TeachingTopics where all of the related TeachingTopicTopicChildsConnections match this filter */
  topicChildsConnection_ALL?: InputMaybe<TeachingTopicTopicChildsConnectionWhere>;
  /** Return TeachingTopics where none of the related TeachingTopicTopicChildsConnections match this filter */
  topicChildsConnection_NONE?: InputMaybe<TeachingTopicTopicChildsConnectionWhere>;
  /** @deprecated Use `topicChildsConnection_NONE` instead. */
  topicChildsConnection_NOT?: InputMaybe<TeachingTopicTopicChildsConnectionWhere>;
  /** Return TeachingTopics where one of the related TeachingTopicTopicChildsConnections match this filter */
  topicChildsConnection_SINGLE?: InputMaybe<TeachingTopicTopicChildsConnectionWhere>;
  /** Return TeachingTopics where some of the related TeachingTopicTopicChildsConnections match this filter */
  topicChildsConnection_SOME?: InputMaybe<TeachingTopicTopicChildsConnectionWhere>;
  /** Return TeachingTopics where all of the related TeachingTopics match this filter */
  topicChilds_ALL?: InputMaybe<TeachingTopicWhere>;
  /** Return TeachingTopics where none of the related TeachingTopics match this filter */
  topicChilds_NONE?: InputMaybe<TeachingTopicWhere>;
  /** @deprecated Use `topicChilds_NONE` instead. */
  topicChilds_NOT?: InputMaybe<TeachingTopicWhere>;
  /** Return TeachingTopics where one of the related TeachingTopics match this filter */
  topicChilds_SINGLE?: InputMaybe<TeachingTopicWhere>;
  /** Return TeachingTopics where some of the related TeachingTopics match this filter */
  topicChilds_SOME?: InputMaybe<TeachingTopicWhere>;
  topicParent?: InputMaybe<TeachingTopicWhere>;
  topicParentAggregate?: InputMaybe<TeachingTopicTopicParentAggregateInput>;
  topicParentConnection?: InputMaybe<TeachingTopicTopicParentConnectionWhere>;
  topicParentConnection_NOT?: InputMaybe<TeachingTopicTopicParentConnectionWhere>;
  topicParent_NOT?: InputMaybe<TeachingTopicWhere>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type TeachingTopicsConnection = {
  __typename?: 'TeachingTopicsConnection';
  edges: Array<TeachingTopicEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingUnit = {
  __typename?: 'TeachingUnit';
  active: Scalars['Boolean']['output'];
  assignments: Array<Assignment>;
  assignmentsAggregate?: Maybe<TeachingUnitAssignmentAssignmentsAggregationSelection>;
  assignmentsConnection: TeachingUnitAssignmentsConnection;
  created: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionMediaType: Scalars['String']['output'];
  group: Group;
  groupAggregate?: Maybe<TeachingUnitGroupGroupAggregationSelection>;
  groupConnection: TeachingUnitGroupConnection;
  note?: Maybe<Material>;
  noteAggregate?: Maybe<TeachingUnitMaterialNoteAggregationSelection>;
  noteConnection: TeachingUnitNoteConnection;
  organization: Organization;
  organizationAggregate?: Maybe<TeachingUnitOrganizationOrganizationAggregationSelection>;
  organizationConnection: TeachingUnitOrganizationConnection;
  owner: Profile;
  ownerAggregate?: Maybe<TeachingUnitProfileOwnerAggregationSelection>;
  ownerConnection: TeachingUnitOwnerConnection;
  sortIndex?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  topic: TeachingTopic;
  topicAggregate?: Maybe<TeachingUnitTeachingTopicTopicAggregationSelection>;
  topicConnection: TeachingUnitTopicConnection;
  updated: Scalars['DateTime']['output'];
  uuid: Scalars['ID']['output'];
  workMaterials: Array<WorkMaterial>;
  workMaterialsAggregate?: Maybe<TeachingUnitWorkMaterialWorkMaterialsAggregationSelection>;
  workMaterialsConnection: TeachingUnitWorkMaterialsConnection;
};

export type TeachingUnitAssignmentsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AssignmentOptions>;
  where?: InputMaybe<AssignmentWhere>;
};

export type TeachingUnitAssignmentsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssignmentWhere>;
};

export type TeachingUnitAssignmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TeachingUnitAssignmentsConnectionSort>>;
  where?: InputMaybe<TeachingUnitAssignmentsConnectionWhere>;
};

export type TeachingUnitGroupArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<GroupOptions>;
  where?: InputMaybe<GroupWhere>;
};

export type TeachingUnitGroupAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GroupWhere>;
};

export type TeachingUnitGroupConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TeachingUnitGroupConnectionSort>>;
  where?: InputMaybe<TeachingUnitGroupConnectionWhere>;
};

export type TeachingUnitNoteArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<MaterialOptions>;
  where?: InputMaybe<MaterialWhere>;
};

export type TeachingUnitNoteAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MaterialWhere>;
};

export type TeachingUnitNoteConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TeachingUnitNoteConnectionSort>>;
  where?: InputMaybe<TeachingUnitNoteConnectionWhere>;
};

export type TeachingUnitOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type TeachingUnitOrganizationAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OrganizationWhere>;
};

export type TeachingUnitOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TeachingUnitOrganizationConnectionSort>>;
  where?: InputMaybe<TeachingUnitOrganizationConnectionWhere>;
};

export type TeachingUnitOwnerArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ProfileOptions>;
  where?: InputMaybe<ProfileWhere>;
};

export type TeachingUnitOwnerAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProfileWhere>;
};

export type TeachingUnitOwnerConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TeachingUnitOwnerConnectionSort>>;
  where?: InputMaybe<TeachingUnitOwnerConnectionWhere>;
};

export type TeachingUnitTopicArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TeachingTopicOptions>;
  where?: InputMaybe<TeachingTopicWhere>;
};

export type TeachingUnitTopicAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TeachingTopicWhere>;
};

export type TeachingUnitTopicConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TeachingUnitTopicConnectionSort>>;
  where?: InputMaybe<TeachingUnitTopicConnectionWhere>;
};

export type TeachingUnitWorkMaterialsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<WorkMaterialOptions>;
  where?: InputMaybe<WorkMaterialWhere>;
};

export type TeachingUnitWorkMaterialsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WorkMaterialWhere>;
};

export type TeachingUnitWorkMaterialsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TeachingUnitWorkMaterialsConnectionSort>>;
  where?: InputMaybe<TeachingUnitWorkMaterialsConnectionWhere>;
};

export type TeachingUnitAggregateSelection = {
  __typename?: 'TeachingUnitAggregateSelection';
  count: Scalars['Int']['output'];
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  descriptionMediaType: StringAggregateSelection;
  sortIndex: IntAggregateSelection;
  title: StringAggregateSelection;
  updated: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type TeachingUnitAssignmentAssignmentsAggregationSelection = {
  __typename?: 'TeachingUnitAssignmentAssignmentsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TeachingUnitAssignmentAssignmentsNodeAggregateSelection>;
};

export type TeachingUnitAssignmentAssignmentsNodeAggregateSelection = {
  __typename?: 'TeachingUnitAssignmentAssignmentsNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  title: StringAggregateSelection;
  updated: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type TeachingUnitAssignmentsAggregateInput = {
  AND?: InputMaybe<Array<TeachingUnitAssignmentsAggregateInput>>;
  NOT?: InputMaybe<TeachingUnitAssignmentsAggregateInput>;
  OR?: InputMaybe<Array<TeachingUnitAssignmentsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TeachingUnitAssignmentsNodeAggregationWhereInput>;
};

export type TeachingUnitAssignmentsConnectFieldInput = {
  connect?: InputMaybe<Array<AssignmentConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AssignmentConnectWhere>;
};

export type TeachingUnitAssignmentsConnection = {
  __typename?: 'TeachingUnitAssignmentsConnection';
  edges: Array<TeachingUnitAssignmentsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingUnitAssignmentsConnectionSort = {
  node?: InputMaybe<AssignmentSort>;
};

export type TeachingUnitAssignmentsConnectionWhere = {
  AND?: InputMaybe<Array<TeachingUnitAssignmentsConnectionWhere>>;
  NOT?: InputMaybe<TeachingUnitAssignmentsConnectionWhere>;
  OR?: InputMaybe<Array<TeachingUnitAssignmentsConnectionWhere>>;
  node?: InputMaybe<AssignmentWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<AssignmentWhere>;
};

export type TeachingUnitAssignmentsCreateFieldInput = {
  node: AssignmentCreateInput;
};

export type TeachingUnitAssignmentsDeleteFieldInput = {
  delete?: InputMaybe<AssignmentDeleteInput>;
  where?: InputMaybe<TeachingUnitAssignmentsConnectionWhere>;
};

export type TeachingUnitAssignmentsDisconnectFieldInput = {
  disconnect?: InputMaybe<AssignmentDisconnectInput>;
  where?: InputMaybe<TeachingUnitAssignmentsConnectionWhere>;
};

export type TeachingUnitAssignmentsFieldInput = {
  connect?: InputMaybe<Array<TeachingUnitAssignmentsConnectFieldInput>>;
  create?: InputMaybe<Array<TeachingUnitAssignmentsCreateFieldInput>>;
};

export type TeachingUnitAssignmentsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TeachingUnitAssignmentsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TeachingUnitAssignmentsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TeachingUnitAssignmentsNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeachingUnitAssignmentsRelationship = {
  __typename?: 'TeachingUnitAssignmentsRelationship';
  cursor: Scalars['String']['output'];
  node: Assignment;
};

export type TeachingUnitAssignmentsUpdateConnectionInput = {
  node?: InputMaybe<AssignmentUpdateInput>;
};

export type TeachingUnitAssignmentsUpdateFieldInput = {
  connect?: InputMaybe<Array<TeachingUnitAssignmentsConnectFieldInput>>;
  create?: InputMaybe<Array<TeachingUnitAssignmentsCreateFieldInput>>;
  delete?: InputMaybe<Array<TeachingUnitAssignmentsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TeachingUnitAssignmentsDisconnectFieldInput>>;
  update?: InputMaybe<TeachingUnitAssignmentsUpdateConnectionInput>;
  where?: InputMaybe<TeachingUnitAssignmentsConnectionWhere>;
};

export type TeachingUnitConnectInput = {
  assignments?: InputMaybe<Array<TeachingUnitAssignmentsConnectFieldInput>>;
  group?: InputMaybe<TeachingUnitGroupConnectFieldInput>;
  note?: InputMaybe<TeachingUnitNoteConnectFieldInput>;
  organization?: InputMaybe<TeachingUnitOrganizationConnectFieldInput>;
  owner?: InputMaybe<TeachingUnitOwnerConnectFieldInput>;
  topic?: InputMaybe<TeachingUnitTopicConnectFieldInput>;
  workMaterials?: InputMaybe<Array<TeachingUnitWorkMaterialsConnectFieldInput>>;
};

export type TeachingUnitConnectWhere = {
  node: TeachingUnitWhere;
};

export type TeachingUnitCreateInput = {
  active: Scalars['Boolean']['input'];
  assignments?: InputMaybe<TeachingUnitAssignmentsFieldInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionMediaType?: Scalars['String']['input'];
  group?: InputMaybe<TeachingUnitGroupFieldInput>;
  note?: InputMaybe<TeachingUnitNoteFieldInput>;
  organization?: InputMaybe<TeachingUnitOrganizationFieldInput>;
  owner?: InputMaybe<TeachingUnitOwnerFieldInput>;
  sortIndex?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
  topic?: InputMaybe<TeachingUnitTopicFieldInput>;
  workMaterials?: InputMaybe<TeachingUnitWorkMaterialsFieldInput>;
};

export type TeachingUnitDeleteInput = {
  assignments?: InputMaybe<Array<TeachingUnitAssignmentsDeleteFieldInput>>;
  group?: InputMaybe<TeachingUnitGroupDeleteFieldInput>;
  note?: InputMaybe<TeachingUnitNoteDeleteFieldInput>;
  organization?: InputMaybe<TeachingUnitOrganizationDeleteFieldInput>;
  owner?: InputMaybe<TeachingUnitOwnerDeleteFieldInput>;
  topic?: InputMaybe<TeachingUnitTopicDeleteFieldInput>;
  workMaterials?: InputMaybe<Array<TeachingUnitWorkMaterialsDeleteFieldInput>>;
};

export type TeachingUnitDisconnectInput = {
  assignments?: InputMaybe<Array<TeachingUnitAssignmentsDisconnectFieldInput>>;
  group?: InputMaybe<TeachingUnitGroupDisconnectFieldInput>;
  note?: InputMaybe<TeachingUnitNoteDisconnectFieldInput>;
  organization?: InputMaybe<TeachingUnitOrganizationDisconnectFieldInput>;
  owner?: InputMaybe<TeachingUnitOwnerDisconnectFieldInput>;
  topic?: InputMaybe<TeachingUnitTopicDisconnectFieldInput>;
  workMaterials?: InputMaybe<Array<TeachingUnitWorkMaterialsDisconnectFieldInput>>;
};

export type TeachingUnitEdge = {
  __typename?: 'TeachingUnitEdge';
  cursor: Scalars['String']['output'];
  node: TeachingUnit;
};

export type TeachingUnitGroupAggregateInput = {
  AND?: InputMaybe<Array<TeachingUnitGroupAggregateInput>>;
  NOT?: InputMaybe<TeachingUnitGroupAggregateInput>;
  OR?: InputMaybe<Array<TeachingUnitGroupAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TeachingUnitGroupNodeAggregationWhereInput>;
};

export type TeachingUnitGroupConnectFieldInput = {
  connect?: InputMaybe<GroupConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<GroupConnectWhere>;
};

export type TeachingUnitGroupConnectOrCreateFieldInput = {
  onCreate: TeachingUnitGroupConnectOrCreateFieldInputOnCreate;
  where: GroupConnectOrCreateWhere;
};

export type TeachingUnitGroupConnectOrCreateFieldInputOnCreate = {
  node: GroupOnCreateInput;
};

export type TeachingUnitGroupConnection = {
  __typename?: 'TeachingUnitGroupConnection';
  edges: Array<TeachingUnitGroupRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingUnitGroupConnectionSort = {
  node?: InputMaybe<GroupSort>;
};

export type TeachingUnitGroupConnectionWhere = {
  AND?: InputMaybe<Array<TeachingUnitGroupConnectionWhere>>;
  NOT?: InputMaybe<TeachingUnitGroupConnectionWhere>;
  OR?: InputMaybe<Array<TeachingUnitGroupConnectionWhere>>;
  node?: InputMaybe<GroupWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<GroupWhere>;
};

export type TeachingUnitGroupCreateFieldInput = {
  node: GroupCreateInput;
};

export type TeachingUnitGroupDeleteFieldInput = {
  delete?: InputMaybe<GroupDeleteInput>;
  where?: InputMaybe<TeachingUnitGroupConnectionWhere>;
};

export type TeachingUnitGroupDisconnectFieldInput = {
  disconnect?: InputMaybe<GroupDisconnectInput>;
  where?: InputMaybe<TeachingUnitGroupConnectionWhere>;
};

export type TeachingUnitGroupFieldInput = {
  connect?: InputMaybe<TeachingUnitGroupConnectFieldInput>;
  connectOrCreate?: InputMaybe<TeachingUnitGroupConnectOrCreateFieldInput>;
  create?: InputMaybe<TeachingUnitGroupCreateFieldInput>;
};

export type TeachingUnitGroupGroupAggregationSelection = {
  __typename?: 'TeachingUnitGroupGroupAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TeachingUnitGroupGroupNodeAggregateSelection>;
};

export type TeachingUnitGroupGroupNodeAggregateSelection = {
  __typename?: 'TeachingUnitGroupGroupNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  managedBy: StringAggregateSelection;
  matrixRoomId: StringAggregateSelection;
  name: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type TeachingUnitGroupNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TeachingUnitGroupNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TeachingUnitGroupNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TeachingUnitGroupNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeachingUnitGroupRelationship = {
  __typename?: 'TeachingUnitGroupRelationship';
  cursor: Scalars['String']['output'];
  node: Group;
};

export type TeachingUnitGroupUpdateConnectionInput = {
  node?: InputMaybe<GroupUpdateInput>;
};

export type TeachingUnitGroupUpdateFieldInput = {
  connect?: InputMaybe<TeachingUnitGroupConnectFieldInput>;
  connectOrCreate?: InputMaybe<TeachingUnitGroupConnectOrCreateFieldInput>;
  create?: InputMaybe<TeachingUnitGroupCreateFieldInput>;
  delete?: InputMaybe<TeachingUnitGroupDeleteFieldInput>;
  disconnect?: InputMaybe<TeachingUnitGroupDisconnectFieldInput>;
  update?: InputMaybe<TeachingUnitGroupUpdateConnectionInput>;
  where?: InputMaybe<TeachingUnitGroupConnectionWhere>;
};

export type TeachingUnitMaterialNoteAggregationSelection = {
  __typename?: 'TeachingUnitMaterialNoteAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TeachingUnitMaterialNoteNodeAggregateSelection>;
};

export type TeachingUnitMaterialNoteNodeAggregateSelection = {
  __typename?: 'TeachingUnitMaterialNoteNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  text: StringAggregateSelection;
  textMediaType: StringAggregateSelection;
  updated: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type TeachingUnitNoteAggregateInput = {
  AND?: InputMaybe<Array<TeachingUnitNoteAggregateInput>>;
  NOT?: InputMaybe<TeachingUnitNoteAggregateInput>;
  OR?: InputMaybe<Array<TeachingUnitNoteAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TeachingUnitNoteNodeAggregationWhereInput>;
};

export type TeachingUnitNoteConnectFieldInput = {
  connect?: InputMaybe<MaterialConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<MaterialConnectWhere>;
};

export type TeachingUnitNoteConnection = {
  __typename?: 'TeachingUnitNoteConnection';
  edges: Array<TeachingUnitNoteRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingUnitNoteConnectionSort = {
  node?: InputMaybe<MaterialSort>;
};

export type TeachingUnitNoteConnectionWhere = {
  AND?: InputMaybe<Array<TeachingUnitNoteConnectionWhere>>;
  NOT?: InputMaybe<TeachingUnitNoteConnectionWhere>;
  OR?: InputMaybe<Array<TeachingUnitNoteConnectionWhere>>;
  node?: InputMaybe<MaterialWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<MaterialWhere>;
};

export type TeachingUnitNoteCreateFieldInput = {
  node: MaterialCreateInput;
};

export type TeachingUnitNoteDeleteFieldInput = {
  delete?: InputMaybe<MaterialDeleteInput>;
  where?: InputMaybe<TeachingUnitNoteConnectionWhere>;
};

export type TeachingUnitNoteDisconnectFieldInput = {
  disconnect?: InputMaybe<MaterialDisconnectInput>;
  where?: InputMaybe<TeachingUnitNoteConnectionWhere>;
};

export type TeachingUnitNoteFieldInput = {
  connect?: InputMaybe<TeachingUnitNoteConnectFieldInput>;
  create?: InputMaybe<TeachingUnitNoteCreateFieldInput>;
};

export type TeachingUnitNoteNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TeachingUnitNoteNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TeachingUnitNoteNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TeachingUnitNoteNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  textMediaType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  textMediaType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  textMediaType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  textMediaType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  textMediaType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  textMediaType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  textMediaType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  textMediaType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  textMediaType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  textMediaType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  textMediaType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  textMediaType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  textMediaType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  textMediaType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  textMediaType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  text_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  text_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeachingUnitNoteRelationship = {
  __typename?: 'TeachingUnitNoteRelationship';
  cursor: Scalars['String']['output'];
  node: Material;
};

export type TeachingUnitNoteUpdateConnectionInput = {
  node?: InputMaybe<MaterialUpdateInput>;
};

export type TeachingUnitNoteUpdateFieldInput = {
  connect?: InputMaybe<TeachingUnitNoteConnectFieldInput>;
  create?: InputMaybe<TeachingUnitNoteCreateFieldInput>;
  delete?: InputMaybe<TeachingUnitNoteDeleteFieldInput>;
  disconnect?: InputMaybe<TeachingUnitNoteDisconnectFieldInput>;
  update?: InputMaybe<TeachingUnitNoteUpdateConnectionInput>;
  where?: InputMaybe<TeachingUnitNoteConnectionWhere>;
};

export type TeachingUnitOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more TeachingUnitSort objects to sort TeachingUnits by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<TeachingUnitSort>>;
};

export type TeachingUnitOrganizationAggregateInput = {
  AND?: InputMaybe<Array<TeachingUnitOrganizationAggregateInput>>;
  NOT?: InputMaybe<TeachingUnitOrganizationAggregateInput>;
  OR?: InputMaybe<Array<TeachingUnitOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TeachingUnitOrganizationNodeAggregationWhereInput>;
};

export type TeachingUnitOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type TeachingUnitOrganizationConnectOrCreateFieldInput = {
  onCreate: TeachingUnitOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type TeachingUnitOrganizationConnectOrCreateFieldInputOnCreate = {
  node: OrganizationOnCreateInput;
};

export type TeachingUnitOrganizationConnection = {
  __typename?: 'TeachingUnitOrganizationConnection';
  edges: Array<TeachingUnitOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingUnitOrganizationConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type TeachingUnitOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<TeachingUnitOrganizationConnectionWhere>>;
  NOT?: InputMaybe<TeachingUnitOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<TeachingUnitOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type TeachingUnitOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type TeachingUnitOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<TeachingUnitOrganizationConnectionWhere>;
};

export type TeachingUnitOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<TeachingUnitOrganizationConnectionWhere>;
};

export type TeachingUnitOrganizationFieldInput = {
  connect?: InputMaybe<TeachingUnitOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<TeachingUnitOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<TeachingUnitOrganizationCreateFieldInput>;
};

export type TeachingUnitOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TeachingUnitOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TeachingUnitOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TeachingUnitOrganizationNodeAggregationWhereInput>>;
  aboutInfoLastUpdated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TeachingUnitOrganizationOrganizationAggregationSelection = {
  __typename?: 'TeachingUnitOrganizationOrganizationAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TeachingUnitOrganizationOrganizationNodeAggregateSelection>;
};

export type TeachingUnitOrganizationOrganizationNodeAggregateSelection = {
  __typename?: 'TeachingUnitOrganizationOrganizationNodeAggregateSelection';
  aboutInfo: StringAggregateSelection;
  aboutInfoLastUpdated: DateTimeAggregateSelection;
  displayName: StringAggregateSelection;
  matrixRoomId: StringAggregateSelection;
  planungSyncProps: StringAggregateSelection;
  procuratSyncProps: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type TeachingUnitOrganizationRelationship = {
  __typename?: 'TeachingUnitOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type TeachingUnitOrganizationUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type TeachingUnitOrganizationUpdateFieldInput = {
  connect?: InputMaybe<TeachingUnitOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<TeachingUnitOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<TeachingUnitOrganizationCreateFieldInput>;
  delete?: InputMaybe<TeachingUnitOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<TeachingUnitOrganizationDisconnectFieldInput>;
  update?: InputMaybe<TeachingUnitOrganizationUpdateConnectionInput>;
  where?: InputMaybe<TeachingUnitOrganizationConnectionWhere>;
};

export type TeachingUnitOwnerAggregateInput = {
  AND?: InputMaybe<Array<TeachingUnitOwnerAggregateInput>>;
  NOT?: InputMaybe<TeachingUnitOwnerAggregateInput>;
  OR?: InputMaybe<Array<TeachingUnitOwnerAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TeachingUnitOwnerNodeAggregationWhereInput>;
};

export type TeachingUnitOwnerConnectFieldInput = {
  connect?: InputMaybe<ProfileConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ProfileConnectWhere>;
};

export type TeachingUnitOwnerConnectOrCreateFieldInput = {
  onCreate: TeachingUnitOwnerConnectOrCreateFieldInputOnCreate;
  where: ProfileConnectOrCreateWhere;
};

export type TeachingUnitOwnerConnectOrCreateFieldInputOnCreate = {
  node: ProfileOnCreateInput;
};

export type TeachingUnitOwnerConnection = {
  __typename?: 'TeachingUnitOwnerConnection';
  edges: Array<TeachingUnitOwnerRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingUnitOwnerConnectionSort = {
  node?: InputMaybe<ProfileSort>;
};

export type TeachingUnitOwnerConnectionWhere = {
  AND?: InputMaybe<Array<TeachingUnitOwnerConnectionWhere>>;
  NOT?: InputMaybe<TeachingUnitOwnerConnectionWhere>;
  OR?: InputMaybe<Array<TeachingUnitOwnerConnectionWhere>>;
  node?: InputMaybe<ProfileWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ProfileWhere>;
};

export type TeachingUnitOwnerCreateFieldInput = {
  node: ProfileCreateInput;
};

export type TeachingUnitOwnerDeleteFieldInput = {
  delete?: InputMaybe<ProfileDeleteInput>;
  where?: InputMaybe<TeachingUnitOwnerConnectionWhere>;
};

export type TeachingUnitOwnerDisconnectFieldInput = {
  disconnect?: InputMaybe<ProfileDisconnectInput>;
  where?: InputMaybe<TeachingUnitOwnerConnectionWhere>;
};

export type TeachingUnitOwnerFieldInput = {
  connect?: InputMaybe<TeachingUnitOwnerConnectFieldInput>;
  connectOrCreate?: InputMaybe<TeachingUnitOwnerConnectOrCreateFieldInput>;
  create?: InputMaybe<TeachingUnitOwnerCreateFieldInput>;
};

export type TeachingUnitOwnerNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TeachingUnitOwnerNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TeachingUnitOwnerNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TeachingUnitOwnerNodeAggregationWhereInput>>;
  address1_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address1_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address2_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address2_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address3_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address3_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  birthday_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  userUuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  userUuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TeachingUnitOwnerRelationship = {
  __typename?: 'TeachingUnitOwnerRelationship';
  cursor: Scalars['String']['output'];
  node: Profile;
};

export type TeachingUnitOwnerUpdateConnectionInput = {
  node?: InputMaybe<ProfileUpdateInput>;
};

export type TeachingUnitOwnerUpdateFieldInput = {
  connect?: InputMaybe<TeachingUnitOwnerConnectFieldInput>;
  connectOrCreate?: InputMaybe<TeachingUnitOwnerConnectOrCreateFieldInput>;
  create?: InputMaybe<TeachingUnitOwnerCreateFieldInput>;
  delete?: InputMaybe<TeachingUnitOwnerDeleteFieldInput>;
  disconnect?: InputMaybe<TeachingUnitOwnerDisconnectFieldInput>;
  update?: InputMaybe<TeachingUnitOwnerUpdateConnectionInput>;
  where?: InputMaybe<TeachingUnitOwnerConnectionWhere>;
};

export type TeachingUnitProfileOwnerAggregationSelection = {
  __typename?: 'TeachingUnitProfileOwnerAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TeachingUnitProfileOwnerNodeAggregateSelection>;
};

export type TeachingUnitProfileOwnerNodeAggregateSelection = {
  __typename?: 'TeachingUnitProfileOwnerNodeAggregateSelection';
  address1: StringAggregateSelection;
  address2: StringAggregateSelection;
  address3: StringAggregateSelection;
  birthday: StringAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  email: StringAggregateSelection;
  firstName: StringAggregateSelection;
  firstNames: StringAggregateSelection;
  lastName: StringAggregateSelection;
  managedBy: StringAggregateSelection;
  matrixToken: StringAggregateSelection;
  nextcloudUserId: StringAggregateSelection;
  prefixName: StringAggregateSelection;
  salutation: StringAggregateSelection;
  shortName: StringAggregateSelection;
  threemaId: StringAggregateSelection;
  title: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  userUuid: StringAggregateSelection;
  uuid: IdAggregateSelection;
  zoomUserId: StringAggregateSelection;
};

/** Fields to sort TeachingUnits by. The order in which sorts are applied is not guaranteed when specifying many fields in one TeachingUnitSort object. */
export type TeachingUnitSort = {
  active?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  descriptionMediaType?: InputMaybe<SortDirection>;
  sortIndex?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
  updated?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type TeachingUnitTeachingTopicTopicAggregationSelection = {
  __typename?: 'TeachingUnitTeachingTopicTopicAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TeachingUnitTeachingTopicTopicNodeAggregateSelection>;
};

export type TeachingUnitTeachingTopicTopicNodeAggregateSelection = {
  __typename?: 'TeachingUnitTeachingTopicTopicNodeAggregateSelection';
  title: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type TeachingUnitTopicAggregateInput = {
  AND?: InputMaybe<Array<TeachingUnitTopicAggregateInput>>;
  NOT?: InputMaybe<TeachingUnitTopicAggregateInput>;
  OR?: InputMaybe<Array<TeachingUnitTopicAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TeachingUnitTopicNodeAggregationWhereInput>;
};

export type TeachingUnitTopicConnectFieldInput = {
  connect?: InputMaybe<TeachingTopicConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TeachingTopicConnectWhere>;
};

export type TeachingUnitTopicConnection = {
  __typename?: 'TeachingUnitTopicConnection';
  edges: Array<TeachingUnitTopicRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingUnitTopicConnectionSort = {
  node?: InputMaybe<TeachingTopicSort>;
};

export type TeachingUnitTopicConnectionWhere = {
  AND?: InputMaybe<Array<TeachingUnitTopicConnectionWhere>>;
  NOT?: InputMaybe<TeachingUnitTopicConnectionWhere>;
  OR?: InputMaybe<Array<TeachingUnitTopicConnectionWhere>>;
  node?: InputMaybe<TeachingTopicWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TeachingTopicWhere>;
};

export type TeachingUnitTopicCreateFieldInput = {
  node: TeachingTopicCreateInput;
};

export type TeachingUnitTopicDeleteFieldInput = {
  delete?: InputMaybe<TeachingTopicDeleteInput>;
  where?: InputMaybe<TeachingUnitTopicConnectionWhere>;
};

export type TeachingUnitTopicDisconnectFieldInput = {
  disconnect?: InputMaybe<TeachingTopicDisconnectInput>;
  where?: InputMaybe<TeachingUnitTopicConnectionWhere>;
};

export type TeachingUnitTopicFieldInput = {
  connect?: InputMaybe<TeachingUnitTopicConnectFieldInput>;
  create?: InputMaybe<TeachingUnitTopicCreateFieldInput>;
};

export type TeachingUnitTopicNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TeachingUnitTopicNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TeachingUnitTopicNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TeachingUnitTopicNodeAggregationWhereInput>>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TeachingUnitTopicRelationship = {
  __typename?: 'TeachingUnitTopicRelationship';
  cursor: Scalars['String']['output'];
  node: TeachingTopic;
};

export type TeachingUnitTopicUpdateConnectionInput = {
  node?: InputMaybe<TeachingTopicUpdateInput>;
};

export type TeachingUnitTopicUpdateFieldInput = {
  connect?: InputMaybe<TeachingUnitTopicConnectFieldInput>;
  create?: InputMaybe<TeachingUnitTopicCreateFieldInput>;
  delete?: InputMaybe<TeachingUnitTopicDeleteFieldInput>;
  disconnect?: InputMaybe<TeachingUnitTopicDisconnectFieldInput>;
  update?: InputMaybe<TeachingUnitTopicUpdateConnectionInput>;
  where?: InputMaybe<TeachingUnitTopicConnectionWhere>;
};

export type TeachingUnitUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  assignments?: InputMaybe<Array<TeachingUnitAssignmentsUpdateFieldInput>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionMediaType?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<TeachingUnitGroupUpdateFieldInput>;
  note?: InputMaybe<TeachingUnitNoteUpdateFieldInput>;
  organization?: InputMaybe<TeachingUnitOrganizationUpdateFieldInput>;
  owner?: InputMaybe<TeachingUnitOwnerUpdateFieldInput>;
  sortIndex?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<TeachingUnitTopicUpdateFieldInput>;
  workMaterials?: InputMaybe<Array<TeachingUnitWorkMaterialsUpdateFieldInput>>;
};

export type TeachingUnitWhere = {
  AND?: InputMaybe<Array<TeachingUnitWhere>>;
  NOT?: InputMaybe<TeachingUnitWhere>;
  OR?: InputMaybe<Array<TeachingUnitWhere>>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  active_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use `assignments_SOME` instead. */
  assignments?: InputMaybe<AssignmentWhere>;
  assignmentsAggregate?: InputMaybe<TeachingUnitAssignmentsAggregateInput>;
  /** @deprecated Use `assignmentsConnection_SOME` instead. */
  assignmentsConnection?: InputMaybe<TeachingUnitAssignmentsConnectionWhere>;
  /** Return TeachingUnits where all of the related TeachingUnitAssignmentsConnections match this filter */
  assignmentsConnection_ALL?: InputMaybe<TeachingUnitAssignmentsConnectionWhere>;
  /** Return TeachingUnits where none of the related TeachingUnitAssignmentsConnections match this filter */
  assignmentsConnection_NONE?: InputMaybe<TeachingUnitAssignmentsConnectionWhere>;
  /** @deprecated Use `assignmentsConnection_NONE` instead. */
  assignmentsConnection_NOT?: InputMaybe<TeachingUnitAssignmentsConnectionWhere>;
  /** Return TeachingUnits where one of the related TeachingUnitAssignmentsConnections match this filter */
  assignmentsConnection_SINGLE?: InputMaybe<TeachingUnitAssignmentsConnectionWhere>;
  /** Return TeachingUnits where some of the related TeachingUnitAssignmentsConnections match this filter */
  assignmentsConnection_SOME?: InputMaybe<TeachingUnitAssignmentsConnectionWhere>;
  /** Return TeachingUnits where all of the related Assignments match this filter */
  assignments_ALL?: InputMaybe<AssignmentWhere>;
  /** Return TeachingUnits where none of the related Assignments match this filter */
  assignments_NONE?: InputMaybe<AssignmentWhere>;
  /** @deprecated Use `assignments_NONE` instead. */
  assignments_NOT?: InputMaybe<AssignmentWhere>;
  /** Return TeachingUnits where one of the related Assignments match this filter */
  assignments_SINGLE?: InputMaybe<AssignmentWhere>;
  /** Return TeachingUnits where some of the related Assignments match this filter */
  assignments_SOME?: InputMaybe<AssignmentWhere>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  created_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  created_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionMediaType?: InputMaybe<Scalars['String']['input']>;
  descriptionMediaType_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  descriptionMediaType_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  descriptionMediaType_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  descriptionMediaType_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  descriptionMediaType_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  descriptionMediaType_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  descriptionMediaType_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  descriptionMediaType_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  descriptionMediaType_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<GroupWhere>;
  groupAggregate?: InputMaybe<TeachingUnitGroupAggregateInput>;
  groupConnection?: InputMaybe<TeachingUnitGroupConnectionWhere>;
  groupConnection_NOT?: InputMaybe<TeachingUnitGroupConnectionWhere>;
  group_NOT?: InputMaybe<GroupWhere>;
  note?: InputMaybe<MaterialWhere>;
  noteAggregate?: InputMaybe<TeachingUnitNoteAggregateInput>;
  noteConnection?: InputMaybe<TeachingUnitNoteConnectionWhere>;
  noteConnection_NOT?: InputMaybe<TeachingUnitNoteConnectionWhere>;
  note_NOT?: InputMaybe<MaterialWhere>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<TeachingUnitOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<TeachingUnitOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<TeachingUnitOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  owner?: InputMaybe<ProfileWhere>;
  ownerAggregate?: InputMaybe<TeachingUnitOwnerAggregateInput>;
  ownerConnection?: InputMaybe<TeachingUnitOwnerConnectionWhere>;
  ownerConnection_NOT?: InputMaybe<TeachingUnitOwnerConnectionWhere>;
  owner_NOT?: InputMaybe<ProfileWhere>;
  sortIndex?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_GT?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_GTE?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sortIndex_LT?: InputMaybe<Scalars['Int']['input']>;
  sortIndex_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sortIndex_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sortIndex_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<TeachingTopicWhere>;
  topicAggregate?: InputMaybe<TeachingUnitTopicAggregateInput>;
  topicConnection?: InputMaybe<TeachingUnitTopicConnectionWhere>;
  topicConnection_NOT?: InputMaybe<TeachingUnitTopicConnectionWhere>;
  topic_NOT?: InputMaybe<TeachingTopicWhere>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  updated_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updated_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updated_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updated_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Use `workMaterials_SOME` instead. */
  workMaterials?: InputMaybe<WorkMaterialWhere>;
  workMaterialsAggregate?: InputMaybe<TeachingUnitWorkMaterialsAggregateInput>;
  /** @deprecated Use `workMaterialsConnection_SOME` instead. */
  workMaterialsConnection?: InputMaybe<TeachingUnitWorkMaterialsConnectionWhere>;
  /** Return TeachingUnits where all of the related TeachingUnitWorkMaterialsConnections match this filter */
  workMaterialsConnection_ALL?: InputMaybe<TeachingUnitWorkMaterialsConnectionWhere>;
  /** Return TeachingUnits where none of the related TeachingUnitWorkMaterialsConnections match this filter */
  workMaterialsConnection_NONE?: InputMaybe<TeachingUnitWorkMaterialsConnectionWhere>;
  /** @deprecated Use `workMaterialsConnection_NONE` instead. */
  workMaterialsConnection_NOT?: InputMaybe<TeachingUnitWorkMaterialsConnectionWhere>;
  /** Return TeachingUnits where one of the related TeachingUnitWorkMaterialsConnections match this filter */
  workMaterialsConnection_SINGLE?: InputMaybe<TeachingUnitWorkMaterialsConnectionWhere>;
  /** Return TeachingUnits where some of the related TeachingUnitWorkMaterialsConnections match this filter */
  workMaterialsConnection_SOME?: InputMaybe<TeachingUnitWorkMaterialsConnectionWhere>;
  /** Return TeachingUnits where all of the related WorkMaterials match this filter */
  workMaterials_ALL?: InputMaybe<WorkMaterialWhere>;
  /** Return TeachingUnits where none of the related WorkMaterials match this filter */
  workMaterials_NONE?: InputMaybe<WorkMaterialWhere>;
  /** @deprecated Use `workMaterials_NONE` instead. */
  workMaterials_NOT?: InputMaybe<WorkMaterialWhere>;
  /** Return TeachingUnits where one of the related WorkMaterials match this filter */
  workMaterials_SINGLE?: InputMaybe<WorkMaterialWhere>;
  /** Return TeachingUnits where some of the related WorkMaterials match this filter */
  workMaterials_SOME?: InputMaybe<WorkMaterialWhere>;
};

export type TeachingUnitWorkMaterialWorkMaterialsAggregationSelection = {
  __typename?: 'TeachingUnitWorkMaterialWorkMaterialsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TeachingUnitWorkMaterialWorkMaterialsNodeAggregateSelection>;
};

export type TeachingUnitWorkMaterialWorkMaterialsNodeAggregateSelection = {
  __typename?: 'TeachingUnitWorkMaterialWorkMaterialsNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  title: StringAggregateSelection;
  updated: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type TeachingUnitWorkMaterialsAggregateInput = {
  AND?: InputMaybe<Array<TeachingUnitWorkMaterialsAggregateInput>>;
  NOT?: InputMaybe<TeachingUnitWorkMaterialsAggregateInput>;
  OR?: InputMaybe<Array<TeachingUnitWorkMaterialsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TeachingUnitWorkMaterialsNodeAggregationWhereInput>;
};

export type TeachingUnitWorkMaterialsConnectFieldInput = {
  connect?: InputMaybe<Array<WorkMaterialConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<WorkMaterialConnectWhere>;
};

export type TeachingUnitWorkMaterialsConnection = {
  __typename?: 'TeachingUnitWorkMaterialsConnection';
  edges: Array<TeachingUnitWorkMaterialsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingUnitWorkMaterialsConnectionSort = {
  node?: InputMaybe<WorkMaterialSort>;
};

export type TeachingUnitWorkMaterialsConnectionWhere = {
  AND?: InputMaybe<Array<TeachingUnitWorkMaterialsConnectionWhere>>;
  NOT?: InputMaybe<TeachingUnitWorkMaterialsConnectionWhere>;
  OR?: InputMaybe<Array<TeachingUnitWorkMaterialsConnectionWhere>>;
  node?: InputMaybe<WorkMaterialWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<WorkMaterialWhere>;
};

export type TeachingUnitWorkMaterialsCreateFieldInput = {
  node: WorkMaterialCreateInput;
};

export type TeachingUnitWorkMaterialsDeleteFieldInput = {
  delete?: InputMaybe<WorkMaterialDeleteInput>;
  where?: InputMaybe<TeachingUnitWorkMaterialsConnectionWhere>;
};

export type TeachingUnitWorkMaterialsDisconnectFieldInput = {
  disconnect?: InputMaybe<WorkMaterialDisconnectInput>;
  where?: InputMaybe<TeachingUnitWorkMaterialsConnectionWhere>;
};

export type TeachingUnitWorkMaterialsFieldInput = {
  connect?: InputMaybe<Array<TeachingUnitWorkMaterialsConnectFieldInput>>;
  create?: InputMaybe<Array<TeachingUnitWorkMaterialsCreateFieldInput>>;
};

export type TeachingUnitWorkMaterialsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TeachingUnitWorkMaterialsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TeachingUnitWorkMaterialsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TeachingUnitWorkMaterialsNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeachingUnitWorkMaterialsRelationship = {
  __typename?: 'TeachingUnitWorkMaterialsRelationship';
  cursor: Scalars['String']['output'];
  node: WorkMaterial;
};

export type TeachingUnitWorkMaterialsUpdateConnectionInput = {
  node?: InputMaybe<WorkMaterialUpdateInput>;
};

export type TeachingUnitWorkMaterialsUpdateFieldInput = {
  connect?: InputMaybe<Array<TeachingUnitWorkMaterialsConnectFieldInput>>;
  create?: InputMaybe<Array<TeachingUnitWorkMaterialsCreateFieldInput>>;
  delete?: InputMaybe<Array<TeachingUnitWorkMaterialsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TeachingUnitWorkMaterialsDisconnectFieldInput>>;
  update?: InputMaybe<TeachingUnitWorkMaterialsUpdateConnectionInput>;
  where?: InputMaybe<TeachingUnitWorkMaterialsConnectionWhere>;
};

export type TeachingUnitsConnection = {
  __typename?: 'TeachingUnitsConnection';
  edges: Array<TeachingUnitEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Threema = {
  __typename?: 'Threema';
  apiToken?: Maybe<Scalars['String']['output']>;
  licenseCount?: Maybe<Scalars['Int']['output']>;
  licenseName?: Maybe<Scalars['String']['output']>;
  licenseType?: Maybe<Scalars['String']['output']>;
  licenseValidUntil?: Maybe<Scalars['DateTime']['output']>;
  organization: Organization;
  organizationAggregate?: Maybe<ThreemaOrganizationOrganizationAggregationSelection>;
  organizationConnection: ThreemaOrganizationConnection;
  profiles: Array<Profile>;
  profilesAggregate?: Maybe<ThreemaProfileProfilesAggregationSelection>;
  profilesConnection: ThreemaProfilesConnection;
  uuid: Scalars['ID']['output'];
};

export type ThreemaOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type ThreemaOrganizationAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OrganizationWhere>;
};

export type ThreemaOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ThreemaOrganizationConnectionSort>>;
  where?: InputMaybe<ThreemaOrganizationConnectionWhere>;
};

export type ThreemaProfilesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ProfileOptions>;
  where?: InputMaybe<ProfileWhere>;
};

export type ThreemaProfilesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProfileWhere>;
};

export type ThreemaProfilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ThreemaProfilesConnectionSort>>;
  where?: InputMaybe<ThreemaProfilesConnectionWhere>;
};

export type ThreemaAggregateSelection = {
  __typename?: 'ThreemaAggregateSelection';
  apiToken: StringAggregateSelection;
  count: Scalars['Int']['output'];
  licenseCount: IntAggregateSelection;
  licenseName: StringAggregateSelection;
  licenseType: StringAggregateSelection;
  licenseValidUntil: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type ThreemaBroadcast = {
  __typename?: 'ThreemaBroadcast';
  apiToken?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  organizationAggregate?: Maybe<ThreemaBroadcastOrganizationOrganizationAggregationSelection>;
  organizationConnection: ThreemaBroadcastOrganizationConnection;
  thremaId?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};

export type ThreemaBroadcastOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type ThreemaBroadcastOrganizationAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OrganizationWhere>;
};

export type ThreemaBroadcastOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ThreemaBroadcastOrganizationConnectionSort>>;
  where?: InputMaybe<ThreemaBroadcastOrganizationConnectionWhere>;
};

export type ThreemaBroadcastAggregateSelection = {
  __typename?: 'ThreemaBroadcastAggregateSelection';
  apiToken: StringAggregateSelection;
  count: Scalars['Int']['output'];
  thremaId: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type ThreemaBroadcastConnectInput = {
  organization?: InputMaybe<ThreemaBroadcastOrganizationConnectFieldInput>;
};

export type ThreemaBroadcastConnectWhere = {
  node: ThreemaBroadcastWhere;
};

export type ThreemaBroadcastCreateInput = {
  apiToken?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<ThreemaBroadcastOrganizationFieldInput>;
  thremaId?: InputMaybe<Scalars['String']['input']>;
};

export type ThreemaBroadcastDeleteInput = {
  organization?: InputMaybe<ThreemaBroadcastOrganizationDeleteFieldInput>;
};

export type ThreemaBroadcastDisconnectInput = {
  organization?: InputMaybe<ThreemaBroadcastOrganizationDisconnectFieldInput>;
};

export type ThreemaBroadcastEdge = {
  __typename?: 'ThreemaBroadcastEdge';
  cursor: Scalars['String']['output'];
  node: ThreemaBroadcast;
};

export type ThreemaBroadcastOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ThreemaBroadcastSort objects to sort ThreemaBroadcasts by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ThreemaBroadcastSort>>;
};

export type ThreemaBroadcastOrganizationAggregateInput = {
  AND?: InputMaybe<Array<ThreemaBroadcastOrganizationAggregateInput>>;
  NOT?: InputMaybe<ThreemaBroadcastOrganizationAggregateInput>;
  OR?: InputMaybe<Array<ThreemaBroadcastOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<LicensePropertiesAggregationWhereInput>;
  node?: InputMaybe<ThreemaBroadcastOrganizationNodeAggregationWhereInput>;
};

export type ThreemaBroadcastOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  edge?: InputMaybe<LicensePropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type ThreemaBroadcastOrganizationConnectOrCreateFieldInput = {
  onCreate: ThreemaBroadcastOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type ThreemaBroadcastOrganizationConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<LicensePropertiesCreateInput>;
  node: OrganizationOnCreateInput;
};

export type ThreemaBroadcastOrganizationConnection = {
  __typename?: 'ThreemaBroadcastOrganizationConnection';
  edges: Array<ThreemaBroadcastOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ThreemaBroadcastOrganizationConnectionSort = {
  edge?: InputMaybe<LicensePropertiesSort>;
  node?: InputMaybe<OrganizationSort>;
};

export type ThreemaBroadcastOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<ThreemaBroadcastOrganizationConnectionWhere>>;
  NOT?: InputMaybe<ThreemaBroadcastOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<ThreemaBroadcastOrganizationConnectionWhere>>;
  edge?: InputMaybe<LicensePropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<LicensePropertiesWhere>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type ThreemaBroadcastOrganizationCreateFieldInput = {
  edge?: InputMaybe<LicensePropertiesCreateInput>;
  node: OrganizationCreateInput;
};

export type ThreemaBroadcastOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<ThreemaBroadcastOrganizationConnectionWhere>;
};

export type ThreemaBroadcastOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<ThreemaBroadcastOrganizationConnectionWhere>;
};

export type ThreemaBroadcastOrganizationFieldInput = {
  connect?: InputMaybe<ThreemaBroadcastOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<ThreemaBroadcastOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<ThreemaBroadcastOrganizationCreateFieldInput>;
};

export type ThreemaBroadcastOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ThreemaBroadcastOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ThreemaBroadcastOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ThreemaBroadcastOrganizationNodeAggregationWhereInput>>;
  aboutInfoLastUpdated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ThreemaBroadcastOrganizationOrganizationAggregationSelection = {
  __typename?: 'ThreemaBroadcastOrganizationOrganizationAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<ThreemaBroadcastOrganizationOrganizationEdgeAggregateSelection>;
  node?: Maybe<ThreemaBroadcastOrganizationOrganizationNodeAggregateSelection>;
};

export type ThreemaBroadcastOrganizationOrganizationEdgeAggregateSelection = {
  __typename?: 'ThreemaBroadcastOrganizationOrganizationEdgeAggregateSelection';
  contractRef: StringAggregateSelection;
  notAfter: DateTimeAggregateSelection;
  notBefore: DateTimeAggregateSelection;
  version: StringAggregateSelection;
};

export type ThreemaBroadcastOrganizationOrganizationNodeAggregateSelection = {
  __typename?: 'ThreemaBroadcastOrganizationOrganizationNodeAggregateSelection';
  aboutInfo: StringAggregateSelection;
  aboutInfoLastUpdated: DateTimeAggregateSelection;
  displayName: StringAggregateSelection;
  matrixRoomId: StringAggregateSelection;
  planungSyncProps: StringAggregateSelection;
  procuratSyncProps: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type ThreemaBroadcastOrganizationRelationship = {
  __typename?: 'ThreemaBroadcastOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
  properties: LicenseProperties;
};

export type ThreemaBroadcastOrganizationUpdateConnectionInput = {
  edge?: InputMaybe<LicensePropertiesUpdateInput>;
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type ThreemaBroadcastOrganizationUpdateFieldInput = {
  connect?: InputMaybe<ThreemaBroadcastOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<ThreemaBroadcastOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<ThreemaBroadcastOrganizationCreateFieldInput>;
  delete?: InputMaybe<ThreemaBroadcastOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<ThreemaBroadcastOrganizationDisconnectFieldInput>;
  update?: InputMaybe<ThreemaBroadcastOrganizationUpdateConnectionInput>;
  where?: InputMaybe<ThreemaBroadcastOrganizationConnectionWhere>;
};

/**
 * The edge properties for the following fields:
 * * Group.threemaBroadcast
 */
export type ThreemaBroadcastProps = {
  __typename?: 'ThreemaBroadcastProps';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  lastSync?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  threemaId?: Maybe<Scalars['String']['output']>;
};

export type ThreemaBroadcastPropsAggregationWhereInput = {
  AND?: InputMaybe<Array<ThreemaBroadcastPropsAggregationWhereInput>>;
  NOT?: InputMaybe<ThreemaBroadcastPropsAggregationWhereInput>;
  OR?: InputMaybe<Array<ThreemaBroadcastPropsAggregationWhereInput>>;
  lastSync_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ThreemaBroadcastPropsCreateInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastSync?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  threemaId?: InputMaybe<Scalars['String']['input']>;
};

export type ThreemaBroadcastPropsSort = {
  enabled?: InputMaybe<SortDirection>;
  lastSync?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  threemaId?: InputMaybe<SortDirection>;
};

export type ThreemaBroadcastPropsUpdateInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastSync?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  threemaId?: InputMaybe<Scalars['String']['input']>;
};

export type ThreemaBroadcastPropsWhere = {
  AND?: InputMaybe<Array<ThreemaBroadcastPropsWhere>>;
  NOT?: InputMaybe<ThreemaBroadcastPropsWhere>;
  OR?: InputMaybe<Array<ThreemaBroadcastPropsWhere>>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  enabled_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  lastSync?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastSync_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lastSync_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lastSync_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  threemaId?: InputMaybe<Scalars['String']['input']>;
  threemaId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  threemaId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  threemaId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  threemaId_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  threemaId_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  threemaId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  threemaId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  threemaId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  threemaId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

/** Fields to sort ThreemaBroadcasts by. The order in which sorts are applied is not guaranteed when specifying many fields in one ThreemaBroadcastSort object. */
export type ThreemaBroadcastSort = {
  apiToken?: InputMaybe<SortDirection>;
  thremaId?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type ThreemaBroadcastUpdateInput = {
  apiToken?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<ThreemaBroadcastOrganizationUpdateFieldInput>;
  thremaId?: InputMaybe<Scalars['String']['input']>;
};

export type ThreemaBroadcastWhere = {
  AND?: InputMaybe<Array<ThreemaBroadcastWhere>>;
  NOT?: InputMaybe<ThreemaBroadcastWhere>;
  OR?: InputMaybe<Array<ThreemaBroadcastWhere>>;
  apiToken?: InputMaybe<Scalars['String']['input']>;
  apiToken_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  apiToken_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  apiToken_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  apiToken_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  apiToken_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  apiToken_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  apiToken_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  apiToken_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  apiToken_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<ThreemaBroadcastOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<ThreemaBroadcastOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<ThreemaBroadcastOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  thremaId?: InputMaybe<Scalars['String']['input']>;
  thremaId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  thremaId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  thremaId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  thremaId_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  thremaId_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  thremaId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  thremaId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  thremaId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  thremaId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type ThreemaBroadcastsConnection = {
  __typename?: 'ThreemaBroadcastsConnection';
  edges: Array<ThreemaBroadcastEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ThreemaConnectInput = {
  organization?: InputMaybe<ThreemaOrganizationConnectFieldInput>;
  profiles?: InputMaybe<Array<ThreemaProfilesConnectFieldInput>>;
};

export type ThreemaConnectWhere = {
  node: ThreemaWhere;
};

export type ThreemaCreateInput = {
  apiToken?: InputMaybe<Scalars['String']['input']>;
  licenseCount?: InputMaybe<Scalars['Int']['input']>;
  licenseName?: InputMaybe<Scalars['String']['input']>;
  licenseType?: InputMaybe<Scalars['String']['input']>;
  licenseValidUntil?: InputMaybe<Scalars['DateTime']['input']>;
  organization?: InputMaybe<ThreemaOrganizationFieldInput>;
  profiles?: InputMaybe<ThreemaProfilesFieldInput>;
};

export type ThreemaDeleteInput = {
  organization?: InputMaybe<ThreemaOrganizationDeleteFieldInput>;
  profiles?: InputMaybe<Array<ThreemaProfilesDeleteFieldInput>>;
};

export type ThreemaDisconnectInput = {
  organization?: InputMaybe<ThreemaOrganizationDisconnectFieldInput>;
  profiles?: InputMaybe<Array<ThreemaProfilesDisconnectFieldInput>>;
};

export type ThreemaEdge = {
  __typename?: 'ThreemaEdge';
  cursor: Scalars['String']['output'];
  node: Threema;
};

export type ThreemaOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ThreemaSort objects to sort Threemas by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ThreemaSort>>;
};

export type ThreemaOrganizationAggregateInput = {
  AND?: InputMaybe<Array<ThreemaOrganizationAggregateInput>>;
  NOT?: InputMaybe<ThreemaOrganizationAggregateInput>;
  OR?: InputMaybe<Array<ThreemaOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<LicensePropertiesAggregationWhereInput>;
  node?: InputMaybe<ThreemaOrganizationNodeAggregationWhereInput>;
};

export type ThreemaOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  edge?: InputMaybe<LicensePropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type ThreemaOrganizationConnectOrCreateFieldInput = {
  onCreate: ThreemaOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type ThreemaOrganizationConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<LicensePropertiesCreateInput>;
  node: OrganizationOnCreateInput;
};

export type ThreemaOrganizationConnection = {
  __typename?: 'ThreemaOrganizationConnection';
  edges: Array<ThreemaOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ThreemaOrganizationConnectionSort = {
  edge?: InputMaybe<LicensePropertiesSort>;
  node?: InputMaybe<OrganizationSort>;
};

export type ThreemaOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<ThreemaOrganizationConnectionWhere>>;
  NOT?: InputMaybe<ThreemaOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<ThreemaOrganizationConnectionWhere>>;
  edge?: InputMaybe<LicensePropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<LicensePropertiesWhere>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type ThreemaOrganizationCreateFieldInput = {
  edge?: InputMaybe<LicensePropertiesCreateInput>;
  node: OrganizationCreateInput;
};

export type ThreemaOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<ThreemaOrganizationConnectionWhere>;
};

export type ThreemaOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<ThreemaOrganizationConnectionWhere>;
};

export type ThreemaOrganizationFieldInput = {
  connect?: InputMaybe<ThreemaOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<ThreemaOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<ThreemaOrganizationCreateFieldInput>;
};

export type ThreemaOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ThreemaOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ThreemaOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ThreemaOrganizationNodeAggregationWhereInput>>;
  aboutInfoLastUpdated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ThreemaOrganizationOrganizationAggregationSelection = {
  __typename?: 'ThreemaOrganizationOrganizationAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<ThreemaOrganizationOrganizationEdgeAggregateSelection>;
  node?: Maybe<ThreemaOrganizationOrganizationNodeAggregateSelection>;
};

export type ThreemaOrganizationOrganizationEdgeAggregateSelection = {
  __typename?: 'ThreemaOrganizationOrganizationEdgeAggregateSelection';
  contractRef: StringAggregateSelection;
  notAfter: DateTimeAggregateSelection;
  notBefore: DateTimeAggregateSelection;
  version: StringAggregateSelection;
};

export type ThreemaOrganizationOrganizationNodeAggregateSelection = {
  __typename?: 'ThreemaOrganizationOrganizationNodeAggregateSelection';
  aboutInfo: StringAggregateSelection;
  aboutInfoLastUpdated: DateTimeAggregateSelection;
  displayName: StringAggregateSelection;
  matrixRoomId: StringAggregateSelection;
  planungSyncProps: StringAggregateSelection;
  procuratSyncProps: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type ThreemaOrganizationRelationship = {
  __typename?: 'ThreemaOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
  properties: LicenseProperties;
};

export type ThreemaOrganizationUpdateConnectionInput = {
  edge?: InputMaybe<LicensePropertiesUpdateInput>;
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type ThreemaOrganizationUpdateFieldInput = {
  connect?: InputMaybe<ThreemaOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<ThreemaOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<ThreemaOrganizationCreateFieldInput>;
  delete?: InputMaybe<ThreemaOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<ThreemaOrganizationDisconnectFieldInput>;
  update?: InputMaybe<ThreemaOrganizationUpdateConnectionInput>;
  where?: InputMaybe<ThreemaOrganizationConnectionWhere>;
};

export type ThreemaProfileProfilesAggregationSelection = {
  __typename?: 'ThreemaProfileProfilesAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<ThreemaProfileProfilesEdgeAggregateSelection>;
  node?: Maybe<ThreemaProfileProfilesNodeAggregateSelection>;
};

export type ThreemaProfileProfilesEdgeAggregateSelection = {
  __typename?: 'ThreemaProfileProfilesEdgeAggregateSelection';
  lastSync: DateTimeAggregateSelection;
  threemaId: StringAggregateSelection;
  workCredentialId: StringAggregateSelection;
  workPass: StringAggregateSelection;
  workUser: StringAggregateSelection;
};

export type ThreemaProfileProfilesNodeAggregateSelection = {
  __typename?: 'ThreemaProfileProfilesNodeAggregateSelection';
  address1: StringAggregateSelection;
  address2: StringAggregateSelection;
  address3: StringAggregateSelection;
  birthday: StringAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  email: StringAggregateSelection;
  firstName: StringAggregateSelection;
  firstNames: StringAggregateSelection;
  lastName: StringAggregateSelection;
  managedBy: StringAggregateSelection;
  matrixToken: StringAggregateSelection;
  nextcloudUserId: StringAggregateSelection;
  prefixName: StringAggregateSelection;
  salutation: StringAggregateSelection;
  shortName: StringAggregateSelection;
  threemaId: StringAggregateSelection;
  title: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  userUuid: StringAggregateSelection;
  uuid: IdAggregateSelection;
  zoomUserId: StringAggregateSelection;
};

export type ThreemaProfilesAggregateInput = {
  AND?: InputMaybe<Array<ThreemaProfilesAggregateInput>>;
  NOT?: InputMaybe<ThreemaProfilesAggregateInput>;
  OR?: InputMaybe<Array<ThreemaProfilesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<ThreemaPropsAggregationWhereInput>;
  node?: InputMaybe<ThreemaProfilesNodeAggregationWhereInput>;
};

export type ThreemaProfilesConnectFieldInput = {
  connect?: InputMaybe<Array<ProfileConnectInput>>;
  edge?: InputMaybe<ThreemaPropsCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ProfileConnectWhere>;
};

export type ThreemaProfilesConnectOrCreateFieldInput = {
  onCreate: ThreemaProfilesConnectOrCreateFieldInputOnCreate;
  where: ProfileConnectOrCreateWhere;
};

export type ThreemaProfilesConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<ThreemaPropsCreateInput>;
  node: ProfileOnCreateInput;
};

export type ThreemaProfilesConnection = {
  __typename?: 'ThreemaProfilesConnection';
  edges: Array<ThreemaProfilesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ThreemaProfilesConnectionSort = {
  edge?: InputMaybe<ThreemaPropsSort>;
  node?: InputMaybe<ProfileSort>;
};

export type ThreemaProfilesConnectionWhere = {
  AND?: InputMaybe<Array<ThreemaProfilesConnectionWhere>>;
  NOT?: InputMaybe<ThreemaProfilesConnectionWhere>;
  OR?: InputMaybe<Array<ThreemaProfilesConnectionWhere>>;
  edge?: InputMaybe<ThreemaPropsWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<ThreemaPropsWhere>;
  node?: InputMaybe<ProfileWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ProfileWhere>;
};

export type ThreemaProfilesCreateFieldInput = {
  edge?: InputMaybe<ThreemaPropsCreateInput>;
  node: ProfileCreateInput;
};

export type ThreemaProfilesDeleteFieldInput = {
  delete?: InputMaybe<ProfileDeleteInput>;
  where?: InputMaybe<ThreemaProfilesConnectionWhere>;
};

export type ThreemaProfilesDisconnectFieldInput = {
  disconnect?: InputMaybe<ProfileDisconnectInput>;
  where?: InputMaybe<ThreemaProfilesConnectionWhere>;
};

export type ThreemaProfilesFieldInput = {
  connect?: InputMaybe<Array<ThreemaProfilesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ThreemaProfilesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ThreemaProfilesCreateFieldInput>>;
};

export type ThreemaProfilesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ThreemaProfilesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ThreemaProfilesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ThreemaProfilesNodeAggregationWhereInput>>;
  address1_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address1_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address2_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address2_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address3_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address3_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  birthday_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  userUuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  userUuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ThreemaProfilesRelationship = {
  __typename?: 'ThreemaProfilesRelationship';
  cursor: Scalars['String']['output'];
  node: Profile;
  properties: ThreemaProps;
};

export type ThreemaProfilesUpdateConnectionInput = {
  edge?: InputMaybe<ThreemaPropsUpdateInput>;
  node?: InputMaybe<ProfileUpdateInput>;
};

export type ThreemaProfilesUpdateFieldInput = {
  connect?: InputMaybe<Array<ThreemaProfilesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ThreemaProfilesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ThreemaProfilesCreateFieldInput>>;
  delete?: InputMaybe<Array<ThreemaProfilesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ThreemaProfilesDisconnectFieldInput>>;
  update?: InputMaybe<ThreemaProfilesUpdateConnectionInput>;
  where?: InputMaybe<ThreemaProfilesConnectionWhere>;
};

/**
 * The edge properties for the following fields:
 * * Profile.threema
 * * Threema.profiles
 */
export type ThreemaProps = {
  __typename?: 'ThreemaProps';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  lastSync?: Maybe<Scalars['DateTime']['output']>;
  threemaId?: Maybe<Scalars['String']['output']>;
  workCredentialId?: Maybe<Scalars['String']['output']>;
  workPass?: Maybe<Scalars['String']['output']>;
  workUser?: Maybe<Scalars['String']['output']>;
};

export type ThreemaPropsAggregationWhereInput = {
  AND?: InputMaybe<Array<ThreemaPropsAggregationWhereInput>>;
  NOT?: InputMaybe<ThreemaPropsAggregationWhereInput>;
  OR?: InputMaybe<Array<ThreemaPropsAggregationWhereInput>>;
  lastSync_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  threemaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workCredentialId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  workCredentialId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  workCredentialId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  workCredentialId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  workCredentialId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  workCredentialId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workCredentialId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workCredentialId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workCredentialId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workCredentialId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workCredentialId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workCredentialId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workCredentialId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workCredentialId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workCredentialId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workPass_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  workPass_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  workPass_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  workPass_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  workPass_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  workPass_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workPass_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workPass_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workPass_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workPass_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workPass_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workPass_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workPass_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workPass_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workPass_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workUser_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  workUser_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  workUser_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  workUser_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  workUser_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  workUser_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workUser_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workUser_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workUser_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workUser_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workUser_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workUser_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workUser_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workUser_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workUser_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ThreemaPropsCreateInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastSync?: InputMaybe<Scalars['DateTime']['input']>;
  threemaId?: InputMaybe<Scalars['String']['input']>;
  workCredentialId?: InputMaybe<Scalars['String']['input']>;
  workPass?: InputMaybe<Scalars['String']['input']>;
  workUser?: InputMaybe<Scalars['String']['input']>;
};

export type ThreemaPropsSort = {
  enabled?: InputMaybe<SortDirection>;
  lastSync?: InputMaybe<SortDirection>;
  threemaId?: InputMaybe<SortDirection>;
  workCredentialId?: InputMaybe<SortDirection>;
  workPass?: InputMaybe<SortDirection>;
  workUser?: InputMaybe<SortDirection>;
};

export type ThreemaPropsUpdateInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastSync?: InputMaybe<Scalars['DateTime']['input']>;
  threemaId?: InputMaybe<Scalars['String']['input']>;
  workCredentialId?: InputMaybe<Scalars['String']['input']>;
  workPass?: InputMaybe<Scalars['String']['input']>;
  workUser?: InputMaybe<Scalars['String']['input']>;
};

export type ThreemaPropsWhere = {
  AND?: InputMaybe<Array<ThreemaPropsWhere>>;
  NOT?: InputMaybe<ThreemaPropsWhere>;
  OR?: InputMaybe<Array<ThreemaPropsWhere>>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  enabled_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  lastSync?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastSync_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSync_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lastSync_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lastSync_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  threemaId?: InputMaybe<Scalars['String']['input']>;
  threemaId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  threemaId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  threemaId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  threemaId_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  threemaId_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  threemaId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  threemaId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  threemaId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  threemaId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  workCredentialId?: InputMaybe<Scalars['String']['input']>;
  workCredentialId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  workCredentialId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  workCredentialId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  workCredentialId_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  workCredentialId_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  workCredentialId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  workCredentialId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  workCredentialId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  workCredentialId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  workPass?: InputMaybe<Scalars['String']['input']>;
  workPass_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  workPass_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  workPass_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  workPass_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  workPass_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  workPass_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  workPass_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  workPass_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  workPass_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  workUser?: InputMaybe<Scalars['String']['input']>;
  workUser_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  workUser_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  workUser_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  workUser_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  workUser_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  workUser_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  workUser_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  workUser_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  workUser_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

/** Fields to sort Threemas by. The order in which sorts are applied is not guaranteed when specifying many fields in one ThreemaSort object. */
export type ThreemaSort = {
  apiToken?: InputMaybe<SortDirection>;
  licenseCount?: InputMaybe<SortDirection>;
  licenseName?: InputMaybe<SortDirection>;
  licenseType?: InputMaybe<SortDirection>;
  licenseValidUntil?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type ThreemaUpdateInput = {
  apiToken?: InputMaybe<Scalars['String']['input']>;
  licenseCount?: InputMaybe<Scalars['Int']['input']>;
  licenseCount_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  licenseCount_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  licenseName?: InputMaybe<Scalars['String']['input']>;
  licenseType?: InputMaybe<Scalars['String']['input']>;
  licenseValidUntil?: InputMaybe<Scalars['DateTime']['input']>;
  organization?: InputMaybe<ThreemaOrganizationUpdateFieldInput>;
  profiles?: InputMaybe<Array<ThreemaProfilesUpdateFieldInput>>;
};

export type ThreemaWhere = {
  AND?: InputMaybe<Array<ThreemaWhere>>;
  NOT?: InputMaybe<ThreemaWhere>;
  OR?: InputMaybe<Array<ThreemaWhere>>;
  apiToken?: InputMaybe<Scalars['String']['input']>;
  apiToken_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  apiToken_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  apiToken_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  apiToken_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  apiToken_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  apiToken_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  apiToken_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  apiToken_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  apiToken_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  licenseCount?: InputMaybe<Scalars['Int']['input']>;
  licenseCount_GT?: InputMaybe<Scalars['Int']['input']>;
  licenseCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  licenseCount_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  licenseCount_LT?: InputMaybe<Scalars['Int']['input']>;
  licenseCount_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  licenseCount_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  licenseCount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  licenseName?: InputMaybe<Scalars['String']['input']>;
  licenseName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  licenseName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  licenseName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  licenseName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  licenseName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  licenseName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  licenseName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  licenseName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  licenseName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  licenseType?: InputMaybe<Scalars['String']['input']>;
  licenseType_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  licenseType_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  licenseType_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  licenseType_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  licenseType_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  licenseType_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  licenseType_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  licenseType_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  licenseType_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  licenseValidUntil?: InputMaybe<Scalars['DateTime']['input']>;
  licenseValidUntil_GT?: InputMaybe<Scalars['DateTime']['input']>;
  licenseValidUntil_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  licenseValidUntil_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  licenseValidUntil_LT?: InputMaybe<Scalars['DateTime']['input']>;
  licenseValidUntil_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  licenseValidUntil_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  licenseValidUntil_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<ThreemaOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<ThreemaOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<ThreemaOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  /** @deprecated Use `profiles_SOME` instead. */
  profiles?: InputMaybe<ProfileWhere>;
  profilesAggregate?: InputMaybe<ThreemaProfilesAggregateInput>;
  /** @deprecated Use `profilesConnection_SOME` instead. */
  profilesConnection?: InputMaybe<ThreemaProfilesConnectionWhere>;
  /** Return Threemas where all of the related ThreemaProfilesConnections match this filter */
  profilesConnection_ALL?: InputMaybe<ThreemaProfilesConnectionWhere>;
  /** Return Threemas where none of the related ThreemaProfilesConnections match this filter */
  profilesConnection_NONE?: InputMaybe<ThreemaProfilesConnectionWhere>;
  /** @deprecated Use `profilesConnection_NONE` instead. */
  profilesConnection_NOT?: InputMaybe<ThreemaProfilesConnectionWhere>;
  /** Return Threemas where one of the related ThreemaProfilesConnections match this filter */
  profilesConnection_SINGLE?: InputMaybe<ThreemaProfilesConnectionWhere>;
  /** Return Threemas where some of the related ThreemaProfilesConnections match this filter */
  profilesConnection_SOME?: InputMaybe<ThreemaProfilesConnectionWhere>;
  /** Return Threemas where all of the related Profiles match this filter */
  profiles_ALL?: InputMaybe<ProfileWhere>;
  /** Return Threemas where none of the related Profiles match this filter */
  profiles_NONE?: InputMaybe<ProfileWhere>;
  /** @deprecated Use `profiles_NONE` instead. */
  profiles_NOT?: InputMaybe<ProfileWhere>;
  /** Return Threemas where one of the related Profiles match this filter */
  profiles_SINGLE?: InputMaybe<ProfileWhere>;
  /** Return Threemas where some of the related Profiles match this filter */
  profiles_SOME?: InputMaybe<ProfileWhere>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type ThreemasConnection = {
  __typename?: 'ThreemasConnection';
  edges: Array<ThreemaEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UpdateAbsenceReasonsMutationResponse = {
  __typename?: 'UpdateAbsenceReasonsMutationResponse';
  absenceReasons: Array<AbsenceReason>;
  info: UpdateInfo;
};

export type UpdateAbsencesMutationResponse = {
  __typename?: 'UpdateAbsencesMutationResponse';
  absences: Array<Absence>;
  info: UpdateInfo;
};

export type UpdateAssignmentsMutationResponse = {
  __typename?: 'UpdateAssignmentsMutationResponse';
  assignments: Array<Assignment>;
  info: UpdateInfo;
};

export type UpdateBigBlueButtonsMutationResponse = {
  __typename?: 'UpdateBigBlueButtonsMutationResponse';
  bigBlueButtons: Array<BigBlueButton>;
  info: UpdateInfo;
};

export type UpdateBildungsplattformsMutationResponse = {
  __typename?: 'UpdateBildungsplattformsMutationResponse';
  bildungsplattforms: Array<Bildungsplattform>;
  info: UpdateInfo;
};

export type UpdateCalendarEventsMutationResponse = {
  __typename?: 'UpdateCalendarEventsMutationResponse';
  calendarEvents: Array<CalendarEvent>;
  info: UpdateInfo;
};

export type UpdateCalendarSubscriptionsMutationResponse = {
  __typename?: 'UpdateCalendarSubscriptionsMutationResponse';
  calendarSubscriptions: Array<CalendarSubscription>;
  info: UpdateInfo;
};

export type UpdateClassGroupsMutationResponse = {
  __typename?: 'UpdateClassGroupsMutationResponse';
  classGroups: Array<ClassGroup>;
  info: UpdateInfo;
};

export type UpdateClassesMutationResponse = {
  __typename?: 'UpdateClassesMutationResponse';
  classes: Array<Class>;
  info: UpdateInfo;
};

export type UpdateDivisionsMutationResponse = {
  __typename?: 'UpdateDivisionsMutationResponse';
  divisions: Array<Division>;
  info: UpdateInfo;
};

export type UpdateFileEntriesMutationResponse = {
  __typename?: 'UpdateFileEntriesMutationResponse';
  fileEntries: Array<FileEntry>;
  info: UpdateInfo;
};

export type UpdateGroupSettings = {
  allowViewersCanAddMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  allowViewersCanCreateEvents?: InputMaybe<Scalars['Boolean']['input']>;
  allowViewersCanStartMeeting?: InputMaybe<Scalars['Boolean']['input']>;
  nextcloudFolder?: InputMaybe<Scalars['Boolean']['input']>;
  threemaGroup?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Information about the number of nodes and relationships created and deleted during an update mutation */
export type UpdateInfo = {
  __typename?: 'UpdateInfo';
  nodesCreated: Scalars['Int']['output'];
  nodesDeleted: Scalars['Int']['output'];
  relationshipsCreated: Scalars['Int']['output'];
  relationshipsDeleted: Scalars['Int']['output'];
};

export type UpdateLocationsMutationResponse = {
  __typename?: 'UpdateLocationsMutationResponse';
  info: UpdateInfo;
  locations: Array<Location>;
};

export type UpdateMaterialsMutationResponse = {
  __typename?: 'UpdateMaterialsMutationResponse';
  info: UpdateInfo;
  materials: Array<Material>;
};

export type UpdateNextcloudsMutationResponse = {
  __typename?: 'UpdateNextcloudsMutationResponse';
  info: UpdateInfo;
  nextclouds: Array<Nextcloud>;
};

export type UpdateNotificationSettingsMutationResponse = {
  __typename?: 'UpdateNotificationSettingsMutationResponse';
  info: UpdateInfo;
  notificationSettings: Array<NotificationSettings>;
};

export type UpdateOrganizationsMutationResponse = {
  __typename?: 'UpdateOrganizationsMutationResponse';
  info: UpdateInfo;
  organizations: Array<Organization>;
};

export type UpdatePasswordsMutationResponse = {
  __typename?: 'UpdatePasswordsMutationResponse';
  users: Array<Scalars['ID']['output']>;
};

export type UpdatePreferencesMutationResponse = {
  __typename?: 'UpdatePreferencesMutationResponse';
  info: UpdateInfo;
  preferences: Array<Preference>;
};

export type UpdateProfileSettings = {
  dropUser?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  frontendUri?: InputMaybe<Scalars['String']['input']>;
  inviteUser?: InputMaybe<Scalars['Boolean']['input']>;
  nextcloudUser?: InputMaybe<Scalars['Boolean']['input']>;
  threemaUser?: InputMaybe<Scalars['Boolean']['input']>;
  zoomUser?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateProfilesMutationResponse = {
  __typename?: 'UpdateProfilesMutationResponse';
  info: UpdateInfo;
  profiles: Array<Profile>;
};

export type UpdateRecurrenceRulesMutationResponse = {
  __typename?: 'UpdateRecurrenceRulesMutationResponse';
  info: UpdateInfo;
  recurrenceRules: Array<RecurrenceRule>;
};

export type UpdateSubmissionsMutationResponse = {
  __typename?: 'UpdateSubmissionsMutationResponse';
  info: UpdateInfo;
  submissions: Array<Submission>;
};

export type UpdateTeachingTopicsMutationResponse = {
  __typename?: 'UpdateTeachingTopicsMutationResponse';
  info: UpdateInfo;
  teachingTopics: Array<TeachingTopic>;
};

export type UpdateTeachingUnitsMutationResponse = {
  __typename?: 'UpdateTeachingUnitsMutationResponse';
  info: UpdateInfo;
  teachingUnits: Array<TeachingUnit>;
};

export type UpdateThreemaBroadcastsMutationResponse = {
  __typename?: 'UpdateThreemaBroadcastsMutationResponse';
  info: UpdateInfo;
  threemaBroadcasts: Array<ThreemaBroadcast>;
};

export type UpdateThreemasMutationResponse = {
  __typename?: 'UpdateThreemasMutationResponse';
  info: UpdateInfo;
  threemas: Array<Threema>;
};

export type UpdateVirtualLocationsMutationResponse = {
  __typename?: 'UpdateVirtualLocationsMutationResponse';
  info: UpdateInfo;
  virtualLocations: Array<VirtualLocation>;
};

export type UpdateWorkMaterialsMutationResponse = {
  __typename?: 'UpdateWorkMaterialsMutationResponse';
  info: UpdateInfo;
  workMaterials: Array<WorkMaterial>;
};

export type UpdateZoomsMutationResponse = {
  __typename?: 'UpdateZoomsMutationResponse';
  info: UpdateInfo;
  zooms: Array<Zoom>;
};

export enum UserStatus {
  Full = 'full',
  ImpersonateOnly = 'impersonateOnly',
  Invited = 'invited',
  None = 'none',
}

export type VirtualLocation = {
  __typename?: 'VirtualLocation';
  /** If a Person is attending this online-conference, one needs to have this Relation */
  attendees: Array<Profile>;
  attendeesAggregate?: Maybe<VirtualLocationProfileAttendeesAggregationSelection>;
  attendeesConnection: VirtualLocationAttendeesConnection;
  /** Which Service should host this conference? */
  backend?: Maybe<VirtualLocationBackend>;
  backendConnection: VirtualLocationBackendConnection;
  description?: Maybe<Scalars['String']['output']>;
  features?: Maybe<Array<Scalars['String']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  organizationAggregate?: Maybe<VirtualLocationOrganizationOrganizationAggregationSelection>;
  organizationConnection: VirtualLocationOrganizationConnection;
  /** true if the conference should be running in Conference-Backend */
  running: Scalars['Boolean']['output'];
  token: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type VirtualLocationAttendeesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ProfileOptions>;
  where?: InputMaybe<ProfileWhere>;
};

export type VirtualLocationAttendeesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProfileWhere>;
};

export type VirtualLocationAttendeesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<VirtualLocationAttendeesConnectionSort>>;
  where?: InputMaybe<VirtualLocationAttendeesConnectionWhere>;
};

export type VirtualLocationBackendArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<VirtualLocationBackendWhere>;
};

export type VirtualLocationBackendConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<VirtualLocationBackendConnectionSort>>;
  where?: InputMaybe<VirtualLocationBackendConnectionWhere>;
};

export type VirtualLocationOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type VirtualLocationOrganizationAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OrganizationWhere>;
};

export type VirtualLocationOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<VirtualLocationOrganizationConnectionSort>>;
  where?: InputMaybe<VirtualLocationOrganizationConnectionWhere>;
};

export type VirtualLocationAggregateSelection = {
  __typename?: 'VirtualLocationAggregateSelection';
  count: Scalars['Int']['output'];
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  token: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

/**
 * The edge properties for the following fields:
 * * VirtualLocation.attendees
 */
export type VirtualLocationAttendeeProperties = {
  __typename?: 'VirtualLocationAttendeeProperties';
  guest?: Maybe<Scalars['Boolean']['output']>;
  joinLink?: Maybe<Scalars['String']['output']>;
  joinTime?: Maybe<Scalars['DateTime']['output']>;
  moderator?: Maybe<Scalars['Boolean']['output']>;
  withVideo?: Maybe<Scalars['Boolean']['output']>;
};

export type VirtualLocationAttendeePropertiesAggregationWhereInput = {
  AND?: InputMaybe<Array<VirtualLocationAttendeePropertiesAggregationWhereInput>>;
  NOT?: InputMaybe<VirtualLocationAttendeePropertiesAggregationWhereInput>;
  OR?: InputMaybe<Array<VirtualLocationAttendeePropertiesAggregationWhereInput>>;
  joinLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  joinLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  joinLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  joinLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  joinLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  joinLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  joinLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  joinLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  joinLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  joinLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  joinLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  joinLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  joinLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  joinLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  joinLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  joinTime_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  joinTime_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  joinTime_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  joinTime_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  joinTime_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  joinTime_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  joinTime_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  joinTime_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  joinTime_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  joinTime_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type VirtualLocationAttendeePropertiesCreateInput = {
  guest?: InputMaybe<Scalars['Boolean']['input']>;
  joinLink?: InputMaybe<Scalars['String']['input']>;
  joinTime?: InputMaybe<Scalars['DateTime']['input']>;
  moderator?: InputMaybe<Scalars['Boolean']['input']>;
  withVideo?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VirtualLocationAttendeePropertiesSort = {
  guest?: InputMaybe<SortDirection>;
  joinLink?: InputMaybe<SortDirection>;
  joinTime?: InputMaybe<SortDirection>;
  moderator?: InputMaybe<SortDirection>;
  withVideo?: InputMaybe<SortDirection>;
};

export type VirtualLocationAttendeePropertiesUpdateInput = {
  guest?: InputMaybe<Scalars['Boolean']['input']>;
  joinLink?: InputMaybe<Scalars['String']['input']>;
  joinTime?: InputMaybe<Scalars['DateTime']['input']>;
  moderator?: InputMaybe<Scalars['Boolean']['input']>;
  withVideo?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VirtualLocationAttendeePropertiesWhere = {
  AND?: InputMaybe<Array<VirtualLocationAttendeePropertiesWhere>>;
  NOT?: InputMaybe<VirtualLocationAttendeePropertiesWhere>;
  OR?: InputMaybe<Array<VirtualLocationAttendeePropertiesWhere>>;
  guest?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  guest_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  joinLink?: InputMaybe<Scalars['String']['input']>;
  joinLink_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  joinLink_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  joinLink_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  joinLink_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  joinLink_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  joinLink_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  joinLink_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  joinLink_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  joinLink_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  joinTime?: InputMaybe<Scalars['DateTime']['input']>;
  joinTime_GT?: InputMaybe<Scalars['DateTime']['input']>;
  joinTime_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  joinTime_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  joinTime_LT?: InputMaybe<Scalars['DateTime']['input']>;
  joinTime_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  joinTime_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  joinTime_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  moderator?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  moderator_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  withVideo?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  withVideo_NOT?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VirtualLocationAttendeesAggregateInput = {
  AND?: InputMaybe<Array<VirtualLocationAttendeesAggregateInput>>;
  NOT?: InputMaybe<VirtualLocationAttendeesAggregateInput>;
  OR?: InputMaybe<Array<VirtualLocationAttendeesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<VirtualLocationAttendeePropertiesAggregationWhereInput>;
  node?: InputMaybe<VirtualLocationAttendeesNodeAggregationWhereInput>;
};

export type VirtualLocationAttendeesConnectFieldInput = {
  connect?: InputMaybe<Array<ProfileConnectInput>>;
  edge?: InputMaybe<VirtualLocationAttendeePropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ProfileConnectWhere>;
};

export type VirtualLocationAttendeesConnectOrCreateFieldInput = {
  onCreate: VirtualLocationAttendeesConnectOrCreateFieldInputOnCreate;
  where: ProfileConnectOrCreateWhere;
};

export type VirtualLocationAttendeesConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<VirtualLocationAttendeePropertiesCreateInput>;
  node: ProfileOnCreateInput;
};

export type VirtualLocationAttendeesConnection = {
  __typename?: 'VirtualLocationAttendeesConnection';
  edges: Array<VirtualLocationAttendeesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type VirtualLocationAttendeesConnectionSort = {
  edge?: InputMaybe<VirtualLocationAttendeePropertiesSort>;
  node?: InputMaybe<ProfileSort>;
};

export type VirtualLocationAttendeesConnectionWhere = {
  AND?: InputMaybe<Array<VirtualLocationAttendeesConnectionWhere>>;
  NOT?: InputMaybe<VirtualLocationAttendeesConnectionWhere>;
  OR?: InputMaybe<Array<VirtualLocationAttendeesConnectionWhere>>;
  edge?: InputMaybe<VirtualLocationAttendeePropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<VirtualLocationAttendeePropertiesWhere>;
  node?: InputMaybe<ProfileWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ProfileWhere>;
};

export type VirtualLocationAttendeesCreateFieldInput = {
  edge?: InputMaybe<VirtualLocationAttendeePropertiesCreateInput>;
  node: ProfileCreateInput;
};

export type VirtualLocationAttendeesDeleteFieldInput = {
  delete?: InputMaybe<ProfileDeleteInput>;
  where?: InputMaybe<VirtualLocationAttendeesConnectionWhere>;
};

export type VirtualLocationAttendeesDisconnectFieldInput = {
  disconnect?: InputMaybe<ProfileDisconnectInput>;
  where?: InputMaybe<VirtualLocationAttendeesConnectionWhere>;
};

export type VirtualLocationAttendeesFieldInput = {
  connect?: InputMaybe<Array<VirtualLocationAttendeesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<VirtualLocationAttendeesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<VirtualLocationAttendeesCreateFieldInput>>;
};

export type VirtualLocationAttendeesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<VirtualLocationAttendeesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<VirtualLocationAttendeesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<VirtualLocationAttendeesNodeAggregationWhereInput>>;
  address1_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address1_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address2_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address2_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address3_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address3_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  birthday_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  userUuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  userUuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type VirtualLocationAttendeesRelationship = {
  __typename?: 'VirtualLocationAttendeesRelationship';
  cursor: Scalars['String']['output'];
  node: Profile;
  properties: VirtualLocationAttendeeProperties;
};

export type VirtualLocationAttendeesUpdateConnectionInput = {
  edge?: InputMaybe<VirtualLocationAttendeePropertiesUpdateInput>;
  node?: InputMaybe<ProfileUpdateInput>;
};

export type VirtualLocationAttendeesUpdateFieldInput = {
  connect?: InputMaybe<Array<VirtualLocationAttendeesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<VirtualLocationAttendeesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<VirtualLocationAttendeesCreateFieldInput>>;
  delete?: InputMaybe<Array<VirtualLocationAttendeesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<VirtualLocationAttendeesDisconnectFieldInput>>;
  update?: InputMaybe<VirtualLocationAttendeesUpdateConnectionInput>;
  where?: InputMaybe<VirtualLocationAttendeesConnectionWhere>;
};

export type VirtualLocationBackend = BigBlueButton | Zoom;

export type VirtualLocationBackendBigBlueButtonConnectFieldInput = {
  connect?: InputMaybe<BigBlueButtonConnectInput>;
  edge?: InputMaybe<VirtualLocationBackendPropertiesCreateInput>;
  where?: InputMaybe<BigBlueButtonConnectWhere>;
};

export type VirtualLocationBackendBigBlueButtonConnectionWhere = {
  AND?: InputMaybe<Array<VirtualLocationBackendBigBlueButtonConnectionWhere>>;
  NOT?: InputMaybe<VirtualLocationBackendBigBlueButtonConnectionWhere>;
  OR?: InputMaybe<Array<VirtualLocationBackendBigBlueButtonConnectionWhere>>;
  edge?: InputMaybe<VirtualLocationBackendPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<VirtualLocationBackendPropertiesWhere>;
  node?: InputMaybe<BigBlueButtonWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<BigBlueButtonWhere>;
};

export type VirtualLocationBackendBigBlueButtonCreateFieldInput = {
  edge?: InputMaybe<VirtualLocationBackendPropertiesCreateInput>;
  node: BigBlueButtonCreateInput;
};

export type VirtualLocationBackendBigBlueButtonDeleteFieldInput = {
  delete?: InputMaybe<BigBlueButtonDeleteInput>;
  where?: InputMaybe<VirtualLocationBackendBigBlueButtonConnectionWhere>;
};

export type VirtualLocationBackendBigBlueButtonDisconnectFieldInput = {
  disconnect?: InputMaybe<BigBlueButtonDisconnectInput>;
  where?: InputMaybe<VirtualLocationBackendBigBlueButtonConnectionWhere>;
};

export type VirtualLocationBackendBigBlueButtonFieldInput = {
  connect?: InputMaybe<VirtualLocationBackendBigBlueButtonConnectFieldInput>;
  create?: InputMaybe<VirtualLocationBackendBigBlueButtonCreateFieldInput>;
};

export type VirtualLocationBackendBigBlueButtonUpdateConnectionInput = {
  edge?: InputMaybe<VirtualLocationBackendPropertiesUpdateInput>;
  node?: InputMaybe<BigBlueButtonUpdateInput>;
};

export type VirtualLocationBackendBigBlueButtonUpdateFieldInput = {
  connect?: InputMaybe<VirtualLocationBackendBigBlueButtonConnectFieldInput>;
  create?: InputMaybe<VirtualLocationBackendBigBlueButtonCreateFieldInput>;
  delete?: InputMaybe<VirtualLocationBackendBigBlueButtonDeleteFieldInput>;
  disconnect?: InputMaybe<VirtualLocationBackendBigBlueButtonDisconnectFieldInput>;
  update?: InputMaybe<VirtualLocationBackendBigBlueButtonUpdateConnectionInput>;
  where?: InputMaybe<VirtualLocationBackendBigBlueButtonConnectionWhere>;
};

export type VirtualLocationBackendConnectInput = {
  BigBlueButton?: InputMaybe<VirtualLocationBackendBigBlueButtonConnectFieldInput>;
  Zoom?: InputMaybe<VirtualLocationBackendZoomConnectFieldInput>;
};

export type VirtualLocationBackendConnection = {
  __typename?: 'VirtualLocationBackendConnection';
  edges: Array<VirtualLocationBackendRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type VirtualLocationBackendConnectionSort = {
  edge?: InputMaybe<VirtualLocationBackendPropertiesSort>;
};

export type VirtualLocationBackendConnectionWhere = {
  BigBlueButton?: InputMaybe<VirtualLocationBackendBigBlueButtonConnectionWhere>;
  Zoom?: InputMaybe<VirtualLocationBackendZoomConnectionWhere>;
};

export type VirtualLocationBackendCreateInput = {
  BigBlueButton?: InputMaybe<VirtualLocationBackendBigBlueButtonFieldInput>;
  Zoom?: InputMaybe<VirtualLocationBackendZoomFieldInput>;
};

export type VirtualLocationBackendDeleteInput = {
  BigBlueButton?: InputMaybe<VirtualLocationBackendBigBlueButtonDeleteFieldInput>;
  Zoom?: InputMaybe<VirtualLocationBackendZoomDeleteFieldInput>;
};

export type VirtualLocationBackendDisconnectInput = {
  BigBlueButton?: InputMaybe<VirtualLocationBackendBigBlueButtonDisconnectFieldInput>;
  Zoom?: InputMaybe<VirtualLocationBackendZoomDisconnectFieldInput>;
};

/**
 * The edge properties for the following fields:
 * * VirtualLocation.backend
 */
export type VirtualLocationBackendProperties = {
  __typename?: 'VirtualLocationBackendProperties';
  backendId?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  metadata?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
};

export type VirtualLocationBackendPropertiesCreateInput = {
  backendId?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type VirtualLocationBackendPropertiesSort = {
  backendId?: InputMaybe<SortDirection>;
  endTime?: InputMaybe<SortDirection>;
  metadata?: InputMaybe<SortDirection>;
  startTime?: InputMaybe<SortDirection>;
};

export type VirtualLocationBackendPropertiesUpdateInput = {
  backendId?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type VirtualLocationBackendPropertiesWhere = {
  AND?: InputMaybe<Array<VirtualLocationBackendPropertiesWhere>>;
  NOT?: InputMaybe<VirtualLocationBackendPropertiesWhere>;
  OR?: InputMaybe<Array<VirtualLocationBackendPropertiesWhere>>;
  backendId?: InputMaybe<Scalars['String']['input']>;
  backendId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  backendId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  backendId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  backendId_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  backendId_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  backendId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  backendId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  backendId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  backendId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  endTime_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endTime_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endTime_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  endTime_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endTime_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  endTime_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  endTime_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  metadata_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  metadata_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  metadata_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  metadata_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  metadata_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  metadata_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  metadata_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  metadata_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  metadata_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  startTime_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startTime_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startTime_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  startTime_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startTime_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  startTime_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  startTime_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export type VirtualLocationBackendRelationship = {
  __typename?: 'VirtualLocationBackendRelationship';
  cursor: Scalars['String']['output'];
  node: VirtualLocationBackend;
  properties: VirtualLocationBackendProperties;
};

export type VirtualLocationBackendUpdateInput = {
  BigBlueButton?: InputMaybe<VirtualLocationBackendBigBlueButtonUpdateFieldInput>;
  Zoom?: InputMaybe<VirtualLocationBackendZoomUpdateFieldInput>;
};

export type VirtualLocationBackendWhere = {
  BigBlueButton?: InputMaybe<BigBlueButtonWhere>;
  Zoom?: InputMaybe<ZoomWhere>;
};

export type VirtualLocationBackendZoomConnectFieldInput = {
  connect?: InputMaybe<ZoomConnectInput>;
  edge?: InputMaybe<VirtualLocationBackendPropertiesCreateInput>;
  where?: InputMaybe<ZoomConnectWhere>;
};

export type VirtualLocationBackendZoomConnectionWhere = {
  AND?: InputMaybe<Array<VirtualLocationBackendZoomConnectionWhere>>;
  NOT?: InputMaybe<VirtualLocationBackendZoomConnectionWhere>;
  OR?: InputMaybe<Array<VirtualLocationBackendZoomConnectionWhere>>;
  edge?: InputMaybe<VirtualLocationBackendPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<VirtualLocationBackendPropertiesWhere>;
  node?: InputMaybe<ZoomWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ZoomWhere>;
};

export type VirtualLocationBackendZoomCreateFieldInput = {
  edge?: InputMaybe<VirtualLocationBackendPropertiesCreateInput>;
  node: ZoomCreateInput;
};

export type VirtualLocationBackendZoomDeleteFieldInput = {
  delete?: InputMaybe<ZoomDeleteInput>;
  where?: InputMaybe<VirtualLocationBackendZoomConnectionWhere>;
};

export type VirtualLocationBackendZoomDisconnectFieldInput = {
  disconnect?: InputMaybe<ZoomDisconnectInput>;
  where?: InputMaybe<VirtualLocationBackendZoomConnectionWhere>;
};

export type VirtualLocationBackendZoomFieldInput = {
  connect?: InputMaybe<VirtualLocationBackendZoomConnectFieldInput>;
  create?: InputMaybe<VirtualLocationBackendZoomCreateFieldInput>;
};

export type VirtualLocationBackendZoomUpdateConnectionInput = {
  edge?: InputMaybe<VirtualLocationBackendPropertiesUpdateInput>;
  node?: InputMaybe<ZoomUpdateInput>;
};

export type VirtualLocationBackendZoomUpdateFieldInput = {
  connect?: InputMaybe<VirtualLocationBackendZoomConnectFieldInput>;
  create?: InputMaybe<VirtualLocationBackendZoomCreateFieldInput>;
  delete?: InputMaybe<VirtualLocationBackendZoomDeleteFieldInput>;
  disconnect?: InputMaybe<VirtualLocationBackendZoomDisconnectFieldInput>;
  update?: InputMaybe<VirtualLocationBackendZoomUpdateConnectionInput>;
  where?: InputMaybe<VirtualLocationBackendZoomConnectionWhere>;
};

export type VirtualLocationConnectInput = {
  attendees?: InputMaybe<Array<VirtualLocationAttendeesConnectFieldInput>>;
  backend?: InputMaybe<VirtualLocationBackendConnectInput>;
  organization?: InputMaybe<VirtualLocationOrganizationConnectFieldInput>;
};

export type VirtualLocationConnectWhere = {
  node: VirtualLocationWhere;
};

export type VirtualLocationCreateInput = {
  attendees?: InputMaybe<VirtualLocationAttendeesFieldInput>;
  backend?: InputMaybe<VirtualLocationBackendCreateInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<VirtualLocationOrganizationFieldInput>;
  running: Scalars['Boolean']['input'];
  token: Scalars['String']['input'];
};

export type VirtualLocationDeleteInput = {
  attendees?: InputMaybe<Array<VirtualLocationAttendeesDeleteFieldInput>>;
  backend?: InputMaybe<VirtualLocationBackendDeleteInput>;
  organization?: InputMaybe<VirtualLocationOrganizationDeleteFieldInput>;
};

export type VirtualLocationDisconnectInput = {
  attendees?: InputMaybe<Array<VirtualLocationAttendeesDisconnectFieldInput>>;
  backend?: InputMaybe<VirtualLocationBackendDisconnectInput>;
  organization?: InputMaybe<VirtualLocationOrganizationDisconnectFieldInput>;
};

export type VirtualLocationEdge = {
  __typename?: 'VirtualLocationEdge';
  cursor: Scalars['String']['output'];
  node: VirtualLocation;
};

export type VirtualLocationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more VirtualLocationSort objects to sort VirtualLocations by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<VirtualLocationSort>>;
};

export type VirtualLocationOrganizationAggregateInput = {
  AND?: InputMaybe<Array<VirtualLocationOrganizationAggregateInput>>;
  NOT?: InputMaybe<VirtualLocationOrganizationAggregateInput>;
  OR?: InputMaybe<Array<VirtualLocationOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<VirtualLocationOrganizationNodeAggregationWhereInput>;
};

export type VirtualLocationOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type VirtualLocationOrganizationConnectOrCreateFieldInput = {
  onCreate: VirtualLocationOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type VirtualLocationOrganizationConnectOrCreateFieldInputOnCreate = {
  node: OrganizationOnCreateInput;
};

export type VirtualLocationOrganizationConnection = {
  __typename?: 'VirtualLocationOrganizationConnection';
  edges: Array<VirtualLocationOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type VirtualLocationOrganizationConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type VirtualLocationOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<VirtualLocationOrganizationConnectionWhere>>;
  NOT?: InputMaybe<VirtualLocationOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<VirtualLocationOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type VirtualLocationOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type VirtualLocationOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<VirtualLocationOrganizationConnectionWhere>;
};

export type VirtualLocationOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<VirtualLocationOrganizationConnectionWhere>;
};

export type VirtualLocationOrganizationFieldInput = {
  connect?: InputMaybe<VirtualLocationOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<VirtualLocationOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<VirtualLocationOrganizationCreateFieldInput>;
};

export type VirtualLocationOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<VirtualLocationOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<VirtualLocationOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<VirtualLocationOrganizationNodeAggregationWhereInput>>;
  aboutInfoLastUpdated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type VirtualLocationOrganizationOrganizationAggregationSelection = {
  __typename?: 'VirtualLocationOrganizationOrganizationAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<VirtualLocationOrganizationOrganizationNodeAggregateSelection>;
};

export type VirtualLocationOrganizationOrganizationNodeAggregateSelection = {
  __typename?: 'VirtualLocationOrganizationOrganizationNodeAggregateSelection';
  aboutInfo: StringAggregateSelection;
  aboutInfoLastUpdated: DateTimeAggregateSelection;
  displayName: StringAggregateSelection;
  matrixRoomId: StringAggregateSelection;
  planungSyncProps: StringAggregateSelection;
  procuratSyncProps: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type VirtualLocationOrganizationRelationship = {
  __typename?: 'VirtualLocationOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type VirtualLocationOrganizationUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type VirtualLocationOrganizationUpdateFieldInput = {
  connect?: InputMaybe<VirtualLocationOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<VirtualLocationOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<VirtualLocationOrganizationCreateFieldInput>;
  delete?: InputMaybe<VirtualLocationOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<VirtualLocationOrganizationDisconnectFieldInput>;
  update?: InputMaybe<VirtualLocationOrganizationUpdateConnectionInput>;
  where?: InputMaybe<VirtualLocationOrganizationConnectionWhere>;
};

export type VirtualLocationProfileAttendeesAggregationSelection = {
  __typename?: 'VirtualLocationProfileAttendeesAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<VirtualLocationProfileAttendeesEdgeAggregateSelection>;
  node?: Maybe<VirtualLocationProfileAttendeesNodeAggregateSelection>;
};

export type VirtualLocationProfileAttendeesEdgeAggregateSelection = {
  __typename?: 'VirtualLocationProfileAttendeesEdgeAggregateSelection';
  joinLink: StringAggregateSelection;
  joinTime: DateTimeAggregateSelection;
};

export type VirtualLocationProfileAttendeesNodeAggregateSelection = {
  __typename?: 'VirtualLocationProfileAttendeesNodeAggregateSelection';
  address1: StringAggregateSelection;
  address2: StringAggregateSelection;
  address3: StringAggregateSelection;
  birthday: StringAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  email: StringAggregateSelection;
  firstName: StringAggregateSelection;
  firstNames: StringAggregateSelection;
  lastName: StringAggregateSelection;
  managedBy: StringAggregateSelection;
  matrixToken: StringAggregateSelection;
  nextcloudUserId: StringAggregateSelection;
  prefixName: StringAggregateSelection;
  salutation: StringAggregateSelection;
  shortName: StringAggregateSelection;
  threemaId: StringAggregateSelection;
  title: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  userUuid: StringAggregateSelection;
  uuid: IdAggregateSelection;
  zoomUserId: StringAggregateSelection;
};

/** Fields to sort VirtualLocations by. The order in which sorts are applied is not guaranteed when specifying many fields in one VirtualLocationSort object. */
export type VirtualLocationSort = {
  description?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  running?: InputMaybe<SortDirection>;
  token?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type VirtualLocationUpdateInput = {
  attendees?: InputMaybe<Array<VirtualLocationAttendeesUpdateFieldInput>>;
  backend?: InputMaybe<VirtualLocationBackendUpdateInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<Array<Scalars['String']['input']>>;
  features_POP?: InputMaybe<Scalars['Int']['input']>;
  features_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<VirtualLocationOrganizationUpdateFieldInput>;
  running?: InputMaybe<Scalars['Boolean']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type VirtualLocationWhere = {
  AND?: InputMaybe<Array<VirtualLocationWhere>>;
  NOT?: InputMaybe<VirtualLocationWhere>;
  OR?: InputMaybe<Array<VirtualLocationWhere>>;
  /** @deprecated Use `attendees_SOME` instead. */
  attendees?: InputMaybe<ProfileWhere>;
  attendeesAggregate?: InputMaybe<VirtualLocationAttendeesAggregateInput>;
  /** @deprecated Use `attendeesConnection_SOME` instead. */
  attendeesConnection?: InputMaybe<VirtualLocationAttendeesConnectionWhere>;
  /** Return VirtualLocations where all of the related VirtualLocationAttendeesConnections match this filter */
  attendeesConnection_ALL?: InputMaybe<VirtualLocationAttendeesConnectionWhere>;
  /** Return VirtualLocations where none of the related VirtualLocationAttendeesConnections match this filter */
  attendeesConnection_NONE?: InputMaybe<VirtualLocationAttendeesConnectionWhere>;
  /** @deprecated Use `attendeesConnection_NONE` instead. */
  attendeesConnection_NOT?: InputMaybe<VirtualLocationAttendeesConnectionWhere>;
  /** Return VirtualLocations where one of the related VirtualLocationAttendeesConnections match this filter */
  attendeesConnection_SINGLE?: InputMaybe<VirtualLocationAttendeesConnectionWhere>;
  /** Return VirtualLocations where some of the related VirtualLocationAttendeesConnections match this filter */
  attendeesConnection_SOME?: InputMaybe<VirtualLocationAttendeesConnectionWhere>;
  /** Return VirtualLocations where all of the related Profiles match this filter */
  attendees_ALL?: InputMaybe<ProfileWhere>;
  /** Return VirtualLocations where none of the related Profiles match this filter */
  attendees_NONE?: InputMaybe<ProfileWhere>;
  /** @deprecated Use `attendees_NONE` instead. */
  attendees_NOT?: InputMaybe<ProfileWhere>;
  /** Return VirtualLocations where one of the related Profiles match this filter */
  attendees_SINGLE?: InputMaybe<ProfileWhere>;
  /** Return VirtualLocations where some of the related Profiles match this filter */
  attendees_SOME?: InputMaybe<ProfileWhere>;
  backend?: InputMaybe<VirtualLocationBackendWhere>;
  backendConnection?: InputMaybe<VirtualLocationBackendConnectionWhere>;
  backendConnection_NOT?: InputMaybe<VirtualLocationBackendConnectionWhere>;
  backend_NOT?: InputMaybe<VirtualLocationBackendWhere>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<Array<Scalars['String']['input']>>;
  features_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  features_NOT?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  features_NOT_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<VirtualLocationOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<VirtualLocationOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<VirtualLocationOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  running?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  running_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  token_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  token_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  token_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  token_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  token_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  token_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  token_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  token_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  token_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type VirtualLocationsConnection = {
  __typename?: 'VirtualLocationsConnection';
  edges: Array<VirtualLocationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type WorkMaterial = {
  __typename?: 'WorkMaterial';
  created: Scalars['DateTime']['output'];
  holder: WorkMaterialHolder;
  holderConnection: WorkMaterialHolderConnection;
  material: Material;
  materialConnection: WorkMaterialMaterialConnection;
  owner: Profile;
  ownerConnection: WorkMaterialOwnerConnection;
  publicFrom?: Maybe<Day>;
  publicFromConnection: WorkMaterialPublicFromConnection;
  title: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  uuid: Scalars['ID']['output'];
  visibleAfterVisibleTo?: Maybe<Scalars['Boolean']['output']>;
  visibleFrom?: Maybe<Day>;
  visibleFromConnection: WorkMaterialVisibleFromConnection;
  visibleTo?: Maybe<Day>;
  visibleToConnection: WorkMaterialVisibleToConnection;
};

export type WorkMaterialHolderArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<WorkMaterialHolderWhere>;
};

export type WorkMaterialHolderConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WorkMaterialHolderConnectionWhere>;
};

export type WorkMaterialMaterialArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<MaterialOptions>;
  where?: InputMaybe<MaterialWhere>;
};

export type WorkMaterialMaterialConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<WorkMaterialMaterialConnectionSort>>;
  where?: InputMaybe<WorkMaterialMaterialConnectionWhere>;
};

export type WorkMaterialOwnerArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ProfileOptions>;
  where?: InputMaybe<ProfileWhere>;
};

export type WorkMaterialOwnerConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<WorkMaterialOwnerConnectionSort>>;
  where?: InputMaybe<WorkMaterialOwnerConnectionWhere>;
};

export type WorkMaterialPublicFromArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DayOptions>;
  where?: InputMaybe<DayWhere>;
};

export type WorkMaterialPublicFromConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<WorkMaterialPublicFromConnectionSort>>;
  where?: InputMaybe<WorkMaterialPublicFromConnectionWhere>;
};

export type WorkMaterialVisibleFromArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DayOptions>;
  where?: InputMaybe<DayWhere>;
};

export type WorkMaterialVisibleFromConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<WorkMaterialVisibleFromConnectionSort>>;
  where?: InputMaybe<WorkMaterialVisibleFromConnectionWhere>;
};

export type WorkMaterialVisibleToArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DayOptions>;
  where?: InputMaybe<DayWhere>;
};

export type WorkMaterialVisibleToConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<WorkMaterialVisibleToConnectionSort>>;
  where?: InputMaybe<WorkMaterialVisibleToConnectionWhere>;
};

export type WorkMaterialAggregateSelection = {
  __typename?: 'WorkMaterialAggregateSelection';
  count: Scalars['Int']['output'];
  created: DateTimeAggregateSelection;
  title: StringAggregateSelection;
  updated: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type WorkMaterialConnectInput = {
  holder?: InputMaybe<WorkMaterialHolderConnectInput>;
  material?: InputMaybe<WorkMaterialMaterialConnectFieldInput>;
  owner?: InputMaybe<WorkMaterialOwnerConnectFieldInput>;
  publicFrom?: InputMaybe<WorkMaterialPublicFromConnectFieldInput>;
  visibleFrom?: InputMaybe<WorkMaterialVisibleFromConnectFieldInput>;
  visibleTo?: InputMaybe<WorkMaterialVisibleToConnectFieldInput>;
};

export type WorkMaterialConnectWhere = {
  node: WorkMaterialWhere;
};

export type WorkMaterialCreateInput = {
  holder?: InputMaybe<WorkMaterialHolderCreateInput>;
  material?: InputMaybe<WorkMaterialMaterialFieldInput>;
  owner?: InputMaybe<WorkMaterialOwnerFieldInput>;
  publicFrom?: InputMaybe<WorkMaterialPublicFromFieldInput>;
  title: Scalars['String']['input'];
  visibleAfterVisibleTo?: InputMaybe<Scalars['Boolean']['input']>;
  visibleFrom?: InputMaybe<WorkMaterialVisibleFromFieldInput>;
  visibleTo?: InputMaybe<WorkMaterialVisibleToFieldInput>;
};

export type WorkMaterialDeleteInput = {
  holder?: InputMaybe<WorkMaterialHolderDeleteInput>;
  material?: InputMaybe<WorkMaterialMaterialDeleteFieldInput>;
  owner?: InputMaybe<WorkMaterialOwnerDeleteFieldInput>;
  publicFrom?: InputMaybe<WorkMaterialPublicFromDeleteFieldInput>;
  visibleFrom?: InputMaybe<WorkMaterialVisibleFromDeleteFieldInput>;
  visibleTo?: InputMaybe<WorkMaterialVisibleToDeleteFieldInput>;
};

export type WorkMaterialDisconnectInput = {
  holder?: InputMaybe<WorkMaterialHolderDisconnectInput>;
  material?: InputMaybe<WorkMaterialMaterialDisconnectFieldInput>;
  owner?: InputMaybe<WorkMaterialOwnerDisconnectFieldInput>;
  publicFrom?: InputMaybe<WorkMaterialPublicFromDisconnectFieldInput>;
  visibleFrom?: InputMaybe<WorkMaterialVisibleFromDisconnectFieldInput>;
  visibleTo?: InputMaybe<WorkMaterialVisibleToDisconnectFieldInput>;
};

export type WorkMaterialEdge = {
  __typename?: 'WorkMaterialEdge';
  cursor: Scalars['String']['output'];
  node: WorkMaterial;
};

export type WorkMaterialHolder = TeachingUnit;

export type WorkMaterialHolderConnectInput = {
  TeachingUnit?: InputMaybe<WorkMaterialHolderTeachingUnitConnectFieldInput>;
};

export type WorkMaterialHolderConnection = {
  __typename?: 'WorkMaterialHolderConnection';
  edges: Array<WorkMaterialHolderRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type WorkMaterialHolderConnectionWhere = {
  TeachingUnit?: InputMaybe<WorkMaterialHolderTeachingUnitConnectionWhere>;
};

export type WorkMaterialHolderCreateInput = {
  TeachingUnit?: InputMaybe<WorkMaterialHolderTeachingUnitFieldInput>;
};

export type WorkMaterialHolderDeleteInput = {
  TeachingUnit?: InputMaybe<WorkMaterialHolderTeachingUnitDeleteFieldInput>;
};

export type WorkMaterialHolderDisconnectInput = {
  TeachingUnit?: InputMaybe<WorkMaterialHolderTeachingUnitDisconnectFieldInput>;
};

export type WorkMaterialHolderRelationship = {
  __typename?: 'WorkMaterialHolderRelationship';
  cursor: Scalars['String']['output'];
  node: WorkMaterialHolder;
};

export type WorkMaterialHolderTeachingUnitConnectFieldInput = {
  connect?: InputMaybe<TeachingUnitConnectInput>;
  where?: InputMaybe<TeachingUnitConnectWhere>;
};

export type WorkMaterialHolderTeachingUnitConnectionWhere = {
  AND?: InputMaybe<Array<WorkMaterialHolderTeachingUnitConnectionWhere>>;
  NOT?: InputMaybe<WorkMaterialHolderTeachingUnitConnectionWhere>;
  OR?: InputMaybe<Array<WorkMaterialHolderTeachingUnitConnectionWhere>>;
  node?: InputMaybe<TeachingUnitWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TeachingUnitWhere>;
};

export type WorkMaterialHolderTeachingUnitCreateFieldInput = {
  node: TeachingUnitCreateInput;
};

export type WorkMaterialHolderTeachingUnitDeleteFieldInput = {
  delete?: InputMaybe<TeachingUnitDeleteInput>;
  where?: InputMaybe<WorkMaterialHolderTeachingUnitConnectionWhere>;
};

export type WorkMaterialHolderTeachingUnitDisconnectFieldInput = {
  disconnect?: InputMaybe<TeachingUnitDisconnectInput>;
  where?: InputMaybe<WorkMaterialHolderTeachingUnitConnectionWhere>;
};

export type WorkMaterialHolderTeachingUnitFieldInput = {
  connect?: InputMaybe<WorkMaterialHolderTeachingUnitConnectFieldInput>;
  create?: InputMaybe<WorkMaterialHolderTeachingUnitCreateFieldInput>;
};

export type WorkMaterialHolderTeachingUnitUpdateConnectionInput = {
  node?: InputMaybe<TeachingUnitUpdateInput>;
};

export type WorkMaterialHolderTeachingUnitUpdateFieldInput = {
  connect?: InputMaybe<WorkMaterialHolderTeachingUnitConnectFieldInput>;
  create?: InputMaybe<WorkMaterialHolderTeachingUnitCreateFieldInput>;
  delete?: InputMaybe<WorkMaterialHolderTeachingUnitDeleteFieldInput>;
  disconnect?: InputMaybe<WorkMaterialHolderTeachingUnitDisconnectFieldInput>;
  update?: InputMaybe<WorkMaterialHolderTeachingUnitUpdateConnectionInput>;
  where?: InputMaybe<WorkMaterialHolderTeachingUnitConnectionWhere>;
};

export type WorkMaterialHolderUpdateInput = {
  TeachingUnit?: InputMaybe<WorkMaterialHolderTeachingUnitUpdateFieldInput>;
};

export type WorkMaterialHolderWhere = {
  TeachingUnit?: InputMaybe<TeachingUnitWhere>;
};

export type WorkMaterialMaterialAggregateInput = {
  AND?: InputMaybe<Array<WorkMaterialMaterialAggregateInput>>;
  NOT?: InputMaybe<WorkMaterialMaterialAggregateInput>;
  OR?: InputMaybe<Array<WorkMaterialMaterialAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<WorkMaterialMaterialNodeAggregationWhereInput>;
};

export type WorkMaterialMaterialConnectFieldInput = {
  connect?: InputMaybe<MaterialConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<MaterialConnectWhere>;
};

export type WorkMaterialMaterialConnection = {
  __typename?: 'WorkMaterialMaterialConnection';
  edges: Array<WorkMaterialMaterialRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type WorkMaterialMaterialConnectionSort = {
  node?: InputMaybe<MaterialSort>;
};

export type WorkMaterialMaterialConnectionWhere = {
  AND?: InputMaybe<Array<WorkMaterialMaterialConnectionWhere>>;
  NOT?: InputMaybe<WorkMaterialMaterialConnectionWhere>;
  OR?: InputMaybe<Array<WorkMaterialMaterialConnectionWhere>>;
  node?: InputMaybe<MaterialWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<MaterialWhere>;
};

export type WorkMaterialMaterialCreateFieldInput = {
  node: MaterialCreateInput;
};

export type WorkMaterialMaterialDeleteFieldInput = {
  delete?: InputMaybe<MaterialDeleteInput>;
  where?: InputMaybe<WorkMaterialMaterialConnectionWhere>;
};

export type WorkMaterialMaterialDisconnectFieldInput = {
  disconnect?: InputMaybe<MaterialDisconnectInput>;
  where?: InputMaybe<WorkMaterialMaterialConnectionWhere>;
};

export type WorkMaterialMaterialFieldInput = {
  connect?: InputMaybe<WorkMaterialMaterialConnectFieldInput>;
  create?: InputMaybe<WorkMaterialMaterialCreateFieldInput>;
};

export type WorkMaterialMaterialNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<WorkMaterialMaterialNodeAggregationWhereInput>>;
  NOT?: InputMaybe<WorkMaterialMaterialNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<WorkMaterialMaterialNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  textMediaType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  textMediaType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  textMediaType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  textMediaType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  textMediaType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  textMediaType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  textMediaType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  textMediaType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  textMediaType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  textMediaType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  textMediaType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  textMediaType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  textMediaType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  textMediaType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  textMediaType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  text_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  text_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type WorkMaterialMaterialRelationship = {
  __typename?: 'WorkMaterialMaterialRelationship';
  cursor: Scalars['String']['output'];
  node: Material;
};

export type WorkMaterialMaterialUpdateConnectionInput = {
  node?: InputMaybe<MaterialUpdateInput>;
};

export type WorkMaterialMaterialUpdateFieldInput = {
  connect?: InputMaybe<WorkMaterialMaterialConnectFieldInput>;
  create?: InputMaybe<WorkMaterialMaterialCreateFieldInput>;
  delete?: InputMaybe<WorkMaterialMaterialDeleteFieldInput>;
  disconnect?: InputMaybe<WorkMaterialMaterialDisconnectFieldInput>;
  update?: InputMaybe<WorkMaterialMaterialUpdateConnectionInput>;
  where?: InputMaybe<WorkMaterialMaterialConnectionWhere>;
};

export type WorkMaterialOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more WorkMaterialSort objects to sort WorkMaterials by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<WorkMaterialSort>>;
};

export type WorkMaterialOwnerAggregateInput = {
  AND?: InputMaybe<Array<WorkMaterialOwnerAggregateInput>>;
  NOT?: InputMaybe<WorkMaterialOwnerAggregateInput>;
  OR?: InputMaybe<Array<WorkMaterialOwnerAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<WorkMaterialOwnerNodeAggregationWhereInput>;
};

export type WorkMaterialOwnerConnectFieldInput = {
  connect?: InputMaybe<ProfileConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ProfileConnectWhere>;
};

export type WorkMaterialOwnerConnectOrCreateFieldInput = {
  onCreate: WorkMaterialOwnerConnectOrCreateFieldInputOnCreate;
  where: ProfileConnectOrCreateWhere;
};

export type WorkMaterialOwnerConnectOrCreateFieldInputOnCreate = {
  node: ProfileOnCreateInput;
};

export type WorkMaterialOwnerConnection = {
  __typename?: 'WorkMaterialOwnerConnection';
  edges: Array<WorkMaterialOwnerRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type WorkMaterialOwnerConnectionSort = {
  node?: InputMaybe<ProfileSort>;
};

export type WorkMaterialOwnerConnectionWhere = {
  AND?: InputMaybe<Array<WorkMaterialOwnerConnectionWhere>>;
  NOT?: InputMaybe<WorkMaterialOwnerConnectionWhere>;
  OR?: InputMaybe<Array<WorkMaterialOwnerConnectionWhere>>;
  node?: InputMaybe<ProfileWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ProfileWhere>;
};

export type WorkMaterialOwnerCreateFieldInput = {
  node: ProfileCreateInput;
};

export type WorkMaterialOwnerDeleteFieldInput = {
  delete?: InputMaybe<ProfileDeleteInput>;
  where?: InputMaybe<WorkMaterialOwnerConnectionWhere>;
};

export type WorkMaterialOwnerDisconnectFieldInput = {
  disconnect?: InputMaybe<ProfileDisconnectInput>;
  where?: InputMaybe<WorkMaterialOwnerConnectionWhere>;
};

export type WorkMaterialOwnerFieldInput = {
  connect?: InputMaybe<WorkMaterialOwnerConnectFieldInput>;
  connectOrCreate?: InputMaybe<WorkMaterialOwnerConnectOrCreateFieldInput>;
  create?: InputMaybe<WorkMaterialOwnerCreateFieldInput>;
};

export type WorkMaterialOwnerNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<WorkMaterialOwnerNodeAggregationWhereInput>>;
  NOT?: InputMaybe<WorkMaterialOwnerNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<WorkMaterialOwnerNodeAggregationWhereInput>>;
  address1_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address1_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address1_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address1_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address1_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address2_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address2_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address2_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address2_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address2_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address3_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  address3_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  address3_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address3_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  address3_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  birthday_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  birthday_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  birthday_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  birthday_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  managedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  managedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  managedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  nextcloudUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nextcloudUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  threemaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  threemaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threemaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  userUuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  userUuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  userUuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userUuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  zoomUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zoomUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkMaterialOwnerRelationship = {
  __typename?: 'WorkMaterialOwnerRelationship';
  cursor: Scalars['String']['output'];
  node: Profile;
};

export type WorkMaterialOwnerUpdateConnectionInput = {
  node?: InputMaybe<ProfileUpdateInput>;
};

export type WorkMaterialOwnerUpdateFieldInput = {
  connect?: InputMaybe<WorkMaterialOwnerConnectFieldInput>;
  connectOrCreate?: InputMaybe<WorkMaterialOwnerConnectOrCreateFieldInput>;
  create?: InputMaybe<WorkMaterialOwnerCreateFieldInput>;
  delete?: InputMaybe<WorkMaterialOwnerDeleteFieldInput>;
  disconnect?: InputMaybe<WorkMaterialOwnerDisconnectFieldInput>;
  update?: InputMaybe<WorkMaterialOwnerUpdateConnectionInput>;
  where?: InputMaybe<WorkMaterialOwnerConnectionWhere>;
};

export type WorkMaterialPublicFromAggregateInput = {
  AND?: InputMaybe<Array<WorkMaterialPublicFromAggregateInput>>;
  NOT?: InputMaybe<WorkMaterialPublicFromAggregateInput>;
  OR?: InputMaybe<Array<WorkMaterialPublicFromAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<WorkMaterialPublicFromNodeAggregationWhereInput>;
};

export type WorkMaterialPublicFromConnectFieldInput = {
  connect?: InputMaybe<DayConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<DayConnectWhere>;
};

export type WorkMaterialPublicFromConnectOrCreateFieldInput = {
  onCreate: WorkMaterialPublicFromConnectOrCreateFieldInputOnCreate;
  where: DayConnectOrCreateWhere;
};

export type WorkMaterialPublicFromConnectOrCreateFieldInputOnCreate = {
  node: DayOnCreateInput;
};

export type WorkMaterialPublicFromConnection = {
  __typename?: 'WorkMaterialPublicFromConnection';
  edges: Array<WorkMaterialPublicFromRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type WorkMaterialPublicFromConnectionSort = {
  node?: InputMaybe<DaySort>;
};

export type WorkMaterialPublicFromConnectionWhere = {
  AND?: InputMaybe<Array<WorkMaterialPublicFromConnectionWhere>>;
  NOT?: InputMaybe<WorkMaterialPublicFromConnectionWhere>;
  OR?: InputMaybe<Array<WorkMaterialPublicFromConnectionWhere>>;
  node?: InputMaybe<DayWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<DayWhere>;
};

export type WorkMaterialPublicFromCreateFieldInput = {
  node: DayCreateInput;
};

export type WorkMaterialPublicFromDeleteFieldInput = {
  delete?: InputMaybe<DayDeleteInput>;
  where?: InputMaybe<WorkMaterialPublicFromConnectionWhere>;
};

export type WorkMaterialPublicFromDisconnectFieldInput = {
  disconnect?: InputMaybe<DayDisconnectInput>;
  where?: InputMaybe<WorkMaterialPublicFromConnectionWhere>;
};

export type WorkMaterialPublicFromFieldInput = {
  connect?: InputMaybe<WorkMaterialPublicFromConnectFieldInput>;
  connectOrCreate?: InputMaybe<WorkMaterialPublicFromConnectOrCreateFieldInput>;
  create?: InputMaybe<WorkMaterialPublicFromCreateFieldInput>;
};

export type WorkMaterialPublicFromNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<WorkMaterialPublicFromNodeAggregationWhereInput>>;
  NOT?: InputMaybe<WorkMaterialPublicFromNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<WorkMaterialPublicFromNodeAggregationWhereInput>>;
  date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  day_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  day_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  day_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  day_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  day_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  day_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  day_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  day_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  day_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  day_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  month_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  month_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  month_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  month_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  month_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  month_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  month_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  month_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  month_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  month_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  week_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  week_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  week_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  week_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  week_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  week_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  week_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  week_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  week_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  week_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  year_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  year_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkMaterialPublicFromRelationship = {
  __typename?: 'WorkMaterialPublicFromRelationship';
  cursor: Scalars['String']['output'];
  node: Day;
};

export type WorkMaterialPublicFromUpdateConnectionInput = {
  node?: InputMaybe<DayUpdateInput>;
};

export type WorkMaterialPublicFromUpdateFieldInput = {
  connect?: InputMaybe<WorkMaterialPublicFromConnectFieldInput>;
  connectOrCreate?: InputMaybe<WorkMaterialPublicFromConnectOrCreateFieldInput>;
  create?: InputMaybe<WorkMaterialPublicFromCreateFieldInput>;
  delete?: InputMaybe<WorkMaterialPublicFromDeleteFieldInput>;
  disconnect?: InputMaybe<WorkMaterialPublicFromDisconnectFieldInput>;
  update?: InputMaybe<WorkMaterialPublicFromUpdateConnectionInput>;
  where?: InputMaybe<WorkMaterialPublicFromConnectionWhere>;
};

/** Fields to sort WorkMaterials by. The order in which sorts are applied is not guaranteed when specifying many fields in one WorkMaterialSort object. */
export type WorkMaterialSort = {
  created?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
  updated?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
  visibleAfterVisibleTo?: InputMaybe<SortDirection>;
};

export type WorkMaterialUpdateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  holder?: InputMaybe<WorkMaterialHolderUpdateInput>;
  material?: InputMaybe<WorkMaterialMaterialUpdateFieldInput>;
  owner?: InputMaybe<WorkMaterialOwnerUpdateFieldInput>;
  publicFrom?: InputMaybe<WorkMaterialPublicFromUpdateFieldInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  visibleAfterVisibleTo?: InputMaybe<Scalars['Boolean']['input']>;
  visibleFrom?: InputMaybe<WorkMaterialVisibleFromUpdateFieldInput>;
  visibleTo?: InputMaybe<WorkMaterialVisibleToUpdateFieldInput>;
};

export type WorkMaterialVisibleFromAggregateInput = {
  AND?: InputMaybe<Array<WorkMaterialVisibleFromAggregateInput>>;
  NOT?: InputMaybe<WorkMaterialVisibleFromAggregateInput>;
  OR?: InputMaybe<Array<WorkMaterialVisibleFromAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<WorkMaterialVisibleFromNodeAggregationWhereInput>;
};

export type WorkMaterialVisibleFromConnectFieldInput = {
  connect?: InputMaybe<DayConnectInput>;
  edge?: InputMaybe<DayRelationPropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<DayConnectWhere>;
};

export type WorkMaterialVisibleFromConnectOrCreateFieldInput = {
  onCreate: WorkMaterialVisibleFromConnectOrCreateFieldInputOnCreate;
  where: DayConnectOrCreateWhere;
};

export type WorkMaterialVisibleFromConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<DayRelationPropertiesCreateInput>;
  node: DayOnCreateInput;
};

export type WorkMaterialVisibleFromConnection = {
  __typename?: 'WorkMaterialVisibleFromConnection';
  edges: Array<WorkMaterialVisibleFromRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type WorkMaterialVisibleFromConnectionSort = {
  edge?: InputMaybe<DayRelationPropertiesSort>;
  node?: InputMaybe<DaySort>;
};

export type WorkMaterialVisibleFromConnectionWhere = {
  AND?: InputMaybe<Array<WorkMaterialVisibleFromConnectionWhere>>;
  NOT?: InputMaybe<WorkMaterialVisibleFromConnectionWhere>;
  OR?: InputMaybe<Array<WorkMaterialVisibleFromConnectionWhere>>;
  edge?: InputMaybe<DayRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<DayRelationPropertiesWhere>;
  node?: InputMaybe<DayWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<DayWhere>;
};

export type WorkMaterialVisibleFromCreateFieldInput = {
  edge?: InputMaybe<DayRelationPropertiesCreateInput>;
  node: DayCreateInput;
};

export type WorkMaterialVisibleFromDeleteFieldInput = {
  delete?: InputMaybe<DayDeleteInput>;
  where?: InputMaybe<WorkMaterialVisibleFromConnectionWhere>;
};

export type WorkMaterialVisibleFromDisconnectFieldInput = {
  disconnect?: InputMaybe<DayDisconnectInput>;
  where?: InputMaybe<WorkMaterialVisibleFromConnectionWhere>;
};

export type WorkMaterialVisibleFromFieldInput = {
  connect?: InputMaybe<WorkMaterialVisibleFromConnectFieldInput>;
  connectOrCreate?: InputMaybe<WorkMaterialVisibleFromConnectOrCreateFieldInput>;
  create?: InputMaybe<WorkMaterialVisibleFromCreateFieldInput>;
};

export type WorkMaterialVisibleFromNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<WorkMaterialVisibleFromNodeAggregationWhereInput>>;
  NOT?: InputMaybe<WorkMaterialVisibleFromNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<WorkMaterialVisibleFromNodeAggregationWhereInput>>;
  date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  day_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  day_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  day_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  day_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  day_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  day_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  day_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  day_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  day_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  day_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  month_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  month_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  month_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  month_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  month_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  month_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  month_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  month_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  month_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  month_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  week_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  week_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  week_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  week_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  week_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  week_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  week_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  week_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  week_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  week_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  year_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  year_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkMaterialVisibleFromRelationship = {
  __typename?: 'WorkMaterialVisibleFromRelationship';
  cursor: Scalars['String']['output'];
  node: Day;
  properties: DayRelationProperties;
};

export type WorkMaterialVisibleFromUpdateConnectionInput = {
  edge?: InputMaybe<DayRelationPropertiesUpdateInput>;
  node?: InputMaybe<DayUpdateInput>;
};

export type WorkMaterialVisibleFromUpdateFieldInput = {
  connect?: InputMaybe<WorkMaterialVisibleFromConnectFieldInput>;
  connectOrCreate?: InputMaybe<WorkMaterialVisibleFromConnectOrCreateFieldInput>;
  create?: InputMaybe<WorkMaterialVisibleFromCreateFieldInput>;
  delete?: InputMaybe<WorkMaterialVisibleFromDeleteFieldInput>;
  disconnect?: InputMaybe<WorkMaterialVisibleFromDisconnectFieldInput>;
  update?: InputMaybe<WorkMaterialVisibleFromUpdateConnectionInput>;
  where?: InputMaybe<WorkMaterialVisibleFromConnectionWhere>;
};

export type WorkMaterialVisibleToAggregateInput = {
  AND?: InputMaybe<Array<WorkMaterialVisibleToAggregateInput>>;
  NOT?: InputMaybe<WorkMaterialVisibleToAggregateInput>;
  OR?: InputMaybe<Array<WorkMaterialVisibleToAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<WorkMaterialVisibleToNodeAggregationWhereInput>;
};

export type WorkMaterialVisibleToConnectFieldInput = {
  connect?: InputMaybe<DayConnectInput>;
  edge?: InputMaybe<DayRelationPropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<DayConnectWhere>;
};

export type WorkMaterialVisibleToConnectOrCreateFieldInput = {
  onCreate: WorkMaterialVisibleToConnectOrCreateFieldInputOnCreate;
  where: DayConnectOrCreateWhere;
};

export type WorkMaterialVisibleToConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<DayRelationPropertiesCreateInput>;
  node: DayOnCreateInput;
};

export type WorkMaterialVisibleToConnection = {
  __typename?: 'WorkMaterialVisibleToConnection';
  edges: Array<WorkMaterialVisibleToRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type WorkMaterialVisibleToConnectionSort = {
  edge?: InputMaybe<DayRelationPropertiesSort>;
  node?: InputMaybe<DaySort>;
};

export type WorkMaterialVisibleToConnectionWhere = {
  AND?: InputMaybe<Array<WorkMaterialVisibleToConnectionWhere>>;
  NOT?: InputMaybe<WorkMaterialVisibleToConnectionWhere>;
  OR?: InputMaybe<Array<WorkMaterialVisibleToConnectionWhere>>;
  edge?: InputMaybe<DayRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<DayRelationPropertiesWhere>;
  node?: InputMaybe<DayWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<DayWhere>;
};

export type WorkMaterialVisibleToCreateFieldInput = {
  edge?: InputMaybe<DayRelationPropertiesCreateInput>;
  node: DayCreateInput;
};

export type WorkMaterialVisibleToDeleteFieldInput = {
  delete?: InputMaybe<DayDeleteInput>;
  where?: InputMaybe<WorkMaterialVisibleToConnectionWhere>;
};

export type WorkMaterialVisibleToDisconnectFieldInput = {
  disconnect?: InputMaybe<DayDisconnectInput>;
  where?: InputMaybe<WorkMaterialVisibleToConnectionWhere>;
};

export type WorkMaterialVisibleToFieldInput = {
  connect?: InputMaybe<WorkMaterialVisibleToConnectFieldInput>;
  connectOrCreate?: InputMaybe<WorkMaterialVisibleToConnectOrCreateFieldInput>;
  create?: InputMaybe<WorkMaterialVisibleToCreateFieldInput>;
};

export type WorkMaterialVisibleToNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<WorkMaterialVisibleToNodeAggregationWhereInput>>;
  NOT?: InputMaybe<WorkMaterialVisibleToNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<WorkMaterialVisibleToNodeAggregationWhereInput>>;
  date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  dayOfWeek_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  day_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  day_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  day_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  day_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  day_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  day_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  day_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  day_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  day_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  day_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  day_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  day_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  month_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  month_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  month_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  month_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  month_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  month_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  month_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  month_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  month_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  month_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  month_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  month_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  week_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  week_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  week_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  week_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  week_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  week_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  week_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  week_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  week_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  week_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  week_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  week_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  year_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  year_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkMaterialVisibleToRelationship = {
  __typename?: 'WorkMaterialVisibleToRelationship';
  cursor: Scalars['String']['output'];
  node: Day;
  properties: DayRelationProperties;
};

export type WorkMaterialVisibleToUpdateConnectionInput = {
  edge?: InputMaybe<DayRelationPropertiesUpdateInput>;
  node?: InputMaybe<DayUpdateInput>;
};

export type WorkMaterialVisibleToUpdateFieldInput = {
  connect?: InputMaybe<WorkMaterialVisibleToConnectFieldInput>;
  connectOrCreate?: InputMaybe<WorkMaterialVisibleToConnectOrCreateFieldInput>;
  create?: InputMaybe<WorkMaterialVisibleToCreateFieldInput>;
  delete?: InputMaybe<WorkMaterialVisibleToDeleteFieldInput>;
  disconnect?: InputMaybe<WorkMaterialVisibleToDisconnectFieldInput>;
  update?: InputMaybe<WorkMaterialVisibleToUpdateConnectionInput>;
  where?: InputMaybe<WorkMaterialVisibleToConnectionWhere>;
};

export type WorkMaterialWhere = {
  AND?: InputMaybe<Array<WorkMaterialWhere>>;
  NOT?: InputMaybe<WorkMaterialWhere>;
  OR?: InputMaybe<Array<WorkMaterialWhere>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  created_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  created_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  holder?: InputMaybe<WorkMaterialHolderWhere>;
  holderConnection?: InputMaybe<WorkMaterialHolderConnectionWhere>;
  holderConnection_NOT?: InputMaybe<WorkMaterialHolderConnectionWhere>;
  holder_NOT?: InputMaybe<WorkMaterialHolderWhere>;
  material?: InputMaybe<MaterialWhere>;
  materialAggregate?: InputMaybe<WorkMaterialMaterialAggregateInput>;
  materialConnection?: InputMaybe<WorkMaterialMaterialConnectionWhere>;
  materialConnection_NOT?: InputMaybe<WorkMaterialMaterialConnectionWhere>;
  material_NOT?: InputMaybe<MaterialWhere>;
  owner?: InputMaybe<ProfileWhere>;
  ownerAggregate?: InputMaybe<WorkMaterialOwnerAggregateInput>;
  ownerConnection?: InputMaybe<WorkMaterialOwnerConnectionWhere>;
  ownerConnection_NOT?: InputMaybe<WorkMaterialOwnerConnectionWhere>;
  owner_NOT?: InputMaybe<ProfileWhere>;
  publicFrom?: InputMaybe<DayWhere>;
  publicFromAggregate?: InputMaybe<WorkMaterialPublicFromAggregateInput>;
  publicFromConnection?: InputMaybe<WorkMaterialPublicFromConnectionWhere>;
  publicFromConnection_NOT?: InputMaybe<WorkMaterialPublicFromConnectionWhere>;
  publicFrom_NOT?: InputMaybe<DayWhere>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  updated_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updated_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updated_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updated_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  visibleAfterVisibleTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  visibleAfterVisibleTo_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  visibleFrom?: InputMaybe<DayWhere>;
  visibleFromAggregate?: InputMaybe<WorkMaterialVisibleFromAggregateInput>;
  visibleFromConnection?: InputMaybe<WorkMaterialVisibleFromConnectionWhere>;
  visibleFromConnection_NOT?: InputMaybe<WorkMaterialVisibleFromConnectionWhere>;
  visibleFrom_NOT?: InputMaybe<DayWhere>;
  visibleTo?: InputMaybe<DayWhere>;
  visibleToAggregate?: InputMaybe<WorkMaterialVisibleToAggregateInput>;
  visibleToConnection?: InputMaybe<WorkMaterialVisibleToConnectionWhere>;
  visibleToConnection_NOT?: InputMaybe<WorkMaterialVisibleToConnectionWhere>;
  visibleTo_NOT?: InputMaybe<DayWhere>;
};

export type WorkMaterialsConnection = {
  __typename?: 'WorkMaterialsConnection';
  edges: Array<WorkMaterialEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Zoom = {
  __typename?: 'Zoom';
  maxParticipantsPerMeeting?: Maybe<Scalars['Int']['output']>;
  oauthAccountId?: Maybe<Scalars['String']['output']>;
  oauthClientId?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  organizationAggregate?: Maybe<ZoomOrganizationOrganizationAggregationSelection>;
  organizationConnection: ZoomOrganizationConnection;
  uuid: Scalars['ID']['output'];
};

export type ZoomOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type ZoomOrganizationAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OrganizationWhere>;
};

export type ZoomOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ZoomOrganizationConnectionSort>>;
  where?: InputMaybe<ZoomOrganizationConnectionWhere>;
};

export type ZoomAggregateSelection = {
  __typename?: 'ZoomAggregateSelection';
  count: Scalars['Int']['output'];
  maxParticipantsPerMeeting: IntAggregateSelection;
  oauthAccountId: StringAggregateSelection;
  oauthClientId: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type ZoomConnectInput = {
  organization?: InputMaybe<ZoomOrganizationConnectFieldInput>;
};

export type ZoomConnectWhere = {
  node: ZoomWhere;
};

export type ZoomCreateInput = {
  maxParticipantsPerMeeting?: InputMaybe<Scalars['Int']['input']>;
  oauthAccountId?: InputMaybe<Scalars['String']['input']>;
  oauthClientId?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<ZoomOrganizationFieldInput>;
};

export type ZoomDeleteInput = {
  organization?: InputMaybe<ZoomOrganizationDeleteFieldInput>;
};

export type ZoomDisconnectInput = {
  organization?: InputMaybe<ZoomOrganizationDisconnectFieldInput>;
};

export type ZoomEdge = {
  __typename?: 'ZoomEdge';
  cursor: Scalars['String']['output'];
  node: Zoom;
};

export type ZoomOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ZoomSort objects to sort Zooms by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ZoomSort>>;
};

export type ZoomOrganizationAggregateInput = {
  AND?: InputMaybe<Array<ZoomOrganizationAggregateInput>>;
  NOT?: InputMaybe<ZoomOrganizationAggregateInput>;
  OR?: InputMaybe<Array<ZoomOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<LicensePropertiesAggregationWhereInput>;
  node?: InputMaybe<ZoomOrganizationNodeAggregationWhereInput>;
};

export type ZoomOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  edge?: InputMaybe<LicensePropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type ZoomOrganizationConnectOrCreateFieldInput = {
  onCreate: ZoomOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type ZoomOrganizationConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<LicensePropertiesCreateInput>;
  node: OrganizationOnCreateInput;
};

export type ZoomOrganizationConnection = {
  __typename?: 'ZoomOrganizationConnection';
  edges: Array<ZoomOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ZoomOrganizationConnectionSort = {
  edge?: InputMaybe<LicensePropertiesSort>;
  node?: InputMaybe<OrganizationSort>;
};

export type ZoomOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<ZoomOrganizationConnectionWhere>>;
  NOT?: InputMaybe<ZoomOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<ZoomOrganizationConnectionWhere>>;
  edge?: InputMaybe<LicensePropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<LicensePropertiesWhere>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type ZoomOrganizationCreateFieldInput = {
  edge?: InputMaybe<LicensePropertiesCreateInput>;
  node: OrganizationCreateInput;
};

export type ZoomOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<ZoomOrganizationConnectionWhere>;
};

export type ZoomOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<ZoomOrganizationConnectionWhere>;
};

export type ZoomOrganizationFieldInput = {
  connect?: InputMaybe<ZoomOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<ZoomOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<ZoomOrganizationCreateFieldInput>;
};

export type ZoomOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ZoomOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ZoomOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ZoomOrganizationNodeAggregationWhereInput>>;
  aboutInfoLastUpdated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfoLastUpdated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  aboutInfo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  aboutInfo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aboutInfo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  matrixRoomId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  matrixRoomId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  planungSyncProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  planungSyncProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  procuratSyncProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  procuratSyncProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ZoomOrganizationOrganizationAggregationSelection = {
  __typename?: 'ZoomOrganizationOrganizationAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<ZoomOrganizationOrganizationEdgeAggregateSelection>;
  node?: Maybe<ZoomOrganizationOrganizationNodeAggregateSelection>;
};

export type ZoomOrganizationOrganizationEdgeAggregateSelection = {
  __typename?: 'ZoomOrganizationOrganizationEdgeAggregateSelection';
  contractRef: StringAggregateSelection;
  notAfter: DateTimeAggregateSelection;
  notBefore: DateTimeAggregateSelection;
  version: StringAggregateSelection;
};

export type ZoomOrganizationOrganizationNodeAggregateSelection = {
  __typename?: 'ZoomOrganizationOrganizationNodeAggregateSelection';
  aboutInfo: StringAggregateSelection;
  aboutInfoLastUpdated: DateTimeAggregateSelection;
  displayName: StringAggregateSelection;
  matrixRoomId: StringAggregateSelection;
  planungSyncProps: StringAggregateSelection;
  procuratSyncProps: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type ZoomOrganizationRelationship = {
  __typename?: 'ZoomOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
  properties: LicenseProperties;
};

export type ZoomOrganizationUpdateConnectionInput = {
  edge?: InputMaybe<LicensePropertiesUpdateInput>;
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type ZoomOrganizationUpdateFieldInput = {
  connect?: InputMaybe<ZoomOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<ZoomOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<ZoomOrganizationCreateFieldInput>;
  delete?: InputMaybe<ZoomOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<ZoomOrganizationDisconnectFieldInput>;
  update?: InputMaybe<ZoomOrganizationUpdateConnectionInput>;
  where?: InputMaybe<ZoomOrganizationConnectionWhere>;
};

/** Fields to sort Zooms by. The order in which sorts are applied is not guaranteed when specifying many fields in one ZoomSort object. */
export type ZoomSort = {
  maxParticipantsPerMeeting?: InputMaybe<SortDirection>;
  oauthAccountId?: InputMaybe<SortDirection>;
  oauthClientId?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type ZoomUpdateInput = {
  maxParticipantsPerMeeting?: InputMaybe<Scalars['Int']['input']>;
  maxParticipantsPerMeeting_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  maxParticipantsPerMeeting_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  oauthAccountId?: InputMaybe<Scalars['String']['input']>;
  oauthClientId?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<ZoomOrganizationUpdateFieldInput>;
};

export type ZoomWhere = {
  AND?: InputMaybe<Array<ZoomWhere>>;
  NOT?: InputMaybe<ZoomWhere>;
  OR?: InputMaybe<Array<ZoomWhere>>;
  maxParticipantsPerMeeting?: InputMaybe<Scalars['Int']['input']>;
  maxParticipantsPerMeeting_GT?: InputMaybe<Scalars['Int']['input']>;
  maxParticipantsPerMeeting_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxParticipantsPerMeeting_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  maxParticipantsPerMeeting_LT?: InputMaybe<Scalars['Int']['input']>;
  maxParticipantsPerMeeting_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  maxParticipantsPerMeeting_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  maxParticipantsPerMeeting_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  oauthAccountId?: InputMaybe<Scalars['String']['input']>;
  oauthAccountId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  oauthAccountId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  oauthAccountId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  oauthAccountId_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  oauthAccountId_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  oauthAccountId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  oauthAccountId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  oauthAccountId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  oauthAccountId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  oauthClientId?: InputMaybe<Scalars['String']['input']>;
  oauthClientId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  oauthClientId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  oauthClientId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  oauthClientId_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  oauthClientId_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  oauthClientId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  oauthClientId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  oauthClientId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  oauthClientId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<ZoomOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<ZoomOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<ZoomOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type ZoomsConnection = {
  __typename?: 'ZoomsConnection';
  edges: Array<ZoomEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DataLoaderDataQueryVariables = Exact<{
  schoolYearWhere: SchoolYearWhere;
  notificationSettingsWhere: NotificationSettingsWhere;
  profile: Scalars['ID']['input'];
  calendarEventWhere: CalendarEventWhere;
  dayConnection: Scalars['String']['input'];
  organizationUuid: Scalars['ID']['input'];
}>;

export type DataLoaderDataQuery = { __typename?: 'Query' } & {
  ' $fragmentRefs'?: {
    OrganizationConfigFieldsFragment: OrganizationConfigFieldsFragment;
    PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment;
    HeaderQueryFieldsFragment: HeaderQueryFieldsFragment;
    MobileMenuQueryFieldsFragment: MobileMenuQueryFieldsFragment;
    PushNotificationWrapperFieldsFragment: PushNotificationWrapperFieldsFragment;
  };
};

export type CreateAbsenceReasonMutationVariables = Exact<{
  input: Array<AbsenceReasonCreateInput> | AbsenceReasonCreateInput;
}>;

export type CreateAbsenceReasonMutation = {
  __typename?: 'Mutation';
  createAbsenceReasons: {
    __typename?: 'CreateAbsenceReasonsMutationResponse';
    info: { __typename?: 'CreateInfo'; nodesCreated: number };
    absenceReasons: Array<{ __typename: 'AbsenceReason'; internal?: boolean | null; reason: string; uuid: string }>;
  };
};

export type UpdateAbsenceReasonMutationVariables = Exact<{
  where: AbsenceReasonWhere;
  update: AbsenceReasonUpdateInput;
}>;

export type UpdateAbsenceReasonMutation = {
  __typename?: 'Mutation';
  updateAbsenceReasons: {
    __typename?: 'UpdateAbsenceReasonsMutationResponse';
    absenceReasons: Array<{ __typename?: 'AbsenceReason'; internal?: boolean | null; reason: string; uuid: string }>;
  };
};

export type AbsenceReasonFormDataQueryVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
}>;

export type AbsenceReasonFormDataQuery = {
  __typename?: 'Query';
  absenceReasons: Array<{ __typename: 'AbsenceReason'; uuid: string; reason: string; internal?: boolean | null }>;
};

export type AbsenceReasonTableFieldsFragment = {
  __typename?: 'Query';
  absenceReasons: Array<{
    __typename: 'AbsenceReason';
    uuid: string;
    reason: string;
    internal?: boolean | null;
    absencesAggregate?: { __typename: 'AbsenceReasonAbsenceReasonAbsencesAggregationSelection'; count: number } | null;
  }>;
} & { ' $fragmentName'?: 'AbsenceReasonTableFieldsFragment' };

export type AccessOverviewFormFieldsFragment = {
  __typename?: 'Query';
  profiles: Array<{
    __typename: 'Profile';
    uuid: string;
    threemaId?: string | null;
    threemaConnection: {
      __typename: 'ProfileThreemaConnection';
      edges: Array<{
        __typename: 'ProfileThreemaRelationship';
        properties: {
          __typename?: 'ThreemaProps';
          threemaId?: string | null;
          workPass?: string | null;
          workUser?: string | null;
        };
      }>;
    };
  }>;
} & { ' $fragmentName'?: 'AccessOverviewFormFieldsFragment' };

export type UpdatePasswordsMutationVariables = Exact<{
  where: PasswordWhere;
  update: PasswordUpdateInput;
}>;

export type UpdatePasswordsMutation = {
  __typename?: 'Mutation';
  updatePasswords: { __typename: 'UpdatePasswordsMutationResponse'; users: Array<string> };
};

export type BpUpdateSubmissionsInActivityProtocolMutationVariables = Exact<{
  where: SubmissionWhere;
  update: SubmissionUpdateInput;
}>;

export type BpUpdateSubmissionsInActivityProtocolMutation = {
  __typename?: 'Mutation';
  updateSubmissions: {
    __typename?: 'UpdateSubmissionsMutationResponse';
    submissions: Array<{ __typename: 'Submission'; uuid: string; status: SubmissionStatus }>;
  };
};

export type ActivityDataQueryVariables = Exact<{
  profiles: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type ActivityDataQuery = {
  __typename?: 'Query';
  profiles: Array<{ __typename: 'Profile'; uuid: string; firstName?: string | null; lastName?: string | null }>;
};

export type BpCreateBpProfileMutationVariables = Exact<{
  input: BpProfileCreateInput;
}>;

export type BpCreateBpProfileMutation = {
  __typename?: 'Mutation';
  createBpProfile: { __typename: 'Profile'; uuid: string };
};

export type UpdateBpProfileMutationVariables = Exact<{
  update: BpProfileUpdateInput;
  uuid: Scalars['String']['input'];
}>;

export type UpdateBpProfileMutation = {
  __typename?: 'Mutation';
  updateBpProfile: { __typename: 'Profile'; uuid: string };
};

export type BpCreateCalendarEventInAppointmentFormMutationVariables = Exact<{
  input: Array<CalendarEventCreateInput> | CalendarEventCreateInput;
}>;

export type BpCreateCalendarEventInAppointmentFormMutation = {
  __typename?: 'Mutation';
  createCalendarEvents: {
    __typename?: 'CreateCalendarEventsMutationResponse';
    calendarEvents: Array<{ __typename: 'CalendarEvent'; uuid: string }>;
  };
};

export type BpUpdateCalendarEventsInAppointmentFormMutationVariables = Exact<{
  where: CalendarEventWhere;
  update: CalendarEventUpdateInput;
}>;

export type BpUpdateCalendarEventsInAppointmentFormMutation = {
  __typename?: 'Mutation';
  updateCalendarEvents: {
    __typename?: 'UpdateCalendarEventsMutationResponse';
    calendarEvents: Array<{
      __typename: 'CalendarEvent';
      uuid: string;
      title?: string | null;
      start: string;
      duration: string;
    }>;
  };
};

export type AppointmentFormPageDataQueryVariables = Exact<{
  appointmentUuid: Scalars['ID']['input'];
  organizationUuid: Scalars['ID']['input'];
  holderUuid: Scalars['ID']['input'];
  groupUuid: Scalars['ID']['input'];
}>;

export type AppointmentFormPageDataQuery = {
  __typename?: 'Query';
  calendarEvents: Array<{
    __typename: 'CalendarEvent';
    uuid: string;
    start: string;
    duration: string;
    categories?: Array<string> | null;
    title?: string | null;
    description?: string | null;
    recordVirtualEvent?: boolean | null;
    maxAttendees?: number | null;
    teachingUnit?: { __typename: 'TeachingUnit'; uuid: string } | null;
    recurrenceRule?: {
      __typename: 'RecurrenceRule';
      uuid: string;
      frequency?: EventRecurrence | null;
      until: string;
    } | null;
  }>;
  profilesAggregate: { __typename: 'ProfileAggregateSelection'; count: number };
} & {
  ' $fragmentRefs'?: {
    UseAvailableServicesForOrganizationFieldsFragment: UseAvailableServicesForOrganizationFieldsFragment;
    AppointmentMetaFieldsFragment: AppointmentMetaFieldsFragment;
    UseGroupMembersCountFieldsFragment: UseGroupMembersCountFieldsFragment;
  };
};

export type AppointmentMetaFieldsFragment = {
  __typename?: 'Query';
  calendarEvents: Array<{ __typename: 'CalendarEvent'; uuid: string; categories?: Array<string> | null }>;
  teachingUnits: Array<{ __typename: 'TeachingUnit'; uuid: string; title: string }>;
} & { ' $fragmentName'?: 'AppointmentMetaFieldsFragment' };

export type BpSetAllowSubmissionsAfterDueDateMutationVariables = Exact<{
  where: AssignmentWhere;
  update: AssignmentUpdateInput;
}>;

export type BpSetAllowSubmissionsAfterDueDateMutation = {
  __typename?: 'Mutation';
  updateAssignments: {
    __typename?: 'UpdateAssignmentsMutationResponse';
    assignments: Array<{ __typename: 'Assignment'; uuid: string; allowSubmissionAfterDueDate?: boolean | null }>;
  };
};

export type AssignmentTabFieldsFragment = {
  __typename: 'Assignment';
  uuid: string;
  allowSubmissionAfterDueDate?: boolean | null;
  material: {
    __typename: 'Material';
    uuid: string;
    text?: string | null;
    fileEntries: Array<
      { __typename: 'FileEntry'; uuid: string } & {
        ' $fragmentRefs'?: { FileTableFieldsFragment: FileTableFieldsFragment };
      }
    >;
  };
  visibleFrom?: { __typename: 'Day'; uuid: string; date: string } | null;
  dueDate?: { __typename: 'Day'; uuid: string; date: string } | null;
} & { ' $fragmentName'?: 'AssignmentTabFieldsFragment' };

export type SubmissionsTabProfileFieldsFragment = {
  __typename: 'Profile';
  uuid: string;
  firstName?: string | null;
  lastName?: string | null;
} & { ' $fragmentName'?: 'SubmissionsTabProfileFieldsFragment' };

export type SubmissionsTabSubmissionFieldsFragment = {
  __typename: 'Submission';
  uuid: string;
  status: SubmissionStatus;
  updated: any;
  owner: { __typename: 'Profile'; uuid: string };
  assignment: Array<{
    __typename: 'Assignment';
    uuid: string;
    dueDate?: { __typename: 'Day'; uuid: string; date: string } | null;
  }>;
} & { ' $fragmentName'?: 'SubmissionsTabSubmissionFieldsFragment' };

export type BpCreateAssignmentMutationVariables = Exact<{
  input: Array<AssignmentCreateInput> | AssignmentCreateInput;
}>;

export type BpCreateAssignmentMutation = {
  __typename?: 'Mutation';
  createAssignments: {
    __typename?: 'CreateAssignmentsMutationResponse';
    assignments: Array<{ __typename: 'Assignment'; uuid: string; title: string }>;
  };
};

export type BpUpdateAssignmentsMutationVariables = Exact<{
  where: AssignmentWhere;
  update: AssignmentUpdateInput;
}>;

export type BpUpdateAssignmentsMutation = {
  __typename?: 'Mutation';
  updateAssignments: {
    __typename?: 'UpdateAssignmentsMutationResponse';
    assignments: Array<{ __typename: 'Assignment'; uuid: string; title: string }>;
  };
};

export type AssignmentFormPageDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
  assignmentUuid: Scalars['ID']['input'];
  courseUuid: Scalars['ID']['input'];
}>;

export type AssignmentFormPageDataQuery = {
  __typename?: 'Query';
  assignments: Array<{
    __typename: 'Assignment';
    uuid: string;
    title: string;
    allowSubmissionAfterDueDate?: boolean | null;
    material: {
      __typename: 'Material';
      uuid: string;
      text?: string | null;
      fileEntries: Array<
        { __typename: 'FileEntry'; uuid: string } & {
          ' $fragmentRefs'?: { FileTableFieldsFragment: FileTableFieldsFragment };
        }
      >;
    };
    visibleFrom?: { __typename: 'Day'; uuid: string; date: string } | null;
    dueDate?: { __typename: 'Day'; uuid: string; date: string } | null;
    holder: { __typename: 'TeachingUnit'; uuid: string };
  }>;
} & {
  ' $fragmentRefs'?: {
    PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment;
    TeachingUnitSelectFieldsFragment: TeachingUnitSelectFieldsFragment;
  };
};

export type AssignmentPreviewStudentFieldsFragment = {
  __typename: 'Assignment';
  uuid: string;
  title: string;
  dueDate?: { __typename: 'Day'; uuid: string; date: string } | null;
  submissions: Array<{ __typename: 'Submission'; uuid: string; status: SubmissionStatus }>;
} & { ' $fragmentName'?: 'AssignmentPreviewStudentFieldsFragment' };

export type BpDeleteAssignmentsFromAssignmentPreviewTeacherMutationVariables = Exact<{
  where: AssignmentWhere;
}>;

export type BpDeleteAssignmentsFromAssignmentPreviewTeacherMutation = {
  __typename?: 'Mutation';
  deleteAssignments: { __typename?: 'DeleteInfo'; nodesDeleted: number; relationshipsDeleted: number };
};

export type AssignmentPreviewTeacherFieldsFragment = {
  __typename: 'Assignment';
  uuid: string;
  title: string;
  dueDate?: { __typename: 'Day'; uuid: string; date: string } | null;
  submissions: Array<{ __typename: 'Submission'; uuid: string; status: SubmissionStatus }>;
} & { ' $fragmentName'?: 'AssignmentPreviewTeacherFieldsFragment' };

export type AssignmentsTableStudentFieldsFragment = {
  __typename: 'Assignment';
  uuid: string;
  title: string;
  allowSubmissionAfterDueDate?: boolean | null;
  visibleFrom?: { __typename: 'Day'; uuid: string; date: string } | null;
  dueDate?: { __typename: 'Day'; uuid: string; date: string } | null;
  submissions: Array<{ __typename: 'Submission'; uuid: string; status: SubmissionStatus }>;
} & { ' $fragmentName'?: 'AssignmentsTableStudentFieldsFragment' };

export type BpDeleteAssignmentsFromAssignmentTableTeacherMutationVariables = Exact<{
  where: AssignmentWhere;
}>;

export type BpDeleteAssignmentsFromAssignmentTableTeacherMutation = {
  __typename?: 'Mutation';
  deleteAssignments: { __typename?: 'DeleteInfo'; nodesDeleted: number; relationshipsDeleted: number };
};

export type AssignmentsTableTeacherFieldsFragment = {
  __typename: 'Assignment';
  uuid: string;
  title: string;
  created: any;
  allowSubmissionAfterDueDate?: boolean | null;
  holder: {
    __typename: 'TeachingUnit';
    uuid: string;
    title: string;
    owner: { __typename: 'Profile'; uuid: string };
    group: { __typename: 'Group'; uuid: string };
    organization: { __typename: 'Organization'; uuid: string };
  };
  visibleFrom?: { __typename: 'Day'; uuid: string; date: string } | null;
  dueDate?: { __typename: 'Day'; uuid: string; date: string } | null;
  submissions: Array<{ __typename: 'Submission'; uuid: string; status: SubmissionStatus }>;
} & { ' $fragmentName'?: 'AssignmentsTableTeacherFieldsFragment' };

export type CreateBigBlueButtonsMutationVariables = Exact<{
  input: Array<BigBlueButtonCreateInput> | BigBlueButtonCreateInput;
}>;

export type CreateBigBlueButtonsMutation = {
  __typename?: 'Mutation';
  createBigBlueButtons: {
    __typename?: 'CreateBigBlueButtonsMutationResponse';
    bigBlueButtons: Array<{ __typename: 'BigBlueButton'; uuid: string }>;
  };
};

export type UpdateBigBlueButtonsMutationVariables = Exact<{
  update: BigBlueButtonUpdateInput;
  where: BigBlueButtonWhere;
}>;

export type UpdateBigBlueButtonsMutation = {
  __typename?: 'Mutation';
  updateBigBlueButtons: {
    __typename?: 'UpdateBigBlueButtonsMutationResponse';
    bigBlueButtons: Array<{
      __typename: 'BigBlueButton';
      uuid: string;
      apiUrl?: string | null;
      allowRecording?: boolean | null;
      maxParticipantsPerMeeting?: number | null;
      organizationConnection: {
        __typename: 'BigBlueButtonOrganizationConnection';
        edges: Array<{
          __typename: 'BigBlueButtonOrganizationRelationship';
          properties: {
            __typename: 'LicenseProperties';
            notAfter?: any | null;
            notBefore?: any | null;
            version?: string | null;
          };
        }>;
      };
    }>;
  };
};

export type SettingsBigBlueButtonFormDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
  uuid: Scalars['ID']['input'];
}>;

export type SettingsBigBlueButtonFormDataQuery = {
  __typename?: 'Query';
  bigBlueButtons: Array<{
    __typename: 'BigBlueButton';
    uuid: string;
    apiUrl?: string | null;
    maxParticipantsPerMeeting?: number | null;
    allowRecording?: boolean | null;
    organizationConnection: {
      __typename: 'BigBlueButtonOrganizationConnection';
      edges: Array<{
        __typename: 'BigBlueButtonOrganizationRelationship';
        properties: {
          __typename: 'LicenseProperties';
          notAfter?: any | null;
          notBefore?: any | null;
          version?: string | null;
          contractRef?: string | null;
        };
      }>;
    };
  }>;
} & { ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment } };

export type CreateBildungsplattformsMutationVariables = Exact<{
  input: Array<BildungsplattformCreateInput> | BildungsplattformCreateInput;
}>;

export type CreateBildungsplattformsMutation = {
  __typename?: 'Mutation';
  createBildungsplattforms: {
    __typename?: 'CreateBildungsplattformsMutationResponse';
    bildungsplattforms: Array<{ __typename: 'Bildungsplattform'; uuid: string }>;
  };
};

export type UpdateBildungsplattformsInBildungsplattformFormMutationVariables = Exact<{
  update: BildungsplattformUpdateInput;
  where: BildungsplattformWhere;
}>;

export type UpdateBildungsplattformsInBildungsplattformFormMutation = {
  __typename?: 'Mutation';
  updateBildungsplattforms: {
    __typename?: 'UpdateBildungsplattformsMutationResponse';
    bildungsplattforms: Array<{
      __typename: 'Bildungsplattform';
      uuid: string;
      allowStudentDirectMessages?: boolean | null;
      organizationConnection: {
        __typename: 'BildungsplattformOrganizationConnection';
        edges: Array<{
          __typename: 'BildungsplattformOrganizationRelationship';
          properties: {
            __typename: 'LicenseProperties';
            version?: string | null;
            notAfter?: any | null;
            notBefore?: any | null;
          };
        }>;
      };
    }>;
  };
};

export type SettingsBildungsplattformFormDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
  uuid: Scalars['ID']['input'];
}>;

export type SettingsBildungsplattformFormDataQuery = {
  __typename?: 'Query';
  bildungsplattforms: Array<{
    __typename: 'Bildungsplattform';
    uuid: string;
    allowStudentDirectMessages?: boolean | null;
    allowParentExcuses?: boolean | null;
    currentSchoolyear?: string | null;
    organizationConnection: {
      __typename: 'BildungsplattformOrganizationConnection';
      edges: Array<{
        __typename: 'BildungsplattformOrganizationRelationship';
        properties: {
          __typename: 'LicenseProperties';
          notAfter?: any | null;
          notBefore?: any | null;
          version?: string | null;
          contractRef?: string | null;
        };
      }>;
    };
  }>;
} & { ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment } };

export type CreateNextcloudsMutationVariables = Exact<{
  input: Array<NextcloudCreateInput> | NextcloudCreateInput;
}>;

export type CreateNextcloudsMutation = {
  __typename?: 'Mutation';
  createNextclouds: {
    __typename?: 'CreateNextcloudsMutationResponse';
    nextclouds: Array<{
      __typename: 'Nextcloud';
      uuid: string;
      serverUri: string;
      organizationConnection: {
        __typename: 'NextcloudOrganizationConnection';
        edges: Array<{
          __typename: 'NextcloudOrganizationRelationship';
          properties: { __typename: 'LicenseProperties'; notAfter?: any | null; notBefore?: any | null };
        }>;
      };
    }>;
  };
};

export type UpdateNextcloudsMutationVariables = Exact<{
  update: NextcloudUpdateInput;
  where: NextcloudWhere;
}>;

export type UpdateNextcloudsMutation = {
  __typename?: 'Mutation';
  updateNextclouds: {
    __typename?: 'UpdateNextcloudsMutationResponse';
    nextclouds: Array<{
      __typename: 'Nextcloud';
      uuid: string;
      serverUri: string;
      organizationConnection: {
        __typename: 'NextcloudOrganizationConnection';
        edges: Array<{
          __typename: 'NextcloudOrganizationRelationship';
          properties: { __typename: 'LicenseProperties'; notAfter?: any | null; notBefore?: any | null };
        }>;
      };
    }>;
  };
};

export type SettingsNextcloudFormDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
  organizationUuid: Scalars['ID']['input'];
}>;

export type SettingsNextcloudFormDataQuery = {
  __typename?: 'Query';
  nextclouds: Array<{
    __typename: 'Nextcloud';
    uuid: string;
    serverUri: string;
    serverAliase?: Array<string> | null;
    organizationConnection: {
      __typename: 'NextcloudOrganizationConnection';
      edges: Array<{
        __typename: 'NextcloudOrganizationRelationship';
        properties: { __typename: 'LicenseProperties'; notBefore?: any | null; notAfter?: any | null };
      }>;
    };
  }>;
} & { ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment } };

export type CreateThreemaBroadcastssMutationVariables = Exact<{
  input: Array<ThreemaBroadcastCreateInput> | ThreemaBroadcastCreateInput;
}>;

export type CreateThreemaBroadcastssMutation = {
  __typename?: 'Mutation';
  createThreemaBroadcasts: {
    __typename?: 'CreateThreemaBroadcastsMutationResponse';
    threemaBroadcasts: Array<{ __typename: 'ThreemaBroadcast'; uuid: string }>;
  };
};

export type UpdateThreemaBroadcastssMutationVariables = Exact<{
  update: ThreemaBroadcastUpdateInput;
  where: ThreemaBroadcastWhere;
}>;

export type UpdateThreemaBroadcastssMutation = {
  __typename?: 'Mutation';
  updateThreemaBroadcasts: {
    __typename?: 'UpdateThreemaBroadcastsMutationResponse';
    threemaBroadcasts: Array<{
      __typename: 'ThreemaBroadcast';
      uuid: string;
      apiToken?: string | null;
      thremaId?: string | null;
      organizationConnection: {
        __typename: 'ThreemaBroadcastOrganizationConnection';
        edges: Array<{
          __typename: 'ThreemaBroadcastOrganizationRelationship';
          properties: { __typename: 'LicenseProperties'; notAfter?: any | null; notBefore?: any | null };
        }>;
      };
    }>;
  };
};

export type SettingsThreemaBroadcastFormDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
  uuid: Scalars['ID']['input'];
}>;

export type SettingsThreemaBroadcastFormDataQuery = {
  __typename?: 'Query';
  threemaBroadcasts: Array<{
    __typename: 'ThreemaBroadcast';
    uuid: string;
    thremaId?: string | null;
    apiToken?: string | null;
    organizationConnection: {
      __typename: 'ThreemaBroadcastOrganizationConnection';
      edges: Array<{
        __typename: 'ThreemaBroadcastOrganizationRelationship';
        properties: {
          __typename: 'LicenseProperties';
          notAfter?: any | null;
          notBefore?: any | null;
          version?: string | null;
          contractRef?: string | null;
        };
      }>;
    };
  }>;
} & { ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment } };

export type CreateThreemasMutationVariables = Exact<{
  input: Array<ThreemaCreateInput> | ThreemaCreateInput;
}>;

export type CreateThreemasMutation = {
  __typename?: 'Mutation';
  createThreemas: {
    __typename?: 'CreateThreemasMutationResponse';
    threemas: Array<{ __typename: 'Threema'; uuid: string }>;
  };
};

export type UpdateThreemasMutationVariables = Exact<{
  update: ThreemaUpdateInput;
  where: ThreemaWhere;
}>;

export type UpdateThreemasMutation = {
  __typename?: 'Mutation';
  updateThreemas: {
    __typename?: 'UpdateThreemasMutationResponse';
    threemas: Array<{
      __typename: 'Threema';
      uuid: string;
      apiToken?: string | null;
      organizationConnection: {
        __typename: 'ThreemaOrganizationConnection';
        edges: Array<{
          __typename: 'ThreemaOrganizationRelationship';
          properties: { __typename: 'LicenseProperties'; notBefore?: any | null; notAfter?: any | null };
        }>;
      };
    }>;
  };
};

export type SettingsThreemaFormDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
  uuid: Scalars['ID']['input'];
}>;

export type SettingsThreemaFormDataQuery = {
  __typename?: 'Query';
  threemas: Array<{
    __typename: 'Threema';
    uuid: string;
    apiToken?: string | null;
    organizationConnection: {
      __typename: 'ThreemaOrganizationConnection';
      edges: Array<{
        __typename: 'ThreemaOrganizationRelationship';
        properties: { __typename: 'LicenseProperties'; notBefore?: any | null; notAfter?: any | null };
      }>;
    };
  }>;
} & { ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment } };

export type UpdateZoomsMutationVariables = Exact<{
  update: ZoomUpdateInput;
  where: ZoomWhere;
}>;

export type UpdateZoomsMutation = {
  __typename?: 'Mutation';
  updateZooms: {
    __typename?: 'UpdateZoomsMutationResponse';
    zooms: Array<{
      __typename: 'Zoom';
      uuid: string;
      oauthAccountId?: string | null;
      oauthClientId?: string | null;
      organizationConnection: {
        __typename: 'ZoomOrganizationConnection';
        edges: Array<{
          __typename: 'ZoomOrganizationRelationship';
          properties: { __typename: 'LicenseProperties'; notAfter?: any | null };
        }>;
      };
    }>;
  };
};

export type SettingsZoomFormDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
  uuid: Scalars['ID']['input'];
}>;

export type SettingsZoomFormDataQuery = {
  __typename?: 'Query';
  zooms: Array<{
    __typename: 'Zoom';
    uuid: string;
    oauthAccountId?: string | null;
    oauthClientId?: string | null;
    organizationConnection: {
      __typename: 'ZoomOrganizationConnection';
      edges: Array<{
        __typename: 'ZoomOrganizationRelationship';
        properties: {
          __typename: 'LicenseProperties';
          notAfter?: any | null;
          notBefore?: any | null;
          version?: string | null;
          contractRef?: string | null;
        };
      }>;
    };
  }>;
} & { ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment } };

export type BookingsTableFieldsFragment = ({
  __typename?: 'Query';
  organizations: Array<{
    __typename: 'Organization';
    uuid: string;
    licensedProducts: Array<
      | {
          __typename: 'BigBlueButton';
          uuid: string;
          organizationConnection: {
            __typename?: 'BigBlueButtonOrganizationConnection';
            edges: Array<{
              __typename?: 'BigBlueButtonOrganizationRelationship';
              properties: {
                __typename?: 'LicenseProperties';
                notAfter?: any | null;
                notBefore?: any | null;
                version?: string | null;
              };
            }>;
          };
        }
      | {
          __typename: 'Bildungsplattform';
          uuid: string;
          organizationConnection: {
            __typename?: 'BildungsplattformOrganizationConnection';
            edges: Array<{
              __typename?: 'BildungsplattformOrganizationRelationship';
              properties: {
                __typename?: 'LicenseProperties';
                notAfter?: any | null;
                notBefore?: any | null;
                version?: string | null;
              };
            }>;
          };
        }
      | {
          __typename: 'Nextcloud';
          uuid: string;
          profilesAggregate?: { __typename: 'NextcloudProfileProfilesAggregationSelection'; count: number } | null;
          organizationConnection: {
            __typename?: 'NextcloudOrganizationConnection';
            edges: Array<{
              __typename?: 'NextcloudOrganizationRelationship';
              properties: {
                __typename?: 'LicenseProperties';
                notAfter?: any | null;
                notBefore?: any | null;
                version?: string | null;
              };
            }>;
          };
        }
      | {
          __typename: 'Threema';
          uuid: string;
          organizationConnection: {
            __typename?: 'ThreemaOrganizationConnection';
            edges: Array<{
              __typename?: 'ThreemaOrganizationRelationship';
              properties: {
                __typename?: 'LicenseProperties';
                notAfter?: any | null;
                notBefore?: any | null;
                version?: string | null;
              };
            }>;
          };
        }
      | {
          __typename: 'ThreemaBroadcast';
          uuid: string;
          organizationConnection: {
            __typename?: 'ThreemaBroadcastOrganizationConnection';
            edges: Array<{
              __typename?: 'ThreemaBroadcastOrganizationRelationship';
              properties: {
                __typename?: 'LicenseProperties';
                notAfter?: any | null;
                notBefore?: any | null;
                version?: string | null;
              };
            }>;
          };
        }
      | {
          __typename: 'Zoom';
          uuid: string;
          organizationConnection: {
            __typename?: 'ZoomOrganizationConnection';
            edges: Array<{
              __typename?: 'ZoomOrganizationRelationship';
              properties: {
                __typename?: 'LicenseProperties';
                notAfter?: any | null;
                notBefore?: any | null;
                version?: string | null;
              };
            }>;
          };
        }
    >;
  }>;
} & { ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment } }) & {
  ' $fragmentName'?: 'BookingsTableFieldsFragment';
};

export type BreadcrumbPageDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
  organizationUuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type BreadcrumbPageDataQuery = {
  __typename?: 'Query';
  groups: Array<{
    __typename: 'Group';
    uuid: string;
    name: string;
    teachingUnits: Array<{
      __typename: 'TeachingUnit';
      uuid: string;
      workMaterials: Array<{ __typename: 'WorkMaterial'; uuid: string; title: string }>;
    }>;
  }>;
  courses: Array<{
    __typename: 'Group';
    uuid: string;
    name: string;
    teachingUnits: Array<{
      __typename: 'TeachingUnit';
      uuid: string;
      title: string;
      workMaterials: Array<{ __typename: 'WorkMaterial'; uuid: string; title: string }>;
      assignments: Array<{
        __typename: 'Assignment';
        uuid: string;
        title: string;
        submissions: Array<{
          __typename: 'Submission';
          uuid: string;
          owner: { __typename: 'Profile'; uuid: string; displayName?: string | null };
        }>;
      }>;
    }>;
  }>;
};

export type AnswersCardFieldsFragment = {
  __typename?: 'Query';
  submissionsForAnswersCard: Array<{
    __typename: 'Submission';
    uuid: string;
    owner: { __typename: 'Profile'; uuid: string; firstName?: string | null; lastName?: string | null };
    material: { __typename: 'Material'; uuid: string; text?: string | null };
  }>;
} & { ' $fragmentName'?: 'AnswersCardFieldsFragment' };

export type UpdateProfileRoleMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
  role: Scalars['String']['input'];
}>;

export type UpdateProfileRoleMutation = {
  __typename?: 'Mutation';
  updateProfileRole: { __typename?: 'EntitiesUpdateInfo'; entitiesUpdated: number };
};

export type UpdateClassGroupInClassGroupProfilesFormMutationVariables = Exact<{
  update: ClassGroupUpdateInput;
  where: ClassGroupWhere;
}>;

export type UpdateClassGroupInClassGroupProfilesFormMutation = {
  __typename?: 'Mutation';
  updateClassGroups: {
    __typename?: 'UpdateClassGroupsMutationResponse';
    classGroups: Array<{
      __typename: 'ClassGroup';
      uuid: string;
      members: Array<{ __typename: 'Profile'; uuid: string }>;
    }>;
  };
};

export type ClassGroupProfilesFormPageDataQueryVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
  classUuid: Scalars['ID']['input'];
}>;

export type ClassGroupProfilesFormPageDataQuery = {
  __typename?: 'Query';
  profiles: Array<{ __typename: 'Profile'; uuid: string; displayName?: string | null }>;
  divisions: Array<{
    __typename: 'Division';
    uuid: string;
    name: string;
    managedBy: string;
    groups: Array<{ __typename: 'ClassGroup'; uuid: string }>;
  }>;
  classGroups: Array<{
    __typename: 'ClassGroup';
    uuid: string;
    name: string;
    shortName: string;
    division: { __typename: 'Division'; uuid: string };
    membersConnection: {
      __typename: 'ClassGroupMembersConnection';
      edges: Array<{ __typename: 'ClassGroupMembersRelationship'; node: { __typename: 'Profile'; uuid: string } }>;
    };
  }>;
};

export type ClassbookAttendeeListFieldsFragment = {
  __typename?: 'Query';
  absenceReasons: Array<{
    __typename: 'AbsenceReason';
    uuid: string;
    reason: string;
    internal?: boolean | null;
    absencesAggregate?: { __typename: 'AbsenceReasonAbsenceReasonAbsencesAggregationSelection'; count: number } | null;
  }>;
} & { ' $fragmentName'?: 'ClassbookAttendeeListFieldsFragment' };

export type BpCreateAbsenceMutationVariables = Exact<{
  input: Array<AbsenceCreateInput> | AbsenceCreateInput;
}>;

export type BpCreateAbsenceMutation = {
  __typename?: 'Mutation';
  createAbsences: {
    __typename?: 'CreateAbsencesMutationResponse';
    absences: Array<{ __typename: 'Absence'; uuid: string }>;
  };
};

export type BpDeleteAbsenceFromClassbookEventMutationVariables = Exact<{
  where: AbsenceWhere;
}>;

export type BpDeleteAbsenceFromClassbookEventMutation = {
  __typename?: 'Mutation';
  deleteAbsences: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type BpUpdateAbsenceInClassbookEventMutationVariables = Exact<{
  where: AbsenceWhere;
  update: AbsenceUpdateInput;
}>;

export type BpUpdateAbsenceInClassbookEventMutation = {
  __typename?: 'Mutation';
  updateAbsences: {
    __typename?: 'UpdateAbsencesMutationResponse';
    absences: Array<{ __typename: 'Absence'; uuid: string; excused?: boolean | null; startTime: any; endTime: any }>;
  };
};

export type BpUpdateCalendarEventsInClassbookEventMutationVariables = Exact<{
  where: CalendarEventWhere;
  update: CalendarEventUpdateInput;
}>;

export type BpUpdateCalendarEventsInClassbookEventMutation = {
  __typename?: 'Mutation';
  updateCalendarEvents: {
    __typename?: 'UpdateCalendarEventsMutationResponse';
    calendarEvents: Array<{
      __typename: 'CalendarEvent';
      uuid: string;
      classbookNote?: string | null;
      classbookHomework?: string | null;
      attendees: Array<{ __typename: 'Profile'; uuid: string }>;
    }>;
    info: { __typename?: 'UpdateInfo'; nodesCreated: number };
  };
};

export type ClassbookEventQueryDocumentQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
  calendarEventWhere: CalendarEventWhere;
  absenceReasonsWhere: AbsenceReasonWhere;
}>;

export type ClassbookEventQueryDocumentQuery = { __typename?: 'Query' } & {
  ' $fragmentRefs'?: {
    CalendarEventMapCalendarEventsToBpEventTypeFieldsFragment: CalendarEventMapCalendarEventsToBpEventTypeFieldsFragment;
    ClassbookAttendeeListFieldsFragment: ClassbookAttendeeListFieldsFragment;
  };
};

export type ClassbookAbsenceDataQueryVariables = Exact<{
  eventAttendeeUuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  start: Scalars['DateTime']['input'];
  end: Scalars['DateTime']['input'];
}>;

export type ClassbookAbsenceDataQuery = {
  __typename?: 'Query';
  profiles: Array<{
    __typename: 'Profile';
    uuid: string;
    organizationRoles: Array<string>;
    firstName?: string | null;
    lastName?: string | null;
  }>;
  absences: Array<{
    __typename: 'Absence';
    uuid: string;
    wholeDay?: boolean | null;
    startTime: any;
    endTime: any;
    excused?: boolean | null;
    owner: { __typename: 'Profile'; uuid: string };
    reason?: { __typename: 'AbsenceReason'; uuid: string } | null;
  }>;
};

export type ClassbookEventsQueryDocumentQueryVariables = Exact<{
  calendarEventWhere: CalendarEventWhere;
  profile: Scalars['ID']['input'];
}>;

export type ClassbookEventsQueryDocumentQuery = { __typename?: 'Query' } & {
  ' $fragmentRefs'?: {
    CalendarEventMapCalendarEventsToBpEventTypeFieldsFragment: CalendarEventMapCalendarEventsToBpEventTypeFieldsFragment;
    EventsListFieldsFragment: EventsListFieldsFragment;
  };
};

export type BpCreateAbsenceInAbsencesFormMutationVariables = Exact<{
  input: Array<AbsenceCreateInput> | AbsenceCreateInput;
}>;

export type BpCreateAbsenceInAbsencesFormMutation = {
  __typename?: 'Mutation';
  createAbsences: {
    __typename?: 'CreateAbsencesMutationResponse';
    absences: Array<{ __typename: 'Absence'; uuid: string }>;
  };
};

export type BpUpdateAbsenceMutationVariables = Exact<{
  where: AbsenceWhere;
  update: AbsenceUpdateInput;
}>;

export type BpUpdateAbsenceMutation = {
  __typename?: 'Mutation';
  updateAbsences: {
    __typename?: 'UpdateAbsencesMutationResponse';
    absences: Array<{
      __typename: 'Absence';
      uuid: string;
      startTime: any;
      endTime: any;
      excused?: boolean | null;
      reason?: { __typename: 'AbsenceReason'; uuid: string } | null;
    }>;
  };
};

export type ClassbookAbsencesFormDataQueryVariables = Exact<{
  absenceReasonsWhere: AbsenceReasonWhere;
  absenceUuid: Scalars['ID']['input'];
  profilesWhere: ProfileWhere;
  classesWhere: ClassWhere;
  profile: Scalars['ID']['input'];
}>;

export type ClassbookAbsencesFormDataQuery = {
  __typename?: 'Query';
  absences: Array<{
    __typename: 'Absence';
    uuid: string;
    startTime: any;
    endTime: any;
    comment?: string | null;
    excused?: boolean | null;
    owner: { __typename: 'Profile'; uuid: string };
    reason?: { __typename: 'AbsenceReason'; uuid: string } | null;
  }>;
  absenceReasons: Array<{ __typename: 'AbsenceReason'; uuid: string; reason: string }>;
  profiles: Array<{
    __typename: 'Profile';
    uuid: string;
    organizationRoles: Array<string>;
    displayName?: string | null;
  }>;
  classes: Array<{
    __typename: 'Class';
    uuid: string;
    name: string;
    membersConnection: {
      __typename: 'ClassMembersConnection';
      edges: Array<{ __typename: 'ClassMembersRelationship'; node: { __typename: 'Profile'; uuid: string } }>;
    };
  }>;
} & { ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment } };

export type ClassbookAbsencesTableFieldsFragment = ({
  __typename?: 'Query';
  absences: Array<{
    __typename?: 'Absence';
    uuid: string;
    comment?: string | null;
    created: any;
    excused?: boolean | null;
    startTime: any;
    endTime: any;
    updated: any;
    wholeDay?: boolean | null;
    owner: { __typename?: 'Profile'; uuid: string };
    reason?: { __typename?: 'AbsenceReason'; uuid: string; reason: string; internal?: boolean | null } | null;
    days: Array<{ __typename?: 'Day'; uuid: string }>;
  }>;
} & { ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment } }) & {
  ' $fragmentName'?: 'ClassbookAbsencesTableFieldsFragment';
};

export type ClassbookAdministrationTableFieldsFragment = {
  __typename?: 'Query';
  absences: Array<{
    __typename: 'Absence';
    uuid: string;
    startTime: any;
    endTime: any;
    comment?: string | null;
    excused?: boolean | null;
    owner: { __typename: 'Profile'; uuid: string };
    reason?: { __typename: 'AbsenceReason'; uuid: string; reason: string } | null;
  }>;
  profiles: Array<{
    __typename: 'Profile';
    uuid: string;
    organizationRoles: Array<string>;
    displayName?: string | null;
  }>;
  classes: Array<{
    __typename: 'Class';
    uuid: string;
    shortName: string;
    membersConnection: {
      __typename: 'ClassMembersConnection';
      edges: Array<{ __typename: 'ClassMembersRelationship'; node: { __typename: 'Profile'; uuid: string } }>;
    };
  }>;
} & { ' $fragmentName'?: 'ClassbookAdministrationTableFieldsFragment' };

export type DeleteClassMutationVariables = Exact<{
  where: ClassWhere;
}>;

export type DeleteClassMutation = {
  __typename?: 'Mutation';
  deleteClasses: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type ClassesListPageDataQueryVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
}>;

export type ClassesListPageDataQuery = {
  __typename?: 'Query';
  classes: Array<{
    __typename: 'Class';
    uuid: string;
    foreignRefId?: Array<string> | null;
    updatedAt: any;
    createdAt: any;
    name: string;
    color?: string | null;
    grade: string;
    gradeGroup: string;
    shortName: string;
    managedBy: string;
    divisionsConnection: {
      __typename?: 'ClassDivisionsConnection';
      edges: Array<{ __typename?: 'ClassDivisionsRelationship'; node: { __typename: 'Division'; uuid: string } }>;
    };
    groupConnection: {
      __typename?: 'ClassGroupConnection';
      edges: Array<{ __typename?: 'ClassGroupRelationship'; node: { __typename?: 'Group'; uuid: string } }>;
    };
    tutorsConnection: {
      __typename?: 'ClassTutorsConnection';
      edges: Array<{
        __typename?: 'ClassTutorsRelationship';
        properties: { __typename?: 'OrderedRelationProperties'; order: number };
        node: { __typename: 'Profile'; uuid: string; selectName?: string | null };
      }>;
    };
    membersConnection: {
      __typename?: 'ClassMembersConnection';
      edges: Array<{
        __typename?: 'ClassMembersRelationship';
        node: { __typename: 'Profile'; uuid: string; selectName?: string | null };
      }>;
    };
  }>;
} & { ' $fragmentRefs'?: { ClassesListItemQueryFieldsFragment: ClassesListItemQueryFieldsFragment } };

export type ClassesListItemQueryFieldsFragment = ({
  __typename?: 'Query';
  profiles: Array<{
    __typename: 'Profile';
    uuid: string;
    organizationRoles: Array<string>;
    firstName?: string | null;
    lastName?: string | null;
    listName?: string | null;
    displayName?: string | null;
  }>;
} & { ' $fragmentRefs'?: { DivisionsListFieldsFragment: DivisionsListFieldsFragment } }) & {
  ' $fragmentName'?: 'ClassesListItemQueryFieldsFragment';
};

export type CreateClassMutationVariables = Exact<{
  input: Array<ClassCreateInput> | ClassCreateInput;
}>;

export type CreateClassMutation = {
  __typename?: 'Mutation';
  createClasses: {
    __typename?: 'CreateClassesMutationResponse';
    classes: Array<{ __typename: 'Class'; uuid: string }>;
  };
};

export type UpdateClassInClassFormMutationVariables = Exact<{
  update: ClassUpdateInput;
  where: ClassWhere;
}>;

export type UpdateClassInClassFormMutation = {
  __typename?: 'Mutation';
  updateClasses: {
    __typename?: 'UpdateClassesMutationResponse';
    classes: Array<{
      __typename: 'Class';
      uuid: string;
      name: string;
      grade: string;
      gradeGroup: string;
      color?: string | null;
      updatedAt: any;
      tutors: Array<{ __typename: 'Profile'; uuid: string }>;
    }>;
  };
};

export type ClassFormDataQueryVariables = Exact<{
  where: ProfileWhere;
  options: ProfileOptions;
}>;

export type ClassFormDataQuery = {
  __typename?: 'Query';
  profiles: Array<{
    __typename: 'Profile';
    uuid: string;
    organizationRoles: Array<string>;
    displayName?: string | null;
  }>;
};

export type UpdateClassMutationVariables = Exact<{
  update: ClassUpdateInput;
  where: ClassWhere;
}>;

export type UpdateClassMutation = {
  __typename?: 'Mutation';
  updateClasses: {
    __typename?: 'UpdateClassesMutationResponse';
    classes: Array<{
      __typename: 'Class';
      uuid: string;
      schoolYear: { __typename: 'SchoolYear'; uuid: string };
      members: Array<{ __typename: 'Profile'; uuid: string }>;
    }>;
  };
};

export type ClassProfilesFormPageDataQueryVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
}>;

export type ClassProfilesFormPageDataQuery = {
  __typename?: 'Query';
  profiles: Array<{ __typename: 'Profile'; uuid: string; displayName?: string | null }>;
};

export type CreateCollaborationInColaborationsFormMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;

export type CreateCollaborationInColaborationsFormMutation = {
  __typename?: 'Mutation';
  createCollaboration: { __typename: 'CollaboratingOrganizations'; uuid: string };
};

export type CollaborationsFormDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
  organizationUuid: Scalars['ID']['input'];
}>;

export type CollaborationsFormDataQuery = {
  __typename?: 'Query';
  collaboratingOrganizations: Array<{
    __typename: 'CollaboratingOrganizations';
    uuid: string;
    name: string;
    collaborationStatus?: CollaborationStatus | null;
  }>;
} & { ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment } };

export type CollaborationsTableFieldsFragment = ({
  __typename?: 'Query';
  collaboratingOrganizations: Array<{
    __typename: 'CollaboratingOrganizations';
    uuid: string;
    name: string;
    collaborationStatus?: CollaborationStatus | null;
    sourceOrganization?: string | null;
  }>;
} & { ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment } }) & {
  ' $fragmentName'?: 'CollaborationsTableFieldsFragment';
};

export type BpCreateGroupsFromCourseFormMutationVariables = Exact<{
  input: BpGroupCreateInput;
}>;

export type BpCreateGroupsFromCourseFormMutation = {
  __typename?: 'Mutation';
  createBpGroup: { __typename: 'Group'; uuid: string };
};

export type BpUpdateGroupsinCourseFormMutationVariables = Exact<{
  update: BpGroupUpdateInput;
  uuid: Scalars['ID']['input'];
}>;

export type BpUpdateGroupsinCourseFormMutation = {
  __typename?: 'Mutation';
  updateBpGroup: {
    __typename: 'Group';
    uuid: string;
    name: string;
    viewers: Array<{ __typename: 'Profile'; uuid: string }>;
    admins: Array<{ __typename: 'Profile'; uuid: string }>;
    editors: Array<{ __typename: 'Profile'; uuid: string }>;
  };
};

export type CourseFormPageDataQueryVariables = Exact<{
  courseUuid: Scalars['ID']['input'];
  organizationUuid: Scalars['ID']['input'];
  profile: Scalars['ID']['input'];
  groupType: GroupType;
}>;

export type CourseFormPageDataQuery = {
  __typename?: 'Query';
  groups: Array<{
    __typename: 'Group';
    uuid: string;
    name: string;
    grades?: Array<string> | null;
    schoolYear?: { __typename: 'SchoolYear'; uuid: string } | null;
    subject?: { __typename: 'Subject'; uuid: string; name: string } | null;
    admins: Array<{
      __typename: 'Profile';
      uuid: string;
      displayName?: string | null;
      organization: { __typename: 'Organization'; uuid: string };
    }>;
    groups: Array<{ __typename: 'Group'; uuid: string }>;
    editors: Array<{ __typename: 'Profile'; uuid: string }>;
    viewers: Array<{ __typename: 'Profile'; uuid: string }>;
  }>;
} & {
  ' $fragmentRefs'?: {
    GroupFormProfilesFieldsFragment: GroupFormProfilesFieldsFragment;
    GroupFormAdminsFieldsFragment: GroupFormAdminsFieldsFragment;
    CourseFormBaseDataFieldsFragment: CourseFormBaseDataFieldsFragment;
    CourseFormTeachersFieldsFragment: CourseFormTeachersFieldsFragment;
  };
};

export type CourseFormBaseDataFieldsFragment = ({
  __typename?: 'Query';
  schoolYears: Array<{ __typename: 'SchoolYear'; uuid: string; name: string }>;
  subjects: Array<{ __typename: 'Subject'; uuid: string; name: string }>;
  profiles: Array<{ __typename: 'Profile'; uuid: string; displayName?: string | null }>;
  classes: Array<{ __typename: 'Class'; uuid: string; shortName: string }>;
} & { ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment } }) & {
  ' $fragmentName'?: 'CourseFormBaseDataFieldsFragment';
};

export type CourseFormTeachersFieldsFragment = {
  __typename?: 'Query';
  courseFormTeachersProfiles: Array<{ __typename: 'Profile'; uuid: string; selectName?: string | null }>;
} & { ' $fragmentName'?: 'CourseFormTeachersFieldsFragment' };

export type UpdateGroupSettingsFromCourseSettingsFormMutationVariables = Exact<{
  where: GroupWhere;
  update: UpdateGroupSettings;
}>;

export type UpdateGroupSettingsFromCourseSettingsFormMutation = {
  __typename?: 'Mutation';
  updateGroupSettings: { __typename?: 'EntitiesUpdateInfo'; entitiesUpdated: number };
};

export type CourseSettingsFormPageDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
  courseUuid: Scalars['ID']['input'];
}>;

export type CourseSettingsFormPageDataQuery = {
  __typename?: 'Query';
  groups: Array<{
    __typename: 'Group';
    uuid: string;
    nextcloudConnection: {
      __typename: 'GroupNextcloudConnection';
      edges: Array<{
        __typename?: 'GroupNextcloudRelationship';
        properties: { __typename?: 'NextcloudGroupProps'; enabled?: boolean | null };
      }>;
    };
    threemaBroadcastConnection: {
      __typename: 'GroupThreemaBroadcastConnection';
      edges: Array<{
        __typename?: 'GroupThreemaBroadcastRelationship';
        properties: { __typename?: 'ThreemaBroadcastProps'; enabled?: boolean | null };
      }>;
    };
  }>;
} & { ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment } };

export type CoursesPreviewTableFieldsFragment = {
  __typename?: 'Query';
  groups: Array<{
    __typename: 'Group';
    uuid: string;
    isCommunity: boolean;
    name: string;
    organization: { __typename: 'Organization'; uuid: string };
    events: Array<{ __typename: 'CalendarEvent'; uuid: string }>;
    schoolYear?: { __typename: 'SchoolYear'; uuid: string } | null;
    teachingUnitsConnection: {
      __typename: 'GroupTeachingUnitsConnection';
      edges: Array<{
        __typename: 'GroupTeachingUnitsRelationship';
        node: {
          __typename: 'TeachingUnit';
          uuid: string;
          assignments: Array<{
            __typename?: 'Assignment';
            uuid: string;
            submissions: Array<{ __typename: 'Submission'; uuid: string }>;
          }>;
        };
      }>;
    };
  }>;
  assignments: Array<{
    __typename: 'Assignment';
    uuid: string;
    submissions: Array<{ __typename: 'Submission'; uuid: string }>;
    holder: { __typename: 'TeachingUnit'; uuid: string; group: { __typename?: 'Group'; uuid: string } };
  }>;
} & { ' $fragmentName'?: 'CoursesPreviewTableFieldsFragment' };

export type BpUpdateProfileSettingsMutationVariables = Exact<{
  where: ProfileWhere;
  update: UpdateProfileSettings;
}>;

export type BpUpdateProfileSettingsMutation = {
  __typename?: 'Mutation';
  updateProfileSettings: { __typename?: 'EntitiesUpdateInfo'; entitiesUpdated: number };
};

export type DivisionsListFieldsFragment = {
  __typename?: 'Query';
  divisionList: Array<{
    __typename: 'Class';
    uuid: string;
    divisionsConnection: {
      __typename?: 'ClassDivisionsConnection';
      edges: Array<{
        __typename?: 'ClassDivisionsRelationship';
        node: {
          __typename: 'Division';
          uuid: string;
          name: string;
          groups: Array<{
            __typename: 'ClassGroup';
            uuid: string;
            name: string;
            shortName: string;
            division: { __typename: 'Division'; uuid: string };
            membersConnection: {
              __typename: 'ClassGroupMembersConnection';
              edges: Array<{ __typename: 'ClassGroupMembersRelationship' }>;
            };
          }>;
        };
      }>;
    };
  }>;
} & { ' $fragmentName'?: 'DivisionsListFieldsFragment' };

export type CreateClassGroupMutationVariables = Exact<{
  input: Array<ClassGroupCreateInput> | ClassGroupCreateInput;
}>;

export type CreateClassGroupMutation = {
  __typename?: 'Mutation';
  createClassGroups: {
    __typename?: 'CreateClassGroupsMutationResponse';
    classGroups: Array<{ __typename: 'ClassGroup'; uuid: string }>;
  };
};

export type CreateDivisionMutationVariables = Exact<{
  input: Array<DivisionCreateInput> | DivisionCreateInput;
}>;

export type CreateDivisionMutation = {
  __typename?: 'Mutation';
  createDivisions: {
    __typename?: 'CreateDivisionsMutationResponse';
    divisions: Array<{ __typename: 'Division'; uuid: string }>;
  };
};

export type UpdateClassGroupMutationVariables = Exact<{
  update: ClassGroupUpdateInput;
  where: ClassGroupWhere;
}>;

export type UpdateClassGroupMutation = {
  __typename?: 'Mutation';
  updateClassGroups: {
    __typename?: 'UpdateClassGroupsMutationResponse';
    classGroups: Array<{ __typename: 'ClassGroup'; uuid: string; name: string; shortName: string }>;
  };
};

export type UpdateDivisionMutationVariables = Exact<{
  update: DivisionUpdateInput;
  where: DivisionWhere;
}>;

export type UpdateDivisionMutation = {
  __typename?: 'Mutation';
  updateDivisions: {
    __typename?: 'UpdateDivisionsMutationResponse';
    divisions: Array<{ __typename: 'Division'; uuid: string; name: string }>;
  };
};

export type DeleteClassGroupMutationVariables = Exact<{
  delete: ClassGroupDeleteInput;
  where: ClassGroupWhere;
}>;

export type DeleteClassGroupMutation = {
  __typename?: 'Mutation';
  deleteClassGroups: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type DeleteDivisionMutationVariables = Exact<{
  delete: DivisionDeleteInput;
  where: DivisionWhere;
}>;

export type DeleteDivisionMutation = {
  __typename?: 'Mutation';
  deleteDivisions: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type DivisionsFormPageDataQueryVariables = Exact<{
  classUuid: Scalars['ID']['input'];
  organizationUuid: Scalars['ID']['input'];
}>;

export type DivisionsFormPageDataQuery = {
  __typename?: 'Query';
  divisions: Array<{
    __typename: 'Division';
    uuid: string;
    name: string;
    groups: Array<{ __typename: 'ClassGroup'; uuid: string; name: string; shortName: string }>;
  }>;
};

export type BpDeleteCalendarEventMutationVariables = Exact<{
  where: CalendarEventWhere;
}>;

export type BpDeleteCalendarEventMutation = {
  __typename?: 'Mutation';
  deleteCalendarEvents: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type EventsListFieldsFragment = ({ __typename?: 'Query' } & {
  ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment };
}) & { ' $fragmentName'?: 'EventsListFieldsFragment' };

export type FilePreviewTableFieldsFragment = {
  __typename: 'FileEntry';
  uuid: string;
  filename: string;
  updated: any;
  downloadToken: string;
} & { ' $fragmentName'?: 'FilePreviewTableFieldsFragment' };

export type BpUpdateFileEntryMutationVariables = Exact<{
  where: FileEntryWhere;
  update: FileEntryUpdateInput;
}>;

export type BpUpdateFileEntryMutation = {
  __typename?: 'Mutation';
  updateFileEntries: {
    __typename?: 'UpdateFileEntriesMutationResponse';
    fileEntries: Array<
      { __typename: 'FileEntry'; uuid: string } & {
        ' $fragmentRefs'?: { FileTableFieldsFragment: FileTableFieldsFragment };
      }
    >;
  };
};

export type BpDeleteFileEntryMutationVariables = Exact<{
  where: FileEntryWhere;
}>;

export type BpDeleteFileEntryMutation = {
  __typename?: 'Mutation';
  deleteFileEntries: { __typename?: 'DeleteInfo'; nodesDeleted: number; relationshipsDeleted: number };
};

export type FileTableFieldsFragment = {
  __typename: 'FileEntry';
  uuid: string;
  mediaType: string;
  size: number;
  publicDownloadToken?: string | null;
  downloadToken: string;
  filename: string;
} & { ' $fragmentName'?: 'FileTableFieldsFragment' };

export type BpUpdateProfileRolesMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
  roles: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type BpUpdateProfileRolesMutation = {
  __typename?: 'Mutation';
  updateAclRoles: { __typename?: 'EntitiesUpdateInfo'; entitiesUpdated: number };
};

export type BpCreateGroupsMutationVariables = Exact<{
  input: BpGroupCreateInput;
}>;

export type BpCreateGroupsMutation = { __typename?: 'Mutation'; createBpGroup: { __typename: 'Group'; uuid: string } };

export type BpUpdateGroupsInGroupFormMutationVariables = Exact<{
  update: BpGroupUpdateInput;
  uuid: Scalars['ID']['input'];
}>;

export type BpUpdateGroupsInGroupFormMutation = {
  __typename?: 'Mutation';
  updateBpGroup: {
    __typename: 'Group';
    uuid: string;
    name: string;
    description?: string | null;
    schoolYear?: { __typename: 'SchoolYear'; uuid: string } | null;
    viewers: Array<{ __typename: 'Profile'; uuid: string }>;
    editors: Array<{ __typename: 'Profile'; uuid: string }>;
    admins: Array<{ __typename: 'Profile'; uuid: string }>;
  };
};

export type GroupFormDataQueryVariables = Exact<{
  groupsWhere: GroupWhere;
  profile: Scalars['ID']['input'];
  organizationUuid: Scalars['ID']['input'];
  groupType: GroupType;
}>;

export type GroupFormDataQuery = {
  __typename?: 'Query';
  groups: Array<{
    __typename: 'Group';
    uuid: string;
    name: string;
    description?: string | null;
    admins: Array<{
      __typename: 'Profile';
      uuid: string;
      displayName?: string | null;
      organization: { __typename: 'Organization'; uuid: string };
    }>;
    schoolYear?: { __typename: 'SchoolYear'; uuid: string } | null;
    editors: Array<{ __typename: 'Profile'; uuid: string }>;
    viewers: Array<{ __typename: 'Profile'; uuid: string }>;
  }>;
} & {
  ' $fragmentRefs'?: {
    GroupFormBaseDataFieldsFragment: GroupFormBaseDataFieldsFragment;
    GroupFormProfilesFieldsFragment: GroupFormProfilesFieldsFragment;
    GroupFormAdminsFieldsFragment: GroupFormAdminsFieldsFragment;
  };
};

export type GroupFormAdminsFieldsFragment = ({
  __typename?: 'Query';
  collaboratingOrganizations: Array<{
    __typename: 'CollaboratingOrganizations';
    uuid: string;
    collaborationStatus?: CollaborationStatus | null;
    name: string;
    groupAdmins: Array<{ __typename: 'PimProfile'; uuid: string; displayName?: string | null }>;
    collaborationAdmins: Array<{ __typename: 'PimProfile'; uuid: string; displayName?: string | null }>;
  }>;
} & { ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment } }) & {
  ' $fragmentName'?: 'GroupFormAdminsFieldsFragment';
};

export type GroupFormBaseDataFieldsFragment = ({
  __typename?: 'Query';
  schoolYears: Array<{ __typename: 'SchoolYear'; uuid: string; name: string }>;
  profiles: Array<{ __typename: 'Profile'; uuid: string; displayName?: string | null }>;
} & { ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment } }) & {
  ' $fragmentName'?: 'GroupFormBaseDataFieldsFragment';
};

export type BpUpdateGroupsInGroupFormOtherMutationVariables = Exact<{
  update: BpGroupUpdateInput;
  uuid: Scalars['ID']['input'];
}>;

export type BpUpdateGroupsInGroupFormOtherMutation = {
  __typename?: 'Mutation';
  updateBpGroup: {
    __typename: 'Group';
    uuid: string;
    viewers: Array<{ __typename: 'Profile'; uuid: string }>;
    editors: Array<{ __typename: 'Profile'; uuid: string }>;
    admins: Array<{ __typename: 'Profile'; uuid: string }>;
  };
};

export type GroupFormOtherPageDataQueryVariables = Exact<{
  groupUuid: Scalars['ID']['input'];
  organizationUuid: Scalars['ID']['input'];
  groupType: GroupType;
}>;

export type GroupFormOtherPageDataQuery = {
  __typename?: 'Query';
  groups: Array<{
    __typename: 'Group';
    uuid: string;
    editors: Array<{ __typename: 'Profile'; uuid: string }>;
    viewers: Array<{ __typename: 'Profile'; uuid: string }>;
    admins: Array<{ __typename: 'Profile'; uuid: string }>;
  }>;
} & { ' $fragmentRefs'?: { GroupFormProfilesFieldsFragment: GroupFormProfilesFieldsFragment } };

export type GroupFormProfilesFieldsFragment = {
  __typename?: 'Query';
  profiles: Array<{ __typename: 'Profile'; uuid: string; selectName?: string | null }>;
  groupsForFormProfiles: Array<{
    __typename: 'Group';
    uuid: string;
    name: string;
    viewers: Array<{ __typename: 'Profile'; uuid: string; selectName?: string | null }>;
  }>;
  classes: Array<{
    __typename: 'Class';
    uuid: string;
    shortName: string;
    membersConnection: {
      __typename: 'ClassMembersConnection';
      edges: Array<{
        __typename: 'ClassMembersRelationship';
        node: { __typename: 'Profile'; uuid: string; selectName?: string | null };
      }>;
    };
  }>;
  divisions: Array<{
    __typename: 'Division';
    uuid: string;
    class: { __typename: 'Class'; uuid: string };
    groups: Array<{
      __typename: 'ClassGroup';
      uuid: string;
      name: string;
      members: Array<{ __typename: 'Profile'; uuid: string; selectName?: string | null }>;
    }>;
  }>;
  classGroups: Array<{
    __typename: 'ClassGroup';
    uuid: string;
    membersConnection: {
      __typename: 'ClassGroupMembersConnection';
      edges: Array<{
        __typename: 'ClassGroupMembersRelationship';
        node: { __typename: 'Profile'; uuid: string; selectName?: string | null };
      }>;
    };
  }>;
} & { ' $fragmentName'?: 'GroupFormProfilesFieldsFragment' };

export type UpdateGroupSettingsMutationVariables = Exact<{
  where: GroupWhere;
  update: UpdateGroupSettings;
}>;

export type UpdateGroupSettingsMutation = {
  __typename?: 'Mutation';
  updateGroupSettings: { __typename?: 'EntitiesUpdateInfo'; entitiesUpdated: number };
};

export type GroupSettingsFormPageDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
  groupUuid: Scalars['ID']['input'];
}>;

export type GroupSettingsFormPageDataQuery = {
  __typename?: 'Query';
  groups: Array<{
    __typename: 'Group';
    uuid: string;
    nextcloudConnection: {
      __typename: 'GroupNextcloudConnection';
      edges: Array<{
        __typename: 'GroupNextcloudRelationship';
        properties: { __typename: 'NextcloudGroupProps'; enabled?: boolean | null };
      }>;
    };
    threemaBroadcastConnection: {
      __typename: 'GroupThreemaBroadcastConnection';
      edges: Array<{
        __typename: 'GroupThreemaBroadcastRelationship';
        properties: { __typename: 'ThreemaBroadcastProps'; enabled?: boolean | null };
      }>;
    };
  }>;
} & { ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment } };

export type GroupsPreviewTableFieldsFragment = ({
  __typename?: 'Query';
  profileGroups: Array<{
    __typename: 'Group';
    uuid: string;
    name: string;
    organization: { __typename: 'Organization'; uuid: string };
    events: Array<{ __typename: 'CalendarEvent'; uuid: string }>;
  }>;
} & { ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment } }) & {
  ' $fragmentName'?: 'GroupsPreviewTableFieldsFragment';
};

export type GroupsTableFieldsFragment = ({ __typename?: 'Query' } & {
  ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment };
}) & { ' $fragmentName'?: 'GroupsTableFieldsFragment' };

export type HeaderQueryFieldsFragment = ({ __typename?: 'Query' } & {
  ' $fragmentRefs'?: {
    PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment;
    HeaderMeetingsFlyoutFieldsFragment: HeaderMeetingsFlyoutFieldsFragment;
  };
}) & { ' $fragmentName'?: 'HeaderQueryFieldsFragment' };

export type HeaderMeetingsFlyoutFieldsFragment = ({ __typename?: 'Query' } & {
  ' $fragmentRefs'?: {
    CalendarEventMapCalendarEventsToBpEventTypeFieldsFragment: CalendarEventMapCalendarEventsToBpEventTypeFieldsFragment;
    MeetingsFlyoutFieldsFragment: MeetingsFlyoutFieldsFragment;
  };
}) & { ' $fragmentName'?: 'HeaderMeetingsFlyoutFieldsFragment' };

export type DashboardEventsFieldsFragment = ({ __typename?: 'Query' } & {
  ' $fragmentRefs'?: {
    EventsListFieldsFragment: EventsListFieldsFragment;
    DashboardEventsQueryFieldsFragment: DashboardEventsQueryFieldsFragment;
  };
}) & { ' $fragmentName'?: 'DashboardEventsFieldsFragment' };

export type PreviewDataQueryFieldsFragment = ({
  __typename?: 'Query';
  profileCourses: Array<{ __typename: 'Group'; uuid: string }>;
  profileGroups: Array<{ __typename: 'Group'; uuid: string }>;
} & {
  ' $fragmentRefs'?: {
    GroupsPreviewTableFieldsFragment: GroupsPreviewTableFieldsFragment;
    CoursesPreviewTableFieldsFragment: CoursesPreviewTableFieldsFragment;
  };
}) & { ' $fragmentName'?: 'PreviewDataQueryFieldsFragment' };

export type DashboardEventsQueryFieldsFragment = {
  __typename?: 'Query';
  calendarEvents: Array<{
    __typename: 'CalendarEvent';
    uuid: string;
    duration: string;
    start: string;
    classShortNames?: Array<string> | null;
    categories?: Array<string> | null;
    title?: string | null;
    description?: string | null;
    keywords?: Array<string> | null;
    locations: Array<{ __typename?: 'Location'; uuid: string }>;
    virtualLocations: Array<{ __typename?: 'VirtualLocation'; uuid: string }>;
    holderConnection: {
      __typename?: 'CalendarEventHolderConnection';
      edges: Array<{
        __typename?: 'CalendarEventHolderRelationship';
        node:
          | { __typename: 'Group'; uuid: string; displayName?: string | null }
          | { __typename: 'Organization'; uuid: string; displayName?: string | null }
          | { __typename: 'Profile'; uuid: string; displayName?: string | null };
      }>;
    };
  }>;
  birthdayEvents: Array<{
    __typename?: 'CalendarEvent';
    uuid: string;
    duration: string;
    title?: string | null;
    start: string;
    color?: string | null;
    categories?: Array<string> | null;
    classShortNames?: Array<string> | null;
  }>;
} & { ' $fragmentName'?: 'DashboardEventsQueryFieldsFragment' };

export type LinkListFieldsFragment = ({ __typename?: 'Query' } & {
  ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment };
}) & { ' $fragmentName'?: 'LinkListFieldsFragment' };

export type MaterialDetailFieldsFragment = ({
  __typename?: 'Query';
  workMaterials: Array<{
    __typename: 'WorkMaterial';
    uuid: string;
    title: string;
    material: {
      __typename: 'Material';
      uuid: string;
      text?: string | null;
      fileEntries: Array<
        { __typename: 'FileEntry'; uuid: string } & {
          ' $fragmentRefs'?: { FileTableFieldsFragment: FileTableFieldsFragment };
        }
      >;
    };
  }>;
} & { ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment } }) & {
  ' $fragmentName'?: 'MaterialDetailFieldsFragment';
};

export type ConvertEventFieldsFragment = {
  __typename: 'CalendarEvent';
  uuid: string;
  categories?: Array<string> | null;
  classShortNames?: Array<string> | null;
  description?: string | null;
  duration: string;
  keywords?: Array<string> | null;
  start: string;
  title?: string | null;
  holderConnection: {
    __typename?: 'CalendarEventHolderConnection';
    edges: Array<{
      __typename?: 'CalendarEventHolderRelationship';
      node:
        | { __typename?: 'Group'; uuid: string; displayName?: string | null }
        | { __typename?: 'Organization'; uuid: string; displayName?: string | null }
        | { __typename?: 'Profile'; uuid: string; displayName?: string | null };
    }>;
  };
  locations: Array<{ __typename: 'Location'; uuid: string }>;
  virtualLocations: Array<{ __typename: 'VirtualLocation'; uuid: string }>;
} & { ' $fragmentName'?: 'ConvertEventFieldsFragment' };

export type MeetingsFlyoutFieldsFragment = ({
  __typename?: 'Query';
  runningMeetings: Array<
    {
      __typename: 'CalendarEvent';
      uuid: string;
      guestsAllowed?: boolean | null;
      owner: { __typename: 'Profile'; uuid: string };
      organization: { __typename: 'Organization'; uuid: string };
      virtualLocations: Array<{ __typename: 'VirtualLocation'; uuid: string; token: string }>;
    } & { ' $fragmentRefs'?: { ConvertEventFieldsFragment: ConvertEventFieldsFragment } }
  >;
  notRunningMeetings: Array<
    {
      __typename: 'CalendarEvent';
      uuid: string;
      guestsAllowed?: boolean | null;
      start: string;
      duration: string;
      owner: { __typename: 'Profile'; uuid: string };
      organization: { __typename: 'Organization'; uuid: string };
      virtualLocations: Array<{ __typename: 'VirtualLocation'; uuid: string; token: string }>;
    } & { ' $fragmentRefs'?: { ConvertEventFieldsFragment: ConvertEventFieldsFragment } }
  >;
} & { ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment } }) & {
  ' $fragmentName'?: 'MeetingsFlyoutFieldsFragment';
};

export type MeetingsLinksFieldsFragment = {
  __typename?: 'Query';
  runningMeetings: Array<{
    __typename: 'CalendarEvent';
    uuid: string;
    virtualLocations: Array<{ __typename: 'VirtualLocation'; uuid: string; token: string }>;
    holderConnection: {
      __typename: 'CalendarEventHolderConnection';
      edges: Array<{
        __typename?: 'CalendarEventHolderRelationship';
        node:
          | { __typename: 'Group'; uuid: string }
          | { __typename: 'Organization'; uuid: string }
          | { __typename: 'Profile'; uuid: string };
      }>;
    };
  }>;
} & { ' $fragmentName'?: 'MeetingsLinksFieldsFragment' };

export type MobileMenuQueryFieldsFragment = ({ __typename?: 'Query' } & {
  ' $fragmentRefs'?: {
    CalendarEventMapCalendarEventsToBpEventTypeFieldsFragment: CalendarEventMapCalendarEventsToBpEventTypeFieldsFragment;
    MeetingsFlyoutFieldsFragment: MeetingsFlyoutFieldsFragment;
  };
}) & { ' $fragmentName'?: 'MobileMenuQueryFieldsFragment' };

export type BpCreateCalendarEventMutationVariables = Exact<{
  input: Array<CalendarEventCreateInput> | CalendarEventCreateInput;
}>;

export type BpCreateCalendarEventMutation = {
  __typename?: 'Mutation';
  createCalendarEvents: {
    __typename?: 'CreateCalendarEventsMutationResponse';
    calendarEvents: Array<{
      __typename: 'CalendarEvent';
      uuid: string;
      virtualLocations: Array<{ __typename: 'VirtualLocation'; uuid: string; token: string }>;
    }>;
  };
};

export type InstantMeetingsFormPageDataQueryVariables = Exact<{
  groupUuid: Scalars['ID']['input'];
}>;

export type InstantMeetingsFormPageDataQuery = {
  __typename?: 'Query';
  groupsForLicenses: Array<{
    __typename: 'Group';
    uuid: string;
    organization: {
      __typename: 'Organization';
      uuid: string;
      licensedProducts: Array<
        | { __typename: 'BigBlueButton'; uuid: string; allowRecording?: boolean | null }
        | { __typename: 'Bildungsplattform'; uuid: string }
        | { __typename: 'Nextcloud'; uuid: string }
        | { __typename: 'Threema'; uuid: string }
        | { __typename: 'ThreemaBroadcast'; uuid: string }
        | { __typename: 'Zoom'; uuid: string }
      >;
    };
  }>;
} & { ' $fragmentRefs'?: { UseGroupMembersCountFieldsFragment: UseGroupMembersCountFieldsFragment } };

export type CreateNotificationPreferencesMutationVariables = Exact<{
  input: Array<PreferenceCreateInput> | PreferenceCreateInput;
}>;

export type CreateNotificationPreferencesMutation = {
  __typename?: 'Mutation';
  createPreferences: {
    __typename?: 'CreatePreferencesMutationResponse';
    info: { __typename?: 'CreateInfo'; nodesCreated: number };
  };
};

export type UpdateProfileMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  update: ProfileUpdateInput;
}>;

export type UpdateProfileMutation = {
  __typename?: 'Mutation';
  updateProfiles: {
    __typename?: 'UpdateProfilesMutationResponse';
    profiles: Array<{
      __typename: 'Profile';
      prefixName?: string | null;
      displayName?: string | null;
      selectName?: string | null;
      displayNameShort?: string | null;
      organizationRoles: Array<string>;
      firstName?: string | null;
      firstNames?: string | null;
      lastName?: string | null;
      uuid: string;
      title?: string | null;
      salutation?: string | null;
      userStatus: UserStatus;
      organization: { __typename?: 'Organization'; uuid: string };
    }>;
  };
};

export type NotificationSettingsFormFieldsFragment = ({
  __typename?: 'Query';
  profiles: Array<{
    __typename: 'Profile';
    uuid: string;
    notificationPreferencesConnection: {
      __typename: 'ProfileNotificationPreferencesConnection';
      edges: Array<{
        __typename: 'ProfileNotificationPreferencesRelationship';
        node: { __typename: 'Preference'; name: string };
        properties: { __typename: 'NotificationPreferenceProperty'; transports: Array<string> };
      }>;
    };
  }>;
} & { ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment } }) & {
  ' $fragmentName'?: 'NotificationSettingsFormFieldsFragment';
};

export type OpenAssignmentQueryFieldsFragment = {
  __typename?: 'Query';
  assignments: Array<{
    __typename?: 'Assignment';
    uuid: string;
    title: string;
    created: any;
    dueDate?: { __typename?: 'Day'; uuid: string; date: string } | null;
    visibleFrom?: { __typename?: 'Day'; uuid: string; date: string } | null;
    holder: { __typename: 'TeachingUnit'; uuid: string; group: { __typename?: 'Group'; uuid: string } };
  }>;
  submissions: Array<{
    __typename: 'Submission';
    uuid: string;
    status: SubmissionStatus;
    assignment: Array<{ __typename: 'Assignment'; uuid: string }>;
  }>;
  openAssignmentCalendarEvents: Array<{
    __typename: 'CalendarEvent';
    uuid: string;
    categories?: Array<string> | null;
    start: string;
    duration: string;
    description?: string | null;
    title?: string | null;
    recurrenceRule?: { __typename: 'RecurrenceRule'; uuid: string; frequency?: EventRecurrence | null } | null;
  }>;
} & { ' $fragmentName'?: 'OpenAssignmentQueryFieldsFragment' };

export type BpUpdateParentsMutationVariables = Exact<{
  child: Scalars['ID']['input'];
  parents: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type BpUpdateParentsMutation = {
  __typename?: 'Mutation';
  updateParents: { __typename?: 'EntitiesUpdateInfo'; entitiesUpdated: number };
};

export type ParentProfilesFormPageDataQueryVariables = Exact<{
  childUuid: Scalars['ID']['input'];
  organizationUuid: Scalars['ID']['input'];
}>;

export type ParentProfilesFormPageDataQuery = {
  __typename?: 'Query';
  listParents: Array<{ __typename: 'Profile'; uuid: string }>;
  profiles: Array<{
    __typename: 'Profile';
    uuid: string;
    organizationRoles: Array<string>;
    selectName?: string | null;
  }>;
};

export type ProcuratClassesDataQueryVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
}>;

export type ProcuratClassesDataQuery = {
  __typename?: 'Query';
  schoolYears: Array<{ __typename: 'SchoolYear'; uuid: string; name: string }>;
  classes: Array<{ __typename: 'Class'; uuid: string; foreignRefId?: Array<string> | null; updatedAt: any }>;
};

export type ProcuratDepartmentsPageDataQueryVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
}>;

export type ProcuratDepartmentsPageDataQuery = {
  __typename?: 'Query';
  profiles: Array<{
    __typename: 'Profile';
    uuid: string;
    foreignRefId?: Array<string> | null;
    updatedAt?: any | null;
    createdAt?: any | null;
    rolesConnection: {
      __typename?: 'ProfileRolesConnection';
      edges: Array<{
        __typename: 'ProfileRolesRelationship';
        properties: { __typename: 'RoleNames'; roleNames: Array<string> };
      }>;
    };
  }>;
};

export type ProcuratGroupsDataQueryVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
}>;

export type ProcuratGroupsDataQuery = {
  __typename?: 'Query';
  groups: Array<{
    __typename: 'Group';
    uuid: string;
    foreignRefId?: Array<string> | null;
    updatedAt?: any | null;
    createdAt?: any | null;
  }>;
};

export type ImportPersonsFormDataQueryVariables = Exact<{
  where: ProfileWhere;
}>;

export type ImportPersonsFormDataQuery = {
  __typename?: 'Query';
  profiles: Array<{
    __typename: 'Profile';
    uuid: string;
    organizationRoles: Array<string>;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
  }>;
};

export type UpdateBpProfileInProfileFormMutationVariables = Exact<{
  update: BpProfileUpdateInput;
  uuid: Scalars['String']['input'];
}>;

export type UpdateBpProfileInProfileFormMutation = {
  __typename?: 'Mutation';
  updateBpProfile: {
    __typename: 'Profile';
    uuid: string;
    email?: string | null;
    threemaId?: string | null;
    firstName?: string | null;
    lastName?: string | null;
  };
};

export type ProfileFormFieldsFragment = {
  __typename?: 'Query';
  profiles: Array<{
    __typename: 'Profile';
    uuid: string;
    email?: string | null;
    threemaId?: string | null;
    firstName?: string | null;
    lastName?: string | null;
  }>;
} & { ' $fragmentName'?: 'ProfileFormFieldsFragment' };

export type AddPushIdsInNotificationSettingsMutationVariables = Exact<{
  add: NotificationSettingsUpdateInput;
  userUuid: Scalars['ID']['input'];
}>;

export type AddPushIdsInNotificationSettingsMutation = {
  __typename?: 'Mutation';
  updateNotificationSettings: {
    __typename?: 'UpdateNotificationSettingsMutationResponse';
    notificationSettings: Array<{ __typename: 'NotificationSettings'; userUuid: string; pushIds: Array<string> }>;
  };
};

export type CreatePushIdIfNoneIsDefinedInNotificationSettingsMutationVariables = Exact<{
  input: Array<NotificationSettingsCreateInput> | NotificationSettingsCreateInput;
}>;

export type CreatePushIdIfNoneIsDefinedInNotificationSettingsMutation = {
  __typename?: 'Mutation';
  createNotificationSettings: {
    __typename?: 'CreateNotificationSettingsMutationResponse';
    notificationSettings: Array<{ __typename: 'NotificationSettings'; userUuid: string; pushIds: Array<string> }>;
  };
};

export type PushNotificationWrapperFieldsFragment = {
  __typename?: 'Query';
  notificationSettings: Array<{ __typename: 'NotificationSettings'; userUuid: string; pushIds: Array<string> }>;
} & { ' $fragmentName'?: 'PushNotificationWrapperFieldsFragment' };

export type RunningMeetingsTableFieldsFragment = {
  __typename?: 'Query';
  calendarEvents: Array<{
    __typename: 'CalendarEvent';
    uuid: string;
    start: string;
    maxAttendees?: number | null;
    holderConnection: {
      __typename: 'CalendarEventHolderConnection';
      edges: Array<{
        __typename: 'CalendarEventHolderRelationship';
        node:
          | { __typename: 'Group'; uuid: string; displayName?: string | null; type: GroupType }
          | { __typename: 'Organization'; uuid: string; displayName?: string | null }
          | { __typename: 'Profile'; uuid: string; displayName?: string | null };
      }>;
    };
    virtualLocations: Array<{
      __typename: 'VirtualLocation';
      uuid: string;
      running: boolean;
      token: string;
      attendeesConnection: {
        __typename: 'VirtualLocationAttendeesConnection';
        edges: Array<{
          __typename: 'VirtualLocationAttendeesRelationship';
          properties: { __typename: 'VirtualLocationAttendeeProperties'; withVideo?: boolean | null };
          node: { __typename: 'Profile'; uuid: string };
        }>;
      };
    }>;
  }>;
} & { ' $fragmentName'?: 'RunningMeetingsTableFieldsFragment' };

export type CreateBpSchoolyearMutationVariables = Exact<{
  input: BpSchoolyearCreateInput;
}>;

export type CreateBpSchoolyearMutation = {
  __typename?: 'Mutation';
  createBpSchoolyear: { __typename: 'SchoolYear'; uuid: string };
};

export type UpdateBpSchoolyearMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  update: BpSchoolyearUpdateInput;
}>;

export type UpdateBpSchoolyearMutation = {
  __typename?: 'Mutation';
  updateBpSchoolyear: {
    __typename: 'SchoolYear';
    uuid: string;
    name: string;
    shortName: string;
    start: any;
    end: any;
    createdAt?: any | null;
    managedBy: string;
  };
};

export type SchoolyearFormPageDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
}>;

export type SchoolyearFormPageDataQuery = { __typename?: 'Query' } & {
  ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment };
};

export type SendMatrixMessageFormPageDataQueryVariables = Exact<{
  groupUuid: Scalars['ID']['input'];
}>;

export type SendMatrixMessageFormPageDataQuery = {
  __typename?: 'Query';
  groups: Array<{
    __typename: 'Group';
    uuid: string;
    viewers: Array<{ __typename: 'Profile'; uuid: string; userStatus: UserStatus }>;
    editors: Array<{ __typename: 'Profile'; uuid: string; userStatus: UserStatus }>;
  }>;
};

export type CreateBpSubjectMutationVariables = Exact<{
  input: BpSubjectCreateInput;
}>;

export type CreateBpSubjectMutation = {
  __typename?: 'Mutation';
  createBpSubject: { __typename: 'Subject'; uuid: string };
};

export type UpdateBpSubjectMutationVariables = Exact<{
  update: BpSubjectUpdateInput;
  uuid: Scalars['ID']['input'];
}>;

export type UpdateBpSubjectMutation = {
  __typename?: 'Mutation';
  updateBpSubject: { __typename: 'Subject'; uuid: string; globalSubject?: string | null; name: string };
};

export type SubjectFormPageDataQueryVariables = Exact<{ [key: string]: never }>;

export type SubjectFormPageDataQuery = {
  __typename?: 'Query';
  globalSubjects: Array<{ __typename: 'GlobalSubject'; subject: string }>;
};

export type PublicSubmissionPageDataQueryVariables = Exact<{
  submissionUuid: Scalars['ID']['input'];
}>;

export type PublicSubmissionPageDataQuery = {
  __typename?: 'Query';
  submissions: Array<{
    __typename: 'Submission';
    uuid: string;
    material: {
      __typename: 'Material';
      uuid: string;
      text?: string | null;
      fileEntries: Array<
        { __typename: 'FileEntry'; uuid: string } & {
          ' $fragmentRefs'?: { FileTableFieldsFragment: FileTableFieldsFragment };
        }
      >;
    };
    owner: { __typename: 'Profile'; uuid: string; displayName?: string | null };
  }>;
};

export type BpUpdateSubmissionsMutationVariables = Exact<{
  where: SubmissionWhere;
  update: SubmissionUpdateInput;
}>;

export type BpUpdateSubmissionsMutation = {
  __typename?: 'Mutation';
  updateSubmissions: {
    __typename?: 'UpdateSubmissionsMutationResponse';
    submissions: Array<{ __typename: 'Submission'; uuid: string; status: SubmissionStatus; public?: boolean | null }>;
  };
};

export type CurrentSubmissionPageQueryVariables = Exact<{
  submissionUuid: Scalars['ID']['input'];
  profile: Scalars['ID']['input'];
}>;

export type CurrentSubmissionPageQuery = {
  __typename?: 'Query';
  submissions: Array<{
    __typename: 'Submission';
    uuid: string;
    status: SubmissionStatus;
    public?: boolean | null;
    owner: { __typename: 'Profile'; uuid: string; displayName?: string | null };
    material: {
      __typename: 'Material';
      uuid: string;
      text?: string | null;
      fileEntries: Array<
        { __typename: 'FileEntry'; uuid: string } & {
          ' $fragmentRefs'?: { FileTableFieldsFragment: FileTableFieldsFragment };
        }
      >;
    };
    assignment: Array<{
      __typename: 'Assignment';
      uuid: string;
      holder: {
        __typename: 'TeachingUnit';
        uuid: string;
        group: { __typename: 'Group'; uuid: string; organization: { __typename: 'Organization'; uuid: string } };
      };
    }>;
  }>;
} & { ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment } };

export type SubmissionPageQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
  assignmentUuid: Scalars['ID']['input'];
  currentSubmissionStatus: SubmissionStatus;
}>;

export type SubmissionPageQuery = {
  __typename?: 'Query';
  otherSubmissions: Array<{ __typename: 'Submission'; uuid: string; status: SubmissionStatus }>;
} & { ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment } };

export type BpCreateTeachingTopicMutationVariables = Exact<{
  input: Array<TeachingTopicCreateInput> | TeachingTopicCreateInput;
}>;

export type BpCreateTeachingTopicMutation = {
  __typename?: 'Mutation';
  createTeachingTopics: {
    __typename?: 'CreateTeachingTopicsMutationResponse';
    info: { __typename: 'CreateInfo'; nodesCreated: number };
    teachingTopics: Array<{
      __typename: 'TeachingTopic';
      uuid: string;
      title: string;
      topicParentConnection: {
        __typename: 'TeachingTopicTopicParentConnection';
        edges: Array<{ __typename: 'TeachingTopicTopicParentRelationship' }>;
      };
    }>;
  };
};

export type BpRenameTopicMutationVariables = Exact<{
  update: TeachingTopicUpdateInput;
  where: TeachingTopicWhere;
}>;

export type BpRenameTopicMutation = {
  __typename?: 'Mutation';
  updateTeachingTopics: {
    __typename?: 'UpdateTeachingTopicsMutationResponse';
    teachingTopics: Array<{
      __typename: 'TeachingTopic';
      uuid: string;
      title: string;
      topicParentConnection: {
        __typename: 'TeachingTopicTopicParentConnection';
        edges: Array<{ __typename: 'TeachingTopicTopicParentRelationship' }>;
      };
    }>;
  };
};

export type TeachingTopicFormPageDataQueryVariables = Exact<{
  topicUuid: Scalars['ID']['input'];
  organizationUuid: Scalars['ID']['input'];
}>;

export type TeachingTopicFormPageDataQuery = {
  __typename?: 'Query';
  teachingTopics: Array<{ __typename: 'TeachingTopic'; uuid: string; title: string }>;
};

export type BpDeleteAssignmentsFromTeachingUnitMutationVariables = Exact<{
  where: AssignmentWhere;
}>;

export type BpDeleteAssignmentsFromTeachingUnitMutation = {
  __typename?: 'Mutation';
  deleteAssignments: { __typename?: 'DeleteInfo'; nodesDeleted: number; relationshipsDeleted: number };
};

export type BpDeleteCalendarEventFromTeachingUnitMutationVariables = Exact<{
  where: CalendarEventWhere;
}>;

export type BpDeleteCalendarEventFromTeachingUnitMutation = {
  __typename?: 'Mutation';
  deleteCalendarEvents: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type BpDeleteWorkMaterialsFromTeachingUnitMutationVariables = Exact<{
  where: WorkMaterialWhere;
}>;

export type BpDeleteWorkMaterialsFromTeachingUnitMutation = {
  __typename?: 'Mutation';
  deleteWorkMaterials: { __typename?: 'DeleteInfo'; nodesDeleted: number; relationshipsDeleted: number };
};

export type TeachingUnitPageDataQueryVariables = Exact<{
  teachingUnitUuid: Scalars['ID']['input'];
}>;

export type TeachingUnitPageDataQuery = {
  __typename?: 'Query';
  calendarEvents: Array<{ __typename: 'CalendarEvent'; uuid: string; title?: string | null; start: string }>;
  workMaterials: Array<{
    __typename: 'WorkMaterial';
    uuid: string;
    title: string;
    visibleAfterVisibleTo?: boolean | null;
    visibleFrom?: { __typename: 'Day'; uuid: string; date: string } | null;
    visibleTo?: { __typename: 'Day'; uuid: string; date: string } | null;
    publicFrom?: { __typename: 'Day'; uuid: string; date: string } | null;
  }>;
  assignments: Array<{
    __typename: 'Assignment';
    uuid: string;
    title: string;
    dueDate?: { __typename: 'Day'; uuid: string; date: string } | null;
    visibleFrom?: { __typename: 'Day'; uuid: string; date: string } | null;
  }>;
  teachingUnits: Array<{
    __typename: 'TeachingUnit';
    uuid: string;
    title: string;
    description?: string | null;
    note?: {
      __typename: 'Material';
      uuid: string;
      text?: string | null;
      fileEntries: Array<
        { __typename: 'FileEntry'; uuid: string } & {
          ' $fragmentRefs'?: { FilePreviewTableFieldsFragment: FilePreviewTableFieldsFragment };
        }
      >;
    } | null;
  }>;
};

export type BpCreateTeachingUnitMutationVariables = Exact<{
  input: Array<TeachingUnitCreateInput> | TeachingUnitCreateInput;
}>;

export type BpCreateTeachingUnitMutation = {
  __typename?: 'Mutation';
  createTeachingUnits: {
    __typename?: 'CreateTeachingUnitsMutationResponse';
    teachingUnits: Array<{ __typename: 'TeachingUnit'; uuid: string }>;
  };
};

export type BpUpdateTeachingUnitMutationVariables = Exact<{
  where: TeachingUnitWhere;
  update: TeachingUnitUpdateInput;
}>;

export type BpUpdateTeachingUnitMutation = {
  __typename?: 'Mutation';
  updateTeachingUnits: {
    __typename?: 'UpdateTeachingUnitsMutationResponse';
    info: {
      __typename?: 'UpdateInfo';
      nodesCreated: number;
      nodesDeleted: number;
      relationshipsCreated: number;
      relationshipsDeleted: number;
    };
    teachingUnits: Array<{
      __typename: 'TeachingUnit';
      uuid: string;
      title: string;
      description?: string | null;
      topic: {
        __typename: 'TeachingTopic';
        uuid: string;
        title: string;
        owner: { __typename: 'Profile'; uuid: string };
        organization: { __typename: 'Organization'; uuid: string };
        group: { __typename: 'Group'; uuid: string };
      };
    }>;
  };
};

export type TeachingUnitFormPageDataQueryVariables = Exact<{
  courseUuid: Scalars['ID']['input'];
  teachingUnitUuid: Scalars['ID']['input'];
}>;

export type TeachingUnitFormPageDataQuery = {
  __typename?: 'Query';
  teachingTopics: Array<{ __typename: 'TeachingTopic'; uuid: string; title: string }>;
  teachingUnits: Array<{
    __typename: 'TeachingUnit';
    uuid: string;
    title: string;
    description?: string | null;
    topic: { __typename: 'TeachingTopic'; uuid: string };
  }>;
};

export type BpUpdateTeachingUnitInTeachingUnitNoteFormMutationVariables = Exact<{
  where: TeachingUnitWhere;
  update: TeachingUnitUpdateInput;
}>;

export type BpUpdateTeachingUnitInTeachingUnitNoteFormMutation = {
  __typename?: 'Mutation';
  updateTeachingUnits: {
    __typename?: 'UpdateTeachingUnitsMutationResponse';
    info: {
      __typename?: 'UpdateInfo';
      nodesCreated: number;
      nodesDeleted: number;
      relationshipsCreated: number;
      relationshipsDeleted: number;
    };
    teachingUnits: Array<{
      __typename: 'TeachingUnit';
      uuid: string;
      title: string;
      description?: string | null;
      note?: {
        __typename: 'Material';
        uuid: string;
        text?: string | null;
        fileEntries: Array<{ __typename: 'FileEntry'; uuid: string }>;
      } | null;
    }>;
  };
};

export type TeachingUnitNoteFormPageDataQueryVariables = Exact<{
  teachingUnitUuid: Scalars['ID']['input'];
}>;

export type TeachingUnitNoteFormPageDataQuery = {
  __typename?: 'Query';
  teachingUnits: Array<{
    __typename: 'TeachingUnit';
    uuid: string;
    note?: {
      __typename: 'Material';
      uuid: string;
      text?: string | null;
      fileEntries: Array<
        { __typename: 'FileEntry'; uuid: string } & {
          ' $fragmentRefs'?: { FileTableFieldsFragment: FileTableFieldsFragment };
        }
      >;
    } | null;
  }>;
};

export type TeachingUnitSelectFieldsFragment = {
  __typename?: 'Query';
  teachingUnits: Array<{ __typename: 'TeachingUnit'; uuid: string; title: string }>;
} & { ' $fragmentName'?: 'TeachingUnitSelectFieldsFragment' };

export type BpDeleteTeachingTopicMutationVariables = Exact<{
  where: TeachingTopicWhere;
}>;

export type BpDeleteTeachingTopicMutation = {
  __typename?: 'Mutation';
  deleteTeachingTopics: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type BpDeleteTeachingUnitsMutationVariables = Exact<{
  where: TeachingUnitWhere;
}>;

export type BpDeleteTeachingUnitsMutation = {
  __typename?: 'Mutation';
  deleteTeachingUnits: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type BpUpdateTeachingTopicsConnectionsMutationVariables = Exact<{
  where: TeachingTopicWhere;
  update: TeachingTopicUpdateInput;
}>;

export type BpUpdateTeachingTopicsConnectionsMutation = {
  __typename?: 'Mutation';
  updateTeachingTopics: {
    __typename?: 'UpdateTeachingTopicsMutationResponse';
    info: { __typename?: 'UpdateInfo'; relationshipsCreated: number; relationshipsDeleted: number };
    teachingTopics: Array<{
      __typename: 'TeachingTopic';
      uuid: string;
      topicParentConnection: {
        __typename: 'TeachingTopicTopicParentConnection';
        edges: Array<{
          __typename: 'TeachingTopicTopicParentRelationship';
          node: { __typename: 'TeachingTopic'; uuid: string };
        }>;
      };
    }>;
  };
};

export type BpUpdateTeachingUnitInTeachingUnitsTreeMutationVariables = Exact<{
  where: TeachingUnitWhere;
  update: TeachingUnitUpdateInput;
}>;

export type BpUpdateTeachingUnitInTeachingUnitsTreeMutation = {
  __typename?: 'Mutation';
  updateTeachingUnits: {
    __typename?: 'UpdateTeachingUnitsMutationResponse';
    info: {
      __typename?: 'UpdateInfo';
      nodesCreated: number;
      nodesDeleted: number;
      relationshipsCreated: number;
      relationshipsDeleted: number;
    };
    teachingUnits: Array<{
      __typename: 'TeachingUnit';
      uuid: string;
      title: string;
      description?: string | null;
      topicConnection: {
        __typename: 'TeachingUnitTopicConnection';
        edges: Array<{
          __typename: 'TeachingUnitTopicRelationship';
          node: { __typename: 'TeachingTopic'; uuid: string };
        }>;
      };
    }>;
  };
};

export type TeachingUnitTreeDataQueryVariables = Exact<{
  courseUuid: Scalars['ID']['input'];
}>;

export type TeachingUnitTreeDataQuery = {
  __typename?: 'Query';
  teachingUnits: Array<{
    __typename: 'TeachingUnit';
    uuid: string;
    title: string;
    topic: { __typename: 'TeachingTopic'; uuid: string };
  }>;
  teachingTopics: Array<{
    __typename: 'TeachingTopic';
    uuid: string;
    title: string;
    topicParentConnection: {
      __typename: 'TeachingTopicTopicParentConnection';
      edges: Array<{
        __typename: 'TeachingTopicTopicParentRelationship';
        node: { __typename: 'TeachingTopic'; uuid: string };
      }>;
    };
  }>;
  groups: Array<{ __typename: 'Group'; uuid: string }>;
};

export type WorkMaterialDetailFieldsFragment = {
  __typename?: 'Query';
  workMaterials: Array<{
    __typename: 'WorkMaterial';
    uuid: string;
    title: string;
    visibleFrom?: { __typename: 'Day'; uuid: string; date: string } | null;
    visibleTo?: { __typename: 'Day'; uuid: string; date: string } | null;
    material: {
      __typename: 'Material';
      uuid: string;
      text?: string | null;
      fileEntries: Array<
        { __typename: 'FileEntry'; uuid: string } & {
          ' $fragmentRefs'?: { FileTableFieldsFragment: FileTableFieldsFragment };
        }
      >;
    };
  }>;
} & { ' $fragmentName'?: 'WorkMaterialDetailFieldsFragment' };

export type BpCreateWorkMaterialsMutationVariables = Exact<{
  input: Array<WorkMaterialCreateInput> | WorkMaterialCreateInput;
}>;

export type BpCreateWorkMaterialsMutation = {
  __typename?: 'Mutation';
  createWorkMaterials: {
    __typename?: 'CreateWorkMaterialsMutationResponse';
    workMaterials: Array<{
      __typename: 'WorkMaterial';
      uuid: string;
      holder: { __typename?: 'TeachingUnit'; uuid: string; group: { __typename: 'Group'; uuid: string; name: string } };
    }>;
    info: { __typename?: 'CreateInfo'; nodesCreated: number };
  };
};

export type BpUpdateWorkMaterialsMutationVariables = Exact<{
  update: WorkMaterialUpdateInput;
  where: WorkMaterialWhere;
}>;

export type BpUpdateWorkMaterialsMutation = {
  __typename?: 'Mutation';
  updateWorkMaterials: {
    __typename?: 'UpdateWorkMaterialsMutationResponse';
    workMaterials: Array<{
      __typename: 'WorkMaterial';
      uuid: string;
      title: string;
      visibleAfterVisibleTo?: boolean | null;
      material: {
        __typename: 'Material';
        uuid: string;
        text?: string | null;
        fileEntries: Array<{ __typename: 'FileEntry'; uuid: string }>;
      };
      publicFrom?: { __typename: 'Day'; uuid: string; date: string } | null;
      visibleFrom?: { __typename: 'Day'; uuid: string; date: string } | null;
      visibleTo?: { __typename: 'Day'; uuid: string; date: string } | null;
      holder: { __typename: 'TeachingUnit'; uuid: string; group: { __typename: 'Group'; uuid: string; name: string } };
    }>;
  };
};

export type CourseWorkMaterialsFormPageDataQueryVariables = Exact<{
  workMaterialUuid: Scalars['ID']['input'];
  courseUuid: Scalars['ID']['input'];
}>;

export type CourseWorkMaterialsFormPageDataQuery = {
  __typename?: 'Query';
  workMaterials: Array<{
    __typename: 'WorkMaterial';
    uuid: string;
    title: string;
    visibleAfterVisibleTo?: boolean | null;
    material: {
      __typename: 'Material';
      uuid: string;
      text?: string | null;
      fileEntries: Array<
        { __typename: 'FileEntry'; uuid: string } & {
          ' $fragmentRefs'?: { FileTableFieldsFragment: FileTableFieldsFragment };
        }
      >;
    };
    visibleFrom?: { __typename: 'Day'; uuid: string; date: string } | null;
    visibleTo?: { __typename: 'Day'; uuid: string; date: string } | null;
    publicFrom?: { __typename: 'Day'; uuid: string; date: string } | null;
  }>;
} & { ' $fragmentRefs'?: { TeachingUnitSelectFieldsFragment: TeachingUnitSelectFieldsFragment } };

export type BpCreateWorkMaterialsInGroupWorkMaterialsFormMutationVariables = Exact<{
  input: Array<WorkMaterialCreateInput> | WorkMaterialCreateInput;
}>;

export type BpCreateWorkMaterialsInGroupWorkMaterialsFormMutation = {
  __typename?: 'Mutation';
  createWorkMaterials: {
    __typename?: 'CreateWorkMaterialsMutationResponse';
    workMaterials: Array<{
      __typename?: 'WorkMaterial';
      uuid: string;
      holder: { __typename?: 'TeachingUnit'; uuid: string; group: { __typename: 'Group'; uuid: string; name: string } };
    }>;
    info: { __typename?: 'CreateInfo'; nodesCreated: number };
  };
};

export type BpUpdateWorkMaterialsinGroupWorkMaterialsFormMutationVariables = Exact<{
  update: WorkMaterialUpdateInput;
  where: WorkMaterialWhere;
}>;

export type BpUpdateWorkMaterialsinGroupWorkMaterialsFormMutation = {
  __typename?: 'Mutation';
  updateWorkMaterials: {
    __typename?: 'UpdateWorkMaterialsMutationResponse';
    workMaterials: Array<{
      __typename: 'WorkMaterial';
      uuid: string;
      title: string;
      visibleAfterVisibleTo?: boolean | null;
      material: {
        __typename: 'Material';
        uuid: string;
        text?: string | null;
        textMediaType: string;
        fileEntries: Array<{ __typename: 'FileEntry'; uuid: string }>;
      };
      publicFrom?: { __typename: 'Day'; uuid: string; date: string } | null;
      visibleFrom?: { __typename: 'Day'; uuid: string; date: string } | null;
      holder: { __typename: 'TeachingUnit'; uuid: string; group: { __typename: 'Group'; uuid: string; name: string } };
    }>;
  };
};

export type GroupWorkMaterialsFormFieldsFragment = ({
  __typename?: 'Query';
  workMaterials: Array<{
    __typename: 'WorkMaterial';
    uuid: string;
    title: string;
    visibleAfterVisibleTo?: boolean | null;
    material: {
      __typename: 'Material';
      uuid: string;
      text?: string | null;
      fileEntries: Array<
        { __typename: 'FileEntry'; uuid: string } & {
          ' $fragmentRefs'?: { FileTableFieldsFragment: FileTableFieldsFragment };
        }
      >;
    };
    visibleFrom?: { __typename: 'Day'; uuid: string; date: string } | null;
    visibleTo?: { __typename: 'Day'; uuid: string; date: string } | null;
    publicFrom?: { __typename: 'Day'; uuid: string; date: string } | null;
  }>;
} & { ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment } }) & {
  ' $fragmentName'?: 'GroupWorkMaterialsFormFieldsFragment';
};

export type WorkMaterialsListFieldsFragment = {
  __typename: 'WorkMaterial';
  uuid: string;
  title: string;
  updated: any;
} & { ' $fragmentName'?: 'WorkMaterialsListFieldsFragment' };

export type CourseWorkMaterialsTableFieldsFragment = {
  __typename: 'WorkMaterial';
  uuid: string;
  title: string;
  visibleAfterVisibleTo?: boolean | null;
  holder: {
    __typename: 'TeachingUnit';
    uuid: string;
    title: string;
    organization: { __typename: 'Organization'; uuid: string };
  };
  owner: { __typename: 'Profile'; uuid: string };
  material: { __typename: 'Material'; uuid: string; fileEntries: Array<{ __typename: 'FileEntry'; uuid: string }> };
} & { ' $fragmentName'?: 'CourseWorkMaterialsTableFieldsFragment' };

export type GroupWorkMaterialsTableFieldsFragment = ({
  __typename?: 'Query';
  workMaterialsTable: Array<{
    __typename: 'WorkMaterial';
    uuid: string;
    title: string;
    created: any;
    updated: any;
    owner: { __typename: 'Profile'; uuid: string; displayName?: string | null };
    material: { __typename: 'Material'; uuid: string; fileEntries: Array<{ __typename: 'FileEntry'; uuid: string }> };
  }>;
} & { ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment } }) & {
  ' $fragmentName'?: 'GroupWorkMaterialsTableFieldsFragment';
};

export type OrganizationConfigFieldsFragment = {
  __typename?: 'Query';
  schoolYears: Array<{ __typename?: 'SchoolYear'; uuid: string; name: string; start: any; end: any }>;
  organizations: Array<{
    __typename: 'Organization';
    uuid: string;
    licensedProducts: Array<
      | {
          __typename: 'BigBlueButton';
          uuid: string;
          maxParticipantsPerMeeting?: number | null;
          allowRecording?: boolean | null;
          apiUrl?: string | null;
          organizationConnection: {
            __typename?: 'BigBlueButtonOrganizationConnection';
            edges: Array<{
              __typename?: 'BigBlueButtonOrganizationRelationship';
              properties: {
                __typename?: 'LicenseProperties';
                notAfter?: any | null;
                notBefore?: any | null;
                version?: string | null;
              };
            }>;
          };
        }
      | {
          __typename: 'Bildungsplattform';
          uuid: string;
          allowStudentDirectMessages?: boolean | null;
          allowParentExcuses?: boolean | null;
          currentSchoolyear?: string | null;
          organizationConnection: {
            __typename?: 'BildungsplattformOrganizationConnection';
            edges: Array<{
              __typename?: 'BildungsplattformOrganizationRelationship';
              properties: {
                __typename?: 'LicenseProperties';
                notAfter?: any | null;
                notBefore?: any | null;
                version?: string | null;
              };
            }>;
          };
        }
      | {
          __typename: 'Nextcloud';
          uuid: string;
          serverUri: string;
          serverAliase?: Array<string> | null;
          organizationConnection: {
            __typename?: 'NextcloudOrganizationConnection';
            edges: Array<{
              __typename?: 'NextcloudOrganizationRelationship';
              properties: {
                __typename?: 'LicenseProperties';
                notAfter?: any | null;
                notBefore?: any | null;
                version?: string | null;
              };
            }>;
          };
        }
      | {
          __typename: 'Threema';
          uuid: string;
          apiToken?: string | null;
          licenseCount?: number | null;
          licenseValidUntil?: any | null;
          organizationConnection: {
            __typename?: 'ThreemaOrganizationConnection';
            edges: Array<{
              __typename?: 'ThreemaOrganizationRelationship';
              properties: {
                __typename?: 'LicenseProperties';
                notAfter?: any | null;
                notBefore?: any | null;
                version?: string | null;
              };
            }>;
          };
        }
      | {
          __typename: 'ThreemaBroadcast';
          uuid: string;
          organizationConnection: {
            __typename?: 'ThreemaBroadcastOrganizationConnection';
            edges: Array<{
              __typename?: 'ThreemaBroadcastOrganizationRelationship';
              properties: {
                __typename?: 'LicenseProperties';
                notAfter?: any | null;
                notBefore?: any | null;
                version?: string | null;
              };
            }>;
          };
        }
      | {
          __typename: 'Zoom';
          uuid: string;
          maxParticipantsPerMeeting?: number | null;
          organizationConnection: {
            __typename?: 'ZoomOrganizationConnection';
            edges: Array<{
              __typename?: 'ZoomOrganizationRelationship';
              properties: {
                __typename?: 'LicenseProperties';
                notAfter?: any | null;
                notBefore?: any | null;
                version?: string | null;
              };
            }>;
          };
        }
    >;
  }>;
} & { ' $fragmentName'?: 'OrganizationConfigFieldsFragment' };

export type NotificationsDataQueryVariables = Exact<{
  submissionWhere: SubmissionWhere;
  groupWhere: GroupWhere;
  calendarEventWhere: CalendarEventWhere;
  organizationUuid: Scalars['ID']['input'];
}>;

export type NotificationsDataQuery = {
  __typename?: 'Query';
  submissions: Array<{
    __typename: 'Submission';
    uuid: string;
    owner: { __typename: 'Profile'; uuid: string };
    assignment: Array<{
      __typename: 'Assignment';
      title: string;
      uuid: string;
      holder: { __typename: 'TeachingUnit'; uuid: string; group: { __typename: 'Group'; uuid: string } };
    }>;
  }>;
  groups: Array<{ __typename: 'Group'; uuid: string; name: string; isCommunity: boolean }>;
  calendarEvents: Array<{
    __typename: 'CalendarEvent';
    uuid: string;
    holderConnection: {
      __typename?: 'CalendarEventHolderConnection';
      edges: Array<{
        __typename?: 'CalendarEventHolderRelationship';
        node:
          | { __typename: 'Group'; uuid: string }
          | { __typename: 'Organization'; uuid: string }
          | { __typename: 'Profile'; uuid: string };
      }>;
    };
  }>;
  collaboratingOrganizations: Array<{ __typename?: 'CollaboratingOrganizations'; uuid: string; name: string }>;
};

export type UseMatrixClientQueryVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
}>;

export type UseMatrixClientQuery = { __typename?: 'Query' } & {
  ' $fragmentRefs'?: {
    GetConversationsFieldsDocumentFragment: GetConversationsFieldsDocumentFragment;
    ResolveRoomNameFieldsFragment: ResolveRoomNameFieldsFragment;
  };
};

export type ResolveRoomNameFieldsFragment = {
  __typename?: 'Query';
  profiles: Array<{
    __typename?: 'Profile';
    uuid: string;
    firstName?: string | null;
    lastName?: string | null;
    organizationRoles: Array<string>;
  }>;
} & { ' $fragmentName'?: 'ResolveRoomNameFieldsFragment' };

export type GetConversationsFieldsDocumentFragment = {
  __typename?: 'Query';
  profiles: Array<{ __typename: 'Profile'; uuid: string; displayNameShort?: string | null }>;
} & { ' $fragmentName'?: 'GetConversationsFieldsDocumentFragment' };

export type UseAvailableServicesForOrganizationFieldsFragment = {
  __typename?: 'Query';
  organizations: Array<{
    __typename: 'Organization';
    uuid: string;
    licensedProducts: Array<
      | {
          __typename: 'BigBlueButton';
          uuid: string;
          allowRecording?: boolean | null;
          maxParticipantsPerMeeting?: number | null;
          organizationConnection: {
            __typename: 'BigBlueButtonOrganizationConnection';
            edges: Array<{
              __typename: 'BigBlueButtonOrganizationRelationship';
              properties: {
                __typename: 'LicenseProperties';
                version?: string | null;
                notAfter?: any | null;
                notBefore?: any | null;
              };
            }>;
          };
        }
      | { __typename: 'Bildungsplattform'; uuid: string }
      | { __typename: 'Nextcloud'; uuid: string }
      | { __typename: 'Threema'; uuid: string }
      | { __typename: 'ThreemaBroadcast'; uuid: string }
      | { __typename: 'Zoom'; uuid: string }
    >;
  }>;
} & { ' $fragmentName'?: 'UseAvailableServicesForOrganizationFieldsFragment' };

export type CalendarEventMapCalendarEventsToBpEventTypeFieldsFragment = ({
  __typename?: 'Query';
  todaysEventData: Array<{
    __typename: 'CalendarEvent';
    uuid: string;
    categories?: Array<string> | null;
    guestsAllowed?: boolean | null;
    maxAttendees?: number | null;
    classbookNoteContentType?: string | null;
    classbookHomework?: string | null;
    classbookHomeworkContentType?: string | null;
    classbookNote?: string | null;
    classShortNames?: Array<string> | null;
    description?: string | null;
    title?: string | null;
    duration: string;
    keywords?: Array<string> | null;
    locale?: string | null;
    status?: string | null;
    start: string;
    virtualLocations: Array<{
      __typename?: 'VirtualLocation';
      uuid: string;
      features?: Array<string> | null;
      token: string;
      running: boolean;
      attendeesConnection: {
        __typename?: 'VirtualLocationAttendeesConnection';
        edges: Array<{
          __typename?: 'VirtualLocationAttendeesRelationship';
          properties: { __typename?: 'VirtualLocationAttendeeProperties'; withVideo?: boolean | null };
        }>;
      };
    }>;
    owner: { __typename?: 'Profile'; uuid: string };
    locations: Array<{ __typename?: 'Location'; uuid: string }>;
    attendeesConnection: {
      __typename: 'CalendarEventAttendeesConnection';
      edges: Array<{
        __typename: 'CalendarEventAttendeesRelationship';
        properties: { __typename?: 'EventAttendeesProperties'; classbookComment?: string | null };
        node: { __typename: 'Profile'; uuid: string; displayName?: string | null };
      }>;
    };
    holderConnection: {
      __typename?: 'CalendarEventHolderConnection';
      edges: Array<{
        __typename?: 'CalendarEventHolderRelationship';
        node:
          | { __typename: 'Group'; uuid: string; displayName?: string | null; type: GroupType }
          | { __typename: 'Organization'; uuid: string; displayName?: string | null }
          | { __typename: 'Profile'; uuid: string; displayName?: string | null };
      }>;
    };
  }>;
} & { ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment } }) & {
  ' $fragmentName'?: 'CalendarEventMapCalendarEventsToBpEventTypeFieldsFragment';
};

export type GroupOrCourseCalendarEventsDataQueryVariables = Exact<{
  calendarEventWhere: CalendarEventWhere;
  profile: Scalars['ID']['input'];
}>;

export type GroupOrCourseCalendarEventsDataQuery = { __typename?: 'Query' } & {
  ' $fragmentRefs'?: {
    CalendarEventMapCalendarEventsToBpEventTypeFieldsFragment: CalendarEventMapCalendarEventsToBpEventTypeFieldsFragment;
    PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment;
  };
};

export type BirthdayEventsDataQueryVariables = Exact<{
  courseUuid: Scalars['ID']['input'];
  groupUuid: Scalars['ID']['input'];
}>;

export type BirthdayEventsDataQuery = {
  __typename?: 'Query';
  birthdayEvents: Array<{
    __typename: 'CalendarEvent';
    uuid: string;
    start: string;
    categories?: Array<string> | null;
    title?: string | null;
    classShortNames?: Array<string> | null;
  }>;
};

export type DaysDataQueryVariables = Exact<{
  date: Scalars['String']['input'];
}>;

export type DaysDataQuery = { __typename?: 'Query'; days: Array<{ __typename: 'Day'; uuid: string; date: string }> };

export type UseGroupMembersCountFieldsFragment = {
  __typename?: 'Query';
  groupMembersCount: Array<{
    __typename: 'Group';
    uuid: string;
    editorsAggregate?: { __typename: 'GroupProfileEditorsAggregationSelection'; count: number } | null;
    viewersAggregate?: { __typename: 'GroupProfileViewersAggregationSelection'; count: number } | null;
    organization: { __typename: 'Organization'; uuid: string };
  }>;
} & { ' $fragmentName'?: 'UseGroupMembersCountFieldsFragment' };

export type PermissionCheckerFieldsFragment = {
  __typename?: 'Query';
  profilePermissions: Array<{
    __typename: 'Profile';
    uuid: string;
    nextcloudConnection: {
      __typename?: 'ProfileNextcloudConnection';
      edges: Array<{
        __typename?: 'ProfileNextcloudRelationship';
        properties: { __typename?: 'NextcloudUserProps'; enabled?: boolean | null };
      }>;
    };
  }>;
  groupPermission: Array<{
    __typename?: 'Group';
    uuid: string;
    admins: Array<{ __typename?: 'Profile'; uuid: string }>;
    editors: Array<{ __typename?: 'Profile'; uuid: string }>;
    viewers: Array<{ __typename?: 'Profile'; uuid: string }>;
  }>;
} & { ' $fragmentName'?: 'PermissionCheckerFieldsFragment' };

export type AdminPagePageDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
}>;

export type AdminPagePageDataQuery = { __typename?: 'Query' } & {
  ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment };
};

export type InstitutionAdminSubpagePageDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
}>;

export type InstitutionAdminSubpagePageDataQuery = { __typename?: 'Query' } & {
  ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment };
};

export type OrganizationsSubpagePageDataQueryVariables = Exact<{ [key: string]: never }>;

export type OrganizationsSubpagePageDataQuery = {
  __typename?: 'Query';
  pimOrganizations: Array<{ __typename: 'PimOrganization'; uuid: string; name: string; bpEnabled?: boolean | null }>;
};

export type ClassbookPagePageDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
}>;

export type ClassbookPagePageDataQuery = { __typename?: 'Query' } & {
  ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment };
};

export type BpDeleteAbsenceMutationVariables = Exact<{
  where: AbsenceWhere;
}>;

export type BpDeleteAbsenceMutation = {
  __typename?: 'Mutation';
  deleteAbsences: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type ClassbookAbsencesSubpagePageDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
  ownerUuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type ClassbookAbsencesSubpagePageDataQuery = { __typename?: 'Query' } & {
  ' $fragmentRefs'?: {
    PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment;
    ClassbookAbsencesTableFieldsFragment: ClassbookAbsencesTableFieldsFragment;
  };
};

export type BpDeleteAbsenceFromClassbookAdminMutationVariables = Exact<{
  where: AbsenceWhere;
}>;

export type BpDeleteAbsenceFromClassbookAdminMutation = {
  __typename?: 'Mutation';
  deleteAbsences: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type ClassbookAdministrationSubpagePageDataQueryVariables = Exact<{
  profilesWhere: ProfileWhere;
  classesWhere: ClassWhere;
  profile: Scalars['ID']['input'];
}>;

export type ClassbookAdministrationSubpagePageDataQuery = { __typename?: 'Query' } & {
  ' $fragmentRefs'?: {
    PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment;
    ClassbookAdministrationTableFieldsFragment: ClassbookAdministrationTableFieldsFragment;
  };
};

export type ClassbookClassesSubpagePageDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
}>;

export type ClassbookClassesSubpagePageDataQuery = { __typename?: 'Query' } & {
  ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment };
};

export type ClassbookCoursesSubpagePageDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
}>;

export type ClassbookCoursesSubpagePageDataQuery = { __typename?: 'Query' } & {
  ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment };
};

export type CoursePagePageDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
  courseUuid: Scalars['ID']['input'];
}>;

export type CoursePagePageDataQuery = {
  __typename?: 'Query';
  groups: Array<{
    __typename: 'Group';
    uuid: string;
    name: string;
    nextcloudConnection: {
      __typename: 'GroupNextcloudConnection';
      edges: Array<{
        __typename: 'GroupNextcloudRelationship';
        properties: { __typename: 'NextcloudGroupProps'; enabled?: boolean | null };
      }>;
    };
    organization: { __typename: 'Organization'; uuid: string };
  }>;
} & { ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment } };

export type BpDeleteGroupCoursesPageMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type BpDeleteGroupCoursesPageMutation = {
  __typename?: 'Mutation';
  deleteBpGroup: { __typename?: 'EntitiesDeleteInfo'; entitiesDeleted: number };
};

export type CoursesPagePageDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
  organizationUuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type CoursesPagePageDataQuery = { __typename?: 'Query' } & {
  ' $fragmentRefs'?: {
    PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment;
    UseConvertToCourseTableTypeFieldsFragment: UseConvertToCourseTableTypeFieldsFragment;
  };
};

export type CourseAdminSubpagePageDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
}>;

export type CourseAdminSubpagePageDataQuery = { __typename?: 'Query' } & {
  ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment };
};

export type CourseAppointmentsSubpagePageDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
  courseUuid: Scalars['ID']['input'];
}>;

export type CourseAppointmentsSubpagePageDataQuery = {
  __typename?: 'Query';
  coursesOrganization: Array<{
    __typename: 'Group';
    uuid: string;
    organization: { __typename: 'Organization'; uuid: string };
  }>;
} & {
  ' $fragmentRefs'?: {
    PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment;
    EventsListFieldsFragment: EventsListFieldsFragment;
  };
};

export type CourseAssignmentSubpagePageDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
}>;

export type CourseAssignmentSubpagePageDataQuery = { __typename?: 'Query' } & {
  ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment };
};

export type CourseAssignmentsSubpagePageDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
}>;

export type CourseAssignmentsSubpagePageDataQuery = { __typename?: 'Query' } & {
  ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment };
};

export type CourseLessonsSubpagePageDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
  courseUuid: Scalars['ID']['input'];
}>;

export type CourseLessonsSubpagePageDataQuery = {
  __typename?: 'Query';
  teachingUnits: Array<{
    __typename: 'TeachingUnit';
    uuid: string;
    organization: { __typename: 'Organization'; uuid: string };
  }>;
  teachingTopics: Array<{
    __typename: 'TeachingTopic';
    uuid: string;
    topicParentConnection: {
      __typename: 'TeachingTopicTopicParentConnection';
      edges: Array<{ __typename: 'TeachingTopicTopicParentRelationship' }>;
    };
  }>;
} & { ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment } };

export type CourseOverviewSubpagePageDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
}>;

export type CourseOverviewSubpagePageDataQuery = { __typename?: 'Query' } & {
  ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment };
};

export type BpUpdateGroupsInCoursePersonsSubpageMutationVariables = Exact<{
  update: BpGroupUpdateInput;
  uuid: Scalars['ID']['input'];
}>;

export type BpUpdateGroupsInCoursePersonsSubpageMutation = {
  __typename?: 'Mutation';
  updateBpGroup: {
    __typename: 'Group';
    uuid: string;
    editors: Array<{ __typename: 'Profile'; uuid: string }>;
    viewers: Array<{ __typename: 'Profile'; uuid: string }>;
    admins: Array<{ __typename: 'Profile'; uuid: string }>;
  };
};

export type CoursePersonsSubpagePageDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
  courseUuid: Scalars['ID']['input'];
  organizationUuid: Scalars['ID']['input'];
}>;

export type CoursePersonsSubpagePageDataQuery = {
  __typename?: 'Query';
  groups: Array<{
    __typename: 'Group';
    uuid: string;
    admins: Array<{ __typename: 'Profile'; uuid: string }>;
    editors: Array<{
      __typename: 'Profile';
      uuid: string;
      displayName?: string | null;
      organizationRoles: Array<string>;
      userStatus: UserStatus;
      organization: { __typename: 'Organization'; uuid: string };
    }>;
    viewers: Array<{
      __typename: 'Profile';
      uuid: string;
      displayName?: string | null;
      organizationRoles: Array<string>;
      userStatus: UserStatus;
      organization: { __typename: 'Organization'; uuid: string };
    }>;
  }>;
  collaboratingOrganizations: Array<{ __typename: 'CollaboratingOrganizations'; uuid: string; name: string }>;
} & { ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment } };

export type BpDeleteWorkMaterialsFromCourseWorkMaterialsMutationVariables = Exact<{
  where: WorkMaterialWhere;
}>;

export type BpDeleteWorkMaterialsFromCourseWorkMaterialsMutation = {
  __typename?: 'Mutation';
  deleteWorkMaterials: { __typename?: 'DeleteInfo'; nodesDeleted: number; relationshipsDeleted: number };
};

export type CourseWorkMaterialsSubpagePageDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
  courseUuid: Scalars['ID']['input'];
  workMaterialUuid: Scalars['ID']['input'];
}>;

export type CourseWorkMaterialsSubpagePageDataQuery = {
  __typename?: 'Query';
  groups: Array<{
    __typename: 'Group';
    uuid: string;
    name: string;
    teachingUnits: Array<{
      __typename: 'TeachingUnit';
      uuid: string;
      workMaterials: Array<
        {
          __typename: 'WorkMaterial';
          uuid: string;
          title: string;
          visibleAfterVisibleTo?: boolean | null;
          visibleFrom?: { __typename: 'Day'; uuid: string; date: string } | null;
          visibleTo?: { __typename: 'Day'; uuid: string; date: string } | null;
          publicFrom?: { __typename: 'Day'; uuid: string; date: string } | null;
        } & { ' $fragmentRefs'?: { CourseWorkMaterialsTableFieldsFragment: CourseWorkMaterialsTableFieldsFragment } }
      >;
    }>;
  }>;
} & {
  ' $fragmentRefs'?: {
    PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment;
    WorkMaterialDetailFieldsFragment: WorkMaterialDetailFieldsFragment;
  };
};

export type BpUpdateSubmissionsInStudentContentMutationVariables = Exact<{
  where: SubmissionWhere;
  update: SubmissionUpdateInput;
}>;

export type BpUpdateSubmissionsInStudentContentMutation = {
  __typename?: 'Mutation';
  updateSubmissions: {
    __typename?: 'UpdateSubmissionsMutationResponse';
    submissions: Array<{ __typename: 'Submission'; uuid: string; status: SubmissionStatus }>;
  };
};

export type CourseAssignmentStudentContentPageQueryVariables = Exact<{
  assignmentUuid: Scalars['ID']['input'];
  profile: Scalars['ID']['input'];
}>;

export type CourseAssignmentStudentContentPageQuery = {
  __typename?: 'Query';
  submissions: Array<{
    __typename: 'Submission';
    uuid: string;
    status: SubmissionStatus;
    owner: { __typename: 'Profile'; uuid: string };
    material: {
      __typename: 'Material';
      uuid: string;
      text?: string | null;
      fileEntries: Array<{
        __typename: 'FileEntry';
        uuid: string;
        mediaType: string;
        size: number;
        publicDownloadToken?: string | null;
        downloadToken: string;
        filename: string;
      }>;
    };
    assignment: Array<{
      __typename: 'Assignment';
      uuid: string;
      title: string;
      allowSubmissionAfterDueDate?: boolean | null;
      dueDate?: { __typename: 'Day'; uuid: string; date: string } | null;
      visibleFrom?: { __typename: 'Day'; uuid: string; date: string } | null;
      material: {
        __typename: 'Material';
        uuid: string;
        text?: string | null;
        fileEntries: Array<{
          __typename: 'FileEntry';
          uuid: string;
          mediaType: string;
          size: number;
          publicDownloadToken?: string | null;
          downloadToken: string;
          filename: string;
        }>;
      };
      holder: {
        __typename: 'TeachingUnit';
        uuid: string;
        group: { __typename: 'Group'; uuid: string; organization: { __typename: 'Organization'; uuid: string } };
      };
    }>;
  }>;
} & {
  ' $fragmentRefs'?: {
    PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment;
    AnswersCardFieldsFragment: AnswersCardFieldsFragment;
  };
};

export type CourseAssignmentsStudentContentFragmentQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
  courseUuid: Scalars['ID']['input'];
}>;

export type CourseAssignmentsStudentContentFragmentQuery = {
  __typename?: 'Query';
  assignments: Array<
    {
      __typename: 'Assignment';
      uuid: string;
      dueDate?: { __typename: 'Day'; uuid: string; date: string } | null;
      visibleFrom?: { __typename: 'Day'; uuid: string; date: string } | null;
      submissions: Array<{ __typename: 'Submission'; uuid: string }>;
    } & {
      ' $fragmentRefs'?: {
        AssignmentPreviewStudentFieldsFragment: AssignmentPreviewStudentFieldsFragment;
        AssignmentsTableStudentFieldsFragment: AssignmentsTableStudentFieldsFragment;
      };
    }
  >;
};

export type CourseOverviewStudentContentDataQueryVariables = Exact<{
  groupWhere: GroupWhere;
  groupOptions?: InputMaybe<GroupOptions>;
  workMaterialsOptions?: InputMaybe<WorkMaterialOptions>;
  currentCourseWhere: GroupWhere;
  currentCourseOptions?: InputMaybe<GroupOptions>;
  profile: Scalars['ID']['input'];
  calendarEventWhere: CalendarEventWhere;
}>;

export type CourseOverviewStudentContentDataQuery = {
  __typename?: 'Query';
  groups: Array<{
    __typename: 'Group';
    uuid: string;
    teachingUnits: Array<{
      __typename: 'TeachingUnit';
      uuid: string;
      title: string;
      workMaterials: Array<
        {
          __typename: 'WorkMaterial';
          uuid: string;
          title: string;
          updated: any;
          visibleFrom?: { __typename: 'Day'; uuid: string; date: string } | null;
          visibleTo?: { __typename: 'Day'; uuid: string; date: string } | null;
        } & { ' $fragmentRefs'?: { WorkMaterialsListFieldsFragment: WorkMaterialsListFieldsFragment } }
      >;
    }>;
  }>;
  currentCourse: Array<{
    __typename: 'Group';
    uuid: string;
    organization: { __typename: 'Organization'; uuid: string };
    subject?: {
      __typename: 'Subject';
      uuid: string;
      organization: { __typename: 'Organization'; uuid: string };
    } | null;
  }>;
} & {
  ' $fragmentRefs'?: {
    OpenAssignmentQueryFieldsFragment: OpenAssignmentQueryFieldsFragment;
    PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment;
  };
};

export type BpDeleteAssignmentsFromCourseAssignmentTeacherMutationVariables = Exact<{
  where: AssignmentWhere;
}>;

export type BpDeleteAssignmentsFromCourseAssignmentTeacherMutation = {
  __typename?: 'Mutation';
  deleteAssignments: { __typename?: 'DeleteInfo'; nodesDeleted: number; relationshipsDeleted: number };
};

export type CourseAssignmentTeacherContentPageDataQueryVariables = Exact<{
  assignmentUuid: Scalars['ID']['input'];
  courseUuid: Scalars['ID']['input'];
}>;

export type CourseAssignmentTeacherContentPageDataQuery = {
  __typename?: 'Query';
  assignments: Array<
    {
      __typename: 'Assignment';
      uuid: string;
      title: string;
      visibleFrom?: { __typename: 'Day'; uuid: string; date: string } | null;
      dueDate?: { __typename: 'Day'; uuid: string; date: string } | null;
      holder: {
        __typename: 'TeachingUnit';
        uuid: string;
        title: string;
        owner: { __typename: 'Profile'; uuid: string };
        group: { __typename: 'Group'; uuid: string };
        organization: { __typename: 'Organization'; uuid: string };
      };
    } & { ' $fragmentRefs'?: { AssignmentTabFieldsFragment: AssignmentTabFieldsFragment } }
  >;
  submissions: Array<
    { __typename: 'Submission'; uuid: string; status: SubmissionStatus } & {
      ' $fragmentRefs'?: { SubmissionsTabSubmissionFieldsFragment: SubmissionsTabSubmissionFieldsFragment };
    }
  >;
  groupAsCourse: Array<{
    __typename: 'Group';
    uuid: string;
    viewers: Array<
      { __typename: 'Profile'; uuid: string } & {
        ' $fragmentRefs'?: { SubmissionsTabProfileFieldsFragment: SubmissionsTabProfileFieldsFragment };
      }
    >;
  }>;
};

export type CourseAssignmentsTeacherContentFragmentQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
  courseUuid: Scalars['ID']['input'];
}>;

export type CourseAssignmentsTeacherContentFragmentQuery = {
  __typename?: 'Query';
  assignments: Array<
    {
      __typename: 'Assignment';
      uuid: string;
      dueDate?: { __typename: 'Day'; uuid: string; date: string } | null;
      visibleFrom?: { __typename: 'Day'; uuid: string; date: string } | null;
      holder: { __typename: 'TeachingUnit'; uuid: string };
    } & {
      ' $fragmentRefs'?: {
        AssignmentPreviewTeacherFieldsFragment: AssignmentPreviewTeacherFieldsFragment;
        AssignmentsTableTeacherFieldsFragment: AssignmentsTableTeacherFieldsFragment;
      };
    }
  >;
} & { ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment } };

export type CourseOverviewTeacherContentPageDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
  courseUuid: Scalars['ID']['input'];
  groupUuid: Scalars['ID']['input'];
  organizationUuid: Scalars['ID']['input'];
  formattedDate: Scalars['String']['input'];
}>;

export type CourseOverviewTeacherContentPageDataQuery = {
  __typename?: 'Query';
  groups: Array<{
    __typename: 'Group';
    uuid: string;
    name: string;
    organization: { __typename: 'Organization'; uuid: string };
    viewers: Array<{ __typename: 'Profile'; uuid: string; userStatus: UserStatus }>;
    teachingUnits: Array<{
      __typename: 'TeachingUnit';
      uuid: string;
      assignments: Array<{
        __typename: 'Assignment';
        uuid: string;
        title: string;
        dueDate?: { __typename: 'Day'; uuid: string; date: string } | null;
        visibleFrom?: { __typename: 'Day'; uuid: string; date: string } | null;
        submissions: Array<{ __typename: 'Submission'; uuid: string; status: SubmissionStatus }>;
      }>;
    }>;
  }>;
} & {
  ' $fragmentRefs'?: {
    PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment;
    UseAvailableServicesForOrganizationFieldsFragment: UseAvailableServicesForOrganizationFieldsFragment;
    MeetingsLinksFieldsFragment: MeetingsLinksFieldsFragment;
  };
};

export type UseConvertToCourseTableTypeFieldsFragment = {
  __typename?: 'Query';
  groups: Array<{
    __typename: 'Group';
    uuid: string;
    name: string;
    managedBy: string;
    isCommunity: boolean;
    organization: { __typename?: 'Organization'; uuid: string };
    nextcloudConnection: {
      __typename: 'GroupNextcloudConnection';
      edges: Array<{
        __typename: 'GroupNextcloudRelationship';
        properties: { __typename?: 'NextcloudGroupProps'; enabled?: boolean | null; lastSync?: any | null };
      }>;
    };
    externalServices?: {
      __typename?: 'ExternalServices';
      threema?: { __typename: 'ExternalServicesStatus'; enabled: boolean; lastSync?: any | null } | null;
    } | null;
    events: Array<{
      __typename: 'CalendarEvent';
      uuid: string;
      virtualLocations: Array<{ __typename: 'VirtualLocation'; uuid: string; running: boolean }>;
    }>;
    admins: Array<{ __typename: 'Profile'; uuid: string; displayNameShort?: string | null }>;
    teachingUnitsConnection: {
      __typename: 'GroupTeachingUnitsConnection';
      edges: Array<{
        __typename: 'GroupTeachingUnitsRelationship';
        node: {
          __typename: 'TeachingUnit';
          uuid: string;
          assignments: Array<{
            __typename: 'Assignment';
            uuid: string;
            submissions: Array<{ __typename: 'Submission'; uuid: string }>;
          }>;
        };
      }>;
    };
  }>;
} & { ' $fragmentName'?: 'UseConvertToCourseTableTypeFieldsFragment' };

export type GroupPagePageDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
  groupUuid: Scalars['ID']['input'];
}>;

export type GroupPagePageDataQuery = {
  __typename?: 'Query';
  groups: Array<{
    __typename: 'Group';
    uuid: string;
    name: string;
    nextcloudConnection: {
      __typename: 'GroupNextcloudConnection';
      edges: Array<{
        __typename: 'GroupNextcloudRelationship';
        properties: { __typename?: 'NextcloudGroupProps'; enabled?: boolean | null; lastSync?: any | null };
      }>;
    };
    organization: { __typename: 'Organization'; uuid: string };
  }>;
} & { ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment } };

export type BpDeleteGroupFromGroupsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type BpDeleteGroupFromGroupsMutation = {
  __typename?: 'Mutation';
  deleteBpGroup: { __typename?: 'EntitiesDeleteInfo'; entitiesDeleted: number };
};

export type GroupsPagePageDataQueryVariables = Exact<{
  groupWhere: GroupWhere;
  calendarEventWhere: CalendarEventWhere;
  profile: Scalars['ID']['input'];
}>;

export type GroupsPagePageDataQuery = {
  __typename?: 'Query';
  groups: Array<{
    __typename: 'Group';
    uuid: string;
    name: string;
    managedBy: string;
    isCommunity: boolean;
    organization: { __typename: 'Organization'; uuid: string; displayName?: string | null };
    admins: Array<{ __typename: 'Profile'; uuid: string; displayNameShort?: string | null }>;
    schoolYear?: { __typename: 'SchoolYear'; uuid: string; name: string } | null;
    editors: Array<{ __typename: 'Profile'; uuid: string }>;
    viewers: Array<{ __typename: 'Profile'; uuid: string }>;
    externalServices?: {
      __typename: 'ExternalServices';
      threema?: { __typename: 'ExternalServicesStatus'; enabled: boolean; lastSync?: any | null } | null;
      zoom?: { __typename: 'ExternalServicesStatus'; enabled: boolean; lastSync?: any | null } | null;
    } | null;
    nextcloudConnection: {
      __typename: 'GroupNextcloudConnection';
      edges: Array<{
        __typename: 'GroupNextcloudRelationship';
        properties: { __typename?: 'NextcloudGroupProps'; enabled?: boolean | null; lastSync?: any | null };
      }>;
    };
  }>;
  onlineEvents: Array<{
    __typename: 'CalendarEvent';
    uuid: string;
    virtualLocations: Array<{ __typename: 'VirtualLocation'; uuid: string; running: boolean }>;
    holderConnection: {
      __typename?: 'CalendarEventHolderConnection';
      edges: Array<{
        __typename?: 'CalendarEventHolderRelationship';
        node:
          | { __typename: 'Group'; uuid: string }
          | { __typename: 'Organization'; uuid: string }
          | { __typename: 'Profile'; uuid: string };
      }>;
    };
  }>;
} & {
  ' $fragmentRefs'?: {
    GroupsTableFieldsFragment: GroupsTableFieldsFragment;
    PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment;
  };
};

export type GroupAppointmentsSubpagePageDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
  groupUuid: Scalars['ID']['input'];
}>;

export type GroupAppointmentsSubpagePageDataQuery = { __typename?: 'Query' } & {
  ' $fragmentRefs'?: {
    PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment;
    UseGroupMembersCountFieldsFragment: UseGroupMembersCountFieldsFragment;
    EventsListFieldsFragment: EventsListFieldsFragment;
  };
};

export type GroupOverviewSubpagePageDataQueryVariables = Exact<{
  groupUuid: Scalars['ID']['input'];
  profile: Scalars['ID']['input'];
  organizationUuid: Scalars['ID']['input'];
  formattedDate: Scalars['String']['input'];
}>;

export type GroupOverviewSubpagePageDataQuery = {
  __typename?: 'Query';
  groups: Array<{
    __typename: 'Group';
    uuid: string;
    name: string;
    organization: { __typename: 'Organization'; uuid: string };
    teachingUnits: Array<{
      __typename: 'TeachingUnit';
      uuid: string;
      workMaterials: Array<
        { __typename: 'WorkMaterial'; uuid: string } & {
          ' $fragmentRefs'?: { WorkMaterialsListFieldsFragment: WorkMaterialsListFieldsFragment };
        }
      >;
    }>;
    viewers: Array<{ __typename: 'Profile'; uuid: string; userStatus: UserStatus }>;
  }>;
  calendarEvents: Array<{
    __typename: 'CalendarEvent';
    uuid: string;
    color?: string | null;
    start: string;
    virtualLocations: Array<{ __typename: 'VirtualLocation'; uuid: string }>;
  }>;
  birthdayEvents: Array<{
    __typename: 'CalendarEvent';
    uuid: string;
    color?: string | null;
    start: string;
    virtualLocations: Array<{ __typename: 'VirtualLocation'; uuid: string }>;
  }>;
} & {
  ' $fragmentRefs'?: {
    PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment;
    MeetingsLinksFieldsFragment: MeetingsLinksFieldsFragment;
  };
};

export type BpUpdateGroupsMutationVariables = Exact<{
  update: BpGroupUpdateInput;
  uuid: Scalars['ID']['input'];
}>;

export type BpUpdateGroupsMutation = {
  __typename?: 'Mutation';
  updateBpGroup: {
    __typename: 'Group';
    uuid: string;
    admins: Array<{ __typename: 'Profile'; uuid: string }>;
    viewers: Array<{ __typename: 'Profile'; uuid: string }>;
    editors: Array<{ __typename: 'Profile'; uuid: string }>;
  };
};

export type GroupPersonsSubpagePageDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
  groupUuid: Scalars['ID']['input'];
  organizationUuid: Scalars['ID']['input'];
}>;

export type GroupPersonsSubpagePageDataQuery = {
  __typename?: 'Query';
  groups: Array<{
    __typename: 'Group';
    uuid: string;
    displayName?: string | null;
    admins: Array<{
      __typename: 'Profile';
      uuid: string;
      displayName?: string | null;
      organization: { __typename: 'Organization'; uuid: string };
    }>;
    editors: Array<{
      __typename: 'Profile';
      uuid: string;
      displayName?: string | null;
      organizationRoles: Array<string>;
      userStatus: UserStatus;
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      organization: { __typename: 'Organization'; uuid: string };
    }>;
    viewers: Array<{
      __typename: 'Profile';
      uuid: string;
      displayName?: string | null;
      organizationRoles: Array<string>;
      userStatus: UserStatus;
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      organization: { __typename: 'Organization'; uuid: string };
    }>;
  }>;
  collaboratingOrganizations: Array<{ __typename: 'CollaboratingOrganizations'; uuid: string; name: string }>;
} & { ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment } };

export type BpDeleteWorkMaterialsFromGroupWorkMaterialsMutationVariables = Exact<{
  where: WorkMaterialWhere;
}>;

export type BpDeleteWorkMaterialsFromGroupWorkMaterialsMutation = {
  __typename?: 'Mutation';
  deleteWorkMaterials: { __typename?: 'DeleteInfo'; nodesDeleted: number; relationshipsDeleted: number };
};

export type GroupWorkMaterialsSubpagePageDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
  groupUuid: Scalars['ID']['input'];
  workMaterialUuid: Scalars['ID']['input'];
}>;

export type GroupWorkMaterialsSubpagePageDataQuery = {
  __typename?: 'Query';
  groups: Array<{
    __typename: 'Group';
    uuid: string;
    name: string;
    teachingUnits: Array<{ __typename: 'TeachingUnit'; uuid: string }>;
  }>;
} & {
  ' $fragmentRefs'?: {
    PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment;
    MaterialDetailFieldsFragment: MaterialDetailFieldsFragment;
    GroupWorkMaterialsFormFieldsFragment: GroupWorkMaterialsFormFieldsFragment;
    GroupWorkMaterialsTableFieldsFragment: GroupWorkMaterialsTableFieldsFragment;
  };
};

export type HomePageDataQueryVariables = Exact<{
  submissionsWhere: SubmissionWhere;
  organizations: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  profile: Scalars['ID']['input'];
  calendarEventWhere: CalendarEventWhere;
}>;

export type HomePageDataQuery = { __typename?: 'Query' } & {
  ' $fragmentRefs'?: {
    OpenAssignmentQueryFieldsFragment: OpenAssignmentQueryFieldsFragment;
    PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment;
    PreviewDataQueryFieldsFragment: PreviewDataQueryFieldsFragment;
    DashboardEventsQueryFieldsFragment: DashboardEventsQueryFieldsFragment;
    DashboardEventsFieldsFragment: DashboardEventsFieldsFragment;
    LinkListFieldsFragment: LinkListFieldsFragment;
  };
};

export type InstitutionPageDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
}>;

export type InstitutionPageDataQuery = { __typename?: 'Query' } & {
  ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment };
};

export type BpDeleteGroupFromInstitutionCoursesMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type BpDeleteGroupFromInstitutionCoursesMutation = {
  __typename?: 'Mutation';
  deleteBpGroup: { __typename?: 'EntitiesDeleteInfo'; entitiesDeleted: number };
};

export type InstitutionCoursesSubpageDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
  organizationUuid: Scalars['ID']['input'];
}>;

export type InstitutionCoursesSubpageDataQuery = {
  __typename?: 'Query';
  groups: Array<{
    __typename: 'Group';
    uuid: string;
    name: string;
    description?: string | null;
    grades?: Array<string> | null;
    managedBy: string;
    isCommunity: boolean;
    viewers: Array<{ __typename: 'Profile'; uuid: string; selectName?: string | null }>;
    editors: Array<{ __typename: 'Profile'; uuid: string; selectName?: string | null }>;
    groups: Array<{ __typename: 'Group'; uuid: string }>;
    admins: Array<{
      __typename: 'Profile';
      uuid: string;
      displayNameShort?: string | null;
      displayName?: string | null;
      organization: { __typename: 'Organization'; uuid: string };
    }>;
    subject?: { __typename: 'Subject'; uuid: string; name: string } | null;
    organization: { __typename?: 'Organization'; uuid: string; displayName?: string | null };
    nextcloudConnection: {
      __typename: 'GroupNextcloudConnection';
      edges: Array<{
        __typename: 'GroupNextcloudRelationship';
        properties: { __typename?: 'NextcloudGroupProps'; enabled?: boolean | null; lastSync?: any | null };
      }>;
    };
    externalServices?: {
      __typename?: 'ExternalServices';
      bbb?: boolean | null;
      matrix?: boolean | null;
      mailbox?: { __typename?: 'ExternalServicesStatus'; enabled: boolean; lastSync?: any | null } | null;
      threema?: { __typename?: 'ExternalServicesStatus'; enabled: boolean; lastSync?: any | null } | null;
      zoom?: { __typename?: 'ExternalServicesStatus'; enabled: boolean; lastSync?: any | null } | null;
    } | null;
    schoolYear?: {
      __typename?: 'SchoolYear';
      start: any;
      end: any;
      name: string;
      uuid: string;
      organization: { __typename?: 'Organization'; uuid: string };
    } | null;
  }>;
} & { ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment } };

export type BpDeleteGroupFromInstitutionGroupsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type BpDeleteGroupFromInstitutionGroupsMutation = {
  __typename?: 'Mutation';
  deleteBpGroup: { __typename?: 'EntitiesDeleteInfo'; entitiesDeleted: number };
};

export type InstitutionGroupsSubpageDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
  organizationUuid: Scalars['ID']['input'];
  groupType: GroupType;
}>;

export type InstitutionGroupsSubpageDataQuery = {
  __typename?: 'Query';
  groups: Array<{
    __typename: 'Group';
    uuid: string;
    name: string;
    description?: string | null;
    grades?: Array<string> | null;
    managedBy: string;
    isCommunity: boolean;
    inCurrentSchoolyear: boolean;
    nextcloudConnection: {
      __typename: 'GroupNextcloudConnection';
      edges: Array<{
        __typename: 'GroupNextcloudRelationship';
        properties: { __typename?: 'NextcloudGroupProps'; enabled?: boolean | null; lastSync?: any | null };
      }>;
    };
    externalServices?: {
      __typename: 'ExternalServices';
      bbb?: boolean | null;
      matrix?: boolean | null;
      mailbox?: { __typename: 'ExternalServicesStatus'; enabled: boolean; lastSync?: any | null } | null;
      threema?: { __typename: 'ExternalServicesStatus'; enabled: boolean; lastSync?: any | null } | null;
      zoom?: { __typename: 'ExternalServicesStatus'; enabled: boolean; lastSync?: any | null } | null;
    } | null;
    groups: Array<{ __typename: 'Group'; uuid: string }>;
    viewers: Array<{ __typename: 'Profile'; uuid: string; selectName?: string | null }>;
    editors: Array<{ __typename: 'Profile'; uuid: string; selectName?: string | null }>;
    admins: Array<{ __typename: 'Profile'; uuid: string; displayNameShort?: string | null }>;
    organization: { __typename: 'Organization'; uuid: string; displayName?: string | null };
    schoolYear?: {
      __typename: 'SchoolYear';
      uuid: string;
      start: any;
      end: any;
      name: string;
      organization: { __typename: 'Organization'; uuid: string };
    } | null;
  }>;
} & {
  ' $fragmentRefs'?: {
    PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment;
    GroupsTableFieldsFragment: GroupsTableFieldsFragment;
  };
};

export type UpdateOrganizationMutationVariables = Exact<{
  update: OrganizationUpdateInput;
  where: OrganizationWhere;
}>;

export type UpdateOrganizationMutation = {
  __typename?: 'Mutation';
  updateOrganizations: {
    __typename?: 'UpdateOrganizationsMutationResponse';
    organizations: Array<{
      __typename: 'Organization';
      uuid: string;
      displayName?: string | null;
      aboutInfo?: string | null;
      aboutInfoLastUpdated?: any | null;
    }>;
  };
};

export type InstitutionOverviewSubpageDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
  organizationUuid: Scalars['ID']['input'];
}>;

export type InstitutionOverviewSubpageDataQuery = {
  __typename?: 'Query';
  organizations: Array<{
    __typename: 'Organization';
    uuid: string;
    aboutInfo?: string | null;
    aboutInfoLastUpdated?: any | null;
  }>;
} & { ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment } };

export type BpDeleteProfileMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;

export type BpDeleteProfileMutation = {
  __typename?: 'Mutation';
  deleteBpProfile: { __typename?: 'EntitiesDeleteInfo'; entitiesDeleted: number };
};

export type BpUpdateProfileMutationVariables = Exact<{
  where: ProfileWhere;
  update: ProfileUpdateInput;
}>;

export type BpUpdateProfileMutation = {
  __typename?: 'Mutation';
  updateProfiles: {
    __typename?: 'UpdateProfilesMutationResponse';
    profiles: Array<{
      __typename: 'Profile';
      uuid: string;
      threema: Array<{ __typename: 'Threema'; uuid: string }>;
      nextcloudConnection: {
        __typename: 'ProfileNextcloudConnection';
        edges: Array<{
          __typename: 'ProfileNextcloudRelationship';
          properties: { __typename: 'NextcloudUserProps'; enabled?: boolean | null };
        }>;
      };
    }>;
  };
};

export type InstitutionPersonsSubpageDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
  organizationUuid: Scalars['ID']['input'];
}>;

export type InstitutionPersonsSubpageDataQuery = {
  __typename?: 'Query';
  profiles: Array<{
    __typename: 'Profile';
    uuid: string;
    userStatus: UserStatus;
    organizationRoles: Array<string>;
    email?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    listName?: string | null;
    displayName?: string | null;
    classes: Array<{ __typename: 'Class'; uuid: string; shortName: string }>;
    nextcloudConnection: {
      __typename: 'ProfileNextcloudConnection';
      edges: Array<{
        __typename: 'ProfileNextcloudRelationship';
        properties: { __typename: 'NextcloudUserProps'; enabled?: boolean | null };
      }>;
    };
    incomingRolesConnection: {
      __typename?: 'ProfileIncomingRolesConnection';
      edges: Array<{
        __typename?: 'ProfileIncomingRolesRelationship';
        properties: { __typename?: 'RoleNames'; roleNames: Array<string> };
        node: { __typename?: 'Profile'; uuid: string };
      }>;
    };
  }>;
} & { ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment } };

export type DeleteBpSchoolyearMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;

export type DeleteBpSchoolyearMutation = {
  __typename?: 'Mutation';
  deleteBpSchoolyear: { __typename?: 'EntitiesDeleteInfo'; entitiesDeleted: number };
};

export type InstitutionSchoolyearsSubpageDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
  organizationUuid: Scalars['ID']['input'];
}>;

export type InstitutionSchoolyearsSubpageDataQuery = {
  __typename?: 'Query';
  schoolYears: Array<{
    __typename: 'SchoolYear';
    uuid: string;
    name: string;
    shortName: string;
    start: any;
    end: any;
    createdAt?: any | null;
    managedBy: string;
  }>;
} & { ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment } };

export type DeleteBpSubjectMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;

export type DeleteBpSubjectMutation = {
  __typename?: 'Mutation';
  deleteBpSubject: { __typename?: 'EntitiesDeleteInfo'; entitiesDeleted: number };
};

export type InstitutionSubjectsSubpageDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
  where: SubjectWhere;
}>;

export type InstitutionSubjectsSubpageDataQuery = {
  __typename?: 'Query';
  subjects: Array<{
    __typename: 'Subject';
    uuid: string;
    name: string;
    managedBy: string;
    globalSubject?: string | null;
  }>;
} & { ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment } };

export type MeetingsPagePageDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
}>;

export type MeetingsPagePageDataQuery = { __typename?: 'Query' } & {
  ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment };
};

export type RunningBbbMeetingsSubpagePageDataQueryVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
  calendarEventWhere: CalendarEventWhere;
}>;

export type RunningBbbMeetingsSubpagePageDataQuery = {
  __typename?: 'Query';
  calendarEvents: Array<{
    __typename: 'CalendarEvent';
    uuid: string;
    virtualLocations: Array<{ __typename?: 'VirtualLocation'; uuid: string; running: boolean }>;
  }>;
} & {
  ' $fragmentRefs'?: {
    UseAvailableServicesForOrganizationFieldsFragment: UseAvailableServicesForOrganizationFieldsFragment;
    RunningMeetingsTableFieldsFragment: RunningMeetingsTableFieldsFragment;
  };
};

export type RunningZoomMeetingsSubpagePageDataQueryVariables = Exact<{
  calendarEventWhere: CalendarEventWhere;
}>;

export type RunningZoomMeetingsSubpagePageDataQuery = { __typename?: 'Query' } & {
  ' $fragmentRefs'?: { RunningMeetingsTableFieldsFragment: RunningMeetingsTableFieldsFragment };
};

export type ProfilePageDataQueryVariables = Exact<{
  profilesWhere: ProfileWhere;
  profilesOptions: ProfileOptions;
  profile: Scalars['ID']['input'];
}>;

export type ProfilePageDataQuery = { __typename?: 'Query' } & {
  ' $fragmentRefs'?: {
    ProfileFormFieldsFragment: ProfileFormFieldsFragment;
    AccessOverviewFormFieldsFragment: AccessOverviewFormFieldsFragment;
    NotificationSettingsFormFieldsFragment: NotificationSettingsFormFieldsFragment;
    PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment;
  };
};

export type SettingsPageDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
}>;

export type SettingsPageDataQuery = { __typename?: 'Query' } & {
  ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment };
};

export type DeleteAbsenceReasonMutationVariables = Exact<{
  where: AbsenceReasonWhere;
}>;

export type DeleteAbsenceReasonMutation = {
  __typename?: 'Mutation';
  deleteAbsenceReasons: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type UpdateBildungsplattformsMutationVariables = Exact<{
  update: BildungsplattformUpdateInput;
  where: BildungsplattformWhere;
}>;

export type UpdateBildungsplattformsMutation = {
  __typename?: 'Mutation';
  updateBildungsplattforms: {
    __typename?: 'UpdateBildungsplattformsMutationResponse';
    bildungsplattforms: Array<{ __typename: 'Bildungsplattform'; uuid: string; allowParentExcuses?: boolean | null }>;
  };
};

export type SettingClassbookSubpageDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
  organizationUuid: Scalars['ID']['input'];
}>;

export type SettingClassbookSubpageDataQuery = { __typename?: 'Query' } & {
  ' $fragmentRefs'?: {
    AbsenceReasonTableFieldsFragment: AbsenceReasonTableFieldsFragment;
    PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment;
  };
};

export type SettingsCollaborationCoursesSubpageDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
  organizationUuid: Scalars['ID']['input'];
}>;

export type SettingsCollaborationCoursesSubpageDataQuery = {
  __typename?: 'Query';
  groups: Array<{
    __typename: 'Group';
    uuid: string;
    name: string;
    isCommunity: boolean;
    displayName?: string | null;
    managedBy: string;
    organization: { __typename: 'Organization'; uuid: string; displayName?: string | null };
    externalServices?: {
      __typename: 'ExternalServices';
      matrix?: boolean | null;
      bbb?: boolean | null;
      nextcloud?: { __typename: 'ExternalServicesStatus'; enabled: boolean; lastSync?: any | null } | null;
      threema?: { __typename: 'ExternalServicesStatus'; enabled: boolean; lastSync?: any | null } | null;
      mailbox?: { __typename: 'ExternalServicesStatus' } | null;
      zoom?: { __typename: 'ExternalServicesStatus' } | null;
    } | null;
    admins: Array<{ __typename: 'Profile'; uuid: string; displayNameShort?: string | null }>;
  }>;
} & { ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment } };

export type SettingsCollaborationGroupsSubpageDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
  organizationUuid: Scalars['ID']['input'];
  groupType: GroupType;
}>;

export type SettingsCollaborationGroupsSubpageDataQuery = {
  __typename?: 'Query';
  groups: Array<{
    __typename: 'Group';
    uuid: string;
    name: string;
    managedBy: string;
    isCommunity: boolean;
    organization: { __typename: 'Organization'; uuid: string; displayName?: string | null };
    admins: Array<{ __typename: 'Profile'; uuid: string; displayNameShort?: string | null }>;
    schoolYear?: { __typename: 'SchoolYear'; uuid: string; name: string } | null;
    editors: Array<{ __typename: 'Profile'; uuid: string }>;
    viewers: Array<{ __typename: 'Profile'; uuid: string }>;
    externalServices?: {
      __typename: 'ExternalServices';
      threema?: { __typename: 'ExternalServicesStatus'; enabled: boolean; lastSync?: any | null } | null;
      zoom?: { __typename: 'ExternalServicesStatus'; enabled: boolean; lastSync?: any | null } | null;
      nextcloud?: { __typename: 'ExternalServicesStatus'; enabled: boolean; lastSync?: any | null } | null;
    } | null;
  }>;
} & {
  ' $fragmentRefs'?: {
    PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment;
    GroupsTableFieldsFragment: GroupsTableFieldsFragment;
  };
};

export type CreateCollaborationInSettingsMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;

export type CreateCollaborationInSettingsMutation = {
  __typename?: 'Mutation';
  createCollaboration: { __typename: 'CollaboratingOrganizations'; uuid: string };
};

export type DeleteCollaborationMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;

export type DeleteCollaborationMutation = {
  __typename?: 'Mutation';
  deleteCollaboration: { __typename?: 'EntitiesDeleteInfo'; entitiesDeleted: number };
};

export type SettingsCollaborationsSubpageDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
  organizationUuid: Scalars['ID']['input'];
}>;

export type SettingsCollaborationsSubpageDataQuery = { __typename?: 'Query' } & {
  ' $fragmentRefs'?: {
    CollaborationsTableFieldsFragment: CollaborationsTableFieldsFragment;
    PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment;
  };
};

export type UpdateBildungsplattformsInSettingsMutationVariables = Exact<{
  update: BildungsplattformUpdateInput;
  where: BildungsplattformWhere;
}>;

export type UpdateBildungsplattformsInSettingsMutation = {
  __typename?: 'Mutation';
  updateBildungsplattforms: {
    __typename?: 'UpdateBildungsplattformsMutationResponse';
    bildungsplattforms: Array<{
      __typename: 'Bildungsplattform';
      uuid: string;
      allowStudentDirectMessages?: boolean | null;
      currentSchoolyear?: string | null;
    }>;
  };
};

export type SettingsOverviewSubpageQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
  organizationUuid: Scalars['ID']['input'];
}>;

export type SettingsOverviewSubpageQuery = {
  __typename?: 'Query';
  adminProfiles: Array<{
    __typename: 'Profile';
    uuid: string;
    displayName?: string | null;
    organizationRoles: Array<string>;
  }>;
} & {
  ' $fragmentRefs'?: {
    PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment;
    BookingsTableFieldsFragment: BookingsTableFieldsFragment;
  };
};

export type SettingsProcuratSubpagePageDataQueryVariables = Exact<{
  profile: Scalars['ID']['input'];
}>;

export type SettingsProcuratSubpagePageDataQuery = { __typename?: 'Query' } & {
  ' $fragmentRefs'?: { PermissionCheckerFieldsFragment: PermissionCheckerFieldsFragment };
};

export const AbsenceReasonTableFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AbsenceReasonTableFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'absenceReasons' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'internal' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'absencesAggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AbsenceReasonTableFieldsFragment, unknown>;
export const AccessOverviewFormFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AccessOverviewFormFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'profilesWhere' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'profilesOptions' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'threemaId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'threemaConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'threemaId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'workPass' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'workUser' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccessOverviewFormFieldsFragment, unknown>;
export const AppointmentMetaFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AppointmentMetaFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'calendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'start' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '500' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'appointmentUuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'categories' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'teachingUnits' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'group' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'holderUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'title' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AppointmentMetaFieldsFragment, unknown>;
export const FileTableFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FileTableFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileEntry' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicDownloadToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'downloadToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FileTableFieldsFragment, unknown>;
export const AssignmentTabFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssignmentTabFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Assignment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'material' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fileEntries' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'FileTableFields' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'allowSubmissionAfterDueDate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'visibleFrom' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dueDate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FileTableFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileEntry' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicDownloadToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'downloadToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssignmentTabFieldsFragment, unknown>;
export const SubmissionsTabProfileFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SubmissionsTabProfileFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Profile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SubmissionsTabProfileFieldsFragment, unknown>;
export const SubmissionsTabSubmissionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SubmissionsTabSubmissionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Submission' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'owner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'updated' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dueDate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SubmissionsTabSubmissionFieldsFragment, unknown>;
export const AssignmentPreviewStudentFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssignmentPreviewStudentFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Assignment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dueDate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submissions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'owner' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssignmentPreviewStudentFieldsFragment, unknown>;
export const AssignmentPreviewTeacherFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssignmentPreviewTeacherFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Assignment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dueDate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssignmentPreviewTeacherFieldsFragment, unknown>;
export const AssignmentsTableStudentFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssignmentsTableStudentFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Assignment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'visibleFrom' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dueDate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submissions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'owner' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'allowSubmissionAfterDueDate' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssignmentsTableStudentFieldsFragment, unknown>;
export const AssignmentsTableTeacherFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssignmentsTableTeacherFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Assignment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'holder' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TeachingUnit' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'owner' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'group' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'organization' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'visibleFrom' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dueDate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'created' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'allowSubmissionAfterDueDate' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssignmentsTableTeacherFieldsFragment, unknown>;
export const PermissionCheckerFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PermissionCheckerFieldsFragment, unknown>;
export const BookingsTableFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BookingsTableFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organizations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'licensedProducts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Bildungsplattform' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'organizationConnection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'properties' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'notAfter' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'notBefore' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Nextcloud' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'profilesAggregate' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'where' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'NOT' },
                                        value: {
                                          kind: 'ObjectValue',
                                          fields: [
                                            {
                                              kind: 'ObjectField',
                                              name: { kind: 'Name', value: 'email_IN' },
                                              value: {
                                                kind: 'ListValue',
                                                values: [{ kind: 'StringValue', value: 'admin@tks.eu', block: false }],
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'organizationConnection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'properties' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'notAfter' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'notBefore' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ThreemaBroadcast' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'organizationConnection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'properties' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'notAfter' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'notBefore' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Threema' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'organizationConnection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'properties' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'notAfter' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'notBefore' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BigBlueButton' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'organizationConnection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'properties' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'notAfter' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'notBefore' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Zoom' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'organizationConnection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'properties' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'notAfter' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'notBefore' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BookingsTableFieldsFragment, unknown>;
export const AnswersCardFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AnswersCardFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'submissionsForAnswersCard' },
            name: { kind: 'Name', value: 'submissions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'public' },
                      value: { kind: 'BooleanValue', value: true },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'assignmentConnection_SINGLE' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'node' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'uuid' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'assignmentUuid' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'material' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AnswersCardFieldsFragment, unknown>;
export const ClassbookAttendeeListFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClassbookAttendeeListFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'absenceReasons' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'absenceReasonsWhere' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'internal' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'absencesAggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClassbookAttendeeListFieldsFragment, unknown>;
export const ClassbookAbsencesTableFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClassbookAbsencesTableFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'absences' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'owner' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid_IN' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'ownerUuids' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'startTime' },
                                value: { kind: 'EnumValue', value: 'DESC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'created' } },
                { kind: 'Field', name: { kind: 'Name', value: 'excused' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'reason' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'internal' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updated' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'days' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'wholeDay' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClassbookAbsencesTableFieldsFragment, unknown>;
export const ClassbookAdministrationTableFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClassbookAdministrationTableFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'absences' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'startTime' },
                                value: { kind: 'EnumValue', value: 'DESC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'reason' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'excused' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'profilesWhere' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'organizationRoles' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'classes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'classesWhere' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'name' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'membersConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClassbookAdministrationTableFieldsFragment, unknown>;
export const DivisionsListFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DivisionsListFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'divisionList' },
            name: { kind: 'Name', value: 'classes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'name' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'divisionsConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'groups' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'division' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                              { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'membersConnection' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'edges' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DivisionsListFieldsFragment, unknown>;
export const ClassesListItemQueryFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClassesListItemQueryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'lastName' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'organizationRoles' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'listName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DivisionsListFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DivisionsListFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'divisionList' },
            name: { kind: 'Name', value: 'classes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'name' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'divisionsConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'groups' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'division' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                              { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'membersConnection' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'edges' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClassesListItemQueryFieldsFragment, unknown>;
export const CollaborationsTableFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CollaborationsTableFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'collaboratingOrganizations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'collaborationStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sourceOrganization' } },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CollaborationsTableFieldsFragment, unknown>;
export const CourseFormBaseDataFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CourseFormBaseDataFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'schoolYears' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subjects' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'classes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'name' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CourseFormBaseDataFieldsFragment, unknown>;
export const CourseFormTeachersFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CourseFormTeachersFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'courseFormTeachersProfiles' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'NOT' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'rolesConnection_SOME' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'Organization' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'edge' },
                                        value: {
                                          kind: 'ObjectValue',
                                          fields: [
                                            {
                                              kind: 'ObjectField',
                                              name: { kind: 'Name', value: 'roleNames_INCLUDES' },
                                              value: { kind: 'StringValue', value: 'STUDENT', block: false },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'rolesConnection_SOME' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'Organization' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'edge' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'roleNames_INCLUDES' },
                                        value: { kind: 'StringValue', value: 'TEACHER', block: false },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'selectName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CourseFormTeachersFieldsFragment, unknown>;
export const FilePreviewTableFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FilePreviewTableFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileEntry' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'downloadToken' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FilePreviewTableFieldsFragment, unknown>;
export const GroupFormAdminsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GroupFormAdminsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'collaboratingOrganizations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'collaborationStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'groupAdmins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'collaborationAdmins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GroupFormAdminsFieldsFragment, unknown>;
export const GroupFormBaseDataFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GroupFormBaseDataFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'schoolYears' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GroupFormBaseDataFieldsFragment, unknown>;
export const GroupFormProfilesFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GroupFormProfilesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'selectName' } },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupsForFormProfiles' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'groupType' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'selectName' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'classes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'name' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'membersConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'selectName' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'divisions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'name' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'class' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'groups' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'members' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'selectName' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'classGroups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'membersConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'selectName' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GroupFormProfilesFieldsFragment, unknown>;
export const GroupsTableFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GroupsTableFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GroupsTableFieldsFragment, unknown>;
export const CalendarEventMapCalendarEventsToBpEventTypeFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CalendarEventMapCalendarEventsToBpEventTypeFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'todaysEventData' },
            name: { kind: 'Name', value: 'calendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'start' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '500' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'calendarEventWhere' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'categories' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guestsAllowed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxAttendees' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualLocations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'features' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'running' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attendeesConnection' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'edges' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'properties' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'withVideo' } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'classbookNoteContentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'classbookHomework' } },
                { kind: 'Field', name: { kind: 'Name', value: 'classbookHomeworkContentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'classbookNote' } },
                { kind: 'Field', name: { kind: 'Name', value: 'classShortNames' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attendeesConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'classbookComment' } }],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'keywords' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locale' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'holderConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Organization' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Group' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Profile' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CalendarEventMapCalendarEventsToBpEventTypeFieldsFragment, unknown>;
export const ConvertEventFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConvertEventFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CalendarEvent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'categories' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'holderConnection' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Group' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Profile' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Organization' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'classShortNames' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'keywords' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'start' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualLocations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ConvertEventFieldsFragment, unknown>;
export const MeetingsFlyoutFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MeetingsFlyoutFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'runningMeetings' },
            name: { kind: 'Name', value: 'calendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'start' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '500' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'AND' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'OR' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'virtualLocations_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'running' },
                                                value: { kind: 'BooleanValue', value: true },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'daysConnection_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'node' },
                                                value: {
                                                  kind: 'ObjectValue',
                                                  fields: [
                                                    {
                                                      kind: 'ObjectField',
                                                      name: { kind: 'Name', value: 'date' },
                                                      value: {
                                                        kind: 'Variable',
                                                        name: { kind: 'Name', value: 'dayConnection' },
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'OR' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'holderConnection' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'Organization' },
                                                value: {
                                                  kind: 'ObjectValue',
                                                  fields: [
                                                    {
                                                      kind: 'ObjectField',
                                                      name: { kind: 'Name', value: 'node' },
                                                      value: {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                          {
                                                            kind: 'ObjectField',
                                                            name: { kind: 'Name', value: 'uuid' },
                                                            value: {
                                                              kind: 'Variable',
                                                              name: { kind: 'Name', value: 'organizationUuid' },
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'attendees_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'uuid' },
                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'owner' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'uuid' },
                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'virtualLocations_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'running' },
                                      value: { kind: 'BooleanValue', value: true },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guestsAllowed' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualLocations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                    ],
                  },
                },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ConvertEventFields' } },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'notRunningMeetings' },
            name: { kind: 'Name', value: 'calendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'start' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '500' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'AND' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'OR' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'virtualLocations_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'running' },
                                                value: { kind: 'BooleanValue', value: true },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'daysConnection_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'node' },
                                                value: {
                                                  kind: 'ObjectValue',
                                                  fields: [
                                                    {
                                                      kind: 'ObjectField',
                                                      name: { kind: 'Name', value: 'date' },
                                                      value: {
                                                        kind: 'Variable',
                                                        name: { kind: 'Name', value: 'dayConnection' },
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'OR' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'holderConnection' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'Organization' },
                                                value: {
                                                  kind: 'ObjectValue',
                                                  fields: [
                                                    {
                                                      kind: 'ObjectField',
                                                      name: { kind: 'Name', value: 'node' },
                                                      value: {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                          {
                                                            kind: 'ObjectField',
                                                            name: { kind: 'Name', value: 'uuid' },
                                                            value: {
                                                              kind: 'Variable',
                                                              name: { kind: 'Name', value: 'organizationUuid' },
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'attendees_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'uuid' },
                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'owner' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'uuid' },
                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'virtualLocations_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'running' },
                                      value: { kind: 'BooleanValue', value: false },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guestsAllowed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualLocations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                    ],
                  },
                },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ConvertEventFields' } },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConvertEventFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CalendarEvent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'categories' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'holderConnection' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Group' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Profile' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Organization' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'classShortNames' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'keywords' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'start' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualLocations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MeetingsFlyoutFieldsFragment, unknown>;
export const HeaderMeetingsFlyoutFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HeaderMeetingsFlyoutFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'CalendarEventMapCalendarEventsToBpEventTypeFields' },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MeetingsFlyoutFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConvertEventFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CalendarEvent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'categories' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'holderConnection' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Group' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Profile' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Organization' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'classShortNames' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'keywords' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'start' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualLocations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CalendarEventMapCalendarEventsToBpEventTypeFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'todaysEventData' },
            name: { kind: 'Name', value: 'calendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'start' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '500' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'calendarEventWhere' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'categories' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guestsAllowed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxAttendees' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualLocations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'features' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'running' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attendeesConnection' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'edges' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'properties' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'withVideo' } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'classbookNoteContentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'classbookHomework' } },
                { kind: 'Field', name: { kind: 'Name', value: 'classbookHomeworkContentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'classbookNote' } },
                { kind: 'Field', name: { kind: 'Name', value: 'classShortNames' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attendeesConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'classbookComment' } }],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'keywords' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locale' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'holderConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Organization' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Group' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Profile' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MeetingsFlyoutFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'runningMeetings' },
            name: { kind: 'Name', value: 'calendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'start' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '500' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'AND' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'OR' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'virtualLocations_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'running' },
                                                value: { kind: 'BooleanValue', value: true },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'daysConnection_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'node' },
                                                value: {
                                                  kind: 'ObjectValue',
                                                  fields: [
                                                    {
                                                      kind: 'ObjectField',
                                                      name: { kind: 'Name', value: 'date' },
                                                      value: {
                                                        kind: 'Variable',
                                                        name: { kind: 'Name', value: 'dayConnection' },
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'OR' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'holderConnection' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'Organization' },
                                                value: {
                                                  kind: 'ObjectValue',
                                                  fields: [
                                                    {
                                                      kind: 'ObjectField',
                                                      name: { kind: 'Name', value: 'node' },
                                                      value: {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                          {
                                                            kind: 'ObjectField',
                                                            name: { kind: 'Name', value: 'uuid' },
                                                            value: {
                                                              kind: 'Variable',
                                                              name: { kind: 'Name', value: 'organizationUuid' },
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'attendees_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'uuid' },
                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'owner' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'uuid' },
                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'virtualLocations_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'running' },
                                      value: { kind: 'BooleanValue', value: true },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guestsAllowed' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualLocations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                    ],
                  },
                },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ConvertEventFields' } },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'notRunningMeetings' },
            name: { kind: 'Name', value: 'calendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'start' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '500' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'AND' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'OR' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'virtualLocations_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'running' },
                                                value: { kind: 'BooleanValue', value: true },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'daysConnection_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'node' },
                                                value: {
                                                  kind: 'ObjectValue',
                                                  fields: [
                                                    {
                                                      kind: 'ObjectField',
                                                      name: { kind: 'Name', value: 'date' },
                                                      value: {
                                                        kind: 'Variable',
                                                        name: { kind: 'Name', value: 'dayConnection' },
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'OR' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'holderConnection' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'Organization' },
                                                value: {
                                                  kind: 'ObjectValue',
                                                  fields: [
                                                    {
                                                      kind: 'ObjectField',
                                                      name: { kind: 'Name', value: 'node' },
                                                      value: {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                          {
                                                            kind: 'ObjectField',
                                                            name: { kind: 'Name', value: 'uuid' },
                                                            value: {
                                                              kind: 'Variable',
                                                              name: { kind: 'Name', value: 'organizationUuid' },
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'attendees_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'uuid' },
                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'owner' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'uuid' },
                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'virtualLocations_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'running' },
                                      value: { kind: 'BooleanValue', value: false },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guestsAllowed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualLocations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                    ],
                  },
                },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ConvertEventFields' } },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HeaderMeetingsFlyoutFieldsFragment, unknown>;
export const HeaderQueryFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HeaderQueryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'HeaderMeetingsFlyoutFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CalendarEventMapCalendarEventsToBpEventTypeFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'todaysEventData' },
            name: { kind: 'Name', value: 'calendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'start' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '500' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'calendarEventWhere' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'categories' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guestsAllowed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxAttendees' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualLocations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'features' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'running' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attendeesConnection' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'edges' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'properties' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'withVideo' } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'classbookNoteContentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'classbookHomework' } },
                { kind: 'Field', name: { kind: 'Name', value: 'classbookHomeworkContentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'classbookNote' } },
                { kind: 'Field', name: { kind: 'Name', value: 'classShortNames' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attendeesConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'classbookComment' } }],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'keywords' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locale' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'holderConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Organization' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Group' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Profile' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConvertEventFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CalendarEvent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'categories' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'holderConnection' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Group' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Profile' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Organization' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'classShortNames' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'keywords' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'start' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualLocations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MeetingsFlyoutFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'runningMeetings' },
            name: { kind: 'Name', value: 'calendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'start' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '500' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'AND' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'OR' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'virtualLocations_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'running' },
                                                value: { kind: 'BooleanValue', value: true },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'daysConnection_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'node' },
                                                value: {
                                                  kind: 'ObjectValue',
                                                  fields: [
                                                    {
                                                      kind: 'ObjectField',
                                                      name: { kind: 'Name', value: 'date' },
                                                      value: {
                                                        kind: 'Variable',
                                                        name: { kind: 'Name', value: 'dayConnection' },
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'OR' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'holderConnection' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'Organization' },
                                                value: {
                                                  kind: 'ObjectValue',
                                                  fields: [
                                                    {
                                                      kind: 'ObjectField',
                                                      name: { kind: 'Name', value: 'node' },
                                                      value: {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                          {
                                                            kind: 'ObjectField',
                                                            name: { kind: 'Name', value: 'uuid' },
                                                            value: {
                                                              kind: 'Variable',
                                                              name: { kind: 'Name', value: 'organizationUuid' },
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'attendees_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'uuid' },
                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'owner' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'uuid' },
                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'virtualLocations_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'running' },
                                      value: { kind: 'BooleanValue', value: true },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guestsAllowed' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualLocations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                    ],
                  },
                },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ConvertEventFields' } },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'notRunningMeetings' },
            name: { kind: 'Name', value: 'calendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'start' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '500' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'AND' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'OR' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'virtualLocations_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'running' },
                                                value: { kind: 'BooleanValue', value: true },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'daysConnection_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'node' },
                                                value: {
                                                  kind: 'ObjectValue',
                                                  fields: [
                                                    {
                                                      kind: 'ObjectField',
                                                      name: { kind: 'Name', value: 'date' },
                                                      value: {
                                                        kind: 'Variable',
                                                        name: { kind: 'Name', value: 'dayConnection' },
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'OR' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'holderConnection' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'Organization' },
                                                value: {
                                                  kind: 'ObjectValue',
                                                  fields: [
                                                    {
                                                      kind: 'ObjectField',
                                                      name: { kind: 'Name', value: 'node' },
                                                      value: {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                          {
                                                            kind: 'ObjectField',
                                                            name: { kind: 'Name', value: 'uuid' },
                                                            value: {
                                                              kind: 'Variable',
                                                              name: { kind: 'Name', value: 'organizationUuid' },
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'attendees_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'uuid' },
                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'owner' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'uuid' },
                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'virtualLocations_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'running' },
                                      value: { kind: 'BooleanValue', value: false },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guestsAllowed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualLocations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                    ],
                  },
                },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ConvertEventFields' } },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HeaderMeetingsFlyoutFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'CalendarEventMapCalendarEventsToBpEventTypeFields' },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MeetingsFlyoutFields' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HeaderQueryFieldsFragment, unknown>;
export const EventsListFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventsListFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EventsListFieldsFragment, unknown>;
export const DashboardEventsQueryFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DashboardEventsQueryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'calendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'start' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '500' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'calendarEventWhere' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualLocations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'classShortNames' } },
                { kind: 'Field', name: { kind: 'Name', value: 'categories' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'keywords' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'holderConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Group' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Organization' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Profile' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'birthdayEvents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                { kind: 'Field', name: { kind: 'Name', value: 'categories' } },
                { kind: 'Field', name: { kind: 'Name', value: 'classShortNames' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DashboardEventsQueryFieldsFragment, unknown>;
export const DashboardEventsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DashboardEventsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventsListFields' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DashboardEventsQueryFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventsListFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DashboardEventsQueryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'calendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'start' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '500' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'calendarEventWhere' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualLocations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'classShortNames' } },
                { kind: 'Field', name: { kind: 'Name', value: 'categories' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'keywords' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'holderConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Group' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Organization' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Profile' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'birthdayEvents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                { kind: 'Field', name: { kind: 'Name', value: 'categories' } },
                { kind: 'Field', name: { kind: 'Name', value: 'classShortNames' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DashboardEventsFieldsFragment, unknown>;
export const GroupsPreviewTableFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GroupsPreviewTableFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profileGroups' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: { kind: 'EnumValue', value: 'group' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid_IN' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizations' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'where' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'virtualLocations_SOME' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'running' },
                                  value: { kind: 'BooleanValue', value: true },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GroupsPreviewTableFieldsFragment, unknown>;
export const CoursesPreviewTableFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CoursesPreviewTableFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: { kind: 'EnumValue', value: 'course' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid_IN' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizations' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'AND' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'OR' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'editors_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'uuid' },
                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'viewers_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'uuid' },
                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'OR' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'inCurrentSchoolyear' },
                                          value: { kind: 'BooleanValue', value: true },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'isCommunity' },
                                          value: { kind: 'BooleanValue', value: true },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isCommunity' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'where' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'virtualLocations_SOME' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'running' },
                                  value: { kind: 'BooleanValue', value: true },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'schoolYear' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'teachingUnitsConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'assignments' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'submissions' },
                                          arguments: [
                                            {
                                              kind: 'Argument',
                                              name: { kind: 'Name', value: 'where' },
                                              value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                  {
                                                    kind: 'ObjectField',
                                                    name: { kind: 'Name', value: 'status' },
                                                    value: { kind: 'EnumValue', value: 'New' },
                                                  },
                                                ],
                                              },
                                            },
                                          ],
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                              { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'submissions_SOME' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'owner' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'uuid' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submissions' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'where' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'submissionsWhere' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'holder' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TeachingUnit' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'group' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CoursesPreviewTableFieldsFragment, unknown>;
export const PreviewDataQueryFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PreviewDataQueryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profileCourses' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: { kind: 'EnumValue', value: 'course' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid_IN' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizations' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'AND' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'OR' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'editors_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'uuid' },
                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'viewers_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'uuid' },
                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'OR' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'inCurrentSchoolyear' },
                                          value: { kind: 'BooleanValue', value: true },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'isCommunity' },
                                          value: { kind: 'BooleanValue', value: true },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profileGroups' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: { kind: 'EnumValue', value: 'group' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid_IN' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizations' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GroupsPreviewTableFields' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CoursesPreviewTableFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GroupsPreviewTableFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profileGroups' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: { kind: 'EnumValue', value: 'group' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid_IN' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizations' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'where' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'virtualLocations_SOME' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'running' },
                                  value: { kind: 'BooleanValue', value: true },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CoursesPreviewTableFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: { kind: 'EnumValue', value: 'course' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid_IN' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizations' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'AND' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'OR' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'editors_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'uuid' },
                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'viewers_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'uuid' },
                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'OR' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'inCurrentSchoolyear' },
                                          value: { kind: 'BooleanValue', value: true },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'isCommunity' },
                                          value: { kind: 'BooleanValue', value: true },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isCommunity' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'where' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'virtualLocations_SOME' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'running' },
                                  value: { kind: 'BooleanValue', value: true },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'schoolYear' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'teachingUnitsConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'assignments' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'submissions' },
                                          arguments: [
                                            {
                                              kind: 'Argument',
                                              name: { kind: 'Name', value: 'where' },
                                              value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                  {
                                                    kind: 'ObjectField',
                                                    name: { kind: 'Name', value: 'status' },
                                                    value: { kind: 'EnumValue', value: 'New' },
                                                  },
                                                ],
                                              },
                                            },
                                          ],
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                              { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'submissions_SOME' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'owner' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'uuid' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submissions' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'where' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'submissionsWhere' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'holder' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TeachingUnit' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'group' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PreviewDataQueryFieldsFragment, unknown>;
export const LinkListFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LinkListFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LinkListFieldsFragment, unknown>;
export const MaterialDetailFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MaterialDetailFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workMaterials' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'workMaterialUuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'material' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fileEntries' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'FileTableFields' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FileTableFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileEntry' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicDownloadToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'downloadToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MaterialDetailFieldsFragment, unknown>;
export const MeetingsLinksFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MeetingsLinksFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'runningMeetings' },
            name: { kind: 'Name', value: 'calendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'AND' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'virtualLocations_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'running' },
                                      value: { kind: 'BooleanValue', value: true },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'daysConnection_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'node' },
                                      value: {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'date' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'formattedDate' } },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'holderConnection' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'Group' },
                                      value: {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'node' },
                                            value: {
                                              kind: 'ObjectValue',
                                              fields: [
                                                {
                                                  kind: 'ObjectField',
                                                  name: { kind: 'Name', value: 'uuid' },
                                                  value: {
                                                    kind: 'Variable',
                                                    name: { kind: 'Name', value: 'groupUuid' },
                                                  },
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'OR' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'holderConnection' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'Organization' },
                                                value: {
                                                  kind: 'ObjectValue',
                                                  fields: [
                                                    {
                                                      kind: 'ObjectField',
                                                      name: { kind: 'Name', value: 'node' },
                                                      value: {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                          {
                                                            kind: 'ObjectField',
                                                            name: { kind: 'Name', value: 'uuid' },
                                                            value: {
                                                              kind: 'Variable',
                                                              name: { kind: 'Name', value: 'organizationUuid' },
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'attendees_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'uuid' },
                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'owner' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'uuid' },
                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualLocations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'holderConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Group' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Organization' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Profile' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MeetingsLinksFieldsFragment, unknown>;
export const MobileMenuQueryFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MobileMenuQueryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'CalendarEventMapCalendarEventsToBpEventTypeFields' },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MeetingsFlyoutFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConvertEventFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CalendarEvent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'categories' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'holderConnection' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Group' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Profile' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Organization' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'classShortNames' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'keywords' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'start' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualLocations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CalendarEventMapCalendarEventsToBpEventTypeFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'todaysEventData' },
            name: { kind: 'Name', value: 'calendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'start' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '500' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'calendarEventWhere' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'categories' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guestsAllowed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxAttendees' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualLocations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'features' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'running' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attendeesConnection' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'edges' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'properties' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'withVideo' } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'classbookNoteContentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'classbookHomework' } },
                { kind: 'Field', name: { kind: 'Name', value: 'classbookHomeworkContentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'classbookNote' } },
                { kind: 'Field', name: { kind: 'Name', value: 'classShortNames' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attendeesConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'classbookComment' } }],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'keywords' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locale' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'holderConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Organization' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Group' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Profile' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MeetingsFlyoutFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'runningMeetings' },
            name: { kind: 'Name', value: 'calendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'start' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '500' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'AND' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'OR' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'virtualLocations_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'running' },
                                                value: { kind: 'BooleanValue', value: true },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'daysConnection_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'node' },
                                                value: {
                                                  kind: 'ObjectValue',
                                                  fields: [
                                                    {
                                                      kind: 'ObjectField',
                                                      name: { kind: 'Name', value: 'date' },
                                                      value: {
                                                        kind: 'Variable',
                                                        name: { kind: 'Name', value: 'dayConnection' },
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'OR' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'holderConnection' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'Organization' },
                                                value: {
                                                  kind: 'ObjectValue',
                                                  fields: [
                                                    {
                                                      kind: 'ObjectField',
                                                      name: { kind: 'Name', value: 'node' },
                                                      value: {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                          {
                                                            kind: 'ObjectField',
                                                            name: { kind: 'Name', value: 'uuid' },
                                                            value: {
                                                              kind: 'Variable',
                                                              name: { kind: 'Name', value: 'organizationUuid' },
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'attendees_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'uuid' },
                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'owner' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'uuid' },
                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'virtualLocations_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'running' },
                                      value: { kind: 'BooleanValue', value: true },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guestsAllowed' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualLocations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                    ],
                  },
                },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ConvertEventFields' } },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'notRunningMeetings' },
            name: { kind: 'Name', value: 'calendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'start' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '500' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'AND' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'OR' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'virtualLocations_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'running' },
                                                value: { kind: 'BooleanValue', value: true },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'daysConnection_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'node' },
                                                value: {
                                                  kind: 'ObjectValue',
                                                  fields: [
                                                    {
                                                      kind: 'ObjectField',
                                                      name: { kind: 'Name', value: 'date' },
                                                      value: {
                                                        kind: 'Variable',
                                                        name: { kind: 'Name', value: 'dayConnection' },
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'OR' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'holderConnection' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'Organization' },
                                                value: {
                                                  kind: 'ObjectValue',
                                                  fields: [
                                                    {
                                                      kind: 'ObjectField',
                                                      name: { kind: 'Name', value: 'node' },
                                                      value: {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                          {
                                                            kind: 'ObjectField',
                                                            name: { kind: 'Name', value: 'uuid' },
                                                            value: {
                                                              kind: 'Variable',
                                                              name: { kind: 'Name', value: 'organizationUuid' },
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'attendees_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'uuid' },
                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'owner' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'uuid' },
                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'virtualLocations_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'running' },
                                      value: { kind: 'BooleanValue', value: false },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guestsAllowed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualLocations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                    ],
                  },
                },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ConvertEventFields' } },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MobileMenuQueryFieldsFragment, unknown>;
export const NotificationSettingsFormFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NotificationSettingsFormFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'profilesWhere' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'profilesOptions' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notificationPreferencesConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'transports' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NotificationSettingsFormFieldsFragment, unknown>;
export const OpenAssignmentQueryFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OpenAssignmentQueryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'submissions_SOME' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'owner' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'uuid' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dueDate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'created' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'visibleFrom' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'holder' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TeachingUnit' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'group' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submissions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'owner' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'openAssignmentCalendarEvents' },
            name: { kind: 'Name', value: 'calendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'calendarEventWhere' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'categories' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recurrenceRule' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'frequency' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OpenAssignmentQueryFieldsFragment, unknown>;
export const ProfileFormFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ProfileFormFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'profilesWhere' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'profilesOptions' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'threemaId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProfileFormFieldsFragment, unknown>;
export const PushNotificationWrapperFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PushNotificationWrapperFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notificationSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'notificationSettingsWhere' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userUuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pushIds' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PushNotificationWrapperFieldsFragment, unknown>;
export const RunningMeetingsTableFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RunningMeetingsTableFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'calendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'calendarEventWhere' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxAttendees' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'holderConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Group' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Organization' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Profile' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualLocations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'running' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attendeesConnection' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'edges' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'properties' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'withVideo' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'node' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RunningMeetingsTableFieldsFragment, unknown>;
export const TeachingUnitSelectFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeachingUnitSelectFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'teachingUnits' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'group' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'courseUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TeachingUnitSelectFieldsFragment, unknown>;
export const WorkMaterialDetailFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WorkMaterialDetailFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workMaterials' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'workMaterialUuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'visibleFrom' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'visibleTo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'material' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fileEntries' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'FileTableFields' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FileTableFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileEntry' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicDownloadToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'downloadToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkMaterialDetailFieldsFragment, unknown>;
export const GroupWorkMaterialsFormFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GroupWorkMaterialsFormFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workMaterials' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'workMaterialUuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'material' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fileEntries' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'FileTableFields' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'visibleFrom' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'visibleTo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'publicFrom' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'visibleAfterVisibleTo' } },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FileTableFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileEntry' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicDownloadToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'downloadToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GroupWorkMaterialsFormFieldsFragment, unknown>;
export const WorkMaterialsListFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WorkMaterialsListFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'WorkMaterial' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updated' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WorkMaterialsListFieldsFragment, unknown>;
export const CourseWorkMaterialsTableFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CourseWorkMaterialsTableFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'WorkMaterial' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'holder' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TeachingUnit' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'organization' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'owner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'material' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fileEntries' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'visibleAfterVisibleTo' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CourseWorkMaterialsTableFieldsFragment, unknown>;
export const GroupWorkMaterialsTableFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GroupWorkMaterialsTableFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'workMaterialsTable' },
            name: { kind: 'Name', value: 'workMaterials' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'holder' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'TeachingUnit' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'group' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'uuid' },
                                        value: { kind: 'Variable', name: { kind: 'Name', value: 'groupUuid' } },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'created' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updated' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'material' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fileEntries' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GroupWorkMaterialsTableFieldsFragment, unknown>;
export const OrganizationConfigFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OrganizationConfigFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'schoolYears' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'schoolYearWhere' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'end' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organizations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'licensedProducts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Bildungsplattform' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'allowStudentDirectMessages' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'allowParentExcuses' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currentSchoolyear' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'organizationConnection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'properties' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'notAfter' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'notBefore' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Nextcloud' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'serverUri' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'serverAliase' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'organizationConnection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'properties' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'notAfter' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'notBefore' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ThreemaBroadcast' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'organizationConnection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'properties' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'notAfter' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'notBefore' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Threema' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'apiToken' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'licenseCount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'licenseValidUntil' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'organizationConnection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'properties' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'notAfter' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'notBefore' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BigBlueButton' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maxParticipantsPerMeeting' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'allowRecording' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'apiUrl' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'organizationConnection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'properties' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'notAfter' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'notBefore' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Zoom' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maxParticipantsPerMeeting' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'organizationConnection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'properties' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'notAfter' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'notBefore' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrganizationConfigFieldsFragment, unknown>;
export const ResolveRoomNameFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ResolveRoomNameFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'organizationRoles' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResolveRoomNameFieldsFragment, unknown>;
export const GetConversationsFieldsDocumentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GetConversationsFieldsDocument' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayNameShort' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetConversationsFieldsDocumentFragment, unknown>;
export const UseAvailableServicesForOrganizationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UseAvailableServicesForOrganizationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organizations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'licensedProducts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Zoom' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Bildungsplattform' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Threema' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ThreemaBroadcast' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Nextcloud' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BigBlueButton' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'allowRecording' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maxParticipantsPerMeeting' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'organizationConnection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'properties' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'notAfter' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'notBefore' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UseAvailableServicesForOrganizationFieldsFragment, unknown>;
export const UseGroupMembersCountFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UseGroupMembersCountFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupMembersCount' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'groupUuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editorsAggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewersAggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UseGroupMembersCountFieldsFragment, unknown>;
export const UseConvertToCourseTableTypeFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UseConvertToCourseTableTypeFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: { kind: 'EnumValue', value: 'course' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid_IN' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuids' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'AND' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'OR' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'editors_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'uuid' },
                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'viewers_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'uuid' },
                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'OR' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'inCurrentSchoolyear' },
                                          value: { kind: 'BooleanValue', value: true },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'isCommunity' },
                                          value: { kind: 'BooleanValue', value: true },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'managedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isCommunity' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastSync' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'externalServices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'threema' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastSync' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'virtualLocations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'running' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayNameShort' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'teachingUnitsConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'assignments' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'submissions' },
                                          arguments: [
                                            {
                                              kind: 'Argument',
                                              name: { kind: 'Name', value: 'where' },
                                              value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                  {
                                                    kind: 'ObjectField',
                                                    name: { kind: 'Name', value: 'status' },
                                                    value: { kind: 'EnumValue', value: 'New' },
                                                  },
                                                ],
                                              },
                                            },
                                          ],
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                              { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UseConvertToCourseTableTypeFieldsFragment, unknown>;
export const DataLoaderDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DataLoaderData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'schoolYearWhere' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SchoolYearWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'notificationSettingsWhere' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'NotificationSettingsWhere' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'calendarEventWhere' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CalendarEventWhere' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dayConnection' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'OrganizationConfigFields' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'HeaderQueryFields' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MobileMenuQueryFields' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PushNotificationWrapperFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CalendarEventMapCalendarEventsToBpEventTypeFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'todaysEventData' },
            name: { kind: 'Name', value: 'calendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'start' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '500' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'calendarEventWhere' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'categories' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guestsAllowed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxAttendees' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualLocations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'features' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'running' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attendeesConnection' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'edges' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'properties' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'withVideo' } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'classbookNoteContentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'classbookHomework' } },
                { kind: 'Field', name: { kind: 'Name', value: 'classbookHomeworkContentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'classbookNote' } },
                { kind: 'Field', name: { kind: 'Name', value: 'classShortNames' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attendeesConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'classbookComment' } }],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'keywords' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locale' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'holderConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Organization' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Group' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Profile' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConvertEventFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CalendarEvent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'categories' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'holderConnection' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Group' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Profile' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Organization' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'classShortNames' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'keywords' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'start' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualLocations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MeetingsFlyoutFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'runningMeetings' },
            name: { kind: 'Name', value: 'calendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'start' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '500' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'AND' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'OR' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'virtualLocations_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'running' },
                                                value: { kind: 'BooleanValue', value: true },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'daysConnection_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'node' },
                                                value: {
                                                  kind: 'ObjectValue',
                                                  fields: [
                                                    {
                                                      kind: 'ObjectField',
                                                      name: { kind: 'Name', value: 'date' },
                                                      value: {
                                                        kind: 'Variable',
                                                        name: { kind: 'Name', value: 'dayConnection' },
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'OR' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'holderConnection' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'Organization' },
                                                value: {
                                                  kind: 'ObjectValue',
                                                  fields: [
                                                    {
                                                      kind: 'ObjectField',
                                                      name: { kind: 'Name', value: 'node' },
                                                      value: {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                          {
                                                            kind: 'ObjectField',
                                                            name: { kind: 'Name', value: 'uuid' },
                                                            value: {
                                                              kind: 'Variable',
                                                              name: { kind: 'Name', value: 'organizationUuid' },
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'attendees_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'uuid' },
                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'owner' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'uuid' },
                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'virtualLocations_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'running' },
                                      value: { kind: 'BooleanValue', value: true },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guestsAllowed' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualLocations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                    ],
                  },
                },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ConvertEventFields' } },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'notRunningMeetings' },
            name: { kind: 'Name', value: 'calendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'start' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '500' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'AND' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'OR' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'virtualLocations_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'running' },
                                                value: { kind: 'BooleanValue', value: true },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'daysConnection_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'node' },
                                                value: {
                                                  kind: 'ObjectValue',
                                                  fields: [
                                                    {
                                                      kind: 'ObjectField',
                                                      name: { kind: 'Name', value: 'date' },
                                                      value: {
                                                        kind: 'Variable',
                                                        name: { kind: 'Name', value: 'dayConnection' },
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'OR' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'holderConnection' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'Organization' },
                                                value: {
                                                  kind: 'ObjectValue',
                                                  fields: [
                                                    {
                                                      kind: 'ObjectField',
                                                      name: { kind: 'Name', value: 'node' },
                                                      value: {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                          {
                                                            kind: 'ObjectField',
                                                            name: { kind: 'Name', value: 'uuid' },
                                                            value: {
                                                              kind: 'Variable',
                                                              name: { kind: 'Name', value: 'organizationUuid' },
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'attendees_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'uuid' },
                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'owner' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'uuid' },
                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'virtualLocations_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'running' },
                                      value: { kind: 'BooleanValue', value: false },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guestsAllowed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualLocations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                    ],
                  },
                },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ConvertEventFields' } },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HeaderMeetingsFlyoutFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'CalendarEventMapCalendarEventsToBpEventTypeFields' },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MeetingsFlyoutFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OrganizationConfigFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'schoolYears' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'schoolYearWhere' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'end' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organizations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'licensedProducts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Bildungsplattform' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'allowStudentDirectMessages' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'allowParentExcuses' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currentSchoolyear' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'organizationConnection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'properties' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'notAfter' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'notBefore' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Nextcloud' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'serverUri' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'serverAliase' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'organizationConnection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'properties' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'notAfter' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'notBefore' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ThreemaBroadcast' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'organizationConnection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'properties' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'notAfter' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'notBefore' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Threema' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'apiToken' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'licenseCount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'licenseValidUntil' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'organizationConnection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'properties' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'notAfter' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'notBefore' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BigBlueButton' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maxParticipantsPerMeeting' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'allowRecording' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'apiUrl' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'organizationConnection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'properties' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'notAfter' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'notBefore' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Zoom' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maxParticipantsPerMeeting' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'organizationConnection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'properties' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'notAfter' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'notBefore' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HeaderQueryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'HeaderMeetingsFlyoutFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MobileMenuQueryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'CalendarEventMapCalendarEventsToBpEventTypeFields' },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MeetingsFlyoutFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PushNotificationWrapperFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notificationSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'notificationSettingsWhere' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userUuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pushIds' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DataLoaderDataQuery, DataLoaderDataQueryVariables>;
export const CreateAbsenceReasonDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateAbsenceReason' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'AbsenceReasonCreateInput' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createAbsenceReasons' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'nodesCreated' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'absenceReasons' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'internal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateAbsenceReasonMutation, CreateAbsenceReasonMutationVariables>;
export const UpdateAbsenceReasonDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateAbsenceReason' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AbsenceReasonWhere' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AbsenceReasonUpdateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAbsenceReasons' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'absenceReasons' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'internal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateAbsenceReasonMutation, UpdateAbsenceReasonMutationVariables>;
export const AbsenceReasonFormDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AbsenceReasonFormData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'absenceReasons' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'internal' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AbsenceReasonFormDataQuery, AbsenceReasonFormDataQueryVariables>;
export const UpdatePasswordsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdatePasswords' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'PasswordWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'PasswordUpdateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePasswords' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'users' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdatePasswordsMutation, UpdatePasswordsMutationVariables>;
export const BpUpdateSubmissionsInActivityProtocolDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpUpdateSubmissionsInActivityProtocol' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SubmissionWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SubmissionUpdateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateSubmissions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BpUpdateSubmissionsInActivityProtocolMutation,
  BpUpdateSubmissionsInActivityProtocolMutationVariables
>;
export const ActivityDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActivityData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profiles' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid_IN' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profiles' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActivityDataQuery, ActivityDataQueryVariables>;
export const BpCreateBpProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpCreateBpProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'BpProfileCreateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createBpProfile' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BpCreateBpProfileMutation, BpCreateBpProfileMutationVariables>;
export const UpdateBpProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateBpProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'BpProfileUpdateInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBpProfile' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateBpProfileMutation, UpdateBpProfileMutationVariables>;
export const BpCreateCalendarEventInAppointmentFormDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpCreateCalendarEventInAppointmentForm' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'CalendarEventCreateInput' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCalendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'calendarEvents' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BpCreateCalendarEventInAppointmentFormMutation,
  BpCreateCalendarEventInAppointmentFormMutationVariables
>;
export const BpUpdateCalendarEventsInAppointmentFormDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpUpdateCalendarEventsInAppointmentForm' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CalendarEventWhere' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CalendarEventUpdateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateCalendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'calendarEvents' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BpUpdateCalendarEventsInAppointmentFormMutation,
  BpUpdateCalendarEventsInAppointmentFormMutationVariables
>;
export const AppointmentFormPageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AppointmentFormPageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'appointmentUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'holderUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'calendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'start' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '500' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'appointmentUuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'categories' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'teachingUnit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recurrenceRule' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'frequency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'until' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'recordVirtualEvent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxAttendees' } },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'UseAvailableServicesForOrganizationFields' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AppointmentMetaFields' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'UseGroupMembersCountFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'profilesAggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UseAvailableServicesForOrganizationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organizations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'licensedProducts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Zoom' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Bildungsplattform' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Threema' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ThreemaBroadcast' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Nextcloud' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BigBlueButton' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'allowRecording' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maxParticipantsPerMeeting' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'organizationConnection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'properties' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'notAfter' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'notBefore' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AppointmentMetaFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'calendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'start' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '500' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'appointmentUuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'categories' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'teachingUnits' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'group' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'holderUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'title' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UseGroupMembersCountFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupMembersCount' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'groupUuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editorsAggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewersAggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AppointmentFormPageDataQuery, AppointmentFormPageDataQueryVariables>;
export const BpSetAllowSubmissionsAfterDueDateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpSetAllowSubmissionsAfterDueDate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'AssignmentWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AssignmentUpdateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAssignments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'allowSubmissionAfterDueDate' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BpSetAllowSubmissionsAfterDueDateMutation,
  BpSetAllowSubmissionsAfterDueDateMutationVariables
>;
export const BpCreateAssignmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpCreateAssignment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'AssignmentCreateInput' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createAssignments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BpCreateAssignmentMutation, BpCreateAssignmentMutationVariables>;
export const BpUpdateAssignmentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpUpdateAssignments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'AssignmentWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AssignmentUpdateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAssignments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BpUpdateAssignmentsMutation, BpUpdateAssignmentsMutationVariables>;
export const AssignmentFormPageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AssignmentFormPageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'assignmentUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'courseUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'assignmentUuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'material' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fileEntries' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'FileTableFields' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'visibleFrom' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dueDate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'allowSubmissionAfterDueDate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'holder' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TeachingUnit' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'TeachingUnitSelectFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FileTableFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileEntry' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicDownloadToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'downloadToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeachingUnitSelectFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'teachingUnits' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'group' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'courseUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssignmentFormPageDataQuery, AssignmentFormPageDataQueryVariables>;
export const BpDeleteAssignmentsFromAssignmentPreviewTeacherDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpDeleteAssignmentsFromAssignmentPreviewTeacher' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'AssignmentWhere' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteAssignments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'nodesDeleted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'relationshipsDeleted' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BpDeleteAssignmentsFromAssignmentPreviewTeacherMutation,
  BpDeleteAssignmentsFromAssignmentPreviewTeacherMutationVariables
>;
export const BpDeleteAssignmentsFromAssignmentTableTeacherDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpDeleteAssignmentsFromAssignmentTableTeacher' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'AssignmentWhere' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteAssignments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'nodesDeleted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'relationshipsDeleted' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BpDeleteAssignmentsFromAssignmentTableTeacherMutation,
  BpDeleteAssignmentsFromAssignmentTableTeacherMutationVariables
>;
export const CreateBigBlueButtonsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateBigBlueButtons' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'BigBlueButtonCreateInput' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createBigBlueButtons' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bigBlueButtons' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateBigBlueButtonsMutation, CreateBigBlueButtonsMutationVariables>;
export const UpdateBigBlueButtonsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateBigBlueButtons' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'BigBlueButtonUpdateInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'BigBlueButtonWhere' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBigBlueButtons' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bigBlueButtons' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'apiUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'allowRecording' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxParticipantsPerMeeting' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'organizationConnection' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'edges' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'properties' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'notAfter' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'notBefore' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateBigBlueButtonsMutation, UpdateBigBlueButtonsMutationVariables>;
export const SettingsBigBlueButtonFormDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SettingsBigBlueButtonFormData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bigBlueButtons' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'apiUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxParticipantsPerMeeting' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allowRecording' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organizationConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'notAfter' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'notBefore' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'contractRef' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SettingsBigBlueButtonFormDataQuery, SettingsBigBlueButtonFormDataQueryVariables>;
export const CreateBildungsplattformsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateBildungsplattforms' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'BildungsplattformCreateInput' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createBildungsplattforms' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bildungsplattforms' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateBildungsplattformsMutation, CreateBildungsplattformsMutationVariables>;
export const UpdateBildungsplattformsInBildungsplattformFormDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateBildungsplattformsInBildungsplattformForm' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'BildungsplattformUpdateInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'BildungsplattformWhere' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBildungsplattforms' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bildungsplattforms' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'allowStudentDirectMessages' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'organizationConnection' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'edges' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'properties' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'notAfter' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'notBefore' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateBildungsplattformsInBildungsplattformFormMutation,
  UpdateBildungsplattformsInBildungsplattformFormMutationVariables
>;
export const SettingsBildungsplattformFormDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SettingsBildungsplattformFormData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bildungsplattforms' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allowStudentDirectMessages' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allowParentExcuses' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentSchoolyear' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organizationConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'notAfter' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'notBefore' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'contractRef' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SettingsBildungsplattformFormDataQuery, SettingsBildungsplattformFormDataQueryVariables>;
export const CreateNextcloudsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateNextclouds' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'NextcloudCreateInput' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createNextclouds' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextclouds' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'serverUri' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'organizationConnection' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'edges' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'properties' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'notAfter' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'notBefore' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateNextcloudsMutation, CreateNextcloudsMutationVariables>;
export const UpdateNextcloudsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateNextclouds' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'NextcloudUpdateInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'NextcloudWhere' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateNextclouds' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextclouds' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'serverUri' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'organizationConnection' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'edges' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'properties' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'notAfter' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'notBefore' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateNextcloudsMutation, UpdateNextcloudsMutationVariables>;
export const SettingsNextcloudFormDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SettingsNextcloudFormData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nextclouds' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'serverUri' } },
                { kind: 'Field', name: { kind: 'Name', value: 'serverAliase' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organizationConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'notBefore' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'notAfter' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SettingsNextcloudFormDataQuery, SettingsNextcloudFormDataQueryVariables>;
export const CreateThreemaBroadcastssDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateThreemaBroadcastss' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'ThreemaBroadcastCreateInput' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createThreemaBroadcasts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'threemaBroadcasts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateThreemaBroadcastssMutation, CreateThreemaBroadcastssMutationVariables>;
export const UpdateThreemaBroadcastssDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateThreemaBroadcastss' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ThreemaBroadcastUpdateInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ThreemaBroadcastWhere' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateThreemaBroadcasts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'threemaBroadcasts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'apiToken' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'thremaId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'organizationConnection' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'edges' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'properties' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'notAfter' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'notBefore' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateThreemaBroadcastssMutation, UpdateThreemaBroadcastssMutationVariables>;
export const SettingsThreemaBroadcastFormDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SettingsThreemaBroadcastFormData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'threemaBroadcasts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'thremaId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'apiToken' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organizationConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'notAfter' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'notBefore' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'contractRef' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SettingsThreemaBroadcastFormDataQuery, SettingsThreemaBroadcastFormDataQueryVariables>;
export const CreateThreemasDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateThreemas' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'ThreemaCreateInput' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createThreemas' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'threemas' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateThreemasMutation, CreateThreemasMutationVariables>;
export const UpdateThreemasDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateThreemas' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ThreemaUpdateInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ThreemaWhere' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateThreemas' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'threemas' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'apiToken' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'organizationConnection' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'edges' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'properties' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'notBefore' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'notAfter' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateThreemasMutation, UpdateThreemasMutationVariables>;
export const SettingsThreemaFormDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SettingsThreemaFormData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'threemas' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'apiToken' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organizationConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'notBefore' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'notAfter' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SettingsThreemaFormDataQuery, SettingsThreemaFormDataQueryVariables>;
export const UpdateZoomsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateZooms' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ZoomUpdateInput' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ZoomWhere' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateZooms' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'zooms' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'oauthAccountId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'oauthClientId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'organizationConnection' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'edges' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'properties' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'notAfter' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateZoomsMutation, UpdateZoomsMutationVariables>;
export const SettingsZoomFormDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SettingsZoomFormData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'zooms' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'oauthAccountId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'oauthClientId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organizationConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'notAfter' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'notBefore' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'contractRef' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SettingsZoomFormDataQuery, SettingsZoomFormDataQueryVariables>;
export const BreadcrumbPageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BreadcrumbPageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuids' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid_IN' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuids' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'teachingUnits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'workMaterials' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'courses' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: { kind: 'EnumValue', value: 'course' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid_IN' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuids' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'AND' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'OR' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'editors_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'uuid' },
                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'viewers_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'uuid' },
                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'OR' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'inCurrentSchoolyear' },
                                          value: { kind: 'BooleanValue', value: true },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'isCommunity' },
                                          value: { kind: 'BooleanValue', value: true },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'teachingUnits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'workMaterials' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assignments' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'submissions' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'owner' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BreadcrumbPageDataQuery, BreadcrumbPageDataQueryVariables>;
export const UpdateProfileRoleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateProfileRole' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'role' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateProfileRole' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'role' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'role' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'entitiesUpdated' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateProfileRoleMutation, UpdateProfileRoleMutationVariables>;
export const UpdateClassGroupInClassGroupProfilesFormDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateClassGroupInClassGroupProfilesForm' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ClassGroupUpdateInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ClassGroupWhere' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateClassGroups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'classGroups' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'members' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateClassGroupInClassGroupProfilesFormMutation,
  UpdateClassGroupInClassGroupProfilesFormMutationVariables
>;
export const ClassGroupProfilesFormPageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ClassGroupProfilesFormPageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'classUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'divisions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'class' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'classUuid' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'groups' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'managedBy' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'classGroups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'division' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'membersConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClassGroupProfilesFormPageDataQuery, ClassGroupProfilesFormPageDataQueryVariables>;
export const BpCreateAbsenceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpCreateAbsence' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'AbsenceCreateInput' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createAbsences' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'absences' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BpCreateAbsenceMutation, BpCreateAbsenceMutationVariables>;
export const BpDeleteAbsenceFromClassbookEventDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpDeleteAbsenceFromClassbookEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'AbsenceWhere' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteAbsences' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'nodesDeleted' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BpDeleteAbsenceFromClassbookEventMutation,
  BpDeleteAbsenceFromClassbookEventMutationVariables
>;
export const BpUpdateAbsenceInClassbookEventDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpUpdateAbsenceInClassbookEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'AbsenceWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AbsenceUpdateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAbsences' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'absences' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'excused' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BpUpdateAbsenceInClassbookEventMutation, BpUpdateAbsenceInClassbookEventMutationVariables>;
export const BpUpdateCalendarEventsInClassbookEventDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpUpdateCalendarEventsInClassbookEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CalendarEventWhere' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CalendarEventUpdateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateCalendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'calendarEvents' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'classbookNote' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'classbookHomework' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attendees' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'nodesCreated' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BpUpdateCalendarEventsInClassbookEventMutation,
  BpUpdateCalendarEventsInClassbookEventMutationVariables
>;
export const ClassbookEventQueryDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ClassbookEventQueryDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'calendarEventWhere' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CalendarEventWhere' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'absenceReasonsWhere' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AbsenceReasonWhere' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'CalendarEventMapCalendarEventsToBpEventTypeFields' },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ClassbookAttendeeListFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CalendarEventMapCalendarEventsToBpEventTypeFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'todaysEventData' },
            name: { kind: 'Name', value: 'calendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'start' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '500' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'calendarEventWhere' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'categories' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guestsAllowed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxAttendees' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualLocations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'features' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'running' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attendeesConnection' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'edges' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'properties' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'withVideo' } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'classbookNoteContentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'classbookHomework' } },
                { kind: 'Field', name: { kind: 'Name', value: 'classbookHomeworkContentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'classbookNote' } },
                { kind: 'Field', name: { kind: 'Name', value: 'classShortNames' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attendeesConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'classbookComment' } }],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'keywords' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locale' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'holderConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Organization' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Group' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Profile' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClassbookAttendeeListFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'absenceReasons' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'absenceReasonsWhere' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'internal' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'absencesAggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClassbookEventQueryDocumentQuery, ClassbookEventQueryDocumentQueryVariables>;
export const ClassbookAbsenceDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ClassbookAbsenceData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventAttendeeUuids' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'start' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'end' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid_IN' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'eventAttendeeUuids' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'organizationRoles' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'absences' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'owner' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid_IN' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'eventAttendeeUuids' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'startTime_LTE' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'start' } },
                              },
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'endTime_GTE' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'start' } },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'startTime_GTE' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'end' } },
                              },
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'endTime_LTE' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'end' } },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'startTime_GTE' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'start' } },
                              },
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'endTime_LTE' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'end' } },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'wholeDay' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'reason' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'excused' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClassbookAbsenceDataQuery, ClassbookAbsenceDataQueryVariables>;
export const ClassbookEventsQueryDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ClassbookEventsQueryDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'calendarEventWhere' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CalendarEventWhere' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'CalendarEventMapCalendarEventsToBpEventTypeFields' },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventsListFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CalendarEventMapCalendarEventsToBpEventTypeFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'todaysEventData' },
            name: { kind: 'Name', value: 'calendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'start' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '500' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'calendarEventWhere' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'categories' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guestsAllowed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxAttendees' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualLocations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'features' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'running' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attendeesConnection' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'edges' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'properties' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'withVideo' } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'classbookNoteContentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'classbookHomework' } },
                { kind: 'Field', name: { kind: 'Name', value: 'classbookHomeworkContentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'classbookNote' } },
                { kind: 'Field', name: { kind: 'Name', value: 'classShortNames' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attendeesConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'classbookComment' } }],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'keywords' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locale' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'holderConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Organization' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Group' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Profile' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventsListFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } }],
      },
    },
  ],
} as unknown as DocumentNode<ClassbookEventsQueryDocumentQuery, ClassbookEventsQueryDocumentQueryVariables>;
export const BpCreateAbsenceInAbsencesFormDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpCreateAbsenceInAbsencesForm' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'AbsenceCreateInput' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createAbsences' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'absences' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BpCreateAbsenceInAbsencesFormMutation, BpCreateAbsenceInAbsencesFormMutationVariables>;
export const BpUpdateAbsenceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpUpdateAbsence' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'AbsenceWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AbsenceUpdateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAbsences' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'absences' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'excused' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BpUpdateAbsenceMutation, BpUpdateAbsenceMutationVariables>;
export const ClassbookAbsencesFormDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ClassbookAbsencesFormData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'absenceReasonsWhere' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AbsenceReasonWhere' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'absenceUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profilesWhere' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProfileWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'classesWhere' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ClassWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'absences' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'absenceUuid' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'startTime' },
                                value: { kind: 'EnumValue', value: 'DESC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'reason' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'excused' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'absenceReasons' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'absenceReasonsWhere' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'profilesWhere' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'organizationRoles' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'classes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'classesWhere' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'name' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'membersConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClassbookAbsencesFormDataQuery, ClassbookAbsencesFormDataQueryVariables>;
export const DeleteClassDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteClass' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ClassWhere' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteClasses' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'nodesDeleted' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteClassMutation, DeleteClassMutationVariables>;
export const ClassesListPageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ClassesListPageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'classes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'name' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'foreignRefId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                { kind: 'Field', name: { kind: 'Name', value: 'grade' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gradeGroup' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'managedBy' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'divisionsConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'groupConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tutorsConnection' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'edge' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'order' },
                                  value: { kind: 'EnumValue', value: 'ASC' },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'order' } }],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'selectName' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'membersConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'selectName' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ClassesListItemQueryFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DivisionsListFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'divisionList' },
            name: { kind: 'Name', value: 'classes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'name' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'divisionsConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'groups' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'division' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                              { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'membersConnection' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'edges' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClassesListItemQueryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'lastName' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'organizationRoles' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'listName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DivisionsListFields' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClassesListPageDataQuery, ClassesListPageDataQueryVariables>;
export const CreateClassDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateClass' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'ClassCreateInput' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createClasses' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'classes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateClassMutation, CreateClassMutationVariables>;
export const UpdateClassInClassFormDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateClassInClassForm' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ClassUpdateInput' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ClassWhere' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateClasses' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'classes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'grade' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'gradeGroup' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tutors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateClassInClassFormMutation, UpdateClassInClassFormMutationVariables>;
export const ClassFormDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ClassFormData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProfileWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'options' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProfileOptions' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'options' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'organizationRoles' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClassFormDataQuery, ClassFormDataQueryVariables>;
export const UpdateClassDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateClass' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ClassUpdateInput' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ClassWhere' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateClasses' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'classes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'schoolYear' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'members' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateClassMutation, UpdateClassMutationVariables>;
export const ClassProfilesFormPageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ClassProfilesFormPageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClassProfilesFormPageDataQuery, ClassProfilesFormPageDataQueryVariables>;
export const CreateCollaborationInColaborationsFormDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateCollaborationInColaborationsForm' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCollaboration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateCollaborationInColaborationsFormMutation,
  CreateCollaborationInColaborationsFormMutationVariables
>;
export const CollaborationsFormDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CollaborationsFormData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'collaboratingOrganizations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'collaborationStatus' } },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CollaborationsFormDataQuery, CollaborationsFormDataQueryVariables>;
export const BpCreateGroupsFromCourseFormDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpCreateGroupsFromCourseForm' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'BpGroupCreateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createBpGroup' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BpCreateGroupsFromCourseFormMutation, BpCreateGroupsFromCourseFormMutationVariables>;
export const BpUpdateGroupsinCourseFormDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpUpdateGroupsinCourseForm' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'BpGroupUpdateInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBpGroup' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BpUpdateGroupsinCourseFormMutation, BpUpdateGroupsinCourseFormMutationVariables>;
export const CourseFormPageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CourseFormPageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'courseUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupType' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'GroupType' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'courseUuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'schoolYear' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subject' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'organization' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'groups' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'grades' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GroupFormProfilesFields' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GroupFormAdminsFields' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CourseFormBaseDataFields' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CourseFormTeachersFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GroupFormProfilesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'selectName' } },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupsForFormProfiles' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'groupType' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'selectName' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'classes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'name' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'membersConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'selectName' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'divisions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'name' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'class' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'groups' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'members' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'selectName' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'classGroups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'membersConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'selectName' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GroupFormAdminsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'collaboratingOrganizations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'collaborationStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'groupAdmins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'collaborationAdmins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CourseFormBaseDataFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'schoolYears' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subjects' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'classes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'name' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CourseFormTeachersFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'courseFormTeachersProfiles' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'NOT' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'rolesConnection_SOME' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'Organization' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'edge' },
                                        value: {
                                          kind: 'ObjectValue',
                                          fields: [
                                            {
                                              kind: 'ObjectField',
                                              name: { kind: 'Name', value: 'roleNames_INCLUDES' },
                                              value: { kind: 'StringValue', value: 'STUDENT', block: false },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'rolesConnection_SOME' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'Organization' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'edge' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'roleNames_INCLUDES' },
                                        value: { kind: 'StringValue', value: 'TEACHER', block: false },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'selectName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CourseFormPageDataQuery, CourseFormPageDataQueryVariables>;
export const UpdateGroupSettingsFromCourseSettingsFormDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateGroupSettingsFromCourseSettingsForm' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'GroupWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateGroupSettings' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateGroupSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'entitiesUpdated' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateGroupSettingsFromCourseSettingsFormMutation,
  UpdateGroupSettingsFromCourseSettingsFormMutationVariables
>;
export const CourseSettingsFormPageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CourseSettingsFormPageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'courseUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'courseUuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'threemaBroadcastConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CourseSettingsFormPageDataQuery, CourseSettingsFormPageDataQueryVariables>;
export const BpUpdateProfileSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpUpdateProfileSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProfileWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateProfileSettings' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateProfileSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'entitiesUpdated' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BpUpdateProfileSettingsMutation, BpUpdateProfileSettingsMutationVariables>;
export const CreateClassGroupDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateClassGroup' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'ClassGroupCreateInput' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createClassGroups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'classGroups' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateClassGroupMutation, CreateClassGroupMutationVariables>;
export const CreateDivisionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateDivision' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'DivisionCreateInput' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createDivisions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'divisions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateDivisionMutation, CreateDivisionMutationVariables>;
export const UpdateClassGroupDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateClassGroup' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ClassGroupUpdateInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ClassGroupWhere' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateClassGroups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'classGroups' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateClassGroupMutation, UpdateClassGroupMutationVariables>;
export const UpdateDivisionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateDivision' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DivisionUpdateInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DivisionWhere' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateDivisions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'divisions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateDivisionMutation, UpdateDivisionMutationVariables>;
export const DeleteClassGroupDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteClassGroup' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'delete' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ClassGroupDeleteInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ClassGroupWhere' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteClassGroups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'delete' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'delete' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'nodesDeleted' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteClassGroupMutation, DeleteClassGroupMutationVariables>;
export const DeleteDivisionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteDivision' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'delete' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DivisionDeleteInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DivisionWhere' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteDivisions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'delete' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'delete' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'nodesDeleted' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteDivisionMutation, DeleteDivisionMutationVariables>;
export const DivisionsFormPageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DivisionsFormPageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'classUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'divisions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'class' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'classUuid' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'groups' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DivisionsFormPageDataQuery, DivisionsFormPageDataQueryVariables>;
export const BpDeleteCalendarEventDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpDeleteCalendarEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CalendarEventWhere' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteCalendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'nodesDeleted' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BpDeleteCalendarEventMutation, BpDeleteCalendarEventMutationVariables>;
export const BpUpdateFileEntryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpUpdateFileEntry' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'FileEntryWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'FileEntryUpdateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateFileEntries' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fileEntries' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'FileTableFields' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FileTableFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileEntry' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicDownloadToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'downloadToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BpUpdateFileEntryMutation, BpUpdateFileEntryMutationVariables>;
export const BpDeleteFileEntryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpDeleteFileEntry' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'FileEntryWhere' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteFileEntries' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'nodesDeleted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'relationshipsDeleted' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BpDeleteFileEntryMutation, BpDeleteFileEntryMutationVariables>;
export const BpUpdateProfileRolesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpUpdateProfileRoles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'roles' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAclRoles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'roles' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'roles' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'entitiesUpdated' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BpUpdateProfileRolesMutation, BpUpdateProfileRolesMutationVariables>;
export const BpCreateGroupsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpCreateGroups' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'BpGroupCreateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createBpGroup' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BpCreateGroupsMutation, BpCreateGroupsMutationVariables>;
export const BpUpdateGroupsInGroupFormDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpUpdateGroupsInGroupForm' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'BpGroupUpdateInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBpGroup' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'schoolYear' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BpUpdateGroupsInGroupFormMutation, BpUpdateGroupsInGroupFormMutationVariables>;
export const GroupFormDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GroupFormData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupsWhere' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'GroupWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupType' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'GroupType' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'groupsWhere' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'organization' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'schoolYear' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GroupFormBaseDataFields' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GroupFormProfilesFields' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GroupFormAdminsFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GroupFormBaseDataFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'schoolYears' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GroupFormProfilesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'selectName' } },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupsForFormProfiles' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'groupType' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'selectName' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'classes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'name' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'membersConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'selectName' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'divisions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'name' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'class' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'groups' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'members' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'selectName' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'classGroups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'membersConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'selectName' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GroupFormAdminsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'collaboratingOrganizations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'collaborationStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'groupAdmins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'collaborationAdmins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GroupFormDataQuery, GroupFormDataQueryVariables>;
export const BpUpdateGroupsInGroupFormOtherDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpUpdateGroupsInGroupFormOther' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'BpGroupUpdateInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBpGroup' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BpUpdateGroupsInGroupFormOtherMutation, BpUpdateGroupsInGroupFormOtherMutationVariables>;
export const GroupFormOtherPageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GroupFormOtherPageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupType' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'GroupType' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'groupUuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GroupFormProfilesFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GroupFormProfilesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'selectName' } },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupsForFormProfiles' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'groupType' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'selectName' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'classes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'name' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'membersConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'selectName' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'divisions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'name' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'class' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'groups' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'members' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'selectName' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'classGroups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'membersConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'selectName' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GroupFormOtherPageDataQuery, GroupFormOtherPageDataQueryVariables>;
export const UpdateGroupSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateGroupSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'GroupWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateGroupSettings' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateGroupSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'entitiesUpdated' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateGroupSettingsMutation, UpdateGroupSettingsMutationVariables>;
export const GroupSettingsFormPageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GroupSettingsFormPageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'groupUuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'threemaBroadcastConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GroupSettingsFormPageDataQuery, GroupSettingsFormPageDataQueryVariables>;
export const BpCreateCalendarEventDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpCreateCalendarEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'CalendarEventCreateInput' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCalendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'calendarEvents' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'virtualLocations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BpCreateCalendarEventMutation, BpCreateCalendarEventMutationVariables>;
export const InstantMeetingsFormPageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'InstantMeetingsFormPageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupsForLicenses' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'groupUuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'licensedProducts' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BigBlueButton' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'allowRecording' } },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Bildungsplattform' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Nextcloud' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Threema' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ThreemaBroadcast' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Zoom' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'UseGroupMembersCountFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UseGroupMembersCountFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupMembersCount' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'groupUuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editorsAggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewersAggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InstantMeetingsFormPageDataQuery, InstantMeetingsFormPageDataQueryVariables>;
export const CreateNotificationPreferencesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateNotificationPreferences' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'PreferenceCreateInput' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPreferences' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'nodesCreated' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateNotificationPreferencesMutation, CreateNotificationPreferencesMutationVariables>;
export const UpdateProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProfileUpdateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateProfiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'profiles' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prefixName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'selectName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayNameShort' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'organizationRoles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstNames' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'salutation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userStatus' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'organization' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateProfileMutation, UpdateProfileMutationVariables>;
export const BpUpdateParentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpUpdateParents' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'child' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'parents' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateParents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'child' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'child' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'parents' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'parents' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'entitiesUpdated' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BpUpdateParentsMutation, BpUpdateParentsMutationVariables>;
export const ParentProfilesFormPageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ParentProfilesFormPageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'childUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listParents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'child' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'childUuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'organizationRoles' } },
                { kind: 'Field', name: { kind: 'Name', value: 'selectName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ParentProfilesFormPageDataQuery, ParentProfilesFormPageDataQueryVariables>;
export const ProcuratClassesDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ProcuratClassesData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'schoolYears' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'classes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'foreignRefId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProcuratClassesDataQuery, ProcuratClassesDataQueryVariables>;
export const ProcuratDepartmentsPageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ProcuratDepartmentsPageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'foreignRefId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rolesConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'roleNames' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProcuratDepartmentsPageDataQuery, ProcuratDepartmentsPageDataQueryVariables>;
export const ProcuratGroupsDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ProcuratGroupsData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'foreignRefId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProcuratGroupsDataQuery, ProcuratGroupsDataQueryVariables>;
export const ImportPersonsFormDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ImportPersonsFormData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProfileWhere' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'organizationRoles' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ImportPersonsFormDataQuery, ImportPersonsFormDataQueryVariables>;
export const UpdateBpProfileInProfileFormDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateBpProfileInProfileForm' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'BpProfileUpdateInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBpProfile' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'threemaId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateBpProfileInProfileFormMutation, UpdateBpProfileInProfileFormMutationVariables>;
export const AddPushIdsInNotificationSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddPushIdsInNotificationSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'add' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'NotificationSettingsUpdateInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateNotificationSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'add' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'userUuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'userUuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notificationSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userUuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pushIds' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddPushIdsInNotificationSettingsMutation,
  AddPushIdsInNotificationSettingsMutationVariables
>;
export const CreatePushIdIfNoneIsDefinedInNotificationSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreatePushIdIfNoneIsDefinedInNotificationSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'NotificationSettingsCreateInput' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createNotificationSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notificationSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userUuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pushIds' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreatePushIdIfNoneIsDefinedInNotificationSettingsMutation,
  CreatePushIdIfNoneIsDefinedInNotificationSettingsMutationVariables
>;
export const CreateBpSchoolyearDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateBpSchoolyear' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'BpSchoolyearCreateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createBpSchoolyear' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateBpSchoolyearMutation, CreateBpSchoolyearMutationVariables>;
export const UpdateBpSchoolyearDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateBpSchoolyear' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'BpSchoolyearUpdateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBpSchoolyear' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'managedBy' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateBpSchoolyearMutation, UpdateBpSchoolyearMutationVariables>;
export const SchoolyearFormPageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SchoolyearFormPageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SchoolyearFormPageDataQuery, SchoolyearFormPageDataQueryVariables>;
export const SendMatrixMessageFormPageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SendMatrixMessageFormPageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'groupUuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userStatus' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userStatus' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SendMatrixMessageFormPageDataQuery, SendMatrixMessageFormPageDataQueryVariables>;
export const CreateBpSubjectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateBpSubject' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'BpSubjectCreateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createBpSubject' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateBpSubjectMutation, CreateBpSubjectMutationVariables>;
export const UpdateBpSubjectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateBpSubject' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'BpSubjectUpdateInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBpSubject' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'globalSubject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateBpSubjectMutation, UpdateBpSubjectMutationVariables>;
export const SubjectFormPageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SubjectFormPageData' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'globalSubjects' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'country' },
                      value: { kind: 'StringValue', value: 'de', block: false },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SubjectFormPageDataQuery, SubjectFormPageDataQueryVariables>;
export const PublicSubmissionPageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PublicSubmissionPageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'submissionUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submissions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'public' },
                      value: { kind: 'BooleanValue', value: true },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'submissionUuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'material' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fileEntries' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'FileTableFields' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FileTableFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileEntry' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicDownloadToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'downloadToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PublicSubmissionPageDataQuery, PublicSubmissionPageDataQueryVariables>;
export const BpUpdateSubmissionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpUpdateSubmissions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SubmissionWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SubmissionUpdateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateSubmissions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'public' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BpUpdateSubmissionsMutation, BpUpdateSubmissionsMutationVariables>;
export const CurrentSubmissionPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CurrentSubmissionPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'submissionUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submissions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'submissionUuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'public' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'material' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fileEntries' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'FileTableFields' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'holder' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TeachingUnit' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'group' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'organization' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                              { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FileTableFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileEntry' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicDownloadToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'downloadToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CurrentSubmissionPageQuery, CurrentSubmissionPageQueryVariables>;
export const SubmissionPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SubmissionPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'assignmentUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'currentSubmissionStatus' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SubmissionStatus' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'otherSubmissions' },
            name: { kind: 'Name', value: 'submissions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'assignment_SINGLE' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'assignmentUuid' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'status' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'currentSubmissionStatus' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'updated' },
                                value: { kind: 'EnumValue', value: 'DESC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SubmissionPageQuery, SubmissionPageQueryVariables>;
export const BpCreateTeachingTopicDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpCreateTeachingTopic' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'TeachingTopicCreateInput' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createTeachingTopics' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'nodesCreated' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'teachingTopics' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'topicParentConnection' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'edges' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: '__typename' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BpCreateTeachingTopicMutation, BpCreateTeachingTopicMutationVariables>;
export const BpRenameTopicDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpRenameTopic' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'TeachingTopicUpdateInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'TeachingTopicWhere' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTeachingTopics' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'teachingTopics' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'topicParentConnection' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'edges' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: '__typename' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BpRenameTopicMutation, BpRenameTopicMutationVariables>;
export const TeachingTopicFormPageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TeachingTopicFormPageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'topicUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'teachingTopics' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'topicUuid' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TeachingTopicFormPageDataQuery, TeachingTopicFormPageDataQueryVariables>;
export const BpDeleteAssignmentsFromTeachingUnitDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpDeleteAssignmentsFromTeachingUnit' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'AssignmentWhere' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteAssignments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'nodesDeleted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'relationshipsDeleted' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BpDeleteAssignmentsFromTeachingUnitMutation,
  BpDeleteAssignmentsFromTeachingUnitMutationVariables
>;
export const BpDeleteCalendarEventFromTeachingUnitDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpDeleteCalendarEventFromTeachingUnit' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CalendarEventWhere' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteCalendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'nodesDeleted' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BpDeleteCalendarEventFromTeachingUnitMutation,
  BpDeleteCalendarEventFromTeachingUnitMutationVariables
>;
export const BpDeleteWorkMaterialsFromTeachingUnitDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpDeleteWorkMaterialsFromTeachingUnit' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'WorkMaterialWhere' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteWorkMaterials' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'nodesDeleted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'relationshipsDeleted' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BpDeleteWorkMaterialsFromTeachingUnitMutation,
  BpDeleteWorkMaterialsFromTeachingUnitMutationVariables
>;
export const TeachingUnitPageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TeachingUnitPageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'teachingUnitUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'calendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'teachingUnit' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'teachingUnitUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workMaterials' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'holder' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'TeachingUnit' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'uuid' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'teachingUnitUuid' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'visibleFrom' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'visibleTo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'publicFrom' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'visibleAfterVisibleTo' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'holder' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'TeachingUnit' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'uuid' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'teachingUnitUuid' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dueDate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'visibleFrom' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'teachingUnits' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'teachingUnitUuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'note' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fileEntries' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'FilePreviewTableFields' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FilePreviewTableFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileEntry' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updated' } },
          { kind: 'Field', name: { kind: 'Name', value: 'downloadToken' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TeachingUnitPageDataQuery, TeachingUnitPageDataQueryVariables>;
export const BpCreateTeachingUnitDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpCreateTeachingUnit' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'TeachingUnitCreateInput' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createTeachingUnits' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'teachingUnits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BpCreateTeachingUnitMutation, BpCreateTeachingUnitMutationVariables>;
export const BpUpdateTeachingUnitDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpUpdateTeachingUnit' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'TeachingUnitWhere' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'TeachingUnitUpdateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTeachingUnits' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'nodesCreated' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nodesDeleted' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'relationshipsCreated' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'relationshipsDeleted' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'teachingUnits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'topic' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'owner' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'organization' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'group' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BpUpdateTeachingUnitMutation, BpUpdateTeachingUnitMutationVariables>;
export const TeachingUnitFormPageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TeachingUnitFormPageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'courseUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'teachingUnitUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'teachingTopics' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'group' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'courseUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'teachingUnits' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'teachingUnitUuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'topic' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TeachingUnitFormPageDataQuery, TeachingUnitFormPageDataQueryVariables>;
export const BpUpdateTeachingUnitInTeachingUnitNoteFormDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpUpdateTeachingUnitInTeachingUnitNoteForm' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'TeachingUnitWhere' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'TeachingUnitUpdateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTeachingUnits' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'nodesCreated' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nodesDeleted' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'relationshipsCreated' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'relationshipsDeleted' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'teachingUnits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'note' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fileEntries' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BpUpdateTeachingUnitInTeachingUnitNoteFormMutation,
  BpUpdateTeachingUnitInTeachingUnitNoteFormMutationVariables
>;
export const TeachingUnitNoteFormPageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TeachingUnitNoteFormPageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'teachingUnitUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'teachingUnits' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'teachingUnitUuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'note' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fileEntries' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'FileTableFields' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FileTableFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileEntry' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicDownloadToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'downloadToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TeachingUnitNoteFormPageDataQuery, TeachingUnitNoteFormPageDataQueryVariables>;
export const BpDeleteTeachingTopicDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpDeleteTeachingTopic' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'TeachingTopicWhere' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteTeachingTopics' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'nodesDeleted' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BpDeleteTeachingTopicMutation, BpDeleteTeachingTopicMutationVariables>;
export const BpDeleteTeachingUnitsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpDeleteTeachingUnits' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'TeachingUnitWhere' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteTeachingUnits' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'nodesDeleted' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BpDeleteTeachingUnitsMutation, BpDeleteTeachingUnitsMutationVariables>;
export const BpUpdateTeachingTopicsConnectionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpUpdateTeachingTopicsConnections' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'TeachingTopicWhere' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'TeachingTopicUpdateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTeachingTopics' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'relationshipsCreated' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'relationshipsDeleted' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'teachingTopics' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'topicParentConnection' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'edges' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'node' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BpUpdateTeachingTopicsConnectionsMutation,
  BpUpdateTeachingTopicsConnectionsMutationVariables
>;
export const BpUpdateTeachingUnitInTeachingUnitsTreeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpUpdateTeachingUnitInTeachingUnitsTree' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'TeachingUnitWhere' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'TeachingUnitUpdateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTeachingUnits' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'nodesCreated' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nodesDeleted' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'relationshipsCreated' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'relationshipsDeleted' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'teachingUnits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'topicConnection' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'edges' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'node' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BpUpdateTeachingUnitInTeachingUnitsTreeMutation,
  BpUpdateTeachingUnitInTeachingUnitsTreeMutationVariables
>;
export const TeachingUnitTreeDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TeachingUnitTreeData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'courseUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'teachingUnits' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'group' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'courseUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'topic' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'teachingTopics' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'group' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'courseUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'topicParentConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'courseUuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TeachingUnitTreeDataQuery, TeachingUnitTreeDataQueryVariables>;
export const BpCreateWorkMaterialsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpCreateWorkMaterials' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'WorkMaterialCreateInput' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createWorkMaterials' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'workMaterials' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'holder' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TeachingUnit' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'group' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'nodesCreated' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BpCreateWorkMaterialsMutation, BpCreateWorkMaterialsMutationVariables>;
export const BpUpdateWorkMaterialsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpUpdateWorkMaterials' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'WorkMaterialUpdateInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'WorkMaterialWhere' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateWorkMaterials' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'workMaterials' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'material' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fileEntries' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publicFrom' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'visibleAfterVisibleTo' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'visibleFrom' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'visibleTo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'holder' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TeachingUnit' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'group' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BpUpdateWorkMaterialsMutation, BpUpdateWorkMaterialsMutationVariables>;
export const CourseWorkMaterialsFormPageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CourseWorkMaterialsFormPageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workMaterialUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'courseUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workMaterials' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'workMaterialUuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'material' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fileEntries' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'FileTableFields' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'visibleFrom' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'visibleTo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'publicFrom' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'visibleAfterVisibleTo' } },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'TeachingUnitSelectFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FileTableFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileEntry' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicDownloadToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'downloadToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TeachingUnitSelectFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'teachingUnits' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'group' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'courseUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CourseWorkMaterialsFormPageDataQuery, CourseWorkMaterialsFormPageDataQueryVariables>;
export const BpCreateWorkMaterialsInGroupWorkMaterialsFormDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpCreateWorkMaterialsInGroupWorkMaterialsForm' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'WorkMaterialCreateInput' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createWorkMaterials' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'workMaterials' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'holder' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TeachingUnit' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'group' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'nodesCreated' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BpCreateWorkMaterialsInGroupWorkMaterialsFormMutation,
  BpCreateWorkMaterialsInGroupWorkMaterialsFormMutationVariables
>;
export const BpUpdateWorkMaterialsinGroupWorkMaterialsFormDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpUpdateWorkMaterialsinGroupWorkMaterialsForm' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'WorkMaterialUpdateInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'WorkMaterialWhere' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateWorkMaterials' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'workMaterials' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'material' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'textMediaType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fileEntries' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publicFrom' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'visibleAfterVisibleTo' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'visibleFrom' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'holder' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TeachingUnit' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'group' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BpUpdateWorkMaterialsinGroupWorkMaterialsFormMutation,
  BpUpdateWorkMaterialsinGroupWorkMaterialsFormMutationVariables
>;
export const NotificationsDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NotificationsData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'submissionWhere' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SubmissionWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupWhere' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'GroupWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'calendarEventWhere' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CalendarEventWhere' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submissions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'submissionWhere' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'holder' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TeachingUnit' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'group' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'groupWhere' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isCommunity' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'calendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'start' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '500' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'calendarEventWhere' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'holderConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Organization' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Group' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Profile' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'collaboratingOrganizations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NotificationsDataQuery, NotificationsDataQueryVariables>;
export const UseMatrixClientDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UseMatrixClient' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GetConversationsFieldsDocument' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ResolveRoomNameFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GetConversationsFieldsDocument' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayNameShort' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ResolveRoomNameFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'organizationRoles' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UseMatrixClientQuery, UseMatrixClientQueryVariables>;
export const GroupOrCourseCalendarEventsDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GroupOrCourseCalendarEventsData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'calendarEventWhere' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CalendarEventWhere' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'CalendarEventMapCalendarEventsToBpEventTypeFields' },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CalendarEventMapCalendarEventsToBpEventTypeFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'todaysEventData' },
            name: { kind: 'Name', value: 'calendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'start' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '500' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'calendarEventWhere' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'categories' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guestsAllowed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxAttendees' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualLocations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'features' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'running' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attendeesConnection' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'edges' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'properties' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'withVideo' } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'classbookNoteContentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'classbookHomework' } },
                { kind: 'Field', name: { kind: 'Name', value: 'classbookHomeworkContentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'classbookNote' } },
                { kind: 'Field', name: { kind: 'Name', value: 'classShortNames' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attendeesConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'classbookComment' } }],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'keywords' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locale' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'holderConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Organization' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Group' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Profile' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GroupOrCourseCalendarEventsDataQuery, GroupOrCourseCalendarEventsDataQueryVariables>;
export const BirthdayEventsDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BirthdayEventsData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'courseUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'birthdayEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'courseUuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'courseUuid' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'groupUuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'groupUuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'categories' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'classShortNames' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BirthdayEventsDataQuery, BirthdayEventsDataQueryVariables>;
export const DaysDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DaysData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'date' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'days' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'date' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'date' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DaysDataQuery, DaysDataQueryVariables>;
export const AdminPagePageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AdminPagePageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdminPagePageDataQuery, AdminPagePageDataQueryVariables>;
export const InstitutionAdminSubpagePageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'InstitutionAdminSubpagePageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InstitutionAdminSubpagePageDataQuery, InstitutionAdminSubpagePageDataQueryVariables>;
export const OrganizationsSubpagePageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'OrganizationsSubpagePageData' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pimOrganizations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bpEnabled' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrganizationsSubpagePageDataQuery, OrganizationsSubpagePageDataQueryVariables>;
export const ClassbookPagePageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ClassbookPagePageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClassbookPagePageDataQuery, ClassbookPagePageDataQueryVariables>;
export const BpDeleteAbsenceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpDeleteAbsence' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'AbsenceWhere' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteAbsences' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'nodesDeleted' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BpDeleteAbsenceMutation, BpDeleteAbsenceMutationVariables>;
export const ClassbookAbsencesSubpagePageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ClassbookAbsencesSubpagePageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ownerUuids' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ClassbookAbsencesTableFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClassbookAbsencesTableFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'absences' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'owner' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid_IN' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'ownerUuids' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'startTime' },
                                value: { kind: 'EnumValue', value: 'DESC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'created' } },
                { kind: 'Field', name: { kind: 'Name', value: 'excused' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'reason' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'internal' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updated' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'days' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'wholeDay' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClassbookAbsencesSubpagePageDataQuery, ClassbookAbsencesSubpagePageDataQueryVariables>;
export const BpDeleteAbsenceFromClassbookAdminDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpDeleteAbsenceFromClassbookAdmin' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'AbsenceWhere' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteAbsences' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'nodesDeleted' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BpDeleteAbsenceFromClassbookAdminMutation,
  BpDeleteAbsenceFromClassbookAdminMutationVariables
>;
export const ClassbookAdministrationSubpagePageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ClassbookAdministrationSubpagePageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profilesWhere' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProfileWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'classesWhere' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ClassWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ClassbookAdministrationTableFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClassbookAdministrationTableFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'absences' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'startTime' },
                                value: { kind: 'EnumValue', value: 'DESC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'reason' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'excused' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'profilesWhere' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'organizationRoles' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'classes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'classesWhere' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'name' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'membersConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ClassbookAdministrationSubpagePageDataQuery,
  ClassbookAdministrationSubpagePageDataQueryVariables
>;
export const ClassbookClassesSubpagePageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ClassbookClassesSubpagePageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClassbookClassesSubpagePageDataQuery, ClassbookClassesSubpagePageDataQueryVariables>;
export const ClassbookCoursesSubpagePageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ClassbookCoursesSubpagePageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClassbookCoursesSubpagePageDataQuery, ClassbookCoursesSubpagePageDataQueryVariables>;
export const CoursePagePageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CoursePagePageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'courseUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'courseUuid' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: { kind: 'EnumValue', value: 'course' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CoursePagePageDataQuery, CoursePagePageDataQueryVariables>;
export const BpDeleteGroupCoursesPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpDeleteGroupCoursesPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteBpGroup' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'entitiesDeleted' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BpDeleteGroupCoursesPageMutation, BpDeleteGroupCoursesPageMutationVariables>;
export const CoursesPagePageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CoursesPagePageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuids' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'UseConvertToCourseTableTypeFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UseConvertToCourseTableTypeFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: { kind: 'EnumValue', value: 'course' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid_IN' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuids' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'AND' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'OR' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'editors_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'uuid' },
                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'viewers_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'uuid' },
                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'OR' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'inCurrentSchoolyear' },
                                          value: { kind: 'BooleanValue', value: true },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'isCommunity' },
                                          value: { kind: 'BooleanValue', value: true },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'managedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isCommunity' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastSync' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'externalServices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'threema' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastSync' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'virtualLocations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'running' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayNameShort' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'teachingUnitsConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'assignments' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'submissions' },
                                          arguments: [
                                            {
                                              kind: 'Argument',
                                              name: { kind: 'Name', value: 'where' },
                                              value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                  {
                                                    kind: 'ObjectField',
                                                    name: { kind: 'Name', value: 'status' },
                                                    value: { kind: 'EnumValue', value: 'New' },
                                                  },
                                                ],
                                              },
                                            },
                                          ],
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                              { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CoursesPagePageDataQuery, CoursesPagePageDataQueryVariables>;
export const CourseAdminSubpagePageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CourseAdminSubpagePageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CourseAdminSubpagePageDataQuery, CourseAdminSubpagePageDataQueryVariables>;
export const CourseAppointmentsSubpagePageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CourseAppointmentsSubpagePageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'courseUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventsListFields' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'coursesOrganization' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'courseUuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventsListFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } }],
      },
    },
  ],
} as unknown as DocumentNode<CourseAppointmentsSubpagePageDataQuery, CourseAppointmentsSubpagePageDataQueryVariables>;
export const CourseAssignmentSubpagePageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CourseAssignmentSubpagePageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CourseAssignmentSubpagePageDataQuery, CourseAssignmentSubpagePageDataQueryVariables>;
export const CourseAssignmentsSubpagePageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CourseAssignmentsSubpagePageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CourseAssignmentsSubpagePageDataQuery, CourseAssignmentsSubpagePageDataQueryVariables>;
export const CourseLessonsSubpagePageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CourseLessonsSubpagePageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'courseUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'teachingUnits' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'group' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'courseUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'teachingTopics' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'group' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'courseUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'topicParentConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: '__typename' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CourseLessonsSubpagePageDataQuery, CourseLessonsSubpagePageDataQueryVariables>;
export const CourseOverviewSubpagePageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CourseOverviewSubpagePageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CourseOverviewSubpagePageDataQuery, CourseOverviewSubpagePageDataQueryVariables>;
export const BpUpdateGroupsInCoursePersonsSubpageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpUpdateGroupsInCoursePersonsSubpage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'BpGroupUpdateInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBpGroup' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BpUpdateGroupsInCoursePersonsSubpageMutation,
  BpUpdateGroupsInCoursePersonsSubpageMutationVariables
>;
export const CoursePersonsSubpagePageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CoursePersonsSubpagePageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'courseUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'courseUuid' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: { kind: 'EnumValue', value: 'course' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'organization' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'organizationRoles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userStatus' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'organization' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'organizationRoles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userStatus' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'collaboratingOrganizations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CoursePersonsSubpagePageDataQuery, CoursePersonsSubpagePageDataQueryVariables>;
export const BpDeleteWorkMaterialsFromCourseWorkMaterialsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpDeleteWorkMaterialsFromCourseWorkMaterials' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'WorkMaterialWhere' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteWorkMaterials' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'nodesDeleted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'relationshipsDeleted' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BpDeleteWorkMaterialsFromCourseWorkMaterialsMutation,
  BpDeleteWorkMaterialsFromCourseWorkMaterialsMutationVariables
>;
export const CourseWorkMaterialsSubpagePageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CourseWorkMaterialsSubpagePageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'courseUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workMaterialUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'courseUuid' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'updatedAt' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'teachingUnits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'workMaterials' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'visibleFrom' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'visibleTo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'publicFrom' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'visibleAfterVisibleTo' } },
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CourseWorkMaterialsTableFields' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'WorkMaterialDetailFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FileTableFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileEntry' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicDownloadToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'downloadToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CourseWorkMaterialsTableFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'WorkMaterial' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'holder' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TeachingUnit' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'organization' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'owner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'material' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fileEntries' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'visibleAfterVisibleTo' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WorkMaterialDetailFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workMaterials' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'workMaterialUuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'visibleFrom' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'visibleTo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'material' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fileEntries' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'FileTableFields' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CourseWorkMaterialsSubpagePageDataQuery, CourseWorkMaterialsSubpagePageDataQueryVariables>;
export const BpUpdateSubmissionsInStudentContentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpUpdateSubmissionsInStudentContent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SubmissionWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SubmissionUpdateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateSubmissions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BpUpdateSubmissionsInStudentContentMutation,
  BpUpdateSubmissionsInStudentContentMutationVariables
>;
export const CourseAssignmentStudentContentPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CourseAssignmentStudentContentPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'assignmentUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submissions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'AND' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'assignmentConnection_SINGLE' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'node' },
                                      value: {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'uuid' },
                                            value: {
                                              kind: 'Variable',
                                              name: { kind: 'Name', value: 'assignmentUuid' },
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'ownerConnection' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'node' },
                                      value: {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'uuid' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'owner' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'material' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fileEntries' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'mediaType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'publicDownloadToken' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'downloadToken' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dueDate' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'visibleFrom' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'material' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fileEntries' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'mediaType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'publicDownloadToken' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'downloadToken' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'allowSubmissionAfterDueDate' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'holder' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TeachingUnit' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'group' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'organization' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                              { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AnswersCardFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AnswersCardFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'submissionsForAnswersCard' },
            name: { kind: 'Name', value: 'submissions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'public' },
                      value: { kind: 'BooleanValue', value: true },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'assignmentConnection_SINGLE' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'node' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'uuid' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'assignmentUuid' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'material' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CourseAssignmentStudentContentPageQuery, CourseAssignmentStudentContentPageQueryVariables>;
export const CourseAssignmentsStudentContentFragmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CourseAssignmentsStudentContentFragment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'courseUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'submissions_SOME' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'owner' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'uuid' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'holder' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'TeachingUnit' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'active' },
                                  value: { kind: 'BooleanValue', value: true },
                                },
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'group' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'uuid' },
                                        value: { kind: 'Variable', name: { kind: 'Name', value: 'courseUuid' } },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dueDate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'visibleFrom' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submissions' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'where' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'owner' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'uuid' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AssignmentPreviewStudentFields' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AssignmentsTableStudentFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssignmentPreviewStudentFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Assignment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dueDate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submissions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'owner' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssignmentsTableStudentFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Assignment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'visibleFrom' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dueDate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submissions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'owner' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'allowSubmissionAfterDueDate' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CourseAssignmentsStudentContentFragmentQuery,
  CourseAssignmentsStudentContentFragmentQueryVariables
>;
export const CourseOverviewStudentContentDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CourseOverviewStudentContentData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupWhere' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'GroupWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupOptions' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'GroupOptions' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workMaterialsOptions' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'WorkMaterialOptions' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'currentCourseWhere' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'GroupWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'currentCourseOptions' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'GroupOptions' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'calendarEventWhere' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CalendarEventWhere' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'OpenAssignmentQueryFields' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'groupWhere' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'groupOptions' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'teachingUnits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'workMaterials' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'options' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'workMaterialsOptions' } },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updated' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'visibleFrom' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'visibleTo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                                ],
                              },
                            },
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'WorkMaterialsListFields' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'currentCourse' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'currentCourseWhere' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'currentCourseOptions' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subject' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'organization' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OpenAssignmentQueryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'submissions_SOME' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'owner' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'uuid' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dueDate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'created' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'visibleFrom' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'holder' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TeachingUnit' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'group' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submissions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'owner' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'openAssignmentCalendarEvents' },
            name: { kind: 'Name', value: 'calendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'calendarEventWhere' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'categories' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recurrenceRule' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'frequency' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WorkMaterialsListFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'WorkMaterial' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updated' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CourseOverviewStudentContentDataQuery, CourseOverviewStudentContentDataQueryVariables>;
export const BpDeleteAssignmentsFromCourseAssignmentTeacherDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpDeleteAssignmentsFromCourseAssignmentTeacher' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'AssignmentWhere' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteAssignments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'nodesDeleted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'relationshipsDeleted' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BpDeleteAssignmentsFromCourseAssignmentTeacherMutation,
  BpDeleteAssignmentsFromCourseAssignmentTeacherMutationVariables
>;
export const CourseAssignmentTeacherContentPageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CourseAssignmentTeacherContentPageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'assignmentUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'courseUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'assignmentUuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'visibleFrom' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dueDate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'holder' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TeachingUnit' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'owner' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'group' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'organization' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AssignmentTabFields' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submissions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'assignment_SOME' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'assignmentUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'updated' },
                                value: { kind: 'EnumValue', value: 'DESC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SubmissionsTabSubmissionFields' } },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupAsCourse' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'courseUuid' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: { kind: 'EnumValue', value: 'course' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SubmissionsTabProfileFields' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FileTableFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileEntry' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicDownloadToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'downloadToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssignmentTabFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Assignment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'material' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fileEntries' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'FileTableFields' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'allowSubmissionAfterDueDate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'visibleFrom' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dueDate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SubmissionsTabSubmissionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Submission' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'owner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'updated' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dueDate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SubmissionsTabProfileFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Profile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CourseAssignmentTeacherContentPageDataQuery,
  CourseAssignmentTeacherContentPageDataQueryVariables
>;
export const CourseAssignmentsTeacherContentFragmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CourseAssignmentsTeacherContentFragment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'courseUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'holder' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'TeachingUnit' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'active' },
                                  value: { kind: 'BooleanValue', value: true },
                                },
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'group' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'uuid' },
                                        value: { kind: 'Variable', name: { kind: 'Name', value: 'courseUuid' } },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dueDate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'visibleFrom' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'holder' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TeachingUnit' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AssignmentPreviewTeacherFields' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AssignmentsTableTeacherFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssignmentPreviewTeacherFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Assignment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dueDate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AssignmentsTableTeacherFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Assignment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'holder' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TeachingUnit' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'owner' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'group' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'organization' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'visibleFrom' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dueDate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'created' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'allowSubmissionAfterDueDate' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CourseAssignmentsTeacherContentFragmentQuery,
  CourseAssignmentsTeacherContentFragmentQueryVariables
>;
export const CourseOverviewTeacherContentPageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CourseOverviewTeacherContentPageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'courseUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'formattedDate' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'courseUuid' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: { kind: 'EnumValue', value: 'course' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userStatus' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'teachingUnits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assignments' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'dueDate' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'visibleFrom' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'submissions' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'UseAvailableServicesForOrganizationFields' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MeetingsLinksFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UseAvailableServicesForOrganizationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organizations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'licensedProducts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Zoom' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Bildungsplattform' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Threema' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ThreemaBroadcast' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Nextcloud' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BigBlueButton' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'allowRecording' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maxParticipantsPerMeeting' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'organizationConnection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'properties' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'notAfter' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'notBefore' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MeetingsLinksFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'runningMeetings' },
            name: { kind: 'Name', value: 'calendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'AND' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'virtualLocations_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'running' },
                                      value: { kind: 'BooleanValue', value: true },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'daysConnection_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'node' },
                                      value: {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'date' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'formattedDate' } },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'holderConnection' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'Group' },
                                      value: {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'node' },
                                            value: {
                                              kind: 'ObjectValue',
                                              fields: [
                                                {
                                                  kind: 'ObjectField',
                                                  name: { kind: 'Name', value: 'uuid' },
                                                  value: {
                                                    kind: 'Variable',
                                                    name: { kind: 'Name', value: 'groupUuid' },
                                                  },
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'OR' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'holderConnection' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'Organization' },
                                                value: {
                                                  kind: 'ObjectValue',
                                                  fields: [
                                                    {
                                                      kind: 'ObjectField',
                                                      name: { kind: 'Name', value: 'node' },
                                                      value: {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                          {
                                                            kind: 'ObjectField',
                                                            name: { kind: 'Name', value: 'uuid' },
                                                            value: {
                                                              kind: 'Variable',
                                                              name: { kind: 'Name', value: 'organizationUuid' },
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'attendees_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'uuid' },
                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'owner' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'uuid' },
                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualLocations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'holderConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Group' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Organization' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Profile' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CourseOverviewTeacherContentPageDataQuery,
  CourseOverviewTeacherContentPageDataQueryVariables
>;
export const GroupPagePageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GroupPagePageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'groupUuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastSync' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GroupPagePageDataQuery, GroupPagePageDataQueryVariables>;
export const BpDeleteGroupFromGroupsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpDeleteGroupFromGroups' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteBpGroup' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'entitiesDeleted' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BpDeleteGroupFromGroupsMutation, BpDeleteGroupFromGroupsMutationVariables>;
export const GroupsPagePageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GroupsPagePageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupWhere' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'GroupWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'calendarEventWhere' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CalendarEventWhere' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'groupWhere' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'managedBy' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayNameShort' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isCommunity' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'schoolYear' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'externalServices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'threema' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastSync' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'zoom' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastSync' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastSync' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'onlineEvents' },
            name: { kind: 'Name', value: 'calendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'start' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '500' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'calendarEventWhere' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualLocations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'running' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'holderConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Organization' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Group' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Profile' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GroupsTableFields' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GroupsTableFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } }],
      },
    },
  ],
} as unknown as DocumentNode<GroupsPagePageDataQuery, GroupsPagePageDataQueryVariables>;
export const GroupAppointmentsSubpagePageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GroupAppointmentsSubpagePageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'UseGroupMembersCountFields' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventsListFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UseGroupMembersCountFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupMembersCount' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'groupUuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editorsAggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewersAggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventsListFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } }],
      },
    },
  ],
} as unknown as DocumentNode<GroupAppointmentsSubpagePageDataQuery, GroupAppointmentsSubpagePageDataQueryVariables>;
export const GroupOverviewSubpagePageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GroupOverviewSubpagePageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'formattedDate' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'groupUuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'teachingUnits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'workMaterials' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'WorkMaterialsListFields' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userStatus' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'calendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'holderConnection' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'Group' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'node' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'uuid' },
                                        value: { kind: 'Variable', name: { kind: 'Name', value: 'groupUuid' } },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualLocations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'birthdayEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'groupUuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'groupUuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualLocations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MeetingsLinksFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WorkMaterialsListFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'WorkMaterial' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updated' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MeetingsLinksFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'runningMeetings' },
            name: { kind: 'Name', value: 'calendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'AND' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'virtualLocations_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'running' },
                                      value: { kind: 'BooleanValue', value: true },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'daysConnection_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'node' },
                                      value: {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'date' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'formattedDate' } },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'holderConnection' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'Group' },
                                      value: {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'node' },
                                            value: {
                                              kind: 'ObjectValue',
                                              fields: [
                                                {
                                                  kind: 'ObjectField',
                                                  name: { kind: 'Name', value: 'uuid' },
                                                  value: {
                                                    kind: 'Variable',
                                                    name: { kind: 'Name', value: 'groupUuid' },
                                                  },
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'OR' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'holderConnection' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'Organization' },
                                                value: {
                                                  kind: 'ObjectValue',
                                                  fields: [
                                                    {
                                                      kind: 'ObjectField',
                                                      name: { kind: 'Name', value: 'node' },
                                                      value: {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                          {
                                                            kind: 'ObjectField',
                                                            name: { kind: 'Name', value: 'uuid' },
                                                            value: {
                                                              kind: 'Variable',
                                                              name: { kind: 'Name', value: 'organizationUuid' },
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'attendees_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'uuid' },
                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'owner' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'uuid' },
                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualLocations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'holderConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Group' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Organization' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Profile' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GroupOverviewSubpagePageDataQuery, GroupOverviewSubpagePageDataQueryVariables>;
export const BpUpdateGroupsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpUpdateGroups' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'BpGroupUpdateInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBpGroup' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BpUpdateGroupsMutation, BpUpdateGroupsMutationVariables>;
export const GroupPersonsSubpagePageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GroupPersonsSubpagePageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'groupUuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'organization' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'organization' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'organizationRoles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'organization' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'organizationRoles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'collaboratingOrganizations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GroupPersonsSubpagePageDataQuery, GroupPersonsSubpagePageDataQueryVariables>;
export const BpDeleteWorkMaterialsFromGroupWorkMaterialsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpDeleteWorkMaterialsFromGroupWorkMaterials' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'WorkMaterialWhere' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteWorkMaterials' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'nodesDeleted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'relationshipsDeleted' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BpDeleteWorkMaterialsFromGroupWorkMaterialsMutation,
  BpDeleteWorkMaterialsFromGroupWorkMaterialsMutationVariables
>;
export const GroupWorkMaterialsSubpagePageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GroupWorkMaterialsSubpagePageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workMaterialUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'groupUuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'teachingUnits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'MaterialDetailFields' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GroupWorkMaterialsFormFields' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GroupWorkMaterialsTableFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FileTableFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileEntry' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicDownloadToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'downloadToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MaterialDetailFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workMaterials' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'workMaterialUuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'material' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fileEntries' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'FileTableFields' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GroupWorkMaterialsFormFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workMaterials' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'workMaterialUuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'material' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fileEntries' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'FileTableFields' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'visibleFrom' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'visibleTo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'publicFrom' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'visibleAfterVisibleTo' } },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GroupWorkMaterialsTableFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'workMaterialsTable' },
            name: { kind: 'Name', value: 'workMaterials' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'holder' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'TeachingUnit' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'group' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'uuid' },
                                        value: { kind: 'Variable', name: { kind: 'Name', value: 'groupUuid' } },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'created' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updated' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'material' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fileEntries' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GroupWorkMaterialsSubpagePageDataQuery, GroupWorkMaterialsSubpagePageDataQueryVariables>;
export const HomePageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'HomePageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'submissionsWhere' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SubmissionWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizations' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'calendarEventWhere' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CalendarEventWhere' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'OpenAssignmentQueryFields' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PreviewDataQueryFields' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DashboardEventsQueryFields' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DashboardEventsFields' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'LinkListFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GroupsPreviewTableFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profileGroups' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: { kind: 'EnumValue', value: 'group' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid_IN' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizations' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'where' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'virtualLocations_SOME' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'running' },
                                  value: { kind: 'BooleanValue', value: true },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CoursesPreviewTableFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: { kind: 'EnumValue', value: 'course' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid_IN' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizations' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'AND' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'OR' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'editors_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'uuid' },
                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'viewers_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'uuid' },
                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'OR' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'inCurrentSchoolyear' },
                                          value: { kind: 'BooleanValue', value: true },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'isCommunity' },
                                          value: { kind: 'BooleanValue', value: true },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isCommunity' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'where' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'virtualLocations_SOME' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'running' },
                                  value: { kind: 'BooleanValue', value: true },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'schoolYear' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'teachingUnitsConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'assignments' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'submissions' },
                                          arguments: [
                                            {
                                              kind: 'Argument',
                                              name: { kind: 'Name', value: 'where' },
                                              value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                  {
                                                    kind: 'ObjectField',
                                                    name: { kind: 'Name', value: 'status' },
                                                    value: { kind: 'EnumValue', value: 'New' },
                                                  },
                                                ],
                                              },
                                            },
                                          ],
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                              { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'submissions_SOME' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'owner' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'uuid' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submissions' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'where' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'submissionsWhere' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'holder' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TeachingUnit' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'group' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventsListFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DashboardEventsQueryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'calendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'start' },
                                value: { kind: 'EnumValue', value: 'ASC' },
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '500' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'calendarEventWhere' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualLocations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'classShortNames' } },
                { kind: 'Field', name: { kind: 'Name', value: 'categories' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'keywords' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'holderConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Group' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Organization' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Profile' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'birthdayEvents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                { kind: 'Field', name: { kind: 'Name', value: 'categories' } },
                { kind: 'Field', name: { kind: 'Name', value: 'classShortNames' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OpenAssignmentQueryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'submissions_SOME' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'owner' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'uuid' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dueDate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'created' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'visibleFrom' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'holder' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TeachingUnit' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'group' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submissions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'owner' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'openAssignmentCalendarEvents' },
            name: { kind: 'Name', value: 'calendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'calendarEventWhere' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'categories' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recurrenceRule' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'frequency' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PreviewDataQueryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profileCourses' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: { kind: 'EnumValue', value: 'course' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid_IN' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizations' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'AND' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'OR' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'editors_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'uuid' },
                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'viewers_SOME' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'uuid' },
                                                value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'OR' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'inCurrentSchoolyear' },
                                          value: { kind: 'BooleanValue', value: true },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'isCommunity' },
                                          value: { kind: 'BooleanValue', value: true },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profileGroups' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: { kind: 'EnumValue', value: 'group' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid_IN' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizations' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GroupsPreviewTableFields' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CoursesPreviewTableFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DashboardEventsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventsListFields' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DashboardEventsQueryFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LinkListFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } }],
      },
    },
  ],
} as unknown as DocumentNode<HomePageDataQuery, HomePageDataQueryVariables>;
export const InstitutionPageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'InstitutionPageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InstitutionPageDataQuery, InstitutionPageDataQueryVariables>;
export const BpDeleteGroupFromInstitutionCoursesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpDeleteGroupFromInstitutionCourses' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteBpGroup' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'entitiesDeleted' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BpDeleteGroupFromInstitutionCoursesMutation,
  BpDeleteGroupFromInstitutionCoursesMutationVariables
>;
export const InstitutionCoursesSubpageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'InstitutionCoursesSubpageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: { kind: 'EnumValue', value: 'course' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'inCurrentSchoolyear' },
                      value: { kind: 'BooleanValue', value: true },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'grades' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'selectName' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'selectName' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'groups' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayNameShort' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'organization' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subject' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'managedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isCommunity' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastSync' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'externalServices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'bbb' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mailbox' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastSync' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'matrix' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'threema' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastSync' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'zoom' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastSync' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'schoolYear' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'organization' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InstitutionCoursesSubpageDataQuery, InstitutionCoursesSubpageDataQueryVariables>;
export const BpDeleteGroupFromInstitutionGroupsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpDeleteGroupFromInstitutionGroups' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteBpGroup' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'entitiesDeleted' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BpDeleteGroupFromInstitutionGroupsMutation,
  BpDeleteGroupFromInstitutionGroupsMutationVariables
>;
export const InstitutionGroupsSubpageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'InstitutionGroupsSubpageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupType' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'GroupType' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GroupsTableFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'groupType' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'grades' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastSync' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'externalServices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bbb' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mailbox' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastSync' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'matrix' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'threema' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastSync' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'zoom' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastSync' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'groups' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'selectName' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'selectName' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayNameShort' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'managedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isCommunity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'inCurrentSchoolyear' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'schoolYear' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'organization' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GroupsTableFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } }],
      },
    },
  ],
} as unknown as DocumentNode<InstitutionGroupsSubpageDataQuery, InstitutionGroupsSubpageDataQueryVariables>;
export const UpdateOrganizationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateOrganization' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'OrganizationUpdateInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'OrganizationWhere' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateOrganizations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organizations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'aboutInfo' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'aboutInfoLastUpdated' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;
export const InstitutionOverviewSubpageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'InstitutionOverviewSubpageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organizations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'aboutInfo' } },
                { kind: 'Field', name: { kind: 'Name', value: 'aboutInfoLastUpdated' } },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InstitutionOverviewSubpageDataQuery, InstitutionOverviewSubpageDataQueryVariables>;
export const BpDeleteProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpDeleteProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteBpProfile' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'entitiesDeleted' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BpDeleteProfileMutation, BpDeleteProfileMutationVariables>;
export const BpUpdateProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BpUpdateProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProfileWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProfileUpdateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateProfiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'profiles' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'threema' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nextcloudConnection' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'edges' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'properties' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BpUpdateProfileMutation, BpUpdateProfileMutationVariables>;
export const InstitutionPersonsSubpageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'InstitutionPersonsSubpageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'classes' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'options' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'sort' },
                            value: {
                              kind: 'ListValue',
                              values: [
                                {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'shortName' },
                                      value: { kind: 'EnumValue', value: 'ASC' },
                                    },
                                  ],
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'userStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'organizationRoles' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'incomingRolesConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'roleNames' } }],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'listName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InstitutionPersonsSubpageDataQuery, InstitutionPersonsSubpageDataQueryVariables>;
export const DeleteBpSchoolyearDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteBpSchoolyear' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteBpSchoolyear' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'entitiesDeleted' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteBpSchoolyearMutation, DeleteBpSchoolyearMutationVariables>;
export const InstitutionSchoolyearsSubpageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'InstitutionSchoolyearsSubpageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'schoolYears' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'managedBy' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InstitutionSchoolyearsSubpageDataQuery, InstitutionSchoolyearsSubpageDataQueryVariables>;
export const DeleteBpSubjectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteBpSubject' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteBpSubject' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'entitiesDeleted' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteBpSubjectMutation, DeleteBpSubjectMutationVariables>;
export const InstitutionSubjectsSubpageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'InstitutionSubjectsSubpageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SubjectWhere' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subjects' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'managedBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'globalSubject' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InstitutionSubjectsSubpageDataQuery, InstitutionSubjectsSubpageDataQueryVariables>;
export const MeetingsPagePageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MeetingsPagePageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MeetingsPagePageDataQuery, MeetingsPagePageDataQueryVariables>;
export const RunningBbbMeetingsSubpagePageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RunningBBBMeetingsSubpagePageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'calendarEventWhere' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CalendarEventWhere' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'UseAvailableServicesForOrganizationFields' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'RunningMeetingsTableFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'calendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'calendarEventWhere' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualLocations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'running' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UseAvailableServicesForOrganizationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organizations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'licensedProducts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Zoom' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Bildungsplattform' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Threema' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ThreemaBroadcast' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Nextcloud' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BigBlueButton' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'allowRecording' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maxParticipantsPerMeeting' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'organizationConnection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'properties' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'notAfter' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'notBefore' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RunningMeetingsTableFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'calendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'calendarEventWhere' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxAttendees' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'holderConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Group' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Organization' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Profile' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualLocations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'running' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attendeesConnection' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'edges' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'properties' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'withVideo' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'node' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RunningBbbMeetingsSubpagePageDataQuery, RunningBbbMeetingsSubpagePageDataQueryVariables>;
export const RunningZoomMeetingsSubpagePageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RunningZoomMeetingsSubpagePageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'calendarEventWhere' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CalendarEventWhere' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RunningMeetingsTableFields' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RunningMeetingsTableFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'calendarEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'calendarEventWhere' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxAttendees' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'holderConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Group' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Organization' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Profile' } },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'virtualLocations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'running' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attendeesConnection' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'edges' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'properties' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'withVideo' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'node' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RunningZoomMeetingsSubpagePageDataQuery, RunningZoomMeetingsSubpagePageDataQueryVariables>;
export const ProfilePageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ProfilePageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profilesWhere' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProfileWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profilesOptions' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProfileOptions' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProfileFormFields' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AccessOverviewFormFields' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'NotificationSettingsFormFields' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ProfileFormFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'profilesWhere' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'profilesOptions' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'threemaId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AccessOverviewFormFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'profilesWhere' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'profilesOptions' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'threemaId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'threemaConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'threemaId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'workPass' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'workUser' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NotificationSettingsFormFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'profilesWhere' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'profilesOptions' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notificationPreferencesConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'transports' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProfilePageDataQuery, ProfilePageDataQueryVariables>;
export const SettingsPageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SettingsPageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SettingsPageDataQuery, SettingsPageDataQueryVariables>;
export const DeleteAbsenceReasonDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteAbsenceReason' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AbsenceReasonWhere' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteAbsenceReasons' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'nodesDeleted' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteAbsenceReasonMutation, DeleteAbsenceReasonMutationVariables>;
export const UpdateBildungsplattformsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateBildungsplattforms' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'BildungsplattformUpdateInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'BildungsplattformWhere' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBildungsplattforms' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bildungsplattforms' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'allowParentExcuses' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateBildungsplattformsMutation, UpdateBildungsplattformsMutationVariables>;
export const SettingClassbookSubpageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SettingClassbookSubpageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AbsenceReasonTableFields' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AbsenceReasonTableFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'absenceReasons' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'internal' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'absencesAggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SettingClassbookSubpageDataQuery, SettingClassbookSubpageDataQueryVariables>;
export const SettingsCollaborationCoursesSubpageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SettingsCollaborationCoursesSubpageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: { kind: 'EnumValue', value: 'course' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'isCommunity' },
                      value: { kind: 'BooleanValue', value: true },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'organization' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'organization' },
                                      value: {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'uuid' },
                                            value: {
                                              kind: 'Variable',
                                              name: { kind: 'Name', value: 'organizationUuid' },
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isCommunity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'externalServices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nextcloud' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastSync' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'threema' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastSync' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'matrix' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mailbox' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: '__typename' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'zoom' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: '__typename' } }],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'bbb' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'managedBy' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayNameShort' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SettingsCollaborationCoursesSubpageDataQuery,
  SettingsCollaborationCoursesSubpageDataQueryVariables
>;
export const SettingsCollaborationGroupsSubpageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SettingsCollaborationGroupsSubpageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupType' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'GroupType' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'groupType' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'isCommunity' },
                      value: { kind: 'BooleanValue', value: true },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'organization' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'organization' },
                                      value: {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'uuid' },
                                            value: {
                                              kind: 'Variable',
                                              name: { kind: 'Name', value: 'organizationUuid' },
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'organization' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'managedBy' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayNameShort' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isCommunity' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'schoolYear' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'externalServices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'threema' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastSync' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'zoom' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastSync' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nextcloud' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastSync' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'GroupsTableFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GroupsTableFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } }],
      },
    },
  ],
} as unknown as DocumentNode<
  SettingsCollaborationGroupsSubpageDataQuery,
  SettingsCollaborationGroupsSubpageDataQueryVariables
>;
export const CreateCollaborationInSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateCollaborationInSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCollaboration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateCollaborationInSettingsMutation, CreateCollaborationInSettingsMutationVariables>;
export const DeleteCollaborationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteCollaboration' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteCollaboration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'entitiesDeleted' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteCollaborationMutation, DeleteCollaborationMutationVariables>;
export const SettingsCollaborationsSubpageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SettingsCollaborationsSubpageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CollaborationsTableFields' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CollaborationsTableFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'collaboratingOrganizations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'collaborationStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sourceOrganization' } },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SettingsCollaborationsSubpageDataQuery, SettingsCollaborationsSubpageDataQueryVariables>;
export const UpdateBildungsplattformsInSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateBildungsplattformsInSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'BildungsplattformUpdateInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'BildungsplattformWhere' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBildungsplattforms' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'update' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'update' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bildungsplattforms' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'allowStudentDirectMessages' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentSchoolyear' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateBildungsplattformsInSettingsMutation,
  UpdateBildungsplattformsInSettingsMutationVariables
>;
export const SettingsOverviewSubpageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SettingsOverviewSubpage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adminProfiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'organization' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uuid' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'organizationRoles' } },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BookingsTableFields' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BookingsTableFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organizations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'organizationUuid' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'licensedProducts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Bildungsplattform' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'organizationConnection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'properties' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'notAfter' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'notBefore' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Nextcloud' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'profilesAggregate' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'where' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'NOT' },
                                        value: {
                                          kind: 'ObjectValue',
                                          fields: [
                                            {
                                              kind: 'ObjectField',
                                              name: { kind: 'Name', value: 'email_IN' },
                                              value: {
                                                kind: 'ListValue',
                                                values: [{ kind: 'StringValue', value: 'admin@tks.eu', block: false }],
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'organizationConnection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'properties' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'notAfter' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'notBefore' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ThreemaBroadcast' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'organizationConnection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'properties' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'notAfter' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'notBefore' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Threema' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'organizationConnection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'properties' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'notAfter' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'notBefore' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BigBlueButton' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'organizationConnection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'properties' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'notAfter' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'notBefore' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Zoom' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'organizationConnection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'properties' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'notAfter' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'notBefore' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SettingsOverviewSubpageQuery, SettingsOverviewSubpageQueryVariables>;
export const SettingsProcuratSubpagePageDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SettingsProcuratSubpagePageData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PermissionCheckerFields' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PermissionCheckerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Query' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'profilePermissions' },
            name: { kind: 'Name', value: 'profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uuid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextcloudConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'properties' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'enabled' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'groupPermission' },
            name: { kind: 'Name', value: 'groups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'OR' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'admins_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'editors_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'viewers_SOME' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'uuid' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'admins' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'editors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'viewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SettingsProcuratSubpagePageDataQuery, SettingsProcuratSubpagePageDataQueryVariables>;
